// AUTO-GENERATED by scripts/generate-catalog.mjs — DO NOT EDIT.
// Star catalog: 8921 stars to magnitude 6.5, packed as RA(deg), Dec(deg), mag, B-V (or -9).
// Data sources: HYG v4.1 (CC BY-SA 4.0, astronexus.com)
// See src/catalog/data/attribution.ts for licenses and provenance.


export const STAR_COUNT = 8921;

export const starData = new Float32Array([
  0, 0, -26.7, 0.656, 0.0795, -44.290561, 6.28, 0.763, 0.09956999999999999, 26.918108, 6.43, 0.514,
  0.128895, 59.559679, 6.18, 1.032, 0.14299499999999998, -53.097713, 6.49, 0.616, 0.181785, 45.253334, 6.36, -0.047,
  0.269115, -48.809876, 5.71, 0.911, 0.330195, 49.981558, 6.22, 0.97, 0.333825, -50.337373, 5.53, 1.615,
  0.39924000000000004, -77.065724, 4.78, 1.254, 0.404235, 61.222801, 5.58, 0.407, 0.413955, 73.611846, 6.5, 0.182,
  0.432705, 42.367144, 6.25, -0.042, 0.45603, -3.027504, 5.13, -0.128, 0.49008, -6.014072, 4.37, 1.631,
  0.5420849999999999, 27.082256, 5.8, 0.69, 0.583005, -29.720414, 5.04, -0.15, 0.60069, 8.956824, 6.33, 0.182,
  0.6237600000000001, 8.485463, 5.7, 0.315, 0.650355, 66.098966, 5.87, 1.073, 0.7395149999999999, -20.045882, 6.25, 0.526,
  0.7827149999999999, -24.145145, 6.46, 1.176, 0.857145, 63.64052, 6.24, 0.332, 0.9349500000000001, -17.335988, 4.55, -0.047,
  0.9651299999999999, 66.712183, 6.31, 1.629, 1.05693, 62.287664, 5.9, 0.274, 1.082475, -16.529036, 5.78, 1.084,
  1.08465, -29.268822, 6.38, 0.006, 1.1254950000000001, -10.509523, 4.99, 1.619, 1.15245, 42.09253, 6.11, 0.159,
  1.1719650000000001, -71.436891, 5.59, -0.1, 1.17456, 67.166445, 5.68, 1.051, 1.223595, 34.659797, 6.09, 0.632,
  1.2333, 26.648764, 6.25, 1.368, 1.25493, 27.674784, 6.47, 0.946, 1.265925, -0.503035, 6.32, 1.099,
  1.275585, 61.31397, 5.8, -0.067, 1.33392, -5.707618, 4.61, 1.029, 1.424835, 13.396266, 5.55, 0.901,
  1.56534, 58.436733, 5.98, 0.687, 1.5791549999999999, -49.075191, 5.7, 0.519, 1.61055, 64.196168, 5.57, -0.023,
  1.653135, 29.021502, 6.07, 0.752, 1.7086649999999999, -23.10754, 6.19, 0.386, 1.826115, -17.38699, 6.2, 0.133,
  1.9338000000000002, -2.548679, 6.43, -0.146, 1.945395, -22.50856, 5.93, 0.141, 2.014545, -33.529326, 5.67, 1.119,
  2.050395, -2.447711, 6.18, 1.366, 2.07306, -8.824112, 5.99, 1.034, 2.096865, 29.090432, 2.07, -0.038,
  2.13693, 63.20404, 6.41, 0.998, 2.13957, -17.578155, 6.11, 1.664, 2.17065, 36.627125, 6.21, 0.504,
  2.21721, 25.462985, 6.24, 0.976, 2.250675, 28.247543, 6.47, 0.242, 2.26008, 18.211963, 5.57, 1.043,
  2.2599, -54.001931, 6.32, 0.738, 2.293305, 59.14978, 2.28, 0.38, 2.332875, 79.714545, 6.01, 0.203,
  2.3377649999999996, -27.987928, 5.42, 0.414, 2.35254, -45.747426, 3.88, 1.013, 2.46711, -62.296794, 6.34, 0.164,
  2.50917, 11.145813, 5.54, -0.064, 2.509395, -82.224047, 5.29, 1.049, 2.57862, -5.248588, 5.84, 0.973,
  2.58018, 46.072272, 5.01, 0.405, 2.678475, -12.579897, 5.84, 1, 2.8160849999999997, -15.467977, 4.89, 0.487,
  2.8934100000000003, -27.799737, 5.41, 1.346, 2.93328, -35.133119, 5.24, 0.459, 2.996115, 48.152396, 6.18, 1.467,
  3.041595, -17.938278, 5.29, 1.478, 3.1422600000000003, 44.707195, 6.5, 1.112, 3.30897, 15.183596, 2.83, -0.19,
  3.331485, -84.993978, 5.78, 1.71, 3.34968, 26.987545, 6.24, 0.68, 3.3786, 41.03537, 5.71, 0.331,
  3.426015, -26.022345, 5.94, 1.548, 3.43491, -26.284959, 6.14, 1.49, 3.5095050000000003, 33.206039, 6.22, 0.009,
  3.61512, -7.780532, 5.13, 1.601, 3.6506700000000003, 20.206702, 4.79, 1.572, 3.660075, -18.932866, 4.44, 1.64,
  3.72714, -9.569571, 5.77, -0.084, 3.7329, 22.284225, 6.25, -0.004, 3.7427249999999996, -34.904223, 6.17, 1.344,
  3.745155, 8.820962, 6.02, 0.312, 3.77895, 31.535725, 6.34, 1.555, 3.79401, 27.28344, 6.35, -0.002,
  3.978585, 61.000172, 6.43, 0.838, 3.9788550000000003, -75.911615, 6.49, 0.983, 4.03689, -31.446394, 5.66, 1.35,
  4.057905, 76.950755, 6.35, -0.044, 4.089675000000001, 43.595049, 6.12, 0.068, 4.14183, 8.240154, 6.12, 0.919,
  4.176435, -20.210061, 6.5, -0.108, 4.237695, 61.533185, 5.74, 0.898, 4.272945, 38.681636, 4.61, 0.059,
  4.287675, 47.947405, 5.86, -0.079, 4.386254999999999, -19.051092, 6.46, 0.386, 4.429424999999999, 51.43309, 6.11, -0.151,
  4.448745, 1.688727, 6.19, 0.937, 4.571865, 11.206214, 6.07, 1.036, 4.581945, 36.785224, 4.51, 0.054,
  4.659375, 31.517227, 5.88, -0.014, 4.674435, -8.053001, 6.47, 0.674, 4.67568, 43.791141, 6.1, -0.074,
  4.6773, -43.235571, 6.33, 1.21, 4.856985, -8.823921, 3.56, 1.214, 4.92318, 40.729461, 6.35, 1.179,
  5.01213, -64.874791, 4.23, 0.576, 5.101665, 30.935614, 5.89, -0.098, 5.12886, 48.968633, 6.46, 0.564,
  5.149425, 8.190271, 5.38, 1.343, 5.162669999999999, -69.624913, 5.5, -0.046, 5.1896700000000004, 32.911186, 5.79, 1.595,
  5.280255, 37.968603, 5.16, 0.442, 5.36979, -77.426873, 5.96, 1.397, 5.379975, -28.981469, 5.18, 1.006,
  5.442794999999999, -20.058024, 5.61, 1.58, 5.606175, 13.482488, 6.25, 1.225, 5.715764999999999, -12.209438, 6.39, 0.659,
  5.7683100000000005, -15.942556, 6.43, 1.595, 6.06522, 52.019914, 5.58, -0.11, 6.12354, -2.219064, 6.08, 1.216,
  6.1589849999999995, 14.315514, 6.48, 1.161, 6.197895, 61.831057, 5.38, 0.008, 6.276675, 53.046786, 5.72, -0.056,
  6.350865000000001, 1.939692, 5.77, 0.855, 6.418740000000001, -77.254247, 2.82, 0.618, 6.55074, -43.679829, 3.93, 0.175,
  6.5708400000000005, -42.305981, 2.4, 1.083, 6.590625, -18.693632, 6.24, 1.622, 6.65589, -0.049533, 6.16, 0.893,
  6.811275, -25.54717, 5.99, 1.022, 6.879449999999999, 16.025483, 6.44, 0.23, 6.98208, -33.007167, 4.86, 1.634,
  6.993615, 19.514039, 6.4, 0.99, 7.012124999999999, 17.893125, 5.01, 1.584, 7.052924999999999, 16.445065, 6.05, 1.58,
  7.05681, 44.394452, 5.18, 0.043, 7.08354, 10.189848, 6.05, 0.447, 7.08792, -20.335051, 6.44, 0.594,
  7.110405, -39.915002, 5.42, 1.556, 7.17948, -50.532859, 6.26, 1.09, 7.23609, 36.899694, 6.28, 0.916,
  7.466220000000001, -14.864109, 6.15, 0.388, 7.509824999999999, -3.957332, 5.72, 1.545, 7.530675, 29.751557, 5.2, 0.271,
  7.583010000000001, 59.977554, 5.94, -0.003, 7.594395, -23.78768, 5.17, 0.128, 7.60863, -48.21491, 5.67, 0.367,
  7.6159349999999995, -40.939586, 6.18, 0.315, 7.726649999999999, 77.019404, 6.18, 0.883, 7.85391, -48.803514, 4.76, 0.018,
  7.855049999999999, 66.519617, 6.18, -0.1, 7.856805, 33.581642, 5.88, 1.133, 7.885875, -62.958218, 4.36, -0.064,
  7.88919, -62.965561, 4.53, 0.147, 7.921575000000001, 52.839526, 5.59, 1.163, 7.943085, 54.522289, 4.74, -0.098,
  8.099084999999999, 6.955463, 5.69, -0.014, 8.147835, 20.294316, 5.38, 1.069, 8.18268, -63.0315, 5.07, 0.038,
  8.204535, 28.280241, 6.26, 0.965, 8.249955, 62.931783, 4.17, 0.13, 8.293185, 54.894985, 5.93, 1.037,
  8.3301, 70.981843, 6.41, -0.007, 8.346945, -71.266246, 6.11, 0.265, 8.421015, -29.558278, 5.55, 1.262,
  8.432549999999999, -35.002078, 6.41, 0.617, 8.603745, 66.750351, 6.47, -0.049, 8.61561, -52.37309, 5.57, 0.472,
  8.73069, 13.371137, 6.39, 1.136, 8.811990000000002, -3.592846, 5.2, 0.567, 8.88681, -0.50561, 5.94, 0.444,
  8.888865, -54.821873, 6.04, 1.001, 8.921505, -48.000907, 5.51, 0.461, 8.978355, 13.207067, 6.32, 0.517,
  9.013155, -14.973035, 6.45, 1.063, 9.028590000000001, -22.842333, 6.06, 0.297, 9.03459, 54.16845, 5.08, -0.098,
  9.113925, 60.326215, 5.78, 0.294, 9.156735000000001, -65.124445, 6.43, 1.26, 9.193545, 44.488587, 5.14, 1.587,
  9.19713, 15.231725, 5.89, -0.146, 9.2202, 33.719344, 4.34, -0.123, 9.24282, 53.896909, 3.69, -0.196,
  9.279959999999999, 24.014136, 6.18, 1.17, 9.325905, -54.393819, 6.4, 0.995, 9.335894999999999, -24.767267, 5.57, 0.715,
  9.338415000000001, 35.399501, 5.45, 0.886, 9.377040000000001, 3.135351, 6.43, 1.339, 9.63903, 29.311751, 4.34, 0.871,
  9.703244999999999, -25.107819, 6.43, 1.482, 9.79122, 49.354589, 5.45, 1.644, 9.83193, 30.861024, 3.27, 1.268,
  9.840945, 21.250472, 5.88, 0.85, 9.948705, 82.493762, 6.38, 0.551, 9.96642, -44.796293, 6, 1.142,
  9.98154, 21.438495, 5.36, 1.16, 10.104885, -59.454604, 5.89, 0.564, 10.11909, -16.516676, 6.49, 0.91,
  10.126740000000002, 56.537331, 2.24, 1.17, 10.136565000000001, -23.804876, 6.14, 0.718, 10.176554999999999, -4.351841, 5.9, 1.091,
  10.27995, 39.458664, 5.3, 0.891, 10.33149, -46.085007, 4.59, 0.953, 10.400145, 24.629008, 6.06, 0.298,
  10.44315, -56.501315, 5.72, 0.131, 10.514295, 66.147592, 5.83, 1.042, 10.516214999999999, 50.512526, 4.8, -0.105,
  10.618034999999999, -65.46803, 5.38, 0.515, 10.62927, 58.753411, 6.18, -0.004, 10.674135000000001, -60.262807, 5.99, 1.318,
  10.67871, -38.463483, 6.05, -0.024, 10.838505, -57.46306, 4.36, 0.024, 10.866990000000001, 47.024546, 4.95, 0.17,
  10.89735, -17.986605, 2.04, 1.019, 10.9587, -12.011813, 6.01, 1.107, 11.047500000000001, -10.60955, 4.77, 0.998,
  11.050245, -38.421686, 5.9, 1.144, 11.10918, 47.863984, 5.66, -0.113, 11.131604999999999, -62.497591, 6.06, 0.446,
  11.1813, 48.284364, 4.48, -0.069, 11.18499, -22.006135, 5.22, 0.35, 11.237805000000002, -42.676558, 5.94, 0.297,
  11.249385, -53.714895, 6.15, 0.524, 11.32161, 55.221396, 5.41, 0.022, 11.35053, -4.62916, 6.15, 1.652,
  11.369535, -12.88081, 6.15, 0.603, 11.412930000000001, 74.988073, 5.64, 0.078, 11.423775, -16.42422, 6.47, 0.314,
  11.43975, -47.551985, 5.8, 0.635, 11.545035, 44.861497, 6.03, -0.063, 11.548935, -22.522097, 5.49, 0.978,
  11.63733, 15.475504, 5.36, 1.559, 11.659695000000001, 69.325408, 6.39, 0.424, 11.67693, 59.574539, 6.41, 1.081,
  11.756070000000001, 11.973849, 5.51, 0.987, 11.80677, 19.578702, 6.11, 0.27, 11.834715000000001, 24.267178, 4.08, 1.1,
  11.848469999999999, 6.740956, 5.98, 0.941, 11.930085, -18.061339, 5.7, 1.3, 11.941785, 74.847573, 5.42, -0.066,
  12.00444, -21.722492, 5.57, -0.058, 12.037305, 72.674482, 5.86, 1.01, 12.07254, 7.299928, 5.92, 1.104,
  12.095730000000001, 5.280615, 5.74, 0.89, 12.146654999999999, -74.923438, 5.09, 1.345, 12.170595, 7.585079, 4.44, 1.5,
  12.20838, 50.968168, 4.9, -0.091, 12.236369999999999, -46.697648, 6.28, 0.897, 12.244620000000001, 16.940644, 5.07, 0.502,
  12.2739, 57.815187, 3.46, 0.587, 12.308100000000001, -24.136672, 5.9, 0.944, 12.35673, -13.561274, 5.59, 1.325,
  12.389295, -23.362144, 6.27, 0.132, 12.45351, 41.078911, 4.53, -0.136, 12.471494999999999, 27.710286, 5.55, 0.398,
  12.515685, -43.394921, 6.49, 0.286, 12.531645000000001, -10.644326, 5.17, 0.514, 12.576045, 45.002258, 6.13, 0.043,
  12.67152, -50.986816, 5.24, 0.356, 12.68163, 64.247549, 5.35, 0.528, 12.738945, 51.508032, 6.38, 0.307,
  12.818264999999998, 61.805494, 6.04, 1.88, 12.82635, 3.38502, 6.39, 1.069, 12.890789999999999, 51.571427, 6.22, 0.032,
  13.169265000000001, -24.005844, 5.47, 1.275, 13.252065, -1.14426, 4.78, 1.55, 13.267665000000001, 61.12397, 4.8, 0.54,
  13.301895, -24.776876, 6.44, 0.439, 13.367595, 37.418209, 6.07, 1.139, 13.407585000000001, -62.871352, 5.73, 1.574,
  13.448205, 52.689293, 6.27, 0.191, 13.573305, -8.740662, 6.15, 0.911, 13.646775, 19.188417, 5.8, -0.016,
  13.720005, 83.707435, 5.59, 0.105, 13.742085000000001, 23.628335, 5.46, 1.012, 13.750725, 58.972698, 4.83, 1.216,
  13.751265, -69.527084, 5.45, 1.095, 13.77171, 48.67852, 6.28, 1.681, 13.811129999999999, 24.557062, 6.19, 1.546,
  13.92666, -7.347149, 5.88, 1.52, 13.981395, -27.775839, 6.11, 1.674, 13.9938, 27.209381, 6.08, 0.133,
  14.006205, -11.266526, 5.35, 1.505, 14.038005, 13.95196, 6.46, 0.962, 14.053965, 57.996557, 6.2, 1.376,
  14.16648, 59.181056, 4.62, 0.957, 14.177145, 60.71674, 2.15, -0.046, 14.188274999999999, 38.499345, 3.86, 0.13,
  14.195655, 60.362836, 5.56, -0.054, 14.22936, 68.775657, 6.39, 0.375, 14.301675, 23.417648, 4.4, 0.94,
  14.331525000000001, 61.421895, 6.44, 0.94, 14.41518, 45.839379, 6.1, 1.028, 14.458965, 28.992217, 5.44, 1.076,
  14.47713, 13.695865, 6.3, 0.895, 14.559225, 33.950885, 5.99, 1, 14.578725, 21.404495, 6.47, 0.089,
  14.592509999999999, -60.696239, 6.23, 0.096, 14.629275, 66.351793, 5.97, -0.008, 14.65149, -29.357449, 4.3, -0.154,
  14.682780000000001, -11.379975, 5.62, 0.949, 14.957025, 6.483225, 6.14, 1.654, 15.01482, 44.713243, 5.69, -0.01,
  15.128804999999998, 70.982988, 6.4, 0.135, 15.326100000000002, -38.916527, 5.59, 1.185, 15.362684999999999, 49.54422, 6.48, 1.099,
  15.411015, -16.265573, 6.47, 1.184, 15.507570000000001, -57.002389, 6.12, 0.935, 15.576944999999998, 51.034938, 6.48, 0.122,
  15.610110000000002, -31.552005, 5.5, 0.083, 15.67875, -65.456102, 6.25, 1.634, 15.704565000000002, 31.804263, 5.5, -0.043,
  15.704955, -46.397311, 5.39, 0.9, 15.726105, 41.345157, 5.95, 0.161, 15.73587, 7.890135, 4.27, 0.952,
  15.756345000000001, 47.376158, 6.46, 0.248, 15.760575, -4.836601, 5.4, 1.106, 15.82377, -29.525848, 6.28, 0.932,
  15.904199999999998, 61.074823, 5.92, 0.512, 15.954285000000002, 1.366846, 6.06, 0.271, 16.00995, 52.502161, 5.99, 1.447,
  16.08126, 61.580184, 5.83, 0.569, 16.115085, 29.658806, 6.2, 0.443, 16.135755, -33.532845, 6.44, 1.071,
  16.21932, 5.656262, 6.03, 1.525, 16.272315, 14.946133, 5.64, 0.42, 16.403685000000003, -9.979323, 6.09, 1.012,
  16.420634999999997, 21.473181, 5.33, 0.003, 16.423785, 21.465442, 5.55, -0.048, 16.45512, 4.908372, 6.35, 0.383,
  16.521105, -46.718414, 3.32, 0.885, 16.521449999999998, -9.839354, 5.58, 0.009, 16.532115, -23.992451, 6.12, 1.076,
  16.546665, 32.181485, 6.28, 1.308, 16.640114999999998, 12.956039, 6.14, 0.962, 16.75053, 56.934972, 6.41, 1.188,
  16.789379999999998, 53.498185, 6.31, 1.499, 16.803825, -23.996334, 6.36, 0.238, 16.827569999999998, -61.775289, 5.36, 0.884,
  16.94253, -9.78555, 5.71, 0.446, 16.949355, -41.486916, 5.21, 0.159, 16.98816, 20.739113, 5.56, 0.121,
  16.9986, 1.993042, 6.44, 0.847, 17.003385, 43.942092, 5.04, 0.109, 17.005515000000003, 32.01213, 6.23, 0.398,
  17.062155, 54.92034, 5.17, 0.704, 17.0925, 5.649819, 5.51, 0.334, 17.096130000000002, -55.24576, 3.94, -0.12,
  17.139405, 58.263449, 5.77, -0.019, 17.147460000000002, -10.182264, 3.46, 1.161, 17.184195, 86.25709, 4.24, 1.213,
  17.30115, 80.011579, 6.24, 0.922, 17.37552, 47.241792, 4.26, 0.012, 17.43291, 35.620558, 2.07, 1.576,
  17.455005, 19.658408, 5.57, 0.697, 17.530725, -57.694419, 6.41, 0.888, 17.547675, 15.673912, 6.07, 1.535,
  17.549775, -8.906135, 6.4, 1.029, 17.5782, 42.081475, 5.67, 0.603, 17.581049999999998, 25.457763, 5.81, 1.466,
  17.639805, 2.44567, 5.97, 1.491, 17.663684999999997, 68.778621, 5.32, -0.014, 17.775255, 55.149901, 4.34, 0.17,
  17.778195, 31.424736, 5.15, 0.261, 17.792835, 37.724121, 5.8, -0.095, 17.85642, 64.202677, 5.56, -0.052,
  17.86341, 21.03465, 4.66, 1.024, 17.870715, 10.291908, 6.49, 0.891, 17.91513, 30.089638, 4.51, 1.092,
  17.922435, 65.018854, 5.57, -0.072, 17.931285, -2.251079, 5.93, 1.403, 18.069015, 79.673963, 5.6, 0.008,
  18.141975, 45.337531, 6.13, 1.652, 18.189239999999998, -37.856479, 5.95, 0.281, 18.2478, 30.064229, 6.24, 0.98,
  18.29097, 61.706188, 6.4, 0.018, 18.432855, 7.575354, 5.21, 0.32, 18.43728, 24.583713, 4.67, 1.047,
  18.4386, 7.578261, 6.44, 0.492, 18.520425000000003, 28.529575, 6.33, 1.684, 18.531795, 16.133479, 5.97, -0.082,
  18.600165, -7.922826, 5.14, 0.448, 18.676635, 6.995136, 6.04, 1.081, 18.704880000000003, -0.973795, 5.7, 0.428,
  18.795645, -45.531664, 4.97, 0.571, 18.94056, -68.875927, 4.25, 0.48, 19.049580000000002, 71.743842, 5.87, 2.042,
  19.05264, 87.145496, 6.2, 1.114, 19.07883, 33.11472, 6.04, 1.163, 19.129215000000002, 79.910013, 6.27, 0.44,
  19.151205, -2.500368, 5.42, 0.888, 19.26546, -66.397854, 6.23, 0.052, 19.271085, 44.901992, 6.11, 1.59,
  19.350495, 31.744617, 6.36, 1.132, 19.44981, 3.614466, 5.13, 0.071, 19.542270000000002, 47.419706, 6.29, 1.357,
  19.55787, 57.803166, 6.39, 1.589, 19.69587, 37.386275, 6.44, 0.233, 19.866645000000002, 27.264059, 4.74, 0.032,
  19.95123, -0.509029, 5.87, 0.635, 20.020485, 58.231611, 4.95, 0.683, 20.080994999999998, 77.570682, 6.31, 0.912,
  20.11587, -11.238999, 6.16, 1.102, 20.144055, -3.24699, 6.26, 1.013, 20.27175, 64.658131, 6.33, 0.113,
  20.280705, 28.738207, 5.23, 1.396, 20.495745, 76.238804, 6.37, 0.283, 20.585054999999997, 45.528778, 4.87, 1.077,
  20.627010000000002, -19.081208, 6.35, 0.493, 20.645129999999998, -0.449673, 6.5, 1.079, 20.653965, 1.726332, 6.21, 1.482,
  20.83896, 58.142994, 6.36, 0.457, 20.85396, 20.468967, 5.97, 1.677, 20.878995, -30.945617, 5.84, 1.612,
  20.906025, 34.245887, 6.28, 0.829, 20.91918, 37.714943, 5.6, 0.276, 20.945055, 78.726056, 6.07, 0.389,
  21.00585, -8.183257, 3.6, 1.065, 21.010575000000003, -8.007416, 6.21, 0.235, 21.085424999999997, -6.914656, 5.92, 0.407,
  21.16638, -15.660468, 6.17, 0.924, 21.169935000000002, -41.492549, 5.42, 1.03, 21.17466, -44.528575, 6.26, 1.122,
  21.20283, -2.84859, 6.17, 0.959, 21.27204, -64.369478, 5.92, 1.561, 21.398654999999998, 23.511519, 6.18, 0.447,
  21.405135, -14.598796, 4.9, 1.231, 21.44295, 70.979887, 6.34, -0.011, 21.453239999999997, 60.235283, 2.66, 0.16,
  21.46818, -3.927391, 6.5, 1.348, 21.48312, 68.130012, 4.72, 1.047, 21.536475, 34.5797, 6.34, 0.5,
  21.563595, 19.172346, 5.35, 0.395, 21.577755, 43.457739, 5.98, 0.52, 21.598305, 20.070804, 6.44, 0.947,
  21.61395, -0.399034, 6.42, 1.241, 21.67365, 19.240422, 5.5, 1.106, 21.714855, -13.056512, 5.51, 0.321,
  21.77628, 34.377552, 6.27, 0.453, 21.847125, -22.338232, 6.43, 1.122, 21.861135, 41.101158, 6.42, 0.311,
  21.913725, 45.406687, 4.83, 0.421, 21.94392, -10.901582, 6.13, 1.32, 22.091385, -43.318234, 3.41, 1.542,
  22.09548, 7.961353, 6.22, 1.114, 22.37724, -46.756422, 6.25, 1.658, 22.400550000000003, -21.629339, 5.11, 0.028,
  22.42839, -25.617749, 6.37, 1.141, 22.470254999999998, 18.355669, 6.01, 0.162, 22.525425, 47.007274, 5.27, 0.999,
  22.546305, 6.14382, 4.84, 1.372, 22.59543, -26.207851, 5.92, 1.327, 22.7169, 66.098087, 6.15, 0.07,
  22.806659999999997, 70.264604, 5.82, 0.489, 22.812765, -49.072702, 3.93, 0.972, 22.870875, 15.345823, 3.62, 0.974,
  22.91253, -45.575712, 6.17, 0.066, 22.9302, -30.283081, 5.79, 1.073, 23.031570000000002, 34.799962, 6.39, -0.103,
  23.15157, -49.727713, 6.27, 0.462, 23.233545, -36.865231, 5.49, 1.021, 23.326155, 8.208738, 6.31, 0.8,
  23.35713, 58.327334, 5.69, 1.435, 23.413515, -78.50482, 6.11, 0.97, 23.428485, -7.025341, 5.75, 0.639,
  23.452305000000003, 89.015639, 6.46, 0.107, 23.48292, 59.23204, 4.68, 0.991, 23.569185, 37.237146, 5.9, -0.067,
  23.6574, -15.676359, 5.62, 0.066, 23.704439999999998, 18.460512, 5.9, 1.536, 23.711625, -31.892317, 6.11, 1.109,
  23.713829999999998, -3.523889, 6.44, 1.341, 23.71488, -23.699681, 6.41, 1.306, 23.811974999999997, -58.139475, 6.03, 0.382,
  23.94351, 14.661422, 6.23, -0.036, 23.96073, -39.947126, 6.43, 0.415, 23.96895, 41.07642, 6.39, 1.122,
  23.97813, 17.433841, 5.95, 0.259, 23.995694999999998, -15.400183, 5.41, 1.226, 24.035415, -29.907317, 5.69, 0.335,
  24.113355, 48.722776, 6.2, 1.237, 24.181365, 7.831529, 6.39, 1.605, 24.186600000000002, -58.270966, 6.18, 1.607,
  24.199485, 41.405459, 4.1, 0.536, 24.274649999999998, 12.141535, 5.54, 0.347, 24.365835, -84.769593, 5.66, 0.939,
  24.4071, -9.403782, 6.24, 0.528, 24.42834, -57.236757, 0.45, -0.158, 24.446669999999997, 64.739357, 6.49, 0.776,
  24.46695, -3.440678, 6.43, 1.568, 24.479385, -82.974995, 5.88, 0.62, 24.498075, 48.628213, 3.59, 1.275,
  24.531525, 57.977631, 5.55, 1.388, 24.61452, -36.528251, 5.94, 1.045, 24.62889, 73.04004, 5.28, 0.972,
  24.63261, 45.399706, 6.38, -0.021, 24.71577, -21.275384, 5.58, 0.346, 24.837525, 44.386165, 5.01, 0.883,
  24.92007, 16.405858, 5.98, 1.119, 24.947535, -56.1964, 5.76, 0.88, 25.05462, 53.868278, 6.35, 1.608,
  25.145055, 40.577049, 4.96, -0.068, 25.14552, 8.760769, 6.34, 0.401, 25.165110000000002, 43.297687, 5.63, 0.214,
  25.326525, 25.745712, 6.2, 0.459, 25.33884, -79.1482, 6.33, 0.947, 25.35789, 5.487613, 4.45, 1.347,
  25.3638, -38.132827, 6.2, 0.404, 25.413495, 30.04712, 5.97, 1.015, 25.436805, -11.324669, 5.75, 0.443,
  25.445745, 42.613369, 4.96, 0.618, 25.449825, -60.789339, 5.7, 1.264, 25.512495, -36.832305, 5.7, -0.01,
  25.51452, 35.245707, 5.63, -0.059, 25.535835, -32.32697, 5.25, 1.044, 25.573725, 58.627739, 6.35, -0.027,
  25.585320000000003, 68.043021, 5.57, -0.049, 25.621875, -53.740834, 5.52, 0.551, 25.62405, 20.268504, 5.24, 0.836,
  25.68129, -3.6902, 4.98, 1.378, 25.732395, 70.622526, 5.18, -0.022, 25.743, 61.421073, 6.33, 0.013,
  25.81863, 45.322649, 6.33, 1.02, 25.832265, 60.551332, 5.78, -0.01, 25.915125, 50.688732, 4.01, -0.098,
  25.958940000000002, 32.192015, 6.32, 0.879, 25.97832, -4.765514, 6.2, 1.537, 26.017185, -15.93748, 3.49, 0.727,
  26.074755, 57.536617, 6.18, 0.131, 26.11053, 46.139692, 6.32, 1.419, 26.18199, -6.766164, 6.45, 0.864,
  26.19234, 57.089226, 6.25, 0.062, 26.232615000000003, 20.083149, 6.27, 0.72, 26.34846, 9.157736, 4.26, 0.942,
  26.411445, -25.05261, 5.29, 0.395, 26.496915, -5.733299, 5.37, 1.517, 26.504385, -27.348831, 6.38, 0.366,
  26.5248, -50.816256, 5.49, 1.615, 26.52588, -53.522037, 5.04, 0.031, 26.81958, -41.759926, 6.18, 1.544,
  26.93502, 63.852501, 5.63, 0.804, 26.944365, -80.176311, 6.05, 0.338, 26.94903, -37.159483, 6.33, 1.016,
  26.95005, 46.22975, 6.33, 0.461, 27.045569999999998, 16.955551, 5.86, -0.039, 27.108404999999998, 3.685447, 5.91, 0.97,
  27.162119999999998, 37.95287, 5.94, 0.975, 27.17325, 32.69021, 5.78, 0.572, 27.31479, 47.896924, 6.01, 0.17,
  27.330885000000002, -31.072463, 6.35, 1.222, 27.39627, -10.68641, 4.66, 0.333, 27.4536, -38.402797, 6.37, 0.523,
  27.53571, 22.275338, 5.83, 0.743, 27.583949999999998, -47.816392, 6.14, 0.998, 27.716549999999998, 11.043378, 5.92, 0.302,
  27.726885000000003, -50.206138, 5.94, 0.154, 27.737969999999997, 51.933417, 5.96, 0.419, 27.859815, -39.835935, 6.44, 1.094,
  27.86514, -10.335038, 3.74, 1.136, 27.9075, -6.874143, 6.42, 1.233, 27.942075, -15.64748, 6.44, 1.608,
  27.99714, 55.147385, 5.53, -0.175, 28.03902, 50.792794, 5.7, -0.067, 28.21137, 51.474836, 6.28, 0.05,
  28.21713, -16.92925, 5.78, 0.26, 28.27044, 29.578829, 3.42, 0.488, 28.32228, 40.72979, 5.42, 1.311,
  28.34646, -38.594632, 6.09, 1.125, 28.38255, 19.293852, 3.88, -0.047, 28.388955000000003, 3.187536, 4.61, 0.928,
  28.41153, -46.302669, 4.39, 1.597, 28.452045000000002, 55.597639, 6.44, 0.185, 28.59183, -42.49695, 5.12, -0.06,
  28.598760000000002, 63.670101, 3.35, -0.15, 28.66002, 20.808035, 2.64, 0.165, 28.72407, 40.702034, 6.25, 1.262,
  28.73358, -67.647303, 4.68, 0.931, 28.740225, 37.12829, 6.28, 1.169, 28.83195, -60.312484, 6.43, 0.409,
  28.94364, -60.860975, 6.07, 0.356, 28.95963, -78.348548, 6.15, 0.448, 28.96266, 23.577322, 5.76, 1.185,
  28.9743, 1.849982, 6.01, 0.549, 28.977, 37.277786, 5.89, 1.599, 28.98846, -51.608896, 3.69, 0.844,
  29.000055, 68.685242, 4.97, -0.084, 29.038905, 37.25183, 5.69, 1.06, 29.039175, -49.836446, 6.37, -0.081,
  29.167485, -22.526785, 4.92, 1.434, 29.249415, -51.766244, 6.1, 0.487, 29.290035, -10.242427, 6.42, 0.817,
  29.291880000000003, -47.385277, 4.82, 0.864, 29.33772, 17.817532, 5.09, 0.921, 29.432265, 27.804381, 5.84, 1.576,
  29.472315, -65.4247, 6.36, 0.906, 29.48217, 23.596061, 4.79, 0.29, 29.49681, 47.09552, 6.48, 1.203,
  29.61117, -33.066787, 6.37, 1.006, 29.638440000000003, 61.697788, 6.02, -0.042, 29.639595, 49.204352, 5.7, 1.005,
  29.691765, -61.569859, 2.86, 0.29, 29.69166, -11.300955, 6.46, 1.128, 29.85786, 12.294876, 6.09, 0.186,
  29.89866, 21.05857, 5.89, 1.031, 29.90838, 64.621602, 5.29, 0.002, 29.91177, -42.030532, 5.57, 1.052,
  29.92125, -66.066558, 6.09, 1.176, 29.942490000000003, -20.824539, 5.43, 1.64, 30.001260000000002, -21.077831, 3.99, 1.554,
  30.038159999999998, 3.097015, 5.89, 0.61, 30.111765000000002, -8.523873, 5.43, 1.391, 30.311385, -30.00183, 5.34, 0.883,
  30.426599999999997, -44.713509, 5.15, 1.471, 30.489659999999997, 70.90702, 4.49, 0.164, 30.511755, 2.763759, 3.82, 0.024,
  30.575384999999997, 54.487541, 4.99, -0.071, 30.617775, -29.665642, 6.4, 0.135, 30.646154999999997, 13.476716, 5.97, 1.584,
  30.715575, -23.886628, 6.3, 1.34, 30.718694999999997, 64.901466, 6, 0.029, 30.737654999999997, 77.916263, 6.04, 1.107,
  30.741495, 33.284135, 5.5, 0.029, 30.744030000000002, -15.305932, 5.87, 0.966, 30.75078, 64.390018, 5.59, 0.325,
  30.793709999999997, 73.85057, 6.12, 0.162, 30.798540000000003, 0.128507, 5.42, 0.146, 30.85902, 72.421294, 3.95, -0.002,
  30.913905, 25.935471, 5.64, 0.537, 30.918704999999996, -4.103516, 5.61, 1.589, 30.92754, 18.253238, 6.24, 1.424,
  30.950715000000002, -0.340251, 5.96, 0.851, 30.97476, 42.329725, 2.1, 1.37, 31.051949999999998, -11.85977, 6.43, 1.498,
  31.122660000000003, -29.296819, 4.68, -0.156, 31.146195000000002, -54.881689, 6.45, 0.386, 31.21254, 7.735664, 6.44, 1.114,
  31.279725, 77.281341, 5.27, 0.345, 31.381544999999996, 76.11506, 5.22, 0.954, 31.551090000000002, 8.248114, 6.27, 1.636,
  31.622114999999997, 0.035384, 6.29, 0.897, 31.641345, 22.648317, 5.03, 0.121, 31.70514, 25.704553, 6.01, -0.03,
  31.71687, -19.138869, 6.39, 1.143, 31.793325000000003, 23.462423, 2.01, 1.151, 32.023695000000004, -41.88042, 6.5, 0.205,
  32.121809999999996, 37.859077, 4.78, 0.12, 32.139825, 44.459429, 6.38, 0.965, 32.16909, 58.423601, 5.66, 0.595,
  32.190255, -17.779155, 6.07, 1.661, 32.28876, -43.516596, 5.84, 1.197, 32.346285, 17.224196, 6.4, 0.471,
  32.355540000000005, 25.939892, 4.98, 0.339, 32.35593, 81.295945, 6.05, 0.118, 32.38587, 34.987297, 3, 0.14,
  32.39502, -24.345785, 6.48, 0.289, 32.451915, -40.866501, 6.49, 0.43, 32.52, -43.815574, 6.32, 0.899,
  32.532255000000006, 53.843091, 6.31, 0.948, 32.605095, -50.823725, 6.12, 0.812, 32.656635, 19.500338, 5.68, 1.641,
  32.72013, 39.039526, 6.09, -0.054, 32.80023, 25.936938, 6.01, 1.365, 32.837835, 8.569805, 5.64, 0.569,
  32.842605, -10.052162, 6, 0.418, 32.854245, 31.526398, 6.24, 0.112, 32.871645, 57.645543, 6.38, 0.298,
  32.899305000000005, -1.825429, 5.94, 0.967, 33.0657, 2.745551, 6.49, 1.039, 33.092865, 30.303067, 4.94, 0.77,
  33.156405, 24.167778, 5.96, 1.366, 33.19809, -2.393637, 5.65, 0.546, 33.200325, 21.210993, 5.23, 0.457,
  33.2082, 79.69154, 6.46, 0.24, 33.226949999999995, -30.723825, 5.27, -0.013, 33.249975, 8.846717, 4.36, 0.878,
  33.2541, -21.000137, 5.86, 1.006, 33.26376, 15.27986, 5.72, 1.551, 33.305535, 44.231652, 4.84, 1.476,
  33.337799999999994, 74.027721, 6.25, 0.915, 33.389625, 53.058589, 6.5, 1.661, 33.40092, 51.065818, 5.31, 0.926,
  33.423375, 58.560586, 6.43, 0.554, 33.473144999999995, -9.06463, 6.43, 1.415, 33.510329999999996, 47.484241, 6.05, 0.406,
  33.56049, -67.841441, 5.57, 1.556, 33.621255000000005, 66.524428, 6.05, 0.641, 33.633120000000005, -41.166765, 5.91, 0.965,
  33.6582, 28.691185, 6.35, 0.957, 33.8691, -67.746366, 5.67, 1.306, 33.928259999999995, 25.043043, 5.57, 0.52,
  33.941835000000005, 25.782937, 5.79, 0.439, 33.984525, 33.358895, 5.25, -0.004, 33.990495, 47.811937, 6.37, 1.029,
  34.12731, -51.512165, 3.56, -0.12, 34.188765, 83.561414, 6.45, 0.951, 34.21548, 57.055246, 6.48, 0.281,
  34.24602, -6.422116, 5.51, 0.962, 34.262865, 34.224231, 4.84, 0.607, 34.328595, 33.847194, 4.03, 0.019,
  34.4994, 57.89982, 5.75, 1.175, 34.506, 1.757802, 5.6, 0.588, 34.519125, 57.516321, 5.99, 1.039,
  34.53141, 19.901164, 5.58, 0.011, 34.737465, 28.642674, 5.29, 0.037, 34.741455, 23.167815, 6.45, 0.376,
  34.743825, -25.945687, 6.33, 0.724, 34.795125, 46.472261, 6.21, 0.164, 34.820055, 47.379973, 5.31, 0.006,
  34.83663, -2.977643, 6.47, 0.966, 34.844609999999996, 48.955463, 6.44, 0.427, 34.85319, -41.848367, 6.36, 1.162,
  34.91991, -4.345573, 6.5, 0.082, 34.976085, -55.944796, 5.81, 1.57, 35.172959999999996, 47.310804, 6.17, -0.094,
  35.242484999999995, 50.151466, 5.57, -0.089, 35.43747, -68.659418, 4.08, 0.034, 35.480985000000004, 57.242916, 6.4, 0.569,
  35.48595, 0.395675, 5.29, 1.648, 35.50638, -10.777534, 5.43, 0.364, 35.520765, -17.662169, 5.89, 1.231,
  35.548905000000005, -43.199811, 6.3, 0.991, 35.55165, -0.884852, 5.42, 0.335, 35.589315, 55.845653, 5.16, 0.369,
  35.63556, -23.816326, 5.19, 0.608, 35.70966, 41.396297, 5.81, 0.289, 35.71845, -73.645792, 5.99, 1.088,
  35.727779999999996, -51.092129, 5.9, 0.213, 35.740095000000004, -18.354982, 6.22, 0.942, 35.77749, -37.576144, 6.47, 1.592,
  35.965605000000004, 55.364861, 6.29, 0.845, 36.083819999999996, -25.847459, 6.45, 1.321, 36.103784999999995, 50.006546, 5.19, 0.979,
  36.141000000000005, -40.840458, 6.17, 0.653, 36.204405, 10.610565, 5.48, -0.098, 36.224805, -60.311947, 5.36, 0.395,
  36.243285, -2.780031, 6.34, -0.011, 36.316785, 56.609823, 6.25, 0.249, 36.3603, -66.494026, 6.39, 1.511,
  36.4059, 50.278631, 4.73, 1.532, 36.487514999999995, -12.29048, 4.88, -0.027, 36.501465, -15.341247, 5.88, 0.116,
  36.646725, -20.042617, 5.89, 1.247, 36.746325, -47.70384, 4.24, -0.136, 36.780165000000004, 27.012395, 6.14, 1.461,
  36.84747, 10.198326, 6.45, 0.45, 36.865725, 31.80128, 5.55, 1.114, 36.9657, 50.569974, 6.16, 0.435,
  36.999705, 1.960846, 6.45, 0.971, 37.007085, -33.811039, 5.13, 0.089, 37.01817, -64.299768, 6.35, -0.025,
  37.039755, 8.460054, 4.3, -0.053, 37.041585, 29.66933, 5.29, 0.311, 37.147650000000006, -31.102445, 6.11, 1.106,
  37.202085, 29.93176, 5.89, 0.591, 37.266555, 67.402474, 4.46, 0.153, 37.306995, 23.469026, 6.2, 0.155,
  37.397324999999995, 9.565629, 6.09, 1.022, 37.557165, -25.186442, 6.5, 0.294, 37.569165000000005, 33.833707, 6.26, 1.079,
  37.63479, 25.235036, 5.88, 0.412, 37.636635, -22.545318, 6.17, 1.581, 37.660064999999996, 19.855301, 6.14, 0.247,
  37.68834, 0.255749, 6, 0.168, 37.72665, 17.703856, 6.21, 0.908, 37.875405, 2.267182, 5.27, 1.271,
  37.91751, -79.109382, 5.27, 0.981, 37.94625, 89.264109, 1.97, 0.636, 38.02179, -15.244677, 4.74, 0.454,
  38.02567500000001, 36.147271, 5.15, 1.472, 38.03925, -1.034896, 5.36, 1.004, 38.061479999999996, -36.427307, 6.28, 1.027,
  38.21928, 34.54241, 5.84, 1.083, 38.22558, 15.034554, 6, 0.572, 38.27928, -34.649967, 5.91, 1.064,
  38.417595000000006, -20.001921, 6.19, 1.1, 38.461275, -28.232343, 4.96, -0.05, 38.47755, -51.093546, 6.24, 0.509,
  38.677605, -7.859445, 5.74, 1.393, 38.76723, 7.470993, 6.17, 1.053, 38.866245, 39.66438, 6.36, -0.095,
  38.911424999999994, 37.312263, 5.72, 1.389, 38.94504, 34.687558, 5.38, 1.652, 38.968635, 5.593246, 4.87, 0.88,
  39.000195000000005, -7.831597, 5.53, 1.607, 39.020355, 6.88687, 5.79, 0.918, 39.038610000000006, -30.044978, 5.74, 1.017,
  39.14613, 7.730026, 5.81, 1.04, 39.157965, 12.447639, 5.64, 0.516, 39.17931, 31.607667, 6.07, 1.052,
  39.238185, 38.733581, 5.91, 0.502, 39.244215, -34.577977, 5.78, 0.653, 39.25215, 24.647222, 6.48, 0.51,
  39.277335, 32.891092, 6.23, 0.515, 39.351375000000004, -52.543086, 5.3, 0.289, 39.40013999999999, 65.745336, 5.8, 1.561,
  39.42417, -3.396175, 5.65, 1.021, 39.50313, 7.695276, 6.4, 0.431, 39.508635, 72.818252, 5.17, 0.896,
  39.57432, 37.726715, 6.19, 0.49, 39.577725, -30.194062, 5.84, 0.476, 39.603404999999995, -37.990545, 6.48, 0.521,
  39.61647, 38.089141, 6.29, -0.029, 39.653355, 3.443205, 6.21, 0.999, 39.704145, 21.961408, 5.45, 0.168,
  39.87066, 0.328511, 4.08, -0.212, 39.890969999999996, -11.872156, 4.83, 0.447, 39.896985, -68.266946, 4.12, -0.061,
  39.94989, -42.89167, 4.74, 0.061, 40.051755, -9.452875, 5.79, 0.524, 40.06539, 6.111944, 6.26, 0.397,
  40.164989999999996, -54.549911, 5.21, 0.411, 40.166714999999996, -39.855375, 4.11, 1.006, 40.171125, 27.060943, 5.3, 0.081,
  40.308330000000005, -0.695653, 5.72, 0.511, 40.39221, -14.549276, 5.98, 0.429, 40.451355, -3.213807, 6.07, 1.175,
  40.52751, -38.383686, 5.99, 0.917, 40.535175, -46.524441, 6.09, 0.876, 40.56216, 40.193944, 4.91, 0.582,
  40.59141, 20.011465, 5.74, -0.017, 40.62057, 10.741725, 6.32, 0.064, 40.638974999999995, -50.800294, 5.4, 0.561,
  40.74792, 53.526105, 5.85, 1.125, 40.75773, 48.265245, 6.3, 1.14, 40.761765000000004, 55.106019, 5.76, -0.11,
  40.82517, 3.235818, 3.47, 0.093, 40.834305, -40.527905, 6.35, -0.022, 40.86051, -66.714252, 6.23, 0.542,
  40.86297, 27.707146, 4.65, -0.122, 40.87047, -2.531452, 6.48, 0.981, 40.963514999999994, 25.638343, 6.35, 0.089,
  41.02149, 44.29704, 5.43, 0.904, 41.030625, -13.858696, 4.24, -0.122, 41.044095000000006, -52.570597, 6.15, 0.088,
  41.04951, 49.228448, 4.1, 0.514, 41.07963, 17.763928, 6.4, 1.143, 41.085555, -32.524715, 6.21, 0.04,
  41.137395, 15.311862, 5.78, -0.024, 41.206995, 67.82463, 5.95, 0.136, 41.235585, 10.114146, 4.27, 0.311,
  41.239920000000005, 12.445761, 5.17, 0.234, 41.275725, -18.572563, 4.47, 0.481, 41.337105, 4.711629, 6.04, 0.312,
  41.364435, -63.704553, 5.73, 0.932, 41.38572, -67.616617, 4.83, 0.058, 41.687925, -21.639521, 6.48, 0.387,
  41.742975, 35.983523, 6.27, 0.935, 41.76492, 35.55468, 6.28, 0.385, 41.796375, -22.48575, 6.47, 0.398,
  41.879805000000005, 44.272198, 6.45, 0.637, 41.94852, 81.448475, 5.8, 1.3, 41.9772, 29.247118, 4.52, 1.112,
  42.133695, 18.28379, 5.83, 1.216, 42.19125, 25.188064, 5.89, -0.033, 42.231285, 69.63429, 6.26, 0.151,
  42.25593, -62.806521, 5.25, 0.101, 42.272535000000005, -32.405898, 4.45, 0.981, 42.323159999999994, 17.464309, 5.26, -0.066,
  42.362145, 37.326411, 6.45, 0.422, 42.378075, 57.084318, 6.25, 0.786, 42.46236, -24.560311, 6.14, 0.998,
  42.47574, -27.941981, 5.39, 0.013, 42.495945, 27.260507, 3.61, -0.1, 42.56157, -35.843636, 5.92, 0.899,
  42.618825, -75.066947, 4.76, 1.337, 42.645945, 38.318644, 4.22, 0.343, 42.647055, 36.948328, 6.44, 0.617,
  42.668355, -35.675849, 5.48, 1.259, 42.674175, 55.895496, 3.77, 1.69, 42.699164999999994, -39.932224, 6.36, 0.04,
  42.759675, -21.004019, 4.76, 0.906, 42.87327, 15.082071, 5.52, -0.099, 42.87849, 35.059741, 4.56, 1.554,
  42.92391000000001, 46.841939, 5.86, 0.903, 42.941235, 58.314291, 6.46, 0.104, 42.984315, -30.81452, 6.38, 0.484,
  42.994785, 68.888497, 5.94, 0.7, 43.0791, -62.909583, 6.03, 1.249, 43.133849999999995, -12.769714, 6.05, 0.862,
  43.211415, -9.441236, 6.31, 0.196, 43.21677, 52.997353, 6.35, 0.093, 43.227689999999996, -65.455291, 6.47, 1.008,
  43.298730000000006, 16.48346, 6.3, 0.457, 43.33779, 48.569955, 6.23, 1.18, 43.393275, -38.437004, 5.93, 0.437,
  43.39716, -22.376308, 5.93, 1.041, 43.42752, 38.337488, 5.34, 0.423, 43.526955, -50.871402, 6.22, 1.571,
  43.564425, 52.762479, 3.93, 0.758, 43.95207, 18.33164, 5.76, 1.452, 43.98678, 61.521138, 5.59, 0.445,
  44.057370000000006, 8.381563, 5.97, 0.478, 44.102714999999996, 64.332442, 6.17, 1.994, 44.10687, -8.898144, 3.89, 1.088,
  44.108940000000004, 18.023119, 5.58, 0.471, 44.138760000000005, 47.164006, 6.05, 1.305, 44.155935, -3.71232, 5.16, 0.084,
  44.211074999999994, 51.261284, 6.22, 1.567, 44.269065000000005, 4.50103, 6.15, 1.623, 44.303760000000004, -29.855289, 6.29, 0.472,
  44.32201499999999, 31.934219, 5.1, -0.007, 44.349, -23.862164, 5.44, 0.238, 44.385945, -38.190925, 6.41, -0.018,
  44.50971, 38.614926, 6.06, 1.403, 44.52171, 20.668733, 5.8, 0.415, 44.52387, -23.606012, 5.82, 1.334,
  44.565345, -40.304672, 2.88, 0.128, 44.675325, -2.782877, 5.22, 0.014, 44.69028, 39.662728, 4.68, 0.065,
  44.69709, -9.776506, 6.14, 0.221, 44.699085, -64.071284, 4.98, 0.126, 44.76534, 35.183128, 4.94, 1.235,
  44.777055, -28.907213, 6.14, 1.044, 44.80302, 21.340429, 4.63, 0.048, 44.900715, -25.274133, 5.69, 0.427,
  44.909595, -32.507198, 6.32, 0.002, 44.916149999999995, 41.032941, 5.89, 1.445, 44.921504999999996, -2.464952, 5.56, -0.072,
  44.92875, 8.907365, 4.71, -0.109, 44.957460000000005, 47.220693, 5.47, 0.869, 45.049544999999995, 38.13174, 6.11, -0.057,
  45.183915, 10.870388, 5.93, 1.593, 45.211995, -2.878618, 6.11, 1.751, 45.217515, 52.351744, 5.24, -0.049,
  45.291765, -7.663012, 5.75, 1.043, 45.406724999999994, -28.091554, 5.88, 0.794, 45.467925, 5.336151, 6.24, 1.041,
  45.47559, 26.462354, 5.91, 0.141, 45.483825, -9.961407, 5.84, 1.092, 45.53865, -6.494543, 6.2, 0.598,
  45.564225, -71.902457, 5.51, -0.125, 45.56988, 4.089734, 2.54, 1.63, 45.59382, 4.352884, 5.62, -0.107,
  45.597945, -23.624472, 4.08, 0.163, 45.67614, -7.685472, 5.32, 0.941, 45.732735000000005, -46.975036, 5.81, 1.304,
  45.87564, 28.269906, 6.38, 0.306, 45.903585, -59.737775, 5.12, 0.349, 45.986445, 47.84848, 6.48, 0.301,
  46.06881, -7.600857, 5.26, 0.193, 46.158615, 1.863604, 6.05, 1.045, 46.169355, 15.856023, 6.37, 1.4,
  46.19913, 53.50644, 2.91, 0.716, 46.29405, 38.840274, 3.32, 1.528, 46.297064999999996, -8.274247, 6.3, 1.02,
  46.337565, 40.582181, 6.06, 1.011, 46.361205, 25.255174, 5.45, -0.031, 46.38507, 56.705719, 4.77, 1.018,
  46.417334999999994, 56.068965, 6.1, 1.049, 46.533044999999994, 79.418535, 5.49, 1.569, 46.598685, 13.18725, 5.64, 1.087,
  46.639545000000005, -6.088555, 5.23, 1.575, 46.829205, 64.057594, 5.89, -0.02, 46.85697, 17.879995, 6.13, -0.123,
  46.883115000000004, -78.989244, 5.67, 0.298, 46.947255, 47.308709, 6.38, 0.122, 46.954065, -69.26492, 6.12, 1.011,
  46.961850000000005, -27.831151, 6.18, 0.166, 47.016015, 52.213511, 6.33, -0.019, 47.04222, 40.955648, 2.09, -0.003,
  47.087954999999994, 18.795053, 6.24, 1.56, 47.161635, 8.471069, 6.28, 1.026, 47.22576, 62.384596, 6.47, 0.231,
  47.265075, 49.613278, 4.05, 0.595, 47.33388, 20.761123, 6.41, 1.241, 47.37387, 44.857544, 3.79, 0.98,
  47.40309, 29.07708, 5.74, 0.115, 47.53683, 27.819766, 6.42, 0.014, 47.612685, 26.896233, 6.02, 1.278,
  47.613524999999996, -48.734156, 6.11, 1.118, 47.64744, -23.738548, 6.37, 0.912, 47.661645, 11.872627, 5.97, -0.061,
  47.753235000000004, 64.896266, 6.5, 0.163, 47.772015, -13.264284, 6.36, 0.614, 47.8197, -16.024967, 6.25, 1.167,
  47.822444999999995, 39.611582, 4.61, 1.115, 47.828235, -3.811595, 6.08, 1.67, 47.84133, 13.047845, 6.11, 1.038,
  47.90733, 19.726677, 4.35, 1.033, 47.928435, 81.47071, 5.92, 0.149, 47.984355, 74.393659, 4.85, 0.035,
  48.018735, -28.987618, 3.8, 0.543, 48.039809999999996, 42.375905, 6.15, -0.099, 48.059355, 27.256968, 5.78, -0.106,
  48.107189999999996, -44.41966, 5.92, 0.44, 48.109995000000005, 47.725875, 6.32, 1.425, 48.10986, 6.660883, 5.55, 1.011,
  48.138135, -57.321549, 5.71, 2.419, 48.193485, -1.196101, 5.07, 0.575, 48.2562, -35.943688, 6.29, -0.076,
  48.349455, 48.176953, 5.93, 0.972, 48.408105, -29.804129, 6.17, 1.041, 48.7254, 21.044441, 4.87, -0.007,
  48.735735, 42.503637, 6.07, 1.093, 48.751124999999995, -26.100459, 6.25, 0.038, 48.835155, 30.556689, 5.61, 0.012,
  48.946425, 32.856712, 6.3, 0.366, 48.949875, 57.14062, 5.79, 0.644, 48.952785, 50.95589, 6.46, 0.1,
  48.958439999999996, -8.81973, 4.8, 0.232, 48.989264999999996, -77.388454, 5.51, 0.438, 49.00356, -5.918705, 6.17, -0.018,
  49.00773, 34.688513, 6.25, 0.29, 49.018545, 45.346133, 6.15, 1.674, 49.050855, 50.937664, 5.04, 1.107,
  49.090515, -5.730464, 6.3, 1.648, 49.146629999999995, 32.184018, 5.98, 0.988, 49.14903, -9.154676, 6.14, 0.407,
  49.297725, 40.482979, 6.44, -0.027, 49.36083, -47.751664, 5.84, 1.228, 49.381395, 65.658367, 6.41, 0.079,
  49.4169, 31.127048, 6.4, 0.574, 49.438545, -62.575322, 5.53, 0.641, 49.44063, 39.283373, 5.97, 0.056,
  49.447275000000005, 44.025024, 5.49, -0.06, 49.49592, -66.926853, 6.03, 0.133, 49.510755, -28.797075, 5.93, 0.337,
  49.549635, -62.506363, 5.24, 0.6, 49.5921, -22.511118, 4.86, 0.904, 49.593435, -0.930288, 5.62, 1.05,
  49.65723, 50.222174, 5.16, -0.073, 49.671435, -18.559794, 5.72, 0.381, 49.682610000000004, 34.222653, 4.85, 1.491,
  49.781805, 50.094966, 5.05, -0.067, 49.840395, 3.370198, 4.84, 0.681, 49.87917, -21.757864, 3.7, 1.614,
  49.895445, -24.122902, 5.63, 1.663, 49.97916, -43.069784, 4.26, 0.711, 49.98249, 27.071134, 5.91, 0.86,
  49.996935, 65.652292, 4.74, -0.108, 50.081745, 77.73474, 5.44, 0.211, 50.084835000000005, 29.048458, 4.47, 1.555,
  50.106555, 25.662739, 6.14, 1.241, 50.188335, -26.606506, 6.4, 0.542, 50.27835, 3.67562, 5.7, 0.964,
  50.306760000000004, 21.147086, 5.27, -0.067, 50.350049999999996, -23.635135, 5.5, 0.885, 50.360715, 43.329651, 4.96, 0.051,
  50.38929, -47.776661, 6.4, 0.989, 50.468655000000005, 49.070905, 5.94, 0.468, 50.549549999999996, 27.607553, 5.55, 1.1,
  50.56785, -25.587802, 6.36, 0.01, 50.68851, 20.742069, 5.1, 1.231, 50.804955, 49.213269, 5.32, -0.076,
  50.823750000000004, -7.794098, 6.2, 0.702, 50.901270000000004, 0.910087, 6.47, 1.154, 50.912459999999996, 4.882105, 6.37, 0.851,
  51.00954, -69.624606, 6.14, 0.482, 51.04221, 12.62959, 6.03, 1.227, 51.07698, 24.724063, 5.5, 1.19,
  51.08067, 49.86118, 1.79, 0.481, 51.108825, 20.803489, 6.07, -0.028, 51.123735, 33.535962, 5.78, -0.001,
  51.150855, -51.062657, 6.5, 0.003, 51.169005, 64.585996, 5.13, 2.038, 51.20331, 9.02887, 3.61, 0.887,
  51.401055, -69.336436, 5.96, 0.415, 51.482654999999994, -35.920885, 6.39, 0.082, 51.48906, 49.120757, 6.09, -0.073,
  51.54909, -41.63694, 6.33, 0.054, 51.593849999999996, -27.317479, 5.93, 0.934, 51.647445000000005, 28.715087, 6.47, 0.882,
  51.7923, 9.73268, 3.73, -0.082, 51.82782, 12.735289, 6.29, -0.025, 51.889215, -35.681323, 5.71, 1.284,
  52.00395, -11.2866, 5.74, 1.102, 52.012755, 49.062866, 4.99, -0.091, 52.048004999999996, -35.853426, 6.49, 0.126,
  52.08624, 33.807557, 5.72, 0.048, 52.09824, 60.255672, 6.49, 0.014, 52.11069, 22.804006, 6.03, 0.951,
  52.217999999999996, 49.848384, 5.58, -0.054, 52.26585, 3.248704, 6.41, 0.79, 52.26723, 59.94033, 4.21, 0.419,
  52.341840000000005, 49.508948, 4.67, -0.096, 52.34337, -62.937527, 4.71, 0.41, 52.359494999999995, 46.937868, 6.21, 0.131,
  52.400115, -12.674737, 5.57, 0.171, 52.413075, -6.804458, 6.01, 1.02, 52.478100000000005, 58.87875, 4.55, 0.489,
  52.47984, -42.634256, 5.76, 0.205, 52.4955, -78.35185, 5.68, 0.932, 52.500855, 55.451808, 5.09, 0.022,
  52.545584999999996, 59.365947, 6.14, 0.095, 52.556594999999994, -41.369937, 6.12, 0.489, 52.580805, 71.863897, 6.37, 1.772,
  52.601955000000004, 11.336442, 5.14, -0.041, 52.643685, 47.995216, 4.36, 1.367, 52.6539, -47.375125, 5.98, 0.116,
  52.65393, 48.103596, 5.82, -0.033, 52.65441, -5.075145, 4.74, -0.092, 52.689255, 6.188703, 5.93, 0.953,
  52.715385, -66.489714, 5.81, -0.055, 52.718235, 12.936678, 4.14, 1.112, 52.87227, 49.20977, 6.29, 0.067,
  52.876215, 40.759934, 6.5, 0.243, 52.95432, 49.401093, 6.41, 0.075, 52.97352, -25.614149, 6.38, 0.12,
  53.035815, 48.023476, 5.47, -0.101, 53.0823, 84.91104, 5.62, 0.894, 53.109465, 46.056862, 5.3, 0.398,
  53.14488, -50.378646, 5.67, 1.101, 53.149785, 9.373438, 5.76, -0.072, 53.162400000000005, 44.855759, 6.42, -0.007,
  53.166735, 35.461729, 5.91, -0.084, 53.21463, -61.016872, 6.42, 1.037, 53.23272, -9.458262, 3.72, 0.881,
  53.38416, 58.76524, 6.45, 0.168, 53.395965000000004, 39.899478, 5.79, 0.139, 53.412825, 54.974857, 5.98, 0.114,
  53.421825, 57.868725, 6.37, 0.523, 53.446979999999996, -21.632883, 4.26, -0.106, 53.48664, -31.080114, 6.2, 0.482,
  53.534895, 17.832828, 6.14, 0.891, 53.61093, 24.464393, 5.95, 0.123, 53.639939999999996, -31.874801, 6.39, 1.404,
  53.656124999999996, -9.868261, 6.25, 0.019, 53.704499999999996, 6.417691, 6.49, 0.642, 53.718345, -25.582825, 6.48, 0.985,
  53.754255, 60.041429, 6.43, 0.433, 53.988525, -5.124954, 6.49, 1.091, 53.99028, -11.193782, 5.56, 0.915,
  54.072554999999994, -17.467064, 5.24, -0.117, 54.122385, 48.192634, 4.32, -0.058, 54.125730000000004, -78.323073, 6.29, 1.15,
  54.19704, 0.587758, 5.82, 0.885, 54.218265, 0.401662, 4.29, 0.575, 54.27366, -40.274545, 4.57, 1.023,
  54.449295, 15.430552, 6.4, 0.167, 54.500744999999995, 42.582843, 6.41, -0.064, 54.582165, 56.932713, 6.29, -0.099,
  54.621885, -7.391863, 5.86, 0.98, 54.698625, -27.943054, 6.01, -0.027, 54.750255, 20.915765, 6.5, 0.151,
  54.754650000000005, -5.62621, 5.97, 0.921, 54.854549999999996, 75.739622, 6.25, 0.973, 54.855855, -10.437278, 6.19, 1.031,
  54.857295, 16.536685, 6.18, 1, 54.90978, -3.39301, 6.22, 1.041, 54.963015, 3.056863, 5.55, 0.931,
  54.998205, -1.121226, 6.12, 0.994, 55.04766, -15.226534, 6.35, 0.881, 55.159725, -5.210706, 5.53, -0.145,
  55.19295, 25.329492, 6.11, 0.097, 55.282725, 37.580198, 5.55, -0.062, 55.30749, -11.802418, 6.49, 0.377,
  55.53891, 63.216806, 5.06, 1.651, 55.541145, -45.957888, 6.5, 0.522, 55.562085, -31.938361, 4.99, -0.159,
  55.578945, 19.700254, 5.68, -0.016, 55.594364999999996, 33.965026, 4.97, -0.048, 55.63626, -85.261964, 6.4, -0.005,
  55.678065, 59.969391, 5.74, 1.736, 55.708619999999996, -37.313518, 4.59, 1.191, 55.73124, 47.787551, 3.01, -0.125,
  55.81209, -9.763395, 3.52, 0.915, 55.890975000000005, -10.485661, 5.59, 0.216, 55.9467, 19.665032, 6.13, 0.994,
  56.02656, -40.660289, 6.45, 1.059, 56.026785000000004, 48.523656, 6.06, 1.552, 56.048895, -64.806903, 3.84, 1.133,
  56.07972, 32.288248, 3.84, 0.022, 56.117505, 20.928737, 6.09, 0.028, 56.12712, -1.163091, 5.24, -0.088,
  56.130930000000006, 36.460103, 5.6, 0.062, 56.14116, -54.274027, 6.29, 1.035, 56.170455, 46.099813, 6.1, 0.291,
  56.200889999999994, 24.28947, 5.45, -0.034, 56.210325000000005, -48.061299, 6.49, 1.011, 56.218905, 24.113339, 3.72, -0.105,
  56.235405, -0.29672, 5.56, 1.411, 56.290575000000004, 24.83926, 5.66, -0.064, 56.298480000000005, 42.578549, 3.77, 0.425,
  56.30205, 24.467278, 4.3, -0.11, 56.31615, -47.359476, 5.72, 0.961, 56.34879, -71.658132, 6.26, -0.123,
  56.404560000000004, 38.676262, 6.45, 1.195, 56.41851, 6.049991, 5.34, -0.099, 56.456685, 24.367748, 3.87, -0.063,
  56.47698, 24.554511, 5.76, -0.036, 56.4969, 45.681899, 5.66, -0.08, 56.50360499999999, 67.201605, 5.79, 0.347,
  56.50971, 63.345047, 4.78, 0.747, 56.512080000000005, 24.527898, 6.43, -0.02, 56.535555, -12.101589, 4.43, 1.604,
  56.539005, 6.80352, 5.91, 0.992, 56.58156, 23.948358, 4.14, -0.051, 56.61429, -29.338157, 5.91, 0.11,
  56.712059999999994, -23.249723, 4.22, 0.434, 56.809425, -74.238962, 3.26, 1.59, 56.87115, 24.105137, 2.85, -0.086,
  56.883900000000004, 55.92196, 6.09, -0.02, 56.915205, -23.874677, 5.24, 0.075, 56.954265, 32.195415, 6.26, 0.474,
  56.95671, -36.105785, 6.21, -0.102, 56.9835, -30.167882, 5.52, 0.973, 57.027255, 24.988416, 6.44, 1.701,
  57.067785, 11.143294, 5.08, -0.125, 57.075315, 50.736767, 6.18, 0.028, 57.08673, 23.42125, 5.44, -0.067,
  57.14877, -20.902977, 5.81, 1.602, 57.149445, -37.620155, 4.3, -0.038, 57.162315, 0.227857, 5.91, 1.224,
  57.23724, 23.857135, 6.47, 0.377, 57.28383, 43.963095, 5.95, 0.279, 57.290595, 24.053415, 3.62, -0.07,
  57.29673, 24.136712, 5.05, -0.082, 57.307140000000004, 70.87105, 5.4, 0.096, 57.332265, 57.118268, 6.46, 0.061,
  57.363555000000005, -36.20025, 4.17, 0.927, 57.380355, 65.525972, 4.39, 1.87, 57.38622, 33.091382, 5.14, 0.057,
  57.40254, 63.296967, 5.82, 0.189, 57.43137, 23.711855, 6.17, -0.046, 57.47946, 22.244151, 6.05, -0.006,
  57.51846, 44.967856, 5.65, 0.779, 57.567345, -1.522574, 6.47, 0.435, 57.578894999999996, 25.579362, 5.24, 0.231,
  57.589529999999996, 71.332266, 4.59, 0.064, 57.81612, 13.046078, 6.3, -0.058, 57.924, 68.507486, 6.31, -0.057,
  57.97383, 34.359119, 5.78, -0.036, 58.00095, 6.534907, 5.66, 0.046, 58.01853, 31.168578, 6.22, 0.206,
  58.17357, -5.361259, 5.48, -0.09, 58.291845, 17.327083, 5.97, 0.354, 58.303875000000005, -18.434447, 6.21, 0.866,
  58.388805, -46.893674, 5.93, 1.22, 58.39365, 25.682883, 6.35, 0.11, 58.411215, 48.650495, 5.76, 1.04,
  58.412265, -34.732297, 5.11, -0.133, 58.427925, -24.61223, 4.64, -0.136, 58.430175, 57.975141, 5.8, 0.182,
  58.533, 31.883635, 2.84, 0.271, 58.57293, -2.95473, 4.46, 0.672, 58.596525, -40.357009, 5.7, 0.599,
  58.641465000000004, -52.690426, 6.46, 0.158, 58.817205, -12.099105, 5.99, 0.323, 58.992360000000005, 47.87142, 5.39, -0.073,
  59.016420000000004, -63.463718, 6.14, 1.094, 59.115255, -13.597531, 6.37, 1.585, 59.119545, 35.080899, 5.49, -0.058,
  59.126265000000004, 71.821606, 6.31, 0.333, 59.15205, 50.695381, 5.28, 0.425, 59.15805, -9.750844, 6.18, 0.269,
  59.21697, 22.477971, 5.62, 0.345, 59.257155, 6.039967, 6.09, 0.058, 59.26587, 23.17555, 6.05, 0.031,
  59.284545, 61.108883, 4.99, 1.435, 59.356004999999996, 63.072264, 4.95, -0.074, 59.35992, 24.461937, 6.19, 1.372,
  59.46345, 40.010215, 2.9, -0.199, 59.507355, -13.508515, 2.97, 1.588, 59.621489999999994, 38.840254, 6.32, 1.081,
  59.6787, -57.10236, 6.05, 0.439, 59.686425, -61.400185, 4.56, 1.59, 59.718315000000004, -5.469947, 5.85, 1.001,
  59.741249999999994, 35.791033, 3.98, 0.016, 59.875544999999995, -12.574425, 5.61, 1.479, 59.918715000000006, 10.330402, 6.35, 0.417,
  59.981175, -24.016215, 4.62, -0.121, 60.153704999999995, 17.29666, 6.31, 0.056, 60.169380000000004, -30.490697, 5.93, 0.036,
  60.17007, 12.490347, 3.41, -0.099, 60.203174999999995, 18.194, 5.89, 0.319, 60.22419, -62.159284, 4.48, 1.5,
  60.31180500000001, 36.989477, 6.39, -0.005, 60.32545499999999, -61.078822, 4.97, 1.386, 60.383535, -1.54966, 5.28, -0.133,
  60.442229999999995, 9.998017, 5.67, 0.005, 60.6531, -0.268923, 5.38, 0.516, 60.78909, 5.989305, 3.91, 0.032,
  60.853109999999994, -20.143796, 6.47, -0.178, 60.935849999999995, 5.435624, 5.32, -0.08, 60.985845000000005, 8.197269, 5.45, 0.371,
  61.036275, -16.588728, 6.36, 1.266, 61.04115000000001, 2.826947, 5.36, 0.505, 61.090305, 24.105993, 5.46, 0.813,
  61.094654999999996, -12.792295, 5.62, 1.062, 61.11318, 59.155507, 5, 0.495, 61.17041999999999, -20.381864, 6.12, 1.157,
  61.173795, 22.081926, 4.36, 1.064, 61.33437, 22.008905, 5.9, 0.62, 61.405919999999995, -27.651807, 5.59, 0.324,
  61.444635, -20.512563, 6.34, 0.918, 61.48545, -8.856105, 6.27, 0.063, 61.51323000000001, 68.679972, 5.88, 1.543,
  61.646024999999995, 50.351262, 4.25, -0.011, 61.65171, 27.599903, 5.18, -0.124, 61.652565, 54.008663, 6.31, 0.983,
  61.661775, 65.520798, 6.14, 0.145, 61.751925, 29.001299, 5.21, 0.359, 61.794734999999996, 74.000359, 6.49, 0.977,
  61.839165, -64.222291, 6.37, 0.636, 61.92492, 15.162788, 6.02, 0.397, 61.997565, 17.339897, 5.89, 1.497,
  62.06418, 37.727493, 6.07, 0.943, 62.152455, 38.039733, 5.52, 0.52, 62.165355000000005, 47.712513, 3.96, -0.025,
  62.25654, 13.398281, 5.94, 0.052, 62.29152, 19.609217, 5.51, 1.077, 62.32431, -16.385875, 5.45, -0.147,
  62.34252, 54.828862, 6.25, 0.448, 62.364884999999994, 59.908071, 6.29, 1.112, 62.429190000000006, 3.322697, 6.49, 0.443,
  62.501279999999994, 86.626139, 5.84, 0.393, 62.511585, 80.698681, 5.1, 0.589, 62.593845, -6.923852, 5.44, 0.941,
  62.691134999999996, -35.273787, 6.43, 1.07, 62.699025000000006, -8.819814, 5.7, 1.057, 62.707755, 26.480952, 5.39, 0.352,
  62.71062, -41.993573, 4.93, 0.334, 62.745915000000004, 33.586792, 5.75, 1.412, 62.834505, 5.523047, 5.71, 0.36,
  62.900835, -20.356157, 5.8, 0.165, 62.966415, -6.837581, 4.04, 0.327, 62.98390500000001, -8.837485, 6.45, 0.95,
  63.00114, -17.274732, 6.41, 0.968, 63.130635, 17.27746, 6.09, 1.081, 63.213525000000004, 22.413458, 6.14, 0.171,
  63.21606, 68.501154, 6.33, 1.169, 63.387930000000004, 7.716045, 5.29, 0.366, 63.394035, 10.212458, 6.24, 0.021,
  63.398835, -40.357763, 6.36, 1.468, 63.40896, -1.149737, 6.45, -0.125, 63.43671, 72.126147, 6.05, 1.019,
  63.457649999999994, 12.753701, 6.25, 1.143, 63.484935, 9.263824, 4.84, 0.799, 63.49875, 37.967147, 6.47, 1.029,
  63.500445, -42.294368, 3.85, 1.085, 63.59871, -10.256283, 4.87, 1.156, 63.60606, -62.473858, 3.33, 0.915,
  63.65097, 10.011406, 5.22, -0.085, 63.702285, -62.191811, 5.45, 1.106, 63.716955000000006, 37.54267, 6.31, 0.958,
  63.722145, 40.483671, 4.67, 1.007, 63.724425, 48.409331, 4.12, 0.935, 63.757484999999996, 57.460361, 6.06, 0.6,
  63.818055, -7.652871, 4.43, 0.82, 63.87, 6.186858, 6.32, 0.57, 63.88357500000001, 8.892357, 4.27, -0.054,
  63.942840000000004, 15.400695, 6.31, 0.4, 64.00645499999999, -51.486648, 4.26, 0.312, 64.08729, -60.948482, 6.34, 0.097,
  64.12107, -59.302156, 4.44, 1.078, 64.17957, 53.611799, 5.2, 0.052, 64.22313, 61.849989, 5.69, -0.116,
  64.28370000000001, 57.860355, 5.72, 1.108, 64.31526, 20.578591, 4.93, 0.259, 64.330095, -6.472177, 5.95, 1.078,
  64.41778500000001, -63.255405, 5.88, -0.061, 64.465995, 80.535783, 6.39, 0.947, 64.473555, -33.798348, 3.55, -0.108,
  64.49664, -80.214033, 5.67, 0.836, 64.53378000000001, 42.141159, 6.22, -0.072, 64.56084, 50.295502, 4.6, 0.043,
  64.56698999999999, -20.71526, 6, 1.597, 64.59666, 21.579297, 5.64, 0.277, 64.65621, -22.969722, 6.09, 0.302,
  64.66669499999999, -52.860097, 6.08, 0.489, 64.762035, -33.904617, 6.36, 0.132, 64.80508499999999, 50.048695, 5.46, 0.235,
  64.819515, -44.267919, 5.33, 1.066, 64.85874, 21.142307, 5.5, -0.069, 64.90293, 21.773491, 5.34, -0.107,
  64.9059, 10.121437, 6.31, 1.428, 64.948335, 15.627642, 3.65, 0.981, 64.990425, 14.035201, 5.58, 0.283,
  65.041455, 31.953174, 6.16, 1.679, 65.047965, 50.920933, 5.55, -0.031, 65.06011500000001, 41.80807, 5.95, 0.962,
  65.08840500000001, 27.350754, 4.97, 1.15, 65.10267, 34.566725, 4.93, 0.95, 65.104605, 18.742608, 6.11, 0.404,
  65.151285, 15.095453, 5.26, 0.225, 65.161005, -6.245995, 6.15, 0.901, 65.16255, -20.639622, 5.38, -0.027,
  65.168115, 65.140441, 5.26, 0.82, 65.17184999999999, 6.130798, 5.76, 0.914, 65.17848000000001, -7.592493, 5.85, -0.124,
  65.219655, 13.864427, 6.15, 0.456, 65.24182499999999, -81.57992, 5.78, 0.359, 65.36266499999999, -0.09817, 5.86, 1.32,
  65.38047, -25.72858, 6.08, 0.371, 65.388165, 46.498878, 4.8, -0.022, 65.40631499999999, -6.284172, 6.45, 0.056,
  65.44840500000001, 60.735625, 5.4, 1.497, 65.46588, 56.506317, 5.91, 0.112, 65.47194, -63.386391, 5.24, 0.955,
  65.514645, 14.077198, 5.72, 0.315, 65.59471500000001, 20.821416, 5.91, 1.66, 65.645595, 25.629314, 5.38, -0.041,
  65.73370499999999, 17.542514, 3.77, 0.983, 65.74137, 59.616182, 6.18, 0.108, 65.77363500000001, -24.892157, 5.81, 1.507,
  65.78232, -35.544815, 6.38, 1.242, 65.85441, 16.77726, 5.64, 0.31, 65.88486, 20.982044, 6, 0.029,
  65.899215, 42.427909, 6.25, 0.023, 65.920215, -3.74547, 5.17, 0.072, 65.965935, 9.460968, 5.1, 0.074,
  65.99901, 24.300992, 6.34, 0.173, 66.009195, -34.016846, 3.97, 1.468, 66.023985, 17.44413, 4.8, 0.154,
  66.051075, -57.071337, 6.28, 0.659, 66.060345, 12.157987, 6.42, 1.408, 66.12147, 34.130758, 5.73, -0.054,
  66.15606, 33.959686, 5.77, 0.4, 66.23801999999999, 19.042013, 5.97, 0.378, 66.272295, -61.238193, 5.94, 1.533,
  66.32964, -44.160897, 6.38, 0.457, 66.34233, 22.293874, 4.21, 0.136, 66.35421, 22.199998, 5.27, 0.25,
  66.37241999999999, 17.92791, 4.3, 0.049, 66.40548, 15.94101, 6.44, 0.509, 66.50562000000001, 4.373451, 6.37, 1.078,
  66.52626, 31.438911, 5.29, 0.986, 66.576915, 22.813583, 4.28, 0.263, 66.58641, 15.618265, 4.48, 0.262,
  66.587925, 8.590269, 6.06, -0.01, 66.651555, 14.713782, 4.69, 0.979, 66.737205, -24.081323, 6.11, 0.143,
  66.75291, 2.079409, 6.23, 1.087, 66.753615, 57.58529, 6.28, 0.063, 66.76209, 80.824159, 5.42, 1.179,
  66.77481, -46.947505, 6.1, 0.47, 66.822705, 22.996337, 5.53, -0.098, 66.869865, 11.2123, 5.87, 0.049,
  66.94181999999999, -62.521206, 5.74, 1.005, 67.003245, 21.619907, 5.72, 0.27, 67.01515500000001, 1.858605, 6.14, 1.018,
  67.03944, -41.959833, 6.41, 1.614, 67.055385, 83.80779, 5.51, -0.106, 67.097505, 14.740974, 5.9, 0.325,
  67.10988, 16.359672, 4.96, 1.137, 67.133835, 1.380821, 5.53, -0.099, 67.14372, 15.962181, 3.84, 0.952,
  67.154145, 19.180431, 3.53, 1.014, 67.16265, -19.458874, 5.95, 1.215, 67.165575, 15.870883, 3.4, 0.179,
  67.209015, 13.047602, 5.02, 0.215, 67.21661999999999, 30.361492, 6.38, 0.547, 67.278855, -13.04837, 5.61, -0.202,
  67.33363499999999, -46.51527, 6.13, 1.062, 67.502385, 83.340379, 5.47, 0.855, 67.50954, 10.262214, 6.47, 1.038,
  67.53582, 15.63784, 5.58, 0.324, 67.541685, -13.592372, 6.22, 1.001, 67.64013, 16.194014, 4.78, 0.17,
  67.65567, 13.724402, 5.4, 0.263, 67.660035, 32.457768, 6.18, -0.026, 67.66203, 15.691879, 5.47, 0.258,
  67.668045, -35.653504, 5.95, 1.005, 67.69497, 16.148696, 6.5, 0.428, 67.70874, -44.953749, 5.07, -0.194,
  67.77996, 15.105037, 6.28, 1.725, 67.85041500000001, 40.010193, 6.25, 0.009, 67.85772, -13.644222, 6.25, 0.086,
  67.96564500000001, 15.85156, 6.01, 0.338, 67.96944, -0.044011, 4.91, 1.32, 67.98727500000001, 36.742688, 6.35, 1.089,
  68.007675, 53.91083, 5.78, 0.119, 68.02003500000001, 5.410035, 6.37, 0.42, 68.156475, -3.209541, 5.76, -0.117,
  68.342025, -10.785333, 6.06, 1.379, 68.353755, 43.063893, 6.09, 0.37, 68.37766500000001, 72.528605, 5.94, 0.306,
  68.37734999999999, -29.766492, 4.49, 0.972, 68.3877, 18.016722, 6.24, 0.077, 68.391795, -62.823677, 5.79, 1.028,
  68.45073, 9.413567, 6.01, 1.061, 68.46214499999999, 14.844424, 4.65, 0.255, 68.47803, -6.738908, 5.71, -0.128,
  68.49897, -55.044975, 3.3, -0.079, 68.534445, 5.568616, 5.67, 0.055, 68.548455, -8.231352, 5.2, 1.708,
  68.54904, -8.970258, 5.24, 1.465, 68.559135, -6.837809, 6.09, 1.384, 68.6583, 28.96115, 5.88, -0.048,
  68.65891500000001, -24.0405, 6.37, 1.137, 68.75295, -19.921384, 6.12, 1.174, 68.88768, -30.562341, 3.81, 0.957,
  68.913585, 10.16079, 4.25, 0.184, 68.92734, 19.881791, 6.33, 0.754, 68.98015500000001, 16.509301, 0.87, 1.538,
  69.006975, -3.611641, 6.34, -0.1, 69.079755, -3.352459, 3.93, -0.21, 69.100905, 64.261602, 5.91, -0.009,
  69.12138, 23.340855, 6.01, 0.38, 69.17262, 41.264808, 4.25, 1.171, 69.19015499999999, -62.077154, 5.59, 1.5,
  69.21222, -30.716779, 6.28, -0.095, 69.30697500000001, 0.998314, 5.32, -0.107, 69.31157999999999, 18.543031, 6.49, 0.81,
  69.330255, -41.872944, 6.4, 0.167, 69.400545, -2.473548, 5.22, 0.283, 69.53934000000001, 16.033291, 5.78, 0.312,
  69.539415, 12.510838, 4.27, 0.122, 69.54509999999999, -14.30402, 3.86, 1.082, 69.56596499999999, 20.684722, 5.85, -0.019,
  69.59058, -77.656003, 6.05, 1.08, 69.72314999999999, -12.123121, 4.99, 0.074, 69.76791, -51.672752, 6.45, 1.321,
  69.77565, 7.870976, 5.38, 0.257, 69.78840000000001, 15.799846, 5.08, 0.141, 69.81874499999999, 15.917977, 4.67, 0.147,
  69.832125, -14.359192, 5.46, 1.054, 69.84645, 25.218274, 6.21, 0.176, 69.946755, -1.052459, 6.11, 0.943,
  69.97785, 53.079535, 5.07, 1.079, 69.99189, 53.473021, 5.36, 0.331, 70.01424, 12.197609, 5.45, -0.121,
  70.028355, -24.482368, 5.56, 0.926, 70.110465, -19.671493, 4.32, 1.599, 70.140585, -41.863752, 4.44, 0.342,
  70.33233, 28.614994, 5.73, 0.018, 70.35048, 48.300881, 5.66, 0.002, 70.459245, 38.280182, 5.97, 0.593,
  70.514475, -37.144297, 5.04, 0.391, 70.56126, 22.956926, 4.27, -0.112, 70.69348500000001, -50.481334, 5.3, 0.977,
  70.72633499999999, 43.365138, 5.3, 0.028, 70.76646, -70.931027, 5.53, -0.114, 70.78873499999999, -30.765557, 5.66, 1.391,
  70.80731999999999, 24.08892, 6.18, 0.544, 70.839975, 49.973789, 5.86, 0.013, 70.89477, -8.794317, 5.98, 0.645,
  70.93446, -41.064788, 6.24, 1.468, 70.95102, 32.865459, 6.49, 0.311, 71.022165, -8.503571, 5.78, -0.076,
  71.03325, -18.666586, 5.53, 0.025, 71.054235, 40.786454, 6.09, 0.04, 71.088075, -59.732733, 5.28, 0.206,
  71.10762, 11.146137, 5.39, 0.251, 71.24128499999999, -63.229715, 6.46, 1.077, 71.26734, -21.283383, 5.72, 1.476,
  71.375625, -3.254657, 4.01, -0.148, 71.42694, 23.627996, 6.34, 0.058, 71.48109, -39.356619, 6.04, 1.065,
  71.50179, 76.611042, 6.46, 0.512, 71.50725, 11.705591, 5.35, 0.197, 71.57011499999999, 18.734693, 5.99, 1.221,
  71.600685, -2.954532, 6.33, 0.041, 71.60728499999999, -28.087444, 6.18, 0.189, 71.685315, 40.31259, 5.99, 0.934,
  71.901195, -16.934456, 5.49, 0.632, 71.95656, -30.020372, 6.35, 1.071, 72.001035, 56.757183, 5.29, 0.246,
  72.02913000000001, 55.602611, 6.32, 0.32, 72.135555, -16.329484, 5.76, 0.537, 72.151605, -5.674045, 5.77, 0.631,
  72.18593999999999, 3.588526, 6.04, 1.2, 72.20952, 75.941219, 5.96, 0.283, 72.30352500000001, 31.437375, 5.57, 1.132,
  72.32947499999999, 32.588191, 5.84, 0.25, 72.42603, -13.769669, 6.27, 0.456, 72.43368, 15.904221, 6.09, 1.551,
  72.460035, 6.961276, 3.19, 0.484, 72.47769, 37.488275, 4.89, 1.447, 72.5484, -16.217159, 5.03, 0.992,
  72.56742, -41.320848, 6.06, 0.408, 72.651615, 70.941528, 6.36, -0.069, 72.65301, 8.900176, 4.35, 0.01,
  72.73059, -53.461508, 5.58, 0.341, 72.73554, -53.459698, 6.42, 0.483, 72.78891, 48.740685, 5.64, 1.013,
  72.80151000000001, 5.605104, 3.68, -0.157, 72.843585, 18.839861, 5.08, 0.214, 72.867555, -34.906286, 5.82, 0.105,
  72.93076500000001, 9.975078, 6.11, 0.06, 72.958275, 13.655155, 6.3, 0.502, 73.02163499999999, 63.505421, 5.47, 1.559,
  73.133175, 14.250642, 4.71, 1.773, 73.15827, 36.703187, 4.79, 1.414, 73.19631, 27.897485, 5.97, 0.368,
  73.19899500000001, 42.586626, 5.68, 0.115, 73.223625, -5.452695, 4.36, 0.257, 73.273785, -72.40768, 6.28, 0.521,
  73.29078, 52.841155, 6.4, 0.068, 73.344885, 2.508225, 5.33, 1.632, 73.37704500000001, -66.675413, 6.43, 1.64,
  73.51254, 66.342678, 4.26, -0.008, 73.562895, 2.440672, 3.71, -0.179, 73.695405, 11.426006, 5.18, 0.121,
  73.699095, 7.779097, 5.33, 1.214, 73.71129, 0.467167, 5.98, -0.116, 73.71349500000001, 44.060861, 6.06, -0.032,
  73.720755, -58.547652, 6.11, 0.442, 73.72386, 10.150833, 4.64, 0.085, 73.72838999999999, -39.628607, 6.11, 1.423,
  73.74316499999999, 19.485388, 6.36, 0.292, 73.76305500000001, 55.259109, 5.52, 0.015, 73.77843, -16.74067, 5.71, 0.953,
  73.796475, -74.936852, 5.47, 1.518, 73.827705, -16.417767, 5.71, 0.874, 73.95897, 15.040278, 5.79, -0.085,
  73.993125, 5.399024, 6.5, 0.025, 74.029485, 52.869761, 5.75, 0.105, 74.03737500000001, 7.904696, 6.42, 0.415,
  74.064915, 24.592218, 6.33, 0.351, 74.083695, 36.168537, 6.1, 0.352, 74.092815, 13.514466, 4.06, 1.158,
  74.10078, -5.171356, 5.5, -0.123, 74.24840999999999, 33.16609, 2.69, 1.49, 74.321625, -1.067258, 6.25, 0.423,
  74.3217, 53.752101, 4.43, -0.017, 74.34309, 17.153677, 5.51, 1.304, 74.43618, -14.23192, 6.15, -0.202,
  74.45269499999999, 23.948562, 5.79, 1.109, 74.539125, 25.050405, 5.79, 0.018, 74.54547000000001, -2.212738, 6.34, 0.11,
  74.63709, 1.714016, 4.47, 1.369, 74.712435, -82.470512, 5.84, 0.932, 74.74755, 14.54324, 6.14, 0.156,
  74.755695, -16.376027, 5.65, 0.447, 74.81418000000001, 37.890245, 4.93, 0.037, 74.94305999999999, 53.155451, 6.09, 1.462,
  74.96021999999999, -10.263325, 5.39, 0.797, 74.98223999999999, -12.537416, 4.78, 0.267, 75.05532000000001, -78.300009, 6.29, 1.517,
  75.076425, 39.394701, 5.95, 0.415, 75.086325, 81.194088, 5.09, 1.304, 75.096735, 39.654653, 6.46, 1.677,
  75.16587, -2.066032, 6.31, 0.293, 75.204165, -5.753675, 6.22, 1.049, 75.35658000000001, -20.051918, 4.91, -0.047,
  75.359775, -7.173965, 4.8, -0.164, 75.393855, -39.718046, 6.02, 0.893, 75.40014000000001, 61.077996, 6.03, 0.448,
  75.45981, 0.722112, 5.91, 1.267, 75.492225, 43.823308, 3.03, 0.537, 75.5001, 1.608865, 6.45, -0.05,
  75.5409, -26.275029, 5.01, 1.056, 75.58248, 74.269368, 6.05, 1.562, 75.59501999999999, -31.771333, 5.92, 1.17,
  75.61951499999999, 41.075837, 3.69, 1.154, 75.679185, -71.3143, 5.3, 0.996, 75.68742, -22.795052, 5.74, 1.188,
  75.68914500000001, -4.210121, 5.86, 1.212, 75.70291499999999, -49.151407, 5.37, 0.421, 75.709905, 66.822974, 6.2, 0.509,
  75.77394, 21.589962, 4.62, 0.155, 75.827655, 41.441646, 6.11, 0.188, 75.85454999999999, 60.442245, 4.03, 0.921,
  75.967185, -14.370231, 6.42, -0.187, 75.97195500000001, -24.388151, 5.61, 0.094, 75.97479, -41.74495, 6.3, 0.528,
  76.05324, 73.763887, 6.21, 1.609, 76.06068, 30.494588, 6.14, 1.208, 76.089945, 21.277931, 6.2, 1.324,
  76.10159999999999, -35.482978, 4.55, 1.177, 76.108965, -35.705109, 6.32, 0.311, 76.14229499999999, 15.404105, 4.65, -0.064,
  76.165245, 74.066955, 6.1, 0.018, 76.22719500000001, -3.039675, 6.04, -0.117, 76.24164, -49.577837, 5.05, 1.484,
  76.25253000000001, -54.407401, 6.26, 1.554, 76.31747999999999, -26.152391, 5.71, 1.166, 76.348815, 1.177627, 6.1, 3.332,
  76.36527, -22.371032, 3.19, 1.46, 76.377795, -57.472704, 4.71, 0.526, 76.38374999999999, 19.806723, 6.48, 0.219,
  76.50384, 35.936388, 6.49, 0.184, 76.535235, 58.972372, 5.22, -0.08, 76.538625, -73.037673, 6.26, 0.01,
  76.55058, 59.02134, 6.08, 1.112, 76.623675, 61.169756, 6, 1.38, 76.6287, 41.234474, 3.18, -0.148,
  76.65308999999999, -13.122622, 6.04, -0.03, 76.669335, 51.59772, 4.98, 0.343, 76.69021500000001, -4.655163, 5.12, -0.059,
  76.70649, 43.174705, 6.2, 0.444, 76.79064, -19.391868, 6.47, 0.648, 76.854, -12.491269, 5.97, 0.606,
  76.86246, 18.645052, 4.91, 0.657, 76.89174, -63.399679, 5.19, 1.646, 76.90963500000001, 9.47178, 6.15, 0.625,
  76.951665, 20.418379, 5.28, 0.118, 76.95752999999999, -12.592658, 6.33, 1.617, 76.962435, -5.086446, 2.78, 0.161,
  76.970385, 8.498429, 5.33, 0.338, 76.98099, 21.704821, 5.84, 0.168, 77.027595, 24.265175, 5.5, 0.03,
  77.05524, -15.095354, 6.38, 0.889, 77.08413, -8.665324, 5.8, -0.059, 77.18208, -4.456207, 5.11, 0.455,
  77.2866, -8.754081, 4.25, -0.187, 77.33184, 9.829579, 5.43, 0.249, 77.402715, 69.639401, 6.43, 1.101,
  77.42481000000001, 15.597232, 4.81, 0.313, 77.43550499999999, 64.91949, 6.37, 0.448, 77.43786, 28.030461, 5.93, 0.311,
  77.513595, -0.565323, 6.11, 1.098, 77.57836499999999, 37.301854, 6.02, 0.72, 77.678775, 46.96207, 5.67, 0.452,
  77.685795, -25.910463, 6.4, 1.246, 77.741775, -2.254114, 6.24, 0.984, 77.8299, -2.490782, 5.89, 0.462,
  77.84529, -11.849089, 5.6, 1.35, 77.90964, 29.90358, 6.42, 1.752, 77.923185, 16.045673, 5.18, 1.525,
  77.938965, 1.037028, 5.88, 0.662, 78.074595, -11.869219, 4.45, -0.099, 78.093555, 73.946674, 5.44, -0.108,
  78.200535, -6.05719, 5.9, 0.96, 78.23292, -16.205468, 3.29, -0.11, 78.261765, 61.85004, 6.17, 0.032,
  78.30783, -12.941291, 4.36, -0.094, 78.322845, 2.861265, 4.46, 1.166, 78.322785, 37.337309, 6.48, 0.542,
  78.35716500000001, 38.484498, 4.82, 0.189, 78.380295, 62.691132, 6.49, 0.204, 78.38148, 1.967684, 6.08, 0.421,
  78.43932000000001, -67.185255, 4.81, 1.274, 78.446895, 0.560423, 6.33, 1.463, 78.47223, -52.030755, 6.03, 1.392,
  78.499785, -14.606872, 6.22, 0.377, 78.62019000000001, -35.976996, 5.75, 1.009, 78.63447, -8.20164, 0.18, -0.03,
  78.64807499999999, 76.472761, 6.36, -0.011, 78.68353499999999, 5.156151, 5.5, 1.369, 78.684465, 53.213949, 6.16, 0.084,
  78.79746, 59.405687, 6.15, 1.179, 78.827085, -1.40904, 6.15, 0.401, 78.85155, -26.943509, 5.06, -0.067,
  78.851655, 32.6876, 5.01, 0.222, 78.85362, -73.588475, 6.49, 0.15, 78.86523, 22.284858, 6.26, 0.075,
  78.9117, -52.182179, 6.48, 1.213, 79.017225, 11.341354, 5.52, -0.012, 79.044, -11.352553, 6.45, 0.67,
  79.07562, 34.312317, 5.99, 0.199, 79.17100500000001, 1.947328, 6.42, -0.015, 79.17225, 45.997991, 0.08, 0.795,
  79.371165, -34.895207, 4.81, 0.987, 79.40163, -6.844409, 3.59, -0.115, 79.41768, -13.519826, 5.48, 0.932,
  79.54402499999999, 33.371613, 4.54, 1.252, 79.5552, 73.268071, 5.81, -0.023, 79.56538499999999, 42.792111, 5.55, 1.492,
  79.578735, 33.767348, 6.15, -0.043, 79.668015, 40.465124, 6.22, 1.386, 79.71025499999999, -18.13005, 5.96, 0.572,
  79.75010999999999, 33.748394, 5.38, -0.167, 79.784925, 40.099051, 4.69, 0.63, 79.796745, 2.595806, 5.34, 0.412,
  79.81122, 20.134596, 6.12, 1.02, 79.81917, 22.096494, 4.96, 0.937, 79.82265, -18.519919, 6.37, -0.134,
  79.842195, -50.605967, 5.44, 0.517, 79.84869, -27.368884, 5.98, -0.022, 79.84891499999999, 33.985421, 6.49, 0.256,
  79.86606, 58.117365, 6.13, -0.031, 79.893855, -13.176788, 4.29, -0.235, 79.89702, -1.411892, 6.33, -0.105,
  79.99593, -12.315585, 5.29, -0.104, 80.003835, 33.958054, 5.05, 0.287, 80.009655, 44.425383, 6.49, 1.331,
  80.06113500000001, 41.086212, 5.46, 0.122, 80.08629, -34.698856, 6.34, 0.318, 80.09422500000001, 62.653711, 5.64, 1.728,
  80.110035, -5.367528, 6.4, -0.047, 80.112165, -21.239763, 4.7, -0.048, 80.16952500000001, 66.746878, 6.39, 0.921,
  80.182335, 2.54478, 6.43, 1.041, 80.2359, 19.814347, 6.2, 1.229, 80.247225, 27.957262, 6.35, 0.039,
  80.30286000000001, 29.569884, 5.66, 0.06, 80.32025999999999, -34.345051, 6.05, -0.176, 80.330445, 4.011948, 6.49, -0.089,
  80.38267499999999, -0.416491, 5.68, -0.125, 80.4315, 8.428556, 5.78, -0.114, 80.44062, -0.382465, 4.72, -0.168,
  80.442735, -24.772981, 5.06, 0.662, 80.45172, 41.804572, 5.22, -0.129, 80.48046, -17.603631, 6.47, 1.206,
  80.592285, -56.134401, 6.1, -0.091, 80.64054, 79.231149, 5.08, 0.506, 80.70834, 3.544452, 4.99, -0.096,
  80.70966, 41.02926, 5.54, 0.127, 80.799975, -26.705433, 6.49, 0.505, 80.827125, -8.415595, 5.99, -0.037,
  80.84529, 28.936761, 6.45, -0.04, 80.85009, -39.678423, 5.73, 1.626, 80.865975, 57.544395, 5.24, -0.011,
  80.87565, -13.927352, 5.25, -0.219, 80.87944499999999, 5.323086, 6.34, 0.123, 80.907105, 16.699298, 6.09, 0.141,
  80.92629, -0.159818, 5.69, -0.208, 80.96388, -0.866622, 6.13, 0.483, 80.986785, -7.808065, 4.13, 0.943,
  81.106065, 17.383534, 5, 0.544, 81.11871, -16.975781, 5.64, -0.001, 81.119235, -2.397146, 3.35, -0.24,
  81.12045, -0.891328, 5.07, 0.961, 81.15042, 2.353165, 6.33, -0.145, 81.16011, 31.223912, 6.3, 1.251,
  81.1605, 31.143148, 5.94, 0.034, 81.163095, 37.385346, 5.02, 1.445, 81.186675, 36.199945, 6.49, 1.645,
  81.18678, 1.846445, 4.89, -0.2, 81.19287, -52.316245, 6.26, 0.067, 81.23157, -44.225684, 6.09, 1.195,
  81.24762000000001, 73.707198, 6.48, 1.738, 81.25726499999999, -10.328887, 5.6, 1.543, 81.282765, 6.349702, 1.64, -0.224,
  81.402075, -1.491294, 6.44, -0.162, 81.445905, 0.520244, 6.18, -0.178, 81.499275, -19.695399, 5.78, 0.441,
  81.50985, -5.518501, 6.24, -0.047, 81.52384500000001, 16.700161, 6.23, -0.084, 81.57297, 28.60745, 1.65, -0.13,
  81.580305, -58.91252, 5.14, 0.986, 81.661785, 6.868658, 6.41, -0.023, 81.70335, 34.39181, 5.92, 0.138,
  81.70929, 3.095674, 4.59, -0.199, 81.71367000000001, 33.262258, 6.18, 1.152, 81.72633, 35.457272, 6.17, 1.453,
  81.74922, -68.622544, 6.02, 0.346, 81.769845, -11.900964, 6.3, 0.553, 81.77217, -40.94351, 5.86, 0.239,
  81.78447, 30.208603, 5.69, 0.175, 81.79206, 17.962216, 5.4, -0.09, 81.80789999999999, 15.25763, 6.18, 0.083,
  81.81417, 2.3412, 6.36, 0.965, 81.902085, -21.375713, 6.08, 1.032, 81.908685, 21.936965, 4.88, -0.14,
  81.91203, 34.475892, 5.08, 1.4, 81.940035, 15.874052, 5.52, 0.015, 82.00389, 33.763703, 6.41, 0.51,
  82.00612500000001, 1.298251, 6.41, -0.173, 82.00671, 17.23913, 5.77, 1.634, 82.06134, -20.759441, 2.81, 0.807,
  82.06389, -37.230767, 5.56, 0.026, 82.14489, 13.678979, 6.35, 0.168, 82.237125, -3.307429, 6.39, -0.007,
  82.31874, 25.150215, 5.47, -0.042, 82.34869499999999, -3.446394, 5.8, 1.149, 82.41939, 29.186464, 6.2, 0.476,
  82.423425, -0.802512, 6.49, 0.251, 82.43325, -1.092239, 4.71, 1.592, 82.47822000000001, 1.78926, 5.77, -0.192,
  82.53948, -47.077655, 5.46, 0.615, 82.542525, 63.06722, 5.43, 1.704, 82.558035, -84.785104, 6.18, -0.003,
  82.56612, -63.927686, 6.19, 0.225, 82.58301, 4.204795, 6.21, 1.28, 82.58647500000001, -7.434811, 6.33, -0.194,
  82.60902, 15.360449, 5.93, 0.103, 82.6806, 22.462255, 6.29, 1.18, 82.68782999999999, 39.825916, 6.38, 0.986,
  82.69605, 5.948139, 4.2, -0.143, 82.70271, 41.461994, 5.99, 1.112, 82.78177500000001, -20.863659, 5.53, 0.012,
  82.80313500000001, -35.470519, 3.86, 1.13, 82.810545, 3.292133, 5.46, -0.176, 82.83705, -6.708379, 6.23, -0.178,
  82.89998999999999, -45.925317, 5.86, 1.349, 82.95003, 85.938528, 6.5, 0.36, 82.96977, -76.340964, 5.18, 1.13,
  82.982745, -7.301537, 4.62, -0.261, 83.001675, -0.299092, 2.25, -0.175, 83.05312500000001, 18.594234, 4.32, 2.06,
  83.05893, 17.058128, 5.5, -0.004, 83.140605, 57.221071, 6.44, 0.587, 83.15824500000001, 0.011933, 6.15, 1.553,
  83.17229999999999, -1.591831, 5.34, -0.188, 83.181975, 32.192022, 4.71, 0.281, 83.18256000000001, -17.822289, 2.58, 0.211,
  83.214195, -38.513371, 5.45, 1.224, 83.24809499999999, -64.227517, 5.34, 1.039, 83.280735, -35.139376, 5.75, 1.085,
  83.36417999999999, 32.80118, 6.5, 0.094, 83.38102500000001, -1.156073, 5.36, -0.175, 83.38179, 18.540231, 5.67, -0.022,
  83.40631499999999, -62.489825, 3.76, 0.64, 83.40924, 34.72557, 6.27, 0.17, 83.41181999999999, 20.474216, 6.19, -0.034,
  83.434725, -54.902289, 6.42, 0.55, 83.476185, 14.305578, 5.6, -0.118, 83.510295, -7.02375, 6.45, 1.116,
  83.516205, -1.035726, 6.24, -0.16, 83.516865, -1.470253, 5.92, 1.535, 83.56989, 3.766895, 5.32, 0.051,
  83.62203, -0.012345, 6.25, 0.997, 83.68659000000001, -73.741277, 5.79, 1.717, 83.70516, 9.489579, 4.39, -0.157,
  83.73931499999999, -61.176048, 6.32, 0.845, 83.754195, -6.00927, 5.67, -0.228, 83.76116999999999, -6.002027, 4.78, -0.248,
  83.78449499999999, 9.934158, 3.39, -0.16, 83.805165, 10.240093, 5.6, 0.149, 83.814465, -33.079724, 5.76, 1.12,
  83.81592, -5.387315, 4.98, -9, 83.818605, -5.389696, 5.13, 0.02, 83.84298, -4.42432, 6.24, -0.148,
  83.84542499999999, -5.41606, 4.98, -0.097, 83.84652, -4.838358, 4.58, -0.183, 83.85826499999999, -5.909901, 2.75, -0.21,
  83.863035, 24.039589, 5.37, -0.092, 83.89960500000001, -3.25284, 6.4, -0.122, 83.90057999999999, -78.820839, 6.04, -0.018,
  83.914515, -4.856067, 5.24, 0.269, 83.98125, 27.662347, 6.27, 1.529, 84.011865, -47.313746, 6.1, 1.159,
  84.042885, -28.708015, 6.26, 0.151, 84.05338499999999, -1.20192, 1.69, -0.184, 84.06648, 47.71529, 6.1, 0.295,
  84.14676, 54.428658, 5.74, 1.671, 84.148725, -6.064752, 5.71, -0.212, 84.2184, 40.182375, 6.08, 1.032,
  84.22662, 9.290673, 4.09, 0.951, 84.229095, -66.560287, 6.28, -0.052, 84.26556, 17.040324, 5.53, 0.237,
  84.26826, 11.035005, 5.97, 1.592, 84.286545, -11.775515, 6.1, 0.051, 84.2874, -80.469122, 5.65, 0.6,
  84.286845, 26.924473, 5.83, -0.075, 84.31278, 64.15469, 6.15, 0.006, 84.31683, 66.696692, 6.26, 0.231,
  84.318765, -27.871362, 6.15, 0.322, 84.330465, 8.951875, 6.11, -0.17, 84.36399, -5.938391, 6.03, -0.21,
  84.41119499999999, 21.142549, 2.97, -0.148, 84.435915, -28.68969, 5.28, 0.486, 84.44085, 33.559167, 6.36, 1.306,
  84.47244, -4.814034, 6.16, -0.029, 84.50466, 7.54142, 5.87, -0.061, 84.57258, -50.640995, 6.43, -0.047,
  84.65821500000001, -6.573959, 5.96, -0.216, 84.65869500000001, 30.492412, 5.4, 0.45, 84.68136, -40.707306, 5.81, -0.078,
  84.68653499999999, -2.600069, 3.77, -0.19, 84.721185, -7.212829, 4.77, 0.139, 84.73904999999999, 26.618068, 6.45, 0.98,
  84.786255, 41.358562, 6.44, 1, 84.79643999999999, 4.121467, 4.5, -0.098, 84.817605, -17.849408, 6.4, -0.095,
  84.826305, 29.215213, 5.98, 0.144, 84.86295000000001, 21.762929, 6.42, 0.066, 84.87850499999999, -9.706628, 6.49, -0.107,
  84.879795, -3.564704, 5.99, 0.294, 84.912255, -34.074108, 2.65, -0.12, 84.93216, 75.043871, 6.19, 1.606,
  84.93415499999999, 25.897091, 5.18, -0.15, 84.95767500000001, -32.629216, 5.44, 0.913, 85.149615, 31.358197, 6.04, 0.037,
  85.155405, -2.825236, 6.22, -0.194, 85.17520499999999, 31.920607, 6.23, 2.088, 85.189695, -1.942572, 1.74, -0.199,
  85.19247, -10.408664, 6.46, -0.127, 85.21131, -1.128787, 4.95, -0.197, 85.27332, 0.337753, 5.93, 0.311,
  85.323825, 16.534148, 4.84, -0.125, 85.33473000000001, 53.481058, 6.21, 0.84, 85.3374, 29.487418, 6.4, -0.081,
  85.36218000000001, -33.400741, 6.35, -0.04, 85.41807, -2.896457, 6.41, 0.32, 85.42296, -16.72583, 6.22, -0.136,
  85.516605, 22.660325, 6.35, 1.194, 85.54825500000001, -30.535442, 6.18, 0.023, 85.558155, -22.373715, 5.88, 0.08,
  85.560315, -17.530376, 6.15, 1.376, 85.563315, -34.667812, 5.29, -0.032, 85.61020500000001, 65.697649, 5.62, 1.249,
  85.619295, 1.474629, 4.9, 1.144, 85.72464, -6.796168, 5.97, 0.447, 85.75695, 56.581522, 6.05, 0.951,
  85.788825, -1.613248, 6.31, 1.467, 85.83126, 23.204372, 6.23, -0.071, 85.84029000000001, -18.557475, 5.73, -0.014,
  85.875735, -39.406908, 6.25, 0.377, 85.92138, -45.832864, 6.38, 0.295, 86.03523, 61.476536, 6.17, 0.902,
  86.115855, -22.448382, 3.59, 0.481, 86.11831500000001, -20.126573, 6.34, 0.58, 86.193345, -65.735526, 4.34, 0.217,
  86.25537, 12.888332, 6.47, 0.234, 86.25747000000001, 4.008111, 6.09, 0.32, 86.37331499999999, 31.324825, 6.5, 1.1,
  86.47518, 49.826255, 5.46, 0.03, 86.499555, -32.306435, 5.18, -0.274, 86.511945, -4.268484, 6.24, 1.05,
  86.61404999999999, -46.59718, 5.31, 1.04, 86.62659000000001, 56.115575, 5.93, 0.164, 86.64546, 1.168193, 5.95, 0.773,
  86.689575, 15.822497, 6, -0.061, 86.717235, 9.522343, 5.78, 0.888, 86.738925, -14.82195, 3.55, 0.104,
  86.75019, 51.520871, 6.47, 0.898, 86.769075, -28.638913, 6.22, -0.132, 86.782515, -16.238079, 6.18, 0.892,
  86.804805, 14.488322, 5.72, 0.077, 86.80554, -54.360728, 6.19, 1.406, 86.81118, 42.526748, 6.3, 1.354,
  86.821185, -51.066514, 3.85, 0.171, 86.82786, -35.674075, 6.29, 1.191, 86.85915, 17.729141, 5.47, 0.301,
  86.86204500000001, -10.532958, 6.04, 0.135, 86.88436499999999, 63.598848, 6.49, 1.01, 86.894445, 25.568623, 6.48, 1.193,
  86.92877999999999, 13.899599, 5.28, -0.156, 86.939115, -9.669605, 2.07, -0.168, 87.000975, 6.454156, 5.26, 0.234,
  87.093195, 20.869481, 6.03, -0.051, 87.14559, -4.094648, 5.97, 0.639, 87.254025, 24.567535, 4.88, 1.021,
  87.26944499999999, 62.80819, 6.18, 0.128, 87.293505, 39.181071, 4.51, 0.949, 87.38721000000001, 12.651324, 4.89, -0.068,
  87.39219, -44.875394, 6.38, 1.262, 87.402255, -14.483665, 5.49, 0.87, 87.456765, -56.166663, 4.5, 1.075,
  87.47291999999999, -22.971872, 5.87, 0.055, 87.473085, -66.901187, 5.1, -0.128, 87.511185, 9.871218, 5.79, 0.876,
  87.55443, 4.423406, 5.96, 1.361, 87.569985, -79.361362, 5.46, -0.076, 87.6201, -52.767879, 6.32, 0.746,
  87.620445, 14.305608, 5.54, 1.006, 87.62511, 2.0247, 5.97, 0.953, 87.721755, -52.108873, 5.16, 0.96,
  87.73464000000001, 51.514583, 6.29, 1.047, 87.739935, -35.768309, 3.12, 1.146, 87.742125, 27.967861, 5.6, 0.978,
  87.760125, 37.305573, 4.72, 1.621, 87.830355, -20.879089, 3.76, 0.984, 87.841605, -7.518003, 5.36, -0.195,
  87.84624000000001, -64.033566, 6.35, 0.866, 87.85729500000001, 32.124694, 6.28, 1.752, 87.86922000000001, -22.926947, 6.16, 1.02,
  87.87249, 39.14848, 3.97, 1.132, 87.99828000000001, -29.449426, 6.47, 1.473, 88.03221, -9.0419, 5.95, 0.1,
  88.0719, 58.964088, 6.14, -0.036, 88.08414, -57.156191, 5.93, 0.656, 88.092885, 14.171787, 5.6, -0.053,
  88.09752, 19.867849, 5.96, 0.549, 88.11016500000001, 1.855134, 4.76, 1.382, 88.138245, -37.631063, 5.62, 1.046,
  88.165275, 39.574705, 6.4, 0.098, 88.167045, 33.917462, 6.04, 1.579, 88.2312, 68.471541, 6.22, 0.955,
  88.278675, -33.801361, 4.88, -0.154, 88.33185, 27.612262, 4.56, -0.008, 88.52487, -63.089627, 4.65, 1.022,
  88.55562, 10.586403, 6.13, 1.404, 88.55843999999999, -29.147206, 6.34, 0.37, 88.565655, 3.225641, 6.3, 1.283,
  88.59579000000001, 20.276174, 4.39, 0.594, 88.67133, -49.62701, 6.11, -0.148, 88.68178499999999, -11.774192, 5.62, 1.523,
  88.68348, 0.968615, 5.99, 1.328, 88.70874, -52.635481, 5.29, 0.295, 88.71160499999999, 55.706947, 4.96, 0.052,
  88.7187, -39.957857, 5.55, 1.515, 88.73619000000001, 19.749614, 5.92, -0.145, 88.74094500000001, 59.888367, 5.2, 0.01,
  88.745805, 31.701496, 5.9, 0.144, 88.792935, 7.407063, 0.45, 1.5, 88.874625, -37.120668, 4.97, 1.102,
  88.87572, -4.616546, 5.87, 1.173, 88.89736500000001, -4.788587, 6.28, 0.056, 89.05944, -22.839975, 5.95, 1.107,
  89.087265, -31.38244, 5.52, 0.382, 89.10123, -14.1677, 3.71, 0.337, 89.116815, 9.509396, 5.97, -0.038,
  89.14069500000001, 28.942266, 6.35, 0.275, 89.143485, -23.21531, 6.37, 1.068, 89.20419, -31.976247, 6.44, 1.07,
  89.206035, 11.521058, 5.89, 1.111, 89.23383, 24.249689, 6.03, 0.346, 89.30988, -53.425693, 6.48, 1.48,
  89.38420500000001, -35.28328, 4.36, -0.165, 89.39574, 66.096099, 6.24, 1.369, 89.47705500000001, 1.22431, 6.22, 1.461,
  89.498565, 25.953912, 4.81, -0.088, 89.5488, -0.994018, 6.21, 1.14, 89.60184, 1.837108, 5.89, 0.223,
  89.656455, -44.034562, 5.81, 1.061, 89.70655500000001, 0.552979, 5.21, 0.009, 89.72182500000001, 12.808264, 5.7, 0.874,
  89.754495, -9.382223, 6.15, 0.333, 89.76796499999999, -9.55825, 5.04, 0.189, 89.78667, -42.815135, 3.96, 1.146,
  89.84076, 49.92454, 5.9, 1.194, 89.88166500000001, 54.284656, 3.72, 1.01, 89.88223500000001, 44.947433, 1.9, 0.077,
  89.930265, 37.212585, 2.65, -0.083, 89.940945, 55.320857, 6.42, 0.318, 89.94978, 54.547009, 6.14, 1.197,
  89.98375499999999, 45.936736, 4.3, 1.701, 90.01395000000001, -3.074253, 4.53, 1.202, 90.073575, -12.900034, 6.21, 0.358,
  90.07878, 44.592013, 6.21, 1.128, 90.204915, -51.216319, 5.65, 0.207, 90.244005, 47.901923, 5.71, -0.007,
  90.25189499999999, 27.572362, 6.04, 0.218, 90.291855, 31.034517, 6.18, 0.095, 90.304575, -25.417763, 6.04, 0.027,
  90.31791000000001, -33.911835, 5.54, 1.58, 90.33408, 85.182113, 6.17, 1.564, 90.42345, 22.401001, 6.36, -0.071,
  90.429405, 48.959445, 5.98, 1.437, 90.460095, -10.59793, 4.92, -0.128, 90.53886, -60.09683, 6.41, 1.508,
  90.59583, 9.647276, 4.12, 0.17, 90.64089, -14.497157, 6.2, 0.947, 90.68805, 47.809529, 6.49, 0.567,
  90.702495, 49.905678, 6.04, -0.033, 90.72289500000001, 43.378334, 6.38, 1.205, 90.729855, 32.635697, 6.23, 0.456,
  90.76797, 57.018314, 6.5, 0.953, 90.814995, -26.284544, 5.03, 1.335, 90.82473, 42.911564, 6.08, 0.979,
  90.85319999999999, 11.681065, 6.09, -0.035, 90.86403, 19.690561, 5.14, -0.097, 90.979935, 20.138452, 4.64, 0.236,
  91.03006500000001, 23.263341, 4.16, 0.835, 91.056255, -6.708941, 5.19, -0.066, 91.08444, -32.17243, 5.65, -0.186,
  91.11858, -45.036603, 6.35, 0.517, 91.12128, 51.573395, 6.39, 0.196, 91.167165, -45.078932, 5.93, 0.493,
  91.242435, 5.41997, 5.67, 1.047, 91.24317, 4.158671, 5.63, 1.041, 91.246365, -16.484435, 4.92, 0.196,
  91.26076499999999, 37.964272, 6.32, 0.825, 91.26414, 42.981635, 5.9, 0.358, 91.28428500000001, 59.39321, 6.32, 1.116,
  91.28886, 75.585919, 6.28, 1.512, 91.36263000000001, -10.242596, 5.88, 0.374, 91.36323, -35.513647, 5.8, 0.027,
  91.39125, 33.59905, 6.23, -0.079, 91.52306999999999, -29.758624, 5.79, 0.041, 91.53562500000001, 35.38774, 6.12, 0.6,
  91.53885, -14.935254, 4.67, 0.046, 91.539045, -66.039621, 5.72, -0.024, 91.593525, 29.512414, 6.01, 1.73,
  91.63374, -23.110846, 5.46, 0.064, 91.646235, 38.482644, 5.35, 0.251, 91.6614, -4.193836, 5.37, -0.122,
  91.663245, 63.453838, 6.42, 1.011, 91.67103, -42.298804, 6.15, 0.246, 91.73964, -21.812299, 5.74, 1.584,
  91.757805, -45.09151, 6.48, 1.162, 91.76406, -62.154581, 5.04, 1.256, 91.76529, -34.312021, 5.82, -0.137,
  91.861485, 41.854282, 6.15, 1.202, 91.88179500000001, -37.25292, 5, -0.095, 91.893015, 14.768472, 4.42, -0.164,
  91.923495, -19.165866, 5.28, 1.661, 91.97025000000001, -42.154043, 5.5, 0.007, 92.0964, 41.055726, 6.34, 1.044,
  92.144295, -44.356212, 6.26, -0.135, 92.18464499999999, -68.843409, 5.06, -0.072, 92.19876, -6.821373, 6.46, 0.876,
  92.241105, -22.427412, 5.49, -0.01, 92.24127, 2.499692, 5.7, 0.067, 92.33415000000001, -18.126385, 6.36, -0.04,
  92.34761999999999, -49.562831, 6.48, 0.502, 92.38515000000001, 22.190262, 5.93, 1.626, 92.39385, -14.584619, 5.56, 1.15,
  92.40105, -5.711429, 6.16, 0.352, 92.43327000000001, 23.113466, 5.75, 0.192, 92.44644000000001, -26.701086, 6.27, 1.01,
  92.44983, -22.774343, 5.71, 0.454, 92.49584999999999, 58.935694, 5.35, 1.096, 92.54337000000001, -40.353792, 5.54, 1.665,
  92.55948000000001, -74.753045, 5.08, 0.714, 92.57463, -54.968645, 4.72, -0.229, 92.64450000000001, -27.154343, 5.72, 1.072,
  92.66637, -45.281988, 6.28, -0.012, 92.755065, -6.754221, 6.15, 0.01, 92.757375, 18.130465, 6.37, 1.35,
  92.806755, 60.453487, 6.48, 1.698, 92.806905, -26.4821, 6.08, -0.021, 92.8125, -65.589417, 5.01, 1.599,
  92.86629, 13.638561, 6.04, 0.021, 92.884605, 24.420253, 5.83, 1.11, 92.90244, 48.710989, 5.78, 0.1,
  92.93215500000001, -4.66544, 6.18, -0.079, 92.941305, 52.647186, 6.28, 0.141, 92.96589, -6.550287, 5.06, -0.201,
  92.984985, 14.208765, 4.45, -0.18, 93.00558, 19.790543, 5.76, -0.071, 93.01366499999999, 16.130406, 4.95, -0.149,
  93.08385, 32.69338, 5.78, 1.646, 93.21273000000001, 65.718422, 5.36, 1.344, 93.24822, 6.016258, 6.45, 1.621,
  93.30208499999999, 10.627144, 6.43, 0.663, 93.43875, -23.861938, 6.37, 0.713, 93.43893, 51.172469, 6.07, 1.051,
  93.47598, -3.741374, 5.83, 0.91, 93.61909499999999, 17.906353, 5.86, 0.253, 93.652935, -4.568457, 5.83, -0.155,
  93.712005, 19.156448, 5.2, 0.43, 93.71388, -6.274776, 3.99, 1.319, 93.719415, 22.506799, 3.31, 1.6,
  93.78501, -20.272186, 5.88, 1.322, 93.785295, 13.851098, 5.91, -0.231, 93.82384499999999, -18.477163, 5.99, 1.058,
  93.84456, 29.498076, 4.32, 1.021, 93.85470000000001, 16.143175, 5.34, -0.101, 93.858945, -9.035757, 6.09, -0.081,
  93.87364500000001, -4.914719, 5.99, 0.097, 93.89277, -0.512189, 5.62, 0.506, 93.9174, 6.066166, 6.07, -0.124,
  93.918855, 59.998975, 5.37, 1.339, 93.93702, -13.718414, 5, -0.078, 93.93735, 12.551067, 5.44, 0.015,
  93.97488, 1.169078, 6.37, 0.443, 94.032045, -16.618006, 5.97, -0.167, 94.07838000000001, -59.213504, 6.44, 0.593,
  94.07935499999999, 23.970027, 6.09, 0.897, 94.09914, 17.181607, 6.39, 1.565, 94.11091499999999, 12.272163, 5.04, 0.431,
  94.13806500000001, -35.140519, 4.37, 0.978, 94.14829499999999, -39.264394, 6, 0.163, 94.24461000000001, 23.740909, 6.24, 0.446,
  94.25512499999999, -37.737445, 5.54, 1.129, 94.264965, -22.715229, 6.05, 0.576, 94.27758, 9.94239, 5.39, 0.106,
  94.289865, -37.253498, 5.88, 0.139, 94.31724, 5.100112, 5.7, 0.61, 94.423845, -16.815908, 5.15, 1.293,
  94.46558999999999, -52.733031, 6.4, 1.456, 94.478445, 61.515286, 5.01, 1.843, 94.52337, 14.382859, 6.12, 0.035,
  94.557195, -19.966974, 5.51, -0.163, 94.57026, 46.360443, 6.33, 1.113, 94.66813499999999, 9.047183, 6.24, 0.87,
  94.703295, -15.024954, 6.04, 1.663, 94.710765, -9.390018, 5.36, 1.239, 94.711575, 69.319787, 4.76, 0.025,
  94.74573, -20.925611, 5.79, -0.155, 94.75767, 17.325259, 6.27, -0.094, 94.78305, -8.586012, 6.22, -0.043,
  94.90578000000001, 59.010964, 4.44, 0.032, 94.90905000000001, -22.103119, 6.29, 1.473, 94.92064500000001, -34.396591, 5.76, -0.08,
  94.928325, -7.822908, 5.27, -0.177, 94.99833, -2.944493, 4.91, 1.613, 95.017605, 14.651127, 5.67, 1.578,
  95.078295, -30.063367, 3.02, -0.16, 95.1465, -23.637963, 6.49, 1.132, 95.151, -34.144144, 5.55, -0.182,
  95.27263500000001, -11.817324, 6.32, 1.676, 95.29965, 29.540816, 6.41, 0.048, 95.352975, -11.773238, 5.48, 0.002,
  95.35737, 2.268522, 6.3, 0.251, 95.358015, 17.763503, 6.32, 1.1, 95.442165, 53.452179, 5.34, 0.448,
  95.51481, 59.372099, 6.05, 0.153, 95.52846, -33.4364, 3.85, 0.858, 95.65164, 12.570237, 6, 0.319,
  95.65935, -69.984043, 5.56, 1.51, 95.674935, -17.955918, 1.98, -0.24, 95.732685, -56.369969, 5.6, 0.242,
  95.740095, 22.513586, 2.87, 1.621, 95.756115, -63.683136, 6.3, 1.612, 95.776545, 56.976349, 6.47, 1.075,
  95.810325, -31.790312, 6.31, 0.893, 95.82705, 3.764489, 6.41, -0.149, 95.899665, -9.874727, 6.11, 1.841,
  95.942025, 4.592865, 4.39, 0.215, 95.94226499999999, -15.071257, 6.27, 1.534, 95.945505, -58.543871, 6.47, 0.12,
  95.98299, -25.577629, 5.61, 1.561, 95.98792499999999, -52.69566, -0.62, 0.164, 96.00421499999999, -36.707764, 5.62, 1.027,
  96.00951, 8.885014, 6.24, -0.06, 96.043005, -11.530088, 5.21, 1.23, 96.05775, -60.281325, 5.78, -0.001,
  96.08574, -12.961939, 6.12, -0.076, 96.11076, -63.428929, 6.45, 0.66, 96.18227999999999, 25.048714, 6.35, 1.21,
  96.182895, -28.780112, 6.37, 0.626, 96.18539999999999, -40.283979, 6.3, -0.049, 96.21987, 16.05713, 6.35, 1.063,
  96.224595, 49.287893, 4.92, 1.905, 96.23251499999999, -63.828144, 6.26, -0.119, 96.30417, 7.085713, 6.26, 0.85,
  96.318945, -0.945883, 5.88, 0.564, 96.367395, 14.721992, 6.3, 2.349, 96.36934500000001, -69.690299, 5.37, 0.971,
  96.375015, -35.064153, 6.24, 1.353, 96.38724, 23.327169, 6.05, 0.02, 96.431895, -48.176898, 5.76, -0.061,
  96.4464, -3.889032, 6.33, 1.018, 96.46803, 11.125884, 6.39, 0.077, 96.49512, -7.894983, 6.4, 0.145,
  96.53979, -3.515691, 6.42, 1.039, 96.60771, 56.285096, 5.53, 0.238, 96.643515, -4.5974, 6.16, -0.151,
  96.664935, -1.507336, 5.87, 0.07, 96.677745, -14.603429, 6.32, 1.242, 96.68688, -7.511936, 6.35, -0.061,
  96.70365, 58.417409, 5.21, 1.538, 96.753645, -4.355659, 6.5, -0.155, 96.76720499999999, -58.002116, 5.82, 1.279,
  96.781605, -37.895507, 6.48, 0.394, 96.7974, -25.856496, 6.05, 0.545, 96.807345, 0.299246, 5.19, 1.186,
  96.814965, -0.275999, 5.55, 1.376, 96.835215, 2.908288, 5.55, 1.035, 96.898005, 32.562946, 6.43, 1.264,
  96.98612999999999, 20.49632, 6.22, 0.041, 96.98988, -4.762154, 5.06, -0.175, 97.04254499999999, -32.58007, 4.47, -0.169,
  97.06035, 70.53532, 6.03, 0.103, 97.06986, 1.912679, 6.48, -0.064, 97.078395, 10.303893, 6.16, 1.15,
  97.1169, 16.238386, 6.24, 0.894, 97.14204000000001, 30.493034, 5.75, 0.779, 97.155915, -17.466009, 5.76, 1.118,
  97.16351999999999, -32.371279, 5.74, -0.16, 97.17675, -41.074877, 6.32, 0.39, 97.204455, -7.033062, 3.76, -0.113,
  97.240785, 20.212133, 4.13, -0.115, 97.31172, 2.646194, 6.17, 1.539, 97.368825, -56.852766, 5.2, 1.087,
  97.45453499999999, -50.239085, 5.28, 0.371, 97.512405, 46.685554, 5.88, 1.448, 97.51254, -65.568242, 6.28, 0.329,
  97.54698, -10.081511, 5.92, 1.373, 97.549245, -19.214889, 6.44, 1.683, 97.64535, -13.148172, 6.16, -0.137,
  97.69287, -27.769575, 5.92, -0.156, 97.69635, 58.162633, 5.86, 0.934, 97.74957, -40.916253, 6.19, 1.398,
  97.789845, 11.251375, 6.17, -0.116, 97.79436000000001, -61.879545, 6.15, -0.147, 97.80456000000001, -35.25884, 5.82, 0.813,
  97.82616, -51.825953, 5.58, 0.534, 97.84602000000001, -12.391953, 5.16, 1.262, 97.849995, -32.868548, 6.31, 1.665,
  97.89560999999999, -36.940027, 6.26, 1.599, 97.90597500000001, 15.903501, 6.38, 0.275, 97.951245, 11.544412, 5.22, 0.185,
  97.958595, -8.158235, 5.43, 1.373, 97.964025, -23.418422, 4.34, -0.245, 97.99296, -58.753835, 5.69, -0.057,
  98.077275, 17.784349, 6.26, 0.541, 98.08002, 4.855999, 5.88, 0.997, 98.089065, -37.696702, 5.25, 0.982,
  98.09637, -5.86882, 5.6, 0.256, 98.09697, 11.67352, 6.08, 1.069, 98.113275, 32.454898, 5.82, 0.188,
  98.16239999999999, -32.030447, 5.73, -0.18, 98.19531, -11.166381, 6.3, 1.096, 98.22594000000001, 7.332965, 4.47, 0.023,
  98.29266000000001, -38.62519, 6.44, 0.999, 98.35956, -52.329234, 6.18, 1.088, 98.36113499999999, -20.923961, 6.39, 0.817,
  98.40069, 14.155163, 5.57, 1.105, 98.40800999999999, -1.220154, 5.09, -0.132, 98.456175, -36.232029, 5.42, 1.419,
  98.636655, 55.353042, 6.45, 1.554, 98.647215, -32.716255, 5.62, -0.085, 98.692995, 7.572482, 6.44, -0.01,
  98.7441, -52.975607, 4.35, -0.021, 98.76411, -22.964793, 4.54, -0.035, 98.80026, 28.022314, 5.26, -0.008,
  98.81595, 0.890216, 5.78, 0.004, 98.823315, 9.988335, 5.93, 1.508, 98.850915, -36.779879, 5.59, -0.13,
  98.87841, -22.109053, 6.32, 1.03, 98.97516, -36.088632, 6.36, 0.486, 99.095205, -18.659904, 5.71, 0.848,
  99.136815, 38.4455, 5.4, 2.773, 99.14721, -5.211143, 5.52, -0.082, 99.17098499999999, -19.255879, 3.95, 1.037,
  99.171105, -22.614732, 6.35, -0.117, 99.19416, -13.321036, 5.95, 1.562, 99.213645, -41.557141, 6.36, 1.147,
  99.257865, -38.146506, 6.03, 1.03, 99.30765000000001, -36.990651, 5.72, -0.112, 99.350175, 6.135382, 6.05, 0.018,
  99.36370500000001, 24.590851, 6.44, 0.101, 99.40372500000001, 10.853293, 6.39, 1.351, 99.40998, 56.857531, 5.87, 0.006,
  99.41802, 2.704158, 6.17, 1.08, 99.41996999999999, -12.985116, 6.11, 0.994, 99.423, 61.481233, 5.94, 0.899,
  99.42792, 16.399252, 1.93, 0.001, 99.440295, -43.195934, 3.17, -0.103, 99.448365, -32.339735, 5.25, 1.177,
  99.469605, 4.95667, 6.14, 0.091, 99.47259, -18.237478, 4.42, 1.137, 99.47976, 73.695636, 6.26, 0.396,
  99.501645, -61.533387, 6.15, 0.624, 99.58524, -2.543897, 6.14, 1.47, 99.595455, -23.580321, 6.48, 0.664,
  99.595875, 28.984354, 5.76, -0.001, 99.64761, -16.873547, 6.01, 0.042, 99.65680499999999, -48.220183, 5.05, 0.997,
  99.659115, 1.613518, 6.23, 0.086, 99.664755, 39.390854, 5.7, 1.367, 99.704925, 39.902559, 5.34, -0.075,
  99.77208, 22.030881, 6.09, 1.027, 99.81966, -14.145764, 4.82, 1.459, 99.832605, 42.488877, 4.8, 1.236,
  99.881175, 24.600162, 6.43, 0.523, 99.888, 28.263134, 6.02, -0.087, 99.90093, -23.695662, 6.05, -0.031,
  99.92775, -30.470491, 5.7, 1.134, 99.948825, 12.982768, 5.99, 0.063, 99.99117, 44.014114, 6.35, 1.222,
  100.01211, -80.813593, 5.61, 0.214, 100.120185, 77.995782, 5.75, 1.488, 100.13436, 71.748786, 5.88, 1.223,
  100.2399, -71.775192, 6.5, 1.11, 100.24441499999999, 9.895754, 4.66, -0.233, 100.272675, 0.495323, 5.79, -0.094,
  100.30905, -40.349847, 6.16, -0.146, 100.321755, 11.003197, 6.19, 1.675, 100.33707, 28.196638, 6.45, 1.09,
  100.34142, 16.39765, 6.28, -0.016, 100.40733, 35.931928, 6.48, 0.509, 100.48494000000001, -9.167537, 5.21, 1.525,
  100.49678999999999, 6.345425, 6.36, -0.084, 100.56826500000001, -38.398791, 6.28, 0.346, 100.601355, 17.645303, 5.2, 0.063,
  100.691865, -22.44859, 6.26, 0.321, 100.770765, 44.52445, 5.04, 1.479, 100.77756000000001, 3.033801, 6.18, 1.366,
  100.807245, 37.147375, 6.21, 1.026, 100.84731000000001, -39.193118, 6.3, 0.258, 100.90308, -73.118208, 6.36, 0.96,
  100.91103, 3.932528, 5.88, -0.046, 100.98303, 25.131124, 3.06, 1.377, 100.997055, 13.228017, 4.49, 1.167,
  101.047905, 53.295939, 6.28, 1.089, 101.05217999999999, 36.109258, 6.37, 0.065, 101.05332000000001, -54.695507, 6.47, -0.119,
  101.11861499999999, -31.070523, 5.23, -0.127, 101.18941500000001, 28.970932, 5.42, 1.445, 101.216475, -27.341666, 6.43, 0.55,
  101.23194, -70.433758, 6.1, 1.335, 101.287215, -16.716116, -1.44, 0.009, 101.32236, 12.895591, 3.35, 0.443,
  101.34567, -31.793661, 5.92, 0.491, 101.34735, -23.462432, 6.04, 1.205, 101.37996, -30.94898, 5.62, -0.138,
  101.47383, -52.409691, 5.81, 1.551, 101.475825, 12.693561, 6.47, 0.344, 101.497485, -14.796127, 5.3, 0.075,
  101.55063, -37.775325, 6.19, -0.123, 101.558925, 59.44167, 4.86, 0.084, 101.56005, 79.564811, 5.44, 0.525,
  101.635065, 8.587153, 5.92, -0.173, 101.66257499999999, -10.10736, 5.66, -0.048, 101.67362999999999, -54.695028, 6.45, 0.858,
  101.684745, 43.577427, 5.24, 0.575, 101.706255, 57.169176, 5.34, 0.964, 101.712885, -14.425971, 5.28, -0.024,
  101.7195, -51.265667, 5.39, 1.33, 101.74384500000001, -87.024964, 6.46, 0.429, 101.756175, -21.015402, 6.07, -0.159,
  101.82795, -55.539988, 5.6, 1.549, 101.83263, 8.037254, 4.77, 1.396, 101.83917000000001, -37.929698, 5.27, -0.078,
  101.847735, 18.193452, 6.35, 0.066, 101.905095, -8.998503, 5.08, 1.795, 101.914905, 48.789476, 5.22, 1.131,
  101.9652, 2.412159, 4.48, 1.099, 102.04791, -61.941391, 3.24, 0.225, 102.051105, 55.704195, 5.54, -9,
  102.07944, -1.318922, 5.75, 0.292, 102.24056999999999, -15.144726, 5.39, -0.096, 102.26522999999999, 1.002065, 6.16, -0.134,
  102.318375, -2.272038, 5.75, -0.098, 102.422145, 32.606756, 5.72, 1.298, 102.433335, -24.076066, 6.31, 0.054,
  102.43451999999999, 37.512748, 6.49, 1.553, 102.45765, 16.202888, 5.87, -0.136, 102.460245, -32.508478, 3.5, -0.116,
  102.463815, -53.622449, 4.41, 0.899, 102.47757, -46.61456, 5.14, 0.46, 102.48398999999999, -50.61456, 2.94, 1.207,
  102.50421, -60.249146, 6.11, 0.457, 102.5907, -17.084555, 5.77, 1.435, 102.597285, -31.706057, 5.74, 0.094,
  102.60624, 13.413177, 5.68, 1.329, 102.65400000000001, -25.778394, 6.32, -0.183, 102.67626, -8.040996, 6.31, 0.011,
  102.691455, 41.78123, 4.99, 1.256, 102.70764, -0.540882, 5.78, 0.396, 102.71814, -34.367318, 4.99, 1.379,
  102.737865, 67.571934, 5.14, -0.152, 102.862425, -70.963411, 5.41, -0.11, 102.88571999999999, -48.292754, 6.42, 1.207,
  102.887685, 21.761148, 5.28, -0.02, 102.91407, 3.041991, 6.37, 0.052, 102.926775, -36.23027, 5.94, 0.183,
  102.99996, 23.601718, 5.68, 1.467, 103.095255, -5.316277, 6.3, 0.977, 103.18930499999999, -59.341195, 6.41, 0.181,
  103.196415, -43.975594, 6.47, -0.101, 103.19724, 33.961254, 3.6, 0.102, 103.20612, 8.380373, 5.75, 0.27,
  103.251255, -26.957632, 6.33, 1.408, 103.255875, 38.869157, 6.1, 0.406, 103.26474, 35.787995, 6.03, 1.455,
  103.27107, 59.448543, 5.34, 0.675, 103.28157, 44.839941, 6.24, 0.239, 103.30581, 38.438013, 6.32, 0.516,
  103.3284, -19.032763, 5.65, 0.279, 103.34100000000001, -18.932844, 6.13, 0.156, 103.34334, 10.99665, 6.3, 0.962,
  103.38711, -20.224254, 4.82, -0.212, 103.39134, -28.539794, 6.05, 0.708, 103.42602000000001, 68.888309, 5.11, -0.114,
  103.481055, -24.538756, 6.23, 0.016, 103.48780500000001, 38.505018, 6.46, -0.044, 103.509495, -50.6116, 6.24, 0.988,
  103.533135, -24.184211, 3.89, 1.74, 103.53578999999999, -5.852188, 6.39, 0.174, 103.547505, -12.038628, 4.08, 1.418,
  103.60276499999999, -1.126996, 5.44, 0.167, 103.61118, -42.365571, 6.32, 2.287, 103.66098000000001, 13.177827, 4.73, 0.321,
  103.675185, -1.756486, 6.2, 0.487, 103.74549, -2.803588, 6.03, 1.102, 103.761405, -20.404876, 5.8, 0.048,
  103.81107, 43.910031, 6.16, 0.314, 103.81331999999999, 45.826408, 6.31, 0.945, 103.827795, 25.375697, 5.74, 0.573,
  103.89423, 8.324285, 6.28, 0.037, 103.90596, -20.136497, 4.66, 0.374, 103.94552999999999, -22.941439, 5.29, -0.163,
  103.97821499999999, -31.790179, 6.36, -0.155, 104.02768499999999, -14.04343, 5, 1.182, 104.03426999999999, -17.054242, 4.36, -0.063,
  104.066625, -48.721144, 4.94, 1.668, 104.10763499999999, 9.956578, 5.9, -0.085, 104.13356999999999, 46.273998, 5.85, -0.079,
  104.143665, -79.420193, 5.45, 0.041, 104.19042, -35.341334, 6.27, 1.278, 104.23365, 46.705352, 5.88, 1.093,
  104.25039000000001, -8.179295, 6.31, 0.641, 104.252175, 33.681039, 5.91, 0.878, 104.30472, 57.563287, 6.03, 1.495,
  104.31918, 58.422759, 4.35, 0.85, 104.32329, -35.507153, 6.23, 0.465, 104.3271, 37.394723, 6.48, 1.673,
  104.35661999999999, 11.907554, 6.26, 0.349, 104.3913, -24.630841, 5.45, 0.39, 104.404635, 45.094094, 4.9, 0.027,
  104.42763, -27.537505, 6.22, -0.147, 104.531475, -27.164381, 6.36, -0.186, 104.60457000000001, -34.111708, 5.07, -0.154,
  104.64958499999999, -25.414157, 5.59, -0.162, 104.65158000000001, -56.394849, 6.46, 0.389, 104.656455, -28.972084, 1.5, -0.211,
  104.66214000000001, 7.6223, 6.25, 0.105, 104.665725, -55.729122, 6.26, 1.16, 104.67388500000001, -45.767593, 6.23, -0.006,
  104.68207500000001, -30.998037, 6.41, -0.137, 104.697585, 26.081079, 6.2, 0.52, 104.737605, 3.602355, 5.96, 1.056,
  104.76189, 38.052317, 6.02, 1.218, 104.834055, 7.316967, 6.34, -0.106, 104.86638, 25.914171, 6.4, -0.111,
  104.913555, -21.602884, 6.26, -0.164, 104.96067000000001, -67.916443, 5.18, 1.396, 105.016215, 76.977408, 4.55, 1.365,
  105.034515, -20.158425, 6.32, -0.134, 105.06594, 16.078998, 5.73, 1.641, 105.07515000000001, -5.367162, 6.29, 0.572,
  105.098985, -8.406821, 5.95, -0.075, 105.163905, -9.202967, 6.49, 0.142, 105.177135, -28.489574, 6.28, 0.449,
  105.20727, -33.46553, 6.39, 1.052, 105.214545, -51.402585, 5.14, 1.652, 105.27144, -58.939937, 6.01, 0.297,
  105.27477, -25.215634, 5.64, -0.165, 105.33918, 70.808296, 5.69, 1.337, 105.42978000000001, -27.93483, 3.49, 1.729,
  105.47049, -1.345883, 6.2, 1.286, 105.484935, -5.722065, 5.22, 1.687, 105.564495, -43.40387, 6.44, -0.039,
  105.57289499999999, 15.336008, 5.78, 1.14, 105.603255, 24.215446, 5.2, 0.953, 105.60639, 17.755521, 5.96, 1.518,
  105.6387, 16.674447, 5.86, 1.659, 105.72823500000001, -4.239231, 4.99, -0.195, 105.756135, -23.833291, 3.02, -0.077,
  105.812925, -59.178109, 5.5, -0.125, 105.824655, 9.138355, 5.96, 0.126, 105.87685499999999, 29.337081, 5.93, 0.595,
  105.90864, 10.951817, 5.14, 1.391, 105.939555, -15.633286, 4.11, -0.112, 105.964995, 12.594242, 6.01, 1.584,
  105.97344, -49.58392, 4.92, 0.14, 105.98892000000001, -43.608039, 5.56, 0.624, 105.98939999999999, -10.123765, 6.44, -0.067,
  106.01166, -42.33728, 5.2, 0.198, 106.02186, -5.323979, 5.63, 1.29, 106.027215, 20.570297, 4.01, 0.899,
  106.07635499999999, -56.749724, 5.14, -0.032, 106.19604, -22.031688, 6.09, 1.225, 106.28744999999999, 47.775044, 6.37, -0.048,
  106.31824499999999, -50.360042, 6.47, 1.424, 106.32654, 22.637458, 6, -0.027, 106.38343499999999, -34.7777, 6.15, 0.353,
  106.41261, 9.1858, 5.78, 1.513, 106.415865, 52.758558, 6.17, 0.102, 106.45683, -10.66008, 6.5, -0.062,
  106.46513999999999, 70.731924, 6.49, 1.568, 106.502025, -30.655711, 6.34, -0.131, 106.5051, 59.80185, 6.4, 1.19,
  106.509435, -38.382854, 6.09, 0.702, 106.54832999999999, 34.473967, 5.55, 0.909, 106.55961, -68.83758, 6.47, 1.039,
  106.64985, -12.393949, 6.48, -0.124, 106.66986, -11.294014, 5.41, 0.033, 106.718655, -24.960572, 6.09, 1.341,
  106.77696, 4.910582, 6.1, -0.129, 106.779495, -40.893268, 5.8, -0.158, 106.805385, -51.968283, 5.96, 0.996,
  106.817835, -59.716416, 6.46, -0.113, 106.843335, 34.009288, 5.94, 1.507, 106.844115, -23.840722, 5.75, -0.117,
  106.853655, 28.176695, 6.47, -0.081, 106.95621, 7.471214, 5.74, 1.176, 107.05529999999999, 33.832388, 6.31, 1.356,
  107.091825, 15.930675, 5.47, 1.02, 107.097855, -26.3932, 1.83, 0.671, 107.151015, 37.445096, 6.19, 1.212,
  107.17647, -70.497087, 5.68, 0.436, 107.18682, -70.498932, 3.78, 1.006, 107.212785, -39.655657, 4.83, -0.179,
  107.334375, -10.346565, 6.23, -0.018, 107.38902, -16.234509, 6, 0.04, 107.429265, -25.231034, 5.69, -0.158,
  107.52785999999999, 21.246985, 6.43, 0.88, 107.53902, -18.685637, 6.23, 0.419, 107.557005, -4.237106, 4.91, 1.02,
  107.58051, -27.49152, 5.46, 0.998, 107.69787000000001, -48.932098, 5.12, 1.251, 107.784885, 30.245163, 4.41, 1.261,
  107.846115, 26.856587, 5.75, 0.13, 107.848395, -0.301928, 5.44, 0.31, 107.913825, 39.320549, 4.91, 1.451,
  107.92335, -20.883063, 5.84, -0.038, 107.945205, 16.976344, 6.5, 1.423, 107.96409, 5.654703, 6.07, -0.016,
  107.966085, -0.492764, 4.15, -0.005, 108.00825, -63.190059, 6.03, -0.011, 108.017055, -30.821365, 6.1, 0.273,
  108.031215, 5.474347, 6.15, 1.142, 108.050895, -25.942588, 5.91, -0.17, 108.06588, -40.498808, 5.3, 0.072,
  108.107595, -36.544381, 5.94, -0.145, 108.109905, 24.128594, 5.85, 0.397, 108.14025, -46.759305, 4.49, 0.324,
  108.204525, 27.224823, 6.46, 0.502, 108.279975, -11.251341, 5.77, 1.508, 108.305655, -45.182739, 4.87, -0.003,
  108.34281, 16.158966, 5.07, 1.653, 108.34749, 51.428745, 5.46, 1.64, 108.3501, -22.674241, 5.99, 1.481,
  108.38455499999999, -44.639739, 4.42, 1.331, 108.40187999999999, -27.35636, 6.12, -0.234, 108.451605, -22.905778, 6.34, -0.184,
  108.48890999999999, -30.339791, 6.32, -0.183, 108.491685, 71.816584, 6.36, 1.119, 108.54520500000001, -3.901779, 5.8, 1.585,
  108.563385, -26.352507, 4.42, -0.17, 108.56466, -9.947533, 5.9, 1.528, 108.58359, 3.111414, 5.36, 1.193,
  108.617715, -10.316245, 6.02, -0.173, 108.635925, 12.115824, 5.71, 1.007, 108.65892000000001, -48.271927, 4.75, -0.091,
  108.674895, 24.884984, 5.84, 1.554, 108.691755, -46.849672, 5.72, -0.109, 108.702735, -26.772667, 4.01, -0.15,
  108.71319, -27.037996, 5.58, 1.22, 108.738135, -41.426394, 5.95, -0.146, 108.830865, -0.161283, 6.42, 0.901,
  108.83781, -30.686447, 5.36, -0.155, 108.838515, -52.499226, 5.96, 1.099, 108.914295, 7.977742, 5.78, 1.537,
  108.930165, -10.583605, 5.95, 1.173, 108.94707, -23.74028, 6.34, -0.018, 108.958875, 47.239964, 5.54, 0.576,
  108.979005, 59.637467, 5.2, 1.081, 108.9882, 27.897419, 5.75, 1.605, 109.06065000000001, -15.585689, 5.46, 0.079,
  109.064475, -46.774533, 5.64, 1.441, 109.13272500000001, -38.318928, 5.81, -0.133, 109.145805, -27.881179, 4.66, 1.589,
  109.15347, -23.315594, 4.83, 1.601, 109.15983, -23.31094, 6.02, 0.317, 109.20588, -36.592633, 5.03, -0.161,
  109.20762, -67.957152, 3.97, 0.76, 109.2384, -30.897012, 6.3, 0.2, 109.264155, 26.689485, 6.38, 0.883,
  109.285665, -37.09747, 2.71, 1.616, 109.381935, -6.679997, 6.29, 1.624, 109.3905, 52.131071, 5.93, 1.259,
  109.4277, 38.876265, 6.48, 0.995, 109.45004999999999, -26.797556, 6.45, -0.153, 109.50923999999999, 40.883392, 5.87, 0.181,
  109.51704, 30.955872, 6.19, -0.024, 109.517715, -43.986786, 5.86, -0.117, 109.52324999999999, 16.540383, 3.58, 0.106,
  109.57665, -36.733962, 4.65, -0.099, 109.633245, 49.464756, 5, 0.087, 109.639635, -39.210285, 5.24, 0.026,
  109.659105, -36.742735, 5.11, -0.17, 109.66824, -24.558701, 4.88, -0.16, 109.67703, -24.954375, 4.37, -0.132,
  109.713645, -26.585854, 5.29, 0.956, 109.758, -19.280304, 6.06, 0.612, 109.807035, -33.727166, 6.31, 1.302,
  109.843215, 2.740694, 5.9, 1.069, 109.86740999999999, -16.395244, 5.7, 0.346, 109.948515, 7.142947, 5.91, 0.537,
  110.02851, 15.142928, 6.45, 0.009, 110.030745, 21.98232, 3.5, 0.374, 110.08932, -52.311524, 5.5, 0.483,
  110.16171, -52.085924, 5.38, -0.069, 110.22882, -26.963838, 6, -0.172, 110.24286, -14.360489, 5.59, 0.971,
  110.26293, 42.655913, 6.33, 1.404, 110.26806, -25.891643, 5.87, 1.604, 110.32296, 45.2282, 5.74, 0.342,
  110.486925, 20.443658, 5.09, 1.528, 110.508555, -8.979377, 6.42, -0.189, 110.51095500000001, 36.760584, 5.12, 1.082,
  110.514495, 0.177121, 5.99, -0.069, 110.55588, 38.995944, 6.4, 1.217, 110.556375, -19.0166, 4.94, -0.039,
  110.57159999999999, 59.901996, 6.36, 0.282, 110.577465, -2.979175, 6.23, 0.686, 110.60578500000001, -5.982829, 5.83, 0.352,
  110.617995, 0.700831, 6.43, 0.995, 110.716905, 55.281392, 5.8, -0.078, 110.752905, -31.923781, 5.4, -0.161,
  110.86725, 22.945349, 6.17, 0.006, 110.86881, 25.050531, 5.04, 0.902, 110.87079, -27.834294, 5.37, 1.539,
  110.88289499999999, -32.202067, 5.41, -0.169, 110.99306999999999, -35.837824, 6.32, -0.136, 111.02376, -29.303104, 2.45, -0.083,
  111.03528, 40.672389, 5.23, 1.249, 111.071805, -22.912758, 6.2, -0.088, 111.1152, 15.517195, 6.47, -0.19,
  111.13938, 27.637857, 5.77, 0.368, 111.154665, -71.470657, 6.49, 0.12, 111.167445, -16.201473, 5.18, -0.035,
  111.18272999999999, -31.808905, 5.35, 1.071, 111.19732499999999, -37.291193, 6.14, 0.261, 111.21200999999999, -19.012279, 6.24, 0.291,
  111.237855, 51.887258, 5.8, 1.61, 111.242415, 11.669524, 5.37, 0.105, 111.284655, -13.751978, 5.79, 0.432,
  111.333225, -21.982591, 6.04, 0.227, 111.341535, 81.257456, 6.3, -0.031, 111.35529, -25.217767, 5.79, -0.103,
  111.40905000000001, -79.094188, 5.54, 1.281, 111.412065, 9.276097, 4.99, 0.991, 111.42909, -31.73872, 6.32, -0.176,
  111.43168499999999, 27.79808, 3.78, 1.024, 111.463335, -5.774961, 5.98, 0.901, 111.59104500000001, -51.018481, 5.09, 1.038,
  111.61578, 10.608067, 6.38, 0.078, 111.67173, 11.008833, 6.39, -0.126, 111.67694999999999, -34.140692, 5.9, -0.153,
  111.67855499999999, 49.211527, 4.61, -0.001, 111.734715, 20.257557, 5.94, 0.336, 111.74784, -23.086023, 5.65, -0.134,
  111.783285, -17.864861, 5.6, 0.314, 111.78768, 8.289315, 2.89, -0.097, 111.85767, 66.331571, 6.47, -0.064,
  111.928905, -22.859199, 5.98, -0.088, 111.93486, 21.445247, 5.2, 0.455, 111.96525, -11.556867, 5.79, 0.583,
  111.99651, -29.155896, 5.55, -0.048, 112.00803, -26.838974, 6.26, 1.513, 112.008645, 6.941968, 5.22, 0.221,
  112.040805, 8.92553, 4.33, 1.425, 112.16625, 27.552938, 6.36, 1.223, 112.196895, 15.109822, 6.23, -0.04,
  112.21314000000001, -31.848401, 5.95, -0.156, 112.21419, -64.509804, 6.38, 1.554, 112.21452, 48.18393, 5.7, -0.092,
  112.21932, 46.314618, 6.42, 1.202, 112.270485, -31.456216, 5.78, -0.185, 112.27374, -38.812065, 5.41, -0.148,
  112.277925, 31.78455, 4.16, 0.32, 112.307685, -43.301432, 3.25, 1.509, 112.327785, -1.905329, 5.6, 1.493,
  112.33518, 28.118275, 5.07, 0.12, 112.341105, -14.998657, 6.05, 0.479, 112.34211, -10.326664, 5.75, 1.616,
  112.356825, -7.551168, 5.86, 0.487, 112.44909, 12.006564, 4.55, 1.276, 112.4532, 27.916146, 5.01, 1.117,
  112.464225, -23.024287, 4.85, 0.243, 112.48300499999999, 49.672463, 5.35, 0.47, 112.498875, -52.651157, 5.87, 1.01,
  112.628805, -54.399365, 5.95, 1.585, 112.67751000000001, -30.962281, 4.65, 0.904, 112.71306, -5.226494, 6.24, 1.185,
  112.71956999999999, 68.465621, 5.63, 1.1, 112.768665, 82.411466, 4.92, 1.633, 112.786605, 11.202979, 6.38, 1.278,
  112.95165, 17.086046, 5.45, 1.126, 113.02401, -8.881326, 5.9, 0.54, 113.02479, 1.914481, 5.24, 0.23,
  113.09280000000001, -35.961188, 6.35, -0.096, 113.29074, -24.710731, 5.84, 0.156, 113.298615, 3.290379, 5.59, 0.321,
  113.30484, -40.058522, 6.27, -0.129, 113.33151, -19.412525, 5.64, 1.121, 113.342445, -14.338307, 6.21, -0.061,
  113.353455, 37.187897, 6.4, 1.231, 113.40200999999999, 15.826662, 5.27, 0.055, 113.449845, -14.523892, 4.82, 1.362,
  113.46268500000001, -36.338392, 5.42, -0.078, 113.464665, 51.314147, 6.44, 1.348, 113.513265, -22.296067, 4.44, 0.521,
  113.52069, 10.568076, 6.28, 0.022, 113.55346499999999, -33.46343, 6.11, 0.297, 113.566215, 3.371725, 5.83, -0.018,
  113.577585, -23.473661, 5.06, 0.468, 113.644995, -27.012275, 5.78, 1.045, 113.64951, 31.888276, 1.58, 0.034,
  113.66493, -51.474517, 6.29, 0.073, 113.78667, 30.960924, 5.34, 1.01, 113.84025, -74.274957, 6.33, 0.016,
  113.84541, -28.369323, 4.65, -0.111, 113.915475, -52.533836, 4.93, 1.373, 113.98062, 26.895741, 4.06, 1.54,
  113.98326, 43.030959, 6.37, 0.364, 114.006705, -55.887708, 6.39, 1.182, 114.01623, -14.492771, 5.66, -0.067,
  114.030885, -22.160505, 6.4, 0.968, 114.06957, -8.311302, 6.27, 1.541, 114.131835, 46.180288, 5.66, 1.56,
  114.144615, 5.862171, 5.89, 0.602, 114.17097000000001, -19.702338, 5.69, -0.165, 114.18299999999999, -48.830167, 5.69, -0.037,
  114.196005, 55.75506, 5.93, 1.123, 114.319545, -4.110979, 5.14, 0.442, 114.32053499999999, -23.775399, 6.34, 0.54,
  114.32415, 40.025383, 6.34, 1.6, 114.342135, -34.96853, 4.53, -0.081, 114.437595, -38.010425, 6.38, 1.472,
  114.47442, 48.773842, 5.93, 0.221, 114.55987499999999, 24.360441, 6.37, 0.337, 114.57519, -25.364804, 4.69, -0.1,
  114.57586500000001, -48.601436, 5.68, 0.683, 114.635565, -38.781487, 6.2, 1.015, 114.6369, 35.04855, 5.58, 0.921,
  114.68292, -36.49683, 5.78, -0.148, 114.70778999999999, -26.803836, 3.8, -0.159, 114.75134999999999, -53.273357, 6.06, -0.118,
  114.7914, 34.584346, 4.89, 0.413, 114.800025, 24.222528, 6.18, 0.028, 114.825495, 5.224993, 0.4, 0.432,
  114.850815, -16.847292, 6.4, 1.47, 114.862425, -26.863102, 6.5, -0.094, 114.863925, -38.308021, 4.84, -0.189,
  114.86913, 17.674519, 5.04, 1.616, 114.932565, -38.139287, 5.73, -0.125, 114.94948500000001, -38.260652, 5.76, -0.071,
  114.975375, 32.009727, 6.16, 0.374, 114.99163499999999, -37.579422, 5.99, -0.04, 115.056375, -19.660861, 5.92, 1.158,
  115.06125, 38.344539, 5.77, 1.654, 115.08756, -11.752552, 6.43, 1.245, 115.09671, -15.26392, 4.98, 1.543,
  115.129425, 87.020091, 5.05, 1.604, 115.14801, -8.18543, 6.01, 0.153, 115.196595, 13.771251, 6.23, 1.393,
  115.206435, 57.082865, 6.09, 1.44, 115.24382999999999, 23.018527, 5.93, 1.561, 115.30173, 48.131533, 5.58, 1.011,
  115.31181, -9.551131, 3.94, 1.022, 115.315905, -38.533532, 5.41, -0.13, 115.34052, -44.632168, 6.41, -0.003,
  115.348035, -22.336721, 6.16, 1.644, 115.396485, 3.624779, 5.95, -0.032, 115.45506, -72.606098, 3.93, 1.033,
  115.466025, 13.480453, 5.79, 1.669, 115.51341, 14.208503, 5.55, 1.642, 115.542585, -58.630918, 6.4, -0.094,
  115.6815, 34.000218, 6.05, 0.469, 115.70064, -26.351326, 5.64, 0.99, 115.72227000000001, -58.230058, 6.2, 1.049,
  115.737975, -45.173118, 5.04, 0.765, 115.75182000000001, 58.71036, 4.93, 0.104, 115.77258, 0.189333, 6.17, 1.047,
  115.79994, -36.050089, 5.6, -0.13, 115.82800499999999, 28.88351, 4.23, 1.118, 115.83829499999999, 4.945762, 6.5, 1.356,
  115.84242, 22.399472, 6.25, 0.93, 115.884945, -28.410885, 4.63, 1.632, 115.924605, -40.933746, 5.12, 1.104,
  115.928835, -38.201879, 6.42, -0.119, 115.95195, -28.954826, 3.94, 0.16, 116.017425, 50.433794, 5.31, -0.001,
  116.02881000000001, 25.784159, 5.3, 1.535, 116.03181, 2.405422, 6.46, 0.211, 116.04040499999999, -36.062505, 5.8, 0.32,
  116.05446, -69.821593, 6.16, -0.032, 116.05856999999999, 12.860071, 6.4, 1.392, 116.111895, 24.397993, 3.57, 0.932,
  116.142375, -24.674079, 5.62, -0.191, 116.14245, -37.942917, 5.89, -0.115, 116.182785, -66.071933, 6.37, 0.949,
  116.313735, -37.968584, 3.62, 1.706, 116.325195, -43.752566, 6.02, -0.069, 116.329155, 28.026199, 1.16, 0.991,
  116.37138, -14.690537, 6.06, 0.11, 116.39604, -34.172363, 5.36, 0.589, 116.39799, -56.72257, 6.1, 0.397,
  116.486955, -14.563805, 5.03, 0.342, 116.509125, -6.772511, 5.49, 1.378, 116.53103999999999, 18.510043, 4.89, 1.425,
  116.54393999999999, -37.93367, 5.87, -0.111, 116.567505, 10.768252, 5.25, 0.018, 116.614335, 62.830522, 6.5, 0.262,
  116.63925, -37.772569, 6.31, 1.348, 116.663655, 37.517394, 5.15, 1.588, 116.666895, 65.455676, 5.93, 1.183,
  116.68630499999999, -12.675313, 6.39, -0.004, 116.77401, -39.330996, 6.33, -0.142, 116.802315, -22.51951, 5.9, -0.18,
  116.810835, -36.0736, 6.46, 1.083, 116.85414, -38.511145, 5.07, -0.112, 116.87635499999999, 33.415697, 5.14, 1.635,
  116.881275, -46.60849, 5.22, -0.151, 116.910525, -15.990688, 6.31, 1.791, 116.938365, -16.014483, 6.38, 1.697,
  116.98633500000001, -12.192705, 5.48, 0.478, 117.02154, -25.937169, 4.4, -0.07, 117.03561, -40.652378, 6.14, 1.591,
  117.081255, -56.471075, 6.3, 1.01, 117.08412, -47.077722, 4.69, 1.039, 117.14016000000001, 23.14098, 6.18, 0.571,
  117.25698, -24.912208, 5.32, 0.751, 117.257655, 13.371869, 6.07, 1.367, 117.277995, -56.41036, 5.57, 1.116,
  117.3036, -46.857717, 5.82, -0.142, 117.303855, -60.283688, 5.78, 0.428, 117.30957, -46.373205, 4.1, -0.16,
  117.31104, -35.243286, 5.94, -0.051, 117.32356499999999, -24.859786, 3.34, 1.218, 117.36787500000001, -44.751157, 6.32, 0.962,
  117.370035, -13.352948, 6.23, -0.078, 117.384645, 12.81425, 6.42, 0.984, 117.39752999999999, -33.28895, 5.61, 1.617,
  117.416565, -14.085359, 6.34, 1.66, 117.41985, -19.505518, 6.49, 1.234, 117.42081, -66.195974, 5.78, -0.04,
  117.42166499999999, -17.228408, 5.17, 1.282, 117.52362000000001, -19.523548, 6.11, 1.265, 117.544065, -9.183441, 5.6, 1.446,
  117.599355, -50.509468, 5.89, 1.088, 117.67713, -44.579945, 6.45, 0.899, 117.697485, 3.277253, 6.17, 1.106,
  117.712905, 4.459514, 6.49, 0.944, 117.72262500000001, 0.079556, 6.38, 1.237, 117.73015500000001, -11.128602, 6.16, 1.128,
  117.75033, -24.528557, 6.43, -0.003, 117.75982499999999, 33.233653, 6.06, 0.15, 117.773865, 54.12924, 6.03, 0.496,
  117.81393, 37.082085, 6.49, 1.51, 117.83475, -43.095232, 6.34, -0.173, 117.918165, -42.888202, 6.05, -0.181,
  117.92037, -12.819405, 6.37, 0.384, 117.92494500000001, 1.766868, 5.12, -0.116, 117.92927999999999, -21.173662, 5.62, 0.956,
  117.94292999999999, -13.898029, 5.16, 0.6, 117.986565, 19.325085, 6.03, 1.125, 118.016145, 45.932989, 6.5, 0.213,
  118.02996, 3.277342, 6.3, 1.464, 118.05432, -40.575786, 3.71, 1.012, 118.06536, -34.705442, 5.01, 0.47,
  118.078665, -14.846175, 5.69, 0.368, 118.123935, -54.367165, 5.7, -0.151, 118.15183499999999, 55.209443, 6.36, -0.003,
  118.16103, -38.862812, 4.49, -0.188, 118.199415, -5.428257, 5.76, 0.412, 118.26462, -36.363769, 5.44, 1.161,
  118.26516, -49.613044, 4.63, -0.228, 118.32567, -48.102934, 4.22, -0.13, 118.37424, 26.765783, 4.97, 0.098,
  118.54587, -35.877287, 5.48, -0.175, 118.62195, 47.385982, 6.25, 1.133, 118.66632, -34.846713, 6.14, 1.54,
  118.67796, 47.564596, 5.47, 1.462, 118.72229999999999, -57.302806, 5.62, 1.298, 118.75179, -52.58333, 6.36, -0.007,
  118.80771, -30.917643, 6.45, 1.474, 118.88097, 8.86284, 5.86, 0.369, 118.916235, 19.88397, 5.38, -0.035,
  118.92014999999999, 35.412684, 6.23, 0.277, 118.94412, -43.845054, 6.02, -0.111, 119.07771, -60.526436, 5.74, 1.554,
  119.094675, -30.28457, 6.28, 1.476, 119.09961, 4.485567, 6.16, 0.957, 119.194695, -52.98236, 3.46, -0.177,
  119.21475000000001, -22.880119, 4.2, 0.718, 119.24085000000001, -43.500411, 5.36, -0.166, 119.24094, -42.406475, 6.09, 1.361,
  119.24772, 15.790281, 5.8, 1.285, 119.30316, -63.296835, 6.14, -0.103, 119.31616500000001, 8.64122, 6.03, 1,
  119.31789, 1.127029, 6.35, 0.507, 119.32677, -44.109859, 5.08, -0.166, 119.333625, -47.890705, 6.21, -0.099,
  119.417115, -30.33457, 4.76, 0.151, 119.44418999999999, -60.303072, 5.59, 0.573, 119.46552, -45.577669, 5.14, 1.263,
  119.478345, -40.784352, 6.46, 0.979, 119.52456, 7.21353, 6.42, -0.031, 119.56017, -49.244912, 4.47, -0.18,
  119.568975, 43.977374, 6.36, 1.043, 119.58606, 2.224767, 5.3, 0.933, 119.58936, -51.448472, 6.44, 0.26,
  119.631135, 16.51868, 6.05, 1.468, 119.71065, -60.824462, 5.77, -0.082, 119.757525, -45.215844, 5.98, -0.143,
  119.773815, -23.310396, 5.09, 1.111, 119.80128, -49.976851, 6.35, -0.151, 119.8065, -49.973772, 6.37, -0.089,
  119.815725, -73.244171, 6.33, 0.128, 119.86825499999999, -39.296944, 5.22, 0.4, 119.896065, 13.242166, 6.05, 1.325,
  119.90643, -60.587061, 5.19, 1.758, 119.917035, -60.207351, 6.3, -0.05, 119.93397, -3.679583, 4.93, 1.205,
  119.96407500000001, 36.082075, 6.5, 1.561, 119.96687999999999, -18.399228, 4.61, 0.087, 120.04896, 73.917919, 5.37, 1.424,
  120.061245, -48.981509, 6.01, 0.042, 120.08320499999999, -63.567456, 4.81, -0.173, 120.12067499999999, -48.871768, 6.13, -0.085,
  120.1839, -2.881917, 6.41, -0.087, 120.19711499999998, 17.308703, 5.6, 1.317, 120.20043000000001, 19.816216, 6.3, 1.109,
  120.20812500000001, -54.151275, 5.87, -0.134, 120.23280000000001, 25.392836, 5.87, 1.021, 120.25325999999998, 23.583093, 6.34, 1.16,
  120.26418, -6.419195, 6.45, 0.838, 120.30556500000002, -1.392608, 4.69, 1.475, 120.307875, 4.879824, 5.65, 0.013,
  120.33651, 59.047398, 5.78, 0.421, 120.34602000000001, -54.51553, 6.12, -0.044, 120.37620000000001, 16.455309, 5.99, -0.024,
  120.38157, -55.454655, 6.28, -0.146, 120.40636500000001, -37.28372, 5.9, 0.147, 120.42697500000001, 60.324353, 6.02, 0.158,
  120.43233, 25.089465, 6.32, 0.023, 120.46137, 8.913991, 6.22, 0.57, 120.47994, 35.413069, 6.34, 1.564,
  120.52555500000001, -37.050043, 6.31, 1.599, 120.5664, 2.334571, 4.39, 1.252, 120.608205, -6.337135, 6.34, 0.615,
  120.628395, 63.090306, 6.09, 0.58, 120.64917000000001, 57.273627, 6.48, 0.649, 120.68661, -41.309828, 5.52, -0.152,
  120.76734, -32.463548, 5.83, 1.225, 120.87337500000001, -42.948327, 6.28, 1.008, 120.87951, 27.794332, 4.94, 1.13,
  120.896055, -40.003148, 2.21, -0.269, 121.06746, -32.674829, 5.25, 1.882, 121.135995, -25.699737, 6.35, 1.461,
  121.17258000000001, -19.728148, 6.12, -0.154, 121.176675, -50.590396, 5.96, 1.213, 121.178895, -62.836347, 6.25, -0.093,
  121.18876499999999, 18.84202, 6.21, -0.042, 121.19651999999999, 79.479612, 5.39, -0.04, 121.265445, -53.107921, 5.52, 1.347,
  121.26870000000001, 13.118215, 5.14, 0.018, 121.33461, -46.978411, 6.18, -0.138, 121.404405, 27.529736, 6.21, 0.01,
  121.437015, -33.569435, 6.15, 1.098, 121.4568, -0.57332, 6.4, 1.058, 121.57665, 22.63549, 5.96, 1.652,
  121.61422499999999, -9.244457, 6.25, -0.006, 121.66808999999999, -45.266015, 5.04, 1.488, 121.67337, -48.497389, 6.34, -0.172,
  121.791435, 43.260365, 6.35, -0.02, 121.816695, -17.368744, 6.5, 1.246, 121.82516999999999, -20.554342, 5.33, 0.1,
  121.88605500000001, -24.304324, 2.83, 0.458, 121.94106, 21.581816, 5.3, 0.642, 121.982595, -68.617062, 4.35, -0.113,
  122.102685, -63.800821, 6.32, -0.058, 122.11444499999999, 51.50667, 4.78, 0.048, 122.14854, -2.983786, 4.36, 0.97,
  122.15684999999999, -37.681221, 6.36, -0.054, 122.17685999999999, 13.640917, 6.25, 0.48, 122.181585, -20.363173, 6.37, 0.141,
  122.23686000000001, -11.33965, 6.31, 0.011, 122.253195, -61.302429, 4.74, 0.437, 122.25682499999999, -19.245014, 4.4, -0.16,
  122.28961499999998, -48.684413, 5.66, -0.101, 122.29245, -35.455015, 6.21, 0.892, 122.34606000000001, 42.430609, 6.26, 1.263,
  122.36889, -16.248922, 5.66, -0.153, 122.38314, -47.336588, 1.75, -0.145, 122.39013000000001, -56.085384, 5.66, 0.204,
  122.39659499999999, 29.093076, 6.47, 0.804, 122.399655, -44.122773, 5.2, -0.173, 122.42981999999999, -47.937193, 5.23, -0.199,
  122.448735, -42.640803, 6.27, -0.036, 122.515785, 58.248242, 5.91, 1.365, 122.55462, 25.844481, 6.44, 1.42,
  122.5857, -49.237347, 6.46, -0.14, 122.61327, 25.507334, 5.73, 0.825, 122.665965, -13.799207, 5.53, 0.488,
  122.74535999999999, 14.629474, 6.22, 0.01, 122.75701500000001, -37.292372, 6.42, -0.045, 122.79498000000001, -48.461994, 5.83, -0.146,
  122.81794500000001, -12.926999, 4.72, 0.939, 122.81916, 9.82123, 6.08, -0.104, 122.82525, 54.540238, 6.48, 0.94,
  122.83956, -39.618545, 4.44, 1.59, 122.85789, -42.987278, 4.73, 0.164, 122.88751500000001, -7.772539, 5.36, 0.892,
  122.99986500000001, -46.644351, 5.77, 0.626, 123.02524499999998, -43.40044, 6.48, 1.704, 123.053025, 17.647771, 4.67, 0.531,
  123.12831, -46.264285, 6, -0.113, 123.20328, 68.474072, 5.34, 1.037, 123.214815, -37.92447, 6.4, 0.108,
  123.24888, 16.51432, 6.03, 0.89, 123.28694999999999, 29.656536, 5.62, -0.073, 123.333195, -15.788221, 4.99, 1.066,
  123.34072500000002, -1.165885, 6.48, 0.918, 123.37299, -35.899518, 4.78, -0.11, 123.39267000000001, -50.196072, 5.52, 1.651,
  123.40065000000001, -46.991628, 5.14, -0.139, 123.421125, -33.569528, 6.38, 1.141, 123.44022, -46.578684, 6.49, -0.159,
  123.459105, 56.452246, 5.88, 1.016, 123.492975, -36.322281, 5.09, -0.184, 123.49458, -36.340777, 6.11, -0.185,
  123.51214499999999, -40.34789, 4.42, 1.17, 123.545985, -32.140711, 6.07, -0.159, 123.54642, 17.675955, 6.47, 0.331,
  123.555255, -35.490019, 5.77, 1.024, 123.587475, 13.048296, 6.39, 1.034, 123.599475, -45.834522, 5.86, -0.176,
  123.713505, -46.485892, 6.45, -0.149, 123.816405, -62.915643, 5.16, 0.086, 123.846915, -50.449222, 6.44, 1.52,
  123.96046499999999, 60.380602, 6.43, 0.21, 123.96893999999999, -30.925944, 6.22, 0.777, 123.9951, -35.903191, 6.15, 1.549,
  124.12884000000001, 9.185545, 3.53, 1.481, 124.22480999999999, 84.057642, 6.45, 0.052, 124.346385, -16.285111, 6.32, 0.057,
  124.38187500000001, 8.86631, 6.28, 0.98, 124.442295, -36.067591, 6.42, 1.446, 124.46007, 59.571133, 5.63, 0.182,
  124.48234500000001, -59.166825, 6.47, 0.397, 124.49283, -30.003697, 6.43, 1.04, 124.56008999999999, 15.67792, 6.42, 1.018,
  124.56581999999999, 54.143696, 6.26, 1.558, 124.57247999999998, -35.451703, 5.59, 1.246, 124.578285, -65.613192, 5.06, 1.129,
  124.599765, -12.632173, 5.95, 0.754, 124.630545, -76.919722, 4.05, 0.413, 124.63887, -36.659288, 4.44, 0.222,
  124.77328499999999, -48.197853, 6.45, -0.131, 124.81284, -10.165754, 6.31, 0.329, 124.82155499999999, 62.507159, 5.73, 0.891,
  124.87297500000001, -34.590137, 6.44, -0.079, 124.88430000000001, 75.756907, 5.55, 0.902, 124.95410999999999, -71.514906, 5.33, -0.063,
  124.95777, 3.948032, 6.04, 0.964, 125.00229000000002, -71.505377, 5.63, -0.099, 125.01608999999999, 27.217707, 5.13, 0.487,
  125.05416000000001, -0.909314, 6.18, 0.607, 125.070915, -5.32993, 6.12, 1.329, 125.08736999999999, 20.747721, 5.8, 1.137,
  125.10846000000001, 57.743278, 5.89, 0.421, 125.11395, -22.92468, 6.12, 1.039, 125.121345, 53.574092, 6.5, 0.3,
  125.1339, 24.022314, 5.92, -0.039, 125.161725, -77.484477, 4.34, 1.161, 125.167995, 72.407232, 6, 1.537,
  125.281845, -64.106002, 6.11, 0.93, 125.30041499999999, -57.97322, 5.96, -0.092, 125.33769, -36.484177, 5.18, -0.187,
  125.338425, -20.079058, 5.58, 0.771, 125.34595499999999, -33.054366, 4.83, 1.419, 125.35077000000001, -39.620714, 6.15, 0.172,
  125.477535, -17.586334, 5.71, 1.05, 125.51876999999999, -73.399985, 5.28, 0.014, 125.53970999999999, 74.820364, 6.4, 1.022,
  125.62568999999999, -6.179158, 6.14, 0.227, 125.62853999999999, -59.509483, 1.86, 1.196, 125.63206499999998, -48.490381, 4.79, -0.146,
  125.683605, 60.631236, 6.42, 0.969, 125.6952, -13.054793, 6.13, 0.997, 125.70806999999999, -26.34822, 5.88, 0.379,
  125.70881999999999, 43.188131, 4.25, 1.55, 125.725395, -7.54312, 5.92, 1.635, 125.72986499999999, -52.12373, 5.89, 0.018,
  125.82055500000001, -38.286079, 6.28, 1.613, 125.84100000000001, 18.3322, 5.94, 0.175, 125.95213499999998, 53.219712, 5.52, 0.125,
  125.98004999999999, 10.632063, 6.11, 1.507, 126.08455500000001, -80.914202, 5.67, 1.018, 126.137895, 82.430759, 6.28, 0.035,
  126.14588999999998, -3.75124, 5.61, 0.478, 126.151815, -4.717, 6.03, 0.46, 126.178215, 42.005242, 6.02, 1.591,
  126.22992, -23.153745, 5.67, 0.066, 126.238365, -42.769834, 5.97, -0.159, 126.26559000000002, -24.046212, 5.32, 1.476,
  126.27036000000001, 35.011409, 6.08, 1.261, 126.32917499999999, -21.045956, 6.01, 0.402, 126.38054999999999, -51.727415, 5.18, -0.164,
  126.39807000000002, 2.102209, 5.74, 1.528, 126.41401499999999, -17.439405, 6.44, 1.234, 126.41514, -3.906424, 3.91, -0.012,
  126.434265, -66.13689, 3.77, 1.132, 126.45784500000002, 17.046267, 6.11, 0.448, 126.46502999999998, -64.600618, 5.95, 0.971,
  126.46630499999999, -42.153072, 5.45, -0.142, 126.47819999999999, 7.564506, 5.13, 0.934, 126.48161999999999, -14.929661, 5.96, 0.167,
  126.573885, -39.058956, 6.07, -0.009, 126.605085, -52.8075, 6.05, 0.062, 126.61336500000002, -3.987479, 5.6, 0.218,
  126.61545, 27.893583, 5.58, 1.421, 126.67480499999999, -12.534602, 5.52, 1.167, 126.683085, 12.654612, 5.56, 1.608,
  126.69612, 26.935489, 6.3, 0.187, 126.74074499999999, -52.70495, 6.49, 0.419, 126.818415, -31.672734, 6.33, 0.897,
  126.8199, -70.093482, 5.51, -0.024, 126.90254999999999, -53.08848, 5.08, 0.256, 126.90328500000001, 45.652987, 6.32, 0.624,
  126.99759000000002, -35.113761, 5.75, -0.151, 127.082445, -8.81628, 6.43, 1.197, 127.12147499999999, -2.517126, 6.42, 0.332,
  127.15017, -23.070981, 6.5, 0.06, 127.15326, 24.144934, 6.05, 0.246, 127.15558499999999, 14.210822, 5.94, 0.201,
  127.21251, -9.748582, 6.01, 0.427, 127.26981, -47.928923, 5.33, -0.14, 127.28154, -44.160413, 5.82, -0.16,
  127.36452000000001, -44.724812, 5.03, -0.168, 127.37419499999999, -54.211761, 6.44, -0.108, 127.40163, -55.190936, 6.36, 0.799,
  127.440165, -46.331693, 5.98, -0.127, 127.44272999999998, 67.297441, 5.89, 0.972, 127.56646500000001, 60.718169, 3.35, 0.856,
  127.61922000000001, -32.159285, 5.61, 1.509, 127.66346999999999, -44.73732, 6.3, -0.007, 127.79429999999999, -47.86662, 6.39, -0.147,
  127.83319500000002, 37.264942, 6.18, -0.039, 127.85290499999999, -39.06411, 6.31, -0.133, 127.87324500000001, -54.39401, 6.34, 1.298,
  127.87717500000001, 24.081105, 5.71, 0.327, 127.878855, -19.577462, 5.42, -0.061, 127.89888000000002, 18.09442, 5.33, 1.567,
  127.92207, 18.987732, 6.5, 1.496, 128.02068, -53.21192, 5.68, 0.582, 128.139, -15.030143, 6.38, 0.275,
  128.13934500000002, 53.114848, 6.23, 1.008, 128.166135, 10.066008, 6.48, -0.007, 128.16877499999998, -47.042108, 6.49, 1.293,
  128.174355, -73.35679, 6.11, 0.946, 128.177085, 20.441162, 5.33, 1.252, 128.215035, -31.500853, 6.38, 0.78,
  128.222025, 69.319901, 6.31, 1.36, 128.22915, 38.016368, 5.88, 1.106, 128.24375999999998, -34.634039, 6.36, 0.951,
  128.25045, 24.08479, 6.35, 1.032, 128.25775499999997, -45.752906, 6.36, -0.119, 128.27019, -24.60696, 6.19, 0.27,
  128.332755, -38.370676, 6.48, -0.153, 128.34063, 36.436429, 6.2, 0.402, 128.37615, -46.970661, 6.25, 1.56,
  128.41014, -38.848815, 5.92, -0.114, 128.43115500000002, 4.757, 5.89, 1.066, 128.437695, 13.257311, 6.26, 1.179,
  128.50674, -2.151555, 5.8, 0.007, 128.555625, 8.452339, 6.04, 0.332, 128.621895, -37.611169, 6.28, 1.562,
  128.62377, -27.098161, 6.4, 1.429, 128.6331, -32.598744, 6.41, 0.752, 128.650665, 65.14517, 5.47, 0.207,
  128.68167, -49.944203, 5.01, 1.304, 128.68287, 36.419619, 5.76, 0.051, 128.80218, -39.970452, 6.44, 0.578,
  128.81486999999998, -58.224735, 5.27, -0.133, 128.83200000000002, -58.009228, 4.84, 0.981, 128.85399, 2.743449, 6.35, 1.023,
  128.86749, -7.982292, 5.72, -0.004, 128.869605, -26.843487, 5.95, 0.393, 128.96239500000001, 6.62022, 5.91, 0.53,
  128.966805, -50.969651, 5.79, -0.132, 129.03213, 15.313632, 6.33, 0.338, 129.203205, 74.723677, 6.31, 0.308,
  129.27405000000002, 9.65558, 5.92, 0.083, 129.3285, -62.853465, 5.45, 1.013, 129.363225, -4.933999, 6.18, 1.054,
  129.410985, -42.989081, 4.11, 0.109, 129.41403, 5.703782, 4.14, 0.003, 129.46731, -26.255, 5.24, -0.03,
  129.579105, 32.802021, 5.96, 1.111, 129.59256000000002, 53.401539, 5.66, 0.964, 129.66789, -19.736904, 6.32, 1.592,
  129.68673, -53.090381, 6.45, -0.1, 129.689325, 3.341435, 4.45, 1.216, 129.74958, 52.925079, 6.34, 1.319,
  129.77141999999998, -70.386745, 5.19, 0.013, 129.78297, -22.661875, 5.05, 0.72, 129.79202999999998, 59.939126, 6.47, 0.035,
  129.798855, 65.020907, 5.63, 0.618, 129.80508, -60.317289, 6.35, -0.002, 129.82347, 52.711623, 5.91, 1.167,
  129.84215999999998, -36.606685, 6.12, 0.426, 129.84939, -53.439767, 5.45, -0.132, 129.852315, 8.0176, 6.46, 1.08,
  129.926985, -29.561084, 4.86, 0.9, 129.927615, 73.629678, 6.16, 1.017, 129.99003000000002, -53.054729, 5.18, -0.147,
  130.00614, -12.475372, 4.98, 1.415, 130.025595, -35.308352, 3.97, 0.936, 130.02675, 20.007788, 6.39, 0.98,
  130.0536, 64.327936, 4.59, 1.179, 130.072815, -53.015398, 5.56, -0.125, 130.07331, -52.921887, 3.6, -0.168,
  130.07621999999998, 31.941898, 6.21, 0.401, 130.07994, -40.263875, 5.2, -0.027, 130.09203000000002, 19.669938, 6.42, 1.02,
  130.11255, 19.544808, 6.29, 0.17, 130.146915, -45.191103, 5.67, 1.664, 130.154295, -59.761003, 4.31, -0.117,
  130.15654500000002, -46.648744, 3.77, 0.67, 130.181415, -57.54549, 6.34, 0.208, 130.254435, 45.83401, 5.35, 0.993,
  130.27218000000002, -48.92268, 5.9, -0.186, 130.30473, -47.317125, 4.74, 0.137, 130.331595, -78.963359, 5.46, -0.101,
  130.430565, -15.943384, 4.87, 1.063, 130.48713, -45.410714, 5.2, 0.171, 130.54089, -11.966008, 6.46, 0.16,
  130.56747, -48.09909, 5.48, -0.172, 130.57917, -53.100056, 5.49, -0.127, 130.586895, -55.774557, 6.26, 1.178,
  130.60581, -53.113984, 4.83, -0.173, 130.737495, -35.943301, 6.42, 0.019, 130.750695, 46.900845, 6.21, 0.981,
  130.801215, -79.070082, 6.05, 0.229, 130.801365, 12.680876, 5.62, 0.435, 130.80615, 3.398662, 4.3, -0.192,
  130.82146500000002, 21.468501, 4.66, 0.01, 130.898085, -33.186385, 3.68, -0.18, 130.91781, -49.822802, 5.15, -0.197,
  130.91823, -7.23373, 4.63, 0.84, 130.97636999999997, -68.21158, 6.33, 1.501, 130.99908, 4.334558, 6.37, -0.04,
  131.099805, -42.649276, 4.05, 0.874, 131.12505, -65.825429, 6.03, 0.217, 131.17125, 18.154309, 3.94, 1.083,
  131.175885, -54.708821, 1.93, 0.043, 131.18766, 10.08167, 5.63, -0.069, 131.21636999999998, -37.147249, 5.74, -0.139,
  131.229795, -21.167826, 6.1, 0.195, 131.25534, 5.680588, 6.13, 0.2, 131.273115, -58.724319, 6.2, -0.083,
  131.33653500000003, -2.601062, 6.41, 0.521, 131.33926499999998, 30.697752, 6.12, 0.935, 131.395275, 4.664376, 6.45, 1.228,
  131.45535, -25.388088, 6.07, 0.084, 131.480085, -79.504373, 5.79, 1.595, 131.50686000000002, -46.041527, 3.87, 0.015,
  131.51030999999998, -2.048655, 5.7, 1.097, 131.52864, -11.006768, 6.22, 1.608, 131.59390499999998, -13.54772, 4.32, 0.9,
  131.599005, -41.125389, 6.21, -0.05, 131.62728, -45.912504, 5.43, 0.238, 131.67426, 28.759898, 4.03, 1.007,
  131.677305, -56.769776, 4.5, -0.169, 131.693805, 6.418809, 3.38, 0.685, 131.705175, -34.622945, 6.33, -0.127,
  131.733405, 12.109952, 5.89, 0.12, 131.81244, -1.897033, 5.28, 0.058, 131.82852, -46.155415, 5.71, 0.554,
  131.839455, -17.052878, 6.48, 0.679, 131.91831, -41.736792, 6.35, 0.578, 132.00096000000002, -52.850151, 6.29, -0.097,
  132.02032499999999, -6.558839, 6.09, 1.282, 132.03657, -42.463446, 6.43, -0.178, 132.060945, -28.6388, 6.42, 1.364,
  132.10821, 5.837812, 4.35, -0.044, 132.156045, -1.044836, 6.42, 1.142, 132.20529000000002, 66.708083, 6.2, -0.106,
  132.34053, -3.443023, 5.3, -0.08, 132.41317500000002, -40.320158, 5.47, 0.066, 132.437265, -21.04844, 6.48, 0.256,
  132.4485, -45.307875, 4.94, 0.043, 132.458895, -72.55124, 6.1, 0.185, 132.46457999999998, -32.780525, 5.19, 0.876,
  132.46818000000002, -39.141603, 6.38, 0.249, 132.50929499999998, -29.462997, 5.86, 0.948, 132.58758, -42.089791, 6, -0.114,
  132.59016, -28.617619, 6.17, -0.055, 132.63306, -27.709844, 4.02, 1.272, 132.63429, 33.285052, 6.22, 0.549,
  132.63942, -46.529187, 5.09, -0.205, 132.64472999999998, -66.792981, 5.34, 0.423, 132.68802, 18.832183, 6.41, 0.009,
  132.75610500000002, 15.350651, 6.36, 0.669, 132.89338500000002, -7.177226, 5.55, 0.15, 132.902175, -57.633577, 5.59, -0.102,
  132.958485, -44.150931, 6.38, -0.15, 132.98164500000001, -40.986584, 6.49, -0.106, 132.98680499999998, 43.726603, 5.15, 0.971,
  133.041795, 42.002735, 5.98, 1.251, 133.04904, 45.312819, 5.96, 1.233, 133.10076, 5.340311, 6.34, 0.122,
  133.108905, -32.509322, 6.49, 1.451, 133.11912, 28.259159, 6.25, 1.552, 133.12818, -13.232942, 6.12, 1.142,
  133.14426, 32.474157, 5.67, 0.224, 133.14937500000002, 28.330819, 5.96, 0.869, 133.160865, -48.359097, 5.92, -0.148,
  133.16124, -36.545342, 6.41, 0.549, 133.170075, -52.128906, 6.39, 0.003, 133.200075, -38.724086, 5.79, 1.508,
  133.26578999999998, -56.649485, 6.02, -0.023, 133.27215, -16.952471, 6.43, 1.082, 133.274745, 59.05614, 6.35, 0.414,
  133.344015, 61.962268, 5.72, 0.305, 133.452765, -60.353909, 5.78, -0.088, 133.46081999999998, -47.520778, 5.31, 0.275,
  133.46149499999999, -40.447542, 6.42, 0.96, 133.48201500000002, 35.538294, 6.14, 0.059, 133.561365, 30.579115, 5.4, 1.05,
  133.57478999999998, -5.434459, 6.01, 0.661, 133.725165, -58.239658, 6.36, -0.086, 133.761855, -60.644609, 3.84, -0.104,
  133.79904, -54.965768, 5.7, 0.481, 133.801785, -18.241189, 5.75, 1.327, 133.83003000000002, -45.04167, 6.26, -0.152,
  133.84533, 17.231276, 6.28, 2.975, 133.84845, 5.945563, 3.11, 0.978, 133.873365, -7.971153, 6.07, 0.22,
  133.88151, -27.681871, 4.87, 0.142, 133.91533500000003, 27.927481, 5.23, 1, 133.97702999999998, -15.439536, 6.47, 1.393,
  133.981455, 11.626023, 5.44, 1.462, 133.98293999999999, -23.818303, 6.39, 0.157, 134.08029000000002, -52.723475, 4.68, -0.115,
  134.12721000000002, 40.201474, 5.9, 0.378, 134.142195, -16.708748, 5.95, 1.544, 134.15433, 4.236581, 6.13, 1.001,
  134.156115, 64.603831, 5.57, 0.877, 134.17423499999998, -85.663152, 5.43, 0.306, 134.20827, 45.631646, 5.72, 1.125,
  134.23584, 32.91043, 5.44, 0.181, 134.24343, -59.229338, 4.93, -0.182, 134.28449999999998, 17.143751, 6.17, 1.001,
  134.31228000000002, 15.322762, 5.22, 0.149, 134.396655, 15.581281, 5.68, 0.209, 134.425095, 9.387764, 6.19, 0.984,
  134.48151000000001, -48.57291, 5.88, 1.06, 134.494425, 30.233826, 6.25, 0.474, 134.62176, 11.857701, 4.26, 0.141,
  134.683035, -16.132727, 5.8, 0.521, 134.71824, -47.234688, 5.17, 0.268, 134.79471, 18.134867, 6.3, 1.511,
  134.80241999999998, 48.041826, 3.12, 0.223, 134.815935, -28.806017, 6.24, 0.997, 134.85117, -59.083712, 5.17, 0.417,
  134.86201499999999, 13.074391, 6.49, 1.462, 134.886075, 32.418559, 5.23, 0.913, 134.91631500000003, -19.208036, 6.19, 0.461,
  135.022575, -41.253605, 4.45, 0.646, 135.092745, -43.173991, 6.04, -0.154, 135.12834, 37.604353, 6.21, 1.572,
  135.160275, 41.782911, 3.96, 0.463, 135.190605, -60.963828, 5.8, 1.211, 135.285405, -68.683916, 5.89, 1.634,
  135.29757, -26.663716, 6.2, 1.137, 135.33693000000002, -41.864254, 5.56, -0.135, 135.350535, 32.252296, 5.89, 0.088,
  135.380775, 5.640986, 6.08, 1.111, 135.41986500000002, 39.713518, 6.39, 0.314, 135.43569, -52.188685, 5.23, -0.12,
  135.45351, 27.902593, 6.07, 0.243, 135.49161, -0.482673, 5.64, 1.163, 135.52665, -39.402164, 6.25, 1,
  135.611655, -66.396076, 4, 0.145, 135.6363, 67.629619, 4.74, 1.542, 135.684435, 24.452915, 5.45, -0.041,
  135.686745, 7.298267, 5.85, 1.1, 135.772245, -53.550372, 6.39, -0.074, 135.906405, 47.156525, 3.57, 0.007,
  136.00167, 54.283887, 5.74, 0.034, 136.024095, -47.44145, 6.46, -0.155, 136.03872, -47.097737, 3.75, 1.174,
  136.199925, -57.852573, 6.43, 0.288, 136.22952, 32.376833, 6.46, 0.241, 136.286775, -72.602705, 4.47, 0.607,
  136.35042, 48.530314, 5.48, 0.475, 136.40991, -70.538497, 4.66, -0.149, 136.49319, 5.092316, 4.99, 1.189,
  136.531755, -64.499849, 6.37, 1.361, 136.632375, 38.452215, 4.56, 1.037, 136.64181, -55.802411, 6.1, -0.132,
  136.67979, 59.34452, 6.44, 0.045, 136.74975, 1.462694, 6.16, 1.648, 136.862145, 22.980872, 6.39, 0.453,
  136.936725, 10.668191, 5.23, -0.092, 136.99902, -43.432589, 2.23, 1.665, 137.00021999999998, 29.654235, 5.42, 0.888,
  137.011995, -25.858536, 4.62, 1.594, 137.01735, 32.540399, 6.47, 0.375, 137.098005, 66.873235, 5.15, 1.514,
  137.17575, -8.589524, 5.6, -0.057, 137.18139000000002, -26.767598, 6.15, 0.17, 137.185515, -16.277321, 6.48, 1.1,
  137.197245, 26.629112, 5.95, 0.654, 137.21289, 33.882217, 5.95, 0.585, 137.217945, 51.604648, 4.46, 0.288,
  137.26755, -18.328548, 5.73, 0, 137.29797, -12.357706, 5.76, 0.937, 137.33973, 22.045446, 5.16, 0.97,
  137.3982, -8.787648, 5.47, 1.002, 137.437485, -49.424383, 6.48, 0.17, 137.44344, 11.564377, 6.48, 0.355,
  137.48505, -30.365401, 5.59, 0.179, 137.487915, -52.082861, 6.19, 1.023, 137.586915, 21.996415, 6.04, 0.89,
  137.59806, 67.134018, 4.8, 0.489, 137.66165999999998, 30.963139, 6.04, 1.373, 137.729115, 63.513633, 4.67, 0.381,
  137.74206, -58.966896, 3.43, -0.19, 137.76834000000002, -44.867902, 4.99, 0.222, 137.80297499999998, 80.828909, 6.37, 0.385,
  137.819775, -62.316977, 3.96, -0.18, 137.889105, -46.583911, 5.78, -0.218, 137.92056, -39.258845, 6.05, -0.108,
  137.98180499999998, 5.468629, 6.34, 0.328, 137.99475, -19.747628, 5.72, 0.977, 138.05121, -76.663028, 6.13, 1.09,
  138.05367, 3.866978, 6.14, -0.01, 138.07317, 14.996037, 6.49, 0.731, 138.10851, -7.109827, 6.1, 0.232,
  138.1272, -43.613262, 5.56, -0.107, 138.210915, -60.916769, 6.36, -0.044, 138.23178000000001, -59.413928, 5.54, 0.846,
  138.300615, -69.717208, 1.67, 0.07, 138.32778, -42.27329, 6.27, 1.25, 138.33978, -29.664369, 6.38, 1.6,
  138.357585, -38.616471, 6.31, 0.018, 138.393585, -47.338407, 5.92, -0.051, 138.405255, 21.283206, 6.48, 0.046,
  138.450885, 43.217825, 5.3, -0.13, 138.51288, -14.694842, 6.46, 0.958, 138.534225, -44.145822, 5.85, -0.113,
  138.57502499999998, -55.569629, 5.26, 0.98, 138.58561500000002, 61.423318, 5.18, 0.605, 138.591075, 2.31428, 3.89, -0.06,
  138.60204, -43.227493, 5.24, -0.137, 138.738195, -37.602396, 5.85, 0.827, 138.80772, 14.941507, 5.36, 1.319,
  138.809445, 34.633516, 5.98, 0.839, 138.81099, -45.555498, 6.25, -0.07, 138.82353, -58.388377, 6.02, -0.101,
  138.838575, 84.181013, 6.3, 0.339, 138.85395, -15.024908, 6.32, 0.013, 138.894675, -57.577742, 6.32, 1.037,
  138.903, -38.569942, 4.92, 1.084, 138.93783000000002, -37.413144, 4.63, 0.473, 138.95748, 56.741406, 5.28, 1.568,
  138.96958500000002, 72.946326, 5.93, 0.179, 139.01679, -44.898723, 6.02, 0.269, 139.04711999999998, 54.021857, 4.8, 0.199,
  139.05035999999998, -57.541473, 4.34, 1.602, 139.09599, -44.265735, 5.12, 1.636, 139.17237, -8.744759, 5.49, -0.081,
  139.1739, -6.353144, 5.24, 1.172, 139.23771000000002, -11.103111, 6.45, 1.172, 139.237845, -39.401539, 5.31, 1.166,
  139.27257, -59.275229, 2.21, 0.189, 139.28216999999998, -14.574069, 5.83, 1.049, 139.322235, -68.689642, 5.38, 0.415,
  139.35501, -74.894313, 5.28, 0.021, 139.365075, -74.734591, 5.86, -0.024, 139.379895, 46.817228, 5.96, 0.063,
  139.42623, -54.494829, 6.33, 1.403, 139.463985, 11.501146, 6.4, 0.095, 139.46526, -67.050868, 6.14, 1.254,
  139.524495, -51.050859, 5.26, -0.062, 139.607985, 35.36408, 5.94, 0.177, 139.67649, -51.560651, 5.83, 0.474,
  139.711035, 36.802597, 3.82, 0.066, 139.885335, -55.186471, 6.28, -0.099, 139.88805, -15.834663, 5.79, 1.285,
  139.943265, -11.974853, 4.77, 0.927, 139.94973, -34.103339, 6.4, -0.087, 139.98234, 74.016601, 6.42, 1.05,
  140.12090999999998, -9.555695, 4.8, 0.913, 140.12364, -37.581688, 6.04, 1.396, 140.18239499999999, 51.266066, 6.14, 0.436,
  140.231235, -15.617826, 6.3, 0.468, 140.236755, -62.404632, 4.79, 0.926, 140.24742, 38.188262, 6.12, 0.38,
  140.263875, 34.392562, 3.14, 1.55, 140.348355, 45.370101, 6.4, 1.305, 140.36325, 32.902151, 6.16, 1.097,
  140.3733, -25.965439, 4.71, 1.633, 140.43039, 56.699219, 5.79, 1.511, 140.458635, -55.514686, 5.61, 0.19,
  140.4624, -42.19486, 5.56, 1.637, 140.52843000000001, -55.010668, 2.47, -0.141, 140.599965, -46.047445, 5.74, 0.903,
  140.801085, -28.833873, 4.71, 0.892, 140.855715, -48.286942, 6.27, -0.144, 140.86386, -60.302314, 6.3, 1.477,
  140.88243, 25.18284, 6.41, 0.856, 140.91567, -46.90875, 6.21, -0.093, 140.936985, -37.7569, 6.47, 0.193,
  140.99724, -51.73708, 6.05, 0.528, 141.02289000000002, -61.648902, 5.99, 1.06, 141.0402, -80.786876, 5.34, 0.454,
  141.06784499999998, -39.425502, 6.05, 0.193, 141.154725, -70.075779, 6.45, 1.275, 141.16359, 26.182324, 4.47, 1.222,
  141.23194500000002, 51.573896, 6.3, 0.774, 141.28278, -43.976603, 6.31, 1.526, 141.350145, -5.117394, 5.6, 1.523,
  141.363795, -61.950476, 5.77, 0.137, 141.385425, 16.585588, 6.31, 0.968, 141.43408499999998, 63.940939, 6.24, 1.465,
  141.57486, -53.378909, 5.09, -0.102, 141.59295, -1.464078, 6.01, 1.313, 141.61857, -40.501706, 6.19, 0.251,
  141.68394, -64.929701, 6.05, 0.147, 141.68708999999998, -28.787696, 6.12, -0.089, 141.77682000000001, -71.601895, 5.46, 1.079,
  141.82665, -22.343783, 4.72, 1.154, 141.89685, -8.658603, 1.99, 1.44, 141.94492499999998, -6.071187, 5.38, 0.642,
  141.954765, -71.781101, 6.33, 0.413, 141.96507, 75.098341, 6.2, 0.115, 142.11417, 9.056778, 5.4, 0.605,
  142.121565, 8.188298, 5.72, 1.045, 142.12740000000002, -66.701877, 5.9, 0.012, 142.16662499999998, 45.601483, 5.4, 0.993,
  142.196445, -62.273134, 5.91, 1.102, 142.25958, -1.256913, 6.27, 0.274, 142.287075, -2.768964, 4.59, 0.411,
  142.30267500000002, -20.749127, 5.66, 1.587, 142.311345, -35.951335, 4.51, 1.408, 142.317465, -38.403542, 6.15, 0.216,
  142.351845, -2.205172, 6.14, 0.222, 142.38507, -4.246636, 6.25, 0.838, 142.44913499999998, 55.745233, 6.5, 0.394,
  142.457805, -23.345342, 6.26, 1.559, 142.47711, -26.589616, 5.49, 1.345, 142.52131500000002, -51.517164, 5.45, -0.078,
  142.59369, -15.577352, 5.86, 1.193, 142.59765000000002, -58.361839, 5.88, 1.676, 142.67511, -40.466769, 3.6, 0.371,
  142.68009, 33.655711, 5.87, 1.032, 142.69206, -31.889222, 5.75, 0.066, 142.805565, -57.034377, 3.16, 1.538,
  142.881795, 63.061861, 3.65, 0.36, 142.884015, -31.871831, 5.91, 0.258, 142.88506500000003, 35.103273, 5.39, 1.543,
  142.88760000000002, -35.71475, 5.86, 1.287, 142.88765999999998, -66.719026, 6.27, 1.348, 142.90128, -73.080913, 5.46, 1.556,
  142.912455, -10.552013, 6.13, 0.261, 142.930125, 22.967971, 4.32, 1.541, 142.98213, -10.370341, 6.12, 1.183,
  142.98641999999998, 11.299827, 4.99, 1.046, 142.9899, 9.715767, 5.07, 1.364, 142.99553999999998, -1.184664, 4.54, 0.109,
  143.07664499999998, -28.627769, 6.43, 0.358, 143.08032, -40.649335, 5.35, 0.897, 143.08504499999998, -19.400303, 5.74, 0.135,
  143.17248, 1.864151, 6.11, 0.614, 143.215725, 51.6773, 3.17, 0.475, 143.23239, -13.516804, 5.95, 1.501,
  143.25822, -8.505374, 6.12, 0.974, 143.282025, -39.129073, 6.43, 0.337, 143.29689000000002, 45.513758, 6.49, 1.141,
  143.301915, -21.115722, 5.02, 1.023, 143.32623, 28.36794, 6.5, 0.128, 143.332935, -7.190204, 6.25, 1.17,
  143.35855500000002, -22.863883, 5.92, 0.023, 143.376495, 36.486949, 6.19, 1.264, 143.43561, -49.005072, 5.12, -0.114,
  143.472855, -80.941258, 5.07, -0.139, 143.496435, 23.453919, 6.26, 1.453, 143.53665, -51.255266, 5.01, -0.18,
  143.55576000000002, 36.397558, 4.54, 0.914, 143.611065, -59.229753, 4.08, -0.013, 143.620545, 69.830343, 4.54, 0.781,
  143.63603999999998, -5.914948, 5.56, 1.159, 143.706075, 52.051477, 4.47, 0.027, 143.72262, 72.205679, 5.77, 0.53,
  143.765985, 39.621493, 4.81, 0.992, 143.7993, -35.82375, 6.48, 0.417, 143.89084499999998, -19.583394, 6.33, 0.069,
  143.91501, 35.810133, 5.4, 0.77, 143.97036, 14.379588, 6.32, 0.027, 144.02826, 74.318805, 6.46, -0.083,
  144.10587, -48.751179, 6.18, 0.277, 144.17854499999999, 31.161734, 5.57, 1.594, 144.19307999999998, -52.94367, 6.18, 1.051,
  144.20658, -49.355026, 4.34, 0.173, 144.250875, -25.296759, 5.68, 1.116, 144.26076, 16.437952, 5.73, 1.223,
  144.27226499999998, 81.326382, 4.28, 1.488, 144.291195, -32.178646, 5.62, 1.023, 144.30276, -53.668508, 5.44, 0.137,
  144.302775, 6.835802, 5, 1.051, 144.36835499999998, -36.095994, 5.96, 1.118, 144.40632, 60.213682, 6.41, 0.921,
  144.441405, -3.170642, 6.45, 0.986, 144.46461, -9.424446, 6.4, -0.04, 144.484425, 73.080394, 6.39, 0.352,
  144.50604, -43.190944, 5.51, 0.985, 144.590745, 40.239793, 5.28, 0.223, 144.61369499999998, 4.649293, 4.68, 1.31,
  144.837585, -61.32806, 4.51, -0.07, 144.86625, 67.27223, 5.96, 1.528, 144.93806999999998, -62.942923, 6.4, -0.084,
  144.94754999999998, -10.570271, 6.31, -0.029, 144.96400500000001, -1.14281, 3.9, 1.313, 145.07652000000002, -14.332292, 5.07, -0.149,
  145.083615, -10.769185, 6.37, 0.083, 145.17741, -57.983553, 5.3, 0.195, 145.25895, -57.259542, 5.8, 1.083,
  145.287645, 9.892308, 3.52, 0.516, 145.319775, 55.866491, 6.5, 1.15, 145.32086999999999, -23.591514, 4.76, -0.117,
  145.396305, 31.277817, 5.9, 1.579, 145.41036, 25.912876, 6.26, 1.251, 145.44971999999999, -55.213762, 5.99, -0.119,
  145.50147, 39.757851, 5.61, 0.951, 145.55407499999998, -66.91482, 6.33, 0.075, 145.56016499999998, -23.915569, 4.93, 0.534,
  145.562055, 69.237537, 5.72, 1.131, 145.672305, -35.501709, 6.39, -0.053, 145.678095, 35.093371, 6.12, 0.386,
  145.679595, 48.431, 6.36, 0.01, 145.738425, 72.252618, 5.15, 1.029, 145.779075, 54.363703, 6.5, 0.121,
  145.86496499999998, -51.228136, 6.15, -0.098, 145.88859, 29.974473, 5.64, 0.111, 145.92609, -53.891282, 5.56, -0.042,
  145.93293, 14.021692, 5.36, 1.61, 146.05041, -27.769471, 4.78, 0.516, 146.12502, 18.863492, 6.49, 1.158,
  146.15247000000002, 64.984112, 6.18, 0.419, 146.311755, -62.507903, 3.69, 1.01, 146.341695, -30.20275, 6.45, -0.137,
  146.379015, 78.134709, 6.25, 1.353, 146.41929, -57.186041, 6.47, -0.108, 146.46282000000002, 23.774255, 2.97, 0.808,
  146.48235, -58.793828, 6.22, 0.461, 146.541855, 6.708556, 5.8, 1.639, 146.58527999999998, -76.77612, 5.43, 0.901,
  146.597205, 11.810043, 5.67, 1.489, 146.598375, 1.785586, 5.65, 0.342, 146.62656, -44.75506, 5.58, -0.176,
  146.63192999999998, 57.12807, 5.09, 1.594, 146.77554, -65.072007, 2.92, 0.273, 146.82549, 79.13668, 6.09, 0.303,
  146.84248499999998, 23.647686, 6.49, 1.093, 146.85819, 11.568165, 6.44, 0.255, 147.14715, 46.021008, 5.08, 0.619,
  147.16677, -56.41189, 6.05, 0.937, 147.36706500000003, -37.186765, 5.95, 1.245, 147.45873, 21.179422, 6.1, 0.257,
  147.463965, -36.268463, 6.36, 1.008, 147.48811500000002, -45.732736, 5.09, -0.098, 147.59847, 65.593226, 6.27, 0.29,
  147.625335, 4.34365, 6.24, 0.479, 147.67477499999998, -46.933923, 5.72, 1.085, 147.731625, -62.745116, 5.56, 1.316,
  147.748005, 59.038735, 3.78, 0.291, 147.75333, -80.061059, 6.47, 0.074, 147.758265, 13.066239, 6.45, 1.624,
  147.800205, -59.425774, 5.79, 1.354, 147.80847, -4.24335, 6.01, 0.171, 147.832215, -46.193871, 5.62, 1.166,
  147.84007499999998, -6.181928, 6.42, 0.577, 147.86955, -14.846603, 4.11, 0.918, 147.91947, -46.54762, 4.58, 1.172,
  147.921735, -11.340507, 6.48, 1.61, 147.97098, 24.395369, 5.29, 0.229, 147.998055, -16.534775, 6.08, 1.035,
  148.02649499999998, 54.064332, 4.55, 0.038, 148.04994, 0.07561, 6.34, 0.934, 148.05067499999998, 2.454131, 6.02, -0.04,
  148.126815, -8.10503, 5.07, 0.038, 148.19097, 26.006951, 3.88, 1.222, 148.241865, -27.332172, 6.28, 0.622,
  148.25039999999998, -55.373208, 6.5, -0.145, 148.428855, 5.958573, 5.9, 1.662, 148.458765, -51.146713, 5.95, -0.152,
  148.551375, -25.932345, 4.87, 1.199, 148.573575, -45.283516, 5.72, -0.114, 148.63257, -22.487456, 6.23, 0.052,
  148.71351, -50.243959, 5.71, 0.006, 148.717545, -19.00936, 4.94, 1.559, 148.76397, 61.116123, 6.29, 1.036,
  148.92918, 49.819843, 5.27, 0.086, 149.02223999999998, -40.824546, 6.39, 1.612, 149.04063000000002, -71.3893, 6.3, -0.056,
  149.09124, -51.336158, 6.39, -0.162, 149.108235, 8.933157, 5.85, 1.129, 149.14788, -33.418496, 5.83, 1.202,
  149.195205, -26.549672, 6.27, 0.219, 149.21562, -54.56779, 3.52, -0.067, 149.22539999999998, -27.475154, 6.32, 0.173,
  149.24928, -69.101804, 6.18, -0.1, 149.2956, -52.638783, 6.13, -0.115, 149.30664, 57.418196, 5.97, 0.895,
  149.42115, 41.055633, 5.11, 0.481, 149.427495, -48.414075, 6.06, -0.127, 149.43292499999998, -1.94175, 6.43, 0.7,
  149.48685, 45.414298, 6.34, 1.096, 149.53179, 8.313979, 6.05, 1.357, 149.55573, 12.4448, 5.26, -0.035,
  149.59528500000002, 72.879509, 5.86, 1.155, 149.60853, 27.758999, 6.48, 0.362, 149.71786500000002, -35.890973, 5.23, 0.3,
  149.776275, -23.95077, 6.11, -0.101, 149.900925, 29.645233, 5.75, 1.059, 149.965425, 56.811807, 5.5, 1.487,
  150.053355, 8.044223, 4.68, 1.589, 150.143955, -56.946108, 6.5, 0.979, 150.182865, -82.21467, 5.53, 0.035,
  150.25296, 31.923672, 5.37, 0.676, 150.29999999999998, -56.096559, 6.42, -0.013, 150.419655, -53.364115, 6.2, -0.137,
  150.49195500000002, -57.349789, 6.2, 1.108, 150.50041499999998, -60.42089, 5.93, 0.263, 150.703965, 21.949258, 5.68, -0.178,
  150.7059, -62.156667, 6.41, 1.688, 150.749775, -60.178675, 6.18, 0.175, 150.835785, -46.636191, 6.11, 0.041,
  150.8922, -61.88404, 6.14, -0.032, 150.920775, -9.573792, 6.09, 1.671, 151.01172, -18.101406, 6.3, -0.06,
  151.035135, 3.201055, 6.43, 0.398, 151.08729, -24.285534, 5.7, 0.303, 151.09736999999998, -39.975858, 6.42, 1.311,
  151.15138499999998, 53.891716, 5.71, 0.507, 151.25769, -51.31362, 6.23, -0.054, 151.28112, -13.064626, 4.6, -0.087,
  151.293285, 52.371302, 6.31, 0.135, 151.31367, -36.384381, 6.27, 1.112, 151.4205, 15.757506, 6.36, 0.387,
  151.530135, -52.187939, 6.5, 0.997, 151.546725, -47.369995, 5.06, 0.88, 151.69761, 5.611493, 6.2, 0.939,
  151.789575, -17.141733, 5.59, 1.49, 151.833135, 16.762664, 3.48, -0.031, 151.857315, 35.244693, 4.49, 0.19,
  151.898835, -48.26082, 6.4, -0.15, 151.97612999999998, 9.997508, 4.39, 1.448, 151.98450000000003, -0.371637, 4.48, -0.032,
  151.98597, -62.221416, 6.45, -0.095, 152.00689500000001, -37.333445, 6.34, 0.98, 152.066235, 31.604053, 6.23, 0.469,
  152.09298, 11.967207, 1.36, -0.087, 152.14332, 83.918372, 6.31, 1.549, 152.14761000000001, -15.611939, 6.25, -0.007,
  152.178345, -65.815438, 5.26, 0.973, 152.234355, -51.811261, 4.85, -0.12, 152.37579, -68.682779, 5.8, 0.015,
  152.38261500000002, -35.856771, 6.14, 0.615, 152.485365, -12.095305, 6.24, 0.184, 152.52453, -12.815923, 5.3, 0.368,
  152.531415, -8.40817, 5.91, 0.026, 152.647005, -12.354083, 3.61, 1.007, 152.65713, -41.715247, 5.98, 1.239,
  152.73275999999998, -8.418462, 5.64, 1.304, 152.74570500000002, 40.661608, 6.34, 1.277, 152.80326, 37.4019, 5.86, 1.282,
  152.82402000000002, -7.316626, 6.23, 0.026, 152.897805, -58.827762, 6.07, 1.647, 152.909205, 13.355114, 6.43, 0.468,
  152.9436, -58.060544, 5.7, -0.118, 153.011895, -28.605956, 6.28, 0.019, 153.095595, -52.163242, 6.16, 1.168,
  153.158205, -19.15304, 6.45, 0.494, 153.201525, 4.61468, 5.77, 1.178, 153.25482, -59.918088, 6.07, -0.072,
  153.33103499999999, -27.028891, 6.23, 0.316, 153.338295, -61.658829, 6.42, -0.111, 153.342915, -56.586697, 6.48, 1.45,
  153.34524, -51.232971, 5.27, 0.257, 153.35322, -33.031722, 6.38, 0.592, 153.36672000000002, -51.755788, 5.78, 0.136,
  153.37776, -66.372811, 5.15, 0.217, 153.434415, -70.037903, 3.29, -0.074, 153.441405, -40.346056, 5.91, 1.204,
  153.45711, 27.135819, 6.05, 0.844, 153.485685, -40.310774, 6.33, 0.94, 153.537345, -23.813946, 6.36, 1.639,
  153.62396999999999, 21.168058, 6.02, 0.573, 153.684105, -42.121942, 3.85, 0.051, 153.77643, 31.468066, 6.47, 0.858,
  153.781905, 59.985539, 6.18, 1.621, 153.81936, -54.974207, 6.16, -0.155, 153.836985, -36.517717, 6.17, 1.058,
  153.881505, -43.112369, 5.59, 1.52, 154.013475, -59.903411, 6.22, 0.194, 154.03749, -11.203419, 6.08, 1.096,
  154.06015499999998, 29.310501, 5.49, 0.02, 154.117035, 28.682479, 6.46, 0.635, 154.134585, 23.503095, 5.95, 0.655,
  154.167285, -51.204636, 6.2, 1.435, 154.169745, 13.728334, 5.42, 1.65, 154.17256500000002, 23.417311, 3.43, 0.307,
  154.17402, 25.370705, 5.84, 1.206, 154.2708, -61.332304, 3.39, 1.541, 154.27428, 42.914365, 3.45, 0.029,
  154.31067000000002, 23.10622, 5.81, 0.5, 154.334115, -46.834942, 6.48, 0.329, 154.40751, -8.068914, 5.25, 0.336,
  154.508745, 65.108351, 5.74, 0.163, 154.531635, -28.992, 5.52, 0.277, 154.617705, -41.66849, 5.97, -0.063,
  154.636845, 43.048445, 6.48, 0.925, 154.65774, -36.804572, 6.31, 1.282, 154.658415, -56.110393, 5.8, 0.481,
  154.744755, 46.760778, 6.42, 1.19, 154.75296, 24.712138, 6.42, 1.388, 154.771245, -64.676258, 5.66, 0.042,
  154.82029500000002, -12.528132, 6.01, 0.258, 154.861755, 48.396762, 6, 1.022, 154.88476500000002, -5.106148, 6.38, 0.894,
  154.903155, -55.029305, 4.59, 1.6, 154.92516, -65.137238, 6.35, 1.556, 154.93407000000002, 19.470914, 4.78, 0.452,
  154.99309499999998, 19.841489, 2.01, 1.128, 154.997835, -9.059004, 6.31, 0.338, 155.06178, 53.779391, 6.45, 0.58,
  155.069655, -47.69909, 5.66, 1.667, 155.12984999999998, 54.216839, 6.01, 1.128, 155.228355, -56.04322, 4.5, -0.102,
  155.26414499999998, 68.747651, 5.88, 0.241, 155.283165, -17.984959, 6.5, 0.402, 155.36944499999998, -23.710834, 6.47, 0.193,
  155.459595, 14.975773, 6.16, 0.018, 155.543535, -58.265572, 6.34, 0.884, 155.544105, 41.22953, 5.73, 0.531,
  155.553915, -19.866571, 6.12, 0.035, 155.58162000000002, -41.64996, 4.82, 1.095, 155.582325, 41.499516, 3.06, 1.603,
  155.74236, -66.901498, 4.97, -0.128, 155.75187, 6.542643, 6.06, 1.119, 155.776365, 33.908145, 5.89, 0.147,
  155.80474500000003, -30.162263, 6.25, 0.304, 155.86032, -4.074035, 5.93, -0.048, 155.86821, -0.902244, 6.45, 0.918,
  155.87216999999998, -38.009839, 5.34, 0.251, 155.886075, -3.642854, 6.39, 1.601, 155.91936, -41.953189, 6.24, 0.884,
  155.923995, 29.615856, 6.36, 1.09, 155.961015, -57.953933, 6.34, 1.517, 156.03273, 65.566423, 4.94, -0.052,
  156.03585, 33.718531, 5.52, 1.186, 156.0549, 2.368018, 6.33, 0.991, 156.09888, -74.031612, 3.99, 0.369,
  156.18562500000002, -73.971732, 6.18, 0.071, 156.24774, -58.576303, 5.93, 0.315, 156.313305, 8.784845, 5.61, 1.63,
  156.32173500000002, -42.467404, 6.18, 1.006, 156.43446, -7.059829, 5.6, 1.528, 156.43723500000002, 35.42543, 6.49, 1.089,
  156.47842500000002, 33.79612, 4.72, 0.26, 156.52263, -16.83629, 3.83, 1.456, 156.54105, -42.738494, 6.13, 1.129,
  156.653805, -0.988055, 6.33, 1.443, 156.70386, -54.877302, 5.58, 1.556, 156.752025, 19.364538, 6.15, 1.141,
  156.78795, -31.067779, 4.28, 1.429, 156.85197, -57.638805, 4.65, 0.474, 156.85563, -65.704664, 6, 0.091,
  156.86687999999998, 41.601035, 6, 0.166, 156.912465, 9.762396, 6.01, -0.043, 156.969735, -58.739403, 3.81, 0.317,
  156.970905, 36.707212, 4.2, 0.908, 157.00870500000002, -49.405801, 6.1, 1.506, 157.01607, 48.784901, 6.42, 0.61,
  157.07613, -63.164565, 6.42, -0.039, 157.15218000000002, 45.212211, 6.37, 1.33, 157.18317, -3.742385, 6.05, 0.059,
  157.21911, -64.172278, 5.27, 1.856, 157.26543, -65.176244, 6.42, 1.675, 157.36959, -2.739078, 5.19, -0.05,
  157.370745, -29.663832, 5.58, 1.42, 157.39741500000002, -30.607065, 5.57, -0.041, 157.425555, 84.252009, 5.52, 0.244,
  157.47679499999998, 65.626233, 6.32, 1.141, 157.52688, 38.925132, 5.79, 0.087, 157.536675, -66.984654, 6.19, -0.004,
  157.572825, -0.637026, 5.08, -0.138, 157.58371499999998, -71.992793, 4.72, 0.042, 157.61094, 64.257689, 6.07, 0.178,
  157.656915, 55.980536, 4.82, 0.541, 157.66351500000002, -61.356474, 6.41, 1.65, 157.744845, -7.63755, 6.2, 1.377,
  157.74933, -13.58847, 5.59, -0.028, 157.75862999999998, -73.22149, 4.94, 1.677, 157.77072, 82.558587, 5.25, 0.399,
  157.841625, -53.715484, 4.89, 0.5, 157.95284999999998, -28.237103, 6.04, 0.501, 157.964055, 32.379554, 5.9, 0.114,
  157.986015, -45.06966, 6.04, -0.096, 157.98933, -45.06671, 5.76, -0.194, 158.006145, -61.685332, 3.3, -0.089,
  158.04906, 14.13727, 5.43, 1.696, 158.14005, -44.618508, 5.91, 0.92, 158.19922499999998, -58.666745, 5.98, 0.29,
  158.202795, 9.306586, 3.84, -0.148, 158.23695, -47.003353, 5.02, 1.045, 158.307975, 40.42556, 4.72, 0.222,
  158.35581000000002, -58.190149, 6.09, 0.325, 158.378805, 34.988695, 5.57, 0.029, 158.50368, -23.745165, 5.08, 1.596,
  158.552985, -60.987629, 6.25, 1.399, 158.70006, 6.953749, 5.07, 0.921, 158.74044, -23.176248, 6.1, 0.496,
  158.758995, 8.650425, 5.67, 0.059, 158.77317, 75.712948, 4.86, 0.957, 158.790255, 57.082637, 5.16, 0.349,
  158.793435, -43.664587, 6.09, 0.94, 158.803575, -39.562589, 5.5, 3.015, 158.85330000000002, -76.308986, 6.29, 1.205,
  158.86749, -78.607786, 4.11, 1.58, 158.8971, -57.557636, 4.45, 1.604, 158.911935, -18.568978, 6.49, 0.199,
  159.00836999999999, 80.494629, 6.48, 0.963, 159.01878000000002, -26.675479, 6.29, 0.475, 159.06942, -16.344326, 6.01, 1.638,
  159.08559, -59.564392, 5.08, 1.172, 159.089235, 36.326927, 6.29, 0.436, 159.13491, -12.230121, 5.71, 0.528,
  159.30721499999999, -27.412634, 4.87, 1.626, 159.31716, -53.85526, 6.43, -0.15, 159.32575500000002, -48.22562, 3.84, 0.3,
  159.36280499999998, -58.733339, 5.47, 0.5, 159.388635, -13.384543, 4.89, 2.8, 159.46777500000002, 34.078623, 6.42, 1.364,
  159.51104999999998, -57.256309, 5.89, -0.128, 159.645645, -16.876572, 4.91, 0.922, 159.68005499999998, 31.976237, 4.68, 0.823,
  159.68751, -59.182997, 4.69, 1.562, 159.68911500000002, -59.26242, 6.5, -0.098, 159.70964999999998, -42.753443, 6.1, 0.661,
  159.710055, -12.443618, 6.04, -0.007, 159.74859, -58.816854, 5.96, 1.692, 159.773715, 53.6683, 5.55, 1.27,
  159.78195, 37.91, 5.84, 0.595, 159.81636, -74.493384, 6.08, 1.683, 159.82668, -55.603268, 4.29, 1.025,
  159.84519, -64.111788, 6.33, -0.072, 160.04772, -65.100209, 5.51, -0.158, 160.21476, -35.741718, 6.36, 0.917,
  160.323, -59.676916, 6.35, 0.088, 160.35078, -1.741491, 6.25, 0.88, 160.45120500000002, 68.443499, 5.74, 1.315,
  160.464855, -79.783288, 5.97, -0.071, 160.4862, 65.71628, 5.12, 1.207, 160.54695, 31.696998, 6.02, 1.617,
  160.55889, -64.466426, 4.76, -0.139, 160.63072499999998, -13.974514, 6.24, 1.54, 160.669035, -59.215759, 5.36, 0.213,
  160.679955, -32.715673, 5.63, 0.006, 160.739235, -64.39445, 2.74, -0.22, 160.75786499999998, 26.325577, 5.51, 0.16,
  160.766835, 69.076214, 5.01, 1.406, 160.83717000000001, 4.747669, 5.77, 1.168, 160.85399999999998, 23.188404, 5.08, 0.042,
  160.884585, -60.566619, 4.58, 1.7, 160.88733000000002, 46.203877, 5.18, 0.324, 160.93053, 57.199203, 5.79, -0.038,
  160.96335000000002, -64.249042, 5.74, 0.012, 160.96776, -60.117783, 6.45, -0.017, 161.02887, -63.961072, 4.8, -0.134,
  161.06062500000002, 19.758834, 6.27, 0.196, 161.08365, -70.859721, 6.25, 0.208, 161.095485, -59.99332, 6.32, -0.31,
  161.1132, -72.443498, 6.26, 0.51, 161.134965, -70.855255, 6.43, 0.227, 161.26677, 67.411384, 5.95, 2.382,
  161.28940500000002, 2.48797, 6.27, 1.212, 161.31819, -80.469597, 5.46, 0.957, 161.446305, -80.540188, 4.45, -0.188,
  161.46624, 30.682313, 5.36, -0.05, 161.523675, 6.373183, 6.38, 1.121, 161.569035, -64.514559, 5.33, -0.096,
  161.57121, -60.602872, 6.26, 0.038, 161.593785, 57.365914, 6.34, 1.568, 161.60226, 18.891523, 5.5, 1.134,
  161.605335, 14.194645, 5.49, 0.908, 161.623335, -64.263242, 5.23, -0.077, 161.65476, -43.192673, 6.29, 0.202,
  161.69232, -49.420255, 2.69, 0.901, 161.70036, -69.209786, 6.34, 0.18, 161.71347, -64.383474, 4.87, -0.149,
  161.716905, -17.296874, 5.44, 0.112, 161.73951, -56.757192, 5.14, -0.08, 161.87754, -69.437733, 6.35, -0.085,
  161.910015, -57.467411, 6.29, 1.673, 161.93469, -59.875257, 6.47, -0.121, 161.97309, -64.262842, 6.46, 0.008,
  162.022545, -59.919163, 5.98, 0.274, 162.058815, -31.68785, 5.87, 0.028, 162.16899, -1.958896, 5.92, 1.608,
  162.20778, 65.132491, 6.4, -0.022, 162.238485, 29.416057, 6.15, 1.144, 162.314295, 10.545202, 5.32, 0.035,
  162.351855, -59.323793, 5.85, 0.008, 162.370035, 63.810029, 6.42, 1.287, 162.406185, -16.193648, 3.11, 1.232,
  162.431205, -9.852695, 5.85, 1.074, 162.473865, 27.973948, 6.05, 0.399, 162.48759, -34.058183, 5.61, 0.038,
  162.575235, -8.897763, 5.8, 0.156, 162.77253, -3.092667, 5.95, 1.475, 162.79600499999998, 56.58225, 5.66, 1.132,
  162.84891, 59.320119, 5.57, 1.16, 162.94542, -57.272315, 6.29, 0.226, 163.05704999999998, 1.024973, 6.37, 0.087,
  163.11942, -79.559437, 6.36, 1.46, 163.12854, -57.240405, 5.26, 0.13, 163.13367000000002, 52.503605, 6.44, 1.114,
  163.15038, -0.201657, 6.31, 1.503, 163.32789, 34.214871, 3.79, 1.04, 163.338225, -58.893453, 6.26, -0.104,
  163.354005, -2.255209, 6.12, 0.913, 163.37304, -20.138731, 5.23, 0.48, 163.373385, -58.853171, 3.78, 0.945,
  163.37978999999999, 69.853881, 5.91, 1.01, 163.38709500000002, -15.445825, 6.34, 1.176, 163.38922499999998, -56.420501, 6.45, 1.392,
  163.393665, 54.585128, 5.12, 1.355, 163.425465, -70.720337, 5.99, -0.02, 163.43214, -2.129205, 5.45, 0.966,
  163.49471999999997, 43.189956, 4.66, -0.039, 163.57407, -13.758036, 5.65, 0.832, 163.62333, -61.826622, 5.95, 1.736,
  163.67571, 25.490722, 6.19, 0.291, 163.74244499999998, 34.034798, 5.73, 1.032, 163.75422, -42.251098, 6.08, -0.061,
  163.798215, -20.664963, 6.45, 1.098, 163.82183999999998, -60.517003, 5.93, 1.065, 163.86342, -43.020528, 6.4, 0.068,
  163.90335, 24.749718, 4.3, 0.016, 163.92666, 0.736922, 5.91, 0.425, 163.93498499999998, 33.506929, 5.02, 1.101,
  164.00613, 6.185371, 5.91, 1.256, 164.060475, 42.008155, 6.03, 1.123, 164.070225, 22.351682, 6.17, 1.549,
  164.14345500000002, 25.500244, 6.36, 1.036, 164.179335, -37.137765, 4.6, 1.006, 164.282745, -50.765018, 5.9, 0.173,
  164.31583500000002, -75.099761, 6.16, 1.531, 164.334195, -69.038055, 6.48, 0, 164.45078999999998, -59.73219, 6.36, 0.84,
  164.80725, -33.737595, 5.7, 0.374, 164.80845, -61.320739, 6.16, -0.064, 164.80887, -84.593893, 6.19, 0.1,
  164.8245, 51.882359, 6.22, 1.352, 164.8668, 40.430257, 5.03, 0.624, 164.878875, -16.353701, 5.88, 1.6,
  164.88657, 36.0931, 5.99, 1.595, 164.94366000000002, -18.298783, 4.08, 1.079, 164.9874, 77.770174, 6.18, 0.966,
  164.997465, -43.80711, 5.81, -0.064, 165.03459, -51.8178, 6.15, 0.188, 165.03858000000002, -42.225859, 4.37, 0.116,
  165.04872, -14.083368, 5.86, 1.501, 165.06126, 45.526276, 5.47, 1.466, 165.08625, 42.911724, 6.03, 0.584,
  165.106515, 51.502101, 6.41, 1.007, 165.140205, 3.617494, 4.84, 1.144, 165.15117, -53.111831, 6.44, 1.28,
  165.169965, -31.839368, 6.06, 0.527, 165.18667499999998, 6.101449, 4.98, 0.166, 165.210135, 39.212092, 5.06, 0.255,
  165.239115, -15.792682, 6.35, 1.172, 165.27373500000002, 63.42111, 6.38, 0.169, 165.456975, -2.484585, 4.73, 1.593,
  165.46015500000001, 56.382427, 2.34, 0.033, 165.55769999999998, -41.114145, 6.48, 1.474, 165.582405, 20.179842, 4.42, 0.053,
  165.601875, -26.831505, 6.21, 0.307, 165.810585, -0.752344, 6.12, 0.269, 165.811995, -11.30347, 5.51, 0.938,
  165.816915, -31.960849, 6.44, 1.616, 165.86406, 70.03074, 6.44, 1.28, 165.902235, -13.43492, 6.34, 0.86,
  165.90246000000002, -0.000833, 5.95, 1.218, 165.93232500000002, 61.751033, 1.81, 1.061, 166.000995, -57.955331, 6.16, -0.167,
  166.13016, 38.241365, 6.01, 0.165, 166.130145, -47.679103, 5.67, 0.256, 166.225815, -35.804678, 5.43, 0.021,
  166.254285, 7.336007, 4.62, 0.332, 166.26717000000002, -49.392299, 6.11, -0.019, 166.333005, -27.293612, 4.92, 0.369,
  166.39164, -11.088901, 6.09, 0.301, 166.48986, -27.287853, 5.69, -0.067, 166.523925, -51.21292, 6.28, 0.943,
  166.601205, -64.839972, 6.39, 0.114, 166.61471999999998, -50.956725, 6.31, 1.156, 166.622055, -58.675021, 6.07, 1.21,
  166.635225, -62.424113, 4.62, 0.988, 166.68345, 17.737364, 6.4, 1.555, 166.70799, -70.87793, 5.58, -0.07,
  166.72587, 1.955525, 5.52, 0.955, 166.81962000000001, -42.638681, 5.15, 0.029, 166.892235, -48.639982, 6.44, 1.486,
  166.91544, 23.323762, 6.48, 0.164, 167.065725, -29.972486, 6.47, 0.029, 167.14167, -61.947175, 5.11, 0.195,
  167.147475, -58.975037, 3.93, 1.225, 167.183355, -28.08067, 5.43, 0.069, 167.204535, 24.658464, 5.7, 0.081,
  167.32953, 36.309379, 5.71, 1.4, 167.410485, 43.207736, 5.89, 1.564, 167.41593, 44.498487, 3, 1.144,
  167.41611, 67.210208, 6.07, 0.225, 167.472465, -32.367529, 5.79, 0.027, 167.873175, -71.436189, 6.34, 1.373,
  167.91453, -22.825847, 4.46, 0.025, 167.93231999999998, 14.400153, 6.3, 0.209, 167.991015, -26.806114, 6.43, 0.924,
  168.01486500000001, -58.423355, 6.24, 1.495, 168.04255500000002, -46.266761, 6.27, 0.155, 168.04546499999998, 68.27187, 6.4, 0.127,
  168.06162, -32.433793, 6.35, 1.683, 168.126555, -18.499862, 6.11, -0.004, 168.13494, 35.81408, 6.41, 0.6,
  168.137865, -49.100996, 5.37, 0.175, 168.145005, -21.749339, 6.39, 1.381, 168.15007500000002, -60.317625, 4.59, 0.541,
  168.18851999999998, -64.16977, 5.22, -0.082, 168.236355, -49.73609, 6.12, 1.055, 168.31119, -44.372216, 5.77, 1.661,
  168.37828499999998, -59.619318, 5.74, -0.106, 168.414165, -53.231813, 5.75, 1.309, 168.41706000000002, 41.088837, 6.33, 1.15,
  168.4398, -0.069502, 5.4, -0.02, 168.507645, 8.060695, 5.79, 1.128, 168.52706999999998, 20.523717, 2.56, 0.128,
  168.560025, 15.42957, 3.33, -0.003, 168.72552, -43.733703, 6.22, 1.606, 168.800955, 23.095502, 4.56, 1.657,
  168.928155, -57.355882, 6.42, 0.098, 168.966255, 13.307578, 5.31, 1.189, 169.116075, -45.880012, 6.3, 0.403,
  169.165425, -3.651601, 4.45, 0.21, 169.174485, 49.47625, 5.88, 1.102, 169.242405, -7.134689, 6.11, 0.211,
  169.30007999999998, -38.014367, 6.24, 0.105, 169.309725, -41.934326, 6.46, 0.015, 169.322505, 2.010556, 5.18, 1.511,
  169.329285, -67.823515, 6.06, 1.753, 169.41195, -34.737348, 6.44, 0.408, 169.619745, 33.094306, 3.49, 1.4,
  169.64266500000002, -79.668651, 6.35, 0.266, 169.72898999999998, 1.650395, 5.9, 1.04, 169.78296, 38.185557, 4.76, 0.113,
  169.819455, -64.582491, 5.99, 0.471, 169.835205, -14.778541, 3.56, 1.112, 169.90236000000002, -75.142452, 6.26, -0.016,
  169.961715, -72.958291, 6.46, 0.004, 170.01729, -71.994337, 6.41, 0.019, 170.223885, 67.100734, 6.2, 1.018,
  170.25175499999997, -54.491019, 3.9, -0.157, 170.28414, 6.029322, 4.05, -0.058, 170.455485, 57.074857, 6.43, 0.161,
  170.487765, -77.608369, 6.43, 0.202, 170.596335, -44.645924, 6.1, 0.926, 170.70663000000002, 43.482703, 4.99, 0.998,
  170.71353000000002, 64.330513, 6.02, 0.085, 170.78394, -56.779355, 5.82, -0.004, 170.802855, -36.164769, 5, 1.464,
  170.8248, 0.13205, 6.05, 1.464, 170.839245, -64.954714, 5.09, -0.061, 170.841225, -18.779973, 5.08, 0.439,
  170.98104, 10.529509, 4, 0.423, 170.98563, -57.880437, 6.5, 1.504, 171.00969, 1.407765, 5.39, 0.938,
  171.0465, -72.256608, 5.55, 0.017, 171.091905, -42.669102, 6.13, -0.175, 171.15246, -10.859323, 4.81, 1.556,
  171.22053, -17.68401, 4.06, 0.216, 171.245535, 11.430292, 5.8, 1.376, 171.37278, -36.063062, 5.21, 0.979,
  171.38793, -37.747575, 5.87, 1.503, 171.401565, 16.456539, 5.58, 0.39, 171.430755, -63.972475, 5.18, 0.495,
  171.45856500000002, 3.86011, 6.35, 0.345, 171.4881, 55.850459, 5.73, 0.988, 171.60651, 33.450608, 6.33, 0.454,
  171.64761000000001, -61.115167, 5.22, -0.077, 171.68884500000001, 3.013102, 6.49, 0.778, 171.697005, -53.159915, 5.8, 0.517,
  171.78966, -12.356749, 5.93, 0.49, 171.973785, -1.699946, 6.23, 1.037, 171.98433, 2.856265, 4.95, 1,
  171.99445500000002, -35.328849, 6.44, 1.614, 172.076865, -72.473977, 6.09, 0.101, 172.146195, -42.674203, 5.14, -0.028,
  172.26721500000002, 39.336974, 5.3, 0.019, 172.269315, 61.778368, 5.83, 0.382, 172.313085, -63.553937, 6.45, 0.32,
  172.41091500000002, -24.464011, 5.77, 0.067, 172.424355, 15.413269, 5.74, 1.371, 172.43169, 56.737573, 6.29, 0.157,
  172.57872, -3.003501, 4.77, 1.529, 172.60343999999998, 46.657533, 6.3, 1.265, 172.62097500000002, 18.409801, 5.54, 1.056,
  172.62976500000002, 43.173242, 5.94, 0.524, 172.72089, 47.928918, 6.4, 0.879, 172.812705, -61.278463, 6.28, 0.473,
  172.85110500000002, 69.331076, 3.82, 1.613, 172.937295, 14.364505, 6.27, 0.57, 172.94196000000002, -59.442061, 5.07, 1.026,
  172.948155, -20.776472, 6.24, 0.537, 172.95334499999998, -59.515648, 5.12, 0.432, 172.96248, 81.127257, 6.12, 0.264,
  173.06835, -29.261022, 4.93, 0.54, 173.08332000000001, -66.961823, 5.89, 1.136, 173.086455, 61.08252, 5.46, 0.515,
  173.09703, -26.746805, 6.15, 1.67, 173.19807, -7.827523, 5.94, 1.38, 173.200395, -40.436194, 5.64, 1.578,
  173.22555, -31.087226, 5.13, 1.581, 173.25057, -31.857625, 3.54, 0.947, 173.311755, -16.280381, 6.05, 0.59,
  173.40144, 2.499034, 6.49, 1.601, 173.405055, -40.586637, 5.39, 0.117, 173.48458499999998, 36.815614, 6.38, 1.057,
  173.59145999999998, 3.060165, 5.76, 0.48, 173.62317, -32.83134, 5.96, 0.811, 173.67704999999998, 16.796915, 5.95, -0.156,
  173.690325, -54.264091, 4.62, -0.077, 173.737095, -49.13649, 5.5, 1.041, 173.745435, -4.361291, 6.43, 1.167,
  173.765655, 20.441545, 6.45, 1.01, 173.770425, 54.785419, 5.63, 1.032, 173.80545, -47.37258, 5.64, 1.682,
  173.92641, -61.28787, 6.23, 0.131, 173.945445, -63.019841, 3.11, -0.044, 173.981565, -47.641643, 5.26, 0.257,
  174.01116000000002, 69.322952, 5.19, 0.974, 174.074805, 27.781351, 5.8, 0.248, 174.09322500000002, -61.052433, 5.84, -0.102,
  174.14559, -33.570057, 5.71, 1.02, 174.16969500000002, -37.237187, 6.3, 0.062, 174.17047499999998, -9.802247, 4.7, -0.073,
  174.23721, -0.823749, 4.3, 0.983, 174.25278, -61.283442, 5.14, 1.105, 174.255075, -32.988184, 6.32, 0.439,
  174.31611, -75.896544, 5.64, 0.362, 174.39171, -47.747309, 5.46, 1.23, 174.4263, 77.595699, 6.49, 1.61,
  174.451905, -67.620379, 5.94, 1.013, 174.470925, 50.618211, 6.14, 1.068, 174.530565, -61.826563, 5.15, -0.04,
  174.54095999999998, 8.883792, 6.18, 1.081, 174.584865, -63.372747, 6.46, 0.043, 174.58584, 43.625429, 5.56, 0.348,
  174.600285, -2.435901, 6.22, 1.119, 174.61503, 8.134298, 5.24, 1.499, 174.63468, 33.625829, 6.29, 1.325,
  174.639675, 46.834209, 6.09, 0.401, 174.666735, -13.201943, 5.48, 0.52, 174.68769, 45.108416, 6.29, 0.566,
  174.7047, 64.346965, 6.49, 0.154, 174.75182999999998, -24.721093, 6.4, 0.821, 174.873405, -65.397766, 5.01, 0.804,
  174.95973, -16.620229, 6.17, 1.579, 174.963015, -14.468529, 6.21, -0.007, 175.053315, -34.74466, 4.7, -0.07,
  175.114305, 57.970404, 6.35, -0.092, 175.15419, -62.568102, 6.32, 0.029, 175.17702, -53.968607, 5.95, 1.67,
  175.19612999999998, 21.35273, 5.26, 0.984, 175.22352, -62.090101, 4.93, 1.111, 175.256505, -83.099937, 6.32, 1.08,
  175.262565, 34.201635, 5.31, 0.723, 175.28511, -29.196274, 6.44, 0.651, 175.33254, -43.095667, 5.54, 0.044,
  175.3929, 31.746058, 5.73, 0.44, 175.43127, 55.172011, 6.28, 1.491, 175.43311500000002, -32.499404, 5.2, 1.475,
  175.5147, -20.294167, 6.21, 0.949, 175.56186, -75.227317, 6.48, 0.528, 175.618335, 66.744906, 5.32, 1.267,
  175.727535, -79.306389, 6.38, 0.894, 175.863285, -37.190155, 5.98, 1.449, 175.87998, -62.489396, 5, 0.784,
  175.97012999999998, -62.87828, 6.1, 0.063, 175.97967, -6.677162, 6.05, 0.96, 176.05485000000002, 25.218327, 6.02, 1.533,
  176.190735, -18.350674, 4.71, 0.958, 176.30268, -49.069843, 6.26, 1.174, 176.320995, 8.258119, 4.84, 0.174,
  176.402115, -66.728763, 3.63, 0.16, 176.43324, -45.690134, 5.28, -0.118, 176.46483, 6.529376, 4.04, 1.501,
  176.512725, 47.779406, 3.69, 1.181, 176.62848000000002, -61.178398, 4.11, 0.895, 176.63064, -40.500354, 4.89, 0.664,
  176.73174, 55.62819, 5.27, 1.276, 176.77935, -35.906862, 6.16, 0.952, 176.815965, -30.28651, 6.48, 0.681,
  176.82980999999998, -57.696498, 5.42, 1.664, 176.97876, 8.245895, 5.31, 0.038, 176.99643, 20.218931, 4.5, 0.547,
  177.06044999999997, -66.81491, 4.75, 1.522, 177.09786, -10.313105, 6.24, 0.585, 177.161295, 14.28421, 5.9, 0.303,
  177.18786, -26.749777, 5.1, 1.594, 177.255345, -0.31867, 6.15, 0.518, 177.26494499999998, 14.57206, 2.14, 0.09,
  177.31161, 16.242882, 6.05, 0.278, 177.421155, -63.788478, 4.3, -0.149, 177.42387, 34.931758, 5.73, 0.467,
  177.485925, -70.22579, 4.98, 1.36, 177.58168500000002, -15.863667, 6.13, 0.947, 177.613665, -62.649381, 5.68, 0.233,
  177.654945, -27.277936, 6.48, 0.98, 177.67383, 1.764718, 3.59, 0.518, 177.73059, 12.279037, 6.37, 0.294,
  177.7593, -5.333332, 5.62, 1.058, 177.786285, -45.17347, 4.47, 1.283, 177.78963, 33.375013, 6.25, 0.345,
  177.84125999999998, -12.187811, 6.34, 0.41, 177.923385, -30.834809, 5.85, 0.554, 177.96355499999999, -65.20591, 4.89, -0.123,
  178.04305499999998, -56.987741, 5.56, 0.069, 178.227195, -33.908124, 4.29, -0.1, 178.2423, 37.718679, 6.42, 0.754,
  178.361745, -35.066645, 6.17, 0.089, 178.45752000000002, 53.69476, 2.41, 0.044, 178.459485, 0.552114, 6.31, 0.207,
  178.54793999999998, -57.410198, 6.05, 0.05, 178.607775, -37.748935, 6.46, 0.528, 178.67724, -25.713887, 5.26, 0.883,
  178.68594, -66.376198, 6.38, 0.406, 178.75008, -63.27918, 5.89, 0.21, 178.76305499999998, 8.443943, 5.58, 0.937,
  178.80861000000002, 36.756378, 6.47, 1.581, 178.91720999999998, -28.477103, 5.93, 1.499, 178.91888999999998, 15.646818, 5.53, 0.116,
  178.97816999999998, -39.689517, 6.13, 1.01, 178.99338, 56.59856, 5.83, 1.101, 179.003985, -17.150829, 5.17, -0.022,
  179.18313, -47.072379, 6.26, 0.407, 179.22189, 61.549213, 6.22, 0.955, 179.26563, -33.315461, 6.2, -0.044,
  179.41677, -62.448748, 5.59, -0.152, 179.529945, 32.273907, 6.42, 0.331, 179.56347, -56.31731, 5.44, -0.062,
  179.69860500000001, -64.33956, 5.59, 0.174, 179.726565, -25.908857, 6.42, 0.038, 179.7639, 0.53068, 6.18, 1.257,
  179.78904, -10.475896, 6.49, 1.45, 179.79453, -45.83222, 6.36, -0.081, 179.79528, -51.696761, 6.04, 1.277,
  179.82307500000002, 33.167004, 5.95, 1.153, 179.856765, -62.830948, 6.34, 0.317, 179.90694, -78.221839, 4.88, -0.054,
  179.98713, 3.655197, 5.36, -0.001, 179.98909500000002, 34.034748, 6.49, 0.243, 180.07836, 80.853186, 6.21, 1.61,
  180.175935, -21.837501, 6.28, 1.22, 180.185205, -10.446014, 5.54, 0.76, 180.213165, -19.658982, 5.28, -0.192,
  180.21829499999998, 6.614322, 4.65, 0.122, 180.257235, -1.768166, 6.32, 1.204, 180.37176, -57.503777, 6.16, -0.004,
  180.414525, 36.042086, 5.59, 1.019, 180.52858500000002, 43.0456, 5.22, 0.283, 180.58602000000002, -85.631757, 6.05, 1.29,
  180.61896, -71.488981, 6.41, 1.163, 180.657225, -69.192288, 5.89, -0.08, 180.71526, -7.683623, 6.24, 1.492,
  180.756705, -63.31293, 4.32, 0.28, 180.91459500000002, -42.434056, 5.15, 0.417, 180.93517500000002, 5.55775, 6.39, 0.476,
  180.93553500000002, -74.214096, 6.44, 1.198, 181.069155, 21.459153, 5.89, 0.248, 181.06965, -51.472518, 6.48, -0.046,
  181.08012, -63.165711, 4.72, -0.081, 181.11874500000002, 85.587132, 6.27, 0.56, 181.162185, -68.328912, 5.34, -0.012,
  181.18863000000002, -59.253287, 6.3, -0.034, 181.19424, -76.519061, 5.04, 1.491, 181.23846, -60.968252, 5.95, 1.691,
  181.302255, 8.732985, 4.12, 0.967, 181.311765, 76.905734, 5.78, 1.029, 181.41556500000002, 62.93312, 6.14, 1.178,
  181.473435, -65.546879, 6.3, 0.152, 181.486125, -35.693926, 6.23, -0.073, 181.49921999999998, -3.131591, 6.37, 0.997,
  181.52168999999998, -32.961231, 6.49, 0.623, 181.58304, -68.651405, 6.23, 1.237, 181.59606, -65.709453, 5.95, 0.613,
  181.720305, -64.61373, 4.14, 0.353, 181.95847500000002, -75.367019, 5.17, 1.278, 182.02182, -50.661278, 4.46, -0.163,
  182.06133, -48.692487, 5.34, -0.01, 182.08965, -50.722425, 2.58, -0.128, 182.10306, -60.847128, 6.22, 1.733,
  182.103375, -24.728875, 4.02, 0.334, 182.22421500000002, -44.325989, 5.75, 0.24, 182.22745500000002, -41.231605, 5.51, -0.097,
  182.422125, 1.897889, 5.95, 1.12, 182.44617, 74.661368, 6.34, 0.511, 182.51064000000002, -34.704742, 6.16, 0.03,
  182.51424, 5.807008, 5.72, 0.352, 182.53119, -22.619766, 3.02, 1.326, 182.63179499999998, 16.809271, 6.4, 0.07,
  182.64086999999998, -37.870349, 6.07, 0.19, 182.69206499999999, 27.281505, 6.01, 0.123, 182.75030999999998, 81.709832, 6, 1.618,
  182.75508, -68.260966, 6.48, 1.352, 182.76601499999998, -23.602423, 5.45, 0.055, 182.77158, -61.277425, 6.08, 0.398,
  182.88147, -51.359333, 6.23, 0.816, 182.91303000000002, -52.36846, 3.97, -0.156, 182.93708999999998, 57.054408, 6.34, 1.505,
  182.96325, 25.87028, 5.66, 1.401, 183.00421500000002, 28.536313, 6.47, 0.428, 183.038715, 20.542064, 5.6, 0.961,
  183.049665, 77.616241, 5.14, 0.358, 183.09159, -62.950773, 5.91, 0.253, 183.195945, -70.151787, 6.05, 1.78,
  183.303945, -34.125272, 6.34, 1.449, 183.354345, -38.929188, 5.77, -0.144, 183.35808, 10.262341, 5.85, 0.262,
  183.40335, -33.792919, 6.34, 0.071, 183.48531000000003, -78.573934, 6.34, 1.234, 183.511275, -45.723919, 5.31, 1.4,
  183.57054, -64.408519, 6.2, 0.075, 183.68090999999998, 53.434626, 6.18, 1.061, 183.74826, -20.84422, 5.82, 1.052,
  183.77667, -29.237256, 6.5, 1.086, 183.78549, 70.200008, 5.72, 1.179, 183.786405, -58.748928, 2.79, -0.193,
  183.793995, -10.3124, 6.11, 0.47, 183.836055, 87.700115, 6.27, 0.346, 183.85629, 57.032617, 3.32, 0.077,
  183.877155, -41.913278, 6.24, 1.002, 183.922935, 72.551196, 6.29, 1.145, 183.95155499999998, -17.541929, 2.58, -0.107,
  184.000785, 14.899071, 5.09, 0.068, 184.031445, 40.66018, 5.69, 1.586, 184.08558000000002, 23.945409, 4.93, 0.957,
  184.09939500000002, -72.614499, 6.21, -0.006, 184.12560000000002, 33.061527, 4.99, 1.14, 184.20613500000002, 86.435819, 6.33, 0.437,
  184.26388500000002, -16.693736, 6.05, 0.113, 184.276425, -65.692958, 6.06, 0.021, 184.373265, 53.191331, 5.8, 1.33,
  184.37740499999998, 28.937189, 5.71, 0.16, 184.393755, -67.960736, 4.06, 1.603, 184.43442000000002, 15.1447, 6.36, 1.384,
  184.44696, -36.093979, 6.15, 0.008, 184.58718, -79.31224, 4.24, -0.123, 184.60947, -64.003071, 4.06, -0.168,
  184.63171499999999, 30.249047, 6.23, 0.31, 184.66798500000002, -0.787184, 5.9, 0.168, 184.708515, 75.160561, 5.47, 0.054,
  184.74912, -55.143002, 5.01, 1.6, 184.758435, 26.008349, 6.44, 0.18, 184.82997, 23.034673, 6.26, 0.177,
  184.873095, 28.156916, 6.38, 0.523, 184.952985, 48.984148, 5.28, 1.623, 184.97649, -0.666803, 3.89, 0.026,
  185.04489, -22.1757, 5.94, 0.824, 185.074005, 26.001875, 6.16, 0.306, 185.08200000000002, 26.619482, 5.52, 1.091,
  185.08741500000002, 3.312574, 4.97, 1.172, 185.11774499999999, -65.842656, 6.2, -0.041, 185.1402, -22.215901, 5.2, -0.09,
  185.172405, 27.054545, 6.32, 0.394, 185.17929, 17.792868, 4.72, 1.01, 185.20299, 15.540988, 6.47, 1.025,
  185.21191499999998, 57.864118, 5.54, 1.452, 185.232135, -13.565724, 5.14, 1.048, 185.340465, -60.401147, 3.59, 1.389,
  185.484435, 47.182202, 6.33, 1.115, 185.489295, -56.374385, 5.91, 1.533, 185.53069499999998, -67.522105, 5.15, 0.195,
  185.545125, 24.773866, 6.21, -0.012, 185.55013499999998, -68.307316, 5.73, 1.038, 185.626305, 25.84616, 4.78, 0.515,
  185.63349, 5.305444, 6.46, 0.567, 185.706045, -57.676132, 5.38, -0.098, 185.810835, -67.631546, 6.36, 0.887,
  185.81403, -4.974503, 6.47, 1.189, 185.82861, -11.812117, 6.48, 1.64, 185.83995, -24.840669, 5.66, 1.153,
  185.89761000000001, -35.412677, 5.32, -0.066, 185.903115, -39.30236, 6.39, 0.285, 185.936475, -38.911381, 5.79, -0.064,
  185.945955, 42.542743, 6.03, 0.366, 185.949285, -30.335415, 6.39, 1.572, 186.00620999999998, 51.562257, 4.76, 0.877,
  186.07719, 26.098606, 5.17, 0.082, 186.11169, 25.582404, 6.41, 0.276, 186.186375, -41.384289, 6.24, 1.169,
  186.2634, 56.777828, 5.82, 1.622, 186.276555, 63.802781, 6.31, 0.919, 186.285615, -42.514312, 6.1, 0.652,
  186.299025, -11.61059, 5.95, 0.043, 186.312945, 23.926202, 6.03, 1.094, 186.323265, -65.769853, 6.29, 0.965,
  186.32671499999998, -27.749002, 6.09, 1.272, 186.34059, -35.186417, 5.71, -0.066, 186.409485, -86.150613, 6.32, 1.065,
  186.4623, 39.018616, 5.01, 0.955, 186.60027, 27.268237, 4.92, 0.277, 186.60160499999998, 71.929827, 6.33, 1.028,
  186.63236999999998, -51.450635, 4.82, -0.141, 186.649665, -63.099092, 0.77, -0.243, 186.70139999999998, -48.913191, 6.25, 0.674,
  186.71538, -32.830121, 5.56, 0.007, 186.73449, 28.268423, 4.35, 1.128, 186.747075, 26.825699, 4.98, 0.088,
  186.853485, -63.788986, 6.02, 0.052, 186.87015, -58.316445, 6.35, 1.612, 186.870285, -58.991756, 5.38, 1.543,
  186.89631, 55.712724, 5.68, 1.582, 186.925335, 8.610344, 6.36, 0.935, 186.956025, -16.631844, 6.3, 0.868,
  186.964785, -4.615277, 6.23, 0.43, 187.009965, -50.230635, 3.91, -0.192, 187.080375, -64.340989, 6.05, 0.022,
  187.09362000000002, -39.041172, 5.45, -0.073, 187.107075, -61.794842, 6.21, 1.253, 187.140435, -56.407816, 6.15, 0.92,
  187.227945, 25.912852, 5.29, -0.056, 187.362675, 24.108925, 5.47, 0.445, 187.43016, 20.896109, 5.68, 0.093,
  187.466085, -16.515432, 2.94, -0.012, 187.47582, -56.52494, 5.78, 1.572, 187.489005, 58.405742, 5.37, 0.205,
  187.491195, -41.735901, 6, 1.515, 187.512225, 51.535631, 6.21, 0.536, 187.51766999999998, 58.767773, 6.07, 0.988,
  187.519905, -13.393184, 6.37, 0.591, 187.52802, 69.201123, 5.01, 1.621, 187.57269000000002, -23.696419, 5.63, 1.67,
  187.708875, 53.076608, 6.2, 0.568, 187.75234500000002, 24.567168, 5.47, 0.056, 187.791435, -57.113212, 1.59, 1.6,
  187.83924, 7.604309, 6.05, 1.523, 187.911345, -5.052592, 6.19, 1.041, 187.91806499999998, -59.423922, 5.49, 0.622,
  187.9839, -63.505838, 5.96, 0.263, 188.01829500000002, -32.533761, 6.46, 0.172, 188.01764999999997, -16.196007, 4.3, 0.388,
  188.041335, -73.001056, 5.88, 1.078, 188.11701, -72.132988, 3.84, -0.157, 188.13672, -21.212116, 6.41, 1.11,
  188.15001, -13.859105, 5.74, 0.376, 188.262, 10.295671, 6.29, 0.953, 188.342715, -19.792549, 6.26, 0.304,
  188.37087000000002, 69.788238, 3.85, -0.116, 188.39259, 24.282984, 6.28, 0.114, 188.39274, -12.830203, 5.58, 0.861,
  188.41215, 33.247584, 5.42, 1.011, 188.43616500000002, 41.35748, 4.24, 0.588, 188.44479, -9.452077, 5.48, -0.035,
  188.44754999999998, 33.384668, 6.24, 1.051, 188.496495, -49.90981, 6.38, 0.428, 188.596815, -23.396759, 2.65, 0.893,
  188.67672, -44.673018, 5.76, 0.683, 188.68353, 70.02177, 4.95, 1.312, 188.712855, 22.629259, 4.8, 0.012,
  188.72691, -67.756894, 6.11, 1.514, 188.78233500000002, 18.377058, 5.03, 1.152, 188.78403, 21.881384, 5.86, 1.242,
  188.873445, -61.841576, 6.22, 0.731, 188.93980499999998, -41.021945, 5.12, 0.224, 188.994975, -20.527476, 6.2, 0.34,
  189.004335, -39.869505, 5.78, 0.003, 189.19424999999998, -50.335394, 6.4, 0.026, 189.19731, -5.831898, 5.88, 0.072,
  189.24305999999999, 17.089536, 5.7, 1.436, 189.29608499999998, -69.135564, 2.69, -0.176, 189.426135, -27.138888, 5.41, 0.334,
  189.42591, -48.541304, 3.85, 0.049, 189.5184, 3.282444, 6.33, 0, 189.593355, 1.854662, 5.68, 1.592,
  189.68589, -18.2501, 6, 0.31, 189.692835, 40.874662, 6.35, 0.204, 189.718185, -67.193048, 6.22, 0.007,
  189.75909, 22.659497, 6.39, 1.096, 189.76443, -30.422387, 5.86, 1.207, 189.780465, 21.062559, 5.49, 0.978,
  189.810915, -75.370594, 6.46, 0.098, 189.81153, -7.995564, 4.66, 1.24, 189.820245, 35.951959, 6.39, 0.095,
  189.96891, -39.987302, 4.63, -0.082, 189.982845, -66.511138, 6.26, -0.05, 190.316475, -13.013901, 5.17, 0.432,
  190.345845, -46.145581, 5.84, 1.475, 190.379565, -48.959888, 2.2, -0.023, 190.391385, 62.713039, 6.02, 0.051,
  190.393305, 10.42627, 6.22, 0.192, 190.415175, -1.449375, 2.74, 0.368, 190.45584, -19.759092, 6.02, 0.397,
  190.471065, 10.235625, 4.88, 0.076, 190.48576500000001, -59.685819, 4.91, -0.044, 190.487985, 6.806617, 5.57, 0.002,
  190.52096999999998, -69.407554, 6.31, 0.75, 190.64787, -48.813109, 4.66, 1.075, 190.707405, -55.947001, 6.06, -0.023,
  190.709475, -63.058624, 5.27, 0.195, 190.76733, 61.155421, 6.39, 1.268, 190.78831499999998, -56.176224, 5.99, -0.074,
  190.85941499999998, -40.177849, 6.43, 0.242, 190.86816, -58.902742, 6.41, 1.092, 190.90854, -1.576996, 5.91, 0.85,
  190.99444499999998, -36.349153, 6.38, -0.06, 191.00221499999998, -28.323957, 5.46, 1.346, 191.107995, 80.621024, 6.33, 0.16,
  191.112945, 44.103004, 6.34, 0.469, 191.24778, 39.278916, 5.95, 0.557, 191.25859499999999, -68.830751, 6.16, 0.688,
  191.28261, 45.440256, 5.42, 2.994, 191.40441, 7.673326, 5.22, 0.322, 191.40825, -60.981318, 4.69, 1.049,
  191.57019, -68.108119, 3.04, -0.178, 191.59392, 9.539684, 5.65, 0.989, 191.594715, -56.488815, 4.62, -0.15,
  191.661495, 16.577691, 5.12, 1.346, 191.69262, -33.315483, 5.87, 1.326, 191.75961, 5.950373, 6.31, -0.013,
  191.80684499999998, 11.958088, 6.11, 0.122, 191.82891, 62.781155, 5.88, 0.215, 191.88926999999998, -6.301752, 6.27, 0.538,
  191.89309500000002, 66.790304, 5.43, 1.567, 191.930385, -59.688764, 1.25, -0.238, 191.96420999999998, 3.572716, 6.42, 1.596,
  191.97353999999999, -24.851659, 6.43, -0.058, 192.05973, 13.553018, 6.47, 0.015, 192.109455, -27.597384, 5.65, 0.947,
  192.16415999999998, 60.319822, 5.83, 0.467, 192.174255, 48.466838, 6.25, 0.195, 192.196125, 24.840226, 6.29, 0.703,
  192.225885, 14.122584, 5.71, 0.024, 192.27825, 83.417832, 5.92, 0.015, 192.30744, 83.412901, 5.38, 0.033,
  192.32274, 27.552379, 5.76, 0.051, 192.40851, 48.74003, 6.5, 1.135, 192.43731000000002, -71.98626, 5.55, 1.154,
  192.544815, 37.516937, 5.87, 0.17, 192.57204000000002, 22.863408, 6.43, 1.002, 192.58124999999998, -48.459543, 6.26, 0.046,
  192.671535, -33.999302, 4.9, -0.031, 192.741195, -52.787424, 5.7, 0.127, 192.82491, -60.329789, 5.71, 0.344,
  192.845535, -10.338219, 6.48, 1.03, 192.903705, 3.056788, 6.02, 1.288, 192.92467499999998, 27.540712, 4.93, 0.681,
  192.987225, -39.680431, 5.99, -0.098, 192.99126, -26.738275, 6.14, 0.232, 193.022685, -48.094286, 6.31, 0.04,
  193.051065, 17.073943, 6.32, 1.622, 193.102485, -53.829931, 6.26, 1.106, 193.114575, 16.122495, 6.29, 0.173,
  193.26753, -54.952473, 5.91, 1.309, 193.27887, -48.943315, 4.33, 1.344, 193.296495, -3.553098, 6.11, 0.493,
  193.323945, 21.244943, 4.89, 0.904, 193.34124, -60.328489, 5.75, 0.295, 193.359105, -40.178872, 4.25, 0.224,
  193.38380999999998, 19.481061, 6.42, 0.805, 193.40884499999999, -4.224662, 6.45, 1.094, 193.453845, -60.376244, 5.89, 0.2,
  193.45713, 12.418416, 6.25, 0.282, 193.50708, 55.959821, 1.76, -0.022, 193.55457, 33.53448, 6.25, 0.207,
  193.57776, -11.64857, 6, 0.068, 193.588185, -9.538994, 4.77, 1.59, 193.6485, -57.177924, 4.03, -0.18,
  193.65376500000002, -57.16867, 5.08, -0.089, 193.663335, -59.146701, 4.62, -0.153, 193.73552999999998, 47.196722, 5.75, 1.451,
  193.743285, -85.123369, 5.45, 0.991, 193.744035, -44.151968, 5.89, 0.633, 193.831005, -42.915732, 5.46, 1.668,
  193.86897, 65.438474, 5.23, 0.303, 193.90087499999998, 3.39747, 3.39, 1.571, 193.971855, -15.327025, 6.18, -0.001,
  193.98807, -56.835806, 5.34, 0.01, 194.00202, 38.314912, 5.61, 0.337, 194.007105, 38.31838, 2.89, -0.115,
  194.073315, 54.099489, 5.84, 0.204, 194.13213000000002, -72.185212, 5.93, 1.115, 194.24265, -54.587348, 6.48, -0.042,
  194.26818, -51.198752, 5.17, -0.066, 194.28249, 46.176789, 6.11, 1.012, 194.3028, -12.066947, 6.33, 1.491,
  194.388045, -22.753499, 6.31, 1.069, 194.578605, 64.925533, 6.44, 1.15, 194.697135, 75.472508, 6, 1.03,
  194.73102, 17.409446, 4.76, 1.568, 194.91465, -3.811926, 5.79, 0.203, 194.97997500000002, 66.597272, 5.37, 1.282,
  195.06864000000002, 30.785021, 4.88, 1.165, 195.13611, -33.505267, 6.01, 0.386, 195.149775, -3.368488, 5.99, 1.119,
  195.161325, 18.373009, 6.2, 0.466, 195.181875, 56.366338, 4.93, 0.368, 195.290055, 17.123147, 5.97, 0.971,
  195.446055, 63.610225, 6.01, 0.427, 195.54416999999998, 10.95915, 2.85, 0.934, 195.566385, -71.548855, 3.61, 1.19,
  195.66849, 59.716306, 6.5, 0.055, 195.772305, -71.475729, 5.93, 0.002, 195.88884, -49.527264, 4.83, 0.029,
  195.94212000000002, -20.583497, 5.58, 0.554, 196.20099000000002, -41.196322, 6.24, 1.649, 196.20738, 73.024976, 6.43, 0.218,
  196.27779, -47.11691, 6.44, 0.414, 196.37832, -52.11566, 6.43, 1.69, 196.43517, 35.798899, 5.2, -0.059,
  196.46779500000002, 45.26855, 5.64, 1.135, 196.56963, -48.463289, 4.71, -0.148, 196.588515, 21.153397, 6, 0.393,
  196.59417, 22.616187, 5.53, 1.461, 196.595295, 62.041868, 6.15, 0.997, 196.646145, -41.588443, 5.59, 1.05,
  196.726035, -35.862033, 5.63, 0.05, 196.7277, -49.906246, 4.27, -0.182, 196.79469, 27.624741, 4.8, 1.482,
  196.85127, -59.86051, 5.98, 0.435, 196.909575, -53.459764, 5.7, -0.061, 196.97349, 27.555958, 6.2, 1.363,
  196.97421, -10.740408, 5.15, 1.138, 197.02981499999999, -65.306023, 5.44, -0.033, 197.085405, -78.44603, 6.43, 0.008,
  197.115975, -67.796762, 6.34, 1.71, 197.13528000000002, -8.984385, 5.57, 1.178, 197.263635, -23.11807, 4.94, 1.048,
  197.30181, 10.022468, 5.79, 1.025, 197.309325, -9.538098, 6.32, 1.017, 197.41108499999999, 37.423146, 6.01, 1.169,
  197.42514, 38.533885, 6.25, -0.098, 197.43867, -10.329327, 5.95, 1.49, 197.449365, 16.848611, 5.91, 1.45,
  197.48746500000001, -5.53901, 4.38, -0.008, 197.49703499999998, 17.529431, 4.32, 0.455, 197.513445, 38.498981, 5.91, 0.294,
  197.743515, -52.566897, 6.05, -0.079, 197.78707500000002, -42.232891, 5.78, 0.521, 197.846835, -43.368553, 5.24, 1.049,
  197.913345, -26.551722, 6.49, 0.193, 197.96418, -69.942017, 5.92, 0.415, 197.96856, 27.878183, 4.23, 0.572,
  197.97114, -63.302992, 6.32, 0.426, 198.013515, -37.803022, 4.85, 0.693, 198.01476, -16.198601, 5.04, 0.46,
  198.03504, 24.258027, 6.31, 1.006, 198.07338, -59.920579, 4.58, -0.073, 198.10605, 80.471309, 6.25, 0.955,
  198.13717499999998, 11.556096, 5.76, 1.499, 198.20325, -66.226747, 5.91, 0.048, 198.211845, -42.69972, 6.19, 1.057,
  198.232125, -59.816605, 6.18, 0.592, 198.30171, 18.727008, 6.1, 1.201, 198.34734, -50.699829, 5.9, -0.011,
  198.361815, -18.826406, 6.26, 0.088, 198.399765, 36.887582, 6.5, 1.616, 198.428955, 40.152885, 4.94, 1.061,
  198.49047, -43.139107, 6.16, 1.366, 198.54541500000002, -19.930947, 5.31, 0.862, 198.550485, -58.683937, 5.91, 1.084,
  198.56367, -59.103235, 4.9, 0.489, 198.572295, -78.447454, 5.84, 1.04, 198.630345, 11.331656, 5.64, 1.514,
  198.680415, -48.957022, 5.84, 1.061, 198.789435, -36.37141, 6.17, 0.968, 198.8124, -67.894589, 4.79, -0.078,
  198.85711500000002, -69.679284, 6.37, 1.21, 198.88323, 40.855199, 5.77, 0.198, 198.99483, -19.943103, 5.21, 1.011,
  199.05954, 19.051734, 6.46, 0.972, 199.11936, 68.408001, 6.2, -0.052, 199.134435, 19.785289, 6.43, 0.274,
  199.187445, -65.138259, 6.06, 0.431, 199.19382000000002, 9.424156, 5.19, 0.585, 199.212645, 17.017182, 6.49, 0.926,
  199.221375, -31.506196, 5.1, 0.959, 199.30428, -66.783438, 4.86, 1.48, 199.308, -43.979479, 5.82, 0.187,
  199.31511, 13.675751, 5.33, 1.304, 199.37439, -0.676065, 6.36, 0.26, 199.385685, 40.572608, 4.72, 0.306,
  199.40118, 5.469869, 4.78, 1.638, 199.56051, 49.682062, 5.14, -0.049, 199.601445, -18.311196, 4.74, 0.709,
  199.615515, 34.098304, 5.81, 1.366, 199.64532, -51.285776, 6.18, -0.001, 199.70136, -79.976017, 6.34, -0.027,
  199.730385, -23.171512, 2.99, 0.92, 199.76773500000002, 35.127978, 6.01, 0.277, 199.82913, -72.035603, 6.04, 1.341,
  200.079, 40.150548, 5.6, 1.204, 200.14602000000002, -59.77278, 6.2, 0.41, 200.14944, -36.712295, 2.75, 0.068,
  200.157645, -52.747825, 5.47, -0.125, 200.1732, 2.94229, 6.26, 0.102, 200.201415, -55.800688, 6, 0.236,
  200.240505, -46.880008, 5.76, 1.106, 200.37404999999998, -19.489294, 6.21, 0.098, 200.423505, 2.087243, 5.69, 0.045,
  200.5164, 43.903379, 6.34, 0.255, 200.54037, 5.154764, 5.89, 0.109, 200.56786499999998, -52.182956, 5.81, 0.072,
  200.65816500000003, -60.988393, 4.52, -0.141, 200.71878, -47.943221, 6.18, 0.181, 200.719215, -72.146712, 6.06, 0.049,
  200.75464499999998, -17.735274, 5.36, 0.987, 200.76084, -48.562791, 6.37, -0.077, 200.785965, -33.189878, 6.17, 1.653,
  200.82873, -4.924427, 5.88, 1.431, 200.967255, -49.822811, 6.48, 0.959, 200.974695, 37.03392, 6.1, 1.637,
  200.981205, 54.925362, 2.23, 0.057, 200.98785, -20.924587, 6.44, 1.101, 201.00192, -64.535668, 4.52, 0.822,
  201.127215, 12.431832, 6.44, 1.062, 201.13845, -5.16401, 5.76, 0.415, 201.27783, 23.854419, 5.75, 0.09,
  201.28041000000002, -74.887818, 5.04, 1.11, 201.298245, -11.161322, 0.98, -0.235, 201.306195, 54.987958, 3.99, 0.169,
  201.30852, -64.485144, 5.32, 0.411, 201.459855, -70.627248, 5.65, -0.018, 201.50058, 63.261275, 6.5, 0.739,
  201.532245, -39.755107, 5.11, 1.181, 201.53349, 72.391476, 5.82, 1.652, 201.54755999999998, -1.192471, 5.97, 0.183,
  201.56914500000002, 46.028055, 5.88, 0.985, 201.679875, -12.707664, 5.27, 1.477, 201.73382999999998, -41.497562, 5.69, 1.477,
  201.73807499999998, 78.643869, 5.74, 0.769, 201.776625, -49.143709, 6.31, 0.003, 201.811095, -40.162665, 6.4, 0.974,
  201.83607, -49.381291, 6.27, -0.123, 201.86319, -15.973578, 4.76, 1.096, 201.998625, 52.745588, 6.34, 0.259,
  202.007835, -26.402235, 6.49, 1.608, 202.107555, 13.778787, 4.97, 0.714, 202.109325, 40.729646, 6.49, 0.927,
  202.113045, 59.945787, 5.4, -0.01, 202.19090999999997, 50.718569, 6.42, 0.404, 202.19505, -69.627152, 6.17, -0.014,
  202.28311499999998, -64.675794, 6.09, 0.117, 202.30417500000001, 10.81831, 5.65, 1.052, 202.312155, -1.364428, 6.42, 1.122,
  202.35521999999997, -51.165134, 5.04, 0.059, 202.42827, -23.281331, 6.4, 1.317, 202.50033, 7.178853, 6.18, 1.471,
  202.60719, -6.470265, 6.1, 0.341, 202.761075, -39.407307, 3.9, 1.186, 202.81578, 42.106153, 6.07, 1.075,
  202.88823, -28.11274, 6.48, 0.09, 202.99119, -6.255816, 4.68, 1.606, 203.01171000000002, -18.72888, 6.01, 0.196,
  203.02254, -38.398844, 6.14, 1.031, 203.143635, -29.565263, 6.45, 0.438, 203.149605, -28.692768, 5.69, 0.037,
  203.200875, 24.346743, 6.11, 0.969, 203.21518500000002, -15.363012, 5.52, 1.228, 203.241975, -10.165, 5.21, 0.964,
  203.39958000000001, -65.63269, 6.36, -0.014, 203.53046999999998, 55.348434, 5.6, -0.014, 203.53305, 3.658967, 4.92, 0.029,
  203.59109999999998, 38.789265, 6.37, 0.241, 203.61374999999998, 49.015973, 4.68, 0.132, 203.62071, -48.272162, 6.32, -0.052,
  203.668545, -13.214324, 5.92, 0.02, 203.6733, -0.59582, 3.38, 0.114, 203.678325, 76.54671, 6.46, 1.573,
  203.681595, -33.310854, 6.46, 1.25, 203.699145, 37.182415, 4.91, 0.404, 203.880405, -5.396191, 5.7, 0.95,
  203.88927, 10.204962, 6.48, 1.043, 204.16622999999998, 49.486648, 6.48, 1.175, 204.2019, -26.495198, 5.73, 0.22,
  204.21072, -34.467839, 6.48, 1.026, 204.24618, 24.613297, 5.72, 1.593, 204.27508500000002, -44.143203, 5.96, 0.936,
  204.295965, 71.242252, 5.5, 1.219, 204.3012, -61.691856, 5.63, 0.493, 204.347835, -46.427879, 5.91, -0.11,
  204.365175, 36.294898, 4.82, 0.239, 204.53178000000003, -58.414646, 6.41, 1.113, 204.53286, 14.301926, 6.49, 0.274,
  204.675315, -29.560867, 5.81, 0.431, 204.69081, -70.444829, 6.11, 1.415, 204.70399500000002, -57.622717, 6, 1.138,
  204.759525, 18.265323, 6.46, 1.217, 204.80011499999998, -75.683788, 6.32, -0.003, 204.812145, 51.804213, 6.49, 1.378,
  204.87708, 52.921208, 5.46, 0.113, 204.89424, 10.746269, 5.57, 0.348, 204.92019, -39.747587, 6.29, 1.597,
  204.95232, -40.051708, 5.61, 1.301, 204.97194000000002, -53.466394, 2.29, -0.171, 204.99933000000001, -49.949956, 5.74, 1.496,
  205.04484, -64.576553, 5.79, 0.401, 205.06494, 31.012036, 6.21, 0.963, 205.08920999999998, 57.207606, 6.28, 0.111,
  205.09698, 50.519413, 6.31, 0.537, 205.162845, 28.065165, 6.22, 1.311, 205.168635, 19.955719, 5.73, 0.017,
  205.184505, 54.681634, 4.63, 1.63, 205.233855, -85.786043, 5.56, 0.183, 205.25979, 22.495768, 5.63, 1.009,
  205.37437500000001, 64.822411, 5.85, 0.073, 205.40323500000002, -8.702984, 5.03, 1.623, 205.436625, -54.559425, 4.99, -0.055,
  205.504605, -58.787078, 5.38, -0.029, 205.553175, 8.388394, 6.16, 0.418, 205.595685, 82.752408, 5.92, 0.993,
  205.62008999999998, 41.674282, 6.3, 0.879, 205.66395, 78.064437, 5.91, 1, 205.680945, 34.989021, 5.98, 0.857,
  205.727655, -50.790236, 6.43, 1.671, 205.729305, -41.401043, 5.96, 1.019, 205.733805, -56.767971, 6, -0.096,
  205.76547, 3.537903, 5.35, 1.091, 205.91703, -42.067521, 5.96, -0.075, 205.93818000000002, 22.700423, 6.12, 1.447,
  205.97826, 52.064413, 6.02, 0.017, 206.066715, -51.012454, 6.44, -0.106, 206.12427000000002, -16.179072, 5.55, 0.805,
  206.19028500000002, -25.500933, 6.21, 1.374, 206.304855, 55.879349, 6.47, 0.486, 206.30597999999998, 10.325305, 6.42, 1.226,
  206.396115, -15.767467, 6.18, 0.046, 206.403735, -26.116009, 5.81, 0.023, 206.422065, -33.043721, 4.23, 0.39,
  206.48466, -12.426528, 5.5, 0.898, 206.55652500000002, 41.088746, 5.88, 0.211, 206.560515, -54.683368, 6.42, 0.116,
  206.57946, 38.503626, 5.92, 0.948, 206.648595, 54.432679, 5.68, -0.039, 206.66406, -51.432766, 4.64, 0.955,
  206.68051499999999, 25.702236, 5.97, 0.523, 206.7348, -36.251933, 5.15, -0.007, 206.73801, 6.350375, 6.33, 0.63,
  206.749155, 38.542697, 5.51, 1.036, 206.79528000000002, -62.589714, 6.4, -9, 206.805855, -9.709455, 6.04, 1.418,
  206.81565, 17.456906, 4.5, 0.508, 206.85578999999998, -17.859839, 5.41, 1.623, 206.865075, -50.249291, 5.92, 0.279,
  206.88531, 49.313265, 1.85, -0.099, 206.91078000000002, -50.320682, 5.46, 1.351, 207.16140000000001, 31.190206, 5.61, 1.032,
  207.36136499999998, -34.450776, 4.19, 1.52, 207.369345, 15.797905, 4.05, 1.52, 207.37617, -41.687709, 3.41, -0.225,
  207.404145, -42.473732, 3.47, -0.17, 207.42846, 21.264105, 4.92, 1.432, 207.437235, 36.632823, 6.43, 0.256,
  207.43944, 61.489313, 5.97, 0.974, 207.46786500000002, -18.134168, 4.96, 1.059, 207.52713, -29.081321, 6.19, -0.009,
  207.580815, -39.900855, 6.43, 0.992, 207.602835, 5.497224, 6, 0.899, 207.615645, 58.539458, 6.45, 0.094,
  207.74706, 68.3153, 6.39, 1.179, 207.7884, 34.664399, 5.89, 1.635, 207.83483999999999, -24.390368, 6.43, 0.703,
  207.858075, 64.723272, 4.58, 1.572, 207.90213, -36.433279, 6.34, 0.484, 207.94675500000002, -46.898666, 5.77, -0.153,
  207.94761, -69.401258, 5.73, 1.704, 207.94781999999998, 34.44424, 4.76, 1.611, 207.956685, -32.994089, 4.32, -0.146,
  208.004085, -31.619207, 6.11, 0.478, 208.020315, -52.81153, 5.26, -0.084, 208.076685, 12.165135, 6.1, 0.042,
  208.285155, 40.337977, 6.48, 1.55, 208.29288, 28.648131, 5.91, 0.202, 208.302255, -31.927612, 4.75, -0.111,
  208.303875, 17.932868, 5.71, 0.845, 208.386555, -35.664248, 5.53, 0.444, 208.42959, -53.373323, 5.87, 0.009,
  208.462605, 53.728677, 5.7, -0.032, 208.46708999999998, -35.314361, 6.17, 1.009, 208.48851, -47.128164, 5.83, -0.053,
  208.56939, -28.56959, 6.05, 1.129, 208.671165, 18.397717, 2.68, 0.58, 208.675605, -1.503125, 5.16, 1.093,
  208.70469, -67.6521, 5.74, 1.49, 208.742505, -8.058852, 6.19, 0.53, 208.80063, -52.160822, 5.66, -0.072,
  208.885005, -47.288375, 2.55, -0.176, 208.912395, -82.66619, 5.95, 1.411, 208.958325, 14.056503, 6.16, 0.518,
  209.04363, 32.032598, 6.31, 0.401, 209.08255499999999, -46.592948, 5.82, 1.14, 209.08323, -54.13242, 6.14, 0.071,
  209.116155, 1.050581, 5.9, 0.217, 209.137335, -54.704665, 6, 0.78, 209.142405, 27.492082, 5.02, 1.441,
  209.36552999999998, -23.02263, 6.14, 1.426, 209.383665, 61.492861, 6.49, 1.04, 209.41213499999998, -63.686696, 4.71, 1.075,
  209.49531000000002, -25.998079, 6.42, 1.274, 209.56779, -42.100753, 3.83, -0.224, 209.629785, -24.972249, 5.2, -0.086,
  209.63028000000003, -65.800665, 6.2, 1.043, 209.66218500000002, 21.696219, 5.76, -0.002, 209.66628, 14.649275, 6.01, 1.43,
  209.669805, -44.803584, 3.87, -0.208, 209.822805, -50.369647, 5.92, 0.957, 209.95533, -3.549788, 6.36, 0.486,
  210.00055500000002, -25.010403, 5.77, 0.48, 210.07263, -61.481028, 6.49, 0.333, 210.13686, -78.589981, 6.09, 0.007,
  210.21893999999998, -66.26891, 5.96, 0.352, 210.2937, 27.386594, 6.23, 0.193, 210.32943, -40.221943, 6.12, 1.265,
  210.335115, 8.894906, 5.98, 0.089, 210.40338, 17.668391, 6.36, 1.215, 210.411645, 1.544532, 4.23, 0.121,
  210.43122, -45.603421, 4.34, 0.598, 210.46119000000002, 68.678675, 6.34, 1.412, 210.55075499999998, 45.753457, 6.28, 1.353,
  210.59493, -27.429773, 5.47, 1.331, 210.6327, 9.686096, 6.18, 0.853, 210.749025, 50.971809, 6.16, 0.026,
  210.75717, -31.684035, 6.18, 0.48, 210.76698000000002, -17.367012, 6.32, 1.38, 210.860565, -56.213434, 5.93, 1.207,
  210.86448, -41.423345, 6.08, -0.112, 210.88479, 10.786779, 6.27, 0.733, 210.90319499999998, 7.54617, 6.25, 0.927,
  210.955935, -60.373039, 0.61, -0.231, 210.971205, -22.421602, 6.3, 0.452, 210.98232000000002, 4.900973, 6.24, 0.406,
  211.060665, -5.381416, 6.39, 1.321, 211.097475, 64.37585, 3.67, -0.049, 211.112415, -14.971708, 6.35, 1.081,
  211.155945, 2.297531, 6.28, 1.022, 211.33354500000002, -76.796752, 5.69, 1.239, 211.44375, -54.669362, 6.2, 0.225,
  211.51155, -41.179633, 4.36, -0.198, 211.54545000000002, -43.091702, 6.18, 0.986, 211.592895, -26.682361, 3.25, 1.091,
  211.604835, -59.715905, 6.39, 0.079, 211.670925, -36.369954, 2.06, 1.011, 211.67844, -9.313515, 5.46, 0.347,
  211.735215, 74.593781, 6.43, 0.16, 211.920075, -48.704026, 6.43, 0.001, 211.92307499999998, -49.867607, 6.45, 0.66,
  211.98230999999998, 43.854452, 5.13, 1.493, 212.059515, -63.20795, 6.39, 1.013, 212.072175, 49.458167, 5.26, 1.637,
  212.11485000000002, -74.850285, 6.02, 0.581, 212.192145, 59.337649, 6.47, 1.023, 212.21247, 77.547514, 4.8, 1.368,
  212.21622, -43.470779, 6.19, -0.056, 212.234415, -59.276712, 6.34, 0.031, 212.252475, -10.334546, 6.45, 1.003,
  212.39601, -51.504672, 5.96, -0.053, 212.47862999999998, -53.438946, 4.74, 0.938, 212.599725, 25.091677, 4.82, 0.541,
  212.62878, -70.305464, 6.07, 1.718, 212.71035, -16.30203, 4.93, 1.684, 212.75797500000002, -69.719318, 6.07, 0.19,
  212.81301, 32.295892, 6.14, 1.258, 212.880015, 1.362399, 6.42, 0.479, 213.01683, 69.432548, 5.18, 1.595,
  213.06585, 2.409433, 4.99, -0.118, 213.10235999999998, -24.363352, 6.35, 1.351, 213.191775, -27.261186, 5.07, 1.13,
  213.22393499999998, -10.273702, 4.18, 1.323, 213.305235, -26.612309, 6.23, 1.071, 213.31839, -53.665674, 5.53, 1.438,
  213.37077, 51.789965, 4.53, 0.233, 213.415965, -54.625627, 6.09, 0.051, 213.41995500000002, -0.845463, 5.89, 0.489,
  213.52159500000002, 12.959444, 5.53, 0.537, 213.588795, -5.947717, 6.36, 0.593, 213.59814, 41.518757, 6.23, 1.071,
  213.64836, 13.975451, 6.45, 1.348, 213.670665, 21.873392, 6.38, 0.194, 213.677865, -41.837495, 5.61, 0.929,
  213.71187, 10.10061, 5.29, 1.007, 213.720915, 3.335878, 6.41, 1.6, 213.73811999999998, -57.086126, 5.03, -0.074,
  213.755235, -29.281904, 6.1, 0.04, 213.838815, -53.509941, 6.4, 1.576, 213.850365, -18.20069, 5.53, 0.001,
  213.911055, -45.000756, 6.31, 0.596, 213.91545, 19.18241, -0.05, 1.239, 214.00362, -6.000547, 4.07, 0.511,
  214.009995, 45.566268, 6.5, 1.041, 214.041585, 51.367231, 4.75, 0.236, 214.08909, -6.621544, 6.44, 0.275,
  214.09610999999998, 46.088305, 4.18, 0.087, 214.10124, 39.744711, 6.38, 0.376, 214.12569, -3.196305, 6.15, -0.007,
  214.136865, 20.121848, 6.25, 0.504, 214.161345, -66.587894, 5.72, -0.095, 214.20306, -8.884473, 6.47, 1.212,
  214.22983499999998, -77.664221, 6.48, 1.375, 214.26578999999998, -18.5857, 6.22, 0.985, 214.33812, 51.307373, 6.19, 0.07,
  214.36855500000001, 15.26338, 5.84, 1.678, 214.455015, 48.002004, 6.32, 0.466, 214.49925000000002, 35.509505, 4.8, 1.057,
  214.503015, -7.542388, 6.47, 0.723, 214.558155, -81.00776, 4.89, 0.243, 214.659405, -18.715968, 5.86, 0.013,
  214.73298, 54.863753, 6.47, 0.183, 214.75383, -25.815426, 5.87, 0.518, 214.77747, -13.371095, 4.52, 0.128,
  214.779825, -27.141147, 6.35, 1.591, 214.81781999999998, 13.004299, 5.41, 0.385, 214.84953, -37.002907, 5.93, 0.082,
  214.85094, -46.058093, 3.55, -0.184, 214.885335, -2.265518, 5.14, 1.023, 214.92063, 0.384333, 6.18, 0.201,
  214.93849500000002, 16.306948, 4.84, 1.228, 214.94889, 38.794052, 6.33, 0.053, 214.96502999999998, -61.272972, 5.22, 0.281,
  214.971675, -6.746167, 6.42, 0.915, 215.036115, 30.429128, 6.45, 0.156, 215.040435, -43.058843, 5.55, 0.907,
  215.081445, -56.386497, 4.3, 0.082, 215.139345, -37.885295, 4.05, -0.03, 215.17738500000002, -45.18706, 4.78, 0.31,
  215.558355, 29.36992, 6.5, 1.44, 215.582175, -34.786792, 5.57, -0.088, 215.59662, -80.108945, 5.06, -0.108,
  215.654565, -58.459117, 4.76, 0.795, 215.661315, -48.319857, 6.1, -0.13, 215.75933999999998, -39.511819, 4.41, -0.185,
  215.77413, -27.754017, 4.78, 1.3, 215.77846499999998, 25.338173, 6.22, 0.411, 215.81368500000002, 1.241569, 6.25, 0.639,
  215.813985, -47.41696, 6.41, 1.257, 215.83440000000002, -50.772252, 6.03, 1.36, 215.84457, 8.446617, 4.86, 0.01,
  215.85678, -11.714043, 6.22, 0.99, 215.95251, -53.176233, 5.99, 1.099, 216.003645, 8.243969, 5.94, 0.066,
  216.00825, 27.413177, 6.39, 1.609, 216.04726499999998, 5.820131, 5.1, 0.124, 216.076125, 8.084595, 6.19, 1.208,
  216.092355, -82.84825, 6.42, -0.001, 216.170085, -44.311134, 6.43, 1.047, 216.17022, -11.669703, 6.49, 0.417,
  216.20262, -24.80631, 5.34, 0.962, 216.27639, -68.195333, 5.56, 0.435, 216.299505, 51.850744, 4.04, 0.497,
  216.32331, -13.353163, 6.49, 1.223, 216.37145999999998, 38.393053, 6.28, 1.225, 216.41574, -66.172922, 6.36, 0.128,
  216.44904, -26.852241, 6.48, 0.941, 216.534285, -45.221424, 4.56, -0.147, 216.54504, -45.379276, 4.33, 0.434,
  216.55611000000002, -42.318597, 6.33, 1.215, 216.614025, 19.2269, 5.4, 0.231, 216.70782, -39.873989, 6.36, -0.088,
  216.732015, -83.667884, 4.31, 1.3, 216.779595, -65.821646, 5.87, 1.502, 216.80087999999998, -46.134254, 5.83, 0.311,
  216.85161, -6.120332, 6.18, 0.093, 216.88137, 75.695993, 4.25, 1.431, 217.04346, -29.491638, 4.97, -0.074,
  217.05057000000002, -2.227957, 4.81, 0.693, 217.06851, 36.197028, 6.22, 1.174, 217.15795500000002, 49.844851, 5.58, 0.864,
  217.17384, -6.900536, 5.42, 1.49, 217.18125, -59.197548, 6.46, 0.111, 217.216305, -47.992086, 6.4, -0.112,
  217.403235, 41.795911, 6.36, 0.702, 217.404405, -76.729083, 6.06, 1.18, 217.456965, 31.791188, 6.06, -0.013,
  217.46049, 0.828929, 5.96, 0.159, 217.535985, -45.321355, 5.51, -0.087, 217.587345, -49.519018, 5.38, 0.056,
  217.68912, 4.772286, 6.01, 1.421, 217.69248, 63.185788, 6.1, 0.428, 217.73592, -40.845122, 6.39, 1.441,
  217.79517, -38.869708, 5.99, 1.06, 217.81836, -67.717197, 5.84, 1.006, 217.928505, 60.225636, 6.26, 0.243,
  217.9575, 30.371437, 3.57, 1.298, 218.01954, 38.308253, 3.04, 0.191, 218.084295, 26.677284, 6, 0.23,
  218.12889, 55.39801, 5.74, 1.529, 218.13561, 22.260059, 5.91, 0.391, 218.15443499999998, -50.457157, 4.44, -0.177,
  218.2902, -30.715068, 6.07, 1.03, 218.33445, 36.959023, 6.39, 0.521, 218.374875, -52.679522, 5.86, 1.085,
  218.38506, -54.998628, 5.86, 0.482, 218.410665, 79.660427, 6.27, 1.315, 218.548725, 32.534477, 6.32, 0.45,
  218.565945, 57.065258, 6.46, 0.526, 218.66043000000002, 36.626064, 6.02, 1.379, 218.66514, 49.368354, 5.74, 1.56,
  218.67, 29.74513, 4.47, 0.364, 218.71137, -20.439381, 6.49, 0.139, 218.82108, -60.015644, 6.39, 1.256,
  218.87679, -42.157824, 2.33, -0.157, 218.881185, -41.517436, 5.88, -0.085, 219.02863499999998, 23.250359, 6.39, 1.063,
  219.07932, -46.245451, 5.55, 1.489, 219.10047, -39.597407, 6.13, 1.048, 219.1839, -40.21158, 5.74, -0.112,
  219.24912, -12.305349, 6.2, 0.464, 219.301755, -53.060788, 6.49, 1.447, 219.33399, -46.133439, 5.39, 0.927,
  219.36861000000002, 2.277238, 6.45, 0.56, 219.44413500000002, -67.932012, 6.03, 0.506, 219.47181, -49.425828, 4.05, -0.152,
  219.55255499999998, 43.64213, 5.74, 1.481, 219.558285, 18.298379, 5.9, 1.099, 219.5634, 54.023339, 5.83, 0.007,
  219.580665, -38.794184, 6.04, 1.422, 219.709335, 44.4045, 5.39, 0.03, 219.795405, -46.58448, 6.06, 0.508,
  219.85221, -49.055319, 6.37, 0.44, 219.90519, -60.8383, 1.35, 0.9, 219.911475, -60.833976, -0.01, 0.71,
  220.091145, 21.975868, 6.13, 0.434, 220.13652, -56.440761, 6.3, 1.173, 220.17663000000002, 13.534325, 5.93, 0.238,
  220.18152, 16.418324, 4.49, -0.002, 220.255815, -36.134858, 5.67, -0.081, 220.2873, 13.7283, 3.78, 0.044,
  220.411455, 8.161764, 4.86, 0.992, 220.431345, 11.660662, 5.55, 0.941, 220.46349, -30.933156, 6.38, -0.083,
  220.47597, 21.123551, 6.4, 0.928, 220.482345, -47.3882, 2.3, -0.154, 220.48315499999998, -58.615829, 6.21, 0.454,
  220.48998, -37.793498, 4.01, -0.157, 220.49895, -77.011452, 6.34, -0.027, 220.513335, 61.261916, 6.24, 0.409,
  220.62738, -64.975138, 3.18, 0.256, 220.765095, -5.658207, 3.87, 0.385, 220.806465, -24.997753, 5.7, 0.006,
  220.85568, 26.52785, 4.8, 1.672, 220.86726000000002, -62.966671, 6.39, -0.086, 220.91436000000002, -35.173655, 4.06, 1.356,
  220.93515000000002, 40.459254, 5.72, 1.398, 221.231325, -58.477492, 6.1, 1.013, 221.24667, -35.191826, 4.92, 0.013,
  221.24676, 27.074222, 2.35, 0.966, 221.29567500000002, -55.60164, 6.1, -0.066, 221.29878, -1.417529, 6.06, 1.608,
  221.30712, 32.788346, 6.27, 1.61, 221.31025499999998, 16.96428, 4.6, 0.972, 221.32202999999998, -62.875648, 5.36, 0.308,
  221.32847999999998, -51.314927, 6.44, 1.591, 221.335755, 18.884956, 6.15, 0.841, 221.37585, 0.717271, 5.68, -0.021,
  221.49066000000002, -15.459541, 6.33, 1.194, 221.500365, -25.443181, 5.15, 0.315, 221.524785, 15.131788, 5.78, 1.335,
  221.52820499999999, -23.153018, 5.8, 0.98, 221.54535, -21.175966, 6.43, 0.603, 221.56217999999998, 1.892885, 3.73, -0.005,
  221.62086000000002, -47.441116, 5.74, 0.066, 221.75541, -52.383518, 5.22, 0.984, 221.77120499999998, -38.290639, 5.9, 1.336,
  221.80245, -52.205256, 6.07, 0.084, 221.806875, -21.324871, 6.05, 1.649, 221.843985, -25.624267, 5.61, -0.043,
  221.88375, -43.556806, 6.3, 1.068, 221.93668499999998, -26.0875, 5.23, 0.938, 221.965515, -79.044751, 3.83, 1.433,
  221.97895499999998, -12.840007, 6.34, 1.097, 221.98983, -26.646155, 5.76, -0.007, 222.09729, 24.366876, 6.15, 0.506,
  222.158535, -36.634697, 5.89, 1.369, 222.185655, -66.593563, 5.91, -0.106, 222.22539, -0.847655, 6.15, -0.025,
  222.27826499999998, 37.811179, 6.15, 0.389, 222.27961499999998, -56.667829, 6.21, 1.107, 222.327795, 46.116205, 5.76, 0.482,
  222.32810999999998, -24.25147, 5.68, 1.275, 222.329385, -14.149022, 5.32, 0.066, 222.3849, 51.374503, 6.49, 0.401,
  222.4044, -68.93619, 6.5, -0.101, 222.422145, 48.720804, 5.68, 0.501, 222.49332, 28.615832, 5.8, 0.046,
  222.565845, 23.911844, 5.86, 0.576, 222.572205, -27.960371, 4.42, 1.366, 222.58220999999998, 82.511944, 5.63, 0.671,
  222.62365499999999, 37.272047, 5.47, 1.03, 222.671595, -15.997237, 5.15, 0.401, 222.676575, 74.155505, 2.07, 1.465,
  222.719655, -16.041778, 2.75, 0.147, 222.75038999999998, -0.257491, 6.18, 1.397, 222.75447, -2.29915, 4.93, 0.988,
  222.847395, 19.10046, 4.54, 0.72, 222.86043, 59.293985, 5.48, 1.369, 222.875265, -77.17597, 6.44, -0.024,
  222.909615, -43.575359, 4.32, -0.154, 222.96378, -18.355325, 6.27, 1.094, 223.13805000000002, -30.577253, 6.3, 0.605,
  223.14693, -63.809827, 5.91, 0.66, 223.212825, -37.80316, 5.02, -0.155, 223.306455, -73.190071, 5.59, 0.82,
  223.347285, 15.705167, 6.41, 0.569, 223.349085, 19.152798, 6, 0.841, 223.58388, -24.642202, 5.27, 1.336,
  223.59531, -11.898348, 5.78, 0.982, 223.65798, -33.300575, 5.85, 1.429, 223.67745, -65.991095, 6.09, -0.061,
  223.725195, -69.860956, 6.38, -0.059, 223.894305, -60.114164, 5.18, 1.161, 223.93627500000002, -33.855785, 5.32, 0.046,
  223.99416000000002, 32.300063, 6.12, 0.109, 224.05512000000002, 14.446266, 5.9, -0.031, 224.071845, -52.809548, 5.38, 0.142,
  224.09586, 49.628449, 5.63, 0.533, 224.128605, -32.636784, 6.06, 1.413, 224.133585, -47.879198, 5.62, -0.035,
  224.148975, -39.416023, 6.36, 0.061, 224.15976, -62.364417, 6.39, -0.055, 224.18331, -62.781016, 5.08, -0.023,
  224.19213, -11.409701, 5.48, 1.491, 224.264985, 21.555419, 6.5, 0.015, 224.295825, -4.346462, 4.47, 0.318,
  224.29865999999998, 16.388128, 5.72, 0.951, 224.30712, -29.157678, 6.28, -0.011, 224.366475, -21.415475, 5.72, 1.024,
  224.38854, -0.167612, 5.51, 1.131, 224.396145, 65.93246, 4.63, 1.59, 224.471325, -76.662655, 5.37, 1.442,
  224.53668000000002, -48.863011, 6.34, 0.708, 224.63305499999998, -43.13396, 2.68, -0.184, 224.652255, -39.907172, 6.17, 1.216,
  224.66358, -27.657314, 5.65, 0.262, 224.71993500000002, -4.989256, 6.08, 0.509, 224.72325, -11.144014, 5.88, 1.274,
  224.79037499999998, -42.104194, 3.13, -0.208, 224.80803, -37.881234, 6.45, -0.08, 224.84631, 4.567761, 5.91, 1.615,
  224.86332, -43.159833, 6.1, 0.597, 224.90397000000002, 39.265333, 5.64, 0.336, 224.982375, -75.032669, 6.2, -0.038,
  225.047205, -77.16055, 5.92, 1.052, 225.16134, 47.277441, 6.35, -0.099, 225.217815, 22.045589, 6.29, 1.179,
  225.24312, -8.518943, 4.91, 0, 225.304545, -38.058398, 5.88, 1.246, 225.33261, -2.754927, 5.52, 1.692,
  225.36292500000002, 60.204453, 5.91, 0.107, 225.453825, -0.140295, 5.71, 1.509, 225.46131, -83.227646, 5.65, 0.962,
  225.48654000000002, 40.390566, 3.49, 0.956, 225.49201499999998, -34.358875, 6.21, 0.242, 225.526785, -28.060611, 5.83, 0.164,
  225.52711499999998, 25.008138, 4.8, 1.506, 225.53572499999999, -7.575299, 6.38, 0.18, 225.72516000000002, 2.091303, 4.39, 1.026,
  225.746985, -32.643294, 5.45, -0.127, 225.775245, 35.205795, 5.52, 1.023, 225.94761, 47.65406, 4.83, 0.647,
  225.990615, 65.919714, 6.22, 0.055, 226.017585, -25.281965, 3.25, 1.674, 226.11147, 26.947649, 4.52, 1.24,
  226.178745, -40.86133, 6.29, 1.389, 226.195665, -83.038311, 5.65, 1.273, 226.20045000000002, -64.03135, 5.16, 0.935,
  226.27954499999998, -47.051245, 3.91, -0.144, 226.32984, -41.067236, 5.13, 1.011, 226.357725, 48.150972, 5.59, -0.005,
  226.391265, -30.550864, 6.48, 0.489, 226.510065, -48.883391, 6.48, -0.137, 226.558065, -36.264599, 6.27, 1.658,
  226.56957, 54.556318, 5.24, 0.958, 226.61308499999998, -22.03183, 6.13, 1.04, 226.63833000000002, -30.918483, 5.97, -0.076,
  226.64647499999998, 36.456063, 6.35, 0.537, 226.65666, -16.256818, 5.19, 1.589, 226.70442, -16.484361, 6.41, 0.162,
  226.73322000000002, -52.029779, 6.4, -0.109, 226.82523, 24.869195, 4.93, 0.429, 226.83486000000002, 18.441825, 6.03, 0.073,
  226.85811, -49.088612, 5.77, 0.92, 226.91801999999998, 5.498035, 6.16, 0.921, 226.98396, -61.128673, 6.49, 0.432,
  226.98648, -65.275449, 6.18, 1.47, 227.050545, -40.58393, 5.75, -0.113, 227.08141500000002, 50.054955, 6.33, 1.05,
  227.099085, 26.301152, 5.67, 1.24, 227.14818, 25.108635, 5.82, 1.233, 227.163345, -42.867921, 5.85, -0.123,
  227.21091, -45.279857, 4.07, -0.162, 227.22297, 13.235242, 6.16, 0.967, 227.35636499999998, -63.64293, 6.25, 0.059,
  227.37465, -67.084133, 5.76, 0.675, 227.53053, -38.792511, 5.98, 0.867, 227.57764500000002, -26.332621, 5.75, 1.045,
  227.68503, 67.781035, 6.18, 0.143, 227.68692000000001, -61.42232, 6.29, 0.623, 227.786655, -84.787812, 5.88, -0.031,
  227.816595, -55.346032, 5.45, 1.118, 227.89503, -45.277459, 6.44, 1.039, 227.98377000000002, -48.737819, 3.88, -0.029,
  227.990445, -48.743687, 5.7, 0.144, 228.01775999999998, 18.976031, 5.9, 1.414, 228.050055, -19.106482, 6.49, 1.507,
  228.05538, -19.79171, 4.54, -0.071, 228.0714, -52.099247, 3.41, 0.918, 228.13004999999998, -48.218992, 6.32, 1.115,
  228.14166, -72.770599, 6.02, -0.002, 228.19654500000001, 10.702305, 6.5, 1.274, 228.20664, -44.500414, 4.83, -0.177,
  228.254265, -61.74378, 6.27, 1.901, 228.28194, -36.091425, 6.09, -0.081, 228.322545, -24.008322, 6.47, -0.026,
  228.329955, -19.647572, 6.07, 0.124, 228.369555, -25.309347, 6.47, 0.691, 228.382785, 22.983399, 6.31, 0.064,
  228.398265, 38.2647, 6.19, 1.218, 228.47214000000002, -26.193569, 5.84, 1.139, 228.49662, -61.342977, 6.36, -0.041,
  228.52516500000002, 31.787845, 5.98, 1.552, 228.54294, 42.171409, 6.12, 1.635, 228.57987, -70.079476, 5.75, 3.271,
  228.621525, 29.164295, 5.28, 0.062, 228.640665, -17.768572, 6.18, -0.015, 228.65550000000002, -31.519121, 4.91, 0.374,
  228.65889, 67.346722, 5.15, 0.55, 228.71082, -5.502555, 6.28, 1.473, 228.79731, 4.939362, 5.32, 1.092,
  228.87564, 33.314833, 3.46, 0.961, 228.954495, 0.372139, 5.62, 0.181, 228.961245, 50.938456, 6.47, 0.854,
  228.973185, 6.46484, 6.47, 1.308, 228.973605, -48.073661, 5.96, 0.21, 229.016775, -41.491155, 5.15, 0.564,
  229.04359499999998, -43.484997, 6.05, -0.128, 229.095885, -22.399416, 5.52, 1.357, 229.152885, -60.903996, 5.74, -0.057,
  229.21587, -47.864544, 6.46, 0.927, 229.229175, -46.202355, 6.44, 0.514, 229.237065, -60.957255, 5.04, -0.077,
  229.251735, -9.382917, 2.61, -0.071, 229.27452, 71.823901, 5.02, 1.369, 229.37875499999998, -58.801208, 4.07, 0.088,
  229.41204, -63.610465, 4.85, 1.26, 229.45767, -30.148673, 4.35, 1.1, 229.53921, -41.061159, 6.3, 0.176,
  229.59432, 0.939409, 6.5, 1.6, 229.602105, 20.572778, 5.68, 0.972, 229.608855, -0.461234, 5.88, 1.507,
  229.633455, -47.875272, 4.27, -0.086, 229.67209499999998, -31.209347, 6.18, 1.205, 229.704765, -60.496334, 5.43, -0.089,
  229.72771500000002, -68.679545, 2.87, 0.014, 229.734915, -40.788222, 5.59, -0.099, 229.82832, 1.765408, 5.04, 0.54,
  229.87520999999998, 32.514903, 6.33, 0.234, 229.882215, -37.097161, 6.19, 0.959, 230.021445, 51.958515, 5.65, 0.122,
  230.03571, 29.616209, 5.51, 1.015, 230.16898500000002, -67.481526, 6.27, -0.09, 230.173635, 44.434376, 6.14, 0.369,
  230.182245, 71.834016, 3, 0.058, 230.19591, -2.413331, 6.34, 1.062, 230.22366, -18.158658, 6.16, 1.024,
  230.25573, -15.548342, 6.14, 0.393, 230.25831000000002, 0.715337, 5.35, 1.191, 230.278665, 24.95802, 6.36, 1.257,
  230.28171, -5.824853, 5.54, 1.047, 230.343015, -40.647518, 3.22, -0.227, 230.397105, -40.749482, 6.21, 0.068,
  230.4516, -36.261376, 3.57, 1.534, 230.452425, 32.933695, 5.38, -0.051, 230.452605, -48.317628, 5.65, 0.639,
  230.534625, -47.927792, 4.99, 0.515, 230.59683, 12.567521, 6.29, -0.008, 230.65521, 62.047076, 5.99, -0.033,
  230.65572, 39.581463, 5.56, 1.626, 230.660115, 63.341439, 5.72, 1.315, 230.67031500000002, -44.689622, 3.37, -0.191,
  230.68836000000002, -29.341935, 6.5, 1.011, 230.75743500000002, -15.134036, 6.46, 1.603, 230.788965, -36.858489, 4.54, -0.155,
  230.793975, -60.657176, 5.65, 0.489, 230.80124999999998, 30.287812, 4.99, 0.577, 230.844375, -59.320787, 4.48, 0.169,
  230.85411, -46.140415, 6.49, 0.945, 230.93212499999998, -1.022384, 6.11, 0.264, 230.96766, -12.369501, 5.72, 1.039,
  231.02133, 45.271031, 6.07, 1.212, 231.049545, -10.322266, 4.92, 0.453, 231.122715, 37.377167, 4.31, 0.309,
  231.18756, -39.710268, 5.36, -0.093, 231.23241000000002, 58.966065, 3.29, 1.166, 231.33427500000002, -38.73362, 4.6, 0,
  231.44747999999998, 15.428036, 5.16, 1.65, 231.47196, 19.480707, 6.26, 0.618, 231.560835, -68.309167, 5.89, 1,
  231.57249000000002, 34.335996, 5.46, 1.41, 231.634095, 54.020294, 6.44, 0.079, 231.825555, -36.76756, 5.46, -0.15,
  231.88789500000001, -64.531504, 5.71, 1.646, 231.91197, 25.101626, 6.01, 1.654, 231.95727, 29.105703, 3.66, 0.319,
  231.964305, 60.670217, 5.9, 1.441, 232.06420500000002, -16.716484, 5.64, 1.545, 232.08597, -88.13301, 6.49, 0.303,
  232.11337500000002, -51.597934, 6.1, 1.067, 232.15932, 1.842081, 5.15, 0.245, 232.184985, 47.201514, 6.15, 0.1,
  232.236765, 55.194937, 6.45, 0.079, 232.24443000000002, -28.866891, 6.43, 0.608, 232.300485, 16.395618, 6.38, 0.955,
  232.33032, -38.634999, 6.44, 0.351, 232.33797, 62.099529, 6.32, 1.369, 232.351125, -46.732704, 5.26, 1.731,
  232.588725, -41.919027, 6.23, -0.005, 232.594875, 31.285932, 6.45, 0.205, 232.65105, -20.728553, 6.2, 0.192,
  232.668345, -16.609464, 5.82, 1.056, 232.70496, -71.654136, 6.39, -0.112, 232.73232, 40.833047, 5.04, 1.589,
  232.73271, 64.208693, 5.74, 0.976, 232.842945, 36.616599, 6.39, 0.529, 232.854285, 77.349352, 5, 1.545,
  232.87842, -73.389591, 5.4, -0.146, 232.930875, -20.164922, 6.28, 0.22, 232.94577, 40.899332, 4.98, 0.086,
  232.9593, -32.881112, 6.49, 0.065, 233.01747, -38.622543, 6.23, 0.212, 233.040315, 16.056169, 6.22, -0.038,
  233.15292, -19.67046, 5.5, 0.197, 233.230095, -16.852844, 5.53, -0.148, 233.23243499999998, 31.359133, 4.14, -0.127,
  233.241405, -1.186399, 5.5, 1.092, 233.28966000000003, -24.490433, 6.26, 0.33, 233.351325, -40.490852, 6.4, 1.016,
  233.469615, 17.137359, 6.49, 0.341, 233.507145, -40.066432, 5.82, 1.695, 233.54457, -10.064529, 4.61, 1,
  233.58689999999999, -39.34921, 6.36, -0.017, 233.61048000000002, -9.183416, 5.16, -0.09, 233.655495, -28.046983, 5.13, 1.306,
  233.67192, 26.714693, 2.22, 0.032, 233.700615, 10.538867, 3.8, 0.268, 233.785215, -41.166757, 2.8, -0.216,
  233.81214, 39.010067, 5.14, 1.65, 233.817525, 53.922144, 5.97, 1.184, 233.881575, -14.789537, 3.91, 1.007,
  233.888475, 17.655555, 6.1, 0.975, 233.95497, 38.373926, 6.3, 1.306, 233.97189, -44.958389, 4.55, -0.175,
  233.97236999999998, 11.265656, 6.04, 1.125, 233.98773, 54.630567, 5.77, 0.051, 234.04735499999998, -33.092806, 6.26, -0.07,
  234.05046, -44.396823, 5.44, 1.497, 234.121815, 16.119085, 5.93, 0.354, 234.12324, 10.010176, 5.26, 0.925,
  234.18, -66.317037, 4.11, 1.161, 234.222585, 29.991182, 6.46, 0.433, 234.25605, -28.135079, 3.6, 1.361,
  234.368745, -26.279864, 6.19, -0.013, 234.38343, 54.508733, 5.85, 1.098, 234.41325, 69.283344, 5.65, 1.371,
  234.450165, -23.141698, 5.79, 1.074, 234.456615, 40.353433, 5.25, 0.886, 234.51348000000002, -42.567348, 4.34, 1.412,
  234.565875, -28.206666, 6.32, 1.176, 234.567495, 46.797751, 5.76, 0.353, 234.567825, -21.016327, 5.82, 1.077,
  234.642495, 50.423283, 5.84, 0.847, 234.66405, -29.777754, 3.66, -0.177, 234.66700500000002, -8.79149, 6.45, 0.505,
  234.675735, -39.127734, 6.05, 0.204, 234.70355999999998, 34.675039, 6.12, 1.039, 234.706185, -52.372695, 5.43, 0.005,
  234.72732000000002, -19.301892, 5.36, 0.883, 234.789675, 57.924426, 6.45, 1.102, 234.827385, -77.918004, 6.19, 1.207,
  234.839055, -23.150224, 6.33, 0.023, 234.84448500000002, 36.635812, 4.64, -0.103, 234.94158000000002, -34.411926, 4.66, 0.964,
  234.98588999999998, -59.908338, 5.95, 0.505, 235.043115, 12.052934, 6.22, 0.968, 235.04833499999998, -70.227883, 6.45, 0.077,
  235.06471499999998, -31.213771, 6.35, 1.418, 235.0704, -23.818078, 4.97, 1.302, 235.08897000000002, -73.446685, 5.64, -0.04,
  235.24266, -47.736091, 6.21, 1.621, 235.246245, 16.024588, 6, 0.908, 235.297575, -44.661205, 4.64, 0.413,
  235.38773999999998, 19.670401, 4.51, 0.062, 235.44755999999998, 12.847528, 5.34, 0.033, 235.477905, -76.081959, 5.95, -0.034,
  235.47798, 18.464037, 5.8, 0.207, 235.48666500000002, -19.678828, 4.75, 1.574, 235.655115, -49.489553, 6.02, 1.315,
  235.659675, -37.424935, 5.23, 0.987, 235.67092499999998, -34.710407, 4.75, -0.151, 235.68571500000002, 26.295637, 3.81, 0.02,
  235.711605, 52.360903, 5.48, -0.042, 235.79388, 13.667666, 6.48, 0.873, 235.817415, -84.465273, 5.57, 0.118,
  235.85358000000002, -15.04323, 6.3, 1.124, 235.98033, -60.287217, 6.46, 1.02, 235.99710000000002, 32.515807, 5.57, 1.076,
  236.007585, 2.515173, 5.86, 0.684, 236.014485, 77.794493, 4.29, 0.038, 236.01834, -15.672834, 5.41, 0.238,
  236.06697, 6.425627, 2.63, 1.167, 236.094495, -41.819089, 5.93, -0.007, 236.175555, 17.264226, 6.15, 0.002,
  236.24826, -50.785463, 6.41, 0.163, 236.347845, 5.447315, 5.57, 0.035, 236.41460999999998, 0.891039, 6.32, 1.195,
  236.523495, -1.804193, 5.39, -0.035, 236.546895, 15.421826, 3.65, 0.073, 236.55357, -28.061481, 6.49, 0.332,
  236.61090000000002, 7.353073, 4.42, 0.604, 236.64505499999999, 55.474791, 5.94, 1.404, 236.66658, 62.599557, 5.19, 0.062,
  236.68425, -34.682454, 5.61, -0.117, 236.689275, -6.120355, 6.24, 1.169, 236.82216000000003, 14.115348, 5.71, 0.094,
  236.85645, -40.19421, 6.41, 0.88, 236.871525, -37.916312, 6.01, 0.715, 236.908005, 55.376627, 5.85, 0.249,
  236.97117, -65.442291, 5.54, 0.231, 237.00746999999998, 31.735615, 6.41, 1.517, 237.05544, 13.789078, 5.98, 1.272,
  237.14339999999999, 28.156749, 5.89, 0.608, 237.184905, 18.141564, 4.09, 1.616, 237.210075, -52.438256, 6.05, 1.385,
  237.236655, -3.818513, 5.53, 0.12, 237.39855, 26.068394, 4.59, 0.794, 237.40503, -3.430208, 3.54, -0.036,
  237.4896, -48.912408, 5.86, 0.068, 237.52956, -53.20977, 5.78, -0.076, 237.56793, -45.401714, 6.11, 0.299,
  237.573105, 2.196509, 5.21, 1.019, 237.704025, 4.47773, 3.71, 0.147, 237.73974, -33.627165, 3.97, -0.045,
  237.74478000000002, -25.751295, 4.63, -0.072, 237.778365, -55.055533, 5.74, 0.017, 237.80805, 35.657382, 4.79, 0.996,
  237.814965, -3.090497, 5.09, 0.135, 237.81629999999998, 20.977919, 4.74, 1.534, 237.88104, -47.0608, 6, 1.152,
  237.90999, -14.133584, 6.2, 1.01, 238.053375, -29.886552, 6.39, 0.991, 238.06903499999999, 55.826713, 5.81, 0.972,
  238.168545, 42.451518, 4.6, 0.563, 238.23382500000002, 17.40315, 6.29, 1.238, 238.30041, 13.196623, 6.07, 0.598,
  238.333575, -20.16704, 5.04, -0.014, 238.34556, -62.606583, 6.22, 1.467, 238.395285, 16.074933, 6.21, 0.413,
  238.402995, -25.327142, 4.59, -0.073, 238.456395, -16.729293, 4.13, 1.003, 238.47465, -24.533157, 5.38, -0.011,
  238.482765, -23.978094, 5.41, -0.033, 238.62546, -27.338639, 6.15, -0.069, 238.644225, 20.310968, 5.45, 1.588,
  238.65774, 43.138567, 5.35, 1.645, 238.664715, -25.243741, 5.87, -0.065, 238.66781999999998, 8.580337, 6.28, 0.171,
  238.719315, -60.743651, 6.14, 0.121, 238.75152, -19.382926, 5.95, -0.013, 238.786245, -63.430727, 2.83, 0.315,
  238.873365, -68.603001, 5.11, 1.108, 238.87534499999998, -26.265993, 5.63, 0.141, 238.87722, -31.083644, 6.21, 1.371,
  238.87749000000002, 42.566193, 5.73, -0.102, 238.884975, -60.177647, 5.78, 0.355, 238.916055, 18.620745, 6.26, -0.089,
  238.94826, 37.946958, 5.43, 0.352, 238.956825, 58.911774, 6.31, -0.028, 239.02473, -60.482477, 5.76, 0.087,
  239.028495, -39.864364, 6.04, 0.13, 239.058435, -31.785882, 6.29, 0.462, 239.06013, -14.399402, 6.32, 0.485,
  239.11323000000002, 15.661617, 3.85, 0.478, 239.13906, -14.829438, 6.11, 0.243, 239.22115499999998, -29.214073, 3.87, -0.199,
  239.222895, -33.966134, 5.14, 0.129, 239.22549, -33.964281, 5.59, 0.072, 239.2662, -48.162186, 6.31, 0.381,
  239.31072, 14.41448, 5.54, 1.141, 239.33885999999998, -36.185344, 5.78, 1.095, 239.37431999999998, 39.695086, 6.3, 1.11,
  239.39691000000002, 26.87788, 4.14, 1.231, 239.4186, -20.98308, 5.84, 0.012, 239.44794, 54.749762, 4.96, 0.269,
  239.547375, -14.279358, 4.95, -0.08, 239.62833, -37.503878, 6.31, 1.006, 239.64528, -24.831488, 5.43, -0.092,
  239.712975, -26.114105, 2.89, -0.18, 239.740455, 36.643773, 5.61, 1.529, 239.742315, -65.037585, 5.74, -0.066,
  239.76828, 49.881043, 6.04, 0.289, 239.876145, -41.744436, 4.99, 0.988, 239.97561, -54.020911, 6.1, -0.016,
  239.979735, -78.027277, 6.4, 0.387, 240.03054, -38.396706, 3.42, -0.206, 240.081705, -16.53335, 5.47, 0.517,
  240.08335499999998, -22.62171, 2.29, -0.117, 240.19846500000003, -8.411353, 5.53, 0.043, 240.21305999999998, 4.427363, 5.82, 1.003,
  240.223785, -40.43548, 6.21, 0.01, 240.26118, 33.303509, 5.39, 0.612, 240.27702, -54.577899, 6.12, 0.264,
  240.29466, -63.776538, 6.42, 0.567, 240.30966, 17.818397, 5.1, 0.992, 240.33147, -31.889137, 6.33, 1.454,
  240.360705, 29.851061, 4.98, -0.05, 240.47297999999998, 58.565251, 4.01, 0.528, 240.51867, -51.120771, 6.38, -0.003,
  240.52315500000003, 52.915917, 5.93, 1.498, 240.57371999999998, 22.804454, 4.82, 0.066, 240.664245, -29.1358, 6.07, 1.304,
  240.69951, 46.036705, 4.72, -0.094, 240.71880000000002, -62.54159, 6.25, -0.015, 240.78898500000003, 59.410738, 6.19, 1.576,
  240.80368499999997, -49.229695, 4.65, 0.902, 240.830685, 36.631787, 5.79, 0.586, 240.83595, -25.86524, 4.96, 1.234,
  240.8508, -38.602541, 4.9, -0.146, 240.88076999999998, 76.793939, 5.73, 0.051, 240.88396500000002, -57.775064, 4.63, 0.252,
  240.89317499999999, -32.000538, 6, 0.47, 240.94037999999998, 4.986834, 6.07, 0.96, 240.977925, -24.726312, 6.22, 1.386,
  241.025835, -59.176182, 6.4, 1.366, 241.074255, -33.213718, 6.1, 0.338, 241.08885000000004, -53.710375, 6.46, 0.006,
  241.15348500000002, -37.862951, 5.91, 0.409, 241.35930000000002, -19.805453, 2.56, -0.065, 241.36065000000002, -19.80186, 4.9, -0.024,
  241.40808, 8.096248, 6.27, 0.084, 241.43565, -6.291129, 6.35, 0.413, 241.482765, -72.400898, 5.7, 1.169,
  241.49922, -6.139754, 6.39, 1.034, 241.52658, -23.606315, 5.9, -0.071, 241.58212499999996, 67.810134, 5.44, -0.019,
  241.62264, -45.173185, 4.73, 0.23, 241.64811000000003, -36.802288, 4.22, -0.184, 241.70177999999999, -20.669192, 3.93, -0.046,
  241.76406, -14.071292, 6.32, 0.66, 241.81752, -36.755676, 5.72, 0.298, 241.842405, 21.822615, 6.15, 1.365,
  241.85035499999998, -56.190956, 6.16, 0.565, 241.85136, -20.868764, 4.31, 0.831, 241.90173, -12.74541, 5.75, 0.018,
  241.90641, 9.891743, 5.63, 0.2, 241.96620000000001, -24.462349, 6.32, -0.038, 242.018865, 17.04698, 5, 0.931,
  242.02065, 17.054382, 6.25, 1.14, 242.03158500000004, -26.326679, 5.35, 1.643, 242.11697999999998, 8.53431, 5.69, 1.575,
  242.15214, 8.613176, 6.47, 1.418, 242.18217, -23.685416, 5.86, 0.02, 242.19243, 44.934906, 4.23, -0.045,
  242.19429, 17.205638, 6.13, -0.003, 242.24293500000002, 36.490944, 4.73, 1.015, 242.24533499999998, 3.454475, 5.93, 1.471,
  242.26209, 57.937883, 6.33, 0.032, 242.29672499999998, 6.378695, 5.93, 0.988, 242.32730999999998, -57.934318, 5.57, -0.024,
  242.35828500000002, 55.828975, 6.43, 1.076, 242.38227, -32.649012, 6.18, 0.79, 242.460495, -3.466729, 5.39, 1.446,
  242.469135, -33.545805, 5.5, -0.075, 242.48031, -18.34062, 6.43, 0.447, 242.496615, -62.967154, 6.5, 0.231,
  242.70636, 75.877563, 5.48, -0.093, 242.75865000000002, -29.41622, 5.09, 1.131, 242.82384, -41.119803, 5.86, 0.273,
  242.86974, 16.665692, 6.09, 0.02, 242.90848499999998, 23.494801, 5.74, 1.519, 242.914995, 33.342764, 6.3, 1.228,
  242.94834000000003, 42.374569, 5.89, 1.464, 242.95022999999998, 36.425094, 5.62, 1.352, 242.99889000000002, -19.460708, 4, 0.076,
  242.999955, -10.064253, 4.93, 0.087, 243.02727, 39.055524, 6.39, 1.262, 243.03047999999998, -8.547576, 5.43, 0.118,
  243.06684, -28.417305, 5.67, 0.012, 243.075855, -27.926372, 4.58, -0.172, 243.105705, 67.144176, 6.21, 0.993,
  243.13404000000003, 75.210681, 6.36, 1.283, 243.189435, 26.670583, 6.48, 0.391, 243.23576999999997, -4.220809, 6.26, 0.133,
  243.31429500000002, 5.021086, 5.46, 1.472, 243.320715, -53.671171, 6.03, 1.965, 243.34476, -55.540947, 5.78, 0.365,
  243.36971999999997, -54.630467, 4.95, 1.017, 243.41082000000003, -1.475133, 6.45, 0.997, 243.439575, -24.422092, 6.4, 0.043,
  243.46210499999998, -11.837747, 5.24, 1.394, 243.55669500000002, 5.901846, 6.3, 1.148, 243.58641000000003, -3.694323, 2.73, 1.584,
  243.59319000000002, -33.011088, 5.91, 1.021, 243.62035500000002, -21.107636, 6.41, 0.002, 243.63942, 73.394891, 6.02, 0.063,
  243.663525, -18.535649, 6.32, 1.085, 243.67034999999998, 33.858613, 5.23, 0.599, 243.722625, -25.476976, 6.06, 0.027,
  243.813855, -47.372021, 5.13, -0.114, 243.84984, -42.899422, 6.14, 1.114, 243.85945500000003, -63.685682, 3.86, 1.105,
  243.86932499999998, 18.808087, 5.72, 1.126, 243.90528, -8.369442, 5.49, 0.652, 243.94718999999998, 27.422081, 6.14, 1.334,
  243.95750999999998, -57.91235, 5.61, 0.137, 243.96455999999998, -14.849115, 6.09, 0.098, 244.18030500000003, -53.811109, 5.45, 1.696,
  244.186605, 29.150261, 5.8, 0.063, 244.23042, -3.953349, 6.18, 0.326, 244.24562999999998, -53.696234, 6.4, 0.793,
  244.24666500000004, -20.104088, 6.4, 1.27, 244.253895, -50.068122, 4.97, 0.788, 244.272735, -67.941285, 5.95, 0.159,
  244.31392499999998, 59.755023, 5.37, 1.551, 244.33724999999998, -53.086385, 6.3, 0.273, 244.376865, 75.75533, 4.95, 0.393,
  244.43065499999997, 1.496714, 6.5, 1.128, 244.54081499999998, 68.554545, 6.39, 1.343, 244.57459500000002, -28.61402, 4.8, 0.008,
  244.58036999999996, -4.692511, 3.23, 0.966, 244.75174500000003, -14.872825, 5.97, 1.475, 244.782165, -20.218072, 6.29, 1.066,
  244.79674500000002, 49.038159, 5.93, 1.369, 244.82351999999997, -42.673965, 5.44, 0.099, 244.88637, -30.906716, 5.53, 0.466,
  244.935165, 46.313366, 3.91, -0.151, 244.960305, -50.155508, 4.01, 1.08, 244.97985000000003, 39.708584, 5.48, 0.41,
  245.01781499999998, 21.13261, 6.04, 0.938, 245.086785, -78.695745, 4.68, 1.68, 245.10517499999997, -55.139706, 5.76, 0.97,
  245.11192499999999, -78.667496, 5.27, 1.413, 245.13590999999997, -39.430344, 6.11, -0.079, 245.15908499999998, -24.16932, 4.55, 0.758,
  245.297145, -25.592796, 2.9, 0.299, 245.45304, 69.109391, 5.26, 1.115, 245.48007, 19.15313, 3.74, 0.299,
  245.51812500000003, 1.029039, 4.82, 0.338, 245.52430499999997, 30.891996, 4.86, 0.97, 245.58927, 33.799052, 5.2, 1.631,
  245.61666, -49.572354, 5.32, -0.047, 245.621115, -43.912051, 5.89, 1.121, 245.621745, 33.703478, 5.4, 1.523,
  245.66210999999998, -2.07987, 6.24, 0.058, 245.73539999999997, 32.333013, 6.41, 0.083, 245.946555, 61.696461, 5.67, 0.956,
  245.986335, -33.199396, 6.45, 0.013, 245.99790000000002, 61.514213, 2.73, 0.91, 246.00532500000003, -39.19298, 5.37, 0.625,
  246.02577, -20.037327, 4.48, 0.996, 246.04512, 6.948207, 5.83, 0.018, 246.10555499999998, 55.205096, 5.75, 0.001,
  246.132315, -37.566044, 5.42, -0.104, 246.16568999999998, -29.704663, 5.4, 0.625, 246.22563, -45.349499, 6.32, 0.187,
  246.34225499999997, -63.125217, 6.14, 0.029, 246.35070000000002, 37.394079, 5.53, 0.174, 246.35396999999998, 14.03327, 4.57, 0.002,
  246.39632999999998, -23.447178, 4.57, 0.227, 246.43110000000001, 78.963854, 5.55, 0.249, 246.54744000000002, 11.407493, 6.11, 1.065,
  246.708645, 2.347944, 6.06, 0.919, 246.755985, -18.456251, 4.22, 0.217, 246.796005, -47.554786, 4.46, -0.07,
  246.88446000000002, 2.870633, 6.35, 1.638, 246.93106500000002, -7.597929, 5.24, 1.721, 246.950775, -8.371731, 4.62, 0.185,
  246.98877, -64.057942, 5.28, 0.383, 246.996, 68.768137, 4.94, -0.051, 247.060275, -37.179881, 5.79, 1.104,
  247.06321499999999, -58.599795, 5.67, 0.008, 247.08814500000003, 67.044, 6.45, 1.517, 247.11633, -70.084401, 4.9, 0.555,
  247.14159, 0.665002, 5.41, 1.461, 247.160595, 41.881677, 4.83, 1.289, 247.17631500000002, 0.054855, 6.46, 1.378,
  247.180965, 51.407738, 6.31, 1.052, 247.20397499999999, -8.128843, 6.49, 0.41, 247.35191999999998, -26.432002, 1.06, 1.865,
  247.42636499999998, -46.243229, 5.35, 0.488, 247.43842500000002, -57.756323, 6.09, 1.459, 247.445505, -14.550879, 5.66, 0.823,
  247.52521500000003, 48.96109, 6.44, 0.026, 247.55199, -25.115224, 4.79, -0.116, 247.55502, 21.489613, 2.78, 0.947,
  247.62506999999997, -7.514451, 6.46, 0.371, 247.63979999999998, 20.479188, 5.24, 1.274, 247.662585, 77.446514, 6.35, 0.995,
  247.705695, -61.633503, 5.19, 1.236, 247.72843500000002, 1.983923, 3.82, 0.022, 247.76160000000002, 35.225066, 6.25, 1.64,
  247.784865, -16.612733, 4.29, 0.924, 247.80597, 22.195458, 5.76, 1.605, 247.84522500000003, -26.537643, 6.07, 1.085,
  247.845555, -34.704366, 4.24, -0.168, 247.86783000000003, 72.612338, 6.27, 1.291, 247.92403500000003, -41.817145, 5.31, 0.299,
  247.94679000000002, 45.598281, 5.61, 0.125, 248.034165, -21.46639, 4.45, 0.13, 248.106945, 60.823323, 5.92, 0.039,
  248.14869, 5.52122, 5.63, -0.044, 248.15122499999998, 11.488041, 4.84, 1.495, 248.36413499999998, -78.897148, 3.86, 0.923,
  248.520915, -44.045315, 4.86, 0.045, 248.52575999999996, 42.437041, 4.2, -0.013, 248.58066000000002, -70.988097, 5.5, 1.235,
  248.782305, -45.244366, 6.43, 1.346, 248.85954, 17.057342, 6.42, 0.062, 248.936625, -65.495399, 5.5, 0.949,
  248.97064500000002, -28.216016, 2.82, -0.206, 249.046695, 46.613333, 5.83, 1.044, 249.04761, 52.900048, 5.53, -0.06,
  249.05718000000002, 52.924422, 5.07, -0.027, 249.08937000000003, -2.324584, 5.77, 0.827, 249.09363000000002, -35.255326, 4.18, 1.535,
  249.09402, -42.858861, 5.46, 0.338, 249.17891999999998, 15.497455, 6.36, -0.055, 249.229125, 63.072824, 6.17, 1.527,
  249.28974000000002, -10.56709, 2.54, 0.038, 249.39066, 5.277526, 6.48, 1.15, 249.450045, 13.687035, 6.3, 0.433,
  249.46998000000002, 78.918667, 6.33, 1.141, 249.50193000000002, 56.01554, 5.28, 1.055, 249.506475, -6.538014, 6.05, 0.165,
  249.60955500000003, -43.398426, 5.83, -0.053, 249.68690999999998, 48.928342, 4.86, 1.562, 249.698865, -8.61861, 6.44, 1.806,
  249.71961000000002, -60.990402, 6.16, -0.073, 249.77177999999998, -37.21737, 5.93, -0.035, 249.91303500000004, -9.554589, 6.33, 0.492,
  250.14382500000002, -20.408649, 6.25, 1.077, 250.16119500000002, 4.219789, 5.77, -0.004, 250.184985, -51.47826, 6.3, 0.321,
  250.2102, -60.446442, 6.17, 0.488, 250.21392000000003, 12.395043, 6.08, 0.046, 250.22967, 64.589046, 4.84, 1.212,
  250.23504, -8.309628, 6.47, 1.147, 250.25244000000004, 24.858705, 6.07, 1.316, 250.2981, -1.000312, 6.25, 0.313,
  250.31973000000002, 1.245444, 6.4, 1.019, 250.32169500000003, 31.602726, 2.81, 0.65, 250.33506, -48.762957, 5.57, 0.169,
  250.34634, -68.296123, 5.89, -0.078, 250.39326, -17.742167, 4.91, 1.095, 250.40075999999996, -24.467962, 6.07, 0.214,
  250.402905, 26.91688, 5.92, 0.402, 250.41760500000004, -49.651552, 5.62, -0.043, 250.42701, 1.181231, 5.74, 0.336,
  250.439415, -33.145759, 5.84, 0.653, 250.47370499999997, -19.924377, 5.55, 0.436, 250.61570999999998, 49.936441, 6.48, 0.541,
  250.62123000000003, -37.079353, 6.47, 0.776, 250.70175000000003, -62.553931, 6.23, 1.524, 250.72399499999997, 38.922254, 3.48, 0.916,
  250.74348000000003, 55.690119, 6.18, 0.088, 250.76485499999998, -46.070293, 6.22, 0.821, 250.77189, -77.517435, 4.23, 1.06,
  250.7757, 77.513973, 5.99, 0.43, 250.84218, -67.432386, 6.02, 0.037, 250.91134500000004, -32.105945, 6.46, -0.076,
  250.940355, -41.119204, 6.21, 0.143, 250.94832, -38.156346, 6.05, -0.054, 250.965405, 34.038803, 6.02, 0.321,
  250.975335, -41.113344, 6.14, -0.078, 251.16561000000002, -53.152313, 5.96, 1.23, 251.17747500000002, -40.839675, 5.64, -0.093,
  251.250795, -28.509657, 5.99, 0.103, 251.299155, 43.217169, 6.07, 1.415, 251.32419000000002, 56.781857, 4.84, 0.375,
  251.34382499999998, 15.745289, 5.6, 1.637, 251.373645, 1.020161, 6.02, -0.012, 251.457885, 8.582616, 5.15, 1.535,
  251.49238499999998, 82.037262, 4.21, 0.897, 251.52655499999997, -46.531996, 6.47, 0.087, 251.58844500000004, -58.503595, 5.74, -0.101,
  251.66668499999997, -67.109691, 5.1, -0.08, 251.699835, -39.376962, 5.48, 0.975, 251.79064499999998, 2.064526, 6.07, 0.14,
  251.831925, -58.341441, 5.55, -0.096, 251.83227, 42.238918, 5.86, 1.504, 251.94340499999998, 5.246746, 5.22, -0.001,
  252.037005, 13.590296, 6.38, 0.877, 252.11239500000002, -14.909421, 6.03, 0.192, 252.166155, -69.027715, 1.91, 1.447,
  252.309225, 45.983323, 4.82, 0.087, 252.36529499999997, -15.66797, 6.18, 0.234, 252.39441000000002, 13.261141, 5.91, 0.015,
  252.41904000000002, 43.430437, 6.18, 1.257, 252.4464, -59.041378, 3.77, 1.562, 252.458445, -10.783, 4.64, 0.478,
  252.54119999999998, -34.293232, 2.29, 1.144, 252.58075499999998, 7.247683, 5.48, 0.108, 252.59271, -2.654356, 6.32, 0.401,
  252.65034, -50.044946, 6.45, 0.325, 252.650445, 41.8965, 6.29, 1.086, 252.662325, 29.806538, 5.73, 1.626,
  252.679785, 32.553668, 6.16, 1.014, 252.75015000000002, -37.514512, 6.1, 0.124, 252.85387500000002, 1.215947, 5.51, 0.055,
  252.890505, -41.230534, 5.23, 0.047, 252.93859500000002, 24.656433, 5.03, 1.246, 252.96763500000003, -38.04738, 3, -0.2,
  252.97452, -65.375457, 6.12, -0.028, 253.07396999999997, -67.681633, 6.33, 1.289, 253.08019499999997, -41.854514, 6.36, 0.264,
  253.083945, -38.017536, 3.56, -0.21, 253.11424499999998, -40.723153, 6.35, -0.141, 253.24194, 31.701674, 5.34, 0.319,
  253.323195, 47.416725, 5.99, 1.325, 253.35509999999996, -20.415555, 5.86, 0.685, 253.42678500000002, -43.050968, 5.95, 1.643,
  253.49523, -41.994327, 6.28, 0.462, 253.49885999999998, -42.362025, 4.7, 0.444, 253.50159000000002, -57.909507, 5.91, 1.592,
  253.50196499999998, 10.165359, 4.39, -0.088, 253.50765, -41.806389, 5.46, 0.176, 253.54192500000002, -41.82504, 6.07, 0.126,
  253.54419000000001, -1.612304, 6.25, 0.283, 253.61226, -42.478891, 5.84, 0.626, 253.631475, -49.7108, 6.49, 1.466,
  253.64596500000002, -42.361313, 3.62, 1.393, 253.648725, -6.153982, 5.23, 1.1, 253.64981999999998, -30.58734, 6.34, 0.214,
  253.72985999999997, 20.958488, 5.39, 0.966, 253.743765, -41.150858, 5.78, 0.132, 253.75900499999997, 25.730681, 6.06, 0.921,
  253.76387999999997, -42.090831, 6.3, 0.396, 253.81662, 13.61991, 6.35, 0.339, 253.842375, 18.433213, 5.35, 1.407,
  253.852845, -63.269659, 5.99, 0.059, 253.99062000000004, -33.506873, 6.29, 1.747, 254.00625, 65.134796, 4.88, 0.481,
  254.00767500000003, -16.806263, 6.33, 0.952, 254.03685000000002, -50.67479, 6.3, -0.016, 254.06973000000002, 73.127867, 6.29, 0.259,
  254.10539999999997, 65.039124, 6.4, 0.383, 254.11991999999998, -52.283746, 5.94, -0.069, 254.149905, -40.823453, 6.18, 0.228,
  254.20015500000002, -23.150346, 5.57, -0.018, 254.25441, -71.111644, 6.46, 0.26, 254.26658999999998, -19.539856, 6.27, 0.084,
  254.29656, -33.259492, 5.48, 1.606, 254.35833000000002, -10.963373, 6.15, 1, 254.37936000000002, 25.352841, 6.27, 0.909,
  254.3835, 13.884113, 6.38, 0.93, 254.417085, 9.375033, 3.19, 1.16, 254.42628000000002, 24.38126, 6.35, 1.089,
  254.459085, 42.512451, 6.36, 1.28, 254.574765, -50.641185, 5.53, 0.016, 254.65509, -55.990141, 3.12, 1.552,
  254.67316500000004, -14.869671, 6.48, 0.391, 254.71774500000004, -37.620508, 6.05, 0.179, 254.76072000000002, 69.186248, 6.41, 0.725,
  254.83973999999998, 56.688594, 6.04, 1.165, 254.891565, -69.268164, 5.79, -0.103, 254.89603499999998, -53.160438, 4.06, 1.452,
  254.990445, -25.092198, 5.88, 1.607, 255.026175, -54.597179, 5.64, 0.194, 255.039615, -24.98907, 5.74, 0.407,
  255.05937, -44.988548, 6.5, 0.403, 255.07240499999997, 30.926405, 3.92, -0.018, 255.11235000000002, -48.647759, 5.98, 0.883,
  255.154125, -35.934133, 5.95, 1.161, 255.242235, 22.632095, 5.69, 1.332, 255.24352500000003, -86.364297, 6.05, 0.043,
  255.265005, -4.222644, 4.82, 1.483, 255.27927, -56.555077, 6.4, 0.1, 255.32062499999998, 60.648754, 6.16, 1.006,
  255.38772, 14.949717, 6.27, 0.031, 255.401505, 33.56827, 5.27, 0.028, 255.41703, 75.297497, 6.17, 0.306,
  255.44314500000002, -51.131026, 6.43, 0.279, 255.44745, -58.958245, 6.26, -0.124, 255.46356, -18.885538, 6.28, 1.351,
  255.46934999999996, -32.143519, 5.03, -0.1, 255.49573499999997, 8.450669, 6.33, 0.091, 255.56568, 64.600739, 6.11, 0.96,
  255.57127499999999, 31.88412, 6.41, 1.134, 255.57789000000002, 25.50562, 5.76, 1.018, 255.78278999999998, 14.091947, 4.97, 1.6,
  255.78628500000002, -53.237028, 5.27, 0.498, 255.87588000000002, 35.414049, 6.19, 1.467, 255.913755, 13.605346, 5.91, 0.01,
  255.92368499999998, -47.160571, 6.07, 0.072, 255.96219000000002, -38.152572, 5.91, 0.409, 255.96941999999999, 19.690513, 6.35, 1.518,
  255.973275, 34.790222, 6.08, 0.2, 255.98655000000002, -37.844143, 6.48, 0.263, 255.991845, 13.56742, 6.06, 1.05,
  256.10301, -57.712166, 5.73, -0.097, 256.14042, -68.278694, 6.47, 1.57, 256.17228, 19.599105, 6.19, 0.01,
  256.188855, -20.494703, 6.29, -0.035, 256.20564, -34.12293, 4.83, 0.257, 256.207335, 48.803958, 6.11, 1.091,
  256.27059, 43.812238, 6.45, 0.099, 256.27239, -45.502127, 6.28, 0.074, 256.320075, 0.702559, 6, 0.578,
  256.333935, 54.470042, 4.91, 0.471, 256.34454, 12.740828, 4.89, 0.125, 256.38441, -0.89207, 5.63, 0.104,
  256.45197, -44.105042, 6.18, 0.281, 256.54018499999995, 9.733868, 6.38, 1.458, 256.54917, -21.564583, 6.29, 0.128,
  256.554375, 10.453878, 6.38, 0.896, 256.57521, 22.084153, 5.56, 1.299, 256.58412, -37.22759, 5.98, 0.076,
  256.6182, -35.451046, 6.15, 0.438, 256.720665, -1.656186, 6.34, 0.209, 256.72177500000004, -26.513022, 6.26, -0.038,
  256.944525, 40.516054, 6.34, 0.032, 257.00289, 31.206189, 6.44, 1.285, 257.008605, 35.935174, 5.41, 0.309,
  257.056875, -1.079476, 6.06, 0.074, 257.06190000000004, -17.609052, 5.98, 1.011, 257.071155, 50.842272, 6.46, -0.017,
  257.19671999999997, 65.714683, 3.17, -0.12, 257.198085, -30.40373, 5.93, 0.276, 257.22717, -3.882991, 6.35, 0.697,
  257.38856999999996, 40.777033, 5.07, 1.275, 257.449785, -10.523301, 5.43, 0.465, 257.52615000000003, -61.675456, 6.37, -0.049,
  257.59452, -15.72491, 2.43, 0.059, 257.627655, 52.408769, 6.3, -0.025, 257.676375, -44.557719, 5.06, 0.867,
  257.76318, 24.237694, 6.2, 0.227, 257.911155, -48.873399, 5.94, 1.786, 257.917785, 49.746357, 6.12, 0.185,
  257.93850000000003, 7.894762, 6.34, 1.04, 258.03828, -43.239189, 3.32, 0.441, 258.06753000000003, -39.506949, 5.66, 0.042,
  258.069015, -38.822535, 6.3, 1.05, 258.08281500000004, -70.721082, 6.21, 1.062, 258.10443000000004, -27.762124, 6.12, -0.048,
  258.115875, 10.585168, 5.32, 1.593, 258.13570500000003, 62.874337, 5.54, 0.216, 258.24399, -32.438332, 5.95, 0.071,
  258.325095, -67.196591, 5.87, 1.07, 258.55587, -56.888526, 6.08, 1.728, 258.615225, -39.76665, 6.42, 2.282,
  258.661905, 14.390333, 2.78, 1.164, 258.75796499999996, 24.839204, 3.12, 0.08, 258.76182, 36.809162, 3.16, 1.437,
  258.83019, -33.54842, 5.6, -0.056, 258.83452500000004, -14.58414, 5.98, 1.096, 258.83754, -26.602829, 4.33, 0.855,
  258.89991, -38.593896, 5.95, 0.58, 258.9228, 23.742761, 5.99, 1.335, 258.96396, -30.210731, 6.2, -0.027,
  259.05582, -26.546147, 6.33, 1.144, 259.05942, 2.186202, 6.17, 0.235, 259.090065, -35.750297, 6.09, 0.479,
  259.12260000000003, 60.670614, 6.32, 1.09, 259.13215499999995, 1.210545, 5.89, 0.023, 259.148685, -74.533008, 6.24, -0.004,
  259.152855, -0.445297, 4.72, 1.119, 259.178115, -6.244975, 6.08, 1.1, 259.23853499999996, 89.037708, 6.31, 1.575,
  259.26523499999996, -32.66284, 5.53, 0.514, 259.27308, -44.778595, 6.46, 0.187, 259.331535, 33.1001, 4.8, -0.166,
  259.39939499999997, 23.090627, 6.25, 1.544, 259.417755, 37.291498, 4.64, 0.043, 259.502835, -24.286901, 5.14, 1.046,
  259.52058, 17.317886, 6, 0.015, 259.580295, -16.311877, 6.28, 1.691, 259.58545499999997, -32.553107, 6.36, 0.109,
  259.596975, 38.811395, 5.97, 1.011, 259.654125, 10.864475, 5.03, 1.539, 259.699305, -44.129746, 5.76, -0.049,
  259.702185, 28.822968, 5.68, 0.981, 259.715625, -62.874577, 6.5, 1.087, 259.73763, -34.989792, 5.91, 1.082,
  259.764825, -46.636235, 5.47, 0.764, 259.80213000000003, -59.694612, 5.93, 1.389, 259.877145, -50.063762, 6.27, 0.413,
  259.90441500000003, 80.136399, 5.74, 1.499, 259.94376, 2.139539, 6.43, 1.487, 259.97229000000004, -17.756543, 6.03, 0.04,
  259.998135, -5.917509, 6.31, 0.85, 260.040975, 25.537603, 5.36, 0.063, 260.078625, 18.057081, 5.01, 1.654,
  260.088045, 46.24078, 5.51, 1.586, 260.140485, 48.188791, 6.36, 0.427, 260.142975, -19.333746, 6.5, 0.578,
  260.1648, 32.467743, 5.38, 0.619, 260.20692, -12.846875, 4.32, 0.037, 260.219295, -10.69641, 6.46, 0.326,
  260.225865, 24.499435, 5.13, 0, 260.251515, -21.112933, 4.39, 0.394, 260.380155, 28.758101, 6.37, 0.724,
  260.38935000000004, 16.731229, 6.35, 1.608, 260.423175, -24.906103, 6.36, 1.399, 260.43174, 39.974649, 5.55, 0.667,
  260.439, 53.420428, 5.69, 1.463, 260.49796499999997, -67.770668, 4.76, 1.194, 260.502405, -24.999545, 3.27, -0.186,
  260.524485, -70.123208, 5.39, -0.042, 260.65815000000003, -35.910699, 6.42, 0.541, 260.66339999999997, -37.804637, 6.33, 0.682,
  260.713695, -2.388176, 6.28, 0.68, 260.72811, -37.220786, 5.91, 1.075, 260.73010500000004, -58.010327, 5.86, 1.075,
  260.77965, -56.525547, 5.76, 0.994, 260.81698500000005, -47.468197, 5.21, -0.097, 260.839965, -28.142831, 5.3, 1.549,
  260.92062000000004, 37.145946, 4.15, -0.011, 260.99007, 8.852571, 5.77, 1.251, 261.004485, -62.864153, 5.69, -0.147,
  261.009405, 38.582782, 6.48, 0.716, 261.02745, 22.960285, 5.7, 0.229, 261.05454, -44.162576, 5.1, -0.052,
  261.07831500000003, -60.673799, 5.76, -0.067, 261.112995, 36.951929, 6.25, 0.884, 261.1314, 16.301006, 5.75, 0.074,
  261.14083500000004, 15.606048, 6.34, -0.017, 261.154335, -18.445762, 6.34, 0.046, 261.175125, -21.441479, 5.82, 0.939,
  261.252465, 67.306705, 6.44, 0.759, 261.26111999999995, -34.696055, 6.14, 0.046, 261.27599999999995, -24.243683, 6.17, 1.103,
  261.324975, -55.529884, 2.84, 1.479, 261.34858499999996, -56.377727, 3.31, -0.15, 261.35037, 52.790684, 6.46, 0.619,
  261.422325, 60.048398, 5.65, 0.024, 261.47652000000005, 16.917578, 6.09, 1.528, 261.49114499999996, -1.651777, 6.44, 0.457,
  261.50016000000005, -50.63351, 5.19, 1.055, 261.50361, 26.878734, 6.38, 0.124, 261.52017, 58.651895, 6.49, 0.139,
  261.57921, 7.59565, 6.01, 0.592, 261.59256, -24.175309, 4.16, 0.283, 261.628665, 4.14036, 4.34, 1.48,
  261.65784, -5.086596, 4.53, 0.385, 261.684345, 48.260065, 5.83, 0.121, 261.692295, 34.695802, 5.94, -0.017,
  261.7047, 20.080977, 5.52, -0.119, 261.71658, -45.84303, 5.28, -0.058, 261.73041, -25.943462, 6.42, -0.055,
  261.734805, -51.948819, 6.17, -0.039, 261.75895499999996, -12.512488, 6.2, 0.517, 261.791175, -15.85336, 6.48, 1.146,
  261.80192999999997, -50.63037, 5.9, 0.063, 261.83863499999995, -29.867033, 4.28, 0.402, 261.906465, -29.724567, 5.98, 0.01,
  261.93366, 8.442039, 6.42, 1.66, 261.99003, -52.297168, 5.72, 1.169, 262.00974, -8.208374, 6.37, 0.57,
  262.03279499999996, -63.03624, 6.22, -0.073, 262.16213999999997, -55.169686, 5.93, 1.113, 262.2069, 0.330625, 5.41, 0.237,
  262.233705, -36.77828, 5.98, 1.112, 262.253595, -43.973919, 6.3, -0.01, 262.356705, -38.51692, 6.38, 0.091,
  262.447275, -5.919479, 6.36, 0.93, 262.59439499999996, 11.924015, 6.47, 0.056, 262.59914999999995, -1.062922, 5.31, 0.715,
  262.608195, 52.301387, 2.79, 0.954, 262.667535, 38.882202, 6.43, 0.51, 262.68152999999995, 57.876824, 6.22, 1.397,
  262.68462, 26.110645, 4.41, 1.434, 262.69097999999997, -37.295811, 2.7, -0.179, 262.69584, 86.968047, 5.78, 0.239,
  262.73071500000003, 31.158139, 5.63, 0.96, 262.77477, -60.683848, 3.6, -0.104, 262.838895, 2.724507, 5.57, 0.844,
  262.84700999999995, -56.920964, 5.99, -0.045, 262.85397, -23.962643, 4.78, 0.016, 262.86447000000004, -80.859134, 5.83, 1.617,
  262.934895, -26.269709, 6.05, -0.065, 262.94732999999997, -33.703158, 6.43, 1.191, 262.954575, -46.036783, 6.04, 0.805,
  262.956585, 28.407499, 5.66, -0.001, 262.96042500000004, -49.876145, 2.84, -0.136, 262.991175, 68.135024, 5.07, 1.077,
  263.043765, 55.184243, 4.89, 0.251, 263.05377, 86.58646, 4.35, 0.021, 263.062005, 11.930047, 6.42, -0.013,
  263.066505, 55.172958, 4.86, 0.279, 263.10262500000005, -34.279405, 6.16, 0.36, 263.2803, 41.243449, 5.72, 1.089,
  263.28078, -41.173066, 5.84, 0.041, 263.3451, 19.256677, 5.65, 0.505, 263.37435, -5.744803, 5.61, 0.187,
  263.381685, 57.558721, 6.15, 0.602, 263.402175, -37.103821, 1.62, -0.231, 263.414115, 16.317553, 5.68, 1.002,
  263.428245, 14.841598, 6.36, 1.595, 263.570295, -48.526787, 6.32, 0.953, 263.6529, 9.5867, 5.8, 0.04,
  263.67705, -32.581662, 5.69, 0.045, 263.69313, -11.241999, 5.54, 0.013, 263.733615, 12.560035, 2.08, 0.155,
  263.74755, 61.874554, 5.23, 0.602, 263.82707999999997, -22.043822, 6.47, 0.011, 263.832945, -53.352928, 6.09, 0.025,
  263.895825, -59.846115, 6.26, -0.081, 263.91498, -46.505684, 4.56, -0.02, 263.92653, 37.301594, 6.13, 0.978,
  263.92945499999996, -37.439878, 6.48, 0.006, 263.9982, 20.996242, 6.11, 0.184, 264.03375, 28.185091, 6.4, 1.367,
  264.08925, 27.566639, 6.37, 1.586, 264.13681499999996, -38.635308, 4.26, 1.075, 264.15309, 30.785179, 6.04, 0.158,
  264.156855, 48.585634, 5.35, 1.142, 264.166665, 69.57073, 6.33, 0.596, 264.237885, 68.75797, 4.77, 0.43,
  264.286875, 72.455794, 5.87, 1.016, 264.3297, -42.997824, 1.86, 0.406, 264.36216, -38.066364, 6.26, 1.244,
  264.363795, -50.059702, 5.89, 1.109, 264.37955999999997, 24.309991, 5.76, 0.114, 264.396675, -15.398557, 3.54, 0.262,
  264.40085999999997, -15.571038, 5.94, 0.357, 264.46130999999997, -8.118771, 4.58, 0.132, 264.52306500000003, -54.500434, 5.25, 0.195,
  264.53517, -42.880274, 6.09, -0.057, 264.539595, -10.926268, 5.74, 1.228, 264.68688, -21.912658, 6.19, 0.827,
  264.74106, 13.329262, 6.12, 0.567, 264.78543, 2.02805, 6.25, 1.021, 264.86620500000004, 46.006332, 3.82, -0.179,
  264.98967, 31.20247, 6.05, 1.599, 265.04976, -2.152301, 6.08, 1.608, 265.09914000000003, -49.415587, 4.76, 0.415,
  265.156455, 43.470666, 6.36, 1.199, 265.171635, 31.287478, 6.3, 1.075, 265.1856, -67.854172, 6.48, 0.999,
  265.24395, -32.214464, 6.01, 1.673, 265.272855, 24.513254, 6.37, 1.204, 265.295805, 15.178376, 6.34, 0.04,
  265.31766, -46.92183, 5.78, -0.004, 265.34078999999997, 51.818182, 6, 1.068, 265.353645, -12.875307, 4.24, 0.086,
  265.38468, 6.313156, 5.97, 1.271, 265.48467, 72.148843, 4.57, 0.434, 265.491915, 72.156911, 5.81, 0.53,
  265.49431500000003, 15.95243, 5.54, 0.387, 265.51507499999997, -50.510703, 6.28, 1.661, 265.618185, 24.564058, 5.56, 1.436,
  265.62198, -39.029983, 2.39, -0.171, 265.71290999999997, -36.945564, 5.53, 1.553, 265.77315, 44.08432, 6.38, 1.521,
  265.778595, -33.051289, 6.44, 1.813, 265.82379, -27.883981, 6.4, 0.438, 265.839885, 24.327821, 5.73, 0.683,
  265.84176, 14.295168, 6.22, 0.426, 265.857495, -21.683194, 4.86, 0.469, 265.868145, 4.567303, 2.76, 1.168,
  265.94592, -7.079608, 6.3, 0.324, 265.95171, -13.508699, 6.36, 0.384, 265.99654499999997, 53.801715, 5.75, 0.017,
  266.03628000000003, -51.834053, 5.12, 0.694, 266.07186, 14.410067, 6.18, 0.211, 266.14206, 2.579441, 6.16, 0.131,
  266.17503, -42.729302, 5.87, 0.163, 266.23272, -57.54554, 5.97, 0.912, 266.41764, 31.504678, 6.22, 0.008,
  266.433315, -64.723871, 3.61, 1.161, 266.614785, 27.720676, 3.42, 0.75, 266.780385, -38.112164, 6.41, -0.02,
  266.78352, 17.697014, 5.61, 0.036, 266.78349, 47.612239, 6.47, 0.095, 266.89011000000005, -27.830788, 4.53, 0.6,
  266.89617000000004, -40.126997, 2.99, 0.509, 266.90325, -14.725824, 5.93, 0.009, 266.94, -22.477791, 6.18, 1.446,
  266.973165, 2.707276, 3.75, 0.043, 267.084345, 3.804215, 6.22, 0.135, 267.1032, 20.565441, 5.69, 0.938,
  267.11598000000004, -26.974945, 6.31, 0.094, 267.15862500000003, -55.401742, 6.09, 0.283, 267.19947, 19.255017, 6.13, 0.024,
  267.20478, 25.622869, 5.09, 1.141, 267.26793000000004, 50.781075, 5.02, 0.043, 267.293655, -31.703203, 4.79, -0.028,
  267.32934, 1.961413, 6.44, 1.236, 267.362325, 76.962881, 5.02, 0.518, 267.464475, -37.043304, 3.19, 1.192,
  267.47088, -61.714704, 6.41, -0.049, 267.5421, 78.306539, 6.25, 1.452, 267.54630000000003, -40.090435, 4.78, 0.259,
  267.59538, 29.322143, 5.51, 1.071, 267.6183, -53.612406, 5.68, -0.099, 267.68169, 11.946548, 6.19, 1.247,
  267.701595, 22.31633, 6.14, 0.242, 267.796005, -53.130269, 6.09, 0.01, 267.8856, -40.772461, 5.94, 1.572,
  267.89779500000003, -60.164056, 5.78, 1.008, 267.935655, -45.600706, 6.09, 0.949, 267.993585, 15.326372, 6.43, 0.997,
  267.997695, -1.236806, 6.33, 1.126, 268.003755, 46.643574, 6.37, 1.06, 268.01967, 39.982089, 6.01, 1.341,
  268.056915, -34.799196, 5.88, -0.111, 268.08234, -34.416842, 5.84, 1.129, 268.14768000000004, 1.305014, 5.91, 1.573,
  268.16127, -6.143577, 6.18, 1.25, 268.2051, -34.114833, 6.05, 1.241, 268.218975, -41.996522, 6.19, 0.523,
  268.24001999999996, -35.624314, 6.03, 0.342, 268.26473999999996, -10.899562, 6.17, 1.11, 268.30911000000003, 6.101424, 5.77, 0.425,
  268.325115, 40.007959, 5.17, 1.166, 268.32585, -65.488601, 6.48, 1.086, 268.33158, -34.730812, 6.14, -0.041,
  268.34779499999996, -34.895125, 5.58, 1.098, 268.38201, 56.872643, 3.73, 1.177, 268.47822, -34.752721, 6, -0.06,
  268.49223, -34.831053, 6.41, 0, 268.55904000000004, 11.130558, 6.24, 0.474, 268.611405, 75.171307, 6.39, 0.972,
  268.61301, -34.466722, 6.1, 0.055, 268.72518, -24.887095, 6.18, 0.001, 268.783455, -36.475645, 6.05, 0.074,
  268.79643, 72.005127, 5.43, 0.34, 268.848495, 55.971394, 6.09, 0.316, 268.85494500000004, 26.049991, 5.47, 0.341,
  268.96171499999997, 22.464221, 5.62, 1.249, 268.97904, -18.802154, 6.48, 0.056, 269.06325000000004, 37.250539, 3.86, 1.35,
  269.076675, 0.670355, 5.82, 0.058, 269.079315, -15.812521, 5.93, 0.024, 269.10094499999997, -65.721739, 6.36, 0.451,
  269.151555, 51.488895, 2.24, 1.521, 269.174325, -28.065394, 5.76, 0.207, 269.197605, -44.342246, 4.85, 1.176,
  269.19894, -4.081823, 5.44, 1.162, 269.20218, 45.350851, 6.22, 1.453, 269.232915, -40.305643, 6.46, 1.411,
  269.23323, 6.48773, 6.28, -0.015, 269.267985, 0.066665, 5.95, 0.11, 269.3097, 23.995889, 6.32, 0.642,
  269.36244, 11.044543, 6.33, 0.13, 269.423685, -76.177949, 6.08, 1.205, 269.428065, -56.896252, 6.26, -0.066,
  269.44116, 29.24788, 3.7, 0.935, 269.449185, -41.716295, 4.88, 1.617, 269.490795, -39.136523, 6.28, 0.007,
  269.62561500000004, 30.189277, 4.41, 0.38, 269.66271, -28.759089, 5.99, -0.077, 269.67632999999995, 36.287797, 6.03, 0.949,
  269.71794, 45.47622, 6.48, -0.064, 269.732025, -36.858376, 5.74, 0.915, 269.75662500000004, -9.773632, 3.32, 0.987,
  269.772, -30.253025, 5, 1.654, 269.90317500000003, -4.821126, 5.86, 1.561, 269.948145, -23.816133, 4.74, -0.03,
  269.98419, 45.501378, 5.69, 1.562, 270.000345, -20.339548, 6.22, 1.405, 270.01416, 80.000841, 6.11, 0.521,
  270.014235, 16.750919, 4.67, 1.254, 270.03789, 80.004095, 5.74, 0.516, 270.06531, 0.629483, 6.36, 0.16,
  270.06582, 4.368615, 4.79, -0.1, 270.115245, 19.505786, 6.42, -0.054, 270.12086999999997, -3.690269, 4.62, 0.39,
  270.15155999999996, 33.213682, 6.01, 1.516, 270.16130999999996, 2.931568, 3.93, 0.029, 270.22024500000003, 6.268294, 6.36, -0.104,
  270.238635, 15.09355, 6.28, 0.747, 270.34633499999995, -17.156868, 6.27, 1.763, 270.37669500000004, 21.595782, 4.26, 0.406,
  270.39252, -85.214828, 6.45, 0.437, 270.399585, 33.311266, 6.18, 1.549, 270.43833, 1.305076, 4.42, 0.046,
  270.45124500000003, -36.377864, 6.3, -0.016, 270.47658, -22.780298, 5.72, -0.03, 270.59604, 20.833632, 5.25, -0.1,
  270.625635, 22.92323, 6.22, -0.092, 270.712905, -24.282468, 5.37, 0.495, 270.77050499999996, -8.180349, 4.77, 0.41,
  270.78702000000004, 48.464269, 6.26, 0.037, 270.810675, 19.613157, 6.41, 0.017, 270.96852, -24.36073, 5.89, 0.031,
  271.15566, 1.918992, 6.14, -0.056, 271.16754000000003, 23.941999, 6.34, 0.306, 271.20993, -35.901442, 5.98, 1.16,
  271.25334000000004, 41.94629, 6.38, 0.287, 271.25511, -29.580087, 4.66, 0.774, 271.36150499999997, -81.486568, 6.37, 1.528,
  271.363695, 2.500099, 4.03, 0.86, 271.375575, 21.646624, 6.18, 1.241, 271.452045, -30.424091, 2.98, 0.981,
  271.45671000000004, 32.230674, 5.72, 1.179, 271.50792, 22.218879, 4.96, 1.656, 271.530825, -8.323956, 5.84, 0.184,
  271.53094500000003, -0.446128, 6.32, 1.014, 271.5384, -51.743905, 6.46, 0.172, 271.563315, -4.751252, 5.74, 0.968,
  271.598775, -36.019788, 5.94, 0.615, 271.6578, -50.091477, 3.65, -0.101, 271.70787, -43.425216, 4.92, 0.255,
  271.72281000000004, 50.822823, 6.31, 1.051, 271.756455, 30.56214, 5.05, 0.528, 271.77622499999995, 49.710441, 6.32, -0.02,
  271.7973, -21.443938, 6.22, 0.102, 271.826505, 8.733867, 4.64, 0.951, 271.83744, 9.563847, 3.71, 0.159,
  271.86975, 43.461891, 5, 0.913, 271.88562, 28.762488, 3.84, -0.018, 271.95154499999995, -64.550177, 6.4, 1.266,
  271.95142500000003, -17.154159, 5.52, 1.132, 271.956255, 26.09734, 5.79, 0.127, 271.95651000000004, 26.10128, 5.83, 0.158,
  272.009385, 36.401264, 5.49, 1.161, 272.02074, -28.457093, 4.55, 0.938, 272.125455, -45.767015, 6.13, -0.082,
  272.14056, 14.284716, 6.34, 0.181, 272.145, -63.668553, 4.33, 0.228, 272.16078, -21.449562, 6.42, 0.755,
  272.18955, 20.814557, 4.37, -0.164, 272.22027, 20.045233, 5.1, 0.176, 272.2926, 30.469531, 6.36, 1.194,
  272.39122499999996, 3.993276, 5.71, 0.363, 272.40612, 38.457777, 6.38, 0.876, 272.43075, -13.934435, 6.38, 1.428,
  272.47506, 3.119827, 5.67, 0.49, 272.489895, -59.040182, 6.38, 1.553, 272.495805, 36.466284, 5.57, 0.915,
  272.49984, -32.719635, 6.39, 1.025, 272.524215, -30.728666, 5.53, 0.979, 272.53636500000005, 16.47659, 6.09, 0.574,
  272.60922, -62.002197, 5.47, 0.592, 272.63164500000005, 54.286552, 5.97, 0.943, 272.667915, 3.324256, 5.5, 1.204,
  272.730615, -33.80007, 6.13, -0.137, 272.76835500000004, -47.513121, 6.07, 1.193, 272.77314, -41.359113, 5.86, 0.295,
  272.77983, 60.409532, 6.5, -0.002, 272.807355, -45.954418, 4.52, 1.009, 272.8116, -19.841958, 6.33, 0.158,
  272.81570999999997, -75.89151, 5.86, 1.253, 272.93055, -23.701235, 4.96, 1.055, 272.93798999999996, 33.447057, 5.98, 0.045,
  272.975655, 31.40535, 4.96, 1.643, 273.14223000000004, -73.672417, 5.86, 0.464, 273.17757, 41.14684, 6.36, 1.038,
  273.270075, 38.773493, 6.04, -0.057, 273.30291, -41.336111, 5.47, -0.155, 273.31901999999997, 21.880332, 6.14, 1.472,
  273.44088, -21.058834, 3.84, 0.195, 273.46758, 2.393465, 6.43, 1.545, 273.473175, 64.397287, 4.99, 0.44,
  273.56624999999997, -21.713164, 5.49, 1.528, 273.56808, -63.689682, 6.47, 1.414, 273.80377500000003, -20.72827, 5.29, 0.007,
  273.804045, -20.387974, 5.96, -0.023, 273.82108500000004, 68.75581, 5.96, 1.055, 273.87818999999996, -18.661577, 6.05, 0.165,
  273.885345, 45.209318, 6.3, 0.641, 273.91158, 42.159345, 5.56, -0.111, 273.91933500000005, -63.055366, 5.58, 0.944,
  273.972645, -44.206461, 5.45, 0.962, 273.99138, -3.617992, 6.35, 0.201, 274.02321, 2.377517, 6.1, 1.55,
  274.22125500000004, -3.007401, 5.99, 0.89, 274.253835, -51.068271, 6.06, -0.046, 274.278525, 40.936727, 6.12, 0.977,
  274.28139, -56.023351, 5.36, -0.05, 274.298445, -17.373886, 5.81, 1.569, 274.34892, -28.288975, 6.36, 0.536,
  274.35035999999997, -28.652065, 6.18, 0.184, 274.35067499999997, -9.758578, 6.29, 0.382, 274.40103, -34.107258, 6.03, -0.096,
  274.406895, -36.761686, 3.1, 1.582, 274.50399, -68.229257, 6.32, -0.026, 274.512255, 13.777038, 6.29, -0.04,
  274.51329, -27.042641, 4.66, 1.629, 274.532145, 18.131691, 6.24, -0.004, 274.53220500000003, 23.296907, 6.45, 1.698,
  274.667325, -42.288399, 6.3, -0.144, 274.78974, 7.259767, 5.41, 1.084, 274.794495, 24.446059, 5.3, 1.508,
  274.91709, -63.886562, 6.17, 0.584, 274.965465, 36.064547, 4.33, 1.162, 274.96696499999996, 29.666392, 6.01, 1.319,
  274.98364499999997, 51.347823, 6.3, 1.112, 275.036625, -15.831697, 5.39, 1.473, 275.074635, 21.961297, 4.92, 1.594,
  275.189325, 71.337814, 4.22, -0.093, 275.216925, 3.377165, 4.85, 0.911, 275.229945, -37.487648, 6.46, 1.315,
  275.23737, 29.858925, 5.61, 0.231, 275.24850000000004, -29.828103, 2.72, 1.38, 275.254245, 28.869954, 5.12, 0.212,
  275.26104000000004, 72.732843, 3.55, 0.489, 275.279775, 49.725466, 6.39, 1.086, 275.32750500000003, -2.898825, 3.23, 0.941,
  275.345775, -18.859999, 5.76, 0.67, 275.368335, 5.435726, 6.14, -0.048, 275.380695, -24.915276, 6.19, 1.823,
  275.386125, 49.121593, 5.02, 1.619, 275.50057499999997, -28.429962, 6.15, 0.264, 275.536245, 23.285176, 5.41, 1.633,
  275.57742, -38.656894, 5.09, 1.498, 275.647155, 12.02968, 5.99, 0.056, 275.70432, 17.826616, 5.25, 1.25,
  275.72114999999997, -36.669556, 5.33, -0.121, 275.758785, -10.218983, 6.32, 0.13, 275.762205, 16.688, 6.22, 1.216,
  275.80068, -12.014755, 5.71, 0.006, 275.806755, -61.493901, 4.35, 1.462, 275.8701, -36.237987, 5.52, 1.015,
  275.90184, -75.044277, 5.47, 0.043, 275.914935, -8.934383, 4.66, 0.932, 275.924505, 21.769752, 3.85, 1.168,
  275.94987, 53.300837, 6.35, 0.168, 275.977605, 58.800736, 4.98, 0.082, 275.98866, 38.73921, 6.41, 1.429,
  276.014955, -3.583157, 6.36, 0.351, 276.038295, 83.1754, 6.16, 0.051, 276.04302, -34.384616, 1.79, -0.031,
  276.05745, 39.507239, 5.11, 0.047, 276.076005, -44.110256, 5.24, -0.163, 276.13803, -49.652879, 6.45, 0.593,
  276.17553, -7.075936, 6.28, 1.161, 276.238365, -1.579413, 6.15, 0.381, 276.243585, 27.394783, 6.27, 0.053,
  276.25599, -30.75657, 5.58, 1.138, 276.337665, -20.541679, 4.81, 1.31, 276.34032, -35.992025, 6.14, 1.006,
  276.381795, -63.021534, 6.13, 0.202, 276.41166000000004, 8.032006, 5.64, 0.884, 276.477525, -33.945718, 6.3, -0.075,
  276.48012, 14.966232, 6.37, -0.037, 276.49494, 29.82893, 5.81, 0.068, 276.496035, 65.56348, 4.82, 1.179,
  276.67053, 26.449216, 6.5, -0.107, 276.72504000000004, -48.117243, 5.44, 0.855, 276.74341499999997, -45.968459, 3.49, -0.179,
  276.786945, -8.040406, 6.5, 1.054, 276.802125, 0.196108, 5.2, 0.487, 276.9255, 59.549112, 6.43, 0.979,
  276.93231000000003, -26.634845, 6.31, 0.263, 276.956175, -29.816865, 5.9, 0.517, 276.95967, 3.74857, 6.07, 1.61,
  276.985335, -17.800357, 6.19, 0.003, 276.992685, -25.4217, 2.82, 1.025, 276.99489, 6.194104, 5.71, -0.034,
  277.0257, -26.757245, 6.28, 0.157, 277.02648, -84.387256, 6.49, -0.035, 277.11297, -38.995671, 5.63, 0.14,
  277.207575, -49.070588, 4.1, 0.995, 277.29939, -14.565813, 4.67, 0.076, 277.303635, -43.845939, 6.36, 0.904,
  277.33336499999996, -80.232708, 5.95, 1.173, 277.398795, 23.866202, 5.87, -0.096, 277.42075500000004, -1.985308, 5.38, 0.961,
  277.43734500000005, 77.547068, 5.65, 1.192, 277.44482999999997, -14.581987, 6.02, 0.006, 277.483065, -47.220546, 5.69, 1.258,
  277.48629, -57.523143, 5.74, 0.987, 277.54942500000004, -18.728794, 5.63, 1.057, 277.559565, -5.724169, 6.27, 0.953,
  277.67355, 20.815046, 6.49, 0.795, 277.76229, -41.913834, 6.02, 0.138, 277.768545, 16.928556, 5.76, 0.053,
  277.77018, -32.989114, 5.37, 0.182, 277.84344, -62.278302, 4.63, -0.116, 277.85706, -10.795836, 5.77, 0.379,
  277.859565, -18.402697, 5.12, 0.016, 277.939305, -45.914814, 4.92, -0.101, 277.98426, -43.507383, 5.71, 1.322,
  277.98747000000003, -1.002977, 5.93, 0.17, 278.00811, -45.757382, 5.07, -0.127, 278.02870499999995, 3.659603, 6.41, -0.025,
  278.086065, -14.644268, 6.36, 0.217, 278.08885499999997, -39.704001, 5.16, 0.079, 278.143845, 57.045599, 4.77, 0.611,
  278.180505, -14.865662, 5.47, 1.998, 278.19231, 23.616801, 5.88, 1.49, 278.20815, 30.554209, 5.47, -0.077,
  278.23056, -73.965596, 5.88, 0.992, 278.25374999999997, -39.892022, 6.22, 0.429, 278.34462, -5.911718, 6.36, 0.034,
  278.34619499999997, -38.720033, 6.31, 0.02, 278.34639, -38.725985, 5.67, -0.06, 278.347095, 8.268251, 6.42, -0.044,
  278.372745, -58.708784, 6.4, 0.688, 278.375745, -42.31251, 4.62, 0.994, 278.41258500000004, -14.853614, 5.74, 0.043,
  278.472855, -24.032283, 5.49, 1.795, 278.486235, 52.353517, 5.38, 1.091, 278.49069, -33.01656, 5.28, -0.115,
  278.62968, -52.891521, 6.21, 1.254, 278.697885, 10.89201, 6.48, 0.032, 278.75997, -10.977206, 5.12, 0.926,
  278.80177499999996, -8.244073, 3.85, 1.317, 278.80251, 18.20341, 5.79, 0.006, 278.80627499999997, 34.458021, 6.1, -0.115,
  278.83887000000004, -20.840442, 6.49, 0.28, 278.876655, 23.60553, 5.62, 1.015, 278.90205, 4.935988, 6.47, 0.075,
  278.971755, 16.975697, 6.21, 0.542, 278.998515, -29.699104, 6.36, 1.272, 279.055245, 65.488717, 6.07, 0.279,
  279.115965, 9.122491, 5.38, 0.387, 279.155595, 33.469036, 5.41, -0.101, 279.16281, 6.671805, 5.43, 0.386,
  279.18976499999997, 43.221815, 6.21, 0.251, 279.2346, 38.783692, 0.03, -0.001, 279.287745, 16.198295, 6.31, 0.896,
  279.38961, 62.526591, 5.74, -0.045, 279.39984, -0.309472, 5.76, 0.067, 279.47677500000003, -21.397725, 5.93, 0.189,
  279.51867000000004, -14.004781, 6.49, 0.189, 279.52698, 39.668326, 6.02, 1.444, 279.59916, -3.19364, 6.49, 0.553,
  279.627975, -23.504893, 5.78, -0.018, 279.72252, -21.051871, 5.85, 0.673, 279.80951999999996, -47.909767, 5.84, 0.233,
  279.88764, 40.935059, 6.25, -0.052, 279.89652, -43.185878, 5.42, 1.654, 279.90366, 5.264287, 6.36, 0.8,
  279.964995, 7.358598, 6.26, 0.962, 279.97005, 52.196075, 6, -0.067, 280.00161, -7.790799, 5.82, 1.536,
  280.00803, 30.849471, 6.43, 0.9, 280.05082500000003, 38.367195, 6.45, 0.22, 280.23501, 62.749466, 6.1, 0.978,
  280.37785499999995, -48.094686, 6.47, 1.22, 280.42211999999995, 31.617612, 6.41, -0.047, 280.42692, -14.564244, 6.4, 0.757,
  280.46511, -23.833423, 6.22, 0.231, 280.53369, 34.746307, 6.49, -0.116, 280.55988, -81.808114, 6.27, -0.104,
  280.568445, -9.052549, 4.7, 0.358, 280.59427500000004, -64.643044, 6.35, 0.153, 280.650495, -7.073654, 6.13, 1.006,
  280.658145, 55.539457, 5.03, -0.07, 280.729575, -19.284209, 6.32, 1.591, 280.7589, -71.428113, 4.01, 1.134,
  280.793115, 70.792849, 6.28, 1.234, 280.81905, 39.300066, 6.45, 1.59, 280.870875, 53.871767, 6.18, 0.094,
  280.88022, -8.275215, 4.88, 1.112, 280.90044, 36.556605, 6.04, 1.04, 280.905525, -64.551425, 5.76, 0.967,
  280.94559, -38.323441, 5.11, 0.075, 280.96347, -6.818119, 6.3, 0.479, 280.964985, 31.926613, 5.68, 0.36,
  281.0331, -36.718335, 6.31, 0.98, 281.076105, 61.048143, 6.02, 0.967, 281.08066499999995, -35.641987, 4.86, -0.168,
  281.08475999999996, 39.670123, 4.67, 0.17, 281.094915, 39.612721, 4.59, 0.18, 281.16789, 23.589883, 6.3, 0.437,
  281.193135, 37.605115, 4.34, 0.192, 281.20083, 37.594615, 5.73, 0.285, 281.20668, -25.010914, 5.82, 0.033,
  281.208075, 2.060038, 5.02, -0.055, 281.230815, 54.897184, 6.26, 0.839, 281.23815, -39.686188, 5.4, 0.85,
  281.29797, -61.095196, 6.04, 1.484, 281.32773000000003, -21.001615, 6.35, 0.458, 281.349585, -56.88197, 6.22, 1.385,
  281.361975, -64.871259, 4.78, 0.199, 281.368185, 5.500128, 5.82, 0.041, 281.40860999999995, 79.942673, 6.4, 0.296,
  281.4141, -26.990778, 3.17, -0.107, 281.415525, 20.546308, 4.19, 0.483, 281.444835, 74.085553, 5.25, 0.953,
  281.48331, -50.872715, 6.24, -0.08, 281.504775, -19.606357, 6.34, 1.578, 281.518665, 26.66213, 4.83, 1.199,
  281.5542, 41.44181, 6.06, -0.12, 281.585865, -22.392176, 5.37, 1.591, 281.592735, 75.433964, 5.37, 0.049,
  281.61915, -0.961692, 5.89, 0.131, 281.67233999999996, 18.705907, 6.18, 1.594, 281.67951, 52.98796, 5.91, -0.096,
  281.680515, -10.125048, 5.69, 0.584, 281.75529, 18.181519, 4.34, 0.148, 281.79363, -4.747867, 4.22, 1.087,
  281.87062499999996, -5.705147, 5.38, 1.28, 281.93589, -40.406167, 5.2, 0.781, 281.95495500000004, -77.868249, 6.39, 0.593,
  281.98905, 31.756835, 6.06, -0.139, 282.0111, 4.241422, 6.2, 1.509, 282.067005, 48.767556, 6.12, 0.225,
  282.06834000000003, 23.514749, 6.19, 0.492, 282.15807, -65.077679, 5.71, 0.268, 282.16455, -6.004311, 6.49, 0.242,
  282.18921, -18.60115, 6.46, 0.902, 282.21036, -43.680047, 5.46, 0.133, 282.222435, 19.32872, 5.89, 0.022,
  282.363855, -45.8101, 5.8, 0.891, 282.39582, -43.434102, 5.6, -0.077, 282.40497, 0.836197, 6.24, 0.041,
  282.417105, -20.324656, 5.22, 1.404, 282.42064500000004, -5.912863, 5.99, 1.568, 282.431985, -72.995722, 6.04, 0.033,
  282.44129999999996, 32.81282, 5.93, -0.154, 282.47049, 32.551058, 5.22, 0.1, 282.51997500000004, 33.362667, 3.52, 0.003,
  282.62988, -13.572262, 6.48, 1.662, 282.68979, 10.976392, 6.37, 1.443, 282.71038500000003, -22.16219, 6.29, 0.39,
  282.74379, -9.774096, 5.82, 0.594, 282.744375, -41.062687, 6.5, -0.075, 282.80022, 59.388351, 4.63, 1.185,
  282.842325, -3.317857, 6.08, 0.299, 282.89567999999997, 52.975117, 5.51, 0.843, 282.89955000000003, 28.783671, 6.22, 1.183,
  282.90216, 36.539092, 6.1, -0.1, 283.008015, 13.965647, 6.19, -0.008, 283.030215, 41.383244, 6.28, -0.083,
  283.04974500000003, -41.709195, 6.47, 1.426, 283.05431999999996, -62.187593, 4.22, -0.15, 283.06845, 21.425142, 5.43, -0.068,
  283.113435, -46.595119, 5.51, 1.641, 283.11798, -26.65077, 6.28, 0.941, 283.154355, -29.379676, 6.12, 1.344,
  283.165125, -52.10737, 5.18, 0.962, 283.249575, -46.586329, 6.17, 0.051, 283.25754, -9.575521, 6.27, 0.2,
  283.25980500000003, -48.360913, 6.17, 0.124, 283.300005, -51.931437, 6.3, -0.092, 283.30644, 50.708221, 4.92, 0.903,
  283.38833999999997, 75.787372, 6.33, 0.021, 283.431495, 36.971721, 5.58, -0.138, 283.44291000000004, 57.486557, 6.24, 1.243,
  283.50037499999996, -21.359845, 5.68, 1.206, 283.542405, -22.744834, 4.86, 1.412, 283.5552, 27.909528, 5.64, 1.361,
  283.59915, 71.297192, 4.82, 1.151, 283.62618, 36.898613, 4.22, 1.575, 283.67964, -15.603036, 5.08, 0.141,
  283.68702, 22.645076, 4.57, 0.782, 283.696425, 48.859401, 5.84, 0.452, 283.69845, -87.605843, 5.29, 1.304,
  283.71741000000003, 41.602723, 5.46, 1.034, 283.71882, 33.968576, 5.99, 0.922, 283.77973499999996, -22.671328, 5, 1.348,
  283.81635, -26.296722, 2.05, -0.134, 283.833735, 43.946088, 4.08, 1.397, 283.84815000000003, -37.386603, 6.48, 1.122,
  283.86435, 6.61529, 5.58, 1.041, 283.8792, -16.376635, 5.56, 0.445, 284.00280000000004, -23.173751, 5.91, -0.021,
  284.02551000000005, 18.10541, 5.69, 1.092, 284.05492499999997, 4.203595, 4.62, 0.161, 284.061015, 4.202132, 4.98, 0.204,
  284.07066000000003, -42.710676, 5.35, 0.998, 284.09442, -1.799863, 6.2, -0.046, 284.10669, 2.47119, 6.14, 0.961,
  284.107215, 65.258084, 5.62, 0.938, 284.113485, -31.689025, 6.45, 1.223, 284.16873, -37.343241, 5.36, -0.147,
  284.187765, 57.814851, 5.67, 1.155, 284.22792, -62.801904, 6.47, 1.535, 284.23765499999996, -67.233495, 4.4, 0.53,
  284.256615, 32.901273, 5.2, 0.594, 284.265285, -5.846314, 4.83, 1.057, 284.309625, -43.917012, 6.27, -0.073,
  284.31912, 2.535346, 5.56, 0.004, 284.32224, 62.396773, 6.5, 0.927, 284.33531999999997, -20.656346, 5.02, 0.137,
  284.36863500000004, 58.225026, 6.47, 0.072, 284.39331, -39.823195, 6.29, 0.21, 284.432505, -21.106654, 3.52, 1.151,
  284.50791, 38.266188, 5.89, -0.09, 284.541825, -83.422198, 6.35, -0.033, 284.56144500000005, 17.360912, 5.33, 0.731,
  284.588685, -31.035975, 6.09, 1.347, 284.598765, 6.239929, 6.22, 0.478, 284.60346, -22.529493, 6.14, 0.087,
  284.61567, -52.938629, 4.85, -0.051, 284.65218, -60.20055, 5.14, 1.355, 284.680815, -37.107357, 4.83, 0.396,
  284.69412, 40.679194, 6.2, -0.146, 284.695515, 13.906648, 5.91, 0.251, 284.735925, 32.689557, 3.25, -0.049,
  284.74749, 50.809143, 6.32, 0.979, 284.77392, 13.622245, 5.27, 0.573, 284.795685, -39.534712, 6.49, -0.04,
  284.80122, 39.217321, 6.43, -0.168, 284.849175, -12.840517, 5.51, -0.038, 284.86158, -18.566433, 6.37, 0.962,
  284.871975, -70.468653, 6.49, 0.305, 284.905665, 15.068298, 4.02, 1.082, 284.93949, 26.230404, 5.26, 1.228,
  284.992125, 22.814515, 6.28, 1.672, 285.003435, 32.145514, 4.94, 1.465, 285.01480499999997, -66.653618, 5.98, 0.977,
  285.056985, 50.533466, 5.39, -0.182, 285.10338, -24.942171, 6.35, 1.253, 285.18108, 55.658301, 5.51, 0.862,
  285.23001, 33.802158, 6.04, 0.983, 285.267915, -37.061555, 6.44, 0.02, 285.27264, 19.309605, 6.47, 1.114,
  285.32232000000005, 26.291411, 5.69, -0.086, 285.35986499999996, 46.934812, 5, 0.186, 285.389655, -15.282617, 6.31, 0.963,
  285.40725, -22.695364, 6.25, 1.647, 285.42012, -5.739115, 4.02, 1.079, 285.451545, 33.621257, 6.39, -0.117,
  285.455955, 22.264412, 6.44, 0.13, 285.52932000000004, 52.261058, 6.35, 0.983, 285.53547, -41.910505, 6.21, 0.001,
  285.58986, 8.373539, 6.25, 1.648, 285.61533000000003, -24.846826, 5.63, 1.232, 285.65297999999996, -29.880105, 2.6, 0.062,
  285.71925, 19.661011, 6.11, 1.317, 285.72708, -3.698987, 5.4, -0.005, 285.765855, -19.245686, 5.96, 1.158,
  285.77860499999997, -42.095105, 4.74, -0.027, 285.77916, -19.103024, 6.37, 0.48, 285.823725, -38.253147, 5.73, 0.328,
  285.87363, -68.755544, 5.89, 0.553, 285.884385, 1.818768, 5.82, 0.182, 285.989775, -51.018604, 5.93, 1.236,
  286.00420499999996, -57.959962, 6.3, 0.857, 286.10064, -5.684843, 6.48, 2.3, 286.104405, -31.047079, 5.49, 0.026,
  286.17075, -21.741496, 3.76, 1.012, 286.22986499999996, 53.396654, 5.4, -0.014, 286.240305, -4.03142, 5.4, 1.12,
  286.241115, 31.744072, 5.63, 1.548, 286.242855, 30.733396, 6.07, 1.575, 286.291005, 49.923166, 6.45, 1.348,
  286.352535, 13.863478, 2.99, 0.014, 286.42158, -15.660419, 5.93, -0.015, 286.446375, 29.921674, 6.32, 1.668,
  286.56225, -4.882554, 3.43, -0.096, 286.5831, -52.34091, 5.17, 0.532, 286.60456500000004, -37.063437, 4.23, 0.523,
  286.6572, 28.628595, 5.53, 0.296, 286.65997500000003, 24.250793, 5.78, 0.104, 286.717155, -16.229276, 6, -0.025,
  286.71873, -37.810658, 6.15, 0.705, 286.72839, -50.323144, 6.29, -0.057, 286.731675, -48.299144, 5.95, -0.017,
  286.73505, -27.670423, 3.32, 1.169, 286.74418499999996, 11.071228, 5.07, -0.055, 286.78468499999997, -18.738171, 6.28, -0.044,
  286.825545, 36.100157, 5.25, -0.109, 286.856535, 32.501738, 5.2, 0.367, 286.87851, -28.6368, 6.05, 1.579,
  286.988835, 16.853385, 6.08, 0.705, 287.014665, 21.698927, 6.22, 0.434, 287.06066999999996, -24.657369, 6.3, 0.011,
  287.069595, -19.290289, 5.56, -0.087, 287.08734, -40.496703, 4.57, 1.07, 287.107605, 52.425731, 5.88, 1.086,
  287.217915, -55.720425, 6.44, 1.101, 287.24964, 6.073207, 5.23, 0.346, 287.29074, 76.560502, 5.11, 0.308,
  287.368035, -37.904474, 4.11, 0.042, 287.415645, -39.827238, 6.44, 1.064, 287.44084499999997, 65.978513, 6.26, 0.008,
  287.440965, -21.023615, 2.88, 0.377, 287.45061000000004, -19.803657, 6.11, 1.156, 287.46498, -0.428114, 6.34, -0.042,
  287.46963, -68.424448, 5.31, 0.901, 287.490225, -41.892256, 5.86, -0.08, 287.50731, -39.340796, 4.1, 1.163,
  287.757945, -39.004705, 6.34, 0.006, 287.828385, -29.502293, 6.28, -0.031, 287.846505, 40.429095, 6.2, 0.093,
  287.87908500000003, 26.735871, 6.35, 0.444, 287.91895500000004, 56.859213, 5.13, 1.008, 287.94171, 31.283456, 5.93, -0.062,
  288.02124, 49.855755, 5.85, 0.666, 288.11682, -21.658382, 6.39, 1.129, 288.138375, 67.661541, 3.07, 0.99,
  288.15306000000004, 21.554572, 6.02, 0.069, 288.16963499999997, -7.939518, 5.35, 0.094, 288.19218, -50.48642, 6.12, 0.954,
  288.306945, -25.906786, 5.79, 1.387, 288.314685, -12.282584, 5.51, 1.442, 288.42793500000005, 2.293707, 5.14, -0.071,
  288.43343999999996, 5.515605, 6.47, 0.1, 288.43953, 39.145968, 4.43, -0.15, 288.479805, 57.705102, 5, 1.156,
  288.664785, -45.193527, 5.91, 0.902, 288.761205, 20.203123, 6.03, 0.895, 288.782985, 83.462746, 6.5, 0.108,
  288.82233, 21.232118, 5.65, 0.121, 288.829905, 50.071127, 6.27, 0.93, 288.833715, 15.083651, 5.58, 1.067,
  288.853575, 30.526381, 5.88, 1.665, 288.885105, -25.256682, 4.86, 0.569, 288.88842, -24.179352, 6.25, 0.548,
  288.888435, 73.355468, 4.45, 1.257, 288.88901999999996, 18.516353, 6.46, 1.743, 288.997875, 27.926302, 6.18, 0.634,
  289.054335, 21.390428, 4.76, -0.058, 289.09059, -45.466033, 5.38, 1.349, 289.09206, 38.133731, 4.35, 1.258,
  289.11161999999996, 14.544616, 5.65, -0.02, 289.11918000000003, -69.190825, 6.25, 0.193, 289.129305, 4.834795, 5.59, 0.101,
  289.214115, 46.999102, 6.02, 0.479, 289.252185, -65.227702, 6.42, -0.046, 289.2756, 53.368459, 3.8, 0.95,
  289.30093500000004, -66.661048, 5.52, 0.17, 289.40866500000004, -18.952908, 4.88, 1.013, 289.43181, 23.02554, 5.46, 0.02,
  289.45077, 2.031727, 6.19, 0.019, 289.45416, 11.595422, 5.28, 0.196, 289.54071000000005, -53.387086, 6.36, 0.505,
  289.63539, 1.085129, 5.1, 1.143, 289.65776999999997, 49.569456, 6.32, 1.123, 289.701705, 19.610477, 6.5, -0.006,
  289.712265, 0.339024, 6.4, 1.05, 289.71981, 9.61807, 6.31, 1.065, 289.75041, -15.53657, 6.09, 1.42,
  289.75480500000003, 37.445346, 6.25, 0.012, 289.90179, 54.375987, 6.23, 0.03, 289.91253, 37.330539, 6.29, 0.676,
  289.913955, 12.37468, 5.53, 0.265, 289.91664000000003, -35.421452, 5.59, -0.122, 289.97110499999997, 11.534965, 6.03, 0.087,
  290.066745, 57.645129, 5.91, 1.626, 290.137095, -5.415766, 4.98, 0.937, 290.137725, 35.185957, 6.3, -0.092,
  290.14869, -0.892161, 5.46, -0.041, 290.15895, -22.402535, 5.59, 0.276, 290.167005, 65.714531, 4.6, 0.033,
  290.373945, -34.983487, 6.48, 0.628, 290.39805, 76.559596, 6.22, 2.673, 290.404635, -19.234446, 6.25, -0.091,
  290.41773, 79.60283, 6.06, 0.072, 290.418165, -17.847197, 3.92, 0.228, 290.431755, -15.955018, 4.52, 0.079,
  290.46205499999996, -18.308388, 5.84, 1.062, 290.53974, -42.016026, 6.33, 1.129, 290.589765, -0.252345, 5.81, 1.093,
  290.63896500000004, 33.518163, 6.09, 1.052, 290.65720500000003, -51.231276, 6.42, 0.328, 290.65954500000004, -44.458965, 3.96, -0.085,
  290.701455, 9.91315, 6.34, 0.458, 290.712015, 26.262403, 5.22, -0.119, 290.71331999999995, -54.423931, 5.03, 0.02,
  290.768535, -7.400615, 6.31, 1.455, 290.80464, -44.799778, 4.27, 0.35, 290.891685, 33.221966, 6.37, 0.804,
  290.945535, 20.264356, 6.4, 0.013, 290.971545, -40.61594, 3.96, -0.105, 290.985405, 43.388171, 5.85, 0.924,
  291.02292, -68.371082, 6.33, 1.238, 291.02523, 36.452094, 6.44, 1.074, 291.031575, 29.621338, 4.99, -0.12,
  291.08946000000003, -43.722063, 6.13, 1.603, 291.09196499999996, 16.937722, 6.27, 0.075, 291.125745, -27.865945, 6.03, -0.117,
  291.24246, 11.944415, 5.17, 0.761, 291.25638, -4.884536, 6.5, 0.34, 291.26685, -29.309359, 5.91, 1.278,
  291.318705, -24.508575, 5.02, 0.235, 291.339975, -13.89713, 5.72, 1.372, 291.343305, 20.271727, 6.31, -0.014,
  291.35735999999997, 24.912774, 6.19, 0.528, 291.36916499999995, 19.798365, 5.14, 0.999, 291.37359, -23.962457, 5.45, 1.442,
  291.37458, 3.114775, 3.36, 0.319, 291.53801999999996, 36.317896, 5.17, -0.12, 291.546, -15.053251, 5.71, 0.007,
  291.555195, 20.097733, 5.6, -0.006, 291.57981, -21.776693, 5.57, 1.228, 291.600555, 13.023801, 5.76, 0.456,
  291.61032, 62.557145, 6.38, 1.413, 291.61953, 19.891493, 5.84, 1.558, 291.62953500000003, 0.33857, 4.64, 0.576,
  291.73533, -29.743225, 5.66, -0.014, 291.85817999999995, 52.320436, 5.73, -0.002, 291.891285, 14.282481, 6.31, -0.068,
  291.90165, 37.941197, 6.3, -0.12, 291.95049, -54.325272, 5.7, 1.406, 292.08666, 2.93003, 5.84, -0.003,
  292.176405, 24.664905, 4.44, 1.502, 292.237845, 24.768723, 5.82, 1.023, 292.25412, 1.950448, 5.79, 0.088,
  292.325115, 0.24608, 6.25, 1.317, 292.33707, 20.279737, 6.34, -0.097, 292.33900500000004, -7.044086, 6.37, 0.87,
  292.342305, 14.596019, 5.57, 1.05, 292.349265, -43.445195, 5.7, 0.214, 292.42647, 51.729779, 3.76, 0.148,
  292.46743499999997, -26.985615, 5.46, 1.12, 292.46916, -55.441754, 6.14, 0.974, 292.54389, 2.904073, 6.08, 1.82,
  292.638015, 3.444403, 6.09, -0.019, 292.64414999999997, -55.110053, 6.29, 0.45, 292.66598999999997, -2.788887, 5.03, 1.77,
  292.680345, 27.959681, 3.05, 1.088, 292.68915, 27.965276, 5.12, -0.095, 292.695135, 36.228503, 6.26, -0.015,
  292.725195, -21.312237, 6.11, 0.121, 292.75119, 70.989339, 6.06, 1.416, 292.795635, -68.43392, 5.98, 1.638,
  292.80647999999997, 55.731836, 6.37, 1.123, 292.830585, 50.306706, 5.55, 1.274, 292.84008, 26.617171, 5.89, 0.915,
  292.94301, 34.452968, 4.74, -0.15, 293.05846499999996, -44.546387, 6.48, 0.526, 293.08723499999996, 69.661175, 4.67, 0.786,
  293.2242, -53.185618, 5.76, 0.3, 293.29194, 60.158691, 6.3, 1.58, 293.340105, -45.271748, 5.59, -0.02,
  293.423355, 49.262319, 6, 1.545, 293.44178999999997, 5.465708, 6.35, 1.471, 293.522295, 7.378941, 4.45, 1.176,
  293.53535999999997, -40.034638, 5.89, 0.105, 293.582415, 51.23662, 5.71, 0.475, 293.6454, 19.773403, 5, -0.093,
  293.671905, 42.412509, 5.34, 0.06, 293.6931, 63.434171, 6.47, 1.326, 293.712195, 29.462954, 5.39, 0.581,
  293.75514, 52.502018, 6.39, 1.122, 293.780235, -10.560444, 5.12, 1.122, 293.80413, -48.099202, 4.88, 1.096,
  293.85471, 2.913605, 6.37, 0.414, 293.874195, -7.460283, 6.32, 1.124, 293.88942000000003, -12.253114, 6.27, 1.089,
  293.95126500000003, 36.944539, 6.03, -0.08, 293.98310999999995, 50.238618, 6.47, 1.034, 294.006885, -24.719081, 5.64, 0.185,
  294.03479999999996, 22.585763, 6.33, -0.059, 294.065355, 14.39107, 6.37, 1.045, 294.108645, -18.852921, 6.13, 0.273,
  294.11058, 50.221103, 4.49, 0.395, 294.15832500000005, 44.694936, 5.17, 0.928, 294.17679, -24.883623, 4.59, -0.075,
  294.18032999999997, -1.286601, 4.36, -0.079, 294.21855, 11.273206, 5.98, 0.881, 294.222705, -7.027477, 4.93, -0.046,
  294.26392500000003, -18.231052, 5.66, 1.237, 294.29007, 29.3337, 6.43, -0.087, 294.32247, 16.462802, 5.67, 1.007,
  294.39340500000003, -14.301801, 5.46, 0.501, 294.420075, 35.022536, 6.44, 1.559, 294.44714999999997, -4.64764, 5.45, 0.429,
  294.486255, 49.284416, 6.47, 0.99, 294.574125, 20.783391, 6.5, 1.037, 294.60807, -57.983341, 6.19, 0.973,
  294.671535, 54.973793, 5.89, 0.482, 294.70412999999996, 3.381522, 6.36, 0.001, 294.79851, 5.397773, 5.18, -0.001,
  294.84418500000004, 30.153321, 4.68, 0.971, 294.85557, 16.571121, 6.37, 1.918, 294.86034, 42.818278, 5.41, -0.063,
  294.89389500000004, 45.957439, 6.25, 0.931, 294.92409, -45.27855, 6.24, 0.293, 294.93717, 33.978938, 6.1, 0.094,
  294.956085, -23.4277, 6.33, 0.034, 294.96729, -66.685505, 6.37, 0.037, 295.024125, 18.01389, 4.39, 0.777,
  295.029855, -23.429086, 5.97, 1.038, 295.05498, 60.507114, 6.49, 0.212, 295.07787, -54.41779, 6.24, 1.001,
  295.17145500000004, 43.077824, 6.17, 1.561, 295.1805, -0.621233, 5.64, 0.123, 295.180755, -16.293268, 5.3, 1.109,
  295.20901499999997, 45.524942, 5.06, 0.426, 295.26225, 17.476041, 4.39, 1.041, 295.273035, 13.815682, 5.98, -0.078,
  295.311045, 22.452773, 6.43, 1.481, 295.405215, -65.854414, 6.08, 1.556, 295.45417499999996, 50.52506, 5.99, 0.643,
  295.466745, 50.517523, 6.25, 0.661, 295.49007, 40.254144, 6.22, 0.182, 295.51218, -9.193654, 6.31, 1.341,
  295.517265, 55.463222, 6.42, 1.453, 295.553385, 12.193261, 6.33, -0.077, 295.62972, -16.123996, 5.06, 0.319,
  295.641705, 11.826583, 5.28, 0.575, 295.68584999999996, 32.426741, 5.93, 0.118, 295.78998, 30.677891, 6.08, 0.003,
  295.79485500000004, 38.671713, 6.37, 1.22, 295.809795, 58.016617, 6.29, 0.59, 295.8897, -15.470105, 5.49, 0.46,
  295.90673999999996, -37.538765, 6.14, 0.019, 295.914555, 57.042713, 6.28, 0.887, 295.92885, 25.771929, 5.5, 0.939,
  295.93788, 41.773108, 5.86, 1.598, 295.964385, 34.162724, 6.04, -0.071, 295.983225, 27.135398, 6.27, 1.015,
  296.06914500000005, 37.354355, 4.89, 0.948, 296.07669, 69.337065, 5.9, 0.072, 296.14246499999996, 13.302783, 6.25, -0.041,
  296.15905499999997, 34.414164, 6.39, 1.521, 296.172075, 8.726538, 6.43, 0.94, 296.204385, 40.716803, 6.36, 1.561,
  296.24361, 45.13081, 2.86, -0.002, 296.415225, 36.091022, 6.38, -0.049, 296.41643999999997, 7.613158, 5.89, 0.18,
  296.463975, 35.012751, 6.14, 1.07, 296.46763500000003, -2.883453, 6.47, 0.016, 296.50507500000003, -31.908571, 5.51, 0.024,
  296.56491000000005, 10.613261, 2.72, 1.507, 296.590605, -19.761113, 4.87, 1.061, 296.606655, 33.727598, 5, 0.476,
  296.645895, 32.888591, 6.18, 1.172, 296.686095, 68.437998, 6.34, 0.309, 296.846925, 18.534286, 3.68, 1.313,
  296.861805, 47.907564, 6.14, 1.64, 296.86575, 38.407614, 5.83, -0.087, 296.95224, 25.384058, 6, 0.993,
  297.004815, -56.362611, 5.33, 0.196, 297.0126, -13.703616, 6.11, 0.193, 297.04275, 70.26793, 3.84, 0.888,
  297.12714, 10.6941, 6.44, 0.932, 297.17524499999996, 11.815896, 5.75, 0.546, 297.209055, -12.319421, 6.47, 1.676,
  297.210825, 33.437283, 6.42, 0.129, 297.22951500000005, -52.888109, 6.27, 1.131, 297.24441, 19.142042, 5.01, 0.095,
  297.259185, -10.870763, 6, 1.233, 297.298335, -28.788972, 6.04, 0.403, 297.35541, -72.503378, 5.39, 0.234,
  297.36459, 38.710149, 6.12, 0.906, 297.472575, -66.813069, 6.44, 1.482, 297.478005, 28.439674, 6.45, -0.104,
  297.48255, 27.085182, 6.46, 0.937, 297.55857, -47.557392, 5.91, 1.678, 297.572835, 7.902419, 6.49, -0.086,
  297.59064, -61.06112, 6.21, -0.135, 297.64164, 38.722419, 5.18, 1.665, 297.65553, 40.599759, 5.68, -0.058,
  297.657195, 52.988001, 5.03, 1.286, 297.686625, -59.193667, 5.41, 0.082, 297.69582, 8.868322, 0.76, 0.221,
  297.694935, -10.763512, 5.38, 0.402, 297.695295, 37.826324, 6.13, 1.626, 297.7548, -65.605087, 6.04, 0.317,
  297.75684, 10.415727, 5.12, 0.563, 297.767115, 22.610046, 4.9, -0.153, 297.796245, -2.46099, 6.12, 1.573,
  297.82387500000004, 9.629887, 6.25, 0.102, 297.83072999999996, 47.377236, 6.22, 0.398, 297.861825, 4.088632, 6.47, 1.345,
  297.96084, -39.874367, 5.32, -0.045, 297.99612, 47.027339, 5.6, -0.078, 298.00663499999996, 24.992162, 5.54, 0.68,
  298.014345, 11.628329, 6.16, 0.642, 298.02987, 47.931795, 5.91, -0.174, 298.050015, -19.044991, 5.88, 0.979,
  298.06839, 36.432295, 6.13, 1.434, 298.09068, 18.671875, 6.24, -0.031, 298.118205, 1.005661, 3.87, 0.63,
  298.157145, -54.971026, 5.76, 0.915, 298.16298, -54.976444, 6.5, 0.1, 298.25519999999995, 47.80772, 6.3, -0.126,
  298.276605, -14.603203, 6.47, 0.149, 298.3224, 57.523482, 5.14, -0.125, 298.32807, -3.114464, 5.63, 0.231,
  298.36539, 24.079614, 4.57, -0.047, 298.39752, 59.70866, 6.06, 0.033, 298.534485, -8.574211, 5.76, 1.664,
  298.56201, 8.461453, 4.71, 1.023, 298.57396500000004, -23.941071, 6.22, 1.017, 298.62948, 24.319388, 5.56, -0.018,
  298.656885, -8.227289, 5.7, -0.079, 298.658595, -8.237048, 6.49, -0.04, 298.667505, 7.140353, 6.14, 0.043,
  298.66852500000005, -61.170792, 6.21, 0.163, 298.68666, 0.273627, 5.6, 0.098, 298.70104499999997, 36.995676, 5.79, 0.773,
  298.771275, -33.046252, 6.47, 1.487, 298.81539000000004, -41.868288, 4.12, 1.063, 298.828305, 6.406763, 3.71, 0.855,
  298.831245, -6.73478, 6.49, 0.391, 298.84189499999997, 58.250193, 6.1, 1.021, 298.907505, 52.438948, 4.91, 0.124,
  298.959765, -26.299506, 4.7, 0.748, 298.96567500000003, 38.486705, 4.95, -0.086, 298.980765, 58.845969, 4.98, 1.584,
  299.00526, 16.634799, 5.71, 0.903, 299.006805, -81.34984, 6.39, 1.402, 299.05938, 11.423721, 5.28, 0.014,
  299.07657, 35.083424, 3.89, 1.019, 299.07932999999997, 56.687017, 6.16, 0.09, 299.183925, 36.250599, 6.03, -0.14,
  299.1882, 50.902523, 6.46, 0.003, 299.2368, -27.169899, 4.54, 1.462, 299.276235, -58.901351, 5.24, 0.014,
  299.30778000000004, 40.367824, 5.46, -0.09, 299.43936, 16.789163, 5.54, -0.048, 299.48382, 42.260771, 6.44, 0.095,
  299.48762999999997, -15.49149, 5.01, 0.055, 299.619735, 63.534135, 6.15, 0.035, 299.64315, 38.105693, 6.33, -0.09,
  299.65824, 30.983665, 5.51, -0.06, 299.67174, -69.163957, 5.74, 0.224, 299.67420000000004, 70.366949, 6.32, 0.868,
  299.689275, 19.492148, 3.51, 1.571, 299.72060999999997, -68.762583, 6.38, 0.164, 299.73506999999995, -30.538384, 6.27, 1.051,
  299.73832500000003, -26.195767, 4.84, 0.882, 299.79391499999997, 23.101281, 5.68, 0.345, 299.813925, 52.055691, 6.14, -0.183,
  299.83509, 45.772541, 5.92, 0.185, 299.84434500000003, 1.377696, 6.17, 1.129, 299.90283, 76.481392, 6.2, 1.61,
  299.934075, -35.276305, 4.37, -0.15, 299.947275, -9.958238, 5.87, 0.598, 299.963925, -34.697799, 5.3, 0.17,
  299.97997499999997, 37.042885, 5.15, -0.133, 300.013785, 17.516511, 5.33, 1.576, 300.06399, 26.187887, 6.49, 1.132,
  300.066375, -37.701719, 5.95, 0.989, 300.084315, -33.703452, 5.65, 0.498, 300.09627, -66.94936, 5.75, 1.033,
  300.10562999999996, -49.350946, 6.18, 1.056, 300.11034, -43.043302, 6.11, 1.634, 300.147675, -72.910504, 3.97, -0.032,
  300.20136, -45.112918, 5.8, 0.295, 300.245745, 8.557735, 5.9, 1.529, 300.27519, 27.753573, 4.66, 0.184,
  300.313755, 37.098996, 6.23, 1.314, 300.339825, 50.104695, 5.06, 1.122, 300.34936500000003, -22.737307, 6.01, 0.981,
  300.36156, -40.814336, 6.31, 0.113, 300.36891, 64.820974, 5.22, 1.598, 300.43629, 24.800423, 5.88, -0.134,
  300.436395, -59.375893, 4.95, 1.356, 300.46845, -66.943966, 5.32, 1.218, 300.49416, -13.637217, 5.69, 0.079,
  300.50595, 24.938043, 5.23, 0.374, 300.5841, 64.634419, 6.27, 0.927, 300.59209500000003, 22.151458, 6.5, 0.127,
  300.66448499999996, -27.709845, 4.43, 1.64, 300.70338, 31.958832, 6.39, 1.205, 300.70439999999996, 67.873565, 4.51, 1.313,
  300.818325, 18.500993, 5.99, 1.42, 300.87507, 16.031255, 5.73, -0.095, 300.889365, -37.940699, 4.77, 1.417,
  300.90559499999995, 29.896805, 5.73, 0.749, 300.911655, 22.941058, 6.45, 1.028, 300.93463499999996, -22.595595, 6.44, 0.503,
  301.025985, 17.070173, 5.8, 0.6, 301.03463999999997, 7.277966, 5.51, 1.063, 301.08162, -32.056296, 4.99, 1.208,
  301.09647, -0.709309, 5.67, 1.301, 301.119975, 48.229664, 6.16, 0.037, 301.150725, 32.218598, 5.62, 0.76,
  301.18548000000004, 63.890207, 6.24, 0.1, 301.22253, 68.027159, 6.32, 1.649, 301.272555, -11.599413, 6.38, 0.543,
  301.278105, 51.839398, 6.14, 1.601, 301.28955, 19.991071, 5.09, 1.058, 301.29058499999996, 38.478457, 6.18, 0.654,
  301.33959, 56.341422, 6.19, 0.437, 301.36060499999996, 15.500412, 6.37, 1.615, 301.38324, -67.320897, 6.07, 0.648,
  301.38666, 61.99542, 5.4, 1.191, 301.55094, -4.07821, 6.47, 1.156, 301.557345, 53.165688, 5.81, 0.445,
  301.590825, 35.972468, 5.38, 0.85, 301.722525, 23.614425, 5.08, -0.162, 301.8465, -52.880793, 4.93, 1.591,
  301.89617999999996, -55.016012, 6.26, 0.53, 301.92267, 34.422905, 6.12, 0.117, 301.95987, 9.399833, 6.43, 0.463,
  302.00759999999997, -0.678185, 5.97, 1.023, 302.0271, 16.66439, 6.39, 1.72, 302.03982, -52.577795, 6.47, 0.682,
  302.085315, -66.354691, 6.45, 1.587, 302.1303, -10.062595, 6.18, 0.031, 302.15949, 10.725867, 6.34, -0.136,
  302.17735500000003, -66.182068, 3.55, 0.751, 302.222175, 77.711419, 4.38, -0.046, 302.26599, -47.06793, 6.46, 1.463,
  302.34318, 56.026828, 6.49, 0.938, 302.35674, 36.839621, 4.93, -0.139, 302.63973000000004, 26.904169, 5.51, 0.087,
  302.764755, 21.134579, 6.24, 0.894, 302.780925, -57.524239, 6.36, 0.057, 302.79199500000004, -8.842344, 6.39, -0.135,
  302.79948, -36.101212, 5.32, 0.868, 302.826195, -0.821461, 3.24, -0.066, 302.83756500000004, 21.874937, 6.24, -0.048,
  302.895105, 62.078542, 5.7, 0.53, 302.9499, 26.80899, 5.51, 1.397, 302.99124, -12.392403, 6.34, 1.209,
  303.002925, 26.478806, 5.91, -0.107, 303.09936000000005, -42.780063, 6.2, 1.228, 303.10779, -12.617497, 5.84, 0.476,
  303.13218, 51.463565, 6.01, 1.139, 303.14635499999997, 0.867054, 6.25, 0.042, 303.26841, -0.330796, 6.47, 1.532,
  303.307845, -1.009339, 5.44, 1.43, 303.3252, 46.815675, 4.8, 0.1, 303.34932, 56.567722, 4.28, 0.114,
  303.364965, 60.640569, 5.81, 1.476, 303.3849, -47.713234, 6.47, 1.249, 303.40794, 46.741329, 3.8, 1.27,
  303.428385, 43.379013, 6.13, 1.489, 303.52031999999997, 36.604881, 6.47, -0.014, 303.560535, 28.694817, 5.19, 0.191,
  303.569235, 15.197609, 4.94, 0.072, 303.57925500000005, -52.44577, 5.65, 1.497, 303.612225, -63.415789, 6.09, 0.308,
  303.63343499999996, 36.806302, 4.93, 0.151, 303.81622500000003, 25.591957, 4.79, -0.181, 303.82209, -27.032977, 5.73, 0.878,
  303.84906, 33.729084, 5.7, 0.926, 303.86800500000004, 47.714208, 3.96, 1.451, 303.87600000000003, 23.508906, 5.18, 1.016,
  303.93019499999997, 50.232903, 6.36, 0.096, 303.94224, 27.814242, 4.5, 1.258, 303.96085500000004, -30.005278, 6.3, 1.513,
  304.002555, 45.579525, 5.87, 0.447, 304.014285, 38.898012, 6.28, 0.006, 304.025025, 4.580795, 6.44, 0.867,
  304.082445, 21.5987, 6.11, 1.039, 304.095015, -12.337119, 6.3, 0.005, 304.098375, -36.453575, 6.3, 1.467,
  304.117305, 37.056395, 6.47, -0.097, 304.19619, 24.671102, 5.3, 0.951, 304.23036, 40.365075, 5.27, 1.65,
  304.371075, 42.72206, 6.32, 1.632, 304.37877, 66.853687, 5.91, 0.602, 304.38138, 29.147563, 6.24, 1.01,
  304.41195, -12.508212, 4.3, 0.928, 304.44667499999997, 38.03293, 4.77, 0.377, 304.50582, -21.80996, 5.86, 1.002,
  304.51356, -12.544852, 3.58, 0.883, 304.529115, 40.732082, 5.83, 0.073, 304.60314, 55.397095, 5.76, 0.118,
  304.61937, 36.999803, 5.58, 0.056, 304.662795, 34.982775, 5.14, 0.66, 304.706955, 46.322194, 6.46, -0.123,
  304.73322, -47.710774, 6.28, 1.657, 304.73974499999997, 39.004184, 6.35, 1.871, 304.762515, -63.230744, 6.27, 1.045,
  304.82415, -47.580289, 6.13, 0.469, 304.848345, -19.118533, 5.28, 1.394, 304.872075, 13.216766, 6.2, 1.648,
  304.902945, 62.257472, 5.71, -0.043, 304.930275, -1.078514, 6.05, 1.093, 304.98351, 46.837319, 6.49, -0.084,
  305.00079, 13.548091, 5.96, 0.299, 305.02497, 68.880317, 5.59, 1.472, 305.063415, 39.403226, 6.22, 0.06,
  305.08551, 14.569257, 6.17, 0.926, 305.08918500000004, 17.792928, 5.82, 1.5, 305.12766, 53.595685, 6.23, 1.547,
  305.134635, -55.050882, 6.27, 1.617, 305.165895, -12.75908, 4.77, -0.047, 305.193945, -14.784892, 6.09, -0.016,
  305.21621999999996, -35.673676, 6.46, 1.311, 305.25280499999997, -14.781367, 3.05, 0.79, 305.298, 63.980122, 5.69, 1.561,
  305.368245, -66.74969, 6.49, 0.505, 305.421465, -49.999416, 6.26, 0.549, 305.51273999999995, 41.132137, 6.38, 1.016,
  305.5143, 24.446099, 5.5, -0.09, 305.52234, 45.794994, 5.58, 1.077, 305.557095, 40.256679, 2.23, 0.673,
  305.614575, -42.049548, 5.6, 0.002, 305.65545000000003, 31.264966, 6.09, 1.363, 305.688735, 41.026012, 5.95, 1.632,
  305.718195, 14.551098, 6.16, 0.498, 305.731335, 42.983543, 6.2, 0.957, 305.753295, -9.65471, 6.29, 0.913,
  305.79456, 5.342987, 5.3, 0.983, 305.93487, 37.476449, 5.87, -0.173, 305.965065, 32.190172, 4.43, 1.331,
  305.97159, -42.422868, 5.64, 0.201, 306.13483499999995, 53.551934, 6.49, -0.025, 306.15624, 1.068406, 6.14, -0.036,
  306.17398499999996, 1.368563, 6.41, 1.605, 306.22839, -83.310616, 6.15, 0.203, 306.27085500000004, 59.600097, 6.44, 0.094,
  306.361785, -28.663269, 5.86, 1.101, 306.411885, -56.73509, 1.94, -0.118, 306.41887499999996, 21.409642, 5.68, 0.921,
  306.427185, -2.800378, 6.1, 1.193, 306.433815, 10.055999, 6.32, 1.571, 306.449775, -40.796184, 6.08, 1.364,
  306.504855, 19.865494, 6.45, 1.037, 306.50665499999997, 13.911612, 6.35, 1.453, 306.596475, 17.315559, 6.23, 1.005,
  306.597795, 56.638698, 6.38, 0.018, 306.72078, -37.402905, 6.24, 0.961, 306.75936, 49.383367, 5.73, 0.339,
  306.78238500000003, 34.329069, 6.39, 0.48, 306.80913000000004, 20.476485, 6.44, 1.03, 306.83004, -18.211721, 5.08, -0.049,
  306.892755, 38.440332, 5.63, 0.072, 307.03141500000004, 8.437448, 6.23, 1.074, 307.060305, 81.422708, 5.38, 1.01,
  307.06996499999997, 2.937161, 6.2, 0.899, 307.103775, -3.357794, 6.12, -0.049, 307.181625, -15.741499, 6.41, 0.999,
  307.194735, -35.595863, 6.09, -0.094, 307.21506, -17.813687, 4.77, 0.386, 307.2618, 83.625417, 6.19, 0.163,
  307.33495500000004, 36.454729, 5.9, 0.407, 307.34889, 30.368555, 4.01, 0.404, 307.362945, 56.06819, 5.89, -0.052,
  307.363965, 81.091277, 5.96, 0.942, 307.380585, -22.391567, 6.13, 1.543, 307.395225, 62.994105, 4.21, 0.199,
  307.412505, -2.885531, 4.91, 1.16, 307.474605, -18.583178, 5.94, 0.062, 307.49967, 45.928556, 6.43, 1.137,
  307.503, 72.531703, 6.23, 1.353, 307.514745, 48.951569, 4.94, -0.087, 307.57484999999997, 10.895924, 6.03, -0.019,
  307.73667, -29.112666, 6.35, 0.227, 307.742295, 20.606148, 6.21, 0.138, 307.74679499999996, 36.935839, 6.21, 0.969,
  307.767945, -15.056168, 6.1, 0.797, 307.828395, 49.220297, 5.44, 1.566, 307.83807, 52.309526, 6.2, 1.018,
  307.87668, 74.954619, 5.18, 0.1, 307.9011, 34.330373, 6.47, 0.422, 307.94379, 56.779858, 6.14, 1.431,
  307.99254, 25.804977, 6.37, 0.281, 308.08506, 2.132808, 6.47, 1.514, 308.098725, -9.853384, 5.66, 0.689,
  308.218155, -24.943829, 6.35, 0.001, 308.303205, 11.303263, 4.03, -0.123, 308.32341, -80.964862, 5.76, 1.122,
  308.45230499999997, 41.772658, 6.5, 0.994, 308.47578000000004, 35.250852, 4.61, 1.593, 308.47851, 46.693866, 5.78, -0.14,
  308.47945500000003, -44.516048, 5.12, 0.999, 308.48767499999997, 13.027255, 5.39, 0.093, 308.49969, 4.898664, 6.42, 1.016,
  308.5416, 20.985185, 6.49, -0.138, 308.54874, -13.721091, 6.11, 0.543, 308.69745, -30.473472, 6.42, -0.075,
  308.71002, 51.854221, 6.19, 0.318, 308.73114, -38.08989, 6.45, 0.264, 308.77632, -71.188779, 6.41, 1.305,
  308.82723, 14.674213, 4.64, 0.12, 308.88439500000004, -16.525879, 6.19, 0.218, 308.895045, -60.581749, 4.75, 0.291,
  308.94921, -44.337606, 6.36, 0.958, 308.965365, -69.610586, 6.09, 1.293, 309.03474, 25.882648, 6.4, 0.158,
  309.15972, -63.120963, 6.34, 0.413, 309.1818, -2.549957, 4.91, 1.606, 309.26946, 26.461947, 5.59, -0.05,
  309.326595, 0.096978, 6.21, -0.076, 309.348255, 38.328665, 6.21, 1.011, 309.38241, 31.57254, 6.32, -0.089,
  309.38724, 14.595087, 3.64, 0.425, 309.39173999999997, -47.291502, 3.11, 0.998, 309.396975, -61.529918, 4.86, 0.447,
  309.454665, 11.377676, 5.42, 0.05, 309.467595, -25.10922, 6.38, 0.328, 309.478035, 18.26858, 6.22, 1.162,
  309.577515, -81.289063, 5.89, 1.692, 309.58450500000004, -1.105121, 4.31, 0.949, 309.63057, 21.201174, 4.81, -0.03,
  309.63297, 24.115958, 5.06, -0.133, 309.64579499999996, 23.680494, 5.91, 0.953, 309.68327999999997, 13.315125, 5.69, 1.509,
  309.74800500000003, 30.334265, 5.68, 1.088, 309.750765, 56.00485, 6.45, 0.403, 309.7707, 15.838199, 5.99, -0.145,
  309.77441999999996, -4.929494, 6.46, 1.016, 309.782415, 10.086203, 5.07, 0.702, 309.79437, 21.817444, 6.08, -0.043,
  309.805215, -2.412975, 6.23, -0.09, 309.817995, -14.95476, 5.24, -0.129, 309.85371, 0.486445, 5.15, 1.06,
  309.88881000000003, 40.579658, 6.07, -0.134, 309.909525, 15.912072, 3.77, -0.057, 309.96556499999997, -62.907802, 6.22, 1.099,
  309.96615, 11.249649, 6.39, 0.559, 310.010205, -60.548892, 5.11, 0.544, 310.012275, -18.138659, 5.15, 1.647,
  310.013235, 43.458878, 5.97, 1.186, 310.048875, -23.773867, 6.36, 0.719, 310.074525, 60.505264, 6.02, 0.443,
  310.08261, -33.431843, 5.47, 1.118, 310.1355, -16.12418, 5.79, 0.997, 310.151145, 29.805552, 6.02, 0.163,
  310.18807499999997, 19.935536, 6.43, 0.611, 310.231755, -42.396689, 6.25, 0.934, 310.260585, 32.307287, 5.53, 0.871,
  310.31754, 14.58288, 6.01, 1.235, 310.34853, -31.598289, 5.75, 1.551, 310.35109500000004, -25.999911, 6.29, 1.224,
  310.35273, -42.13378, 6.28, 1.584, 310.35798, 45.280338, 1.25, 0.092, 310.48542, 41.716875, 5.68, -0.107,
  310.48779, -66.760682, 5.14, -0.061, 310.49235, 17.521489, 6.24, 0.942, 310.510965, -76.180592, 5.99, 0.45,
  310.55262, 50.34003, 5.41, -0.107, 310.64632500000005, 82.531158, 5.75, 0, 310.665375, 60.601316, 6.17, 0.034,
  310.72065, -39.55883, 6.3, 1.073, 310.79583, 66.657447, 5.59, 0.218, 310.80702, 57.113996, 6.34, 0.282,
  310.850805, 35.587801, 6.48, 1.251, 310.864725, 15.074581, 4.43, 0.302, 311.00948999999997, -51.920971, 4.51, 0.278,
  311.091855, 56.488405, 5.91, 1.643, 311.13777, 69.751813, 6.5, 0.973, 311.21878499999997, 25.270617, 4.92, 1.183,
  311.23970999999995, -66.203212, 3.42, 0.163, 311.304675, -27.24728, 6.5, 0.946, 311.322165, 61.838782, 3.41, 0.912,
  311.33817, 57.579725, 4.52, 0.535, 311.41564500000004, 30.719715, 4.22, 1.051, 311.5239, -25.270898, 4.13, 0.426,
  311.541615, -21.514032, 5.91, 0.066, 311.55267000000003, 33.970256, 2.48, 1.021, 311.57750999999996, -36.120152, 6.49, 0.433,
  311.58357, -39.199262, 5.48, -0.078, 311.58849000000004, 52.995297, 6.34, 1.131, 311.66082, 46.531692, 6.3, 0.064,
  311.66193, 16.124134, 5.15, 0.495, 311.6646, 16.124296, 4.27, 1.042, 311.76484500000004, -2.486912, 6.28, 1.558,
  311.794785, 34.374123, 4.93, 1.294, 311.83653, 45.579934, 6.41, 1.606, 311.852235, 36.490717, 4.53, -0.083,
  311.88975, 80.552262, 5.36, 1.144, 311.91897, -9.495776, 3.78, 0, 311.934315, -5.027701, 4.43, 1.639,
  311.949495, 3.306467, 6.38, -0.013, 311.951385, 6.008209, 5.57, -0.01, 311.955375, 47.831869, 5.6, 1.466,
  311.97056999999995, 52.407167, 6.29, 0.883, 312.076725, -44.196832, 6.47, 1.161, 312.12126, -43.988544, 5.11, 0.361,
  312.17808, 51.910331, 6.26, -0.071, 312.234555, 46.114134, 4.81, 0.571, 312.321825, -0.563337, 6.24, 1.401,
  312.32246999999995, 64.042257, 6.45, 0.025, 312.32338500000003, -25.78124, 5.86, -0.069, 312.325995, -68.776521, 5.41, 1.122,
  312.335595, -18.035855, 6.2, 1.402, 312.370635, -46.226826, 4.9, 1.494, 312.40701, 50.127082, 6.5, 1.624,
  312.40737, 12.545128, 6.01, 0.42, 312.45108000000005, 7.864185, 6.32, 0.019, 312.47769, 46.661337, 6.33, -0.066,
  312.49199999999996, -33.779722, 4.89, 1.004, 312.49623, 5.54456, 6.2, 0.986, 312.520425, 44.059304, 5.06, 0.198,
  312.67407, -12.544906, 5.87, 1.075, 312.69645, -32.054604, 6.42, 1.513, 312.753165, -37.913332, 5.52, 1.38,
  312.85728, -5.626633, 5.99, 0.464, 312.86766, 28.250505, 5.66, 0.616, 312.875205, -51.608179, 5.06, 1.125,
  312.910215, -62.429335, 5.67, 0.203, 312.95538, -26.919133, 4.12, 1.633, 312.99483, -33.177974, 6.06, 0.029,
  313.001625, 32.848894, 6.42, -0.138, 313.032015, 27.096979, 4.56, 0.835, 313.03623, -5.507059, 5.55, -0.076,
  313.163475, -8.983318, 4.73, 0.325, 313.254795, -23.783203, 6.32, 0.876, 313.27332, -11.573659, 6.38, 0.661,
  313.2807, 29.649097, 6.36, 1.085, 313.311465, 44.38726, 4.8, -0.134, 313.32735, 45.181673, 5.48, 1.088,
  313.35399, -30.718954, 6.35, 1.1, 313.41741, -39.809865, 5.34, 1.318, 313.47456, 33.437891, 5.47, 1.522,
  313.49328, -6.889461, 6.44, 0.361, 313.527375, -27.925239, 6.41, 1.634, 313.64016000000004, 28.057621, 5.03, 1.481,
  313.64626499999997, -50.727341, 6.23, -0.098, 313.68456, 75.92557, 5.99, 0.946, 313.699245, -17.922894, 5.78, 1.122,
  313.70247, -58.454155, 3.67, 1.25, 313.90287, 13.721536, 5.19, 1.119, 313.910715, 12.568558, 5.54, 0.131,
  313.91949, 4.532723, 6.04, 0.824, 313.957515, 47.417656, 5.68, 0.408, 314.07087, 56.887519, 6.23, -0.172,
  314.106105, 50.728598, 5.83, 0.337, 314.10789, 49.195847, 5.92, 1.054, 314.14491, 44.924722, 5.96, 0.02,
  314.197185, -26.296378, 5.7, 0.507, 314.22511499999996, -9.697545, 5.49, 1.474, 314.293395, 41.167136, 3.94, 0.027,
  314.29407, 0.463779, 6.06, 1.217, 314.41935, -16.031539, 5.89, 0.18, 314.56813500000004, 22.325908, 5.3, 1.419,
  314.581005, 44.471711, 5.55, 0.973, 314.608065, 10.839286, 5.51, 0.934, 314.625135, 50.461791, 5.59, -0.144,
  314.62896, 41.939925, 6.17, -0.079, 314.674335, -14.483128, 5.95, 0.244, 314.768655, 4.293481, 5.3, 0.464,
  314.771295, 4.29461, 5.24, 0.457, 314.852565, 42.324466, 6.47, -0.077, 314.85565499999996, 59.438594, 5.54, 1.411,
  314.90058, -19.035283, 6.26, -0.11, 314.95647, 47.520951, 4.74, -0.084, 314.998665, -36.129641, 6.1, 0.4,
  315.01659, 7.516197, 5.98, 0.283, 315.08964000000003, -51.265312, 5.76, 0.48, 315.115365, 19.329581, 5.69, 1.588,
  315.14099999999996, -4.730261, 6.21, 0.635, 315.18091499999997, -53.73907, 6.26, 1.563, 315.215685, -17.530898, 6.07, 1.267,
  315.29553, 46.155773, 5.38, -0.206, 315.3036, 36.02601, 6.01, 0.994, 315.322755, -32.257767, 4.67, 0.89,
  315.36675, -68.209593, 6.36, 0.101, 315.43865999999997, -26.880993, 6.04, 0.073, 315.53751, 56.669614, 5.83, -0.058,
  315.587325, 39.509035, 6.5, 1.51, 315.60084, 44.79098, 6.18, 1.687, 315.61309500000004, -38.53097, 5.93, 1.106,
  315.70257000000004, 45.84889, 6.5, -0.124, 315.741495, -38.631447, 5.32, 0.424, 315.74844, -0.924744, 6.5, -0.094,
  315.75747, 14.730026, 6.33, 1.68, 315.7626, 1.532061, 6.24, 0.479, 315.770145, 38.657415, 6.1, 1.011,
  315.79245000000003, -27.731594, 6.25, 0.945, 315.85861500000004, 50.351914, 6.37, 0.986, 315.931155, 46.86315, 6.32, 0.259,
  315.948375, 53.2859, 5.93, 1.001, 315.96723000000003, 41.628175, 6.34, 0.39, 316.01968500000004, -5.823066, 5.53, 0.683,
  316.101255, -19.854991, 4.82, 0.169, 316.14437999999996, 5.502862, 5.63, 1.65, 316.173495, 2.942274, 6.41, 1.051,
  316.179315, -77.023767, 5.13, 0.49, 316.18906499999997, 2.269771, 6.34, 0.965, 316.23276000000004, 43.927852, 3.72, 1.609,
  316.30935, -54.727042, 5.17, 1.201, 316.36134, 5.958199, 5.94, 0.538, 316.37174999999996, 78.126392, 5.91, -0.065,
  316.48677000000004, -17.232861, 4.08, -0.01, 316.504755, -30.12512, 5.69, 1.047, 316.59735, 71.431797, 5.88, 0.386,
  316.597815, 26.924362, 6.13, 1.026, 316.602825, -32.341618, 5.2, 1.104, 316.606305, -41.385965, 5.55, 1.35,
  316.626015, 31.184657, 5.77, 0.554, 316.65039, 47.648403, 4.56, 1.569, 316.666005, 3.803119, 6.48, 0.88,
  316.72191, 38.749415, 5.2, 1.069, 316.727445, 38.742055, 6.05, 1.309, 316.78195500000004, -25.005853, 4.49, 1.604,
  316.89018, 15.658657, 6.27, 1.008, 316.935495, -45.379469, 6.45, 0.245, 316.93623, -17.455902, 6.18, -0.035,
  317.11725, 6.989358, 6.14, 1.669, 317.13625499999995, -63.92826, 5.75, 1.18, 317.140095, -21.193669, 5.3, 0,
  317.16202499999997, 30.205637, 5.6, -0.048, 317.191785, -88.956499, 5.45, 0.283, 317.34078, -73.172968, 5.67, 0.59,
  317.343045, -36.705937, 6.47, 0.52, 317.387475, -20.556661, 6.25, 0.385, 317.39853, -11.371693, 4.5, 0.926,
  317.492775, 2.943681, 6.44, 0.375, 317.56485, 53.5631, 5.75, -0.111, 317.58541499999995, 10.131579, 4.7, 0.262,
  317.62899, 47.692224, 6.46, 0.007, 317.630475, 10.048922, 6.07, 0.022, 317.69557499999996, -9.354074, 6.27, 1.161,
  317.837025, -72.544353, 6.18, 1.087, 317.92224, -14.472378, 6.47, 0.316, 317.950995, 59.98661, 5.64, 0.11,
  318.05709, -40.269362, 5.83, 0.45, 318.234105, 30.226916, 3.21, 0.99, 318.26265, -39.424922, 5.25, 0.46,
  318.322185, -27.619333, 5.41, 1.425, 318.328995, -36.423527, 5.97, 0.967, 318.335265, -70.126267, 5.06, 1.578,
  318.339975, 81.230972, 6.12, 0.092, 318.360105, 36.633263, 6.07, 0.223, 318.369945, 15.982395, 6.27, 0.238,
  318.42696, 64.403952, 6.38, 0.625, 318.54285, 29.900959, 6.18, 1.105, 318.62005500000004, 10.006981, 4.47, 0.529,
  318.654375, 0.092256, 6.38, 1.574, 318.69775500000003, 38.045317, 3.74, 0.393, 318.777585, -17.345138, 6.05, 0.978,
  318.809865, -40.506065, 6.2, 1.138, 318.904905, 47.973995, 6.45, -0.129, 318.90792, -20.651696, 5.17, 1.161,
  318.926685, 77.012296, 5.92, 1.531, 318.93684, -15.1715, 5.31, 1.639, 318.94106999999997, -53.263084, 5.73, 0.191,
  318.944925, -36.210709, 6.13, 1.38, 318.955965, 5.247845, 3.92, 0.549, 319.07135999999997, 44.238222, 6.36, 0.979,
  319.07406, -9.214656, 6.45, 1.612, 319.12341, 42.251787, 6.23, 1.251, 319.164465, -1.607759, 6.48, 0.981,
  319.258485, 53.997693, 6.12, 0.049, 319.30640999999997, -13.278989, 6.41, 0.035, 319.30933500000003, 55.798001, 6, 1.447,
  319.328295, 58.611485, 6.42, 0.194, 319.346595, 42.683572, 6.17, -0.094, 319.35397500000005, 39.394681, 4.22, 0.098,
  319.47948, 34.896898, 4.41, -0.103, 319.48449, -32.172539, 4.71, 0.07, 319.48869, -17.985138, 5.4, -0.118,
  319.50198, -64.68158, 6.32, -0.064, 319.54614000000004, -4.519478, 5.83, -0.13, 319.613265, 43.945945, 5.04, -0.061,
  319.63512, 61.184393, 6.43, 1.543, 319.64445, 62.585573, 2.45, 0.257, 319.71677999999997, 11.203373, 5.97, 1.612,
  319.725825, -28.76582, 6.4, 0.966, 319.73053500000003, 41.040518, 6.15, 0.257, 319.81537499999996, 58.623502, 5.51, 1.114,
  319.84242, 38.237473, 5.89, 0.505, 319.84257, 64.871855, 5.19, -0.045, 319.86978, 49.510294, 5.75, -0.119,
  319.96644, -53.449427, 4.39, 0.191, 320.03952000000004, -45.021893, 6.15, 2.387, 320.05863, 22.026186, 6.29, -0.106,
  320.13948, 60.756405, 6.11, 1.005, 320.19012000000004, -40.809465, 4.8, 0.029, 320.208525, 32.452221, 6.45, 0.802,
  320.25594, 40.345066, 6.39, 0.533, 320.26825499999995, 23.855966, 5.58, 1.057, 320.267985, -4.560125, 5.87, 0.912,
  320.2701, 7.354503, 5.81, 1.663, 320.319165, -49.938248, 6.4, 1.327, 320.34141, 32.612733, 6.05, 0.062,
  320.50169999999997, 49.388848, 5.68, 1.1, 320.52165, 19.804508, 4.08, 1.108, 320.56164, -16.834542, 4.28, 0.888,
  320.67521999999997, 30.309882, 6.07, 1.079, 320.723385, 6.81114, 5.16, 0.064, 320.734395, -9.31933, 5.99, 1.516,
  320.75205, -22.669048, 5.63, 1.641, 320.95162500000004, 37.351481, 6.46, 1.472, 320.982885, -25.202484, 6.47, 1.123,
  320.99508, 24.274135, 5.7, 0.314, 321.03103500000003, 25.312423, 6.2, 0.026, 321.03303, -22.747101, 6.38, 1.026,
  321.03997499999997, -20.851869, 5.38, 1.176, 321.04788, -12.878108, 5.48, 0.297, 321.06975, -69.733882, 6.28, 2.607,
  321.08679, -46.614706, 6.3, 0.235, 321.09639, 24.528393, 6.35, 1.057, 321.102345, 10.174252, 6.33, 0.474,
  321.103395, -41.006695, 5.76, -0.036, 321.141675, 26.17456, 5.67, 0.323, 321.205935, 80.524826, 5.97, 0.95,
  321.21531, -3.398357, 6.38, 0.334, 321.304275, -9.748552, 5.71, 0.208, 321.320655, -3.556747, 5.48, 1.451,
  321.325095, -71.799061, 6.09, 1.265, 321.331245, 46.714341, 5.59, 0.335, 321.44593499999996, 36.667386, 5.93, 0.033,
  321.46494, 0.53434, 6.45, 0.162, 321.56433000000004, -54.660459, 6.1, 0.366, 321.5952, -37.829429, 5.64, 1.185,
  321.61057500000004, -65.366198, 4.21, 0.494, 321.611085, 19.37564, 6.08, 0.235, 321.61689, 1.103359, 6.12, 0.481,
  321.66677999999996, -22.411332, 3.77, 1.002, 321.687345, 52.898537, 6.01, -0.109, 321.71502, 48.835168, 5.29, 0.108,
  321.75681000000003, -42.54793, 5.5, 0.392, 321.811755, -21.19621, 5.78, 1.44, 321.839025, 37.116798, 5.3, -0.14,
  321.85537500000004, 59.750075, 6.11, 1.72, 321.91689, 27.608593, 5.39, 0.049, 321.9423, 66.809096, 5.42, -0.099,
  322.034325, 32.22533, 5.75, 0.333, 322.10349, 8.195645, 6.39, 1.64, 322.16492999999997, 70.560716, 3.23, -0.201,
  322.180815, -21.80718, 4.5, 0.889, 322.18681499999997, -69.505386, 5.47, 1.553, 322.21971, 55.418702, 6.14, 0.1,
  322.249065, 22.179436, 5.84, 1.37, 322.24965, 17.905909, 6.42, 1.393, 322.25049, -53.705912, 6.39, 1.14,
  322.36224, 46.540585, 5.22, 0.965, 322.39374000000004, 6.581379, 6.41, 1.179, 322.487055, 23.638838, 4.52, 1.618,
  322.584675, 52.957998, 6.02, 0.08, 322.74705, 60.459432, 5.53, 0.102, 322.790115, 12.137475, 6.1, -0.047,
  322.864425, 52.619856, 6.17, 0.9, 322.88973, -5.571172, 2.9, 0.828, 322.95897, 23.845179, 6.43, 1.064,
  323.01201000000003, -84.810069, 6.42, 1.405, 323.024475, -41.17931, 5.29, 1.109, 323.060715, -33.944623, 5.97, 0.051,
  323.13858, -24.590418, 6.43, 0.2, 323.23578, 49.977629, 5.77, -0.042, 323.323395, -52.737773, 6.43, 1.481,
  323.32452, 45.854014, 6.27, 1.805, 323.33783999999997, -80.039361, 6.47, 0.044, 323.34801, -44.8487, 5.57, 1.044,
  323.477025, -82.683084, 6.35, 0.089, 323.49525, 45.591837, 3.98, 0.885, 323.57151, -42.924679, 6.32, 1.093,
  323.614425, 51.698465, 6.17, -0.015, 323.64156, 22.754521, 6.45, 0.513, 323.678205, 1.829161, 6.41, 1.398,
  323.69129999999996, 18.328929, 6.47, 1.254, 323.69394, 38.534054, 4.87, 1.085, 323.71272, -20.084274, 5.7, 0.423,
  323.720835, -29.696117, 6.42, -0.097, 323.816475, -23.454313, 6.39, 1.098, 323.82342, -3.983305, 5.79, 1.11,
  323.8296, 28.197607, 6.25, 0.357, 323.857995, 68.21929, 6.47, -0.083, 323.862645, 24.452161, 6.22, 0.141,
  324.010335, 45.374591, 5.96, 1.341, 324.021, 15.081993, 6.5, 0.94, 324.04569, -26.171516, 5.73, 0.234,
  324.058275, 30.055422, 6.36, 1.24, 324.20329499999997, -33.047896, 6.1, 0.226, 324.23740499999997, 40.413521, 5.04, 0.198,
  324.27012, -19.466011, 4.51, -0.18, 324.36615, 44.69655, 6.19, 0.218, 324.39066, -0.390562, 6.22, 0.056,
  324.411705, 54.042192, 6.16, 0.991, 324.43185, 6.618391, 6.19, 0.046, 324.43795500000004, -7.854201, 4.68, 0.175,
  324.439275, 19.318607, 5.46, 0.321, 324.48010500000004, 62.08194, 4.76, 0.246, 324.51177, -64.824167, 6.22, 0.021,
  324.633075, 5.771742, 5.66, 0.265, 324.68817, 25.498829, 6.18, 1.026, 324.734145, -79.442583, 6.17, 0.46,
  324.740085, 57.489037, 5.74, 0.2, 324.754935, 20.265451, 5.77, 0.314, 324.77545499999997, -33.678856, 6.28, 0.949,
  324.86712, -10.576896, 6.07, 1.034, 324.8886, 2.243558, 5.1, 1.034, 324.99885, -52.35901, 6.2, 0.584,
  325.022715, -16.662308, 3.69, 0.32, 325.04623499999997, 43.273839, 5.09, 1.601, 325.140435, -55.737977, 6.33, 1.06,
  325.18044, 54.872149, 6.16, 1.116, 325.368795, -77.390046, 3.73, 1.008, 325.38693, -14.047611, 5.16, 0.672,
  325.39275, 40.805222, 6.07, 0.068, 325.47978, 71.311417, 4.55, 1.108, 325.50288, -23.262858, 5.24, 0.991,
  325.50451499999997, 35.5102, 5.98, 2.5, 325.523595, 51.189622, 4.69, -0.119, 325.53481500000004, 45.765697, 6.11, 1.415,
  325.542135, 1.285253, 5.66, 1.446, 325.56437999999997, 5.680137, 5.3, 1.653, 325.59564, 41.077019, 5.73, 0.055,
  325.637325, 10.824314, 6.06, -0.115, 325.6617, 49.600257, 6.1, 0.993, 325.66459499999996, -18.866323, 4.72, 0.868,
  325.689045, 59.270844, 6.1, 1.349, 325.76709, 72.320084, 5.18, 1.063, 325.76831999999996, -14.399709, 5.88, 0.255,
  325.776975, 41.15497, 5.51, 1.615, 325.806375, -19.620961, 6.23, 0.269, 325.85686499999997, 38.283589, 5.69, -0.01,
  325.876905, 58.780046, 4.23, 2.242, 325.91571, 7.528657, 6.47, 1.114, 325.99212, 22.815289, 6.43, 1.295,
  325.99620000000004, -57.325247, 6.49, 0.484, 326.00403, -14.74937, 5.96, 0.219, 326.03565000000003, 28.742632, 4.49, 0.512,
  326.04649500000005, 9.875011, 2.38, 1.52, 326.12274, -38.55253, 6.28, 1.129, 326.1279, 17.350017, 4.34, 1.161,
  326.13052500000003, 14.771939, 5.96, 0.587, 326.16137999999995, 25.645036, 4.14, 0.425, 326.22201, 62.460567, 5.94, 0.312,
  326.236695, -33.025781, 4.35, -0.053, 326.251065, -9.082428, 5.1, 1.108, 326.30165999999997, 52.267577, 6.4, 1.901,
  326.32797, -49.498761, 6.46, 1.148, 326.36220000000003, 61.120806, 4.25, 0.474, 326.37005999999997, -71.008849, 6.02, -0.099,
  326.435415, 35.857311, 6.44, 0.997, 326.518185, 22.94888, 5.29, 1.381, 326.56779, -9.275935, 6, 1.629,
  326.59974, 25.563504, 6.28, 1.212, 326.63374500000003, -11.365954, 5.57, -0.002, 326.69836499999997, 49.30957, 4.23, -0.12,
  326.753595, 70.150882, 6.45, -0.007, 326.760165, -16.127286, 2.85, 0.18, 326.769825, 17.194041, 6.18, 0.35,
  326.80818, 2.686124, 5.63, 0.012, 326.85542999999996, 60.692689, 5.53, 1.575, 326.909325, -5.916802, 6.17, 0.23,
  326.93397, -30.898304, 5.02, 0.042, 327.03499500000004, 36.580388, 6.25, 1.545, 327.06544499999995, -47.303615, 5.57, 0.601,
  327.12230999999997, 38.648575, 6.1, -0.072, 327.2838, 66.792032, 6.49, 0.391, 327.32921999999996, 61.27276, 6.18, 1.685,
  327.36195, 20.462446, 6.27, -0.097, 327.41706, 41.148787, 6.48, 0.381, 327.42091500000004, -12.722865, 6.31, 0.223,
  327.46122, 30.174215, 5.07, 0.01, 327.500535, -64.712537, 5.62, 1.018, 327.536235, 17.285851, 5.34, 0.394,
  327.554085, -16.844914, 6.38, 1.42, 327.69671999999997, -69.629416, 5.52, 1.378, 327.726195, -82.718904, 5.27, 0.756,
  327.770745, 39.536658, 6.2, -0.068, 327.892695, 19.826682, 5.78, -0.1, 327.905205, 65.75271, 6.37, 0.281,
  327.923925, -18.62294, 6.19, 0.374, 328.00431, 55.796743, 5.7, -0.081, 328.075755, 21.273162, 6.27, 1.601,
  328.12467, 28.793538, 5.52, 0.426, 328.2657, 25.92514, 5.09, -0.155, 328.32402, -13.551768, 5.08, 0.378,
  328.405755, 19.668437, 5.69, 0.011, 328.48212, -37.364852, 3, -0.084, 328.4907, 6.864804, 6.14, 0.786,
  328.54321500000003, -4.27618, 5.71, 1.185, 328.572585, 19.718121, 6.36, 0.938, 328.61061, 80.308559, 6.43, 1.453,
  328.64964, -3.301272, 6.24, 0.466, 328.72149, 56.611227, 5.74, 0.655, 328.797345, -61.886608, 5.92, 0.393,
  328.83582, 61.54181, 6.17, 1.599, 328.87914, 65.320809, 5.84, -0.037, 328.981815, -30.60592, 6.41, 0.927,
  329.01432, -52.46376, 6.5, 0.925, 329.05852500000003, -57.899591, 6.17, 0.215, 329.094885, -37.253655, 5.45, 0.084,
  329.09994, 21.239858, 6.39, 1.698, 329.163105, 63.625557, 5.11, 1.547, 329.23488000000003, 12.076492, 5.54, 0.054,
  329.25895499999996, -37.746844, 6.18, 0.321, 329.29623, 66.156153, 6.41, -0.056, 329.46276, 74.996714, 6.32, 1.56,
  329.479395, -54.992575, 4.4, 0.297, 329.55544499999996, -5.424922, 6.33, 0.378, 329.625315, -59.01214, 6.13, 0.469,
  329.682465, -21.182945, 6.06, 1.621, 329.72298, 62.697986, 5.96, 1.64, 329.7291, -4.373109, 6.24, 0.971,
  329.748705, 19.020302, 6.5, 1.013, 329.81277, 73.179896, 5.04, 0.439, 329.82460499999996, -38.395096, 5.5, 0.996,
  330.03303, 6.717437, 6, -0.112, 330.10098, -55.883486, 6.02, -0.061, 330.111255, 33.005928, 6.46, 0.463,
  330.20926499999996, -28.453736, 5.43, -0.095, 330.2709, 0.604715, 5.6, 1.279, 330.27228, 13.119823, 5.61, 0.336,
  330.28848, 8.257164, 5.65, 1.44, 330.46077, 52.882253, 5.79, -0.106, 330.469335, -77.662544, 6.39, 0.231,
  330.505725, 10.973806, 6.36, -0.104, 330.51906, 58.000366, 5.55, 0.017, 330.549375, -17.903474, 6.28, 1.002,
  330.609375, -16.964836, 6.39, 0.447, 330.73611, 44.649863, 5.57, -0.029, 330.76566, -76.118427, 5.94, 0.399,
  330.81858, -6.522406, 5.55, 0.959, 330.83229, -56.785977, 4.69, 1.056, 330.82851, -2.155363, 4.74, -0.1,
  330.829305, 11.386552, 5.83, -0.05, 330.947025, 64.627971, 4.26, 0.379, 330.970635, 63.11992, 5.26, 1.557,
  331.09932000000003, -29.91653, 6.45, 1.603, 331.143825, 32.941744, 6.36, 1.121, 331.153185, -26.822359, 5.97, -0.167,
  331.197585, -0.906343, 5.29, 0.231, 331.25203500000003, 62.785671, 5.27, 1.413, 331.264425, 14.815918, 6.38, 1.523,
  331.286625, 62.279814, 5.07, 0.24, 331.297215, 26.673689, 5.75, 1.249, 331.318785, 46.744836, 6.16, 1.611,
  331.39446, 28.963981, 5.69, -0.048, 331.419795, 5.05853, 4.86, 1.443, 331.445985, -0.319851, 2.95, 0.969,
  331.46019, 45.112504, 6.5, -0.025, 331.46244, -59.636072, 5.62, 1.468, 331.463415, 48.231494, 6.26, -0.088,
  331.50814499999996, 45.014348, 5.09, 1.568, 331.52871, -39.543353, 4.47, 1.349, 331.55107499999997, 45.24869, 6.19, 0.078,
  331.55649, 56.343396, 6.38, -0.091, 331.60929, -13.869679, 4.29, -0.075, 331.752705, 25.345112, 3.77, 0.435,
  331.790175, 58.840718, 6.34, 0.877, 331.85661, 53.307438, 6.17, 0.389, 331.86911999999995, 19.475526, 5.74, 0.331,
  331.87485, 18.000709, 6.31, 1.605, 331.959615, 21.702926, 5.79, -0.077, 332.058135, -46.960975, 1.73, -0.07,
  332.067855, 49.79699, 6.41, 1.579, 332.07183, 25.543522, 6.08, 0.311, 332.09583, -32.988468, 4.5, 0.054,
  332.108055, -34.043841, 4.99, 1.499, 332.170125, 45.742254, 6.11, 0.763, 332.17767000000003, -33.125691, 6.37, 0.205,
  332.2458, -18.519592, 5.8, -0.154, 332.306835, 33.172337, 5.58, 0.985, 332.37066, -23.659109, 6.36, 0.921,
  332.451615, 72.341207, 4.79, 0.919, 332.48209499999996, -34.014967, 5.37, 0.241, 332.49108, -48.107661, 6.43, 1.38,
  332.49685500000004, 33.178224, 4.28, 0.471, 332.50062, -28.292435, 6.44, 0.147, 332.536395, -32.548407, 4.94, 0.489,
  332.54994, 6.197865, 3.52, 0.086, 332.56379999999996, 72.111265, 6.36, -0.053, 332.57923500000004, 19.616339, 6.18, 0.688,
  332.58795, -3.894086, 6.28, -0.006, 332.59182, 14.629858, 6.36, 1.08, 332.625765, 20.977984, 6.45, 0.099,
  332.640615, -4.266855, 5.98, 0.981, 332.655975, 11.624539, 5.78, 1.617, 332.65617000000003, -11.564939, 5.43, -0.117,
  332.66193, 70.132573, 5.52, 0.391, 332.71362, 58.201261, 3.39, 1.558, 332.71543499999996, 30.553001, 6.3, 0.227,
  332.75989500000003, -21.23279, 6.1, 0.503, 332.791035, 50.823393, 5.38, 0.152, 332.87742000000003, 59.414488, 5.05, 0.192,
  332.95272, 56.839357, 5.24, 0.534, 332.96388, 16.040551, 5.93, 0.951, 332.979555, -76.116023, 6.13, 1.001,
  332.98674, 59.084579, 6.29, 1.123, 333.0084, 60.759095, 5.37, 1.184, 333.03372, 24.950641, 5.97, 1.5,
  333.093525, 63.291035, 5.76, 1.645, 333.107325, -14.193957, 6.04, 0.386, 333.18279, -4.720679, 6.39, 0.498,
  333.19926000000004, 34.604592, 5.34, 1.134, 333.219735, 73.307193, 6.11, 1.006, 333.23952, -26.327793, 6.19, 0.169,
  333.291735, 18.279812, 6.5, 1.374, 333.29251500000004, 86.107955, 5.27, -0.03, 333.411225, 28.608017, 5.87, 1.169,
  333.43512, -25.180905, 5.58, 0.497, 333.455085, 45.440613, 5.53, 0.021, 333.45712499999996, 63.162337, 6.13, -0.089,
  333.46968, 39.714927, 4.5, 1.385, 333.57513, -21.074566, 5.33, 0.812, 333.57667499999997, 17.189344, 6.5, 1.288,
  333.57813, -27.766908, 5.45, -0.121, 333.660585, -41.381666, 6.23, 0.648, 333.68484, 42.95391, 5.72, 0.014,
  333.75816000000003, 57.043587, 4.18, 0.278, 333.89598, -44.451499, 6.1, 0.988, 333.903795, -41.3467, 4.79, 0.79,
  333.9924, 37.748737, 4.14, 1.447, 333.999285, 8.549574, 6.21, 0.019, 334.11058499999996, 57.220238, 5.88, 0.95,
  334.110675, -41.627225, 5.11, 0.93, 334.12353, 27.80403, 6.38, 0.982, 334.140225, -1.596389, 6.16, 0.194,
  334.15609500000005, -25.898162, 6.14, 1.11, 334.20018, -12.831436, 5.34, 1.132, 334.20847499999996, -7.78329, 4.17, 0.979,
  334.21902, -9.040067, 5.8, 1.158, 334.24930500000005, -23.140247, 6.17, 1.051, 334.277085, -5.387164, 5.75, 0.878,
  334.368, 49.126957, 6.46, 1.046, 334.46113499999996, -77.511553, 5.49, 0.312, 334.51780499999995, -0.237656, 6.39, 0.441,
  334.55257500000005, 62.804388, 5.75, 1.256, 334.564335, -53.627073, 5.36, 0.614, 334.625565, -60.259587, 2.87, 1.39,
  334.734165, 37.769286, 6.19, 0.27, 334.75308, -13.304995, 5.96, 1.075, 335.00631, -80.439747, 5.09, 1.276,
  335.049645, -7.821102, 5.35, -0.048, 335.11490999999995, 5.789498, 5.37, -0.037, 335.15109, -57.509783, 6.41, 1.404,
  335.161545, 58.409904, 6.46, 0.99, 335.164665, 50.980814, 6.4, 1.195, 335.232495, 8.186742, 6.18, 0.451,
  335.25024, 26.935162, 6.46, 1.526, 335.25642, 46.536569, 4.55, -0.1, 335.33058, 28.330529, 4.78, -0.01,
  335.37948, 12.205186, 4.82, -0.132, 335.39820000000003, -21.59823, 5.12, 1.057, 335.41407000000004, -1.387331, 3.86, -0.057,
  335.46195, 42.078156, 6.38, -0.086, 335.68416, -45.947944, 6.42, 2.231, 335.70951, 36.659047, 6.45, 1.052,
  335.750745, 57.284612, 6.18, -0.112, 335.75212500000004, 62.419357, 6.04, 0.035, 335.779245, 55.96323, 6.44, 2.215,
  335.783025, -45.928488, 5.62, 0.372, 335.878515, -24.762661, 5.53, 0.979, 335.88396, -7.194421, 5.92, 0.998,
  335.890125, 52.229046, 4.42, 1.015, 335.9148, 20.84823, 6.2, 0.518, 335.97588, 38.573612, 6.18, 0.485,
  336.02868, -4.83702, 5.79, -0.033, 336.112755, -13.529369, 5.76, 0.97, 336.12913499999996, 49.476392, 4.55, 0.092,
  336.14646, -72.255412, 5.28, 0.66, 336.23457, -57.797415, 5.31, 0.665, 336.293595, -70.431622, 5.78, 0.396,
  336.31926, 1.377401, 4.8, -0.171, 336.41958, 18.444316, 6.26, 1.201, 336.46274999999997, -75.015689, 6.12, 0.599,
  336.50331, 70.770898, 5.47, 1.216, 336.54458999999997, -23.682447, 6.29, -0.021, 336.642795, -16.742138, 5.55, 0.618,
  336.65577, 4.393766, 5.76, 0.519, 336.67683, 78.785853, 5.83, 0.171, 336.68982, 37.443706, 6.46, -0.132,
  336.77212499999996, 65.13227, 5.52, 0.302, 336.832965, -64.966354, 4.51, -0.029, 336.860415, 39.810026, 6.16, -0.136,
  336.942705, 31.840045, 6, 1.442, 336.96468, 4.695664, 4.78, 1.039, 337.04636999999997, 27.018806, 6.48, 0.986,
  337.08117, 64.085155, 6.3, 1.113, 337.15636500000005, -67.489059, 5.56, 0.208, 337.163355, -39.131792, 5.47, 0.959,
  337.207965, -0.019972, 3.65, 0.406, 337.28326500000003, 9.129034, 5.6, 1.578, 337.2885, 58.4041, 6.31, -0.033,
  337.29260999999997, 26.763198, 5.79, 1.252, 337.292745, 58.415198, 4.07, 0.778, 337.317375, -43.495565, 3.97, 1.022,
  337.38259500000004, 47.706887, 4.34, 1.679, 337.439325, -43.749224, 4.12, 1.57, 337.44171, -27.107284, 5.95, 0.362,
  337.470705, 78.824285, 5.45, 0.093, 337.491405, 4.43169, 5.51, 0.385, 337.506165, -12.915116, 6.41, 0.356,
  337.507545, 32.572638, 5.64, -0.031, 337.52713500000004, 49.356412, 6.41, 1.166, 337.572285, -14.585734, 6.36, -0.047,
  337.62192, 43.123376, 4.52, -0.086, 337.66173, -10.67795, 4.82, -0.053, 337.72404, -26.073752, 6.43, 1.083,
  337.822725, 50.282491, 3.76, 0.031, 337.826295, -6.555151, 6.15, 0.565, 337.82674499999996, -2.911276, 6.15, 1.083,
  337.87635, -32.346073, 4.29, 0.011, 337.89313500000003, 29.542758, 6.33, 0.209, 337.90752, -85.967253, 5.76, 1.02,
  337.92216, -10.905561, 6.39, 0.29, 338.067765, 76.226441, 5.7, 0.02, 338.077935, 54.037032, 6.41, 1.043,
  338.1099, 39.779733, 5.88, 0.166, 338.147805, 20.230019, 6.43, 0.35, 338.195445, 15.863263, 6.35, 1.19,
  338.25015, -61.982122, 4.91, 1.612, 338.26155, 69.913545, 6.01, 0.334, 338.31993, 70.373714, 6.26, 0.018,
  338.419215, 56.624737, 5.72, 0.966, 338.51214, -1.57427, 5.88, 0.977, 338.67345, -20.708216, 5.21, 0.446,
  338.83908, -0.117498, 4.04, -0.083, 338.859975, -78.771585, 6.15, 1.368, 338.90155500000003, -23.991094, 5.97, 0.984,
  338.94115500000004, 73.643188, 5.08, 0.395, 338.95335, -17.460424, 6.39, 1.42, 338.96661, 56.070574, 6.37, 0.107,
  338.96785500000004, 39.634331, 5.73, -0.16, 338.97035999999997, -57.883752, 6.22, 0.212, 338.972415, 50.070788, 6.29, -0.071,
  339.032925, 35.577504, 6.11, 0.997, 339.122085, -40.582689, 6.28, 0.119, 339.14769, -31.663789, 5.82, 1.074,
  339.15138, 11.696636, 6.42, 0.027, 339.202845, 35.652419, 6.28, 1.392, 339.24519, -40.591034, 5.85, 0.06,
  339.270195, 12.576816, 6.3, 1.431, 339.303705, 75.371811, 5.8, 1.594, 339.343485, 51.545123, 4.64, 0.254,
  339.439095, -4.228056, 5.04, 1.14, 339.572505, 45.182935, 6.38, 0.771, 339.59226, -7.897563, 6.23, 0.783,
  339.6579, 56.795632, 5.11, 1.537, 339.66273, 63.584472, 5.19, 0.083, 339.686145, -28.748214, 6.46, 1.034,
  339.714435, -33.081347, 5.66, 0.037, 339.71913, 19.522263, 5.84, 0.922, 339.815325, 39.050269, 4.89, -0.207,
  339.89304, 37.592817, 6.03, 0.854, 339.93406500000003, -28.325661, 6.3, 1.006, 339.94588500000003, 19.681125, 6.33, 0.035,
  340.076685, 53.845927, 5.94, 0.946, 340.09299, -30.658871, 5.88, 1.297, 340.128495, 44.276305, 4.5, 1.318,
  340.16391, -27.043617, 4.18, -0.105, 340.199805, -3.554239, 6.32, 0.52, 340.203705, -57.422322, 5.98, 1.45,
  340.21948499999996, 14.549161, 5.72, 0.723, 340.365495, 10.831364, 3.41, -0.086, 340.36938000000004, 40.225449, 5.25, -0.137,
  340.38043500000003, 30.965861, 6.36, 1.579, 340.4001, 41.549123, 5.93, 0.998, 340.439205, 29.307641, 4.8, -0.013,
  340.489395, 14.516393, 5.92, 1.114, 340.52511, -5.101968, 6.28, 1.569, 340.586715, 53.908748, 6.14, 1.634,
  340.592025, -29.361046, 6.12, 1.522, 340.653675, -47.210813, 5.99, 0.584, 340.666725, -46.884577, 2.07, 1.61,
  340.67947499999997, -44.248036, 6.06, 0.956, 340.73103000000003, 37.802735, 6.43, -0.119, 340.75056, 30.221245, 2.93, 0.852,
  340.76422499999995, -8.311441, 6.45, 0.166, 340.76799, 47.168755, 6.39, 0.45, 340.809435, -6.962937, 6.4, -0.039,
  340.87489500000004, -41.414347, 4.84, 1.027, 340.89681, -18.830375, 4.68, 1.358, 341.02173, 39.465348, 5.93, 1.49,
  341.02284000000003, 41.819235, 5.11, 0.96, 341.06865, -60.499618, 6.29, 0.568, 341.20466999999996, 52.517208, 6.43, 1.541,
  341.22073500000005, 39.201027, 6.47, 1.498, 341.26527, 58.14705, 6.45, 0.43, 341.36740499999996, 19.366561, 6.27, 1.057,
  341.393715, 30.442557, 6.37, 0.933, 341.407785, -53.500121, 4.84, 1.18, 341.419965, -46.547328, 5.52, 1.302,
  341.51538, -81.381615, 4.13, 0.208, 341.542455, 44.546054, 5.84, 0.358, 341.61777, -49.68579, 6.49, 1.162,
  341.632815, 23.565654, 3.97, 1.07, 341.67324, 12.172888, 4.2, 0.502, 341.82987, -34.161722, 6.28, 1.145,
  341.846805, 58.483031, 6.33, 0.017, 341.87067, 83.15383, 4.77, 1.257, 341.888025, -19.613375, 5.24, 0.941,
  341.898705, -65.560252, 6.49, 1.208, 341.928195, -14.056428, 5.68, -0.016, 341.984145, -25.912028, 6.31, 0.913,
  342.046005, 37.416688, 5.82, 1.024, 342.088905, -61.684364, 6.36, 1.059, 342.125865, -10.555478, 6.19, 0.274,
  342.13858500000003, -51.316864, 3.49, 0.083, 342.18436499999996, 62.93841, 6.07, 1.194, 342.199545, 54.414892, 6.14, -0.083,
  342.253125, 68.570228, 6.19, 0.44, 342.32274, -70.347982, 6.35, 0.071, 342.39792, -13.592632, 4.05, 1.57,
  342.4203, 66.200408, 3.5, 1.053, 342.442815, 55.902777, 5.43, 1.167, 342.49676999999997, -32.805457, 6.34, 0.317,
  342.500775, 24.601579, 3.51, 0.933, 342.542055, 50.676917, 6.23, 1.129, 342.590715, 41.953394, 5.91, 0.062,
  342.594825, -80.123845, 5.32, -0.126, 342.758985, -39.156834, 5.43, 1.444, 342.76227, 85.373739, 5.89, 1.34,
  342.83725499999997, -29.536309, 5.99, 0.907, 342.84402, 61.69674, 5.61, 0.775, 342.93739500000004, -59.881358, 6.47, 1.132,
  343.008375, 43.312417, 4.95, 1.559, 343.041645, -63.188667, 6.14, 1.025, 343.100295, 9.835664, 5.16, 0.487,
  343.131405, -32.875504, 4.46, -0.037, 343.15364999999997, -7.579599, 3.73, 1.626, 343.217685, 50.412285, 6.46, -0.047,
  343.259445, 16.841194, 5.86, 1.132, 343.265745, 60.101029, 6.01, 1.748, 343.29739500000005, 40.167361, 6.33, -0.074,
  343.36960500000004, -11.616514, 5.8, -0.082, 343.40778, -48.598286, 6.03, 0.621, 343.41731999999996, 44.749163, 5.79, 0.282,
  343.52352, -19.175149, 6.37, 1.515, 343.52902500000005, 40.376907, 5.82, 1.136, 343.601835, 84.346177, 4.7, 1.418,
  343.64217, -7.204626, 6.2, 1.284, 343.64844, 16.941834, 6.39, 1.729, 343.662555, -15.82082, 3.27, 0.066,
  343.664715, -70.073709, 6.04, 0.66, 343.68948, -16.271957, 5.53, 1.111, 343.74786, 1.064904, 6.11, 0.192,
  343.760985, 37.076827, 5.91, 0.397, 343.795665, -4.987899, 5.72, 0.881, 343.80696, 8.816166, 4.91, -0.003,
  343.81207500000005, -36.388579, 6.4, 1.313, 343.877475, -20.139404, 6.36, 1.429, 343.935435, 36.35139, 5.73, -0.051,
  343.96473000000003, -31.633231, 6.09, 1.358, 343.98708, -32.539628, 4.2, 0.952, 344.098455, 41.603876, 5.6, -0.149,
  344.100075, -31.565567, 6.48, 1.094, 344.108325, 49.733544, 4.99, 1.778, 344.199195, -47.969221, 5.72, 0.226,
  344.26875, 48.684068, 5.34, -0.102, 344.321655, -4.810095, 6.31, 0.948, 344.36655, 20.768832, 5.45, 0.666,
  344.38668, 3.810241, 6.28, 1.122, 344.41256999999996, -29.622236, 1.17, 0.145, 344.41974, 39.308777, 6.17, -0.148,
  344.56476000000004, -2.395385, 6.17, 0.744, 344.598585, -1.410209, 6.38, 0.366, 344.646165, 9.356859, 6.43, 0.64,
  344.645865, -35.523231, 6.15, 0.582, 344.677605, 7.340074, 6.35, 0.052, 344.78751, 59.814655, 6.46, 0.012,
  344.793135, 52.65453, 6.31, 1.414, 344.799225, 11.728844, 5.76, 0.293, 344.86440000000005, 0.962927, 5.43, 0.982,
  344.898645, -13.070895, 6.12, 1.459, 344.89898999999997, -29.462311, 5.51, 0.271, 345.021255, 56.945374, 5.1, 1.011,
  345.024105, -25.16418, 5.66, 1.253, 345.102645, -25.626846, 6.3, 1.124, 345.15794999999997, 0.185866, 6.22, 0.892,
  345.178755, 3.011805, 5.85, 1.343, 345.220155, -52.754137, 4.11, 0.96, 345.281445, -50.950028, 5.68, 1.411,
  345.33075, -28.85396, 5.55, 1.349, 345.34601999999995, -22.790891, 6.27, 0.126, 345.34851, -7.061153, 6.23, 1.418,
  345.377985, 57.105458, 6.24, 1.499, 345.382125, -4.711461, 5.94, 0.992, 345.43158, 3.53091, 6.44, 0.97,
  345.480255, 42.325979, 3.62, -0.099, 345.54717, 44.572858, 6.43, 0.959, 345.635655, -6.574008, 6.18, 1.59,
  345.64206, -36.42088, 6.46, 0.938, 345.65154, 42.757795, 5.09, 0.094, 345.68439, -20.870712, 5.97, 0.946,
  345.68812499999996, 44.05875, 6.37, -0.02, 345.838995, 58.563854, 6.43, 0.898, 345.8742, -34.749412, 5.12, 0.305,
  345.88692000000003, 67.20921, 5.25, 1.248, 345.943515, 28.082789, 2.44, 1.655, 345.969225, 3.820045, 4.48, -0.115,
  345.99849, -41.478896, 5.79, 1.069, 346.003245, 6.616338, 6.42, 0.417, 346.04553, 50.052091, 4.64, 1.058,
  346.16501999999997, -53.964905, 5.37, 1.453, 346.19022, 15.205264, 2.49, -0.002, 346.2174, -68.820226, 5.53, 0.395,
  346.2762, 16.562837, 6.43, 0.886, 346.29078, -7.693801, 5.44, 0.312, 346.30356, -17.07925, 6.15, 1.37,
  346.323465, 1.307127, 6.39, 0.928, 346.575555, 18.517765, 6.16, 0.482, 346.63281, 19.910853, 6.44, 0.544,
  346.65339, 59.41976, 4.84, -0.06, 346.670175, -23.743115, 4.48, 0.892, 346.71975000000003, -43.520358, 4.28, 0.423,
  346.72341, -38.892293, 5.62, 0.006, 346.751085, 9.409492, 4.54, 1.559, 346.77092999999996, 35.636491, 6.38, 1.158,
  346.778085, 25.468259, 4.76, 1.285, 346.78932000000003, -49.606135, 6.33, 1.452, 346.791885, 52.816601, 6.12, 1.06,
  346.79353499999996, 59.727394, 6.41, -0.03, 346.81161000000003, -50.686681, 5.81, 0.486, 346.86552, 32.825345, 6.13, 0.137,
  346.86963000000003, 21.134251, 5.97, 0.259, 346.913625, 46.387231, 5.3, 1.409, 346.9389, 49.295776, 5.68, 0.449,
  346.94892, 63.633466, 6.25, -0.025, 346.974345, 75.387496, 4.41, 0.802, 346.98834, 64.222532, 6.21, 1.084,
  347.08779, -28.823697, 5.6, 0.882, 347.09832, -79.480689, 6.11, 0.145, 347.14817999999997, -73.586116, 6.18, 1.419,
  347.1705, 2.127883, 5.42, 0.908, 347.361645, -21.17241, 3.68, 1.202, 347.38107, 8.677161, 5.05, 1.484,
  347.433915, 59.332692, 5.68, 0.315, 347.435955, -28.088572, 5.88, 1.311, 347.43639, -67.876284, 6.47, 0.394,
  347.45646, -14.510552, 6.43, 0.01, 347.478735, -22.457611, 4.71, 0.674, 347.489325, -42.861292, 5.83, 0.475,
  347.50608, 9.822082, 5.39, -0.068, 347.54055, -40.591547, 5.9, 1.565, 347.55051000000003, -66.857644, 6.47, 0.956,
  347.5896, -45.246711, 3.88, 0.998, 347.613525, 43.544232, 5.91, 0.45, 347.67764999999997, 17.594372, 5.68, 1.33,
  347.93412, 8.720116, 5.15, 0.139, 347.955015, 26.847308, 6.19, 0.937, 348.051855, -80.9127, 6.43, 1.498,
  348.1374, 49.406207, 4.53, 0.302, 348.266625, 29.441525, 6.34, 0.924, 348.31647000000004, 57.168355, 5.57, 1,
  348.36043500000005, 11.065001, 5.85, 1.004, 348.497325, 19.633898, 6.47, 1.151, 348.52608, -62.700004, 6.12, 0.787,
  348.559875, 50.617891, 6.32, -0.005, 348.58066499999995, -6.049003, 4.22, 1.545, 348.59049, 29.771831, 6.41, 0.448,
  348.65202, 24.102898, 6.36, 1.167, 348.65432999999996, 74.231268, 5.89, -0.01, 348.66738000000004, -10.688715, 6.13, 1.504,
  348.744165, -41.105397, 5.77, 1.16, 348.89274, -3.49638, 5.56, 0.062, 348.90715500000005, 70.88808, 5.55, 0.263,
  348.972885, -9.087737, 4.24, 1.107, 349.165785, -44.489166, 5.92, 1.053, 349.17607499999997, 53.213476, 5.58, 0.556,
  349.20765, -41.194395, 6.49, 1.07, 349.21225499999997, -7.726504, 4.93, 1.613, 349.23988499999996, -62.001198, 5.64, 0.521,
  349.286475, -28.438273, 6.24, 1.556, 349.29141, 3.282289, 3.7, 0.916, 349.31937, 45.164167, 6.44, 1.077,
  349.32861, 75.299025, 6.35, 0.049, 349.35747, -58.235734, 3.99, 0.41, 349.417005, -11.712942, 6.33, 0.058,
  349.43598000000003, 49.0153, 4.82, 1.668, 349.47589500000004, -9.182513, 4.41, -0.144, 349.48335, 45.488924, 6.48, -0.037,
  349.541085, -40.824361, 5.54, 0.445, 349.583355, -67.471177, 6.15, 1.356, 349.59718499999997, 41.773676, 5.98, 0.215,
  349.656, 68.111445, 4.75, 0.836, 349.705995, -32.532027, 4.41, 1.109, 349.740315, -9.61075, 4.99, -0.022,
  349.76373, -28.387846, 6.49, 1.535, 349.77777000000003, -13.458552, 5.2, 0.787, 349.78567499999997, -79.472409, 6.34, 0.913,
  349.849905, -5.124352, 5.56, 0.386, 349.85044500000004, -18.075376, 5.96, 1.534, 349.864215, 34.793183, 6.32, -0.053,
  349.874175, 48.625322, 5.44, 1.014, 349.922895, 48.380935, 6.29, 1.123, 349.92976500000003, -33.708052, 6.35, 1.308,
  349.968375, 42.078044, 5.81, 1.512, 350.05989, 61.970129, 6.39, 1.678, 350.08576500000004, 5.381307, 5.05, 1.204,
  350.143905, 62.213264, 6.41, 1.605, 350.15934, 23.740337, 4.58, 0.18, 350.170365, -5.907975, 6.17, 1.089,
  350.18374500000004, 44.116167, 6.25, 0.152, 350.206455, 30.414921, 5.58, 1.501, 350.209005, -50.306559, 6.04, 0.423,
  350.22184500000003, 38.182326, 5.77, 0.468, 350.314575, -26.986769, 5.65, 0.817, 350.478885, 31.812465, 5.35, -0.101,
  350.619075, 25.918483, 6.38, 1.54, 350.63553, 60.133485, 5.56, 1.679, 350.663205, -15.039338, 5.19, 0.203,
  350.6688, 20.828716, 6.28, -0.033, 350.73636, -60.055843, 6.08, 1.603, 350.74263, -20.10058, 3.96, 1.082,
  350.76903000000004, 12.31391, 5.09, 1.315, 350.883105, 0.291325, 6.33, 1.583, 350.93925, -43.124429, 6.12, 1.464,
  350.97705, -53.80874, 6.13, 0.258, 351.01658999999995, -21.774411, 6.46, 0.433, 351.03273, -18.688006, 6.18, 1.02,
  351.03695999999997, 41.612874, 6.37, 1.702, 351.055215, -51.891174, 5.75, 1.611, 351.209385, 62.282806, 4.96, 1.676,
  351.2118, 32.384882, 5.56, -0.075, 351.33093, -56.848985, 5.6, 1.063, 351.344895, 23.404101, 4.42, 0.617,
  351.51162, -20.642014, 4.38, 1.46, 351.647805, -21.740836, 6.43, 1.036, 351.65235, -52.721603, 5.53, 0.409,
  351.73314, 1.255608, 4.95, 0.036, 351.74985, 87.307504, 5.56, 0.25, 351.78075, 42.91201, 5.75, -0.007,
  351.78105, -66.580886, 6.47, 1.455, 351.787905, -50.157244, 6.22, -0.08, 351.81163499999997, 1.122609, 6.26, 1.013,
  351.81235499999997, -58.47611, 5.63, 0.983, 351.8187, 70.359782, 5.6, 0.163, 351.91827, 25.167281, 5.99, -0.066,
  351.99207, 6.378992, 4.27, 1.062, 352.00287, -35.544485, 6.34, 1.201, 352.01489999999995, -87.482214, 5.5, 1.278,
  352.02163499999995, -11.449752, 6.37, 0.902, 352.25277, -9.266104, 6.2, 1.438, 352.2534, -44.498068, 6.43, 1.177,
  352.25397, -63.110656, 5.66, -0.142, 352.273665, 23.048083, 6.45, 1.088, 352.288725, 12.760554, 4.54, 0.939,
  352.36244999999997, -1.791213, 6.35, 1.125, 352.383675, -4.532747, 6.26, 1.123, 352.50804, 58.54892, 4.89, -0.122,
  352.53085500000003, 49.133145, 6.19, 1.464, 352.66482, 38.662253, 6.07, 0.992, 352.75476000000003, -6.288082, 6.39, 1.259,
  352.82235000000003, 39.236198, 5.22, 1.029, 352.86228, -44.843579, 6.02, 1.014, 352.881255, -4.087406, 6.5, 0.531,
  352.925175, -21.369457, 6.24, 0.319, 352.9293, 28.403489, 6.41, 0.035, 352.98985500000003, -1.085885, 6.39, 1.177,
  353.120955, 23.843609, 6.41, 1.492, 353.24268, -37.818268, 4.38, -0.095, 353.31927, -20.914504, 4.7, 0.02,
  353.33148, -77.385327, 5.82, 0.681, 353.36706000000004, 22.498775, 5.33, 1.481, 353.42913, 45.0581, 6.25, 0.986,
  353.48121000000003, 20.840934, 6.1, 1.654, 353.48826, 31.325277, 4.97, 1.383, 353.53756500000003, -1.247567, 5.91, 0.299,
  353.656425, 40.236441, 5.55, 0.096, 353.65918500000004, 33.497328, 5.63, 1.042, 353.69475, 38.024, 6.18, 1.586,
  353.70567, -15.246005, 5.95, 1.35, 353.74597500000004, 71.642043, 5.86, 1.681, 353.768985, -42.615075, 4.69, 0.078,
  353.86908, 1.313142, 6.47, 1.151, 353.88363, -7.464431, 6.4, 0.874, 353.983095, 24.561012, 6.44, 1.703,
  354.09702, 2.102222, 5.68, 0.449, 354.12714, 32.904215, 6.35, 0.459, 354.383505, 44.428994, 5.81, -0.064,
  354.39083999999997, 46.458152, 3.81, 0.984, 354.414825, -13.060243, 5.66, 1.025, 354.415575, 16.825495, 6.26, 0.025,
  354.462405, -45.492351, 4.74, 0.082, 354.486675, 18.400667, 5.49, 0.01, 354.51262499999996, -15.095108, 6.38, 1.078,
  354.53415, 43.268073, 4.29, -0.083, 354.59889, -76.869552, 5.99, 0.907, 354.78474, 50.471733, 5.35, -0.061,
  354.792345, 75.292882, 5.95, 0.124, 354.83729999999997, 77.632276, 3.21, 1.031, 354.83817, 74.002628, 5.98, 0.889,
  354.866415, -46.637799, 6.07, 0.24, 354.94611000000003, -14.222178, 4.97, 0.257, 354.979335, 9.677294, 5.99, 0.212,
  354.98766, 5.626292, 4.13, 0.507, 355.01175, 37.652644, 6.49, 0.355, 355.102035, 44.333932, 4.15, -0.071,
  355.15899, -32.073125, 5.3, 0.965, 355.169175, 36.720768, 6.24, 0.424, 355.287135, -11.680655, 5.89, 0.984,
  355.361625, 49.512413, 6.26, 0.182, 355.39371, -18.027077, 5.36, 1.58, 355.440855, -17.816533, 4.82, 0.822,
  355.477335, 57.259954, 6.24, 1.025, 355.486215, 7.250546, 5.89, 0.101, 355.511685, 1.780041, 4.49, 0.2,
  355.561125, 44.991715, 6.43, 1.5, 355.61593500000004, -15.448033, 5.27, 1.344, 355.63095, 61.679363, 6.4, 1.25,
  355.680585, -14.544905, 4.49, -0.032, 355.682745, 16.335719, 6.3, 0.97, 355.77101999999996, 51.939335, 6.44, 1.034,
  355.84317000000004, 10.331536, 5.09, 1.692, 355.997835, 29.361454, 4.93, 0.935, 356.00517, -45.083123, 6.08, 0.978,
  356.05014, -64.404451, 5.73, 1.393, 356.05032, -18.276938, 5.24, -0.084, 356.10477, -70.490226, 6.06, 0.91,
  356.121105, -26.246631, 6.23, 0.495, 356.169645, -78.791442, 5.74, 1.108, 356.201595, 55.799687, 6.46, 0.992,
  356.50383, -18.67834, 5.28, 0.299, 356.505165, -40.182565, 6.32, 0.21, 356.50851, 46.420276, 4.97, 1.086,
  356.59798500000005, 3.486811, 4.95, 2.508, 356.65303500000005, 66.782244, 5.95, -0.049, 356.75799, 57.451359, 5.55, 1.63,
  356.76426, 58.651989, 4.88, 1.122, 356.81631, -11.911126, 5.74, 1.068, 356.81664, -50.226461, 5.18, -0.164,
  356.88771, 46.832564, 6.08, -0.135, 356.978145, 67.806808, 5.05, 0.007, 356.98560000000003, -2.761598, 5.49, 0.941,
  357.13532999999995, -6.380426, 6.09, 1.452, 357.16267500000004, 64.87645, 6.41, 0.062, 357.205695, 2.214413, 6.47, 0.461,
  357.209055, 62.214516, 5.43, 0.67, 357.22474500000004, 59.97897, 6.33, -0.007, 357.231405, -28.130268, 4.59, 0.001,
  357.29961, 58.963202, 6.36, 0.408, 357.364485, 1.076131, 5.77, 0.167, 357.381705, -15.861277, 6.21, 1.212,
  357.41412, 28.842389, 5.95, 0.187, 357.42066, 36.425281, 5.86, 0.806, 357.456645, -25.331336, 6.44, 0.097,
  357.561375, -9.974136, 5.93, 1.133, 357.59245500000003, 51.621663, 6.47, 0.403, 357.638685, -14.40149, 5.7, 1.488,
  357.64848, -47.376942, 6.49, 1.025, 357.83853, 9.313351, 5.77, 1.661, 357.838905, -18.909163, 5.17, -0.122,
  357.99099, 2.930384, 5.59, 1.527, 358.02777000000003, -82.018818, 5.1, 0.934, 358.09747500000003, 21.671099, 6.13, 1.616,
  358.10299499999996, 75.544588, 6.36, 0.977, 358.12203, 19.120287, 5.06, 1.587, 358.12497, -14.251217, 5.85, 1.252,
  358.15461, 10.94732, 5.3, 0.186, 358.21053, -8.996756, 5.76, 1.171, 358.231515, -3.155482, 5.93, 1.069,
  358.26982499999997, 2.090625, 6.29, -0.003, 358.33684500000004, -24.229257, 6.23, 0.188, 358.58919000000003, -27.042907, 6.34, 0.197,
  358.59596999999997, 57.499382, 4.51, 1.19, 358.66065000000003, -40.300062, 6.03, 0.572, 358.694265, 0.109309, 5.78, 1.466,
  358.782465, 7.070972, 6.22, -0.066, 358.81911, -31.921467, 6.09, -0.093, 358.88948999999997, 47.355804, 6.01, 1.17,
  358.891005, 57.412168, 6.03, 0.155, 358.977825, 15.230291, 6.45, 1.56, 359.12478000000004, -24.737218, 6.31, 0.921,
  359.17293, 22.648091, 6.18, 1.635, 359.265135, 42.658232, 6.01, 0.712, 359.283975, -26.623446, 6.26, 1.452,
  359.28534, 55.705705, 5.57, 0.478, 359.29215, -20.833643, 6.45, 0.979, 359.33261999999996, -62.956584, 5.95, 0.101,
  359.387385, -82.169804, 5.72, 1.055, 359.389695, 60.0236, 6.47, 0.029, 359.395905, -64.298231, 5, 0.06,
  359.439705, 25.141401, 4.63, 1.584, 359.58843, -15.847484, 6.28, 1.079, 359.66824499999996, -3.555983, 4.88, 0.93,
  359.732325, -52.745807, 5.13, 1.121, 359.75223, 55.754928, 4.88, -0.071, 359.827875, 6.863321, 4.03, 0.419,
  359.86623, -29.485168, 5.59, 1.599, 359.87208000000004, 33.723878, 5.81, 0.539, 359.97891, -65.577132, 4.49, -0.075,
  8.184660000000001, -63.03121, 6, -9, 8.80989, -3.593069, 6.4, -9, 9.335685, -24.766593, 6.4, -9,
  24.945045, -56.19462, 5.8, 0.86, 39.891945, -11.871068, 5.6, -9, 40.822755, 3.237385, 6.3, -9,
  76.863405, 18.647141, 5.7, -9, 79.16889, 46.000842, 0.96, -9, 86.10885, -22.420198, 6.13, 0.94,
  113.652405, 31.89052, 2.85, -9, 117.94122, -13.896051, 6.17, 0.65, 131.1741, -54.708074, 5, -9,
  135.163305, 41.78362, 6.18, 0.65, 139.3272, -68.689446, 6.13, -9, 142.67646, -40.465622, 4.65, -9,
  146.049045, -27.769033, 5.6, -9, 169.54676999999998, 31.528783, 4.33, 0.59, 169.54676999999998, 31.528783, 4.8, -9,
  190.412565, -1.449235, 3.52, -9, 195.940125, -20.583353, 6.4, -9, 197.495835, 17.528977, 5.17, -9,
  200.98494, 54.920471, 3.95, 0.13, 225.948675, 47.653692, 5.96, -9, 230.79945, 30.2862, 5.96, -9,
  241.09160999999997, -11.374611, 4.84, 0.45, 241.09160999999997, -11.374611, 5, -9, 250.32235500000002, 31.601207, 5.4, -9,
  256.33071, 54.469093, 5.63, 0.47, 257.591745, -15.726921, 3.4, -9, 258.83601, -26.603215, 5.07, 0.85,
  262.59765, -1.064706, 6.2, -9, 270.76803, -8.181708, 5.24, 0.38, 271.36485000000005, 2.498264, 6, 1.15,
  286.60270499999996, -37.06474, 5, -9, 316.10274000000004, -19.855641, 6.5, -9, 317.33905500000003, -73.175927, 6.4, -9,
  318.620865, 10.006094, 5.4, -9, 318.69831, 38.045192, 6.42, 0.6, 326.032635, 28.743078, 6.09, -9,
  336.121815, -72.256978, 6.1, -9, 336.64458, -16.742424, 6.21, 0.62, 347.479575, -22.457364, 5.9, -9,
  78.38874990000001, -8.14777778, 6.37, -9, 95.90708325, -52.18111111, 5.98, -9, 97.7920833, 17.46638888, 6.2, -9,
  115.02916665, 16.93861111, 6.02, -9, 161.265, -59.68416667, 6.21, -9, 214.01749995, 18.91194444, 5.98, -9,
  253.54916655, -41.85027778, 6.45, -9, 268.43958330000004, -34.78611111, 6.38, -9,
]);

export const starHip = new Int32Array([
  -1, 25, 34, 43, 50, 63, 88, 106, 107, 122, 124, 128, 137, 145, 154, 171,
  183, 186, 194, 207, 238, 253, 274, 301, 302, 330, 343, 345, 355, 365, 377, 379,
  394, 399, 410, 417, 418, 443, 476, 518, 522, 531, 544, 560, 602, 635, 636, 655,
  664, 671, 677, 695, 696, 699, 716, 728, 729, 730, 746, 760, 761, 765, 798, 813,
  814, 840, 841, 873, 910, 930, 950, 967, 983, 1009, 1067, 1074, 1076, 1086, 1096, 1099,
  1123, 1158, 1168, 1170, 1191, 1193, 1195, 1196, 1208, 1215, 1269, 1268, 1288, 1296, 1302, 1319,
  1331, 1354, 1366, 1372, 1402, 1415, 1421, 1465, 1473, 1493, 1499, 1501, 1502, 1562, 1575, 1599,
  1630, 1639, 1645, 1647, 1657, 1686, 1706, 1708, 1728, 1772, 1803, 1821, 1921, 1939, 1948, 1960,
  1982, 2006, 2021, 2072, 2081, 2086, 2100, 2159, 2178, 2210, 2213, 2219, 2224, 2225, 2235, 2237,
  2240, 2256, 2270, 2337, 2353, 2355, 2377, 2381, 2383, 2388, 2422, 2472, 2474, 2475, 2484, 2487,
  2497, 2505, 2548, 2568, 2578, 2583, 2599, 2611, 2628, 2629, 2661, 2663, 2707, 2711, 2734, 2762,
  2787, 2789, 2802, 2832, 2846, 2852, 2854, 2876, 2889, 2900, 2903, 2912, 2920, 2926, 2937, 2941,
  2942, 2954, 3031, 3056, 3083, 3092, 3093, 3132, 3137, 3138, 3170, 3175, 3179, 3185, 3193, 3231,
  3245, 3269, 3277, 3299, 3300, 3330, 3334, 3352, 3356, 3405, 3414, 3419, 3436, 3455, 3456, 3478,
  3489, 3504, 3505, 3521, 3527, 3544, 3552, 3559, 3572, 3576, 3583, 3604, 3607, 3632, 3641, 3649,
  3675, 3685, 3693, 3697, 3717, 3721, 3741, 3750, 3760, 3765, 3781, 3786, 3801, 3807, 3810, 3821,
  3834, 3849, 3858, 3881, 3885, 3903, 3909, 3919, 3949, 3951, 3965, 3988, 3992, 4023, 4104, 4147,
  4151, 4164, 4185, 4200, 4212, 4257, 4267, 4283, 4288, 4292, 4293, 4298, 4317, 4346, 4363, 4366,
  4371, 4382, 4383, 4422, 4427, 4436, 4440, 4446, 4463, 4475, 4501, 4510, 4520, 4552, 4558, 4563,
  4572, 4577, 4587, 4655, 4675, 4709, 4770, 4786, 4801, 4829, 4844, 4852, 4879, 4889, 4890, 4903,
  4906, 4911, 4914, 4932, 4962, 4979, 4998, 5021, 5034, 5042, 5074, 5081, 5121, 5131, 5132, 5141,
  5165, 5164, 5170, 5175, 5204, 5240, 5251, 5259, 5268, 5296, 5300, 5310, 5315, 5317, 5319, 5336,
  5346, 5348, 5361, 5364, 5372, 5412, 5434, 5447, 5454, 5477, 5483, 5485, 5493, 5494, 5510, 5518,
  5542, 5544, 5550, 5566, 5571, 5575, 5586, 5589, 5594, 5626, 5650, 5661, 5679, 5688, 5737, 5742,
  5743, 5772, 5778, 5799, 5824, 5833, 5862, 5896, 5926, 5928, 5936, 5947, 5951, 5992, 5993, 6025,
  6061, 6087, 6093, 6140, 6193, 6226, 6242, 6261, 6272, 6283, 6312, 6315, 6378, 6411, 6427, 6429,
  6432, 6486, 6492, 6502, 6512, 6514, 6522, 6537, 6539, 6564, 6589, 6592, 6595, 6605, 6631, 6669,
  6670, 6685, 6686, 6687, 6692, 6702, 6706, 6711, 6714, 6717, 6732, 6748, 6776, 6789, 6794, 6813,
  6822, 6867, 6868, 6952, 6960, 6971, 6981, 6999, 7007, 7016, 7050, 7078, 7083, 7097, 7115, 7118,
  7147, 7189, 7213, 7243, 7251, 7271, 7276, 7283, 7294, 7321, 7345, 7359, 7361, 7362, 7363, 7387,
  7436, 7443, 7444, 7447, 7450, 7463, 7493, 7505, 7506, 7513, 7535, 7568, 7580, 7588, 7593, 7597,
  7601, 7607, 7617, 7643, 7650, 7651, 7679, 7719, 7740, 7751, 7786, 7818, 7819, 7825, 7874, 7879,
  7884, 7886, 7906, 7916, 7918, 7921, 7941, 7943, 7955, 7963, 7965, 7978, 7981, 7999, 8016, 8020,
  8044, 8046, 8068, 8086, 8094, 8102, 8115, 8127, 8143, 8148, 8159, 8198, 8209, 8230, 8233, 8240,
  8241, 8320, 8362, 8366, 8369, 8370, 8387, 8404, 8423, 8433, 8475, 8480, 8497, 8514, 8544, 8552,
  8588, 8593, 8598, 8641, 8645, 8664, 8688, 8704, 8714, 8771, 8778, 8796, 8814, 8820, 8832, 8833,
  8837, 8847, 8882, 8886, 8903, 8922, 8928, 8930, 8957, 8983, 8991, 8993, 8998, 9001, 9007, 9009,
  9021, 9022, 9061, 9085, 9094, 9095, 9110, 9132, 9149, 9153, 9163, 9207, 9220, 9222, 9236, 9237,
  9295, 9307, 9312, 9313, 9318, 9326, 9347, 9353, 9372, 9440, 9459, 9480, 9487, 9505, 9521, 9533,
  9562, 9564, 9568, 9570, 9572, 9573, 9586, 9589, 9598, 9621, 9622, 9627, 9631, 9640, 9655, 9677,
  9685, 9706, 9727, 9763, 9809, 9827, 9836, 9859, 9862, 9884, 9951, 9977, 9983, 9990, 9999, 10035,
  10050, 10053, 10054, 10064, 10069, 10096, 10111, 10115, 10138, 10155, 10176, 10203, 10212, 10215, 10220, 10227,
  10234, 10273, 10280, 10296, 10305, 10306, 10309, 10320, 10324, 10326, 10328, 10340, 10350, 10361, 10366, 10379,
  10396, 10403, 10418, 10438, 10440, 10446, 10513, 10535, 10540, 10559, 10562, 10602, 10623, 10633, 10642, 10644,
  10670, 10718, 10723, 10729, 10732, 10793, 10795, 10798, 10814, 10819, 10826, 10830, 10832, 10854, 10871, 10924,
  10944, 11001, 11020, 11021, 11029, 11033, 11043, 11046, 11060, 11072, 11090, 11095, 11102, 11108, 11121, 11174,
  11212, 11220, 11231, 11249, 11258, 11261, 11279, 11293, 11313, 11345, 11348, 11381, 11407, 11415, 11427, 11432,
  11465, 11474, 11477, 11479, 11484, 11486, 11524, 11548, 11569, 11578, 11603, 11644, 11651, 11670, 11671, 11678,
  11687, 11698, 11738, 11757, 11767, 11783, 11784, 11791, 11802, 11840, 11843, 11867, 11907, 11918, 11925, 12002,
  12022, 12057, 12072, 12086, 12093, 12107, 12114, 12122, 12148, 12153, 12160, 12181, 12186, 12189, 12200, 12225,
  12239, 12247, 12272, 12273, 12287, 12288, 12300, 12305, 12318, 12332, 12387, 12390, 12394, 12413, 12444, 12447,
  12484, 12486, 12489, 12530, 12562, 12584, 12608, 12611, 12623, 12640, 12647, 12653, 12686, 12690, 12692, 12706,
  12708, 12717, 12719, 12720, 12744, 12768, 12770, 12775, 12777, 12784, 12786, 12803, 12821, 12828, 12832, 12843,
  12862, 12871, 12876, 12964, 12982, 12990, 13008, 13036, 13055, 13061, 13108, 13121, 13133, 13141, 13147, 13165,
  13176, 13178, 13197, 13202, 13209, 13225, 13244, 13254, 13257, 13265, 13268, 13271, 13288, 13327, 13328, 13339,
  13347, 13363, 13367, 13387, 13402, 13421, 13424, 13429, 13448, 13462, 13473, 13479, 13490, 13518, 13531, 13654,
  13665, 13679, 13700, 13701, 13702, 13713, 13717, 13732, 13756, 13768, 13775, 13782, 13789, 13832, 13834, 13835,
  13847, 13874, 13879, 13883, 13884, 13905, 13907, 13914, 13942, 13947, 13949, 13951, 13954, 13965, 13997, 14036,
  14040, 14043, 14060, 14086, 14104, 14109, 14110, 14124, 14131, 14135, 14143, 14146, 14168, 14187, 14232, 14240,
  14264, 14293, 14315, 14318, 14328, 14354, 14355, 14365, 14376, 14382, 14392, 14417, 14439, 14456, 14502, 14514,
  14521, 14544, 14547, 14551, 14566, 14576, 14586, 14607, 14626, 14632, 14649, 14668, 14677, 14719, 14748, 14749,
  14757, 14764, 14791, 14797, 14814, 14817, 14819, 14821, 14838, 14844, 14862, 14879, 14887, 14893, 14913, 14914,
  14915, 14930, 14954, 14972, 15004, 15024, 15110, 15118, 15125, 15154, 15191, 15192, 15193, 15197, 15201, 15203,
  15204, 15209, 15219, 15230, 15241, 15244, 15282, 15305, 15309, 15323, 15330, 15334, 15338, 15353, 15357, 15371,
  15382, 15383, 15404, 15411, 15416, 15444, 15457, 15474, 15479, 15510, 15514, 15520, 15547, 15549, 15557, 15585,
  15619, 15627, 15643, 15648, 15655, 15669, 15696, 15700, 15737, 15770, 15776, 15800, 15807, 15840, 15850, 15861,
  15863, 15870, 15876, 15884, 15890, 15900, 15968, 15987, 15988, 16015, 16029, 16042, 16083, 16095, 16112, 16142,
  16147, 16156, 16168, 16177, 16181, 16210, 16226, 16228, 16244, 16245, 16252, 16263, 16266, 16281, 16285, 16290,
  16292, 16303, 16310, 16319, 16322, 16335, 16339, 16340, 16341, 16358, 16368, 16369, 16424, 16425, 16447, 16449,
  16470, 16489, 16499, 16509, 16511, 16516, 16518, 16531, 16537, 16587, 16591, 16599, 16602, 16611, 16628, 16641,
  16664, 16672, 16677, 16695, 16697, 16712, 16779, 16780, 16803, 16826, 16827, 16846, 16852, 16870, 16924, 16938,
  16974, 16989, 17007, 17026, 17027, 17056, 17057, 17058, 17086, 17103, 17120, 17136, 17167, 17181, 17203, 17214,
  17296, 17298, 17304, 17309, 17313, 17328, 17342, 17351, 17358, 17378, 17395, 17408, 17436, 17437, 17440, 17448,
  17453, 17457, 17460, 17464, 17475, 17489, 17493, 17499, 17506, 17527, 17529, 17531, 17534, 17543, 17558, 17563,
  17573, 17579, 17584, 17585, 17587, 17588, 17593, 17595, 17608, 17618, 17651, 17678, 17702, 17707, 17717, 17732,
  17734, 17738, 17759, 17771, 17772, 17776, 17798, 17797, 17805, 17832, 17846, 17847, 17851, 17854, 17858, 17874,
  17884, 17886, 17891, 17900, 17921, 17932, 17950, 17954, 17959, 18033, 18067, 18081, 18089, 18094, 18141, 18170,
  18173, 18199, 18201, 18212, 18213, 18216, 18217, 18246, 18255, 18262, 18275, 18339, 18396, 18401, 18428, 18434,
  18438, 18453, 18455, 18471, 18481, 18485, 18488, 18505, 18508, 18532, 18543, 18565, 18592, 18597, 18606, 18614,
  18647, 18658, 18673, 18717, 18723, 18724, 18735, 18744, 18769, 18772, 18788, 18805, 18859, 18907, 18926, 18957,
  18975, 18990, 18993, 19009, 19011, 19018, 19037, 19038, 19076, 19095, 19111, 19121, 19129, 19167, 19171, 19172,
  19177, 19205, 19222, 19233, 19261, 19284, 19302, 19335, 19343, 19376, 19388, 19398, 19400, 19412, 19434, 19454,
  19461, 19483, 19509, 19511, 19513, 19515, 19525, 19554, 19571, 19587, 19590, 19601, 19641, 19672, 19673, 19719,
  19720, 19721, 19725, 19730, 19736, 19740, 19746, 19747, 19777, 19780, 19799, 19805, 19810, 19811, 19812, 19823,
  19849, 19859, 19860, 19877, 19893, 19917, 19921, 19949, 19968, 19983, 19990, 19996, 20020, 20039, 20042, 20049,
  20063, 20070, 20075, 20087, 20106, 20109, 20138, 20156, 20161, 20171, 20186, 20188, 20205, 20219, 20231, 20234,
  20241, 20250, 20252, 20255, 20261, 20263, 20264, 20266, 20268, 20271, 20284, 20297, 20341, 20347, 20354, 20360,
  20376, 20380, 20384, 20400, 20417, 20430, 20455, 20456, 20465, 20467, 20484, 20493, 20498, 20507, 20522, 20533,
  20535, 20542, 20552, 20558, 20579, 20591, 20614, 20619, 20630, 20635, 20641, 20648, 20661, 20698, 20704, 20711,
  20713, 20715, 20732, 20765, 20771, 20772, 20776, 20781, 20789, 20804, 20825, 20842, 20848, 20856, 20860, 20873,
  20877, 20884, 20885, 20889, 20892, 20894, 20901, 20904, 20922, 20934, 20982, 20985, 20995, 20997, 21029, 21036,
  21038, 21039, 21042, 21053, 21060, 21082, 21108, 21110, 21137, 21139, 21144, 21148, 21152, 21192, 21239, 21242,
  21247, 21248, 21251, 21253, 21269, 21273, 21278, 21281, 21295, 21296, 21297, 21298, 21323, 21324, 21363, 21393,
  21402, 21408, 21421, 21428, 21444, 21452, 21459, 21476, 21479, 21486, 21515, 21517, 21525, 21547, 21588, 21589,
  21594, 21604, 21611, 21644, 21666, 21670, 21673, 21683, 21685, 21689, 21718, 21727, 21730, 21735, 21743, 21763,
  21770, 21819, 21823, 21847, 21861, 21881, 21914, 21928, 21949, 21958, 21961, 21972, 21986, 21998, 22003, 22024,
  22028, 22034, 22040, 22044, 22081, 22086, 22109, 22128, 22144, 22152, 22157, 22176, 22189, 22192, 22220, 22263,
  22280, 22287, 22300, 22325, 22336, 22354, 22361, 22393, 22407, 22439, 22441, 22449, 22453, 22479, 22488, 22508,
  22509, 22531, 22534, 22545, 22549, 22565, 22573, 22597, 22607, 22626, 22667, 22678, 22697, 22699, 22701, 22717,
  22720, 22730, 22737, 22783, 22797, 22833, 22834, 22840, 22842, 22844, 22845, 22847, 22850, 22854, 22860, 22871,
  22881, 22913, 22923, 22936, 22938, 22949, 22955, 22957, 22958, 23015, 23041, 23040, 23043, 23060, 23068, 23088,
  23092, 23123, 23148, 23161, 23166, 23179, 23216, 23221, 23231, 23251, 23261, 23265, 23268, 23296, 23311, 23362,
  23364, 23377, 23380, 23408, 23416, 23419, 23430, 23442, 23446, 23453, 23467, 23474, 23475, 23482, 23484, 23497,
  23511, 23522, 23551, 23554, 23555, 23582, 23583, 23589, 23595, 23596, 23607, 23617, 23643, 23649, 23653, 23668,
  23680, 23685, 23693, 23695, 23724, 23734, 23737, 23743, 23766, 23767, 23777, 23783, 23794, 23799, 23818, 23831,
  23835, 23840, 23852, 23871, 23874, 23875, 23879, 23883, 23900, 23908, 23916, 23941, 23972, 23983, 24003, 24010,
  24017, 24019, 24041, 24072, 24109, 24114, 24130, 24162, 24169, 24193, 24197, 24203, 24244, 24254, 24294, 24305,
  24313, 24327, 24331, 24332, 24340, 24348, 24349, 24372, 24377, 24384, 24394, 24426, 24436, 24440, 24450, 24451,
  24479, 24493, 24505, 24504, 24507, 24512, 24520, 24555, 24560, 24575, 24607, 24608, 24659, 24674, 24679, 24727,
  24732, 24738, 24740, 24771, 24786, 24799, 24813, 24817, 24820, 24822, 24825, 24829, 24831, 24832, 24836, 24845,
  24847, 24873, 24879, 24881, 24902, 24909, 24914, 24925, 24927, 24955, 24960, 24977, 24984, 25001, 25007, 25011,
  25028, 25041, 25044, 25045, 25048, 25059, 25098, 25110, 25142, 25143, 25180, 25187, 25192, 25194, 25197, 25202,
  25205, 25216, 25223, 25240, 25247, 25278, 25280, 25281, 25282, 25288, 25290, 25291, 25292, 25301, 25302, 25303,
  25317, 25322, 25329, 25336, 25368, 25378, 25397, 25401, 25410, 25428, 25429, 25453, 25471, 25473, 25475, 25476,
  25482, 25486, 25488, 25492, 25499, 25502, 25505, 25532, 25539, 25541, 25555, 25580, 25582, 25583, 25606, 25608,
  25638, 25667, 25695, 25708, 25730, 25732, 25737, 25751, 25768, 25769, 25776, 25781, 25785, 25786, 25790, 25806,
  25810, 25813, 25816, 25853, 25859, 25861, 25869, 25887, 25911, 25918, 25923, 25930, 25945, 25950, 25973, 25976,
  25980, 25984, 25985, 25993, 26001, 26019, 26054, 26063, 26064, 26069, 26071, 26072, 26079, 26093, 26104, 26106,
  26108, 26126, 26149, 26169, 26176, 26190, 26197, 26199, 26207, 26215, 26219, 26220, 26221, 26234, 26235, 26237,
  26241, 26248, 26263, 26264, 26268, 26291, 26300, 26309, 26311, 26315, 26344, 26345, 26363, 26366, 26368, 26382,
  26386, 26395, 26394, 26396, 26408, 26410, 26412, 26414, 26427, 26451, 26460, 26463, 26477, 26487, 26515, 26535,
  26536, 26545, 26549, 26563, 26571, 26592, 26594, 26602, 26606, 26616, 26623, 26624, 26634, 26638, 26640, 26649,
  26712, 26713, 26718, 26727, 26728, 26736, 26762, 26777, 26779, 26781, 26796, 26820, 26821, 26853, 26862, 26865,
  26866, 26868, 26882, 26885, 26926, 26942, 26953, 26964, 26966, 26981, 27001, 27046, 27072, 27075, 27100, 27116,
  27118, 27164, 27196, 27204, 27212, 27243, 27249, 27253, 27265, 27280, 27288, 27293, 27303, 27308, 27316, 27317,
  27319, 27321, 27325, 27338, 27341, 27346, 27353, 27364, 27366, 27386, 27421, 27435, 27468, 27472, 27483, 27511,
  27512, 27517, 27530, 27533, 27534, 27549, 27560, 27566, 27583, 27581, 27588, 27621, 27625, 27628, 27629, 27639,
  27654, 27658, 27660, 27661, 27670, 27673, 27705, 27713, 27731, 27737, 27743, 27747, 27750, 27766, 27777, 27778,
  27795, 27810, 27830, 27890, 27900, 27901, 27902, 27913, 27937, 27938, 27939, 27947, 27949, 27955, 27965, 27971,
  27973, 27989, 28010, 28011, 28019, 28085, 28098, 28103, 28110, 28117, 28118, 28138, 28139, 28154, 28180, 28199,
  28205, 28232, 28237, 28252, 28271, 28287, 28296, 28302, 28321, 28325, 28328, 28343, 28358, 28360, 28380, 28385,
  28390, 28404, 28413, 28434, 28438, 28484, 28499, 28500, 28517, 28520, 28524, 28532, 28561, 28562, 28574, 28596,
  28614, 28622, 28634, 28637, 28642, 28644, 28656, 28675, 28677, 28686, 28691, 28716, 28734, 28744, 28756, 28764,
  28765, 28790, 28812, 28814, 28816, 28820, 28823, 28829, 28831, 28854, 28855, 28861, 28899, 28908, 28910, 28909,
  28930, 28943, 28946, 28949, 28951, 28957, 28984, 28988, 28991, 28992, 29025, 29034, 29038, 29048, 29064, 29114,
  29129, 29134, 29140, 29150, 29151, 29178, 29185, 29196, 29205, 29210, 29225, 29233, 29234, 29246, 29263, 29271,
  29276, 29294, 29304, 29323, 29326, 29348, 29347, 29353, 29371, 29379, 29388, 29401, 29404, 29417, 29426, 29433,
  29434, 29451, 29490, 29509, 29525, 29568, 29569, 29575, 29616, 29629, 29650, 29651, 29655, 29679, 29678, 29692,
  29696, 29704, 29705, 29711, 29716, 29728, 29730, 29735, 29736, 29746, 29771, 29788, 29789, 29798, 29800, 29807,
  29808, 29840, 29842, 29843, 29850, 29852, 29860, 29895, 29913, 29919, 29931, 29941, 29949, 29982, 29993, 29996,
  29997, 30011, 30019, 30028, 30060, 30062, 30069, 30073, 30093, 30099, 30122, 30141, 30143, 30190, 30200, 30214,
  30217, 30218, 30247, 30272, 30277, 30318, 30321, 30324, 30342, 30343, 30352, 30357, 30376, 30382, 30407, 30419,
  30420, 30423, 30436, 30438, 30444, 30448, 30457, 30463, 30468, 30480, 30501, 30503, 30505, 30517, 30520, 30524,
  30541, 30545, 30564, 30565, 30566, 30570, 30591, 30595, 30602, 30608, 30627, 30651, 30660, 30666, 30669, 30675,
  30679, 30700, 30703, 30706, 30711, 30717, 30720, 30728, 30741, 30769, 30772, 30788, 30794, 30798, 30804, 30815,
  30827, 30836, 30840, 30849, 30867, 30883, 30906, 30932, 30953, 30972, 30973, 30986, 30988, 31024, 31037, 31039,
  31056, 31066, 31068, 31072, 31079, 31084, 31086, 31099, 31105, 31119, 31121, 31125, 31137, 31158, 31159, 31165,
  31167, 31168, 31173, 31190, 31205, 31216, 31241, 31265, 31266, 31277, 31278, 31299, 31359, 31362, 31385, 31407,
  31416, 31434, 31446, 31448, 31457, 31469, 31509, 31564, 31579, 31583, 31592, 31593, 31599, 31603, 31617, 31637,
  31646, 31650, 31662, 31665, 31672, 31674, 31676, 31681, 31685, 31688, 31697, 31700, 31703, 31711, 31733, 31736,
  31737, 31758, 31765, 31766, 31771, 31789, 31813, 31827, 31832, 31850, 31852, 31859, 31870, 31876, 31889, 31897,
  31940, 31946, 31977, 31978, 31992, 32007, 32012, 32019, 32020, 32040, 32064, 32067, 32091, 32104, 32144, 32173,
  32177, 32190, 32208, 32222, 32226, 32246, 32249, 32261, 32268, 32269, 32292, 32311, 32322, 32332, 32349, 32362,
  32366, 32368, 32385, 32402, 32404, 32411, 32434, 32438, 32439, 32463, 32474, 32477, 32480, 32489, 32492, 32494,
  32500, 32504, 32531, 32533, 32537, 32539, 32558, 32562, 32578, 32607, 32609, 32617, 32677, 32682, 32698, 32740,
  32744, 32746, 32753, 32759, 32761, 32765, 32768, 32775, 32809, 32810, 32814, 32827, 32838, 32844, 32851, 32855,
  32864, 32912, 32918, 32921, 32931, 32938, 32968, 32990, 33012, 33015, 33018, 33024, 33040, 33041, 33044, 33048,
  33056, 33064, 33077, 33079, 33082, 33092, 33094, 33104, 33126, 33133, 33139, 33152, 33154, 33160, 33184, 33189,
  33202, 33210, 33243, 33248, 33269, 33271, 33277, 33297, 33302, 33316, 33330, 33345, 33347, 33357, 33372, 33377,
  33384, 33394, 33415, 33420, 33421, 33444, 33449, 33451, 33453, 33465, 33478, 33485, 33492, 33532, 33558, 33575,
  33577, 33579, 33584, 33588, 33590, 33591, 33595, 33603, 33614, 33644, 33650, 33666, 33682, 33694, 33703, 33715,
  33719, 33729, 33754, 33760, 33774, 33779, 33800, 33804, 33827, 33856, 33873, 33878, 33909, 33914, 33927, 33929,
  33937, 33971, 33977, 34000, 34002, 34017, 34033, 34045, 34055, 34059, 34065, 34066, 34081, 34086, 34088, 34105,
  34142, 34168, 34177, 34182, 34200, 34215, 34217, 34234, 34238, 34248, 34250, 34253, 34267, 34270, 34297, 34301,
  34318, 34338, 34339, 34349, 34350, 34358, 34360, 34367, 34387, 34428, 34440, 34444, 34462, 34473, 34481, 34495,
  34536, 34561, 34579, 34608, 34617, 34622, 34624, 34670, 34693, 34722, 34724, 34752, 34758, 34763, 34768, 34769,
  34780, 34782, 34789, 34798, 34802, 34817, 34819, 34834, 34860, 34888, 34899, 34909, 34912, 34914, 34922, 34924,
  34940, 34954, 34956, 34975, 34981, 34982, 34987, 34999, 35005, 35020, 35025, 35029, 35037, 35044, 35054, 35080,
  35083, 35084, 35120, 35127, 35132, 35136, 35146, 35152, 35180, 35181, 35202, 35205, 35210, 35213, 35226, 35228,
  35241, 35253, 35264, 35301, 35304, 35317, 35326, 35341, 35345, 35347, 35350, 35363, 35384, 35393, 35406, 35412,
  35415, 35427, 35442, 35463, 35476, 35487, 35509, 35548, 35550, 35564, 35589, 35611, 35615, 35623, 35626, 35643,
  35699, 35707, 35710, 35712, 35725, 35727, 35735, 35737, 35749, 35751, 35785, 35795, 35842, 35846, 35848, 35855,
  35893, 35904, 35907, 35920, 35933, 35941, 35946, 35951, 35957, 35960, 35975, 35984, 35987, 35998, 36017, 36019,
  36024, 36039, 36041, 36045, 36046, 36055, 36114, 36123, 36141, 36143, 36145, 36156, 36168, 36186, 36188, 36211,
  36236, 36238, 36251, 36258, 36264, 36265, 36284, 36325, 36340, 36345, 36346, 36348, 36351, 36362, 36363, 36366,
  36377, 36388, 36393, 36395, 36396, 36399, 36425, 36429, 36431, 36439, 36444, 36496, 36514, 36526, 36528, 36547,
  36553, 36616, 36640, 36641, 36657, 36721, 36723, 36728, 36732, 36736, 36740, 36760, 36773, 36778, 36779, 36795,
  36796, 36807, 36812, 36817, 36848, 36850, 36856, 36896, 36914, 36917, 36942, 36962, 36965, 36977, 36981, 36986,
  37000, 37023, 37031, 37036, 37043, 37046, 37088, 37089, 37091, 37096, 37128, 37140, 37165, 37173, 37174, 37202,
  37204, 37223, 37229, 37248, 37265, 37269, 37279, 37289, 37293, 37297, 37300, 37322, 37329, 37339, 37345, 37364,
  37369, 37375, 37379, 37391, 37394, 37404, 37406, 37428, 37441, 37447, 37450, 37461, 37465, 37478, 37504, 37508,
  37521, 37530, 37580, 37590, 37599, 37606, 37609, 37614, 37623, 37629, 37634, 37636, 37648, 37664, 37666, 37677,
  37701, 37704, 37705, 37710, 37720, 37723, 37740, 37751, 37752, 37773, 37819, 37823, 37826, 37843, 37853, 37854,
  37891, 37901, 37908, 37915, 37921, 37934, 37939, 37946, 37949, 37951, 37982, 37995, 37996, 38010, 38016, 38020,
  38031, 38037, 38048, 38070, 38074, 38087, 38089, 38106, 38146, 38147, 38152, 38159, 38160, 38164, 38167, 38170,
  38183, 38184, 38196, 38200, 38206, 38209, 38210, 38211, 38246, 38253, 38267, 38292, 38300, 38303, 38306, 38307,
  38316, 38319, 38325, 38349, 38355, 38370, 38372, 38373, 38375, 38382, 38394, 38403, 38406, 38414, 38423, 38427,
  38438, 38449, 38455, 38474, 38497, 38500, 38518, 38538, 38593, 38623, 38635, 38639, 38656, 38667, 38686, 38712,
  38722, 38723, 38732, 38783, 38792, 38794, 38827, 38835, 38846, 38845, 38848, 38863, 38868, 38870, 38872, 38879,
  38901, 38908, 38917, 38925, 38945, 38957, 38959, 38962, 38963, 38975, 38994, 39014, 39023, 39035, 39038, 39041,
  39061, 39067, 39070, 39073, 39079, 39094, 39095, 39117, 39122, 39138, 39153, 39172, 39177, 39180, 39184, 39191,
  39194, 39198, 39211, 39213, 39221, 39225, 39236, 39238, 39251, 39261, 39263, 39271, 39279, 39299, 39311, 39326,
  39340, 39348, 39360, 39380, 39420, 39424, 39429, 39487, 39514, 39524, 39527, 39530, 39535, 39538, 39566, 39567,
  39584, 39607, 39617, 39625, 39659, 39675, 39690, 39691, 39722, 39730, 39734, 39757, 39780, 39794, 39843, 39847,
  39863, 39866, 39874, 39876, 39898, 39903, 39906, 39919, 39920, 39938, 39943, 39953, 39957, 39958, 39961, 39970,
  39974, 39995, 40007, 40016, 40023, 40035, 40058, 40063, 40077, 40084, 40085, 40086, 40091, 40096, 40107, 40155,
  40160, 40167, 40183, 40215, 40220, 40231, 40240, 40259, 40263, 40274, 40282, 40285, 40291, 40299, 40305, 40321,
  40324, 40326, 40341, 40342, 40344, 40354, 40357, 40397, 40429, 40433, 40474, 40476, 40485, 40526, 40559, 40604,
  40617, 40639, 40646, 40655, 40656, 40675, 40677, 40678, 40680, 40693, 40702, 40706, 40749, 40766, 40772, 40787,
  40793, 40817, 40818, 40834, 40843, 40858, 40859, 40866, 40875, 40876, 40878, 40881, 40888, 40889, 40926, 40932,
  40943, 40944, 40945, 40947, 40990, 41003, 41011, 41036, 41037, 41039, 41060, 41067, 41074, 41075, 41080, 41081,
  41107, 41117, 41152, 41163, 41191, 41208, 41211, 41214, 41224, 41242, 41250, 41260, 41262, 41282, 41296, 41299,
  41306, 41307, 41312, 41319, 41321, 41323, 41325, 41328, 41361, 41373, 41375, 41377, 41395, 41400, 41404, 41426,
  41449, 41451, 41483, 41484, 41515, 41547, 41564, 41572, 41574, 41578, 41597, 41616, 41621, 41639, 41644, 41653,
  41674, 41676, 41704, 41723, 41737, 41781, 41798, 41806, 41813, 41816, 41817, 41822, 41833, 41861, 41893, 41894,
  41904, 41905, 41907, 41909, 41926, 41927, 41935, 41939, 41940, 41941, 41949, 41970, 41975, 41986, 42001, 42008,
  42010, 42028, 42049, 42070, 42071, 42075, 42080, 42088, 42090, 42123, 42129, 42134, 42142, 42146, 42147, 42172,
  42177, 42187, 42249, 42265, 42286, 42299, 42312, 42313, 42334, 42365, 42372, 42394, 42400, 42402, 42415, 42425,
  42430, 42434, 42438, 42440, 42452, 42455, 42459, 42462, 42483, 42484, 42504, 42509, 42515, 42516, 42527, 42535,
  42536, 42538, 42540, 42549, 42556, 42564, 42568, 42570, 42579, 42604, 42614, 42624, 42637, 42662, 42679, 42701,
  42712, 42715, 42717, 42726, 42775, 42777, 42794, 42795, 42799, 42806, 42828, 42834, 42835, 42850, 42854, 42884,
  42895, 42911, 42913, 42917, 42923, 42928, 42931, 42936, 42951, 42954, 42981, 43002, 43012, 43023, 43026, 43035,
  43067, 43073, 43082, 43103, 43105, 43109, 43114, 43121, 43142, 43148, 43152, 43177, 43195, 43204, 43209, 43215,
  43234, 43246, 43266, 43305, 43325, 43338, 43347, 43351, 43352, 43354, 43370, 43392, 43394, 43409, 43410, 43413,
  43414, 43427, 43454, 43496, 43499, 43520, 43528, 43531, 43550, 43553, 43570, 43573, 43575, 43580, 43584, 43587,
  43589, 43590, 43593, 43603, 43620, 43623, 43624, 43644, 43669, 43671, 43673, 43685, 43721, 43726, 43763, 43783,
  43797, 43798, 43807, 43811, 43813, 43822, 43825, 43834, 43850, 43851, 43853, 43878, 43894, 43899, 43902, 43903,
  43908, 43923, 43932, 43937, 43957, 43970, 44001, 44010, 44024, 44031, 44066, 44075, 44093, 44126, 44127, 44130,
  44143, 44148, 44154, 44162, 44191, 44213, 44231, 44248, 44256, 44283, 44290, 44299, 44307, 44315, 44331, 44337,
  44342, 44356, 44367, 44382, 44390, 44405, 44406, 44423, 44471, 44504, 44509, 44511, 44565, 44574, 44599, 44613,
  44626, 44659, 44665, 44700, 44708, 44717, 44738, 44768, 44798, 44816, 44818, 44824, 44825, 44857, 44883, 44887,
  44888, 44892, 44897, 44901, 44923, 44936, 44946, 44961, 44979, 44984, 45001, 45002, 45033, 45038, 45058, 45075,
  45080, 45085, 45097, 45101, 45122, 45127, 45150, 45158, 45166, 45167, 45170, 45184, 45189, 45214, 45219, 45238,
  45242, 45249, 45259, 45270, 45272, 45290, 45305, 45314, 45328, 45333, 45336, 45344, 45386, 45410, 45412, 45413,
  45418, 45421, 45424, 45437, 45439, 45448, 45455, 45461, 45481, 45493, 45496, 45505, 45526, 45527, 45543, 45544,
  45556, 45559, 45571, 45581, 45585, 45590, 45603, 45614, 45615, 45631, 45661, 45675, 45688, 45742, 45743, 45751,
  45754, 45764, 45811, 45814, 45836, 45854, 45856, 45858, 45860, 45888, 45896, 45902, 45915, 45920, 45924, 45941,
  45962, 46026, 46045, 46049, 46058, 46067, 46075, 46093, 46101, 46107, 46114, 46143, 46146, 46168, 46194, 46221,
  46225, 46232, 46247, 46283, 46288, 46297, 46328, 46329, 46358, 46371, 46390, 46404, 46407, 46410, 46454, 46457,
  46460, 46471, 46482, 46504, 46509, 46511, 46515, 46517, 46529, 46543, 46566, 46569, 46578, 46594, 46618, 46620,
  46651, 46652, 46657, 46701, 46733, 46734, 46735, 46736, 46737, 46741, 46744, 46750, 46768, 46771, 46774, 46776,
  46810, 46811, 46813, 46840, 46853, 46859, 46869, 46874, 46879, 46880, 46891, 46893, 46897, 46904, 46914, 46928,
  46938, 46950, 46952, 46974, 46977, 46982, 47006, 47013, 47029, 47039, 47070, 47080, 47096, 47119, 47145, 47168,
  47172, 47175, 47187, 47189, 47193, 47199, 47204, 47205, 47224, 47231, 47242, 47249, 47260, 47267, 47300, 47310,
  47391, 47401, 47422, 47427, 47431, 47452, 47454, 47479, 47498, 47508, 47521, 47522, 47544, 47550, 47559, 47570,
  47591, 47592, 47594, 47627, 47631, 47633, 47654, 47664, 47694, 47701, 47717, 47723, 47758, 47779, 47791, 47854,
  47868, 47884, 47893, 47908, 47913, 47943, 47956, 47959, 47960, 47963, 47965, 48002, 48017, 48023, 48029, 48113,
  48119, 48191, 48218, 48219, 48224, 48266, 48273, 48287, 48310, 48319, 48320, 48324, 48339, 48341, 48348, 48351,
  48356, 48374, 48375, 48390, 48396, 48402, 48413, 48414, 48437, 48455, 48468, 48469, 48519, 48527, 48559, 48561,
  48584, 48613, 48615, 48638, 48682, 48706, 48715, 48730, 48734, 48748, 48763, 48774, 48776, 48782, 48799, 48802,
  48833, 48835, 48839, 48861, 48876, 48883, 48893, 48895, 48926, 48943, 48982, 49005, 49029, 49052, 49065, 49081,
  49092, 49137, 49160, 49164, 49220, 49223, 49233, 49259, 49281, 49293, 49321, 49329, 49339, 49343, 49363, 49394,
  49402, 49408, 49418, 49445, 49477, 49485, 49530, 49569, 49583, 49593, 49619, 49637, 49641, 49642, 49645, 49658,
  49669, 49688, 49689, 49698, 49712, 49764, 49769, 49802, 49809, 49812, 49841, 49844, 49865, 49870, 49893, 49900,
  49926, 49929, 49934, 49967, 49994, 50013, 50027, 50044, 50066, 50067, 50069, 50070, 50075, 50078, 50083, 50099,
  50103, 50109, 50122, 50142, 50174, 50191, 50218, 50222, 50232, 50234, 50241, 50287, 50292, 50303, 50316, 50319,
  50332, 50333, 50335, 50336, 50371, 50372, 50384, 50391, 50414, 50448, 50456, 50480, 50485, 50492, 50493, 50509,
  50516, 50520, 50536, 50546, 50552, 50555, 50562, 50564, 50583, 50584, 50606, 50609, 50635, 50676, 50685, 50693,
  50728, 50755, 50785, 50786, 50790, 50799, 50801, 50847, 50851, 50860, 50868, 50885, 50887, 50888, 50893, 50903,
  50904, 50916, 50933, 50935, 50939, 50954, 50976, 50993, 51008, 51014, 51046, 51047, 51056, 51069, 51077, 51117,
  51140, 51161, 51172, 51192, 51194, 51200, 51213, 51232, 51233, 51245, 51248, 51265, 51290, 51302, 51313, 51327,
  51362, 51364, 51376, 51384, 51401, 51420, 51425, 51437, 51438, 51448, 51459, 51461, 51490, 51491, 51495, 51502,
  51523, 51551, 51556, 51560, 51561, 51576, 51585, 51610, 51623, 51624, 51635, 51658, 51676, 51685, 51718, 51732,
  51775, 51795, 51802, 51808, 51814, 51816, 51821, 51835, 51839, 51849, 51852, 51883, 51885, 51905, 51912, 51914,
  51933, 51979, 51984, 51986, 52004, 52009, 52032, 52043, 52085, 52098, 52102, 52103, 52112, 52113, 52127, 52136,
  52139, 52150, 52154, 52160, 52221, 52273, 52308, 52316, 52338, 52340, 52353, 52366, 52370, 52391, 52405, 52407,
  52419, 52422, 52425, 52452, 52457, 52468, 52469, 52478, 52487, 52488, 52502, 52513, 52520, 52526, 52535, 52537,
  52577, 52584, 52595, 52633, 52638, 52660, 52678, 52679, 52685, 52686, 52689, 52701, 52709, 52727, 52730, 52736,
  52737, 52742, 52785, 52797, 52806, 52815, 52827, 52841, 52863, 52877, 52882, 52911, 52922, 52929, 52943, 52948,
  52959, 52965, 52980, 53035, 53043, 53064, 53100, 53141, 53151, 53154, 53157, 53167, 53229, 53231, 53240, 53252,
  53253, 53257, 53259, 53260, 53261, 53272, 53273, 53295, 53316, 53334, 53355, 53377, 53379, 53387, 53394, 53411,
  53417, 53423, 53426, 53449, 53465, 53472, 53492, 53502, 53530, 53546, 53556, 53589, 53699, 53701, 53702, 53706,
  53721, 53723, 53726, 53740, 53761, 53762, 53771, 53773, 53778, 53781, 53791, 53798, 53807, 53811, 53818, 53824,
  53838, 53849, 53860, 53907, 53910, 53940, 53954, 53963, 54027, 54029, 54030, 54038, 54048, 54049, 54061, 54082,
  54136, 54137, 54173, 54182, 54185, 54204, 54214, 54255, 54264, 54289, 54291, 54294, 54301, 54319, 54327, 54336,
  54360, 54380, 54388, 54430, 54461, 54463, 54477, 54487, 54522, 54537, 54539, 54540, 54561, 54673, 54682, 54688,
  54703, 54708, 54718, 54721, 54725, 54742, 54745, 54746, 54749, 54751, 54767, 54783, 54811, 54829, 54840, 54842,
  54849, 54863, 54872, 54879, 54929, 54951, 55003, 55016, 55068, 55084, 55086, 55106, 55130, 55133, 55137, 55140,
  55164, 55219, 55225, 55249, 55266, 55280, 55282, 55308, 55332, 55350, 55412, 55425, 55434, 55485, 55497, 55528,
  55560, 55564, 55581, 55588, 55595, 55597, 55598, 55642, 55645, 55650, 55657, 55667, 55687, 55705, 55716, 55756,
  55763, 55765, 55779, 55791, 55797, 55821, 55831, 55846, 55849, 55874, 55941, 55945, 55953, 55979, 56000, 56034,
  56035, 56050, 56078, 56080, 56083, 56127, 56135, 56146, 56148, 56170, 56201, 56211, 56242, 56243, 56245, 56250,
  56253, 56280, 56287, 56290, 56293, 56318, 56319, 56332, 56343, 56364, 56388, 56391, 56410, 56445, 56452, 56473,
  56480, 56497, 56500, 56508, 56510, 56518, 56550, 56561, 56573, 56583, 56601, 56606, 56620, 56632, 56633, 56647,
  56656, 56657, 56675, 56700, 56716, 56727, 56731, 56754, 56756, 56769, 56770, 56775, 56779, 56784, 56789, 56802,
  56809, 56816, 56830, 56862, 56899, 56901, 56922, 56944, 56961, 56970, 56975, 56986, 56996, 56997, 57001, 57013,
  57029, 57045, 57047, 57079, 57092, 57111, 57137, 57165, 57175, 57211, 57214, 57240, 57283, 57322, 57328, 57363,
  57371, 57380, 57399, 57439, 57443, 57477, 57497, 57507, 57512, 57562, 57565, 57581, 57587, 57606, 57613, 57629,
  57632, 57646, 57669, 57670, 57696, 57732, 57741, 57749, 57757, 57779, 57791, 57803, 57805, 57819, 57841, 57851,
  57870, 57936, 57939, 57971, 58001, 58002, 58041, 58057, 58082, 58085, 58103, 58110, 58119, 58158, 58159, 58177,
  58181, 58188, 58242, 58259, 58272, 58326, 58369, 58379, 58427, 58436, 58445, 58450, 58452, 58453, 58460, 58469,
  58484, 58510, 58512, 58545, 58574, 58576, 58587, 58590, 58603, 58642, 58654, 58684, 58697, 58706, 58720, 58741,
  58758, 58803, 58809, 58810, 58858, 58859, 58867, 58874, 58884, 58901, 58905, 58921, 58948, 58952, 58989, 59003,
  59008, 59010, 59021, 59046, 59050, 59072, 59151, 59173, 59184, 59196, 59200, 59199, 59229, 59232, 59285, 59291,
  59307, 59309, 59316, 59352, 59353, 59364, 59384, 59389, 59394, 59396, 59439, 59449, 59458, 59468, 59489, 59501,
  59504, 59517, 59551, 59588, 59607, 59608, 59622, 59647, 59654, 59678, 59708, 59728, 59742, 59746, 59747, 59750,
  59767, 59774, 59785, 59796, 59803, 59819, 59831, 59847, 59851, 59856, 59879, 59895, 59898, 59920, 59923, 59929,
  59941, 59950, 60000, 60009, 60018, 60030, 60044, 60059, 60066, 60087, 60098, 60122, 60129, 60157, 60168, 60170,
  60172, 60183, 60189, 60197, 60202, 60210, 60212, 60221, 60260, 60305, 60308, 60320, 60327, 60329, 60351, 60353,
  60379, 60417, 60418, 60421, 60425, 60449, 60454, 60463, 60467, 60468, 60485, 60514, 60525, 60549, 60584, 60589,
  60591, 60595, 60599, 60601, 60603, 60610, 60638, 60646, 60697, 60699, 60710, 60718, 60729, 60735, 60742, 60746,
  60771, 60780, 60781, 60795, 60804, 60809, 60813, 60823, 60851, 60855, 60861, 60870, 60904, 60941, 60957, 60965,
  60969, 60978, 60979, 60988, 60992, 60994, 60998, 61015, 61053, 61071, 61084, 61103, 61134, 61136, 61158, 61172,
  61174, 61181, 61199, 61208, 61212, 61246, 61270, 61281, 61295, 61296, 61309, 61317, 61318, 61320, 61328, 61359,
  61379, 61384, 61394, 61404, 61418, 61420, 61443, 61468, 61496, 61498, 61557, 61558, 61571, 61585, 61621, 61622,
  61637, 61658, 61688, 61692, 61703, 61719, 61720, 61724, 61738, 61740, 61748, 61789, 61796, 61910, 61916, 61932,
  61936, 61937, 61941, 61951, 61960, 61966, 61968, 61981, 62012, 62026, 62027, 62046, 62058, 62081, 62084, 62103,
  62128, 62131, 62170, 62172, 62207, 62212, 62223, 62267, 62268, 62322, 62325, 62327, 62356, 62360, 62376, 62394,
  62402, 62421, 62423, 62434, 62443, 62448, 62478, 62500, 62512, 62516, 62523, 62541, 62561, 62572, 62576, 62600,
  62608, 62641, 62653, 62655, 62683, 62703, 62732, 62743, 62757, 62763, 62786, 62788, 62799, 62807, 62821, 62825,
  62861, 62867, 62875, 62886, 62894, 62896, 62904, 62915, 62931, 62933, 62956, 62972, 62983, 62985, 63003, 63005,
  63007, 63024, 63031, 63033, 63066, 63076, 63090, 63109, 63117, 63121, 63125, 63143, 63165, 63204, 63210, 63211,
  63220, 63243, 63297, 63340, 63355, 63414, 63432, 63462, 63490, 63494, 63497, 63503, 63533, 63584, 63608, 63613,
  63647, 63688, 63724, 63738, 63820, 63822, 63849, 63883, 63901, 63916, 63945, 63948, 63950, 63952, 63972, 64003,
  64004, 64022, 64033, 64053, 64077, 64078, 64094, 64108, 64117, 64122, 64166, 64179, 64181, 64212, 64217, 64224,
  64226, 64238, 64241, 64246, 64320, 64332, 64348, 64375, 64390, 64394, 64395, 64408, 64407, 64417, 64425, 64437,
  64445, 64466, 64472, 64478, 64496, 64515, 64520, 64530, 64540, 64557, 64577, 64580, 64583, 64587, 64607, 64623,
  64651, 64661, 64682, 64692, 64725, 64751, 64774, 64779, 64790, 64792, 64797, 64803, 64820, 64822, 64823, 64838,
  64844, 64852, 64906, 64924, 64927, 64933, 64951, 64962, 64979, 64994, 65072, 65108, 65109, 65112, 65119, 65129,
  65144, 65183, 65198, 65230, 65241, 65247, 65271, 65288, 65289, 65301, 65303, 65311, 65323, 65372, 65376, 65378,
  65381, 65387, 65417, 65420, 65466, 65468, 65474, 65477, 65479, 65522, 65530, 65535, 65536, 65545, 65550, 65581,
  65593, 65595, 65606, 65621, 65630, 65639, 65678, 65682, 65721, 65723, 65728, 65754, 65755, 65783, 65790, 65796,
  65810, 65835, 65862, 65892, 65936, 65951, 65969, 66006, 66015, 66019, 66060, 66065, 66086, 66091, 66098, 66152,
  66198, 66200, 66223, 66234, 66236, 66247, 66249, 66251, 66254, 66257, 66320, 66326, 66385, 66400, 66405, 66417,
  66427, 66435, 66438, 66454, 66458, 66521, 66522, 66563, 66574, 66575, 66594, 66607, 66613, 66634, 66640, 66645,
  66656, 66657, 66666, 66681, 66690, 66700, 66704, 66725, 66727, 66738, 66753, 66763, 66798, 66803, 66821, 66849,
  66860, 66878, 66892, 66903, 66907, 66923, 66924, 66925, 66936, 66984, 66992, 67005, 67036, 67057, 67071, 67103,
  67104, 67139, 67143, 67153, 67172, 67194, 67199, 67210, 67231, 67234, 67239, 67244, 67246, 67250, 67261, 67271,
  67275, 67288, 67292, 67301, 67304, 67384, 67457, 67459, 67464, 67472, 67480, 67483, 67485, 67494, 67523, 67537,
  67545, 67548, 67589, 67605, 67620, 67627, 67648, 67663, 67664, 67665, 67669, 67696, 67703, 67714, 67778, 67782,
  67786, 67787, 67819, 67836, 67848, 67851, 67861, 67890, 67927, 67929, 67942, 67953, 67973, 68002, 68009, 68030,
  68065, 68079, 68080, 68092, 68101, 68103, 68177, 68184, 68191, 68224, 68245, 68269, 68270, 68276, 68279, 68282,
  68333, 68380, 68390, 68413, 68431, 68455, 68478, 68493, 68498, 68516, 68520, 68523, 68537, 68567, 68581, 68594,
  68637, 68641, 68643, 68670, 68673, 68682, 68687, 68702, 68705, 68707, 68739, 68756, 68763, 68776, 68815, 68842,
  68862, 68872, 68895, 68902, 68933, 68940, 68956, 69011, 69012, 69038, 69065, 69068, 69090, 69107, 69112, 69113,
  69122, 69127, 69174, 69191, 69226, 69241, 69269, 69298, 69316, 69340, 69373, 69389, 69398, 69415, 69427, 69458,
  69462, 69483, 69491, 69493, 69536, 69564, 69569, 69585, 69592, 69598, 69612, 69614, 69618, 69623, 69655, 69658,
  69671, 69673, 69701, 69704, 69713, 69727, 69732, 69735, 69747, 69751, 69763, 69773, 69778, 69792, 69818, 69829,
  69862, 69879, 69881, 69896, 69929, 69958, 69965, 69974, 69977, 69989, 69995, 69996, 70012, 70022, 70027, 70029,
  70035, 70038, 70051, 70054, 70069, 70090, 70104, 70236, 70243, 70248, 70264, 70270, 70300, 70306, 70310, 70319,
  70320, 70325, 70327, 70336, 70363, 70384, 70385, 70400, 70414, 70418, 70451, 70452, 70469, 70492, 70497, 70501,
  70517, 70528, 70538, 70574, 70576, 70580, 70602, 70626, 70638, 70657, 70663, 70680, 70692, 70753, 70755, 70762,
  70791, 70794, 70798, 70809, 70873, 70874, 70892, 70894, 70915, 70931, 70949, 70952, 70966, 70987, 71002, 71040,
  71053, 71075, 71094, 71111, 71115, 71121, 71154, 71168, 71182, 71184, 71196, 71243, 71251, 71277, 71280, 71284,
  71295, 71333, 71352, 71353, 71406, 71419, 71429, 71453, 71469, 71494, 71500, 71510, 71530, 71536, 71568, 71571,
  71573, 71581, 71618, 71639, 71658, 71681, 71683, 71729, 71746, 71759, 71762, 71783, 71795, 71832, 71837, 71853,
  71857, 71860, 71861, 71865, 71870, 71876, 71908, 71957, 71974, 71995, 72000, 72010, 72012, 72097, 72104, 72105,
  72121, 72122, 72124, 72125, 72131, 72135, 72139, 72154, 72194, 72197, 72208, 72210, 72217, 72220, 72250, 72290,
  72296, 72308, 72310, 72323, 72338, 72357, 72370, 72373, 72378, 72412, 72432, 72438, 72449, 72469, 72471, 72487,
  72488, 72489, 72508, 72518, 72524, 72552, 72567, 72571, 72573, 72582, 72603, 72607, 72622, 72629, 72631, 72659,
  72664, 72670, 72683, 72702, 72772, 72773, 72800, 72833, 72846, 72848, 72929, 72934, 72959, 72965, 72983, 73036,
  73049, 73068, 73087, 73095, 73100, 73107, 73111, 73116, 73118, 73129, 73133, 73156, 73165, 73166, 73171, 73184,
  73193, 73199, 73223, 73241, 73273, 73279, 73284, 73309, 73310, 73334, 73341, 73350, 73354, 73369, 73394, 73415,
  73454, 73464, 73473, 73493, 73497, 73507, 73536, 73540, 73555, 73559, 73566, 73568, 73571, 73620, 73624, 73634,
  73695, 73706, 73714, 73745, 73764, 73771, 73776, 73807, 73826, 73841, 73850, 73881, 73901, 73909, 73927, 73937,
  73941, 73945, 73953, 73966, 73996, 74000, 74006, 74026, 74044, 74047, 74066, 74083, 74087, 74096, 74100, 74117,
  74121, 74181, 74184, 74224, 74239, 74272, 74273, 74296, 74305, 74336, 74376, 74380, 74386, 74391, 74392, 74395,
  74418, 74421, 74441, 74449, 74470, 74479, 74490, 74493, 74500, 74505, 74514, 74539, 74552, 74561, 74571, 74582,
  74596, 74600, 74604, 74605, 74623, 74649, 74666, 74689, 74690, 74695, 74696, 74707, 74716, 74732, 74750, 74769,
  74775, 74778, 74785, 74793, 74824, 74837, 74857, 74875, 74895, 74896, 74901, 74911, 74929, 74941, 74946, 74950,
  74975, 75000, 75003, 75043, 75049, 75091, 75093, 75097, 75101, 75110, 75118, 75119, 75125, 75127, 75141, 75164,
  75177, 75178, 75181, 75206, 75230, 75256, 75257, 75260, 75264, 75272, 75294, 75304, 75308, 75312, 75323, 75324,
  75342, 75352, 75369, 75379, 75411, 75439, 75458, 75501, 75530, 75535, 75565, 75572, 75587, 75647, 75665, 75674,
  75695, 75696, 75730, 75736, 75742, 75761, 75770, 75788, 75790, 75810, 75818, 75822, 75828, 75915, 75919, 75939,
  75944, 75959, 75973, 75974, 76006, 76008, 76013, 76033, 76041, 76048, 76063, 76069, 76106, 76126, 76127, 76133,
  76143, 76165, 76198, 76207, 76219, 76234, 76243, 76259, 76267, 76276, 76297, 76307, 76311, 76333, 76337, 76366,
  76371, 76372, 76376, 76395, 76397, 76424, 76425, 76440, 76456, 76470, 76503, 76509, 76519, 76532, 76534, 76552,
  76567, 76568, 76569, 76594, 76600, 76603, 76608, 76617, 76618, 76628, 76651, 76664, 76666, 76669, 76705, 76716,
  76733, 76736, 76739, 76742, 76750, 76809, 76810, 76829, 76852, 76866, 76877, 76878, 76880, 76935, 76939, 76945,
  76952, 76957, 76985, 76996, 77007, 77042, 77048, 77052, 77055, 77060, 77070, 77086, 77111, 77138, 77163, 77186,
  77227, 77233, 77235, 77257, 77272, 77277, 77286, 77287, 77336, 77350, 77358, 77370, 77390, 77397, 77412, 77442,
  77450, 77454, 77464, 77512, 77516, 77541, 77562, 77574, 77578, 77622, 77634, 77635, 77645, 77655, 77660, 77661,
  77678, 77689, 77729, 77738, 77760, 77782, 77801, 77811, 77817, 77835, 77840, 77853, 77858, 77859, 77900, 77902,
  77907, 77909, 77910, 77927, 77939, 77952, 77982, 77984, 77985, 77986, 77990, 77995, 78012, 78017, 78045, 78046,
  78058, 78059, 78072, 78078, 78104, 78105, 78106, 78117, 78132, 78142, 78153, 78159, 78168, 78180, 78207, 78236,
  78246, 78265, 78276, 78279, 78286, 78323, 78355, 78360, 78384, 78400, 78401, 78436, 78442, 78445, 78459, 78469,
  78476, 78481, 78486, 78493, 78527, 78540, 78542, 78554, 78575, 78592, 78603, 78632, 78639, 78649, 78650, 78655,
  78661, 78662, 78665, 78685, 78699, 78710, 78726, 78731, 78747, 78820, 78821, 78840, 78849, 78868, 78870, 78877,
  78893, 78914, 78918, 78933, 78955, 78970, 78985, 78989, 78990, 79005, 79007, 79031, 79043, 79045, 79050, 79072,
  79086, 79098, 79101, 79102, 79119, 79120, 79125, 79137, 79153, 79164, 79173, 79195, 79199, 79203, 79208, 79280,
  79302, 79320, 79332, 79349, 79350, 79357, 79358, 79374, 79375, 79385, 79387, 79399, 79404, 79414, 79420, 79441,
  79463, 79488, 79490, 79497, 79509, 79522, 79530, 79540, 79581, 79593, 79596, 79599, 79601, 79605, 79607, 79622,
  79653, 79661, 79664, 79666, 79672, 79686, 79689, 79692, 79754, 79757, 79781, 79787, 79788, 79790, 79797, 79804,
  79812, 79822, 79834, 79867, 79881, 79882, 79938, 79945, 79953, 79963, 79980, 79992, 80000, 80008, 80021, 80047,
  80054, 80057, 80066, 80079, 80112, 80161, 80170, 80179, 80181, 80197, 80208, 80212, 80214, 80227, 80247, 80309,
  80324, 80331, 80337, 80343, 80351, 80375, 80390, 80399, 80421, 80455, 80460, 80463, 80473, 80480, 80514, 80558,
  80569, 80582, 80610, 80620, 80628, 80645, 80650, 80672, 80675, 80682, 80686, 80693, 80704, 80708, 80710, 80719,
  80763, 80782, 80788, 80793, 80809, 80815, 80816, 80840, 80843, 80850, 80874, 80883, 80888, 80894, 80898, 80910,
  80911, 80920, 80945, 80953, 80975, 80991, 81007, 81008, 81065, 81122, 81126, 81141, 81198, 81231, 81252, 81266,
  81289, 81290, 81292, 81300, 81304, 81305, 81337, 81358, 81377, 81404, 81425, 81428, 81437, 81440, 81472, 81497,
  81499, 81507, 81523, 81580, 81632, 81641, 81650, 81657, 81659, 81660, 81663, 81670, 81687, 81691, 81693, 81702,
  81710, 81724, 81728, 81729, 81733, 81734, 81741, 81754, 81800, 81803, 81823, 81833, 81840, 81847, 81852, 81854,
  81873, 81891, 81903, 81904, 81911, 81914, 81966, 81972, 81992, 82012, 82020, 82028, 82037, 82073, 82080, 82091,
  82110, 82129, 82135, 82162, 82171, 82172, 82216, 82241, 82259, 82273, 82321, 82339, 82350, 82355, 82363, 82369,
  82396, 82402, 82405, 82418, 82419, 82422, 82426, 82453, 82480, 82493, 82504, 82514, 82517, 82539, 82543, 82545,
  82554, 82587, 82611, 82621, 82650, 82669, 82671, 82672, 82673, 82676, 82691, 82693, 82716, 82723, 82729, 82730,
  82731, 82764, 82775, 82780, 82783, 82798, 82802, 82806, 82855, 82860, 82861, 82868, 82880, 82898, 82902, 82911,
  82925, 82944, 82951, 82960, 82979, 82987, 82989, 83000, 83007, 83013, 83057, 83081, 83090, 83100, 83114, 83138,
  83150, 83153, 83176, 83187, 83196, 83202, 83207, 83216, 83235, 83254, 83255, 83262, 83269, 83289, 83308, 83313,
  83317, 83321, 83323, 83331, 83336, 83342, 83359, 83365, 83367, 83430, 83431, 83462, 83478, 83481, 83491, 83493,
  83494, 83499, 83504, 83535, 83556, 83565, 83567, 83574, 83575, 83593, 83594, 83601, 83608, 83613, 83635, 83650,
  83677, 83684, 83688, 83692, 83693, 83706, 83738, 83740, 83816, 83834, 83838, 83853, 83854, 83857, 83895, 83896,
  83906, 83947, 83962, 83984, 84012, 84021, 84033, 84054, 84105, 84108, 84113, 84143, 84150, 84151, 84158, 84175,
  84177, 84183, 84226, 84248, 84311, 84332, 84345, 84379, 84380, 84401, 84402, 84405, 84425, 84431, 84445, 84478,
  84479, 84489, 84496, 84500, 84510, 84514, 84524, 84535, 84551, 84556, 84573, 84599, 84606, 84626, 84631, 84649,
  84650, 84656, 84671, 84690, 84691, 84700, 84709, 84720, 84731, 84759, 84769, 84780, 84792, 84801, 84821, 84833,
  84835, 84855, 84856, 84862, 84880, 84883, 84887, 84893, 84934, 84938, 84947, 84949, 84950, 84969, 84970, 84979,
  85019, 85020, 85042, 85048, 85049, 85068, 85079, 85084, 85112, 85139, 85147, 85149, 85157, 85162, 85169, 85181,
  85185, 85187, 85195, 85207, 85235, 85237, 85242, 85258, 85267, 85268, 85290, 85302, 85307, 85312, 85313, 85317,
  85333, 85340, 85355, 85365, 85379, 85382, 85385, 85389, 85391, 85393, 85397, 85405, 85409, 85423, 85442, 85450,
  85470, 85474, 85480, 85520, 85537, 85543, 85549, 85589, 85622, 85666, 85667, 85670, 85688, 85692, 85693, 85696,
  85699, 85715, 85727, 85749, 85751, 85755, 85760, 85783, 85786, 85788, 85790, 85792, 85805, 85819, 85822, 85826,
  85829, 85839, 85888, 85889, 85912, 85922, 85923, 85927, 85930, 85934, 85975, 85998, 86011, 86019, 86032, 86036,
  86060, 86064, 86088, 86092, 86096, 86098, 86118, 86130, 86153, 86170, 86178, 86182, 86184, 86201, 86219, 86228,
  86246, 86248, 86254, 86263, 86266, 86284, 86305, 86311, 86313, 86352, 86373, 86391, 86414, 86462, 86476, 86486,
  86501, 86506, 86510, 86527, 86537, 86546, 86552, 86561, 86565, 86575, 86614, 86620, 86623, 86628, 86667, 86670,
  86698, 86713, 86716, 86725, 86731, 86732, 86736, 86742, 86768, 86769, 86782, 86796, 86809, 86831, 86847, 86871,
  86925, 86929, 86974, 87042, 87044, 87045, 87072, 87073, 87074, 87099, 87108, 87150, 87158, 87163, 87174, 87192,
  87194, 87212, 87220, 87224, 87234, 87261, 87264, 87293, 87294, 87308, 87314, 87335, 87341, 87379, 87390, 87393,
  87404, 87427, 87428, 87434, 87445, 87460, 87472, 87491, 87495, 87516, 87523, 87532, 87540, 87558, 87563, 87564,
  87567, 87569, 87585, 87616, 87624, 87655, 87670, 87671, 87706, 87722, 87728, 87744, 87747, 87777, 87782, 87808,
  87812, 87813, 87822, 87833, 87836, 87846, 87847, 87850, 87865, 87866, 87875, 87895, 87910, 87926, 87928, 87933,
  87936, 87948, 87998, 88012, 88020, 88030, 88038, 88048, 88060, 88101, 88116, 88122, 88125, 88127, 88128, 88136,
  88148, 88149, 88172, 88175, 88190, 88192, 88213, 88217, 88258, 88267, 88274, 88277, 88290, 88294, 88298, 88331,
  88346, 88380, 88404, 88415, 88429, 88469, 88522, 88528, 88550, 88565, 88567, 88599, 88601, 88604, 88635, 88636,
  88657, 88670, 88671, 88675, 88684, 88694, 88714, 88726, 88732, 88745, 88754, 88760, 88765, 88771, 88788, 88794,
  88815, 88816, 88817, 88818, 88836, 88839, 88859, 88862, 88866, 88876, 88886, 88899, 88929, 88964, 88972, 88981,
  89000, 89006, 89008, 89010, 89020, 89023, 89042, 89047, 89065, 89086, 89096, 89099, 89104, 89112, 89114, 89115,
  89153, 89156, 89172, 89234, 89246, 89279, 89290, 89298, 89341, 89347, 89348, 89369, 89370, 89439, 89440, 89448,
  89470, 89474, 89482, 89487, 89507, 89512, 89527, 89587, 89597, 89604, 89605, 89609, 89620, 89622, 89623, 89637,
  89642, 89674, 89677, 89678, 89684, 89683, 89726, 89772, 89773, 89805, 89826, 89827, 89835, 89851, 89861, 89908,
  89918, 89920, 89925, 89931, 89935, 89937, 89943, 89962, 89968, 89977, 89980, 89981, 90012, 90023, 90037, 90052,
  90067, 90074, 90083, 90086, 90096, 90098, 90124, 90133, 90135, 90139, 90146, 90156, 90163, 90174, 90182, 90185,
  90191, 90200, 90223, 90238, 90253, 90256, 90260, 90289, 90290, 90304, 90313, 90336, 90337, 90342, 90344, 90398,
  90414, 90422, 90437, 90441, 90476, 90478, 90485, 90487, 90494, 90496, 90497, 90510, 90509, 90541, 90568, 90595,
  90597, 90606, 90637, 90642, 90647, 90651, 90662, 90664, 90687, 90692, 90729, 90759, 90762, 90763, 90797, 90804,
  90806, 90830, 90842, 90844, 90853, 90858, 90884, 90887, 90905, 90913, 90915, 90923, 90930, 90936, 90967, 90969,
  90968, 90971, 90981, 90982, 90991, 91004, 91013, 91014, 91062, 91090, 91105, 91117, 91118, 91119, 91132, 91139,
  91142, 91159, 91172, 91196, 91217, 91235, 91237, 91250, 91262, 91279, 91315, 91322, 91347, 91369, 91373, 91394,
  91405, 91438, 91461, 91491, 91494, 91499, 91523, 91525, 91532, 91533, 91552, 91606, 91662, 91675, 91677, 91689,
  91707, 91723, 91726, 91733, 91751, 91755, 91781, 91792, 91811, 91820, 91843, 91845, 91852, 91854, 91875, 91880,
  91883, 91901, 91915, 91918, 91919, 91926, 91958, 91971, 91973, 91974, 91975, 91985, 91989, 92008, 92016, 92021,
  92024, 92027, 92040, 92041, 92043, 92056, 92072, 92079, 92088, 92098, 92111, 92112, 92117, 92131, 92133, 92136,
  92161, 92175, 92202, 92226, 92233, 92243, 92254, 92269, 92270, 92294, 92296, 92301, 92308, 92312, 92367, 92382,
  92386, 92390, 92391, 92394, 92398, 92405, 92420, 92456, 92475, 92480, 92488, 92487, 92512, 92524, 92549, 92550,
  92551, 92593, 92599, 92608, 92609, 92614, 92630, 92635, 92643, 92646, 92669, 92674, 92676, 92687, 92689, 92717,
  92728, 92731, 92747, 92761, 92768, 92782, 92791, 92814, 92818, 92822, 92824, 92831, 92833, 92845, 92855, 92862,
  92866, 92872, 92882, 92931, 92937, 92946, 92951, 92953, 92963, 92968, 92969, 92972, 92989, 92997, 93012, 93015,
  93017, 93026, 93049, 93051, 93053, 93057, 93068, 93074, 93085, 93104, 93117, 93124, 93134, 93138, 93140, 93148,
  93163, 93174, 93177, 93179, 93194, 93197, 93203, 93209, 93210, 93225, 93234, 93238, 93244, 93256, 93270, 93279,
  93287, 93299, 93315, 93340, 93354, 93371, 93374, 93393, 93408, 93418, 93423, 93429, 93437, 93443, 93466, 93470,
  93488, 93498, 93506, 93523, 93526, 93537, 93542, 93543, 93552, 93574, 93580, 93624, 93629, 93666, 93667, 93683,
  93713, 93717, 93718, 93720, 93733, 93747, 93763, 93770, 93805, 93815, 93825, 93843, 93845, 93855, 93858, 93860,
  93862, 93864, 93867, 93887, 93903, 93917, 93925, 93966, 93975, 93993, 93996, 94005, 94013, 94054, 94068, 94083,
  94114, 94130, 94140, 94141, 94144, 94149, 94150, 94157, 94160, 94243, 94272, 94280, 94290, 94302, 94311, 94336,
  94372, 94376, 94382, 94385, 94398, 94434, 94437, 94477, 94478, 94481, 94490, 94556, 94598, 94604, 94620, 94623,
  94624, 94630, 94643, 94645, 94648, 94646, 94685, 94703, 94712, 94713, 94720, 94724, 94727, 94755, 94770, 94779,
  94789, 94820, 94827, 94833, 94834, 94858, 94885, 94890, 94910, 94913, 94916, 94929, 94932, 94974, 94981, 94982,
  94986, 95002, 95038, 95066, 95067, 95073, 95077, 95081, 95149, 95154, 95159, 95167, 95168, 95176, 95188, 95211,
  95222, 95235, 95239, 95241, 95253, 95260, 95261, 95281, 95294, 95319, 95340, 95347, 95352, 95369, 95370, 95372,
  95396, 95398, 95408, 95447, 95453, 95456, 95477, 95485, 95487, 95492, 95498, 95503, 95501, 95556, 95557, 95560,
  95564, 95572, 95576, 95582, 95585, 95619, 95656, 95664, 95673, 95690, 95732, 95771, 95785, 95793, 95812, 95818,
  95820, 95822, 95823, 95853, 95865, 95866, 95898, 95929, 95932, 95937, 95947, 95951, 95953, 95965, 95978, 95999,
  96003, 96014, 96016, 96052, 96095, 96100, 96141, 96164, 96178, 96198, 96204, 96229, 96234, 96258, 96275, 96288,
  96297, 96302, 96316, 96327, 96341, 96351, 96356, 96365, 96387, 96396, 96406, 96417, 96428, 96440, 96441, 96459,
  96465, 96468, 96481, 96483, 96496, 96503, 96516, 96536, 96546, 96556, 96572, 96601, 96607, 96620, 96630, 96665,
  96683, 96688, 96693, 96706, 96721, 96724, 96729, 96734, 96757, 96760, 96771, 96781, 96805, 96807, 96808, 96825,
  96837, 96840, 96856, 96882, 96895, 96901, 96907, 96917, 96919, 96931, 96950, 96957, 96977, 97028, 97029, 97033,
  97063, 97067, 97070, 97077, 97081, 97087, 97091, 97118, 97122, 97139, 97142, 97144, 97151, 97165, 97228, 97229,
  97242, 97244, 97260, 97278, 97290, 97295, 97307, 97326, 97365, 97372, 97376, 97402, 97421, 97423, 97433, 97454,
  97473, 97484, 97485, 97491, 97496, 97499, 97515, 97534, 97538, 97569, 97572, 97573, 97598, 97607, 97611, 97630,
  97634, 97635, 97646, 97649, 97650, 97651, 97674, 97675, 97679, 97687, 97697, 97700, 97709, 97749, 97757, 97765,
  97767, 97774, 97783, 97789, 97796, 97804, 97816, 97819, 97845, 97849, 97870, 97871, 97886, 97892, 97928, 97938,
  97944, 97961, 97966, 97967, 97970, 97971, 97980, 97985, 98012, 98032, 98036, 98038, 98044, 98055, 98066, 98068,
  98073, 98085, 98086, 98103, 98110, 98111, 98143, 98146, 98162, 98174, 98194, 98234, 98253, 98258, 98308, 98320,
  98325, 98332, 98333, 98337, 98346, 98351, 98353, 98375, 98379, 98383, 98385, 98401, 98412, 98416, 98421, 98425,
  98438, 98458, 98461, 98470, 98478, 98482, 98485, 98495, 98512, 98526, 98543, 98563, 98571, 98575, 98579, 98583,
  98609, 98608, 98624, 98633, 98636, 98658, 98661, 98688, 98701, 98702, 98738, 98754, 98761, 98767, 98772, 98785,
  98819, 98823, 98842, 98844, 98858, 98863, 98872, 98890, 98910, 98915, 98920, 98921, 98946, 98954, 98959, 98962,
  99024, 99026, 99031, 99080, 99120, 99137, 99145, 99158, 99171, 99176, 99188, 99200, 99221, 99234, 99240, 99255,
  99270, 99294, 99303, 99404, 99445, 99453, 99457, 99461, 99473, 99479, 99500, 99518, 99529, 99531, 99570, 99572,
  99579, 99585, 99624, 99631, 99639, 99655, 99663, 99666, 99675, 99685, 99719, 99738, 99742, 99747, 99762, 99770,
  99824, 99825, 99841, 99848, 99853, 99870, 99874, 99878, 99889, 99893, 99894, 99913, 99918, 99920, 99929, 99951,
  99968, 100016, 100017, 100018, 100027, 100044, 100062, 100064, 100069, 100097, 100108, 100122, 100142, 100151, 100155, 100165,
  100184, 100195, 100208, 100221, 100232, 100250, 100256, 100261, 100268, 100274, 100276, 100295, 100300, 100310, 100325, 100332,
  100345, 100357, 100379, 100412, 100434, 100435, 100437, 100453, 100469, 100486, 100501, 100511, 100515, 100524, 100541, 100574,
  100587, 100591, 100651, 100664, 100672, 100697, 100714, 100738, 100751, 100754, 100758, 100762, 100764, 100779, 100781, 100807,
  100808, 100852, 100859, 100866, 100876, 100881, 100907, 100953, 100965, 100969, 100977, 101011, 101017, 101027, 101044, 101067,
  101076, 101084, 101082, 101090, 101093, 101101, 101123, 101133, 101134, 101138, 101160, 101211, 101213, 101214, 101221, 101243,
  101245, 101260, 101268, 101285, 101300, 101339, 101345, 101384, 101421, 101427, 101467, 101474, 101475, 101477, 101483, 101489,
  101505, 101507, 101552, 101556, 101558, 101570, 101589, 101608, 101612, 101623, 101626, 101641, 101684, 101692, 101716, 101746,
  101756, 101765, 101769, 101772, 101773, 101800, 101808, 101810, 101843, 101847, 101867, 101868, 101870, 101882, 101899, 101900,
  101909, 101911, 101916, 101919, 101921, 101923, 101936, 101949, 101958, 101965, 101966, 101983, 101984, 101986, 101997, 102011,
  102014, 102026, 102033, 102040, 102057, 102066, 102080, 102092, 102094, 102096, 102098, 102155, 102157, 102158, 102162, 102177,
  102208, 102216, 102230, 102253, 102258, 102276, 102281, 102333, 102358, 102370, 102388, 102395, 102414, 102422, 102431, 102453,
  102485, 102487, 102488, 102496, 102497, 102499, 102530, 102531, 102532, 102561, 102571, 102585, 102589, 102599, 102618, 102624,
  102631, 102633, 102635, 102642, 102670, 102693, 102712, 102724, 102770, 102771, 102772, 102773, 102780, 102790, 102804, 102805,
  102819, 102827, 102831, 102833, 102843, 102891, 102901, 102916, 102945, 102949, 102950, 102962, 102978, 102989, 102993, 103004,
  103005, 103045, 103071, 103077, 103079, 103089, 103094, 103103, 103127, 103145, 103154, 103168, 103200, 103206, 103219, 103226,
  103227, 103294, 103298, 103301, 103312, 103346, 103359, 103360, 103371, 103389, 103401, 103413, 103414, 103460, 103511, 103519,
  103527, 103530, 103532, 103545, 103569, 103571, 103596, 103598, 103616, 103632, 103646, 103652, 103673, 103675, 103682, 103693,
  103703, 103732, 103734, 103738, 103752, 103777, 103810, 103822, 103828, 103836, 103871, 103882, 103889, 103891, 103892, 103894,
  103902, 103929, 103949, 103956, 103963, 103981, 104019, 104031, 104041, 104043, 104048, 104060, 104085, 104101, 104105, 104139,
  104148, 104171, 104172, 104174, 104177, 104185, 104194, 104202, 104214, 104217, 104234, 104281, 104296, 104297, 104357, 104364,
  104365, 104371, 104382, 104440, 104441, 104452, 104459, 104481, 104516, 104521, 104537, 104538, 104557, 104597, 104634, 104642,
  104680, 104732, 104738, 104750, 104752, 104755, 104756, 104765, 104771, 104788, 104822, 104858, 104872, 104887, 104914, 104925,
  104962, 104963, 104968, 104974, 104978, 104980, 104987, 105017, 105019, 105034, 105046, 105064, 105079, 105080, 105091, 105101,
  105102, 105138, 105140, 105143, 105148, 105164, 105186, 105193, 105199, 105224, 105228, 105229, 105259, 105269, 105268, 105282,
  105319, 105334, 105344, 105370, 105382, 105390, 105406, 105411, 105412, 105413, 105425, 105432, 105497, 105502, 105515, 105558,
  105570, 105574, 105576, 105637, 105646, 105652, 105660, 105662, 105665, 105668, 105678, 105685, 105689, 105695, 105696, 105703,
  105727, 105729, 105761, 105767, 105768, 105769, 105811, 105819, 105841, 105854, 105858, 105860, 105864, 105881, 105891, 105898,
  105913, 105928, 105942, 105949, 105966, 105972, 106003, 106021, 106032, 106039, 106044, 106052, 106062, 106064, 106065, 106093,
  106103, 106140, 106171, 106227, 106243, 106267, 106278, 106306, 106320, 106327, 106340, 106363, 106393, 106419, 106420, 106424,
  106429, 106474, 106481, 106500, 106518, 106527, 106544, 106550, 106551, 106559, 106564, 106590, 106592, 106595, 106604, 106605,
  106642, 106643, 106654, 106661, 106703, 106711, 106723, 106752, 106758, 106771, 106783, 106786, 106787, 106801, 106818, 106856,
  106872, 106881, 106886, 106897, 106907, 106938, 106944, 106978, 106985, 106999, 107030, 107041, 107089, 107095, 107097, 107119,
  107128, 107129, 107136, 107140, 107144, 107151, 107162, 107173, 107186, 107188, 107197, 107230, 107232, 107235, 107238, 107253,
  107259, 107271, 107297, 107299, 107302, 107310, 107315, 107344, 107348, 107350, 107354, 107374, 107380, 107382, 107398, 107409,
  107418, 107423, 107445, 107472, 107487, 107502, 107517, 107533, 107555, 107556, 107558, 107575, 107586, 107596, 107608, 107637,
  107649, 107664, 107710, 107723, 107734, 107749, 107750, 107763, 107773, 107788, 107797, 107835, 107843, 107856, 107887, 107893,
  107901, 107930, 107956, 107975, 108022, 108036, 108060, 108085, 108090, 108102, 108119, 108133, 108144, 108165, 108195, 108209,
  108226, 108259, 108268, 108281, 108294, 108296, 108317, 108339, 108347, 108364, 108420, 108431, 108453, 108478, 108494, 108505,
  108506, 108513, 108535, 108543, 108612, 108626, 108632, 108661, 108691, 108693, 108699, 108758, 108759, 108766, 108772, 108784,
  108797, 108845, 108849, 108868, 108870, 108874, 108875, 108917, 108924, 108952, 108969, 108975, 108991, 109005, 109009, 109017,
  109023, 109033, 109056, 109068, 109074, 109079, 109081, 109082, 109102, 109111, 109121, 109124, 109139, 109176, 109190, 109205,
  109209, 109212, 109240, 109268, 109272, 109276, 109285, 109289, 109303, 109306, 109332, 109352, 109375, 109400, 109404, 109408,
  109410, 109412, 109422, 109427, 109434, 109439, 109442, 109445, 109458, 109466, 109471, 109472, 109474, 109492, 109493, 109509,
  109521, 109556, 109572, 109577, 109584, 109585, 109592, 109602, 109620, 109624, 109647, 109654, 109659, 109667, 109691, 109693,
  109730, 109737, 109745, 109746, 109754, 109786, 109788, 109789, 109821, 109831, 109857, 109902, 109908, 109937, 109939, 109972,
  109973, 109977, 109984, 109990, 110000, 110003, 110009, 110018, 110023, 110055, 110078, 110091, 110103, 110109, 110130, 110171,
  110179, 110256, 110273, 110298, 110311, 110314, 110316, 110341, 110346, 110351, 110371, 110386, 110391, 110395, 110408, 110478,
  110487, 110497, 110498, 110504, 110506, 110529, 110532, 110538, 110548, 110566, 110578, 110602, 110609, 110618, 110649, 110668,
  110672, 110696, 110712, 110725, 110746, 110778, 110785, 110787, 110790, 110817, 110838, 110849, 110873, 110882, 110907, 110919,
  110935, 110936, 110960, 110986, 110988, 110992, 110991, 110997, 111022, 111043, 111045, 111056, 111062, 111066, 111068, 111072,
  111086, 111104, 111123, 111138, 111169, 111170, 111171, 111188, 111191, 111196, 111200, 111242, 111247, 111259, 111278, 111296,
  111310, 111314, 111325, 111362, 111394, 111449, 111497, 111504, 111515, 111532, 111539, 111543, 111546, 111548, 111550, 111567,
  111594, 111600, 111601, 111627, 111643, 111649, 111660, 111674, 111710, 111753, 111761, 111795, 111797, 111801, 111809, 111810,
  111841, 111869, 111879, 111884, 111925, 111934, 111944, 111954, 111965, 111967, 111974, 112029, 112031, 112032, 112041, 112051,
  112067, 112078, 112098, 112102, 112117, 112122, 112127, 112144, 112158, 112168, 112170, 112179, 112203, 112211, 112241, 112242,
  112259, 112300, 112305, 112324, 112358, 112368, 112374, 112381, 112405, 112417, 112432, 112440, 112447, 112501, 112508, 112519,
  112529, 112533, 112542, 112567, 112590, 112603, 112615, 112623, 112635, 112641, 112670, 112694, 112716, 112724, 112731, 112746,
  112748, 112761, 112778, 112781, 112832, 112833, 112862, 112864, 112895, 112917, 112924, 112935, 112948, 112961, 112986, 112997,
  112998, 113009, 113031, 113044, 113048, 113080, 113084, 113116, 113127, 113131, 113136, 113137, 113148, 113167, 113174, 113184,
  113186, 113189, 113204, 113222, 113234, 113246, 113281, 113283, 113288, 113307, 113327, 113345, 113357, 113360, 113368, 113371,
  113421, 113433, 113445, 113447, 113465, 113498, 113501, 113503, 113521, 113531, 113532, 113561, 113562, 113593, 113610, 113622,
  113638, 113657, 113669, 113673, 113674, 113684, 113686, 113705, 113726, 113750, 113781, 113784, 113788, 113801, 113802, 113852,
  113860, 113864, 113881, 113889, 113902, 113904, 113919, 113957, 113963, 113969, 113994, 113996, 113998, 114005, 114081, 114096,
  114104, 114119, 114131, 114132, 114144, 114152, 114155, 114159, 114162, 114163, 114167, 114187, 114189, 114200, 114210, 114212,
  114222, 114227, 114254, 114258, 114268, 114273, 114341, 114347, 114365, 114366, 114367, 114371, 114375, 114382, 114389, 114407,
  114408, 114421, 114430, 114449, 114520, 114526, 114550, 114570, 114607, 114622, 114641, 114686, 114699, 114714, 114724, 114725,
  114742, 114745, 114750, 114775, 114822, 114831, 114855, 114921, 114924, 114937, 114939, 114948, 114969, 114971, 114981, 114984,
  114996, 115015, 115022, 115033, 115036, 115054, 115062, 115065, 115088, 115102, 115115, 115121, 115126, 115129, 115142, 115144,
  115148, 115152, 115171, 115178, 115191, 115218, 115227, 115245, 115250, 115257, 115261, 115271, 115272, 115280, 115312, 115355,
  115389, 115395, 115404, 115407, 115433, 115438, 115444, 115476, 115496, 115510, 115522, 115528, 115530, 115537, 115590, 115591,
  115620, 115623, 115669, 115709, 115713, 115738, 115746, 115755, 115756, 115759, 115768, 115769, 115770, 115806, 115830, 115833,
  115836, 115839, 115906, 115907, 115908, 115915, 115919, 115945, 115953, 115990, 115996, 116030, 116060, 116076, 116097, 116106,
  116118, 116119, 116146, 116187, 116231, 116247, 116250, 116264, 116292, 116307, 116310, 116323, 116354, 116355, 116365, 116368,
  116380, 116389, 116422, 116428, 116465, 116495, 116505, 116582, 116584, 116591, 116592, 116602, 116611, 116624, 116631, 116653,
  116709, 116714, 116727, 116728, 116737, 116758, 116768, 116771, 116781, 116805, 116820, 116824, 116853, 116876, 116889, 116901,
  116912, 116918, 116928, 116941, 116957, 116962, 116971, 116972, 116991, 117020, 117073, 117075, 117088, 117089, 117105, 117107,
  117125, 117133, 117218, 117219, 117221, 117245, 117265, 117299, 117301, 117314, 117315, 117340, 117371, 117375, 117420, 117430,
  117445, 117447, 117450, 117452, 117472, 117491, 117494, 117500, 117503, 117510, 117541, 117551, 117567, 117571, 117628, 117629,
  117683, 117689, 117710, 117712, 117718, 117722, 117730, 117756, 117761, 117774, 117797, 117860, 117863, 117880, 117887, 117927,
  117931, 117956, 117957, 117986, 118029, 118048, 118071, 118076, 118077, 118081, 118092, 118114, 118116, 118121, 118131, 118178,
  118209, 118234, 118243, 118268, 118277, 118281, 118322, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
  -1, -1, -1, -1, -1, -1, -1, -1, -1,
]);

export const starNames: readonly string[] = [
  "Sol",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alpheratz",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Caph",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Algenib",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ankaa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Fulu",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Schedar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Diphda",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "96 G. Psc",
  "",
  "",
  "",
  "",
  "",
  "Achird",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Castula",
  "Cih",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Wurren",
  "",
  "",
  "",
  "",
  "",
  "Mirach",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Revati",
  "",
  "Revati B",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Adhil",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ruchbah",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alpherg",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Titawin",
  "",
  "",
  "",
  "Achernar",
  "",
  "",
  "",
  "Nembus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "p Eridani",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Torcular",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Baten Kaitos",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mothallah",
  "",
  "",
  "Mesarthim",
  "",
  "",
  "",
  "",
  "Segin",
  "Sheratan",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alrescha",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Almach",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Hamal",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mira",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Polaris",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "268 G. Cet",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kaffaljidhma",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Lilii Borea",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bharani",
  "",
  "",
  "",
  "",
  "",
  "Miram",
  "",
  "Angetenar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Azha",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Acamar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Menkar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Algol",
  "",
  "",
  "",
  "",
  "",
  "Misam",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Botein",
  "",
  "",
  "Dalim",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zibal",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "82 G. Eri",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mirfak",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ran",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rana",
  "",
  "",
  "",
  "",
  "",
  "Atik",
  "",
  "",
  "",
  "",
  "",
  "Celaeno",
  "",
  "Electra",
  "",
  "",
  "",
  "Taygeta",
  "",
  "",
  "",
  "",
  "Maia",
  "Asterope",
  "",
  "",
  "",
  "",
  "",
  "",
  "Merope",
  "",
  "",
  "",
  "Alcyone",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Atlas",
  "Pleione",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zaurak",
  "",
  "",
  "",
  "",
  "Menkib",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Beid",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Keid",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Prima Hyadum",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Secunda Hyadum",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Beemim",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ain",
  "",
  "Chamukuy",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Theemin",
  "",
  "",
  "Aldebaran",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sceptrum",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tabit",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Hassaleh",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Almaaz",
  "",
  "",
  "",
  "",
  "Saclateni",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Haedus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Cursa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mago",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rigel",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Capella",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bellatrix",
  "",
  "",
  "",
  "",
  "",
  "Elnath",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nihal",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mintaka",
  "",
  "",
  "",
  "",
  "",
  "",
  "Arneb",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Meissa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Hatysa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alnilam",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tianguan",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Phact",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alnitak",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Saiph",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Wazn",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Betelgeuse",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Menkalinan",
  "Mahasim",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Elkurud",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Propus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Furud",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mirzam",
  "",
  "Tejat",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Canopus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alhena",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mebsuta",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sirius",
  "Alzirr",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Adhara",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Citalá",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nganurganity",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Muliphein",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mekbuda",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Wezen",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Wasat",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Aludra",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gomeisa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Castor",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Jishui",
  "",
  "Procyon",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Pollux",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Azmidi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Naos",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tureis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tegmine",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tarf",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Piautos",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Avior",
  "",
  "",
  "",
  "",
  "Alsciaukat",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Muscida",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Minchir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Meleph",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Asellus Borealis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Asellus Australis",
  "Alsephina",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ashlesha",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Copernicus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Acubens",
  "",
  "",
  "",
  "Talitha",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alkaphrah",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Suhail",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nahn",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Miaplacidus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Aspidiske",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Markeb",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alphard",
  "",
  "",
  "",
  "",
  "",
  "",
  "Intercrus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alterf",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ukdah",
  "",
  "",
  "",
  "",
  "Subra",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ras Elased Australis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zhang",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rasalas",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Felis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Regulus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Adhafera",
  "",
  "",
  "Tania Borealis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Algieba",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tania Australis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Praecipua",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Chalawan",
  "",
  "",
  "Alkes",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Merak",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Dubhe",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zosma",
  "Chertan",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alula Borealis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Giausar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Formosa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Taiyangshou",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Denebola",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zavijava",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Groombridge 1830",
  "",
  "Phecda",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tonatiuh",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alchiba",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Imai",
  "",
  "",
  "Megrez",
  "",
  "",
  "Gienah",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zaniah",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ginan",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Acrux",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Algorab",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gacrux",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Chara",
  "",
  "",
  "",
  "Kraz",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Porrima",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "La Superba",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tianyi",
  "Mimosa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alioth",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Taiyi",
  "Minelauva",
  "",
  "",
  "Cor Caroli B",
  "Cor Caroli",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Vindemiatrix",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Diadem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mizar",
  "",
  "",
  "",
  "",
  "",
  "",
  "Spica",
  "Alcor",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Heze",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alkaid",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Muphrid",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Hadar",
  "",
  "",
  "",
  "Thuban",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Menkent",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kang",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Arcturus",
  "Syrma",
  "",
  "",
  "",
  "Xuange",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Khambalia",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Elgafar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Seginus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Toliman",
  "Rigil Kentaurus",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Izar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Merga",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kochab",
  "Zubenelgenubi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nekkar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Brachium",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zubeneschamali",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Pherkad",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alkalurops",
  "",
  "Edasich",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nusakan",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alphecca",
  "",
  "",
  "",
  "",
  "Zubenelhakrabi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Unukalhai",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gudja",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Iklil",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Fang",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Dschubba",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Acrab",
  "Acrab B",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Marsic",
  "Marsic B",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Jabbah",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Yed Prior",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Yed Posterior",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alniyat",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Athebyne",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Cujam",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Antares",
  "",
  "",
  "",
  "",
  "",
  "Kornephoros",
  "",
  "",
  "",
  "",
  "Marfik",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Paikauhale",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Atria",
  "",
  "",
  "",
  "",
  "",
  "",
  "Larawag",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Xamidimura",
  "",
  "",
  "",
  "Pipirima",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Aldhibah",
  "",
  "",
  "",
  "",
  "",
  "Sabik",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rasalgethi",
  "Sarin",
  "",
  "",
  "",
  "Guniibuu",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rastaban",
  "",
  "",
  "Maasym",
  "Lesath",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Yildun",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Shaula",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rasalhague",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sargas",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Dziban",
  "Dziban B",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Cebalrai",
  "",
  "",
  "Alruba",
  "Cervantes",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Fuyue",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Grumium",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eltanin",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alnasl",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Polis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kaus Media",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kaus Australis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Fafnir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kaus Borealis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Vega",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Xihe",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sheliak",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ainalrami",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nunki",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alya",
  "Alya B",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sulafat",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ascella",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Okab",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Meridiana",
  "",
  "",
  "Albaldah",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Altais",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Aladfar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gumala",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Arkab Prior",
  "",
  "",
  "",
  "",
  "Arkab Posterior",
  "",
  "",
  "Rukbat",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Anser",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Albireo",
  "Albireo B",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alsafi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sham",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Fawaris",
  "",
  "",
  "",
  "",
  "",
  "Tarazed",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Altair",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Libertas",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alshain",
  "",
  "",
  "",
  "Terebellum",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Chechia",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Algedi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alshat",
  "",
  "",
  "Dabih",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sadr",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Peacock",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Aldulfin",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rotanev",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sualocin",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Deneb",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Aljanah",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Albali",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Musica",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Polaris Australis",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kitalpha",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alderamin",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alfirk",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sadalsuud",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bunda",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nashira",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Azelfafage",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Enif",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Deneb Algedi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Aldhanab",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kurhah",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sadalmelik",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alnair",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Biham",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ancha",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sadachbia",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Situla",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Homam",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tiaki",
  "",
  "",
  "Matar",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sadalbari",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Skat",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Helvetios",
  "",
  "Fomalhaut",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Scheat",
  "Fumalsamakah",
  "",
  "",
  "",
  "",
  "Markab",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Salm",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alkarab",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Veritate",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Errai",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "p Eridani",
  "",
  "",
  "",
  "",
  "",
  "Castor B",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alula Australis",
  "Alula Australis B",
  "",
  "",
  "",
  "",
  "",
  "",
  "Graffias",
  "",
  "",
  "Alrakis",
  "",
  "Guniibuu B",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
];

export const starDesignations: readonly string[] = [
  "",
  "",
  "",
  "",
  "",
  "",
  "Tau Phe",
  "",
  "",
  "The Oct",
  "",
  "",
  "",
  "29 Psc",
  "30 Psc",
  "85 Peg",
  "Zet Scl",
  "31 Psc",
  "32 Psc",
  "",
  "",
  "",
  "",
  "2 Cet",
  "",
  "9 Cas",
  "",
  "",
  "3 Cet",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "33 Psc",
  "86 Peg",
  "",
  "",
  "10 Cas",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alp And",
  "",
  "",
  "",
  "",
  "",
  "87 Peg",
  "",
  "Bet Cas",
  "",
  "Kap-1 Scl",
  "Eps Phe",
  "",
  "34 Psc",
  "Gam-3 Oct",
  "",
  "22 And",
  "",
  "6 Cet",
  "Kap-2 Scl",
  "The Scl",
  "",
  "",
  "",
  "Gam Peg",
  "",
  "",
  "23 And",
  "",
  "",
  "",
  "",
  "Chi Peg",
  "7 Cet",
  "",
  "",
  "",
  "35 Psc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "36 Psc",
  "",
  "",
  "The And",
  "",
  "",
  "",
  "",
  "",
  "Sig And",
  "",
  "",
  "26 And",
  "",
  "Iot Cet",
  "",
  "Zet Tuc",
  "",
  "",
  "41 Psc",
  "Pi Tuc",
  "",
  "Rho And",
  "",
  "Iot Scl",
  "",
  "42 Psc",
  "9 Cet",
  "",
  "",
  "",
  "43 Psc",
  "12 Cas",
  "",
  "44 Psc",
  "Bet Hyi",
  "Kap Phe",
  "Alp Phe",
  "",
  "10 Cet",
  "",
  "",
  "Eta Scl",
  "46 Psc",
  "47 Psc",
  "48 Psc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "12 Cet",
  "28 And",
  "",
  "",
  "",
  "",
  "",
  "Lam-1 Phe",
  "13 Cas",
  "",
  "Bet-1 Tuc",
  "Bet-2 Tuc",
  "",
  "Lam Cas",
  "51 Psc",
  "52 Psc",
  "Bet-3 Tuc",
  "",
  "Kap Cas",
  "",
  "",
  "The Tuc",
  "",
  "",
  "16 Cas",
  "",
  "",
  "13 Cet",
  "14 Cet",
  "",
  "Lam-2 Phe",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "53 Psc",
  "Pi And",
  "Zet Cas",
  "",
  "",
  "",
  "",
  "",
  "Eps And",
  "",
  "",
  "Del And",
  "54 Psc",
  "",
  "",
  "55 Psc",
  "",
  "",
  "Alp Cas",
  "",
  "",
  "32 And",
  "Mu Phe",
  "",
  "Xi Phe",
  "",
  "Xi Cas",
  "Rho Tuc",
  "",
  "",
  "Lam-1 Scl",
  "Eta Phe",
  "Pi Cas",
  "Bet Cet",
  "",
  "Phi-1 Cet",
  "Lam-2 Scl",
  "",
  "",
  "Omi Cas",
  "",
  "",
  "",
  "",
  "",
  "18 Cet",
  "21 Cas",
  "",
  "",
  "",
  "",
  "57 Psc",
  "",
  "",
  "58 Psc",
  "59 Psc",
  "Zet And",
  "60 Psc",
  "",
  "23 Cas",
  "",
  "",
  "62 Psc",
  "",
  "Lam Hyi",
  "Del Psc",
  "Nu Cas",
  "",
  "64 Psc",
  "Eta Cas",
  "",
  "",
  "",
  "Nu And",
  "65 Psc",
  "",
  "Phi-2 Cet",
  "",
  "Rho Phe",
  "",
  "",
  "",
  "",
  "",
  "",
  "20 Cet",
  "",
  "",
  "",
  "",
  "",
  "21 Cet",
  "66 Psc",
  "",
  "36 And",
  "Ups-1 Cas",
  "Lam-2 Tuc",
  "",
  "",
  "",
  "",
  "67 Psc",
  "Phi-3 Cet",
  "",
  "",
  "Ups-2 Cas",
  "Gam Cas",
  "Mu And",
  "",
  "",
  "Eta And",
  "",
  "",
  "68 Psc",
  "",
  "",
  "",
  "",
  "",
  "Alp Scl",
  "Phi-4 Cet",
  "",
  "",
  "",
  "Xi Scl",
  "",
  "",
  "Ome Phe",
  "",
  "Sig Scl",
  "",
  "Sig Psc",
  "",
  "39 And",
  "Eps Psc",
  "",
  "25 Cet",
  "",
  "",
  "26 Cet",
  "",
  "",
  "",
  "",
  "73 Psc",
  "72 Psc",
  "27 Cet",
  "Psi-1 Psc",
  "Psi-1 Psc",
  "77 Psc",
  "Bet Phe",
  "28 Cet",
  "",
  "76 Psc",
  "75 Psc",
  "",
  "",
  "",
  "Iot Tuc",
  "30 Cet",
  "Ups Phe",
  "Psi-2 Psc",
  "29 Cet",
  "41 And",
  "78 Psc",
  "Mu Cas",
  "80 Psc",
  "Zet Phe",
  "",
  "Eta Cet",
  "",
  "",
  "Phi And",
  "Bet And",
  "Psi-3 Psc",
  "",
  "",
  "32 Cet",
  "44 And",
  "",
  "33 Cet",
  "31 Cas",
  "The Cas",
  "82 Psc",
  "45 And",
  "",
  "Chi Psc",
  "",
  "Tau Psc",
  "32 Cas",
  "34 Cet",
  "",
  "",
  "",
  "",
  "",
  "Zet Psc",
  "Phi Psc",
  "Zet Psc",
  "",
  "87 Psc",
  "37 Cet",
  "88 Psc",
  "38 Cet",
  "Nu Phe",
  "Kap Tuc",
  "",
  "",
  "",
  "",
  "39 Cet",
  "",
  "",
  "",
  "89 Psc",
  "",
  "",
  "",
  "Ups Psc",
  "42 Cet",
  "Phi Cas",
  "",
  "",
  "",
  "35 Cas",
  "91 Psc",
  "",
  "Xi And",
  "",
  "43 Cet",
  "",
  "",
  "",
  "",
  "",
  "47 And",
  "",
  "The Cet",
  "44 Cet",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "46 Cet",
  "",
  "Del Cas",
  "",
  "Psi Cas",
  "",
  "Rho Psc",
  "",
  "",
  "",
  "94 Psc",
  "47 Cet",
  "",
  "",
  "",
  "Ome And",
  "",
  "Gam Phe",
  "",
  "",
  "48 Cet",
  "",
  "97 Psc",
  "49 And",
  "Mu Psc",
  "",
  "",
  "38 Cas",
  "Del Phe",
  "Eta Psc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Chi Cas",
  "",
  "49 Cet",
  "",
  "",
  "",
  "",
  "",
  "101 Psc",
  "",
  "",
  "",
  "50 Cet",
  "Tau Scl",
  "",
  "",
  "",
  "Ups And",
  "Pi Psc",
  "",
  "",
  "Alp Eri",
  "",
  "",
  "",
  "51 And",
  "",
  "",
  "40 Cas",
  "",
  "",
  "Chi And",
  "105 Psc",
  "",
  "",
  "Tau And",
  "",
  "",
  "",
  "Tau-1 Hyi",
  "Nu Psc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Pi Scl",
  "",
  "43 Cas",
  "",
  "107 Psc",
  "",
  "42 Cas",
  "",
  "",
  "44 Cas",
  "Phi Per",
  "",
  "",
  "Tau Cet",
  "",
  "",
  "",
  "",
  "109 Psc",
  "Omi Psc",
  "Eps Scl",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tau-2 Hyi",
  "",
  "",
  "4 Ari",
  "",
  "",
  "",
  "",
  "",
  "Chi Cet",
  "",
  "1 Ari",
  "",
  "",
  "",
  "",
  "",
  "Zet Cet",
  "",
  "",
  "1 Per",
  "2 Per",
  "",
  "",
  "Alp Tri",
  "55 And",
  "",
  "Gam-2 Ari",
  "Xi Psc",
  "Psi Phe",
  "",
  "Phi Phe",
  "Eps Cas",
  "Bet Ari",
  "",
  "Eta-2 Hyi",
  "",
  "",
  "",
  "Sig Hyi",
  "7 Ari",
  "",
  "",
  "Chi Eri",
  "Ome Cas",
  "56 And",
  "",
  "56 Cet",
  "",
  "",
  "",
  "Iot Ari",
  "",
  "",
  "Lam Ari",
  "",
  "",
  "",
  "3 Per",
  "Alp Hyi",
  "",
  "",
  "",
  "",
  "",
  "",
  "57 Cet",
  "Ups Cet",
  "112 Psc",
  "",
  "Pi For",
  "Chi Phe",
  "48 Cas",
  "Alp Psc",
  "4 Per",
  "",
  "",
  "",
  "52 Cas",
  "",
  "Eps Tri",
  "",
  "53 Cas",
  "",
  "60 Cet",
  "50 Cas",
  "10 Ari",
  "",
  "",
  "61 Cet",
  "Gam-1 And",
  "",
  "Nu For",
  "",
  "",
  "47 Cas",
  "49 Cas",
  "",
  "",
  "Kap Ari",
  "11 Ari",
  "",
  "Alp Ari",
  "",
  "58 And",
  "",
  "",
  "",
  "",
  "",
  "14 Ari",
  "",
  "Bet Tri",
  "",
  "",
  "",
  "",
  "",
  "15 Ari",
  "59 And",
  "16 Ari",
  "64 Cet",
  "",
  "5 Tri",
  "5 Per",
  "63 Cet",
  "",
  "6 Tri",
  "",
  "66 Cet",
  "Eta Ari",
  "",
  "Mu For",
  "Xi-1 Cet",
  "",
  "19 Ari",
  "60 And",
  "",
  "",
  "",
  "",
  "",
  "",
  "Pi-1 Hyi",
  "55 Cas",
  "",
  "",
  "Pi-2 Hyi",
  "21 Ari",
  "20 Ari",
  "7 Tri",
  "",
  "Phi Eri",
  "",
  "",
  "67 Cet",
  "Del Tri",
  "Gam Tri",
  "8 Per",
  "",
  "7 Per",
  "The Ari",
  "10 Tri",
  "",
  "",
  "",
  "62 And",
  "Omi Cet",
  "",
  "",
  "",
  "",
  "",
  "63 And",
  "Del Hyi",
  "",
  "69 Cet",
  "",
  "",
  "",
  "70 Cet",
  "9 Per",
  "Kap For",
  "",
  "Kap Hyi",
  "",
  "",
  "",
  "",
  "",
  "64 And",
  "",
  "Xi Ari",
  "Lam Hor",
  "71 Cet",
  "10 Per",
  "",
  "65 And",
  "Rho Cet",
  "",
  "",
  "Kap Eri",
  "",
  "",
  "11 Tri",
  "66 And",
  "",
  "Phi For",
  "",
  "Xi-2 Cet",
  "12 Tri",
  "",
  "13 Tri",
  "Iot Cas",
  "",
  "",
  "",
  "",
  "",
  "",
  "26 Ari",
  "",
  "27 Ari",
  "",
  "Mu Hyi",
  "Alp UMi",
  "Sig Cet",
  "14 Tri",
  "75 Cet",
  "",
  "",
  "29 Ari",
  "Lam-1 For",
  "",
  "Ome For",
  "",
  "77 Cet",
  "",
  "",
  "",
  "15 Tri",
  "Nu Cet",
  "80 Cet",
  "",
  "Iot-1 For",
  "",
  "31 Ari",
  "",
  "",
  "Lam-2 For",
  "30 Ari",
  "",
  "Eta Hor",
  "",
  "81 Cet",
  "",
  "",
  "",
  "Iot-2 For",
  "",
  "",
  "",
  "Nu Ari",
  "Del Cet",
  "Eps Cet",
  "Eps Hyi",
  "",
  "",
  "",
  "Zet Hor",
  "Iot Eri",
  "33 Ari",
  "84 Cet",
  "",
  "",
  "",
  "",
  "12 Per",
  "Mu Ari",
  "",
  "Iot Hor",
  "",
  "",
  "11 Per",
  "Gam Cet",
  "",
  "",
  "35 Ari",
  "",
  "",
  "14 Per",
  "Pi Cet",
  "",
  "The Per",
  "36 Ari",
  "",
  "Omi Ari",
  "",
  "Mu Cet",
  "38 Ari",
  "Tau-1 Eri",
  "",
  "Gam Hor",
  "Zet Hyi",
  "",
  "",
  "",
  "",
  "",
  "",
  "39 Ari",
  "40 Ari",
  "",
  "",
  "Nu Hor",
  "Bet For",
  "Pi Ari",
  "",
  "",
  "Gam-1 For",
  "Gam-2 For",
  "41 Ari",
  "Eta-2 For",
  "Nu Hyi",
  "16 Per",
  "",
  "Eta-3 For",
  "Eta Per",
  "",
  "Tau-2 Eri",
  "Sig Ari",
  "17 Per",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Psi For",
  "",
  "20 Per",
  "",
  "Tau Per",
  "Rho-2 Ari",
  "",
  "",
  "",
  "Eta Eri",
  "Rho-3 Ari",
  "",
  "",
  "",
  "",
  "",
  "21 Per",
  "4 Eri",
  "",
  "",
  "47 Ari",
  "6 Eri",
  "The-1 Eri",
  "",
  "Pi Per",
  "",
  "Bet Hor",
  "24 Per",
  "",
  "Eps Ari",
  "Zet For",
  "",
  "",
  "5 Eri",
  "Lam Cet",
  "",
  "",
  "",
  "7 Eri",
  "",
  "Rho-1 Eri",
  "Eps For",
  "",
  "49 Ari",
  "",
  "",
  "The Hyi",
  "Alp Cet",
  "93 Cet",
  "Tau-3 Eri",
  "Rho-2 Eri",
  "",
  "",
  "Mu Hor",
  "",
  "Rho-3 Eri",
  "",
  "",
  "Gam Per",
  "Rho Per",
  "",
  "",
  "52 Ari",
  "",
  "",
  "",
  "",
  "",
  "",
  "53 Ari",
  "",
  "",
  "",
  "",
  "",
  "Bet Per",
  "54 Ari",
  "",
  "",
  "Iot Per",
  "",
  "Kap Per",
  "55 Ari",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ome Per",
  "",
  "",
  "Del Ari",
  "",
  "",
  "Alp For",
  "",
  "56 Ari",
  "",
  "",
  "",
  "",
  "94 Cet",
  "",
  "",
  "",
  "Zet Ari",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet Eri",
  "Iot Hyi",
  "",
  "",
  "",
  "",
  "",
  "",
  "14 Eri",
  "",
  "",
  "",
  "",
  "Zet-1 Ret",
  "",
  "30 Per",
  "",
  "",
  "Zet-2 Ret",
  "15 Eri",
  "95 Cet",
  "29 Per",
  "",
  "",
  "31 Per",
  "Kap-1 Cet",
  "Tau-4 Eri",
  "",
  "",
  "59 Ari",
  "",
  "",
  "",
  "60 Ari",
  "",
  "Kap-2 Cet",
  "Tau-1 Ari",
  "",
  "32 Per",
  "",
  "",
  "62 Ari",
  "",
  "Tau-2 Ari",
  "",
  "",
  "",
  "",
  "",
  "",
  "64 Ari",
  "Alp Per",
  "65 Ari",
  "",
  "",
  "",
  "Omi Tau",
  "",
  "Chi-1 For",
  "",
  "",
  "",
  "",
  "Xi Tau",
  "",
  "Chi-2 For",
  "",
  "",
  "Chi-3 For",
  "",
  "",
  "66 Ari",
  "",
  "",
  "",
  "34 Per",
  "Kap Ret",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "4 Tau",
  "Sig Per",
  "",
  "",
  "17 Eri",
  "",
  "",
  "5 Tau",
  "",
  "",
  "",
  "",
  "",
  "",
  "36 Per",
  "",
  "6 Tau",
  "",
  "",
  "",
  "Eps Eri",
  "",
  "",
  "",
  "",
  "Tau-5 Eri",
  "",
  "",
  "7 Tau",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "20 Eri",
  "Psi Per",
  "",
  "",
  "10 Tau",
  "",
  "",
  "",
  "",
  "",
  "Tau For",
  "",
  "21 Eri",
  "",
  "",
  "",
  "",
  "12 Tau",
  "",
  "",
  "22 Eri",
  "11 Tau",
  "",
  "",
  "",
  "",
  "Del For",
  "13 Tau",
  "40 Per",
  "",
  "",
  "",
  "Del Per",
  "Del Eri",
  "",
  "14 Tau",
  "",
  "",
  "Bet Ret",
  "Omi Per",
  "",
  "24 Eri",
  "",
  "",
  "",
  "16 Tau",
  "",
  "17 Tau",
  "25 Eri",
  "18 Tau",
  "Nu Per",
  "19 Tau",
  "",
  "",
  "",
  "29 Tau",
  "20 Tau",
  "21 Tau",
  "",
  "",
  "",
  "22 Tau",
  "Pi Eri",
  "",
  "23 Tau",
  "Sig For",
  "Tau-6 Eri",
  "Gam Hyi",
  "Eta Tau",
  "",
  "Tau-7 Eri",
  "",
  "",
  "Rho For",
  "",
  "30 Tau",
  "",
  "",
  "",
  "",
  "",
  "26 Tau",
  "",
  "27 Tau",
  "28 Tau",
  "",
  "",
  "",
  "",
  "42 Per",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gam Cam",
  "",
  "",
  "",
  "31 Tau",
  "",
  "30 Eri",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tau-8 Eri",
  "",
  "Zet Per",
  "32 Eri",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "43 Per",
  "",
  "32 Tau",
  "",
  "33 Tau",
  "",
  "",
  "",
  "Eps Per",
  "Gam Eri",
  "",
  "",
  "Del Ret",
  "",
  "Xi Per",
  "",
  "",
  "Tau-9 Eri",
  "",
  "",
  "Lam Tau",
  "",
  "Gam Ret",
  "",
  "Iot Ret",
  "35 Eri",
  "",
  "",
  "Nu Tau",
  "",
  "40 Tau",
  "",
  "",
  "",
  "36 Tau",
  "",
  "",
  "",
  "37 Tau",
  "39 Tau",
  "",
  "",
  "",
  "",
  "Lam Per",
  "41 Tau",
  "",
  "",
  "Psi Tau",
  "",
  "",
  "",
  "",
  "49 Per",
  "50 Per",
  "48 Per",
  "",
  "Ome-1 Tau",
  "",
  "",
  "",
  "",
  "",
  "",
  "37 Eri",
  "",
  "",
  "44 Tau",
  "Del Hor",
  "",
  "45 Tau",
  "",
  "Omi-1 Eri",
  "",
  "",
  "",
  "",
  "",
  "46 Tau",
  "",
  "",
  "",
  "",
  "",
  "47 Tau",
  "",
  "Alp Hor",
  "39 Eri",
  "Alp Ret",
  "",
  "",
  "",
  "52 Per",
  "Mu Per",
  "",
  "Omi-2 Eri",
  "",
  "Mu Tau",
  "48 Tau",
  "Gam Dor",
  "",
  "Eps Ret",
  "",
  "",
  "",
  "Ome-2 Tau",
  "",
  "The Ret",
  "",
  "Ups-4 Eri",
  "Del Men",
  "",
  "",
  "",
  "51 Tau",
  "",
  "",
  "",
  "",
  "",
  "53 Tau",
  "56 Tau",
  "",
  "Gam Tau",
  "57 Tau",
  "",
  "",
  "",
  "Phi Tau",
  "54 Per",
  "",
  "58 Tau",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nu Men",
  "",
  "",
  "53 Per",
  "",
  "",
  "",
  "Eta Ret",
  "60 Tau",
  "",
  "Chi Tau",
  "Del-1 Tau",
  "",
  "",
  "",
  "63 Tau",
  "",
  "",
  "Xi Eri",
  "66 Tau",
  "62 Tau",
  "43 Eri",
  "Del-2 Tau",
  "",
  "",
  "55 Per",
  "56 Per",
  "",
  "",
  "",
  "Kap-1 Tau",
  "Kap-2 Tau",
  "Del-3 Tau",
  "70 Tau",
  "",
  "",
  "Ups Tau",
  "71 Tau",
  "",
  "Pi Tau",
  "",
  "",
  "",
  "",
  "",
  "72 Tau",
  "",
  "",
  "",
  "",
  "",
  "",
  "76 Tau",
  "75 Tau",
  "",
  "The-1 Tau",
  "Eps Tau",
  "",
  "The-2 Tau",
  "79 Tau",
  "",
  "",
  "",
  "",
  "",
  "80 Tau",
  "",
  "",
  "83 Tau",
  "",
  "81 Tau",
  "",
  "",
  "Del Cae",
  "84 Tau",
  "",
  "",
  "85 Tau",
  "45 Eri",
  "",
  "1 Cam",
  "",
  "",
  "",
  "57 Per",
  "",
  "Ups-1 Eri",
  "",
  "",
  "",
  "Rho Tau",
  "46 Eri",
  "Alp Dor",
  "",
  "47 Eri",
  "",
  "",
  "",
  "",
  "",
  "Ups-2 Eri",
  "88 Tau",
  "",
  "Alp Tau",
  "",
  "Nu Eri",
  "",
  "",
  "58 Per",
  "",
  "",
  "",
  "",
  "",
  "51 Eri",
  "89 Tau",
  "90 Tau",
  "53 Eri",
  "",
  "",
  "",
  "",
  "",
  "Sig-1 Tau",
  "Sig-2 Tau",
  "",
  "",
  "",
  "3 Cam",
  "2 Cam",
  "93 Tau",
  "",
  "54 Eri",
  "Alp Cae",
  "",
  "",
  "",
  "Bet Cae",
  "Tau Tau",
  "Lam Pic",
  "59 Per",
  "Mu Men",
  "",
  "95 Tau",
  "",
  "55 Eri",
  "",
  "",
  "56 Eri",
  "",
  "",
  "Kap Dor",
  "",
  "",
  "",
  "Mu Eri",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "58 Eri",
  "Zet Cae",
  "4 Cam",
  "",
  "59 Eri",
  "",
  "",
  "",
  "",
  "",
  "",
  "96 Tau",
  "Pi-3 Ori",
  "",
  "60 Eri",
  "",
  "",
  "Pi-2 Ori",
  "Iot Pic",
  "Iot Pic",
  "",
  "Pi-4 Ori",
  "97 Tau",
  "",
  "",
  "",
  "",
  "Omi-1 Ori",
  "2 Aur",
  "",
  "",
  "Ome Eri",
  "",
  "",
  "5 Ori",
  "",
  "Alp Cam",
  "Pi-5 Ori",
  "6 Ori",
  "",
  "",
  "",
  "",
  "Pi-1 Ori",
  "",
  "",
  "5 Cam",
  "",
  "Eta Men",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Omi-2 Ori",
  "62 Eri",
  "Iot Aur",
  "",
  "7 Cam",
  "",
  "",
  "99 Tau",
  "98 Tau",
  "",
  "Pi-6 Ori",
  "Xi Men",
  "",
  "",
  "Ome Aur",
  "8 Cam",
  "63 Eri",
  "64 Eri",
  "",
  "5 Aur",
  "",
  "6 Aur",
  "",
  "",
  "",
  "Psi Eri",
  "",
  "",
  "",
  "Eps Aur",
  "",
  "",
  "",
  "",
  "Zet Aur",
  "Bet Men",
  "1 Lep",
  "",
  "Eta-1 Pic",
  "",
  "Iot Tau",
  "",
  "Bet Cam",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gam-1 Cae",
  "Gam-2 Cae",
  "11 Ori",
  "",
  "",
  "Eta-2 Pic",
  "",
  "",
  "",
  "Eps Lep",
  "Zet Dor",
  "",
  "",
  "11 Cam",
  "",
  "12 Cam",
  "",
  "Eta Aur",
  "",
  "9 Aur",
  "66 Eri",
  "",
  "",
  "",
  "104 Tau",
  "",
  "13 Ori",
  "106 Tau",
  "",
  "Bet Eri",
  "14 Ori",
  "105 Tau",
  "103 Tau",
  "",
  "",
  "68 Eri",
  "Lam Eri",
  "16 Ori",
  "",
  "15 Ori",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Iot Lep",
  "",
  "",
  "Mu Lep",
  "",
  "Kap Lep",
  "Rho Ori",
  "",
  "Mu Aur",
  "14 Cam",
  "",
  "The Dor",
  "",
  "",
  "",
  "",
  "Bet Ori",
  "",
  "",
  "",
  "",
  "",
  "",
  "14 Aur",
  "",
  "108 Tau",
  "",
  "18 Ori",
  "",
  "",
  "",
  "Alp Aur",
  "Omi Col",
  "Tau Ori",
  "",
  "16 Aur",
  "",
  "",
  "17 Aur",
  "",
  "",
  "",
  "Lam Aur",
  "21 Ori",
  "",
  "109 Tau",
  "",
  "Zet Pic",
  "",
  "18 Aur",
  "15 Cam",
  "Lam Lep",
  "",
  "Nu Lep",
  "19 Aur",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "22 Ori",
  "",
  "Rho Aur",
  "",
  "Kap Pic",
  "",
  "23 Ori",
  "",
  "",
  "",
  "22 Aur",
  "",
  "16 Cam",
  "8 Lep",
  "",
  "110 Tau",
  "",
  "",
  "29 Ori",
  "111 Tau",
  "",
  "Eta Ori",
  "27 Ori",
  "",
  "",
  "",
  "Sig Aur",
  "",
  "Psi-1 Ori",
  "The Pic",
  "",
  "",
  "",
  "Gam Ori",
  "",
  "",
  "",
  "",
  "113 Tau",
  "Bet Tau",
  "Lam Dor",
  "",
  "",
  "Psi-2 Ori",
  "",
  "",
  "",
  "",
  "",
  "",
  "115 Tau",
  "",
  "",
  "",
  "114 Tau",
  "Phi Aur",
  "116 Tau",
  "",
  "",
  "117 Tau",
  "Bet Lep",
  "",
  "",
  "",
  "118 Tau",
  "",
  "",
  "",
  "31 Ori",
  "",
  "",
  "17 Cam",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "32 Ori",
  "",
  "10 Lep",
  "Eps Col",
  "33 Ori",
  "",
  "",
  "",
  "Gam Men",
  "Ups Ori",
  "Del Ori",
  "119 Tau",
  "",
  "18 Cam",
  "",
  "",
  "Chi Aur",
  "Alp Lep",
  "",
  "",
  "",
  "",
  "",
  "120 Tau",
  "Bet Dor",
  "",
  "",
  "",
  "35 Ori",
  "",
  "",
  "",
  "38 Ori",
  "",
  "",
  "Phi-1 Ori",
  "",
  "",
  "",
  "Lam Ori",
  "",
  "",
  "The-1 Ori",
  "The-1 Ori",
  "",
  "The-2 Ori",
  "42 Ori",
  "Iot Ori",
  "121 Tau",
  "",
  "Iot Men",
  "45 Ori",
  "",
  "",
  "",
  "Eps Ori",
  "",
  "",
  "",
  "",
  "Phi-2 Ori",
  "",
  "122 Tau",
  "",
  "",
  "Pi Men",
  "",
  "19 Cam",
  "",
  "Nu-1 Col",
  "",
  "",
  "Zet Tau",
  "Nu-2 Col",
  "",
  "",
  "",
  "",
  "",
  "26 Aur",
  "",
  "Sig Ori",
  "49 Ori",
  "",
  "",
  "Ome Ori",
  "",
  "",
  "",
  "",
  "",
  "Alp Col",
  "",
  "125 Tau",
  "",
  "",
  "",
  "",
  "Zet Ori",
  "",
  "",
  "",
  "126 Tau",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "12 Lep",
  "",
  "",
  "",
  "51 Ori",
  "",
  "24 Cam",
  "",
  "",
  "",
  "",
  "",
  "23 Cam",
  "Gam Lep",
  "",
  "Del Dor",
  "",
  "",
  "",
  "Omi Aur",
  "Mu Col",
  "",
  "",
  "26 Cam",
  "",
  "129 Tau",
  "",
  "Zet Lep",
  "",
  "",
  "",
  "131 Tau",
  "",
  "",
  "Bet Pic",
  "",
  "130 Tau",
  "",
  "",
  "",
  "133 Tau",
  "Kap Ori",
  "52 Ori",
  "",
  "",
  "132 Tau",
  "",
  "Tau Aur",
  "134 Tau",
  "",
  "",
  "Gam Pic",
  "",
  "Eps Dor",
  "",
  "",
  "Kap Men",
  "",
  "135 Tau",
  "",
  "",
  "",
  "Bet Col",
  "",
  "Ups Aur",
  "Del Lep",
  "55 Ori",
  "",
  "",
  "",
  "Nu Aur",
  "",
  "",
  "30 Cam",
  "",
  "137 Tau",
  "",
  "56 Ori",
  "",
  "",
  "",
  "",
  "Lam Col",
  "136 Tau",
  "",
  "",
  "",
  "",
  "Chi-1 Ori",
  "",
  "",
  "",
  "",
  "Xi Aur",
  "",
  "57 Ori",
  "31 Cam",
  "",
  "Alp Ori",
  "Xi Col",
  "",
  "",
  "",
  "Sig Col",
  "Eta Lep",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gam Col",
  "",
  "",
  "139 Tau",
  "",
  "59 Ori",
  "",
  "60 Ori",
  "",
  "1 Mon",
  "2 Mon",
  "Eta Col",
  "",
  "Del Aur",
  "Bet Aur",
  "The Aur",
  "",
  "",
  "Pi Aur",
  "",
  "",
  "",
  "",
  "36 Aur",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "3 Mon",
  "",
  "Mu Ori",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "38 Aur",
  "",
  "64 Ori",
  "Chi-2 Ori",
  "1 Gem",
  "",
  "",
  "",
  "",
  "",
  "63 Ori",
  "66 Ori",
  "17 Lep",
  "",
  "39 Aur",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "The Lep",
  "Eta-1 Dor",
  "",
  "",
  "40 Aur",
  "",
  "",
  "Pi-1 Col",
  "",
  "",
  "",
  "",
  "",
  "The Col",
  "Nu Ori",
  "19 Lep",
  "Pi-2 Col",
  "",
  "",
  "Nu Dor",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "3 Gem",
  "",
  "",
  "37 Cam",
  "",
  "Alp Men",
  "Del Pic",
  "",
  "",
  "",
  "",
  "39 Cam",
  "",
  "Eta-2 Dor",
  "",
  "5 Gem",
  "41 Aur",
  "",
  "",
  "",
  "Xi Ori",
  "68 Ori",
  "69 Ori",
  "",
  "36 Cam",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "71 Ori",
  "Gam Mon",
  "Eta Gem",
  "",
  "",
  "",
  "Kap Aur",
  "72 Ori",
  "",
  "",
  "",
  "",
  "40 Cam",
  "",
  "73 Ori",
  "",
  "",
  "",
  "8 Gem",
  "",
  "74 Ori",
  "Kap Col",
  "",
  "9 Gem",
  "",
  "",
  "75 Ori",
  "",
  "",
  "",
  "",
  "1 Lyn",
  "",
  "",
  "43 Aur",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "2 Lyn",
  "",
  "",
  "7 Mon",
  "",
  "",
  "Zet CMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "45 Aur",
  "4 Lyn",
  "Del Col",
  "",
  "Pi-1 Dor",
  "Bet CMa",
  "Nu Pic",
  "Mu Gem",
  "",
  "",
  "",
  "",
  "",
  "Eps Mon",
  "",
  "",
  "",
  "Alp Car",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Psi-1 Aur",
  "",
  "",
  "",
  "",
  "Pi-2 Dor",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "5 Lyn",
  "9 Mon",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "16 Gem",
  "10 Mon",
  "Lam CMa",
  "",
  "",
  "",
  "",
  "48 Aur",
  "",
  "",
  "",
  "Bet Mon",
  "Nu Gem",
  "",
  "",
  "",
  "47 Aur",
  "",
  "",
  "",
  "",
  "",
  "6 Lyn",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "19 Gem",
  "",
  "",
  "Xi-1 CMa",
  "Mu Pic",
  "20 Gem",
  "12 Mon",
  "",
  "",
  "",
  "",
  "",
  "",
  "13 Mon",
  "",
  "",
  "",
  "",
  "",
  "",
  "7 Lyn",
  "",
  "14 Mon",
  "",
  "Xi-2 CMa",
  "49 Aur",
  "",
  "",
  "",
  "",
  "",
  "Nu-1 CMa",
  "",
  "",
  "Nu-2 CMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "11 Lyn",
  "",
  "",
  "8 Lyn",
  "Gam Gem",
  "Nu Pup",
  "",
  "",
  "Nu-3 CMa",
  "",
  "",
  "",
  "",
  "53 Aur",
  "",
  "",
  "",
  "51 Aur",
  "Psi-3 Aur",
  "",
  "",
  "Psi-2 Aur",
  "",
  "54 Aur",
  "",
  "",
  "",
  "",
  "Zet Men",
  "",
  "",
  "",
  "15 Mon",
  "",
  "",
  "",
  "25 Gem",
  "",
  "",
  "",
  "",
  "",
  "26 Gem",
  "",
  "Psi-4 Aur",
  "",
  "",
  "",
  "",
  "",
  "Eps Gem",
  "30 Gem",
  "",
  "",
  "",
  "10 CMa",
  "28 Gem",
  "",
  "",
  "Alp CMa",
  "Xi Gem",
  "",
  "",
  "",
  "",
  "32 Gem",
  "",
  "",
  "12 Lyn",
  "",
  "16 Mon",
  "",
  "",
  "Psi-5 Aur",
  "13 Lyn",
  "11 CMa",
  "",
  "",
  "12 CMa",
  "",
  "17 Mon",
  "",
  "",
  "",
  "Psi-6 Aur",
  "18 Mon",
  "Alp Pic",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "33 Gem",
  "Kap CMa",
  "",
  "",
  "Tau Pup",
  "",
  "",
  "",
  "35 Gem",
  "",
  "",
  "Psi-7 Aur",
  "",
  "",
  "42 Cam",
  "Iot Vol",
  "",
  "36 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "The Gem",
  "",
  "",
  "59 Aur",
  "",
  "14 Lyn",
  "",
  "60 Aur",
  "",
  "",
  "",
  "15 CMa",
  "",
  "43 Cam",
  "",
  "Psi-8 Aur",
  "",
  "Omi-1 CMa",
  "",
  "The CMa",
  "",
  "",
  "38 Gem",
  "",
  "",
  "17 CMa",
  "",
  "",
  "37 Gem",
  "",
  "Pi CMa",
  "",
  "",
  "Mu CMa",
  "Iot CMa",
  "",
  "",
  "Psi-9 Aur",
  "The Men",
  "",
  "",
  "",
  "",
  "",
  "15 Lyn",
  "",
  "",
  "",
  "",
  "16 Lyn",
  "",
  "",
  "",
  "",
  "",
  "Eps CMa",
  "",
  "",
  "",
  "",
  "39 Gem",
  "",
  "62 Aur",
  "",
  "40 Gem",
  "",
  "",
  "",
  "",
  "41 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sig CMa",
  "",
  "",
  "",
  "",
  "Ome Gem",
  "",
  "",
  "19 Mon",
  "Omi-2 CMa",
  "",
  "",
  "",
  "",
  "Gam CMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet Gem",
  "",
  "",
  "",
  "",
  "44 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "45 Gem",
  "Del CMa",
  "",
  "Gam-1 Vol",
  "Gam-2 Vol",
  "",
  "",
  "",
  "",
  "",
  "",
  "20 Mon",
  "",
  "",
  "Tau Gem",
  "47 Gem",
  "21 Mon",
  "63 Aur",
  "",
  "",
  "",
  "Del Mon",
  "",
  "",
  "",
  "26 CMa",
  "",
  "",
  "48 Gem",
  "",
  "",
  "",
  "",
  "51 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "27 CMa",
  "",
  "",
  "",
  "",
  "",
  "52 Gem",
  "",
  "Ome CMa",
  "",
  "",
  "24 Mon",
  "",
  "",
  "",
  "",
  "",
  "",
  "18 Lyn",
  "53 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del Vol",
  "",
  "",
  "Pi Pup",
  "",
  "",
  "",
  "",
  "64 Aur",
  "",
  "",
  "Lam Gem",
  "",
  "",
  "",
  "",
  "29 CMa",
  "Tau CMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "56 Gem",
  "",
  "65 Aur",
  "",
  "",
  "",
  "47 Cam",
  "",
  "",
  "",
  "19 Lyn",
  "",
  "58 Gem",
  "57 Gem",
  "",
  "",
  "",
  "Eta CMa",
  "66 Aur",
  "",
  "",
  "59 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "1 CMi",
  "",
  "",
  "",
  "",
  "Eps Men",
  "Eps CMi",
  "",
  "Iot Gem",
  "",
  "",
  "",
  "",
  "",
  "21 Lyn",
  "61 Gem",
  "",
  "",
  "Bet CMi",
  "",
  "",
  "63 Gem",
  "",
  "",
  "",
  "Eta CMi",
  "Gam CMi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rho Gem",
  "Sig Pup",
  "",
  "64 Gem",
  "",
  "",
  "",
  "6 CMi",
  "65 Gem",
  "",
  "22 Lyn",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del-1 CMi",
  "",
  "",
  "Del-2 CMi",
  "",
  "",
  "",
  "",
  "68 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del-3 CMi",
  "",
  "",
  "Alp Gem",
  "",
  "",
  "",
  "",
  "",
  "Ups Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "25 Mon",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "70 Gem",
  "",
  "",
  "",
  "Omi Gem",
  "",
  "Alp CMi",
  "",
  "",
  "",
  "74 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "23 Lyn",
  "",
  "",
  "Alp Mon",
  "",
  "",
  "",
  "",
  "Zet Vol",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "24 Lyn",
  "",
  "",
  "Sig Gem",
  "",
  "",
  "1 Pup",
  "",
  "",
  "3 Pup",
  "",
  "76 Gem",
  "",
  "",
  "",
  "",
  "Kap Gem",
  "",
  "",
  "",
  "",
  "",
  "Bet Gem",
  "2 Pup",
  "",
  "",
  "4 Pup",
  "",
  "81 Gem",
  "",
  "11 CMi",
  "49 Cam",
  "",
  "",
  "51 Cam",
  "",
  "",
  "",
  "",
  "",
  "Pi Gem",
  "",
  "",
  "",
  "5 Pup",
  "Omi Pup",
  "",
  "",
  "",
  "82 Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Xi Pup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "6 Pup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "8 Pup",
  "Zet CMi",
  "",
  "9 Pup",
  "",
  "",
  "",
  "",
  "",
  "10 Pup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Phi Gem",
  "",
  "25 Lyn",
  "",
  "26 Lyn",
  "",
  "",
  "",
  "",
  "85 Gem",
  "",
  "",
  "",
  "",
  "",
  "Chi Car",
  "11 Pup",
  "",
  "",
  "1 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "14 CMi",
  "",
  "",
  "",
  "",
  "12 Pup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "27 Mon",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "3 Cnc",
  "",
  "",
  "Ome-1 Cnc",
  "",
  "",
  "28 Mon",
  "",
  "",
  "",
  "5 Cnc",
  "",
  "",
  "53 Cam",
  "Ome-2 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Chi Gem",
  "Zet Pup",
  "",
  "",
  "14 Pup",
  "",
  "",
  "",
  "",
  "",
  "8 Cnc",
  "",
  "",
  "",
  "",
  "Mu-1 Cnc",
  "",
  "",
  "",
  "28 Lyn",
  "",
  "",
  "Rho Pup",
  "Mu-2 Cnc",
  "Eps Vol",
  "",
  "27 Lyn",
  "Zet Mon",
  "",
  "12 Cnc",
  "",
  "",
  "",
  "16 Pup",
  "",
  "",
  "",
  "",
  "Gam-2 Vel",
  "",
  "",
  "",
  "",
  "",
  "",
  "13 Cnc",
  "",
  "Psi Cnc",
  "18 Pup",
  "",
  "",
  "",
  "19 Pup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet-2 Cnc",
  "",
  "",
  "",
  "",
  "15 Cnc",
  "20 Pup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet Cnc",
  "",
  "21 Pup",
  "",
  "",
  "29 Lyn",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alp Cha",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kap-1 Vol",
  "",
  "Kap-2 Vol",
  "Chi Cnc",
  "",
  "",
  "",
  "30 Lyn",
  "",
  "",
  "Lam Cnc",
  "The Cha",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eta Vol",
  "",
  "",
  "Eps Car",
  "",
  "",
  "22 Pup",
  "",
  "31 Lyn",
  "",
  "",
  "",
  "20 Cnc",
  "",
  "21 Cnc",
  "",
  "",
  "1 Hya",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet Vol",
  "25 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "2 Hya",
  "Phi-1 Cnc",
  "",
  "27 Cnc",
  "Phi-2 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "28 Cnc",
  "29 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Omi UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ups-1 Cnc",
  "",
  "The Cnc",
  "",
  "",
  "",
  "",
  "34 Cnc",
  "",
  "",
  "Eta Cnc",
  "",
  "",
  "",
  "",
  "Ups-2 Cnc",
  "",
  "",
  "",
  "32 Lyn",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "2 UMa",
  "",
  "33 Lyn",
  "",
  "",
  "",
  "",
  "3 Hya",
  "",
  "",
  "",
  "",
  "",
  "36 Cnc",
  "",
  "",
  "",
  "Del Hya",
  "Eta Pyx",
  "",
  "",
  "",
  "",
  "Sig Hya",
  "",
  "The Vol",
  "",
  "",
  "Pi-1 UMa",
  "",
  "",
  "",
  "",
  "",
  "Zet Pyx",
  "",
  "",
  "6 Hya",
  "Bet Pyx",
  "39 Cnc",
  "Pi-2 UMa",
  "",
  "Omi Vel",
  "",
  "",
  "",
  "Eps Cnc",
  "",
  "",
  "",
  "",
  "34 Lyn",
  "",
  "",
  "Eta Cha",
  "9 Hya",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "45 Cnc",
  "Eta Hya",
  "Gam Cnc",
  "Alp Pyx",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del Cnc",
  "Del Vel",
  "49 Cnc",
  "",
  "",
  "10 Hya",
  "",
  "",
  "46 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "12 Hya",
  "",
  "",
  "Iot Cnc",
  "",
  "Eps Hya",
  "",
  "50 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rho Hya",
  "",
  "",
  "14 Hya",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gam Pyx",
  "",
  "",
  "",
  "",
  "54 Cnc",
  "15 Hya",
  "",
  "",
  "",
  "35 Lyn",
  "",
  "",
  "",
  "",
  "53 Cnc",
  "",
  "Sig-1 Cnc",
  "Rho-1 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "5 UMa",
  "",
  "",
  "",
  "",
  "57 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet Hya",
  "17 Hya",
  "Del Pyx",
  "Rho-2 Cnc",
  "",
  "60 Cnc",
  "",
  "",
  "",
  "",
  "",
  "6 UMa",
  "Zet Oct",
  "",
  "Sig-2 Cnc",
  "",
  "",
  "Omi-1 Cnc",
  "Omi-2 Cnc",
  "",
  "",
  "61 Cnc",
  "Alp Cnc",
  "",
  "",
  "",
  "Iot UMa",
  "",
  "",
  "",
  "Sig-3 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "66 Cnc",
  "",
  "",
  "",
  "67 Cnc",
  "",
  "",
  "Alp Vol",
  "Rho UMa",
  "Nu Cnc",
  "",
  "",
  "Kap UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ome Hya",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kap Cnc",
  "Lam Vel",
  "Tau Cnc",
  "Kap Pyx",
  "",
  "Sig-1 UMa",
  "19 Hya",
  "",
  "",
  "75 Cnc",
  "",
  "15 UMa",
  "",
  "",
  "Xi Cnc",
  "20 Hya",
  "",
  "",
  "Eps Pyx",
  "",
  "79 Cnc",
  "Sig-2 UMa",
  "",
  "Tau UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Pi-1 Cnc",
  "21 Hya",
  "",
  "",
  "",
  "Bet Car",
  "",
  "",
  "",
  "",
  "",
  "36 Lyn",
  "",
  "",
  "",
  "16 UMa",
  "The Hya",
  "",
  "",
  "Pi-2 Cnc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "17 UMa",
  "",
  "",
  "18 UMa",
  "",
  "",
  "24 Hya",
  "23 Hya",
  "",
  "",
  "Iot Car",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "38 Lyn",
  "",
  "",
  "26 Hya",
  "",
  "",
  "27 Hya",
  "",
  "",
  "",
  "",
  "",
  "Alp Lyn",
  "",
  "",
  "The Pyx",
  "",
  "",
  "",
  "Kap Vel",
  "",
  "Lam Pyx",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Iot Cha",
  "",
  "",
  "Kap Leo",
  "",
  "",
  "28 Hya",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alp Hya",
  "",
  "",
  "",
  "Ome Leo",
  "3 Leo",
  "",
  "",
  "",
  "",
  "Tau-1 Hya",
  "",
  "Eps Ant",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Psi Vel",
  "7 LMi",
  "Zet-1 Ant",
  "",
  "23 UMa",
  "Zet-2 Ant",
  "8 LMi",
  "",
  "",
  "",
  "",
  "Lam Leo",
  "",
  "Xi Leo",
  "6 Leo",
  "Tau-2 Hya",
  "",
  "",
  "",
  "",
  "The UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "9 LMi",
  "",
  "Zet Cha",
  "",
  "",
  "10 LMi",
  "",
  "24 UMa",
  "33 Hya",
  "26 UMa",
  "22 UMa",
  "",
  "",
  "",
  "11 LMi",
  "7 Leo",
  "",
  "",
  "",
  "",
  "",
  "",
  "8 Leo",
  "",
  "",
  "",
  "10 Leo",
  "",
  "",
  "",
  "34 Hya",
  "",
  "",
  "42 Lyn",
  "",
  "",
  "",
  "",
  "37 Hya",
  "Iot Hya",
  "Kap Hya",
  "",
  "",
  "",
  "Omi Leo",
  "",
  "",
  "",
  "13 Leo",
  "",
  "43 Lyn",
  "",
  "",
  "",
  "",
  "13 LMi",
  "",
  "27 UMa",
  "",
  "",
  "15 Leo",
  "",
  "Psi Leo",
  "The Ant",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eps Leo",
  "",
  "",
  "Nu Cha",
  "18 Leo",
  "",
  "",
  "",
  "Ups Car",
  "",
  "",
  "19 Leo",
  "",
  "",
  "",
  "20 Leo",
  "",
  "",
  "",
  "4 Sex",
  "",
  "",
  "Ups UMa",
  "",
  "23 Leo",
  "",
  "6 Sex",
  "",
  "",
  "Ups-1 Hya",
  "",
  "",
  "22 Leo",
  "",
  "Phi UMa",
  "",
  "7 Sex",
  "Gam Sex",
  "Mu Leo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "31 UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "Phi Vel",
  "",
  "",
  "",
  "",
  "19 LMi",
  "",
  "",
  "",
  "",
  "Nu Leo",
  "",
  "",
  "Eta Ant",
  "",
  "",
  "",
  "Pi Leo",
  "",
  "Mu-1 Cha",
  "20 LMi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "13 Sex",
  "",
  "",
  "",
  "",
  "Ups-2 Hya",
  "",
  "",
  "",
  "",
  "",
  "14 Sex",
  "",
  "Eta Leo",
  "21 LMi",
  "",
  "31 Leo",
  "Alp Sex",
  "",
  "",
  "",
  "Alp Leo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "17 Sex",
  "Lam Hya",
  "",
  "18 Sex",
  "",
  "",
  "",
  "",
  "34 Leo",
  "",
  "",
  "",
  "",
  "19 Sex",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ome Car",
  "",
  "",
  "",
  "",
  "",
  "",
  "22 LMi",
  "",
  "",
  "",
  "",
  "",
  "",
  "23 LMi",
  "24 LMi",
  "35 Leo",
  "",
  "37 Leo",
  "Zet Leo",
  "",
  "",
  "Lam UMa",
  "39 Leo",
  "",
  "Eps Sex",
  "32 UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "40 Leo",
  "Gam-1 Leo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "42 Leo",
  "",
  "",
  "",
  "",
  "Mu UMa",
  "",
  "43 Leo",
  "27 LMi",
  "",
  "25 Sex",
  "24 Sex",
  "",
  "",
  "",
  "",
  "",
  "",
  "28 LMi",
  "",
  "",
  "",
  "",
  "44 Leo",
  "",
  "",
  "29 LMi",
  "30 LMi",
  "Mu Hya",
  "",
  "26 Sex",
  "",
  "",
  "Alp Ant",
  "",
  "",
  "",
  "45 Leo",
  "",
  "Bet LMi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del Sex",
  "",
  "Del Ant",
  "",
  "35 UMa",
  "32 LMi",
  "",
  "Bet Sex",
  "",
  "",
  "36 UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "33 LMi",
  "",
  "",
  "",
  "46 Leo",
  "",
  "",
  "Rho Leo",
  "",
  "",
  "",
  "34 LMi",
  "44 Hya",
  "",
  "48 Leo",
  "",
  "49 Leo",
  "",
  "37 UMa",
  "",
  "",
  "",
  "Gam Cha",
  "",
  "",
  "",
  "",
  "Phi-2 Hya",
  "",
  "35 LMi",
  "",
  "",
  "",
  "",
  "",
  "",
  "36 LMi",
  "",
  "Phi-3 Hya",
  "37 LMi",
  "",
  "",
  "",
  "",
  "",
  "",
  "38 LMi",
  "",
  "",
  "",
  "",
  "",
  "",
  "33 Sex",
  "",
  "",
  "38 UMa",
  "",
  "",
  "",
  "",
  "",
  "The Car",
  "40 LMi",
  "",
  "35 Sex",
  "41 LMi",
  "",
  "",
  "39 UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "36 Sex",
  "Del-1 Cha",
  "Del-2 Cha",
  "42 LMi",
  "",
  "",
  "",
  "41 UMa",
  "51 Leo",
  "52 Leo",
  "",
  "",
  "Mu Vel",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "43 LMi",
  "53 Leo",
  "",
  "",
  "Nu Hya",
  "",
  "44 LMi",
  "",
  "41 Sex",
  "",
  "43 UMa",
  "42 UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "46 LMi",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "44 UMa",
  "",
  "",
  "Ome UMa",
  "",
  "",
  "48 LMi",
  "",
  "",
  "",
  "",
  "",
  "54 Leo",
  "55 Leo",
  "46 UMa",
  "56 Leo",
  "",
  "",
  "50 LMi",
  "Iot Ant",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eta Oct",
  "",
  "47 UMa",
  "",
  "",
  "Alp Crt",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "58 Leo",
  "",
  "",
  "59 Leo",
  "49 UMa",
  "",
  "",
  "61 Leo",
  "Bet UMa",
  "",
  "60 Leo",
  "",
  "",
  "",
  "",
  "",
  "",
  "62 Leo",
  "Alp UMa",
  "",
  "51 UMa",
  "",
  "",
  "Chi Leo",
  "",
  "Chi-1 Hya",
  "",
  "Chi-2 Hya",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "65 Leo",
  "",
  "",
  "64 Leo",
  "",
  "",
  "",
  "",
  "67 Leo",
  "",
  "",
  "Psi UMa",
  "",
  "",
  "",
  "Bet Crt",
  "",
  "",
  "",
  "",
  "",
  "",
  "Psi Crt",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "69 Leo",
  "",
  "Del Leo",
  "The Leo",
  "",
  "72 Leo",
  "",
  "73 Leo",
  "",
  "Phi Leo",
  "",
  "",
  "",
  "",
  "75 Leo",
  "",
  "",
  "Nu UMa",
  "",
  "76 Leo",
  "55 UMa",
  "",
  "Del Crt",
  "",
  "",
  "",
  "",
  "Pi Cen",
  "Sig Leo",
  "",
  "",
  "",
  "56 UMa",
  "",
  "",
  "",
  "",
  "",
  "Lam Crt",
  "Iot Leo",
  "",
  "79 Leo",
  "",
  "",
  "Eps Crt",
  "Gam Crt",
  "",
  "",
  "",
  "81 Leo",
  "",
  "80 Leo",
  "",
  "",
  "",
  "83 Leo",
  "",
  "Kap Crt",
  "",
  "Tau Leo",
  "",
  "",
  "",
  "57 UMa",
  "",
  "",
  "",
  "85 Leo",
  "",
  "87 Leo",
  "",
  "86 Leo",
  "58 UMa",
  "",
  "",
  "Lam Dra",
  "88 Leo",
  "Omi-1 Cen",
  "",
  "Omi-2 Cen",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Xi Hya",
  "",
  "",
  "",
  "",
  "89 Leo",
  "",
  "90 Leo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Lam Cen",
  "",
  "2 Dra",
  "",
  "",
  "",
  "",
  "The Crt",
  "Ups Leo",
  "",
  "",
  "Pi Cha",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "59 UMa",
  "",
  "Ome Vir",
  "",
  "60 UMa",
  "Iot Crt",
  "",
  "",
  "",
  "",
  "",
  "",
  "Omi Hya",
  "",
  "",
  "",
  "92 Leo",
  "",
  "",
  "61 UMa",
  "",
  "",
  "62 UMa",
  "",
  "",
  "",
  "",
  "3 Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet Crt",
  "",
  "Xi Vir",
  "Lam Mus",
  "",
  "Nu Vir",
  "Chi UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "4 Vir",
  "93 Leo",
  "Mu Mus",
  "",
  "",
  "",
  "",
  "Bet Leo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet Hya",
  "",
  "",
  "Gam UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "6 Vir",
  "",
  "",
  "95 Leo",
  "",
  "66 UMa",
  "Eta Crt",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eps Cha",
  "7 Vir",
  "",
  "",
  "",
  "",
  "",
  "Pi Vir",
  "",
  "",
  "",
  "67 UMa",
  "",
  "",
  "",
  "",
  "The-1 Cru",
  "",
  "",
  "",
  "2 Com",
  "",
  "The-2 Cru",
  "",
  "",
  "",
  "Kap Cha",
  "",
  "Omi Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eta Cru",
  "",
  "",
  "",
  "Del Cen",
  "",
  "Alp Crv",
  "",
  "",
  "10 Vir",
  "",
  "",
  "11 Vir",
  "Eps Crv",
  "3 Com",
  "",
  "",
  "",
  "",
  "3 Crv",
  "",
  "",
  "Rho Cen",
  "68 UMa",
  "4 Com",
  "",
  "5 Com",
  "",
  "",
  "",
  "",
  "",
  "12 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del Cru",
  "",
  "",
  "Del UMa",
  "",
  "",
  "Gam Crv",
  "6 Com",
  "2 CVn",
  "7 Com",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eps Mus",
  "",
  "",
  "Bet Cha",
  "Zet Cru",
  "",
  "13 Vir",
  "",
  "",
  "",
  "8 Com",
  "9 Com",
  "3 CVn",
  "Eta Vir",
  "",
  "",
  "",
  "16 Vir",
  "",
  "Zet Crv",
  "",
  "11 Com",
  "",
  "70 UMa",
  "",
  "Eps Cru",
  "",
  "",
  "Zet-2 Mus",
  "",
  "Zet-1 Mus",
  "12 Com",
  "17 Vir",
  "",
  "",
  "",
  "",
  "6 Crv",
  "",
  "",
  "",
  "4 CVn",
  "",
  "5 CVn",
  "13 Com",
  "",
  "",
  "71 UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "6 CVn",
  "14 Com",
  "",
  "",
  "Alp-1 Cru",
  "",
  "",
  "Gam Com",
  "16 Com",
  "",
  "",
  "",
  "73 UMa",
  "",
  "",
  "",
  "Sig Cen",
  "",
  "",
  "",
  "",
  "17 Com",
  "18 Com",
  "20 Com",
  "Del Crv",
  "",
  "74 UMa",
  "",
  "7 CVn",
  "75 UMa",
  "",
  "4 Dra",
  "",
  "",
  "21 Com",
  "Gam Cru",
  "",
  "",
  "",
  "",
  "",
  "Eta Crv",
  "",
  "Gam Mus",
  "",
  "",
  "20 Vir",
  "",
  "Kap Dra",
  "22 Com",
  "",
  "",
  "Bet CVn",
  "21 Vir",
  "",
  "",
  "Bet Crv",
  "",
  "6 Dra",
  "23 Com",
  "",
  "24 Com",
  "",
  "",
  "",
  "",
  "",
  "",
  "25 Vir",
  "25 Com",
  "Alp Mus",
  "",
  "Tau Cen",
  "",
  "",
  "",
  "9 CVn",
  "",
  "",
  "",
  "26 Com",
  "",
  "Chi Vir",
  "",
  "",
  "",
  "",
  "",
  "Gam Cen",
  "76 UMa",
  "27 Vir",
  "Gam Vir",
  "",
  "Rho Vir",
  "",
  "31 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "10 CVn",
  "",
  "",
  "32 Vir",
  "Iot Cru",
  "Bet Mus",
  "33 Vir",
  "",
  "27 Com",
  "",
  "",
  "34 Vir",
  "",
  "",
  "7 Dra",
  "Bet Cru",
  "35 Vir",
  "",
  "28 Com",
  "",
  "",
  "11 CVn",
  "",
  "29 Com",
  "",
  "",
  "30 Com",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "37 Vir",
  "31 Com",
  "",
  "",
  "",
  "32 Com",
  "",
  "",
  "",
  "",
  "38 Vir",
  "35 Com",
  "",
  "",
  "",
  "",
  "Kap Cru",
  "41 Vir",
  "Eps UMa",
  "",
  "",
  "Psi Vir",
  "Mu-1 Cru",
  "Mu-2 Cru",
  "Lam Cru",
  "",
  "Iot Oct",
  "",
  "",
  "8 Dra",
  "Del Vir",
  "",
  "",
  "Alp-1 CVn",
  "Alp-2 CVn",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "36 Com",
  "44 Vir",
  "9 Dra",
  "37 Com",
  "",
  "46 Vir",
  "",
  "78 UMa",
  "38 Com",
  "",
  "Eps Vir",
  "Del Mus",
  "",
  "",
  "Xi-1 Cen",
  "",
  "",
  "",
  "",
  "",
  "14 CVn",
  "",
  "",
  "39 Com",
  "40 Com",
  "",
  "",
  "",
  "Xi-2 Cen",
  "41 Com",
  "",
  "",
  "",
  "49 Vir",
  "The Mus",
  "",
  "",
  "",
  "Psi Hya",
  "",
  "",
  "",
  "15 CVn",
  "50 Vir",
  "",
  "The Vir",
  "Alp Com",
  "17 CVn",
  "",
  "",
  "",
  "",
  "",
  "Bet Com",
  "",
  "",
  "53 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "54 Vir",
  "",
  "",
  "",
  "55 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eta Mus",
  "",
  "19 CVn",
  "57 Vir",
  "",
  "",
  "",
  "",
  "59 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "20 CVn",
  "Sig Vir",
  "21 CVn",
  "61 Vir",
  "",
  "",
  "",
  "Gam Hya",
  "",
  "",
  "23 CVn",
  "",
  "Iot Cen",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "64 Vir",
  "",
  "",
  "",
  "",
  "63 Vir",
  "",
  "",
  "65 Vir",
  "",
  "",
  "Zet UMa",
  "",
  "",
  "",
  "66 Vir",
  "",
  "Iot-1 Mus",
  "Alp Vir",
  "80 UMa",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "68 Vir",
  "",
  "",
  "",
  "",
  "",
  "69 Vir",
  "",
  "",
  "70 Vir",
  "",
  "",
  "",
  "",
  "",
  "71 Vir",
  "",
  "",
  "",
  "",
  "72 Vir",
  "",
  "",
  "",
  "74 Vir",
  "73 Vir",
  "",
  "",
  "",
  "",
  "75 Vir",
  "76 Vir",
  "",
  "81 UMa",
  "78 Vir",
  "",
  "24 CVn",
  "",
  "",
  "Zet Vir",
  "",
  "",
  "",
  "80 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "25 CVn",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "82 UMa",
  "",
  "",
  "",
  "Eps Cen",
  "",
  "",
  "",
  "",
  "",
  "",
  "1 Boo",
  "83 UMa",
  "Kap Oct",
  "2 Boo",
  "",
  "82 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "84 Vir",
  "",
  "",
  "",
  "",
  "83 Vir",
  "",
  "",
  "",
  "85 Vir",
  "",
  "1 Cen",
  "86 Vir",
  "",
  "",
  "",
  "84 UMa",
  "",
  "3 Boo",
  "",
  "",
  "",
  "",
  "",
  "Tau Boo",
  "87 Vir",
  "",
  "Eta UMa",
  "",
  "",
  "2 Cen",
  "Ups Boo",
  "Nu Cen",
  "Mu Cen",
  "6 Boo",
  "",
  "",
  "89 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "10 Dra",
  "",
  "",
  "",
  "",
  "3 Cen",
  "",
  "",
  "",
  "",
  "",
  "4 Cen",
  "7 Boo",
  "",
  "",
  "86 UMa",
  "",
  "",
  "",
  "Eta Boo",
  "90 Vir",
  "",
  "",
  "",
  "Zet Cen",
  "",
  "",
  "",
  "",
  "",
  "92 Vir",
  "",
  "9 Boo",
  "",
  "",
  "",
  "",
  "Phi Cen",
  "47 Hya",
  "",
  "10 Boo",
  "",
  "Ups-1 Cen",
  "",
  "",
  "48 Hya",
  "",
  "",
  "",
  "11 Boo",
  "",
  "",
  "",
  "Tau Vir",
  "Ups-2 Cen",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet Cen",
  "",
  "",
  "",
  "Alp Dra",
  "",
  "",
  "The Aps",
  "",
  "Chi Cen",
  "",
  "Pi Hya",
  "",
  "The Cen",
  "95 Vir",
  "3 UMi",
  "",
  "",
  "",
  "",
  "13 Boo",
  "",
  "",
  "4 UMi",
  "",
  "",
  "96 Vir",
  "",
  "",
  "12 Boo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "50 Hya",
  "Kap Vir",
  "",
  "",
  "Kap-2 Boo",
  "",
  "",
  "14 Boo",
  "",
  "",
  "",
  "",
  "",
  "15 Boo",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alp Boo",
  "Iot Vir",
  "",
  "Iot Boo",
  "",
  "Lam Boo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eta Aps",
  "",
  "",
  "",
  "Lam Vir",
  "",
  "18 Boo",
  "",
  "Iot Lup",
  "Ups Vir",
  "",
  "20 Boo",
  "",
  "",
  "",
  "",
  "",
  "",
  "Psi Cen",
  "",
  "",
  "",
  "Eps Aps",
  "",
  "",
  "",
  "51 Hya",
  "",
  "",
  "",
  "",
  "",
  "2 Lib",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "The Boo",
  "",
  "",
  "",
  "",
  "Tau-1 Lup",
  "Tau-2 Lup",
  "",
  "22 Boo",
  "",
  "Del Oct",
  "",
  "",
  "104 Vir",
  "5 UMi",
  "52 Hya",
  "Phi Vir",
  "",
  "24 Boo",
  "106 Vir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rho Boo",
  "Gam Boo",
  "",
  "",
  "26 Boo",
  "Sig Lup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sig Boo",
  "",
  "",
  "Eta Cen",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rho Lup",
  "",
  "",
  "",
  "",
  "33 Boo",
  "",
  "",
  "Alp-2 Cen",
  "Alp-1 Cen",
  "",
  "",
  "",
  "Pi-1 Boo",
  "",
  "Zet Boo",
  "31 Boo",
  "32 Boo",
  "",
  "",
  "Alp Lup",
  "",
  "",
  "",
  "",
  "Alp Cir",
  "Mu Vir",
  "4 Lib",
  "34 Boo",
  "",
  "",
  "",
  "",
  "",
  "Eps Boo",
  "",
  "",
  "",
  "Omi Boo",
  "",
  "",
  "",
  "108 Vir",
  "5 Lib",
  "54 Hya",
  "",
  "",
  "",
  "109 Vir",
  "",
  "",
  "",
  "",
  "",
  "55 Hya",
  "",
  "56 Hya",
  "Alp Aps",
  "",
  "57 Hya",
  "",
  "",
  "",
  "",
  "",
  "",
  "38 Boo",
  "",
  "Mu Lib",
  "",
  "",
  "39 Boo",
  "",
  "",
  "58 Hya",
  "",
  "",
  "Alp-1 Lib",
  "Bet UMi",
  "Alp-2 Lib",
  "",
  "11 Lib",
  "Xi Boo",
  "",
  "",
  "Omi Lup",
  "10 Lib",
  "",
  "",
  "",
  "",
  "",
  "",
  "12 Lib",
  "Xi-1 Lib",
  "",
  "Zet Cir",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "The Cir",
  "Xi-2 Lib",
  "",
  "16 Lib",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet Lup",
  "",
  "59 Hya",
  "",
  "18 Lib",
  "Kap Cen",
  "",
  "",
  "",
  "40 Boo",
  "",
  "",
  "",
  "",
  "Del Lib",
  "",
  "",
  "",
  "",
  "Pi-1 Oct",
  "Bet Boo",
  "",
  "60 Hya",
  "Ome Boo",
  "",
  "110 Vir",
  "",
  "",
  "44 Boo",
  "",
  "Sig Lib",
  "Psi Boo",
  "",
  "Pi-2 Oct",
  "Eta Cir",
  "Pi Lup",
  "",
  "47 Boo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nu Lib",
  "22 Lib",
  "",
  "45 Boo",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "46 Boo",
  "",
  "",
  "Lam Lup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ome Oct",
  "",
  "",
  "Kap-1 Lup",
  "Kap-2 Lup",
  "",
  "",
  "Iot-1 Lib",
  "Zet Lup",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Iot-2 Lib",
  "23 Lib",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Chi Boo",
  "26 Lib",
  "1 Lup",
  "",
  "",
  "3 Ser",
  "Del Boo",
  "4 Ser",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del Cir",
  "Bet Lib",
  "11 UMi",
  "Bet Cir",
  "Eps Cir",
  "2 Lup",
  "",
  "",
  "",
  "",
  "Mu Lup",
  "",
  "",
  "Gam TrA",
  "",
  "5 Ser",
  "",
  "",
  "",
  "Omi CrB",
  "",
  "",
  "Gam UMi",
  "",
  "28 Lib",
  "Omi Lib",
  "6 Ser",
  "",
  "",
  "Del Lup",
  "",
  "Phi-1 Lup",
  "50 Boo",
  "Nu-2 Lup",
  "Nu-1 Lup",
  "7 Ser",
  "",
  "",
  "",
  "Eps Lup",
  "",
  "30 Lib",
  "Phi-2 Lup",
  "",
  "Eta CrB",
  "Gam Cir",
  "",
  "8 Ser",
  "",
  "",
  "Eps Lib",
  "Mu-1 Boo",
  "Ups Lup",
  "Iot Dra",
  "",
  "Tau-1 Ser",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet CrB",
  "",
  "Zet-1 Lib",
  "",
  "",
  "10 Ser",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet-3 Lib",
  "",
  "Nu-1 Boo",
  "",
  "",
  "The UMi",
  "Kap-1 Aps",
  "",
  "Nu-2 Boo",
  "",
  "",
  "Tau-2 Ser",
  "",
  "Zet-4 Lib",
  "The CrB",
  "11 Ser",
  "",
  "",
  "",
  "",
  "37 Lib",
  "",
  "",
  "36 Lib",
  "Alp CrB",
  "Del Ser",
  "Gam Lup",
  "Mu CrB",
  "",
  "Gam Lib",
  "Tau-3 Ser",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tau-5 Ser",
  "16 Ser",
  "Eps TrA",
  "",
  "Ups Lib",
  "",
  "",
  "",
  "",
  "Phi Boo",
  "Ome Lup",
  "",
  "",
  "",
  "",
  "Tau Lib",
  "",
  "",
  "",
  "",
  "41 Lib",
  "",
  "",
  "",
  "Zet-1 CrB",
  "Psi-1 Lup",
  "",
  "",
  "",
  "",
  "42 Lib",
  "Kap-2 Aps",
  "",
  "Tau-6 Ser",
  "",
  "Iot Ser",
  "Chi Ser",
  "",
  "Tau-7 Ser",
  "Kap Lib",
  "",
  "",
  "Psi-2 Lup",
  "Gam CrB",
  "",
  "",
  "Rho Oct",
  "",
  "",
  "Pi CrB",
  "Psi Ser",
  "Zet UMi",
  "Eta Lib",
  "Alp Ser",
  "",
  "Tau-8 Ser",
  "",
  "",
  "",
  "25 Ser",
  "Bet Ser",
  "",
  "Lam Ser",
  "",
  "",
  "",
  "",
  "Ups Ser",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kap Ser",
  "",
  "",
  "Del CrB",
  "Mu Ser",
  "",
  "",
  "",
  "Ome Ser",
  "Eps Ser",
  "Chi Lup",
  "1 Sco",
  "",
  "Kap CrB",
  "36 Ser",
  "Rho Ser",
  "",
  "",
  "",
  "",
  "Chi Her",
  "",
  "39 Ser",
  "Lam Lib",
  "",
  "",
  "2 Sco",
  "The Lib",
  "",
  "",
  "",
  "",
  "2 Her",
  "3 Sco",
  "40 Ser",
  "",
  "47 Lib",
  "Bet TrA",
  "Kap TrA",
  "4 Sco",
  "",
  "4 Her",
  "",
  "",
  "Lam CrB",
  "",
  "",
  "",
  "",
  "",
  "Gam Ser",
  "",
  "Rho Sco",
  "Xi-1 Lup",
  "Xi-2 Lup",
  "",
  "Phi Ser",
  "",
  "",
  "Eps CrB",
  "",
  "",
  "48 Lib",
  "",
  "",
  "Pi Sco",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eta Lup",
  "49 Lib",
  "Del Sco",
  "50 Lib",
  "",
  "",
  "Rho CrB",
  "",
  "",
  "5 Her",
  "",
  "Iot CrB",
  "The Dra",
  "",
  "",
  "Pi Ser",
  "",
  "Ups Her",
  "",
  "",
  "Eta Nor",
  "",
  "",
  "",
  "",
  "Iot-1 Nor",
  "",
  "43 Ser",
  "",
  "",
  "",
  "",
  "",
  "Bet-1 Sco",
  "Bet-2 Sco",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del Nor",
  "The Lup",
  "Ome-1 Sco",
  "",
  "",
  "",
  "",
  "Ome-2 Sco",
  "11 Sco",
  "45 Ser",
  "",
  "Kap Her",
  "Kap Her",
  "",
  "47 Ser",
  "",
  "",
  "Phi Her",
  "8 Her",
  "Tau CrB",
  "",
  "",
  "",
  "Iot-2 Nor",
  "",
  "",
  "",
  "",
  "",
  "",
  "19 UMi",
  "",
  "",
  "",
  "10 Her",
  "",
  "",
  "",
  "Nu Sco",
  "Psi Sco",
  "",
  "16 Sco",
  "12 Sco",
  "13 Sco",
  "",
  "20 UMi",
  "",
  "",
  "9 Her",
  "",
  "Zet Nor",
  "Kap Nor",
  "",
  "",
  "Chi Sco",
  "",
  "Del Oph",
  "",
  "",
  "",
  "",
  "Sig CrB",
  "",
  "The Nor",
  "",
  "Del TrA",
  "16 Her",
  "18 Sco",
  "",
  "",
  "",
  "",
  "Ups CrB",
  "",
  "",
  "",
  "Gam-1 Nor",
  "",
  "",
  "",
  "Eta UMi",
  "",
  "",
  "",
  "Eps Oph",
  "",
  "",
  "",
  "Lam Nor",
  "",
  "Tau Her",
  "Gam-2 Nor",
  "",
  "",
  "Del-1 Aps",
  "",
  "Del-2 Aps",
  "",
  "Omi Sco",
  "Sig Sco",
  "",
  "Gam Her",
  "Sig Ser",
  "Xi CrB",
  "Nu-1 CrB",
  "",
  "",
  "Nu-2 CrB",
  "",
  "",
  "",
  "",
  "Eta Dra",
  "",
  "Psi Oph",
  "21 Her",
  "",
  "",
  "",
  "",
  "",
  "25 Her",
  "Ome Her",
  "Rho Oph",
  "",
  "",
  "",
  "Chi Oph",
  "Eps Nor",
  "",
  "",
  "Ups Oph",
  "Iot TrA",
  "15 Dra",
  "",
  "",
  "",
  "Zet TrA",
  "",
  "30 Her",
  "",
  "",
  "",
  "Alp Sco",
  "",
  "",
  "",
  "34 Her",
  "22 Sco",
  "Bet Her",
  "",
  "",
  "",
  "",
  "Lam Oph",
  "",
  "Phi Oph",
  "",
  "",
  "",
  "",
  "",
  "",
  "Ome Oph",
  "",
  "28 Her",
  "29 Her",
  "Gam Aps",
  "Mu Nor",
  "Sig Her",
  "",
  "",
  "",
  "The TrA",
  "Tau Sco",
  "",
  "16 Dra",
  "17 Dra",
  "12 Oph",
  "",
  "",
  "",
  "",
  "Zet Oph",
  "",
  "",
  "",
  "",
  "",
  "",
  "42 Her",
  "",
  "",
  "",
  "",
  "",
  "37 Her",
  "",
  "",
  "",
  "18 Dra",
  "",
  "",
  "",
  "",
  "Zet Her",
  "",
  "Eta-1 TrA",
  "",
  "",
  "39 Her",
  "",
  "14 Oph",
  "",
  "",
  "",
  "",
  "",
  "Eta Her",
  "",
  "",
  "Bet Aps",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "16 Oph",
  "43 Her",
  "Eps UMi",
  "",
  "",
  "",
  "",
  "19 Oph",
  "",
  "",
  "45 Her",
  "",
  "",
  "Alp TrA",
  "52 Her",
  "",
  "",
  "",
  "Eta Ara",
  "20 Oph",
  "Eps Sco",
  "47 Her",
  "",
  "",
  "",
  "50 Her",
  "",
  "",
  "21 Oph",
  "",
  "51 Her",
  "Mu-1 Sco",
  "",
  "",
  "",
  "Mu-2 Sco",
  "",
  "53 Her",
  "",
  "",
  "",
  "",
  "Zet-1 Sco",
  "",
  "Iot Oph",
  "",
  "",
  "",
  "",
  "",
  "Zet-2 Sco",
  "23 Oph",
  "",
  "",
  "",
  "56 Her",
  "",
  "",
  "54 Her",
  "",
  "",
  "19 Dra",
  "",
  "",
  "",
  "20 Dra",
  "",
  "",
  "24 Oph",
  "",
  "",
  "27 Sco",
  "",
  "57 Her",
  "",
  "Kap Oph",
  "",
  "",
  "",
  "Zet Ara",
  "",
  "",
  "",
  "",
  "",
  "Eps-1 Ara",
  "",
  "",
  "26 Oph",
  "",
  "Eps Her",
  "",
  "",
  "",
  "",
  "30 Oph",
  "",
  "",
  "",
  "59 Her",
  "",
  "",
  "",
  "29 Oph",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eps-2 Ara",
  "61 Her",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Mu Dra",
  "60 Her",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet Dra",
  "",
  "",
  "",
  "",
  "",
  "Eta Oph",
  "",
  "",
  "63 Her",
  "",
  "",
  "",
  "Eta Sco",
  "",
  "",
  "",
  "",
  "37 Oph",
  "",
  "",
  "",
  "",
  "",
  "Alp-1 Her",
  "Del Her",
  "Pi Her",
  "",
  "",
  "36 Oph",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "41 Oph",
  "",
  "Lam UMi",
  "",
  "",
  "68 Her",
  "",
  "69 Her",
  "Omi Oph",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "74 Her",
  "",
  "",
  "72 Her",
  "Nu Ser",
  "",
  "70 Her",
  "Xi Oph",
  "",
  "",
  "",
  "",
  "",
  "Zet Aps",
  "The Oph",
  "Iot Aps",
  "",
  "",
  "",
  "",
  "",
  "",
  "Iot Ara",
  "43 Oph",
  "Rho Her",
  "",
  "",
  "",
  "73 Her",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet Ara",
  "Gam Ara",
  "",
  "",
  "",
  "",
  "Kap Ara",
  "",
  "",
  "",
  "44 Oph",
  "Sig Oph",
  "",
  "77 Her",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "45 Oph",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Bet Dra",
  "",
  "",
  "Lam Her",
  "Ups Sco",
  "24 UMi",
  "",
  "Del Ara",
  "",
  "",
  "51 Oph",
  "",
  "",
  "",
  "",
  "78 Her",
  "Alp Ara",
  "27 Dra",
  "Nu-1 Dra",
  "Del UMi",
  "",
  "Nu-2 Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "Lam Sco",
  "",
  "",
  "",
  "53 Oph",
  "",
  "",
  "Alp Oph",
  "26 Dra",
  "52 Oph",
  "",
  "",
  "Sig Ara",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "82 Her",
  "",
  "Ome Dra",
  "",
  "The Sco",
  "",
  "",
  "79 Her",
  "Xi Ser",
  "",
  "Mu Oph",
  "Pi Ara",
  "",
  "",
  "",
  "",
  "",
  "Iot Her",
  "",
  "",
  "Lam Ara",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Omi Ser",
  "",
  "Psi-1 Dra",
  "Psi-1 Dra",
  "",
  "",
  "83 Her",
  "Kap Sco",
  "",
  "",
  "",
  "",
  "84 Her",
  "",
  "58 Oph",
  "Bet Oph",
  "",
  "",
  "",
  "Mu Ara",
  "",
  "61 Oph",
  "",
  "",
  "",
  "Eta Pav",
  "Mu Her",
  "",
  "",
  "",
  "3 Sgr",
  "Iot-1 Sco",
  "",
  "",
  "Gam Oph",
  "",
  "",
  "",
  "",
  "",
  "87 Her",
  "30 Dra",
  "",
  "",
  "35 Dra",
  "",
  "",
  "",
  "Iot-2 Sco",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "90 Her",
  "",
  "",
  "",
  "Xi Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Psi-2 Dra",
  "",
  "89 Her",
  "",
  "",
  "The Her",
  "",
  "",
  "",
  "Gam Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Xi Her",
  "",
  "",
  "Nu Her",
  "",
  "",
  "",
  "",
  "Nu Oph",
  "",
  "",
  "4 Sgr",
  "",
  "",
  "40 Dra",
  "93 Her",
  "41 Dra",
  "",
  "66 Oph",
  "",
  "Zet Ser",
  "",
  "67 Oph",
  "",
  "",
  "6 Sgr",
  "95 Her",
  "",
  "",
  "68 Oph",
  "",
  "",
  "96 Her",
  "97 Her",
  "7 Sgr",
  "Tau Oph",
  "",
  "",
  "9 Sgr",
  "",
  "",
  "",
  "",
  "Gam-1 Sgr",
  "",
  "70 Oph",
  "",
  "Gam-2 Sgr",
  "",
  "98 Her",
  "",
  "",
  "",
  "",
  "",
  "The Ara",
  "",
  "",
  "99 Her",
  "",
  "",
  "71 Oph",
  "72 Oph",
  "",
  "Omi Her",
  "",
  "",
  "100 Her",
  "100 Her",
  "",
  "",
  "",
  "",
  "Pi Pav",
  "",
  "102 Her",
  "101 Her",
  "",
  "73 Oph",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Iot Pav",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eps Tel",
  "",
  "",
  "1 Sgr",
  "",
  "104 Her",
  "",
  "",
  "",
  "",
  "",
  "Mu Sgr",
  "",
  "36 Dra",
  "14 Sgr",
  "",
  "15 Sgr",
  "16 Sgr",
  "37 Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eta Sgr",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "105 Her",
  "",
  "Kap Lyr",
  "",
  "",
  "",
  "106 Her",
  "Phi Dra",
  "74 Oph",
  "",
  "108 Her",
  "Del Sgr",
  "107 Her",
  "Chi Dra",
  "",
  "Eta Ser",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Xi Pav",
  "",
  "Phi Oct",
  "Zet Sct",
  "109 Her",
  "",
  "39 Dra",
  "",
  "",
  "",
  "Eps Sgr",
  "Mu Lyr",
  "",
  "",
  "",
  "",
  "",
  "18 Sgr",
  "21 Sgr",
  "",
  "",
  "",
  "",
  "",
  "",
  "42 Dra",
  "",
  "",
  "Alp Tel",
  "",
  "59 Ser",
  "",
  "",
  "",
  "",
  "",
  "Lam Sgr",
  "",
  "",
  "",
  "",
  "Zet Tel",
  "Gam Sct",
  "",
  "",
  "",
  "60 Ser",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nu Pav",
  "",
  "",
  "Del-1 Tel",
  "",
  "61 Ser",
  "Del-2 Tel",
  "",
  "",
  "",
  "45 Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "Kap-2 CrA",
  "Kap-1 CrA",
  "",
  "",
  "The CrA",
  "",
  "24 Sgr",
  "",
  "",
  "",
  "",
  "",
  "Alp Sct",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alp Lyr",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "26 Sgr",
  "",
  "",
  "Del Sct",
  "",
  "",
  "46 Dra",
  "",
  "Zet Pav",
  "",
  "",
  "",
  "Eps Sct",
  "",
  "",
  "Lam CrA",
  "",
  "",
  "",
  "",
  "",
  "Eps-1 Lyr",
  "Eps-2 Lyr",
  "",
  "Zet-1 Lyr",
  "Zet-2 Lyr",
  "",
  "4 Aql",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Phi Sgr",
  "110 Her",
  "",
  "",
  "",
  "",
  "",
  "28 Sgr",
  "50 Dra",
  "5 Aql",
  "",
  "",
  "",
  "111 Her",
  "Bet Sct",
  "",
  "Mu CrA",
  "",
  "",
  "",
  "",
  "",
  "The Pav",
  "",
  "",
  "Eta-1 CrA",
  "",
  "",
  "Eta-2 CrA",
  "",
  "29 Sgr",
  "",
  "",
  "Nu-1 Lyr",
  "Nu-2 Lyr",
  "Bet Lyr",
  "",
  "",
  "30 Sgr",
  "",
  "",
  "Omi Dra",
  "8 Aql",
  "",
  "",
  "",
  "",
  "",
  "",
  "Lam Pav",
  "112 Her",
  "",
  "",
  "",
  "Kap Tel",
  "",
  "",
  "",
  "",
  "",
  "",
  "Del-1 Lyr",
  "",
  "33 Sgr",
  "Nu-1 Sgr",
  "",
  "Ups Dra",
  "Del-2 Lyr",
  "",
  "113 Her",
  "",
  "Chi Oct",
  "",
  "",
  "Nu-2 Sgr",
  "Sig Sgr",
  "13 Lyr",
  "",
  "",
  "",
  "",
  "",
  "The-1 Ser",
  "The-2 Ser",
  "",
  "",
  "",
  "",
  "",
  "",
  "48 Dra",
  "",
  "Kap Pav",
  "",
  "Eta Sct",
  "",
  "64 Ser",
  "",
  "Xi-1 Sgr",
  "",
  "",
  "Xi-2 Sgr",
  "",
  "",
  "",
  "",
  "",
  "",
  "Lam Tel",
  "Ome Pav",
  "Eps CrA",
  "",
  "10 Aql",
  "Gam Lyr",
  "",
  "11 Aql",
  "",
  "",
  "",
  "",
  "",
  "Eps Aql",
  "",
  "",
  "Lam Lyr",
  "",
  "",
  "",
  "49 Dra",
  "",
  "",
  "",
  "",
  "16 Lyr",
  "",
  "",
  "12 Aql",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet Sgr",
  "",
  "14 Aql",
  "",
  "Zet CrA",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Omi Sgr",
  "51 Dra",
  "15 Aql",
  "",
  "",
  "",
  "Zet Aql",
  "",
  "",
  "Lam Aql",
  "Rho Tel",
  "Gam CrA",
  "",
  "",
  "",
  "",
  "",
  "",
  "Tau Sgr",
  "18 Aql",
  "",
  "Iot Lyr",
  "17 Lyr",
  "",
  "",
  "",
  "",
  "",
  "Del CrA",
  "",
  "",
  "19 Aql",
  "59 Dra",
  "Alp CrA",
  "",
  "55 Dra",
  "Pi Sgr",
  "",
  "",
  "",
  "",
  "Bet CrA",
  "",
  "",
  "",
  "",
  "53 Dra",
  "19 Lyr",
  "",
  "",
  "Del Dra",
  "",
  "20 Aql",
  "",
  "",
  "",
  "21 Aql",
  "",
  "Eta Lyr",
  "54 Dra",
  "",
  "",
  "",
  "1 Sge",
  "",
  "",
  "",
  "Psi Sgr",
  "",
  "Tau Dra",
  "",
  "",
  "1 Vul",
  "",
  "The Lyr",
  "",
  "Tau Pav",
  "22 Aql",
  "",
  "",
  "Kap Cyg",
  "",
  "43 Sgr",
  "2 Vul",
  "",
  "Ome-1 Aql",
  "",
  "23 Aql",
  "",
  "",
  "24 Aql",
  "",
  "",
  "",
  "",
  "",
  "28 Aql",
  "",
  "Ome-2 Aql",
  "",
  "26 Aql",
  "",
  "27 Aql",
  "",
  "Pi Dra",
  "",
  "",
  "",
  "",
  "Rho-1 Sgr",
  "Ups Sgr",
  "Rho-2 Sgr",
  "",
  "",
  "",
  "",
  "Bet-1 Sgr",
  "",
  "3 Vul",
  "Eta Tel",
  "",
  "Bet-2 Sgr",
  "",
  "",
  "Alp Sgr",
  "",
  "",
  "",
  "2 Cyg",
  "",
  "2 Sge",
  "",
  "31 Aql",
  "",
  "",
  "Chi-1 Sgr",
  "",
  "",
  "",
  "4 Vul",
  "Chi-3 Sgr",
  "Del Aql",
  "4 Cyg",
  "",
  "5 Vul",
  "50 Sgr",
  "",
  "",
  "",
  "Nu Aql",
  "",
  "Iot-1 Cyg",
  "",
  "",
  "",
  "",
  "Alp Vul",
  "8 Vul",
  "35 Aql",
  "",
  "7 Vul",
  "",
  "",
  "",
  "Iot-2 Cyg",
  "",
  "",
  "",
  "",
  "Mu Tel",
  "36 Aql",
  "Bet-1 Cyg",
  "Bet-2 Cyg",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "8 Cyg",
  "",
  "Sig Dra",
  "",
  "",
  "",
  "",
  "",
  "Mu Aql",
  "",
  "",
  "9 Vul",
  "",
  "",
  "9 Cyg",
  "",
  "37 Aql",
  "Iot Tel",
  "",
  "",
  "",
  "11 Cyg",
  "",
  "51 Sgr",
  "",
  "",
  "",
  "The Cyg",
  "",
  "52 Sgr",
  "Iot Aql",
  "",
  "Kap Aql",
  "",
  "",
  "Eps Sge",
  "",
  "",
  "42 Aql",
  "",
  "",
  "",
  "",
  "",
  "Sig Aql",
  "Phi Cyg",
  "",
  "14 Cyg",
  "",
  "",
  "",
  "53 Sgr",
  "",
  "Alp Sge",
  "",
  "",
  "",
  "",
  "45 Aql",
  "54 Sgr",
  "",
  "Bet Sge",
  "",
  "",
  "",
  "16 Cyg",
  "",
  "",
  "",
  "",
  "46 Aql",
  "55 Sgr",
  "Chi Aql",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "10 Vul",
  "",
  "",
  "",
  "15 Cyg",
  "",
  "Psi Aql",
  "",
  "",
  "",
  "Del Cyg",
  "",
  "Ups Aql",
  "",
  "",
  "",
  "Gam Aql",
  "56 Sgr",
  "17 Cyg",
  "",
  "",
  "Del Sge",
  "",
  "",
  "",
  "Nu Tel",
  "",
  "Eps Dra",
  "",
  "Pi Aql",
  "",
  "",
  "",
  "Zet Sge",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "19 Cyg",
  "",
  "20 Cyg",
  "",
  "Alp Aql",
  "51 Aql",
  "",
  "",
  "Omi Aql",
  "12 Vul",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "57 Sgr",
  "",
  "9 Sge",
  "Eta Aql",
  "",
  "",
  "",
  "",
  "23 Cyg",
  "",
  "13 Vul",
  "",
  "56 Aql",
  "Xi Aql",
  "",
  "",
  "57 Aql",
  "57 Aql",
  "",
  "",
  "58 Aql",
  "",
  "",
  "Iot Sgr",
  "Bet Aql",
  "",
  "",
  "Psi Cyg",
  "Ome Sgr",
  "22 Cyg",
  "",
  "10 Sge",
  "",
  "Phi Aql",
  "Eta Cyg",
  "",
  "",
  "",
  "59 Sgr",
  "",
  "",
  "11 Sge",
  "",
  "61 Sgr",
  "",
  "",
  "",
  "",
  "",
  "Gam Sge",
  "",
  "",
  "60 Sgr",
  "14 Vul",
  "",
  "",
  "",
  "69 Dra",
  "The-1 Sgr",
  "",
  "The-2 Sgr",
  "25 Cyg",
  "13 Sge",
  "",
  "",
  "",
  "Mu-1 Pav",
  "",
  "",
  "Eps Pav",
  "",
  "",
  "15 Vul",
  "",
  "26 Cyg",
  "",
  "",
  "64 Dra",
  "",
  "",
  "Mu-2 Pav",
  "63 Sgr",
  "16 Vul",
  "65 Dra",
  "",
  "62 Sgr",
  "",
  "Rho Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "15 Sge",
  "Tau Aql",
  "",
  "62 Aql",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eta Sge",
  "",
  "",
  "",
  "",
  "66 Dra",
  "",
  "",
  "27 Cyg",
  "17 Vul",
  "Xi Tel",
  "",
  "",
  "",
  "64 Aql",
  "",
  "",
  "",
  "",
  "",
  "Del Pav",
  "Kap Cep",
  "",
  "",
  "28 Cyg",
  "18 Vul",
  "",
  "",
  "",
  "",
  "The Aql",
  "",
  "68 Dra",
  "19 Vul",
  "Xi-1 Cap",
  "20 Vul",
  "",
  "Xi-2 Cap",
  "",
  "",
  "",
  "66 Aql",
  "30 Cyg",
  "33 Cyg",
  "",
  "",
  "31 Cyg",
  "",
  "",
  "21 Vul",
  "Rho Aql",
  "",
  "",
  "29 Cyg",
  "",
  "",
  "",
  "32 Cyg",
  "22 Vul",
  "",
  "23 Vul",
  "",
  "",
  "",
  "",
  "18 Sge",
  "3 Cap",
  "",
  "",
  "24 Vul",
  "",
  "",
  "",
  "",
  "Alp-1 Cap",
  "34 Cyg",
  "4 Cap",
  "Alp-2 Cap",
  "",
  "",
  "36 Cyg",
  "35 Cyg",
  "",
  "",
  "",
  "",
  "",
  "Sig Cap",
  "",
  "71 Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Nu Cap",
  "",
  "",
  "Bet Cap",
  "",
  "",
  "",
  "",
  "25 Vul",
  "",
  "Gam Cyg",
  "Kap-1 Sgr",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "39 Cyg",
  "Kap-2 Sgr",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alp Pav",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "43 Cyg",
  "",
  "",
  "Pi Cap",
  "40 Cyg",
  "",
  "75 Dra",
  "",
  "68 Aql",
  "",
  "",
  "Rho Cap",
  "",
  "42 Cyg",
  "41 Cyg",
  "",
  "74 Dra",
  "",
  "The Cep",
  "69 Aql",
  "Omi Cap",
  "",
  "",
  "Ome-1 Cyg",
  "1 Del",
  "",
  "",
  "44 Cyg",
  "",
  "Ome-2 Cyg",
  "",
  "73 Dra",
  "",
  "",
  "",
  "",
  "",
  "",
  "Eps Del",
  "",
  "",
  "47 Cyg",
  "",
  "Nu Mic",
  "Eta Del",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet Del",
  "",
  "Phi-1 Pav",
  "",
  "",
  "26 Vul",
  "",
  "70 Aql",
  "27 Vul",
  "",
  "",
  "48 Cyg",
  "Bet Del",
  "Alp Ind",
  "Rho Pav",
  "Iot Del",
  "",
  "",
  "",
  "71 Aql",
  "29 Vul",
  "28 Vul",
  "",
  "The Del",
  "",
  "",
  "",
  "",
  "Kap Del",
  "",
  "",
  "Tau Cap",
  "1 Aqr",
  "",
  "Alp Del",
  "",
  "",
  "Phi-2 Pav",
  "Ups Cap",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "49 Cyg",
  "10 Del",
  "",
  "",
  "",
  "Alp Cyg",
  "",
  "Ups Pav",
  "",
  "Mu-1 Oct",
  "51 Cyg",
  "76 Dra",
  "",
  "",
  "4 Cep",
  "",
  "",
  "Del Del",
  "Eta Ind",
  "",
  "",
  "30 Vul",
  "Bet Pav",
  "",
  "Eta Cep",
  "",
  "52 Cyg",
  "Psi Cap",
  "17 Cap",
  "Eps Cyg",
  "",
  "",
  "",
  "",
  "Gam-1 Del",
  "Gam-2 Del",
  "",
  "",
  "",
  "Lam Cyg",
  "",
  "Eps Aqr",
  "3 Aqr",
  "",
  "13 Del",
  "",
  "",
  "",
  "Iot Mic",
  "",
  "55 Cyg",
  "",
  "",
  "",
  "Sig Pav",
  "",
  "Zet Ind",
  "",
  "15 Del",
  "14 Del",
  "",
  "Alp Mic",
  "",
  "56 Cyg",
  "",
  "",
  "",
  "4 Aqr",
  "",
  "Iot Ind",
  "",
  "Ome Cap",
  "Bet Mic",
  "",
  "31 Vul",
  "5 Aqr",
  "Mu Aqr",
  "",
  "",
  "",
  "57 Cyg",
  "",
  "",
  "",
  "",
  "",
  "",
  "32 Vul",
  "",
  "",
  "19 Cap",
  "Bet Ind",
  "17 Del",
  "16 Del",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "7 Aqr",
  "Nu Cyg",
  "",
  "",
  "33 Vul",
  "",
  "18 Del",
  "",
  "",
  "",
  "Eps Equ",
  "",
  "",
  "",
  "20 Cap",
  "59 Cyg",
  "",
  "",
  "",
  "",
  "11 Aqr",
  "",
  "21 Cap",
  "60 Cyg",
  "",
  "Gam Mic",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Zet Mic",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "12 Aqr",
  "Eta Cap",
  "3 Equ",
  "",
  "Alp Oct",
  "",
  "Xi Cyg",
  "Mu Ind",
  "4 Equ",
  "",
  "The Cap",
  "Del Mic",
  "",
  "",
  "",
  "Eta Mic",
  "",
  "63 Cyg",
  "",
  "61 Cyg",
  "61 Cyg",
  "24 Cap",
  "",
  "",
  "",
  "",
  "",
  "Chi Cap",
  "",
  "Sig Oct",
  "",
  "",
  "27 Cap",
  "Nu Aqr",
  "",
  "",
  "Gam Equ",
  "",
  "6 Equ",
  "",
  "",
  "",
  "",
  "",
  "Zet Cyg",
  "",
  "",
  "",
  "Omi Pav",
  "",
  "",
  "",
  "",
  "",
  "Del Equ",
  "",
  "Tau Cyg",
  "",
  "",
  "",
  "Phi Cap",
  "",
  "29 Cap",
  "",
  "",
  "Alp Equ",
  "",
  "14 Aqr",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Sig Cyg",
  "Ups Cyg",
  "Eps Mic",
  "30 Cap",
  "",
  "15 Aqr",
  "68 Cyg",
  "",
  "Alp Cep",
  "",
  "",
  "",
  "",
  "",
  "6 Cep",
  "",
  "The Ind",
  "",
  "",
  "",
  "The-1 Mic",
  "",
  "",
  "",
  "16 Aqr",
  "9 Equ",
  "",
  "",
  "",
  "1 Peg",
  "Iot Cap",
  "",
  "Bet Equ",
  "17 Aqr",
  "",
  "",
  "",
  "",
  "",
  "",
  "33 Cap",
  "18 Aqr",
  "",
  "",
  "",
  "",
  "The-2 Mic",
  "",
  "",
  "20 Aqr",
  "19 Aqr",
  "21 Aqr",
  "",
  "",
  "69 Cyg",
  "",
  "Gam Ind",
  "",
  "Gam Pav",
  "",
  "",
  "Zet Cap",
  "",
  "",
  "",
  "35 Cap",
  "70 Cyg",
  "",
  "35 Vul",
  "7 Cep",
  "",
  "",
  "Bet Cep",
  "36 Cap",
  "",
  "",
  "",
  "",
  "",
  "71 Cyg",
  "",
  "2 Peg",
  "",
  "",
  "",
  "",
  "Bet Aqr",
  "",
  "",
  "Xi Gru",
  "6 PsA",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Rho Cyg",
  "",
  "",
  "",
  "",
  "",
  "72 Cyg",
  "37 Cap",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "8 PsA",
  "",
  "7 PsA",
  "74 Cyg",
  "Eps Cap",
  "",
  "",
  "",
  "3 Peg",
  "Xi Aqr",
  "5 Peg",
  "9 Cep",
  "",
  "4 Peg",
  "",
  "",
  "",
  "",
  "",
  "",
  "25 Aqr",
  "",
  "Gam Cap",
  "75 Cyg",
  "",
  "",
  "Nu Oct",
  "42 Cap",
  "76 Cyg",
  "11 Cep",
  "41 Cap",
  "",
  "Pi-1 Cyg",
  "",
  "26 Aqr",
  "7 Peg",
  "77 Cyg",
  "",
  "",
  "Kap Cap",
  "",
  "",
  "44 Cap",
  "",
  "",
  "79 Cyg",
  "Mu Cep",
  "",
  "",
  "",
  "45 Cap",
  "Mu-1 Cyg",
  "Eps Peg",
  "",
  "9 Peg",
  "",
  "Kap Peg",
  "",
  "Iot PsA",
  "46 Cap",
  "",
  "",
  "Nu Cep",
  "",
  "",
  "12 Peg",
  "47 Cap",
  "",
  "Lam Cap",
  "Pi-2 Cyg",
  "",
  "Del Cap",
  "",
  "11 Peg",
  "12 Cep",
  "",
  "The PsA",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "14 Peg",
  "",
  "13 Peg",
  "",
  "Omi Ind",
  "Lam Oct",
  "",
  "",
  "",
  "",
  "",
  "",
  "15 Peg",
  "16 Peg",
  "Mu Cap",
  "",
  "Gam Gru",
  "",
  "",
  "",
  "",
  "",
  "13 Cep",
  "",
  "",
  "",
  "",
  "",
  "Pi Ind",
  "",
  "",
  "",
  "17 Peg",
  "",
  "",
  "",
  "Del Ind",
  "",
  "Kap-1 Ind",
  "",
  "",
  "",
  "",
  "16 Cep",
  "",
  "18 Peg",
  "",
  "",
  "Eta PsA",
  "28 Aqr",
  "20 Peg",
  "19 Peg",
  "",
  "",
  "",
  "14 Cep",
  "",
  "29 Aqr",
  "",
  "",
  "30 Aqr",
  "Eps Ind",
  "Omi Aqr",
  "21 Peg",
  "Xi Cep",
  "18 Cep",
  "13 PsA",
  "",
  "",
  "32 Aqr",
  "20 Cep",
  "",
  "19 Cep",
  "",
  "",
  "23 Peg",
  "Nu Peg",
  "Alp Aqr",
  "",
  "Kap-2 Ind",
  "",
  "",
  "Lam Gru",
  "",
  "",
  "Iot Aqr",
  "Iot Peg",
  "",
  "",
  "",
  "",
  "25 Peg",
  "Alp Gru",
  "",
  "",
  "Mu PsA",
  "Ups PsA",
  "",
  "",
  "35 Aqr",
  "Pi-1 Peg",
  "",
  "24 Cep",
  "",
  "",
  "Pi-2 Peg",
  "",
  "Tau PsA",
  "The Peg",
  "",
  "",
  "",
  "",
  "28 Peg",
  "",
  "",
  "38 Aqr",
  "",
  "Zet Cep",
  "",
  "",
  "",
  "Lam Cep",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "39 Aqr",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "41 Aqr",
  "",
  "Lam PsA",
  "",
  "",
  "Eps Cep",
  "",
  "Mu-1 Gru",
  "1 Lac",
  "",
  "",
  "Mu-2 Gru",
  "",
  "",
  "",
  "42 Aqr",
  "The Aqr",
  "",
  "",
  "44 Aqr",
  "",
  "Psi Oct",
  "",
  "25 Cep",
  "",
  "Alp Tuc",
  "",
  "45 Aqr",
  "Eps Oct",
  "Rho Aqr",
  "30 Peg",
  "",
  "",
  "",
  "",
  "",
  "2 Lac",
  "32 Peg",
  "31 Peg",
  "47 Aqr",
  "Gam Aqr",
  "",
  "Pi-1 Gru",
  "",
  "",
  "",
  "",
  "Pi-2 Gru",
  "49 Aqr",
  "",
  "Bet Lac",
  "33 Peg",
  "",
  "51 Aqr",
  "50 Aqr",
  "4 Lac",
  "Nu Ind",
  "",
  "",
  "Pi Aqr",
  "",
  "",
  "",
  "",
  "53 Aqr",
  "34 Peg",
  "Rho-1 Cep",
  "",
  "26 Cep",
  "Del Tuc",
  "",
  "",
  "35 Peg",
  "",
  "",
  "",
  "Nu Gru",
  "Zet-1 Aqr",
  "36 Peg",
  "",
  "",
  "Del Cep",
  "Del-1 Gru",
  "5 Lac",
  "Del-2 Gru",
  "",
  "Rho-2 Cep",
  "37 Peg",
  "",
  "38 Peg",
  "",
  "56 Aqr",
  "6 Lac",
  "Sig Aqr",
  "Zet PsA",
  "Alp Lac",
  "",
  "",
  "Bet PsA",
  "",
  "Ups Oct",
  "58 Aqr",
  "",
  "",
  "",
  "39 Peg",
  "",
  "Nu Tuc",
  "",
  "",
  "",
  "60 Aqr",
  "Ups Aqr",
  "Eta Aqr",
  "",
  "",
  "31 Cep",
  "61 Aqr",
  "",
  "",
  "",
  "",
  "",
  "Sig-1 Gru",
  "",
  "",
  "",
  "Sig-2 Gru",
  "",
  "",
  "9 Lac",
  "Kap Aqr",
  "",
  "",
  "",
  "30 Cep",
  "",
  "",
  "40 Peg",
  "10 Lac",
  "",
  "",
  "41 Peg",
  "",
  "",
  "11 Lac",
  "Eps PsA",
  "",
  "",
  "",
  "Zet Peg",
  "12 Lac",
  "",
  "",
  "Omi Peg",
  "",
  "",
  "",
  "19 PsA",
  "",
  "Bet Gru",
  "",
  "",
  "Eta Peg",
  "",
  "",
  "67 Aqr",
  "Rho Gru",
  "66 Aqr",
  "",
  "13 Lac",
  "",
  "",
  "",
  "",
  "45 Peg",
  "",
  "Eta Gru",
  "",
  "Bet Oct",
  "",
  "",
  "Lam Peg",
  "Xi Peg",
  "",
  "",
  "",
  "68 Aqr",
  "",
  "Tau-1 Aqr",
  "",
  "",
  "",
  "70 Aqr",
  "Eps Gru",
  "",
  "",
  "",
  "",
  "Tau-2 Aqr",
  "Iot Cep",
  "",
  "",
  "Mu Peg",
  "",
  "14 Lac",
  "Xi Oct",
  "",
  "",
  "21 PsA",
  "",
  "",
  "15 Lac",
  "",
  "Sig Peg",
  "Gam PsA",
  "Lam Aqr",
  "",
  "",
  "",
  "",
  "74 Aqr",
  "Tau-1 Gru",
  "",
  "",
  "",
  "",
  "78 Aqr",
  "",
  "Del Aqr",
  "Rho Ind",
  "77 Aqr",
  "1 Psc",
  "",
  "",
  "Rho Peg",
  "",
  "",
  "",
  "",
  "Del PsA",
  "16 Lac",
  "",
  "",
  "Tau-3 Gru",
  "",
  "",
  "51 Peg",
  "",
  "Alp PsA",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "52 Peg",
  "2 Psc",
  "",
  "",
  "",
  "",
  "",
  "3 Psc",
  "",
  "Zet Gru",
  "",
  "",
  "",
  "81 Aqr",
  "",
  "",
  "",
  "Omi And",
  "",
  "82 Aqr",
  "",
  "2 And",
  "",
  "",
  "",
  "Pi PsA",
  "",
  "Bet Peg",
  "Bet Psc",
  "",
  "",
  "3 And",
  "Kap Gru",
  "Alp Peg",
  "",
  "",
  "83 Aqr",
  "",
  "",
  "",
  "",
  "1 Cas",
  "86 Aqr",
  "The Gru",
  "Ups Gru",
  "55 Peg",
  "",
  "56 Peg",
  "",
  "",
  "",
  "",
  "",
  "",
  "4 And",
  "5 And",
  "",
  "Pi Cep",
  "",
  "",
  "",
  "",
  "5 Psc",
  "88 Aqr",
  "57 Peg",
  "2 Cas",
  "",
  "",
  "",
  "89 Aqr",
  "",
  "58 Peg",
  "",
  "",
  "Iot Gru",
  "6 And",
  "",
  "59 Peg",
  "60 Peg",
  "",
  "7 And",
  "",
  "",
  "",
  "",
  "",
  "",
  "Phi Aqr",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Psi-1 Aqr",
  "",
  "",
  "",
  "Chi Aqr",
  "",
  "",
  "Gam Psc",
  "",
  "",
  "Gam Tuc",
  "",
  "8 And",
  "Psi-2 Aqr",
  "",
  "Phi Gru",
  "",
  "9 And",
  "Omi Cep",
  "Gam Scl",
  "Psi-3 Aqr",
  "",
  "94 Aqr",
  "",
  "96 Aqr",
  "",
  "",
  "11 And",
  "",
  "",
  "10 And",
  "",
  "7 Psc",
  "",
  "Tau Peg",
  "",
  "",
  "63 Peg",
  "",
  "12 And",
  "",
  "64 Peg",
  "",
  "",
  "97 Aqr",
  "65 Peg",
  "",
  "98 Aqr",
  "66 Peg",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "4 Cas",
  "67 Peg",
  "",
  "Ups Peg",
  "99 Aqr",
  "",
  "Omi Gru",
  "Kap Psc",
  "",
  "13 And",
  "",
  "",
  "9 Psc",
  "",
  "",
  "69 Peg",
  "The Psc",
  "",
  "Tau Oct",
  "",
  "",
  "",
  "",
  "",
  "70 Peg",
  "11 Psc",
  "",
  "",
  "",
  "",
  "",
  "14 And",
  "",
  "",
  "100 Aqr",
  "",
  "13 Psc",
  "",
  "Bet Scl",
  "101 Aqr",
  "",
  "71 Peg",
  "",
  "",
  "72 Peg",
  "14 Psc",
  "15 And",
  "73 Peg",
  "",
  "",
  "",
  "Iot Phe",
  "15 Psc",
  "",
  "",
  "16 Psc",
  "",
  "",
  "Lam And",
  "",
  "74 Peg",
  "",
  "75 Peg",
  "",
  "Iot And",
  "",
  "18 And",
  "",
  "Gam Cep",
  "",
  "The Phe",
  "Ome-1 Aqr",
  "",
  "Iot Psc",
  "",
  "Kap And",
  "Mu Scl",
  "",
  "",
  "",
  "103 Aqr",
  "104 Aqr",
  "",
  "",
  "Lam Psc",
  "",
  "",
  "",
  "Ome-2 Aqr",
  "76 Peg",
  "",
  "77 Peg",
  "78 Peg",
  "",
  "",
  "106 Aqr",
  "",
  "",
  "",
  "",
  "107 Aqr",
  "",
  "Psi And",
  "19 Psc",
  "",
  "",
  "Tau Cas",
  "",
  "Sig Phe",
  "",
  "",
  "20 Psc",
  "",
  "",
  "",
  "6 Cas",
  "",
  "Del Scl",
  "",
  "21 Psc",
  "",
  "79 Peg",
  "",
  "",
  "",
  "",
  "",
  "",
  "80 Peg",
  "108 Aqr",
  "22 Psc",
  "Gam-1 Oct",
  "",
  "",
  "Phi Peg",
  "",
  "82 Peg",
  "",
  "24 Psc",
  "25 Psc",
  "",
  "",
  "Rho Cas",
  "",
  "",
  "26 Psc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Gam-2 Oct",
  "",
  "Eta Tuc",
  "Psi Peg",
  "1 Cet",
  "27 Psc",
  "Pi Phe",
  "Sig Cas",
  "Ome Psc",
  "",
  "",
  "Eps Tuc",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "Alp Gem",
  "",
  "",
  "",
  "",
  "",
  "",
  "Xi UMa",
  "Xi UMa",
  "Gam Vir",
  "",
  "Alp Com",
  "Zet UMa",
  "",
  "Eta CrB",
  "Xi Sco",
  "Xi Sco",
  "",
  "Mu Dra",
  "",
  "36 Oph",
  "",
  "Tau Oph",
  "",
  "Gam CrA",
  "",
  "",
  "",
  "",
  "Mu-2 Cyg",
  "",
  "53 Aqr",
  "",
  "",
  "",
  "",
  "",
  "Eta Car",
  "",
  "",
  "",
];

export const starConstellations: readonly string[] = [
  "",
  "Phe",
  "Peg",
  "Cas",
  "Phe",
  "And",
  "Phe",
  "Cas",
  "Phe",
  "Oct",
  "Cas",
  "Cep",
  "And",
  "Psc",
  "Psc",
  "Peg",
  "Scl",
  "Psc",
  "Psc",
  "Cas",
  "Cet",
  "Cet",
  "Cas",
  "Cet",
  "Cep",
  "Cas",
  "Cet",
  "Scl",
  "Cet",
  "And",
  "Tuc",
  "Cep",
  "And",
  "Peg",
  "Peg",
  "Psc",
  "Cas",
  "Psc",
  "Peg",
  "Cas",
  "Phe",
  "Cas",
  "And",
  "Cet",
  "Cet",
  "Psc",
  "Cet",
  "Scl",
  "Psc",
  "Cet",
  "And",
  "Cas",
  "Cet",
  "And",
  "Peg",
  "Peg",
  "Peg",
  "Phe",
  "Cas",
  "Cep",
  "Scl",
  "Phe",
  "Tuc",
  "Psc",
  "Oct",
  "Psc",
  "And",
  "Cet",
  "Cet",
  "Scl",
  "Scl",
  "And",
  "Cet",
  "And",
  "Peg",
  "Oct",
  "And",
  "And",
  "Scl",
  "Scl",
  "And",
  "Cet",
  "Peg",
  "Cet",
  "Cet",
  "Peg",
  "Scl",
  "Psc",
  "And",
  "And",
  "Cas",
  "Hyi",
  "Scl",
  "Cep",
  "And",
  "Psc",
  "Cet",
  "Cas",
  "And",
  "Cas",
  "Cet",
  "Cas",
  "Psc",
  "Psc",
  "And",
  "And",
  "Cet",
  "And",
  "Phe",
  "Cet",
  "And",
  "Tuc",
  "And",
  "Cas",
  "Psc",
  "Tuc",
  "And",
  "And",
  "Hyi",
  "Scl",
  "Cet",
  "Psc",
  "Cet",
  "Cet",
  "Cas",
  "Psc",
  "Psc",
  "Cas",
  "Cas",
  "Psc",
  "Hyi",
  "Phe",
  "Phe",
  "Cet",
  "Cet",
  "Scl",
  "Psc",
  "Scl",
  "Psc",
  "Psc",
  "Psc",
  "And",
  "Psc",
  "Cet",
  "Phe",
  "Phe",
  "And",
  "Cet",
  "Cet",
  "And",
  "Cas",
  "Cet",
  "Phe",
  "Phe",
  "Cas",
  "Phe",
  "Cas",
  "And",
  "Tuc",
  "Tuc",
  "Cas",
  "Cas",
  "Psc",
  "Psc",
  "Tuc",
  "And",
  "Cas",
  "Cas",
  "Cas",
  "Tuc",
  "Scl",
  "Scl",
  "Cas",
  "Phe",
  "Psc",
  "Cet",
  "Cet",
  "Phe",
  "Phe",
  "Psc",
  "Cet",
  "Cet",
  "Cas",
  "Cas",
  "Tuc",
  "And",
  "Psc",
  "And",
  "Cas",
  "And",
  "Phe",
  "Cet",
  "And",
  "Psc",
  "And",
  "Scl",
  "Cas",
  "And",
  "Psc",
  "Cep",
  "Phe",
  "Psc",
  "Tuc",
  "Cet",
  "Cas",
  "Cet",
  "Cet",
  "And",
  "Phe",
  "And",
  "Phe",
  "Cas",
  "Cas",
  "Tuc",
  "Cas",
  "Tuc",
  "Scl",
  "Phe",
  "Cas",
  "Cet",
  "Cet",
  "Cet",
  "Scl",
  "Cas",
  "Tuc",
  "Cas",
  "Cet",
  "Phe",
  "Phe",
  "Cas",
  "Cet",
  "Cet",
  "Cas",
  "Cet",
  "Phe",
  "And",
  "Cet",
  "Psc",
  "Cas",
  "Cas",
  "Psc",
  "Psc",
  "And",
  "Psc",
  "Cet",
  "Cas",
  "Cet",
  "Cas",
  "Psc",
  "Psc",
  "Hyi",
  "Psc",
  "Cas",
  "Phe",
  "Psc",
  "Cas",
  "Cet",
  "Cet",
  "Cet",
  "And",
  "Psc",
  "Phe",
  "Cet",
  "And",
  "Phe",
  "Cas",
  "Cas",
  "Cas",
  "Psc",
  "Cas",
  "Cet",
  "Cet",
  "Cas",
  "Cet",
  "And",
  "Tuc",
  "Cas",
  "Cet",
  "Psc",
  "Cep",
  "And",
  "Cas",
  "Tuc",
  "Cas",
  "Psc",
  "Cet",
  "Scl",
  "Psc",
  "Cet",
  "Psc",
  "Cas",
  "Cas",
  "Cas",
  "And",
  "Cas",
  "Cas",
  "And",
  "Cas",
  "And",
  "Psc",
  "Psc",
  "And",
  "Psc",
  "Tuc",
  "Cas",
  "Scl",
  "Cet",
  "Psc",
  "And",
  "Cas",
  "Scl",
  "Cas",
  "Cet",
  "Phe",
  "Cas",
  "Scl",
  "Tuc",
  "Psc",
  "Phe",
  "And",
  "Psc",
  "And",
  "Cet",
  "Scl",
  "Cas",
  "Cet",
  "Cas",
  "Cas",
  "Psc",
  "Scl",
  "Psc",
  "Psc",
  "Cet",
  "Psc",
  "Psc",
  "Psc",
  "Phe",
  "Cet",
  "Cet",
  "Psc",
  "Psc",
  "Cas",
  "Cas",
  "Cet",
  "Tuc",
  "Cet",
  "Phe",
  "Psc",
  "Cet",
  "And",
  "Psc",
  "Cas",
  "Psc",
  "Phe",
  "Cas",
  "Cet",
  "Cep",
  "Cep",
  "And",
  "And",
  "Psc",
  "Phe",
  "Psc",
  "Cet",
  "And",
  "Psc",
  "Cet",
  "Cas",
  "Cas",
  "Psc",
  "And",
  "Cas",
  "Psc",
  "Psc",
  "Psc",
  "Cas",
  "Cet",
  "Cep",
  "And",
  "Scl",
  "Psc",
  "Cas",
  "Psc",
  "Psc",
  "Psc",
  "Psc",
  "Psc",
  "Cet",
  "Psc",
  "Cet",
  "Phe",
  "Tuc",
  "Cas",
  "Cep",
  "Psc",
  "Cep",
  "Cet",
  "Tuc",
  "And",
  "Psc",
  "Psc",
  "And",
  "Cas",
  "And",
  "Psc",
  "Cet",
  "Cas",
  "Cas",
  "Cet",
  "Cet",
  "Cas",
  "Psc",
  "Cas",
  "And",
  "Cet",
  "Cet",
  "Cet",
  "Cas",
  "Psc",
  "Scl",
  "And",
  "And",
  "Cep",
  "Cet",
  "Cet",
  "Cet",
  "Cet",
  "Phe",
  "Phe",
  "Cet",
  "Hyi",
  "Psc",
  "Cet",
  "Cas",
  "Cas",
  "Cet",
  "Cas",
  "And",
  "Psc",
  "And",
  "Psc",
  "Cet",
  "Psc",
  "Cet",
  "And",
  "Cet",
  "And",
  "And",
  "Cet",
  "Phe",
  "Psc",
  "Phe",
  "Cet",
  "Scl",
  "Psc",
  "And",
  "Psc",
  "Scl",
  "Cas",
  "Cas",
  "Phe",
  "Psc",
  "Phe",
  "Scl",
  "Tri",
  "Phe",
  "Scl",
  "Psc",
  "Cas",
  "Hyi",
  "Cet",
  "UMi",
  "Cas",
  "And",
  "Cet",
  "Psc",
  "Scl",
  "Cet",
  "Cet",
  "Hyi",
  "Psc",
  "Phe",
  "And",
  "Psc",
  "Cet",
  "Scl",
  "And",
  "Psc",
  "Hyi",
  "And",
  "Psc",
  "Oct",
  "Cet",
  "Eri",
  "Cas",
  "Cet",
  "Oct",
  "And",
  "Cas",
  "Scl",
  "Cas",
  "And",
  "Cet",
  "And",
  "Psc",
  "Eri",
  "Per",
  "And",
  "Psc",
  "And",
  "Psc",
  "Hyi",
  "Psc",
  "Scl",
  "Tri",
  "Cet",
  "And",
  "Hyi",
  "Scl",
  "Tri",
  "Scl",
  "Cas",
  "Cas",
  "Eri",
  "Psc",
  "Cet",
  "Cas",
  "Cas",
  "And",
  "Cas",
  "Per",
  "Tri",
  "Cet",
  "Cet",
  "Cas",
  "And",
  "Cet",
  "Cas",
  "Psc",
  "Psc",
  "Scl",
  "Cet",
  "For",
  "Phe",
  "Eri",
  "Phe",
  "Cas",
  "Hyi",
  "For",
  "And",
  "Ari",
  "Psc",
  "And",
  "Tri",
  "Per",
  "For",
  "Cet",
  "For",
  "Ari",
  "Phe",
  "Ari",
  "Phe",
  "Per",
  "Phe",
  "Cet",
  "Cet",
  "Cet",
  "Per",
  "Per",
  "Per",
  "Cet",
  "Tri",
  "And",
  "For",
  "Ari",
  "Psc",
  "Phe",
  "Per",
  "Phe",
  "Cas",
  "Ari",
  "And",
  "Hyi",
  "And",
  "Hyi",
  "Hyi",
  "Hyi",
  "Ari",
  "Cet",
  "And",
  "Eri",
  "Cas",
  "And",
  "Eri",
  "Cet",
  "Eri",
  "Cet",
  "Phe",
  "Ari",
  "Tri",
  "Hyi",
  "Ari",
  "And",
  "For",
  "Cas",
  "Per",
  "Hyi",
  "Cet",
  "Ari",
  "Ari",
  "Cas",
  "Phe",
  "Hyi",
  "Cet",
  "Cet",
  "Psc",
  "Cet",
  "For",
  "Phe",
  "Cas",
  "Psc",
  "Per",
  "For",
  "Ari",
  "For",
  "Cas",
  "Cep",
  "Tri",
  "Cet",
  "Cas",
  "Cas",
  "Cet",
  "Cas",
  "Ari",
  "Cet",
  "Ari",
  "Cet",
  "And",
  "Cet",
  "For",
  "Eri",
  "Psc",
  "Cas",
  "Cas",
  "Psc",
  "Cet",
  "Ari",
  "Ari",
  "Cet",
  "Ari",
  "Phe",
  "And",
  "And",
  "Per",
  "Cet",
  "Phe",
  "Ari",
  "Ari",
  "Cep",
  "Tri",
  "For",
  "Phe",
  "Phe",
  "Per",
  "Eri",
  "Ari",
  "And",
  "Ari",
  "Cet",
  "Cet",
  "Tri",
  "Per",
  "Cet",
  "Cet",
  "Tri",
  "Ari",
  "Cet",
  "Ari",
  "Cep",
  "For",
  "Cet",
  "Cet",
  "Ari",
  "And",
  "Cas",
  "Per",
  "And",
  "Per",
  "Cet",
  "And",
  "Hyi",
  "Cas",
  "Phe",
  "Tri",
  "Hyi",
  "Ari",
  "Ari",
  "Tri",
  "And",
  "Eri",
  "Cep",
  "Per",
  "Cet",
  "Tri",
  "Tri",
  "Per",
  "Cet",
  "Per",
  "Ari",
  "Tri",
  "Ari",
  "For",
  "And",
  "And",
  "Cet",
  "And",
  "Phe",
  "Cet",
  "Hor",
  "And",
  "And",
  "Hyi",
  "Per",
  "Cet",
  "Cet",
  "Cet",
  "Phe",
  "Cet",
  "Per",
  "For",
  "And",
  "Hyi",
  "Eri",
  "Cet",
  "For",
  "Per",
  "For",
  "And",
  "Phe",
  "Ari",
  "Hor",
  "Cet",
  "Per",
  "Hor",
  "And",
  "Cet",
  "Cet",
  "Cet",
  "Eri",
  "Ari",
  "Cet",
  "Tri",
  "And",
  "Cet",
  "For",
  "Hor",
  "Cet",
  "Tri",
  "For",
  "Tri",
  "Cas",
  "Ari",
  "Cet",
  "For",
  "Tri",
  "Ari",
  "Cet",
  "Ari",
  "Cet",
  "Ari",
  "Cet",
  "Hyi",
  "UMi",
  "Cet",
  "Tri",
  "Cet",
  "For",
  "Tri",
  "Ari",
  "For",
  "Cet",
  "For",
  "Hor",
  "Cet",
  "Cet",
  "And",
  "And",
  "Tri",
  "Cet",
  "Cet",
  "Cet",
  "For",
  "Cet",
  "Ari",
  "Tri",
  "And",
  "For",
  "Ari",
  "Tri",
  "Hor",
  "Cas",
  "Cet",
  "Cet",
  "Cas",
  "And",
  "For",
  "For",
  "And",
  "Cet",
  "Ari",
  "Cet",
  "Cet",
  "Hyi",
  "Eri",
  "Cet",
  "Cet",
  "Hor",
  "Eri",
  "Ari",
  "Cet",
  "Cet",
  "Cet",
  "For",
  "Eri",
  "Per",
  "Ari",
  "Ari",
  "Hor",
  "Per",
  "Per",
  "Per",
  "Cet",
  "Eri",
  "Hor",
  "Ari",
  "Cet",
  "Ari",
  "Per",
  "Cet",
  "Hor",
  "Per",
  "Ari",
  "For",
  "Ari",
  "Cas",
  "Cet",
  "Ari",
  "Eri",
  "Cet",
  "Hor",
  "Hyi",
  "Eri",
  "Per",
  "Per",
  "Eri",
  "Per",
  "Cep",
  "Ari",
  "Ari",
  "Ari",
  "Cas",
  "Hor",
  "For",
  "Ari",
  "Per",
  "Per",
  "For",
  "For",
  "Ari",
  "For",
  "Hyi",
  "Per",
  "Per",
  "For",
  "Per",
  "Eri",
  "Eri",
  "Ari",
  "Per",
  "Per",
  "Cas",
  "For",
  "Cas",
  "Hor",
  "Eri",
  "Eri",
  "Per",
  "Hor",
  "Ari",
  "Per",
  "For",
  "Eri",
  "Per",
  "Hor",
  "Per",
  "Ari",
  "Cas",
  "Cet",
  "Cas",
  "Eri",
  "Ari",
  "Per",
  "Eri",
  "Per",
  "Cet",
  "For",
  "Per",
  "Eri",
  "For",
  "Per",
  "Ari",
  "Eri",
  "Eri",
  "Eri",
  "Per",
  "Eri",
  "Hor",
  "Per",
  "For",
  "Ari",
  "For",
  "For",
  "Per",
  "Eri",
  "Cet",
  "Per",
  "Per",
  "Ari",
  "Eri",
  "Per",
  "Eri",
  "For",
  "Cet",
  "Ari",
  "Eri",
  "Eri",
  "Hyi",
  "Cet",
  "Cet",
  "Eri",
  "Eri",
  "Eri",
  "Ari",
  "Hor",
  "Per",
  "Eri",
  "Cet",
  "Ari",
  "Per",
  "Per",
  "Eri",
  "Per",
  "Ari",
  "Per",
  "Per",
  "Cep",
  "Ari",
  "Eri",
  "Cas",
  "Ari",
  "Hyi",
  "Per",
  "Hyi",
  "For",
  "Per",
  "Per",
  "Ari",
  "Cet",
  "Cas",
  "Per",
  "Ari",
  "Per",
  "Ari",
  "Ari",
  "Ari",
  "Hor",
  "Eri",
  "Ari",
  "Cas",
  "Eri",
  "Eri",
  "Per",
  "Eri",
  "Ari",
  "Ari",
  "Cep",
  "Cas",
  "For",
  "Per",
  "Ari",
  "Eri",
  "Per",
  "Cet",
  "Hor",
  "Cet",
  "For",
  "Per",
  "For",
  "Ari",
  "Per",
  "For",
  "Ari",
  "Per",
  "Per",
  "Per",
  "Eri",
  "Hyi",
  "Eri",
  "Per",
  "Per",
  "Per",
  "Eri",
  "Per",
  "Eri",
  "Per",
  "Hor",
  "Cam",
  "Ari",
  "Ret",
  "Per",
  "Per",
  "Ret",
  "For",
  "Ret",
  "Eri",
  "Cet",
  "Per",
  "Eri",
  "Per",
  "Per",
  "Cet",
  "Eri",
  "For",
  "Eri",
  "Ari",
  "Cam",
  "Cep",
  "Ari",
  "Ari",
  "For",
  "Cet",
  "Ari",
  "Eri",
  "Per",
  "Hor",
  "Per",
  "Ari",
  "For",
  "Ari",
  "Per",
  "Eri",
  "Tau",
  "Tau",
  "Hyi",
  "Tau",
  "Ari",
  "Per",
  "Ari",
  "Per",
  "Hor",
  "Cam",
  "Tau",
  "Hyi",
  "For",
  "Per",
  "Eri",
  "For",
  "Ari",
  "Tau",
  "Tau",
  "For",
  "Eri",
  "Per",
  "For",
  "Per",
  "Cam",
  "Ari",
  "Per",
  "Tau",
  "Cam",
  "Per",
  "Ret",
  "Per",
  "Eri",
  "Eri",
  "Cam",
  "Eri",
  "Men",
  "Cam",
  "Cam",
  "Eri",
  "Cas",
  "Tau",
  "Per",
  "Hor",
  "Per",
  "Eri",
  "Tau",
  "Ret",
  "Tau",
  "Per",
  "Per",
  "Per",
  "For",
  "Per",
  "Cep",
  "Per",
  "Hor",
  "Tau",
  "Per",
  "Per",
  "Ret",
  "Eri",
  "Cam",
  "Per",
  "Cam",
  "Cam",
  "Eri",
  "For",
  "Tau",
  "Tau",
  "For",
  "Eri",
  "Tau",
  "For",
  "Cam",
  "Eri",
  "Eri",
  "Eri",
  "Per",
  "Men",
  "Tau",
  "Tau",
  "Eri",
  "Tau",
  "Per",
  "Cam",
  "Eri",
  "For",
  "Tau",
  "Eri",
  "Cas",
  "Eri",
  "Tau",
  "Eri",
  "Tau",
  "Tau",
  "Eri",
  "Eri",
  "Tau",
  "Per",
  "Eri",
  "Cam",
  "Hor",
  "For",
  "Tau",
  "Per",
  "Oct",
  "Cam",
  "Eri",
  "Per",
  "Eri",
  "Eri",
  "Tau",
  "Eri",
  "Per",
  "Ret",
  "Per",
  "Tau",
  "Eri",
  "Per",
  "Ret",
  "Per",
  "Tau",
  "Hor",
  "Tau",
  "Eri",
  "Tau",
  "Per",
  "Tau",
  "Hor",
  "Hyi",
  "Per",
  "Tau",
  "Tau",
  "Tau",
  "Per",
  "Cam",
  "Cam",
  "Tau",
  "Eri",
  "Tau",
  "Tau",
  "For",
  "Eri",
  "Hyi",
  "Tau",
  "Cam",
  "Eri",
  "Per",
  "Eri",
  "For",
  "Tau",
  "Tau",
  "Per",
  "Tau",
  "Eri",
  "Eri",
  "Eri",
  "Tau",
  "Per",
  "Tau",
  "Tau",
  "Cam",
  "Cam",
  "Eri",
  "Cam",
  "Per",
  "Cam",
  "Tau",
  "Tau",
  "Per",
  "Eri",
  "Tau",
  "Cam",
  "Tau",
  "Cam",
  "Per",
  "Tau",
  "Per",
  "Eri",
  "Tau",
  "Eri",
  "Hor",
  "Tau",
  "Per",
  "Eri",
  "Eri",
  "Cam",
  "Per",
  "Eri",
  "Eri",
  "Dor",
  "Eri",
  "Per",
  "Ret",
  "Eri",
  "Per",
  "Cam",
  "Per",
  "Eri",
  "Tau",
  "Tau",
  "Tau",
  "Cam",
  "Cam",
  "Tau",
  "Per",
  "Eri",
  "Per",
  "Ret",
  "Ret",
  "Eri",
  "Per",
  "Eri",
  "Tau",
  "Eri",
  "Tau",
  "Eri",
  "Tau",
  "Tau",
  "Ret",
  "Per",
  "Ret",
  "Eri",
  "Tau",
  "Eri",
  "Tau",
  "Eri",
  "Tau",
  "Tau",
  "Eri",
  "Tau",
  "Tau",
  "Eri",
  "Cam",
  "Eri",
  "Tau",
  "Tau",
  "Eri",
  "Eri",
  "Eri",
  "Cam",
  "Per",
  "Tau",
  "Cam",
  "Cam",
  "Tau",
  "Cam",
  "Ret",
  "Tau",
  "Tau",
  "Per",
  "Per",
  "Per",
  "Tau",
  "Tau",
  "Eri",
  "Cam",
  "Cam",
  "Tau",
  "Cep",
  "Cep",
  "Eri",
  "Eri",
  "Eri",
  "Tau",
  "Hor",
  "Per",
  "Tau",
  "Eri",
  "Eri",
  "Eri",
  "Eri",
  "Tau",
  "Tau",
  "Cam",
  "Tau",
  "Tau",
  "Hor",
  "Eri",
  "Cam",
  "Tau",
  "Tau",
  "Per",
  "Hor",
  "Eri",
  "Ret",
  "Tau",
  "Ret",
  "Per",
  "Per",
  "Per",
  "Cam",
  "Eri",
  "Tau",
  "Tau",
  "Tau",
  "Dor",
  "Ret",
  "Ret",
  "Cam",
  "Cam",
  "Cam",
  "Tau",
  "Eri",
  "Ret",
  "Cep",
  "Eri",
  "Men",
  "Per",
  "Per",
  "Eri",
  "Tau",
  "Eri",
  "Dor",
  "Eri",
  "Per",
  "Hor",
  "Tau",
  "Tau",
  "Tau",
  "Tau",
  "Tau",
  "Per",
  "Per",
  "Per",
  "Tau",
  "Per",
  "Tau",
  "Tau",
  "Eri",
  "Eri",
  "Cam",
  "Tau",
  "Eri",
  "Tau",
  "Men",
  "Eri",
  "Eri",
  "Per",
  "Eri",
  "Cam",
  "Cam",
  "Ret",
  "Tau",
  "Tau",
  "Tau",
  "Tau",
  "Cam",
  "Eri",
  "Eri",
  "Tau",
  "Tau",
  "Per",
  "Eri",
  "Tau",
  "Tau",
  "Eri",
  "Tau",
  "Dor",
  "Tau",
  "Per",
  "Per",
  "Tau",
  "Ret",
  "Cae",
  "Tau",
  "Tau",
  "Tau",
  "Tau",
  "Tau",
  "Per",
  "Tau",
  "Tau",
  "Tau",
  "Tau",
  "Eri",
  "Tau",
  "Cam",
  "Cep",
  "Cae",
  "Tau",
  "Tau",
  "Ret",
  "Tau",
  "Tau",
  "Cae",
  "Cep",
  "Tau",
  "Tau",
  "Tau",
  "Tau",
  "Tau",
  "Eri",
  "Tau",
  "Tau",
  "Tau",
  "Eri",
  "Cae",
  "Cep",
  "Tau",
  "Tau",
  "Eri",
  "Tau",
  "Tau",
  "Per",
  "Tau",
  "Eri",
  "Tau",
  "Cae",
  "Tau",
  "Per",
  "Eri",
  "Tau",
  "Eri",
  "Per",
  "Cam",
  "Tau",
  "Eri",
  "Eri",
  "Per",
  "Cam",
  "Eri",
  "Tau",
  "Ret",
  "Tau",
  "Tau",
  "Eri",
  "Dor",
  "Tau",
  "Eri",
  "Eri",
  "Eri",
  "Tau",
  "Eri",
  "Eri",
  "Eri",
  "Tau",
  "Tau",
  "Tau",
  "Eri",
  "Eri",
  "Cam",
  "Tau",
  "Per",
  "Dor",
  "Eri",
  "Tau",
  "Tau",
  "Cae",
  "Eri",
  "Tau",
  "Tau",
  "Eri",
  "Tau",
  "Men",
  "Eri",
  "Pic",
  "Tau",
  "Tau",
  "Tau",
  "Eri",
  "Tau",
  "Eri",
  "Cam",
  "Cam",
  "Tau",
  "Eri",
  "Eri",
  "Cae",
  "Tau",
  "Per",
  "Per",
  "Cae",
  "Tau",
  "Pic",
  "Per",
  "Men",
  "Cae",
  "Tau",
  "Per",
  "Eri",
  "Cae",
  "Aur",
  "Eri",
  "Eri",
  "Per",
  "Dor",
  "Ori",
  "Dor",
  "Eri",
  "Eri",
  "Tau",
  "Cae",
  "Cam",
  "Ori",
  "Tau",
  "Ori",
  "Eri",
  "Per",
  "Eri",
  "Cae",
  "Cam",
  "Cam",
  "Eri",
  "Eri",
  "Ori",
  "Cam",
  "Aur",
  "Aur",
  "Eri",
  "Tau",
  "Ori",
  "Per",
  "Eri",
  "Cae",
  "Cam",
  "Ori",
  "Pic",
  "Pic",
  "Aur",
  "Ori",
  "Tau",
  "Cae",
  "Ori",
  "Ori",
  "Cam",
  "Ori",
  "Aur",
  "Tau",
  "Aur",
  "Eri",
  "Men",
  "Cam",
  "Ori",
  "Dor",
  "Cam",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Aur",
  "Dor",
  "Ori",
  "Cae",
  "Tau",
  "Cam",
  "Eri",
  "Men",
  "Eri",
  "Ori",
  "Ori",
  "Cam",
  "Ori",
  "Tau",
  "Aur",
  "Ori",
  "Eri",
  "Aur",
  "Ori",
  "Cam",
  "Tau",
  "Eri",
  "Tau",
  "Tau",
  "Ori",
  "Ori",
  "Men",
  "Ori",
  "Lep",
  "Aur",
  "Cam",
  "Eri",
  "Eri",
  "Men",
  "Aur",
  "Cep",
  "Aur",
  "Ori",
  "Eri",
  "Lep",
  "Eri",
  "Cae",
  "Cam",
  "Ori",
  "Aur",
  "Ori",
  "Lep",
  "Cam",
  "Cae",
  "Aur",
  "Men",
  "Lep",
  "Eri",
  "Pic",
  "Cam",
  "Tau",
  "Aur",
  "Cam",
  "Lep",
  "Lep",
  "Cae",
  "Cam",
  "Aur",
  "Tau",
  "Cae",
  "Cae",
  "Ori",
  "Cam",
  "Ori",
  "Pic",
  "Pic",
  "Lep",
  "Ori",
  "Lep",
  "Dor",
  "Tau",
  "Aur",
  "Cam",
  "Men",
  "Cam",
  "Cam",
  "Aur",
  "Lep",
  "Aur",
  "Eri",
  "Aur",
  "Lep",
  "Lep",
  "Tau",
  "Dor",
  "Ori",
  "Tau",
  "Lep",
  "Eri",
  "Ori",
  "Tau",
  "Tau",
  "Lep",
  "Eri",
  "Eri",
  "Eri",
  "Ori",
  "Cam",
  "Ori",
  "Cam",
  "Tau",
  "Ori",
  "Aur",
  "Aur",
  "Lep",
  "Ori",
  "Ori",
  "Lep",
  "Aur",
  "Ori",
  "Ori",
  "Lep",
  "Cam",
  "Ori",
  "Lep",
  "Cam",
  "Lep",
  "Ori",
  "Aur",
  "Aur",
  "Cam",
  "Ori",
  "Dor",
  "Ori",
  "Pic",
  "Lep",
  "Col",
  "Ori",
  "Cam",
  "Ori",
  "Aur",
  "Cam",
  "Ori",
  "Lep",
  "Aur",
  "Men",
  "Tau",
  "Pic",
  "Ori",
  "Lep",
  "Aur",
  "Ori",
  "Aur",
  "Col",
  "Ori",
  "Lep",
  "Aur",
  "Cam",
  "Aur",
  "Aur",
  "Aur",
  "Lep",
  "Aur",
  "Aur",
  "Ori",
  "Tau",
  "Tau",
  "Lep",
  "Pic",
  "Col",
  "Aur",
  "Cam",
  "Lep",
  "Ori",
  "Lep",
  "Aur",
  "Aur",
  "Aur",
  "Col",
  "Cam",
  "Ori",
  "Lep",
  "Cam",
  "Ori",
  "Tau",
  "Tau",
  "Aur",
  "Col",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Lep",
  "Aur",
  "Lep",
  "Pic",
  "Cam",
  "Ori",
  "Aur",
  "Lep",
  "Ori",
  "Aur",
  "Col",
  "Cam",
  "Lep",
  "Ori",
  "Tau",
  "Ori",
  "Ori",
  "Ori",
  "Tau",
  "Lep",
  "Ori",
  "Ori",
  "Ori",
  "Aur",
  "Aur",
  "Aur",
  "Aur",
  "Ori",
  "Pic",
  "Pic",
  "Cam",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Lep",
  "Ori",
  "Tau",
  "Tau",
  "Dor",
  "Ori",
  "Aur",
  "Ori",
  "Aur",
  "Aur",
  "Dor",
  "Lep",
  "Col",
  "Aur",
  "Tau",
  "Ori",
  "Ori",
  "Lep",
  "Tau",
  "Aur",
  "Tau",
  "Aur",
  "Ori",
  "Tau",
  "Lep",
  "Col",
  "Ori",
  "Ori",
  "Tau",
  "Ori",
  "Aur",
  "Ori",
  "Ori",
  "Ori",
  "Pic",
  "Cam",
  "Men",
  "Dor",
  "Ori",
  "Ori",
  "Ori",
  "Tau",
  "Aur",
  "Ori",
  "Aur",
  "Lep",
  "Col",
  "Ori",
  "Ori",
  "Pic",
  "Cep",
  "Men",
  "Ori",
  "Ori",
  "Tau",
  "Tau",
  "Cam",
  "Ori",
  "Ori",
  "Aur",
  "Lep",
  "Col",
  "Dor",
  "Col",
  "Aur",
  "Ori",
  "Tau",
  "Dor",
  "Aur",
  "Tau",
  "Pic",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Men",
  "Ori",
  "Dor",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Col",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Tau",
  "Ori",
  "Men",
  "Ori",
  "Tau",
  "Pic",
  "Col",
  "Ori",
  "Aur",
  "Aur",
  "Ori",
  "Aur",
  "Ori",
  "Dor",
  "Tau",
  "Ori",
  "Lep",
  "Men",
  "Tau",
  "Cam",
  "Cam",
  "Col",
  "Ori",
  "Ori",
  "Tau",
  "Col",
  "Aur",
  "Ori",
  "Ori",
  "Pic",
  "Ori",
  "Aur",
  "Col",
  "Ori",
  "Ori",
  "Tau",
  "Aur",
  "Ori",
  "Lep",
  "Aur",
  "Tau",
  "Ori",
  "Ori",
  "Col",
  "Cam",
  "Tau",
  "Col",
  "Aur",
  "Ori",
  "Aur",
  "Ori",
  "Ori",
  "Ori",
  "Ori",
  "Tau",
  "Aur",
  "Aur",
  "Col",
  "Ori",
  "Lep",
  "Tau",
  "Col",
  "Lep",
  "Lep",
  "Col",
  "Cam",
  "Ori",
  "Ori",
  "Cam",
  "Ori",
  "Tau",
  "Lep",
  "Col",
  "Pic",
  "Cam",
  "Lep",
  "Lep",
  "Dor",
  "Tau",
  "Ori",
  "Aur",
  "Aur",
  "Col",
  "Ori",
  "Pic",
  "Cam",
  "Ori",
  "Tau",
  "Ori",
  "Lep",
  "Aur",
  "Col",
  "Lep",
  "Tau",
  "Pic",
  "Aur",
  "Pic",
  "Col",
  "Tau",
  "Ori",
  "Cam",
  "Tau",
  "Tau",
  "Ori",
  "Ori",
  "Tau",
  "Ori",
  "Tau",
  "Cam",
  "Aur",
  "Tau",
  "Pic",
  "Lep",
  "Pic",
  "Lep",
  "Dor",
  "Ori",
  "Ori",
  "Men",
  "Pic",
  "Tau",
  "Ori",
  "Pic",
  "Aur",
  "Col",
  "Tau",
  "Aur",
  "Lep",
  "Ori",
  "Dor",
  "Aur",
  "Lep",
  "Aur",
  "Col",
  "Ori",
  "Cam",
  "Pic",
  "Tau",
  "Ori",
  "Ori",
  "Col",
  "Aur",
  "Aur",
  "Cam",
  "Col",
  "Tau",
  "Dor",
  "Ori",
  "Col",
  "Ori",
  "Ori",
  "Pic",
  "Lep",
  "Ori",
  "Pic",
  "Aur",
  "Col",
  "Ori",
  "Cam",
  "Aur",
  "Ori",
  "Col",
  "Ori",
  "Ori",
  "Lep",
  "Col",
  "Lep",
  "Ori",
  "Aur",
  "Lep",
  "Col",
  "Ori",
  "Tau",
  "Pic",
  "Col",
  "Cam",
  "Ori",
  "Tau",
  "Ori",
  "Ori",
  "Pic",
  "Ori",
  "Ori",
  "Mon",
  "Mon",
  "Col",
  "Aur",
  "Aur",
  "Aur",
  "Aur",
  "Aur",
  "Aur",
  "Aur",
  "Ori",
  "Lep",
  "Aur",
  "Pic",
  "Aur",
  "Gem",
  "Aur",
  "Lep",
  "Col",
  "Cep",
  "Gem",
  "Aur",
  "Mon",
  "Pic",
  "Ori",
  "Lep",
  "Aur",
  "Aur",
  "Aur",
  "Aur",
  "Cam",
  "Lep",
  "Aur",
  "Ori",
  "Ori",
  "Ori",
  "Gem",
  "Mon",
  "Col",
  "Pup",
  "Aur",
  "Pup",
  "Ori",
  "Ori",
  "Lep",
  "Aur",
  "Aur",
  "Cam",
  "Cam",
  "Mon",
  "Col",
  "Aur",
  "Col",
  "Aur",
  "Lep",
  "Dor",
  "Aur",
  "Lep",
  "Aur",
  "Mon",
  "Cam",
  "Col",
  "Lep",
  "Pup",
  "Pic",
  "Col",
  "Aur",
  "Col",
  "Ori",
  "Lep",
  "Col",
  "Aur",
  "Pup",
  "Dor",
  "Mon",
  "Lep",
  "Ori",
  "Lep",
  "Pup",
  "Gem",
  "Lep",
  "Mon",
  "Gem",
  "Lep",
  "Lep",
  "Cam",
  "Col",
  "Men",
  "Pic",
  "Lep",
  "Pup",
  "Mon",
  "Ori",
  "Cam",
  "Lep",
  "Dor",
  "Ori",
  "Gem",
  "Aur",
  "Mon",
  "Aur",
  "Mon",
  "Ori",
  "Ori",
  "Ori",
  "Aur",
  "Cam",
  "Ori",
  "Ori",
  "CMa",
  "Aur",
  "Ori",
  "Ori",
  "Mon",
  "Ori",
  "Mon",
  "Gem",
  "CMa",
  "Ori",
  "CMa",
  "Aur",
  "Ori",
  "Mon",
  "Mon",
  "Ori",
  "Ori",
  "Cam",
  "CMa",
  "Ori",
  "Ori",
  "CMa",
  "Pic",
  "Gem",
  "Ori",
  "Ori",
  "Col",
  "Col",
  "Gem",
  "Col",
  "CMa",
  "Ori",
  "Col",
  "Ori",
  "CMa",
  "Car",
  "Lyn",
  "Ori",
  "CMa",
  "Aur",
  "Ori",
  "CMa",
  "Mon",
  "Cam",
  "CMa",
  "Ori",
  "Mon",
  "Lyn",
  "CMa",
  "Col",
  "Mon",
  "Ori",
  "Ori",
  "CMa",
  "CMa",
  "Col",
  "CMa",
  "Aur",
  "CMa",
  "Mon",
  "Gem",
  "Aur",
  "Lyn",
  "Col",
  "Ori",
  "Dor",
  "CMa",
  "Pic",
  "Gem",
  "Pic",
  "Lyn",
  "CMa",
  "Mon",
  "Mon",
  "Mon",
  "CMa",
  "Pic",
  "CMa",
  "Car",
  "Col",
  "Mon",
  "CMa",
  "Pic",
  "CMa",
  "Pic",
  "Gem",
  "CMa",
  "Col",
  "Ori",
  "Aur",
  "Pic",
  "Mon",
  "Mon",
  "Ori",
  "Dor",
  "Col",
  "Gem",
  "Pup",
  "Mon",
  "Mon",
  "Mon",
  "Mon",
  "Lyn",
  "Mon",
  "Mon",
  "CMa",
  "Mon",
  "Lyn",
  "Mon",
  "Pic",
  "Col",
  "CMa",
  "Mon",
  "Mon",
  "Mon",
  "Aur",
  "Gem",
  "Mon",
  "CMa",
  "Cam",
  "Mon",
  "Mon",
  "Gem",
  "Aur",
  "CMa",
  "CMa",
  "Col",
  "Mon",
  "Gem",
  "Mon",
  "Pic",
  "Pup",
  "Aur",
  "Dor",
  "Mon",
  "CMa",
  "CMa",
  "CMa",
  "Lyn",
  "Col",
  "Mon",
  "Pic",
  "Col",
  "Car",
  "CMa",
  "CMa",
  "Col",
  "Gem",
  "Mon",
  "Mon",
  "CMa",
  "Pic",
  "Gem",
  "Mon",
  "Col",
  "Mon",
  "Mon",
  "Aur",
  "CMa",
  "CMa",
  "Mon",
  "Col",
  "Car",
  "CMa",
  "Gem",
  "Mon",
  "Col",
  "Lyn",
  "CMa",
  "Mon",
  "Car",
  "CMa",
  "Aur",
  "Mon",
  "Mon",
  "Col",
  "CMa",
  "Col",
  "CMa",
  "Aur",
  "Mon",
  "CMa",
  "CMa",
  "CMa",
  "Col",
  "Col",
  "Col",
  "Mon",
  "Gem",
  "Mon",
  "Lyn",
  "Mon",
  "CMa",
  "Lyn",
  "Gem",
  "Pup",
  "CMa",
  "Mon",
  "CMa",
  "Cam",
  "Pic",
  "Mon",
  "CMa",
  "Aur",
  "CMa",
  "Pup",
  "Mon",
  "Aur",
  "Aur",
  "Gem",
  "CMa",
  "Aur",
  "Gem",
  "Aur",
  "CMa",
  "CMa",
  "Gem",
  "Aur",
  "Men",
  "Cam",
  "Cam",
  "Vol",
  "Mon",
  "Mon",
  "Pup",
  "Mon",
  "Gem",
  "Gem",
  "Aur",
  "Mon",
  "Mon",
  "Pup",
  "Gem",
  "CMa",
  "Aur",
  "Mon",
  "Aur",
  "Pup",
  "Vol",
  "Mon",
  "Gem",
  "Gem",
  "Lyn",
  "Aur",
  "Car",
  "CMa",
  "Gem",
  "CMa",
  "Vol",
  "CMa",
  "Gem",
  "CMa",
  "CMa",
  "CMa",
  "Car",
  "Gem",
  "CMa",
  "Pup",
  "Lyn",
  "Cam",
  "Mon",
  "Mon",
  "Car",
  "Aur",
  "Lyn",
  "CMa",
  "Car",
  "Oct",
  "CMa",
  "Car",
  "Mon",
  "Pup",
  "Gem",
  "Mon",
  "Aur",
  "Mon",
  "Pic",
  "Lyn",
  "Mon",
  "CMa",
  "Mon",
  "Mon",
  "Gem",
  "CMa",
  "Aur",
  "Gem",
  "CMa",
  "Car",
  "Pup",
  "Pup",
  "Pic",
  "CMa",
  "CMa",
  "Gem",
  "CMa",
  "Mon",
  "Aur",
  "Mon",
  "Pup",
  "Cam",
  "Vol",
  "Pup",
  "Gem",
  "Mon",
  "Pup",
  "Gem",
  "Mon",
  "Car",
  "Pup",
  "Gem",
  "Mon",
  "CMa",
  "Aur",
  "Aur",
  "Lyn",
  "Aur",
  "Aur",
  "CMa",
  "CMa",
  "Mon",
  "CMa",
  "CMa",
  "Cam",
  "CMa",
  "Aur",
  "Pup",
  "CMa",
  "Mon",
  "CMa",
  "Mon",
  "Pup",
  "Gem",
  "Mon",
  "Mon",
  "CMa",
  "Aur",
  "Aur",
  "Gem",
  "Mon",
  "CMa",
  "CMa",
  "CMa",
  "CMa",
  "CMa",
  "Pup",
  "Mon",
  "Aur",
  "Men",
  "Pup",
  "Aur",
  "Mon",
  "Gem",
  "Lyn",
  "Lyn",
  "Pup",
  "Aur",
  "Gem",
  "CMa",
  "Lyn",
  "CMa",
  "CMa",
  "Pup",
  "CMa",
  "Car",
  "CMa",
  "Mon",
  "Car",
  "Pup",
  "CMa",
  "Gem",
  "Mon",
  "Aur",
  "Mon",
  "Gem",
  "CMa",
  "Vol",
  "Cam",
  "CMa",
  "Gem",
  "Mon",
  "Mon",
  "Mon",
  "CMa",
  "Pup",
  "Car",
  "Car",
  "CMa",
  "Cam",
  "CMa",
  "Mon",
  "Mon",
  "Pup",
  "Gem",
  "Gem",
  "Gem",
  "Gem",
  "Mon",
  "CMa",
  "Car",
  "Mon",
  "Gem",
  "Gem",
  "CMa",
  "Gem",
  "Pup",
  "Pup",
  "Mon",
  "Pup",
  "Mon",
  "Gem",
  "Car",
  "CMa",
  "Lyn",
  "Pup",
  "Gem",
  "Pup",
  "Mon",
  "Lyn",
  "Mon",
  "Cam",
  "CMa",
  "Lyn",
  "Pup",
  "Gem",
  "Vol",
  "CMa",
  "CMa",
  "CMa",
  "Mon",
  "Pup",
  "Car",
  "Car",
  "Gem",
  "CMa",
  "Gem",
  "CMi",
  "Gem",
  "Gem",
  "CMa",
  "Aur",
  "Vol",
  "Vol",
  "Pup",
  "Mon",
  "CMa",
  "CMa",
  "Gem",
  "CMa",
  "Mon",
  "CMa",
  "Pup",
  "Gem",
  "Gem",
  "Mon",
  "Aur",
  "CMa",
  "Gem",
  "CMi",
  "Mon",
  "Car",
  "CMa",
  "CMi",
  "CMa",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Gem",
  "CMa",
  "Pup",
  "Gem",
  "Lyn",
  "CMa",
  "Pup",
  "CMa",
  "CMa",
  "CMa",
  "Cam",
  "Mon",
  "CMa",
  "Mon",
  "CMi",
  "Mon",
  "CMi",
  "Pup",
  "Gem",
  "Pup",
  "CMa",
  "CMa",
  "Pup",
  "Mon",
  "CMa",
  "Car",
  "CMi",
  "Mon",
  "CMa",
  "Lyn",
  "Lyn",
  "Gem",
  "CMa",
  "Pup",
  "Pup",
  "CMa",
  "CMa",
  "CMa",
  "Pup",
  "Vol",
  "CMa",
  "Gem",
  "Pup",
  "Mon",
  "Lyn",
  "Aur",
  "CMa",
  "Aur",
  "Gem",
  "Pup",
  "Gem",
  "Pup",
  "Lyn",
  "Pup",
  "Pup",
  "CMa",
  "CMa",
  "CMa",
  "CMa",
  "Pup",
  "CMi",
  "CMa",
  "CMi",
  "Gem",
  "Gem",
  "Car",
  "Car",
  "CMa",
  "CMa",
  "Aur",
  "CMa",
  "Lyn",
  "Gem",
  "Mon",
  "Aur",
  "CMi",
  "Aur",
  "CMa",
  "Cam",
  "Mon",
  "Mon",
  "CMi",
  "Lyn",
  "CMa",
  "Gem",
  "Gem",
  "CMa",
  "CMa",
  "Pup",
  "CMa",
  "Aur",
  "CMa",
  "Gem",
  "Gem",
  "Vol",
  "CMa",
  "CMa",
  "Pup",
  "CMa",
  "Lyn",
  "CMi",
  "CMa",
  "CMa",
  "Cam",
  "CMa",
  "Men",
  "CMi",
  "CMa",
  "Gem",
  "Mon",
  "Car",
  "CMi",
  "CMi",
  "Pup",
  "Lyn",
  "Gem",
  "CMa",
  "CMa",
  "CMi",
  "Cam",
  "Pup",
  "Gem",
  "CMa",
  "Pup",
  "Pup",
  "CMi",
  "CMi",
  "Gem",
  "Gem",
  "Pup",
  "Vol",
  "Lyn",
  "Lyn",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Mon",
  "Gem",
  "Pup",
  "Mon",
  "Mon",
  "CMi",
  "Gem",
  "Pup",
  "Lyn",
  "Car",
  "Car",
  "Pup",
  "Mon",
  "Cam",
  "Cam",
  "CMi",
  "Gem",
  "Mon",
  "CMi",
  "Pup",
  "Pup",
  "CMi",
  "Pup",
  "Pup",
  "Pup",
  "Lyn",
  "Gem",
  "Pup",
  "Pup",
  "Lyn",
  "Pup",
  "CMi",
  "Pup",
  "CMi",
  "Pup",
  "Pup",
  "Gem",
  "Car",
  "Gem",
  "Vol",
  "Pup",
  "Car",
  "Gem",
  "Lyn",
  "Car",
  "Pup",
  "Pup",
  "Mon",
  "Lyn",
  "CMi",
  "Pup",
  "Pup",
  "Lyn",
  "Mon",
  "Pup",
  "Lyn",
  "Pup",
  "Pup",
  "Lyn",
  "Gem",
  "Pup",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Pup",
  "Car",
  "Gem",
  "Gem",
  "CMi",
  "Pup",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Pup",
  "Lyn",
  "Pup",
  "Pup",
  "Cep",
  "Mon",
  "Gem",
  "Lyn",
  "Gem",
  "Lyn",
  "Mon",
  "Pup",
  "Pup",
  "Pup",
  "CMi",
  "Vol",
  "Gem",
  "Gem",
  "Car",
  "Gem",
  "Pup",
  "Car",
  "Pup",
  "Lyn",
  "CMi",
  "Pup",
  "Gem",
  "CMi",
  "Gem",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Lyn",
  "Gem",
  "CMi",
  "Pup",
  "Vol",
  "CMi",
  "Gem",
  "Pup",
  "Pup",
  "Vol",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Pup",
  "Car",
  "Pup",
  "Mon",
  "Gem",
  "Pup",
  "CMi",
  "Cam",
  "Pup",
  "Lyn",
  "Cam",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Car",
  "Pup",
  "Gem",
  "Pup",
  "Gem",
  "Car",
  "Pup",
  "Car",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "CMi",
  "Pup",
  "Pup",
  "Pup",
  "Vol",
  "Pup",
  "Pup",
  "Mon",
  "Pup",
  "Pup",
  "CMi",
  "CMi",
  "CMi",
  "Mon",
  "Pup",
  "Gem",
  "Lyn",
  "Lyn",
  "Pup",
  "Pup",
  "Pup",
  "CMi",
  "Pup",
  "Pup",
  "Gem",
  "Lyn",
  "CMi",
  "Pup",
  "Pup",
  "Pup",
  "Car",
  "Lyn",
  "Pup",
  "Mon",
  "Pup",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Lyn",
  "Pup",
  "Lyn",
  "Car",
  "Car",
  "Pup",
  "CMi",
  "Gem",
  "Lyn",
  "Pup",
  "Car",
  "Pup",
  "CMi",
  "Car",
  "Pup",
  "Pup",
  "Pup",
  "Cnc",
  "Car",
  "CMi",
  "CMi",
  "Pup",
  "Pup",
  "Pup",
  "Car",
  "Pup",
  "Pup",
  "CMi",
  "Pup",
  "Lyn",
  "CMi",
  "Car",
  "Cnc",
  "Car",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Vol",
  "Pup",
  "Cnc",
  "Car",
  "Car",
  "Mon",
  "Lyn",
  "Pup",
  "Cam",
  "Pup",
  "Car",
  "Pup",
  "Mon",
  "Cnc",
  "Cnc",
  "Car",
  "Cnc",
  "Cnc",
  "Mon",
  "Mon",
  "CMi",
  "Lyn",
  "Car",
  "Cnc",
  "Car",
  "Pup",
  "Cam",
  "Cnc",
  "CMi",
  "Lyn",
  "Pup",
  "CMi",
  "Mon",
  "Cam",
  "Lyn",
  "Pup",
  "Pup",
  "Pup",
  "Gem",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Vel",
  "Car",
  "Cnc",
  "Cam",
  "Car",
  "Cnc",
  "Vel",
  "Cnc",
  "Pup",
  "Mon",
  "Cnc",
  "Mon",
  "Vel",
  "Vel",
  "Lyn",
  "Pup",
  "Pup",
  "Pup",
  "Cnc",
  "Vol",
  "Car",
  "Lyn",
  "Mon",
  "Pup",
  "Cnc",
  "Pup",
  "Mon",
  "Car",
  "Pup",
  "Vel",
  "Pup",
  "Lyn",
  "Pup",
  "Vel",
  "Car",
  "Cnc",
  "Vel",
  "Vel",
  "Pup",
  "Lyn",
  "Cnc",
  "Vel",
  "Cnc",
  "Pup",
  "Cnc",
  "Pup",
  "Vel",
  "Pup",
  "Cnc",
  "Lyn",
  "Pup",
  "Pup",
  "Hya",
  "Vel",
  "Vel",
  "Cnc",
  "Vel",
  "UMa",
  "Pup",
  "Cnc",
  "Cnc",
  "Pup",
  "Hya",
  "Pup",
  "Vel",
  "Vel",
  "Pup",
  "Vel",
  "Lyn",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Cnc",
  "Pup",
  "Cnc",
  "Vel",
  "Vel",
  "Car",
  "Vel",
  "UMa",
  "Pup",
  "Pup",
  "Cnc",
  "Cam",
  "Pup",
  "Cnc",
  "Pup",
  "Lyn",
  "Car",
  "Pup",
  "Cnc",
  "Lyn",
  "Pup",
  "Vol",
  "Pup",
  "Cha",
  "Pup",
  "Vel",
  "Hya",
  "UMa",
  "Pup",
  "Cam",
  "Vol",
  "Hya",
  "Vol",
  "Cnc",
  "Hya",
  "Hya",
  "Cnc",
  "Lyn",
  "Pup",
  "Lyn",
  "Cnc",
  "Cha",
  "UMa",
  "Car",
  "Car",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Pup",
  "Vol",
  "Cam",
  "Hya",
  "Car",
  "Vel",
  "UMa",
  "Pup",
  "Pup",
  "Lyn",
  "Hya",
  "Vel",
  "Pup",
  "Cnc",
  "Lyn",
  "Cnc",
  "Cha",
  "Cam",
  "Hya",
  "Hya",
  "Lyn",
  "Pup",
  "Pup",
  "Pup",
  "Lyn",
  "Pup",
  "Vel",
  "Hya",
  "Pup",
  "Hya",
  "Vol",
  "Cnc",
  "Vol",
  "Pup",
  "Cnc",
  "Pup",
  "Pup",
  "Vel",
  "Hya",
  "Cnc",
  "Pup",
  "Cnc",
  "Cnc",
  "Vel",
  "Pyx",
  "Vol",
  "Vel",
  "Lyn",
  "Pyx",
  "Hya",
  "Hya",
  "Pyx",
  "Cnc",
  "Cnc",
  "Hya",
  "Vel",
  "Vel",
  "Vel",
  "Car",
  "Car",
  "Vel",
  "UMa",
  "UMa",
  "Pyx",
  "Vel",
  "Vel",
  "Lyn",
  "Vel",
  "Vel",
  "Cnc",
  "Pyx",
  "Cnc",
  "Cnc",
  "Vel",
  "Hya",
  "Lyn",
  "Cnc",
  "Vel",
  "Vol",
  "Cnc",
  "Pyx",
  "UMa",
  "Lyn",
  "Pyx",
  "Cnc",
  "Vel",
  "Pyx",
  "Vel",
  "Lyn",
  "Vel",
  "Vel",
  "Hya",
  "Cnc",
  "Hya",
  "Cnc",
  "Vel",
  "Pyx",
  "Pyx",
  "UMa",
  "Vel",
  "Lyn",
  "Vel",
  "Car",
  "Car",
  "Hya",
  "Hya",
  "Pyx",
  "Cnc",
  "Vel",
  "Cnc",
  "Cam",
  "Cnc",
  "Car",
  "Hya",
  "Vel",
  "Hya",
  "Pyx",
  "Cnc",
  "UMa",
  "Pyx",
  "Vel",
  "Hya",
  "UMa",
  "Vol",
  "Pyx",
  "UMa",
  "UMa",
  "Car",
  "UMa",
  "Pyx",
  "Vel",
  "Cnc",
  "Pyx",
  "Cam",
  "Vel",
  "Hya",
  "Pyx",
  "Cnc",
  "UMa",
  "Vel",
  "Vel",
  "Cnc",
  "Vel",
  "Cnc",
  "Cnc",
  "Vel",
  "Car",
  "Vel",
  "Car",
  "Lyn",
  "Vel",
  "Vel",
  "Cha",
  "Hya",
  "Vel",
  "Hya",
  "Vel",
  "Vel",
  "Car",
  "Vel",
  "Pyx",
  "UMa",
  "Cha",
  "Cnc",
  "Hya",
  "Cnc",
  "Pyx",
  "Vel",
  "Hya",
  "Vol",
  "Hya",
  "Vel",
  "Vol",
  "Cnc",
  "Vel",
  "Cnc",
  "Pyx",
  "Pyx",
  "Hya",
  "Car",
  "Hya",
  "Cnc",
  "Hya",
  "Pyx",
  "Cha",
  "Vel",
  "Hya",
  "Hya",
  "Hya",
  "Vel",
  "Vel",
  "Cnc",
  "Car",
  "Hya",
  "Pyx",
  "Cnc",
  "Hya",
  "Vel",
  "Hya",
  "Vel",
  "Vel",
  "Hya",
  "Vel",
  "Pyx",
  "Hya",
  "Hya",
  "UMa",
  "Hya",
  "Vel",
  "Pyx",
  "Vel",
  "Vol",
  "Pyx",
  "Vel",
  "Pyx",
  "Vel",
  "Pyx",
  "Pyx",
  "Lyn",
  "Vel",
  "Vol",
  "Cnc",
  "Cnc",
  "Hya",
  "Car",
  "Vel",
  "Vel",
  "Lyn",
  "Lyn",
  "Lyn",
  "Hya",
  "Pyx",
  "Cnc",
  "Hya",
  "Cnc",
  "Cnc",
  "Vel",
  "Pyx",
  "Vel",
  "Vel",
  "Car",
  "Hya",
  "UMa",
  "UMa",
  "Car",
  "Vel",
  "Vel",
  "Lyn",
  "Cnc",
  "Hya",
  "Car",
  "Car",
  "Vel",
  "Hya",
  "Vel",
  "Cnc",
  "Hya",
  "Hya",
  "Pyx",
  "Cnc",
  "Hya",
  "Cnc",
  "Pyx",
  "Vel",
  "Lyn",
  "Hya",
  "Hya",
  "UMa",
  "Oct",
  "Lyn",
  "Cnc",
  "Car",
  "Cnc",
  "Cnc",
  "Cnc",
  "Cnc",
  "Vel",
  "Cnc",
  "Cnc",
  "Hya",
  "Vel",
  "Cnc",
  "UMa",
  "Pyx",
  "Car",
  "Cnc",
  "Cnc",
  "Hya",
  "Vel",
  "Vel",
  "Lyn",
  "Lyn",
  "Car",
  "Vol",
  "Pyx",
  "Vel",
  "Cnc",
  "Hya",
  "Lyn",
  "Vel",
  "Cnc",
  "Hya",
  "Vel",
  "Vol",
  "UMa",
  "Cnc",
  "Cnc",
  "Vel",
  "UMa",
  "UMa",
  "Vel",
  "Vel",
  "Car",
  "Cnc",
  "Car",
  "UMa",
  "Car",
  "Hya",
  "Car",
  "Lyn",
  "Vel",
  "UMa",
  "Hya",
  "Cnc",
  "Cnc",
  "Vel",
  "Cnc",
  "Pyx",
  "Cnc",
  "UMa",
  "Hya",
  "Pyx",
  "Hya",
  "Cnc",
  "Lyn",
  "UMa",
  "Hya",
  "Hya",
  "Cnc",
  "Hya",
  "Vel",
  "Cnc",
  "Pyx",
  "Vel",
  "Cnc",
  "UMa",
  "Cnc",
  "UMa",
  "Car",
  "Vel",
  "Cam",
  "Car",
  "Vel",
  "Vel",
  "Hya",
  "Hya",
  "Cha",
  "Hya",
  "Cnc",
  "Hya",
  "Vel",
  "Car",
  "Car",
  "Car",
  "Vel",
  "Pyx",
  "Vel",
  "Vel",
  "Cnc",
  "Lyn",
  "Hya",
  "Vel",
  "Vel",
  "UMa",
  "Hya",
  "Vel",
  "Vel",
  "Cnc",
  "Lyn",
  "Vel",
  "Car",
  "Cam",
  "Hya",
  "Car",
  "Vel",
  "Vel",
  "UMa",
  "UMa",
  "Vel",
  "UMa",
  "Car",
  "Vel",
  "Hya",
  "Hya",
  "Hya",
  "Vel",
  "Car",
  "Hya",
  "Car",
  "Car",
  "Car",
  "UMa",
  "Vel",
  "Cnc",
  "Car",
  "Vel",
  "Lyn",
  "Vel",
  "Lyn",
  "Vel",
  "Hya",
  "Hya",
  "Pyx",
  "Cam",
  "Hya",
  "Vel",
  "UMa",
  "Hya",
  "Car",
  "Lyn",
  "Lyn",
  "UMa",
  "Cnc",
  "Pyx",
  "UMa",
  "Vel",
  "Vel",
  "Vel",
  "Vel",
  "Pyx",
  "Vel",
  "Car",
  "Leo",
  "Vel",
  "Vel",
  "Vel",
  "Car",
  "Cha",
  "Vel",
  "Car",
  "Leo",
  "UMa",
  "Vel",
  "Hya",
  "Car",
  "Leo",
  "UMa",
  "Vel",
  "Hya",
  "Vel",
  "Car",
  "Pyx",
  "Car",
  "Hya",
  "Hya",
  "Hya",
  "Car",
  "Dra",
  "Leo",
  "Leo",
  "Car",
  "UMa",
  "Car",
  "Hya",
  "Hya",
  "Hya",
  "Ant",
  "Ant",
  "Hya",
  "Hya",
  "UMa",
  "Hya",
  "Ant",
  "Vel",
  "Hya",
  "Car",
  "Vel",
  "LMi",
  "Ant",
  "Vel",
  "UMa",
  "Ant",
  "LMi",
  "Ant",
  "Car",
  "Car",
  "Hya",
  "Leo",
  "Hya",
  "Leo",
  "Leo",
  "Hya",
  "Ant",
  "Vel",
  "Hya",
  "Hya",
  "UMa",
  "Hya",
  "Hya",
  "Ant",
  "UMa",
  "Hya",
  "Leo",
  "Hya",
  "Hya",
  "LMi",
  "Vel",
  "Cha",
  "Leo",
  "Vel",
  "LMi",
  "Car",
  "UMa",
  "Hya",
  "UMa",
  "UMa",
  "Lyn",
  "Ant",
  "Hya",
  "LMi",
  "Leo",
  "Dra",
  "Vel",
  "Leo",
  "Vel",
  "Vel",
  "Ant",
  "Leo",
  "Dra",
  "Ant",
  "Vel",
  "Leo",
  "Ant",
  "UMa",
  "Hya",
  "Hya",
  "Dra",
  "Vel",
  "Lyn",
  "Hya",
  "Car",
  "UMa",
  "Car",
  "Hya",
  "Hya",
  "Hya",
  "Hya",
  "Car",
  "Car",
  "Leo",
  "UMa",
  "Hya",
  "Leo",
  "Leo",
  "Vel",
  "Lyn",
  "Car",
  "Hya",
  "UMa",
  "Ant",
  "LMi",
  "UMa",
  "UMa",
  "UMa",
  "Vel",
  "Leo",
  "Vel",
  "Leo",
  "Ant",
  "Leo",
  "UMa",
  "Car",
  "Ant",
  "Dra",
  "Car",
  "Leo",
  "Car",
  "Leo",
  "Cha",
  "Leo",
  "Sex",
  "Vel",
  "UMa",
  "Car",
  "Dra",
  "Leo",
  "Leo",
  "UMa",
  "Vel",
  "Ant",
  "Leo",
  "Ant",
  "Vel",
  "UMa",
  "Sex",
  "Vel",
  "Car",
  "UMa",
  "Cha",
  "Leo",
  "Car",
  "Sex",
  "Vel",
  "Sex",
  "Hya",
  "Vel",
  "Sex",
  "Leo",
  "Hya",
  "UMa",
  "Sex",
  "Sex",
  "Sex",
  "Leo",
  "Ant",
  "Vel",
  "Sex",
  "Vel",
  "Hya",
  "Vel",
  "Hya",
  "Vel",
  "Hya",
  "UMa",
  "UMa",
  "Vel",
  "Car",
  "Vel",
  "Leo",
  "Ant",
  "Hya",
  "Vel",
  "Ant",
  "Car",
  "Vel",
  "UMa",
  "LMi",
  "Vel",
  "Sex",
  "UMa",
  "Leo",
  "Leo",
  "UMa",
  "Leo",
  "Ant",
  "Hya",
  "Leo",
  "UMa",
  "Leo",
  "Vel",
  "Cha",
  "LMi",
  "Vel",
  "Vel",
  "Car",
  "Car",
  "Leo",
  "Car",
  "Car",
  "Vel",
  "Car",
  "Sex",
  "Hya",
  "Sex",
  "Hya",
  "Ant",
  "UMa",
  "Vel",
  "Hya",
  "UMa",
  "Ant",
  "Leo",
  "Vel",
  "Vel",
  "Sex",
  "Hya",
  "Leo",
  "LMi",
  "Vel",
  "Leo",
  "Sex",
  "Car",
  "Ant",
  "LMi",
  "Leo",
  "Cam",
  "Hya",
  "Car",
  "Vel",
  "Car",
  "Ant",
  "Hya",
  "Hya",
  "Sex",
  "Hya",
  "Vel",
  "Sex",
  "LMi",
  "LMi",
  "Sex",
  "Car",
  "Leo",
  "Car",
  "Ant",
  "Vel",
  "Hya",
  "Sex",
  "Car",
  "Hya",
  "Car",
  "Vel",
  "Vel",
  "Ant",
  "Vel",
  "Car",
  "Car",
  "Ant",
  "Leo",
  "Ant",
  "Hya",
  "Leo",
  "Vel",
  "LMi",
  "UMa",
  "Vel",
  "Ant",
  "Vel",
  "Car",
  "Sex",
  "LMi",
  "LMi",
  "Leo",
  "Vel",
  "Leo",
  "Leo",
  "Leo",
  "Car",
  "UMa",
  "Leo",
  "Vel",
  "Sex",
  "UMa",
  "Ant",
  "Vel",
  "UMa",
  "Ant",
  "Vel",
  "UMa",
  "Leo",
  "Car",
  "Hya",
  "UMa",
  "Sex",
  "Vel",
  "Car",
  "Leo",
  "Leo",
  "Sex",
  "UMa",
  "Vel",
  "UMa",
  "Vel",
  "UMa",
  "Hya",
  "Hya",
  "Leo",
  "Car",
  "UMa",
  "Hya",
  "Vel",
  "UMa",
  "Car",
  "Leo",
  "LMi",
  "Ant",
  "Sex",
  "Sex",
  "Ant",
  "Sex",
  "Vel",
  "LMi",
  "Car",
  "UMa",
  "LMi",
  "Sex",
  "Car",
  "Car",
  "Car",
  "Leo",
  "Vel",
  "Sex",
  "LMi",
  "LMi",
  "Hya",
  "Vel",
  "Sex",
  "Vel",
  "Leo",
  "Ant",
  "Car",
  "Car",
  "UMa",
  "Leo",
  "Car",
  "LMi",
  "Vel",
  "UMa",
  "Car",
  "UMa",
  "Sex",
  "Car",
  "Car",
  "Sex",
  "Hya",
  "Ant",
  "Cam",
  "UMa",
  "LMi",
  "Car",
  "Sex",
  "Car",
  "UMa",
  "UMa",
  "Car",
  "Sex",
  "Hya",
  "Car",
  "Cam",
  "Vel",
  "Hya",
  "LMi",
  "Vel",
  "Vel",
  "Car",
  "Leo",
  "Vel",
  "Car",
  "Leo",
  "Vel",
  "UMa",
  "Car",
  "LMi",
  "Hya",
  "Car",
  "Leo",
  "Hya",
  "Leo",
  "Dra",
  "UMa",
  "Vel",
  "Ant",
  "Cha",
  "Cha",
  "Car",
  "Hya",
  "Dra",
  "Hya",
  "Hya",
  "Car",
  "LMi",
  "Hya",
  "Hya",
  "Vel",
  "Vel",
  "Car",
  "Hya",
  "LMi",
  "Car",
  "Hya",
  "LMi",
  "Car",
  "Car",
  "Vel",
  "Hya",
  "Car",
  "UMa",
  "LMi",
  "Car",
  "Vel",
  "Car",
  "Car",
  "Ant",
  "Car",
  "Sex",
  "UMa",
  "Cha",
  "UMa",
  "LMi",
  "Car",
  "Hya",
  "Car",
  "Ant",
  "Car",
  "LMi",
  "UMa",
  "Sex",
  "LMi",
  "Car",
  "UMa",
  "UMa",
  "Car",
  "Car",
  "Car",
  "Leo",
  "Car",
  "Car",
  "Car",
  "Car",
  "UMa",
  "Sex",
  "Cha",
  "Cha",
  "LMi",
  "Leo",
  "Car",
  "Car",
  "UMa",
  "Leo",
  "Leo",
  "Car",
  "Vel",
  "Vel",
  "Car",
  "Car",
  "Hya",
  "Vel",
  "Car",
  "Car",
  "Car",
  "Car",
  "Car",
  "Hya",
  "Sex",
  "UMa",
  "LMi",
  "Leo",
  "Car",
  "UMa",
  "Hya",
  "Sex",
  "LMi",
  "Ant",
  "Sex",
  "Sex",
  "UMa",
  "UMa",
  "Car",
  "Leo",
  "Cha",
  "Car",
  "UMa",
  "Leo",
  "LMi",
  "Car",
  "Leo",
  "Hya",
  "Car",
  "UMa",
  "Crt",
  "Vel",
  "UMa",
  "Car",
  "Leo",
  "UMa",
  "Crt",
  "Car",
  "LMi",
  "UMa",
  "Vel",
  "Hya",
  "Car",
  "Vel",
  "Leo",
  "Leo",
  "UMa",
  "Leo",
  "UMa",
  "Leo",
  "LMi",
  "Ant",
  "Vel",
  "Car",
  "Car",
  "Car",
  "Hya",
  "Car",
  "Oct",
  "UMa",
  "UMa",
  "Crt",
  "UMa",
  "Crt",
  "Dra",
  "Vel",
  "Vel",
  "Vel",
  "Crt",
  "UMa",
  "UMa",
  "UMa",
  "Leo",
  "Vel",
  "Hya",
  "Leo",
  "UMa",
  "Crt",
  "UMa",
  "Leo",
  "UMa",
  "Vel",
  "Leo",
  "Hya",
  "Leo",
  "Crt",
  "Hya",
  "UMa",
  "Crt",
  "Leo",
  "UMa",
  "Car",
  "UMa",
  "Vel",
  "Ant",
  "Leo",
  "Vel",
  "Hya",
  "Crt",
  "Hya",
  "Cen",
  "Car",
  "Cen",
  "Car",
  "Car",
  "Leo",
  "Car",
  "Leo",
  "Cen",
  "Cen",
  "Leo",
  "Hya",
  "Car",
  "Car",
  "Hya",
  "Leo",
  "UMa",
  "UMa",
  "UMa",
  "UMa",
  "Hya",
  "Car",
  "Crt",
  "Leo",
  "Hya",
  "Car",
  "Cen",
  "UMa",
  "Hya",
  "Crt",
  "UMa",
  "Cen",
  "Crt",
  "Car",
  "Car",
  "Cen",
  "Cen",
  "Car",
  "Cen",
  "UMa",
  "Leo",
  "Leo",
  "Leo",
  "Leo",
  "Cen",
  "Leo",
  "Car",
  "Leo",
  "Cen",
  "Leo",
  "UMa",
  "Crt",
  "Cen",
  "Cen",
  "Leo",
  "Car",
  "Hya",
  "UMa",
  "Cha",
  "Leo",
  "UMa",
  "Car",
  "Crt",
  "Mus",
  "Mus",
  "Mus",
  "UMa",
  "Cen",
  "Leo",
  "UMa",
  "Cha",
  "Cen",
  "UMa",
  "UMa",
  "Cen",
  "Cen",
  "Leo",
  "Mus",
  "Crt",
  "Leo",
  "Cen",
  "Leo",
  "Mus",
  "Cen",
  "Crt",
  "Crt",
  "Leo",
  "Cen",
  "Cen",
  "Leo",
  "Cen",
  "Leo",
  "UMa",
  "UMa",
  "Cen",
  "Leo",
  "Cen",
  "Crt",
  "Leo",
  "Leo",
  "Hya",
  "Mus",
  "Cen",
  "UMa",
  "UMa",
  "Cen",
  "Crt",
  "Leo",
  "UMa",
  "Leo",
  "UMa",
  "Leo",
  "UMa",
  "UMa",
  "Cen",
  "Dra",
  "Leo",
  "Cen",
  "Crt",
  "Cen",
  "Cam",
  "Hya",
  "Mus",
  "UMa",
  "Hya",
  "Crt",
  "Cen",
  "Hya",
  "Hya",
  "Crt",
  "Leo",
  "Cen",
  "UMa",
  "Leo",
  "Hya",
  "Leo",
  "Cen",
  "Cen",
  "Leo",
  "Leo",
  "UMa",
  "Cen",
  "Cen",
  "Cen",
  "Cen",
  "Dra",
  "Leo",
  "Cen",
  "Hya",
  "Cen",
  "Crt",
  "Leo",
  "Cen",
  "Hya",
  "Cha",
  "Cen",
  "Dra",
  "Mus",
  "UMa",
  "Cen",
  "Vir",
  "Cen",
  "UMa",
  "Vir",
  "Vir",
  "UMa",
  "UMa",
  "Crt",
  "UMa",
  "UMa",
  "Crt",
  "Mus",
  "Crt",
  "Crt",
  "Hya",
  "UMa",
  "Cen",
  "Cen",
  "Leo",
  "Cen",
  "Cha",
  "UMa",
  "Hya",
  "Cen",
  "UMa",
  "UMa",
  "Hya",
  "Crt",
  "Mus",
  "Dra",
  "Cha",
  "Cen",
  "Cen",
  "Cen",
  "Vir",
  "Leo",
  "Crt",
  "Cen",
  "Vir",
  "Mus",
  "Cen",
  "Vir",
  "UMa",
  "Cen",
  "Cen",
  "UMa",
  "Cen",
  "Hya",
  "Cen",
  "Vir",
  "Leo",
  "Mus",
  "Crt",
  "Leo",
  "Hya",
  "Vir",
  "Leo",
  "Leo",
  "Cen",
  "UMa",
  "Mus",
  "Crt",
  "Cen",
  "Hya",
  "Vir",
  "Leo",
  "Vir",
  "Cen",
  "UMa",
  "Crt",
  "Hya",
  "Mus",
  "Cen",
  "Hya",
  "UMa",
  "Hya",
  "UMa",
  "Vir",
  "Cen",
  "Cen",
  "Hya",
  "Mus",
  "Cen",
  "Vir",
  "UMa",
  "Hya",
  "Leo",
  "Cen",
  "UMa",
  "Crt",
  "Cen",
  "UMa",
  "Hya",
  "Cru",
  "UMa",
  "Cru",
  "Cru",
  "Hya",
  "Vir",
  "Vir",
  "Cen",
  "Cen",
  "UMa",
  "Cru",
  "Cha",
  "Vir",
  "UMa",
  "Cam",
  "Crv",
  "Vir",
  "Crv",
  "Vir",
  "Vir",
  "Cru",
  "UMa",
  "UMa",
  "Oct",
  "Mus",
  "Mus",
  "Vir",
  "Cru",
  "Cen",
  "Vir",
  "Mus",
  "Com",
  "Cen",
  "Cru",
  "Cam",
  "Mus",
  "Cru",
  "Cha",
  "Cru",
  "Vir",
  "Cam",
  "UMa",
  "Mus",
  "Hya",
  "Vir",
  "Hya",
  "Mus",
  "Mus",
  "Cru",
  "Mus",
  "Cen",
  "Cen",
  "Cen",
  "Cru",
  "Crv",
  "Cen",
  "Cen",
  "Vir",
  "Dra",
  "Hya",
  "Vir",
  "Crv",
  "Com",
  "Cen",
  "Com",
  "Cam",
  "Mus",
  "Crv",
  "Cru",
  "Cen",
  "Cen",
  "UMa",
  "Com",
  "Com",
  "Com",
  "Cam",
  "Cru",
  "Mus",
  "Hya",
  "Cen",
  "Vir",
  "Hya",
  "Cha",
  "Cen",
  "Cru",
  "UMa",
  "Crv",
  "Hya",
  "Dra",
  "Cru",
  "Vir",
  "UMi",
  "UMa",
  "Cen",
  "Dra",
  "Crv",
  "Com",
  "CVn",
  "Com",
  "Mus",
  "Com",
  "UMi",
  "Crv",
  "Mus",
  "UMa",
  "Com",
  "Mus",
  "Com",
  "Cen",
  "Cha",
  "Cru",
  "Com",
  "Vir",
  "Dra",
  "Cen",
  "Com",
  "Com",
  "Com",
  "CVn",
  "Vir",
  "Crv",
  "Com",
  "Com",
  "Vir",
  "Mus",
  "Crv",
  "Com",
  "Com",
  "Com",
  "UMa",
  "Crv",
  "Cru",
  "CVn",
  "Cru",
  "Mus",
  "Com",
  "Mus",
  "Com",
  "Vir",
  "Cru",
  "Mus",
  "Vir",
  "Crv",
  "Crv",
  "Cen",
  "Cen",
  "Cen",
  "CVn",
  "Hya",
  "CVn",
  "Com",
  "Com",
  "Cen",
  "UMa",
  "Dra",
  "Cen",
  "Vir",
  "Com",
  "Mus",
  "Hya",
  "Cen",
  "Oct",
  "CVn",
  "Com",
  "Dra",
  "Cen",
  "Cru",
  "Cen",
  "Hya",
  "Com",
  "Com",
  "Cru",
  "Cru",
  "Cru",
  "UMa",
  "Vir",
  "Crv",
  "Vir",
  "Cen",
  "Cru",
  "Cen",
  "Cru",
  "Cru",
  "Com",
  "Com",
  "Com",
  "Crv",
  "Cru",
  "UMa",
  "Cen",
  "CVn",
  "UMa",
  "Crv",
  "Dra",
  "Crv",
  "UMa",
  "Com",
  "Cru",
  "Vir",
  "Vir",
  "Cru",
  "Cru",
  "Hya",
  "Crv",
  "Mus",
  "Mus",
  "Crv",
  "Crv",
  "Vir",
  "Crv",
  "Dra",
  "Com",
  "Crv",
  "CVn",
  "CVn",
  "Vir",
  "CVn",
  "Cen",
  "Crv",
  "Cen",
  "Dra",
  "Com",
  "Mus",
  "Com",
  "Com",
  "Cru",
  "Cen",
  "Crv",
  "Cen",
  "Cen",
  "Vir",
  "Com",
  "Mus",
  "Hya",
  "Cen",
  "Vir",
  "Vir",
  "Crv",
  "CVn",
  "Mus",
  "Com",
  "Hya",
  "Com",
  "Mus",
  "Vir",
  "CVn",
  "Cen",
  "Mus",
  "Crv",
  "Cen",
  "Cen",
  "UMa",
  "Vir",
  "Vir",
  "Crv",
  "Vir",
  "Cru",
  "Vir",
  "Mus",
  "Cen",
  "Cru",
  "Cru",
  "UMa",
  "Cru",
  "Cen",
  "Cru",
  "Vir",
  "Cen",
  "Hya",
  "Cam",
  "CVn",
  "CVn",
  "Mus",
  "CVn",
  "Vir",
  "Cru",
  "Mus",
  "Vir",
  "Cru",
  "Com",
  "Cen",
  "Vir",
  "Vir",
  "UMa",
  "Vir",
  "Dra",
  "Cru",
  "Vir",
  "Hya",
  "Com",
  "Hya",
  "UMa",
  "CVn",
  "Com",
  "Com",
  "Cam",
  "Cam",
  "Com",
  "CVn",
  "Mus",
  "CVn",
  "Com",
  "Cen",
  "Cen",
  "Cen",
  "Cru",
  "Vir",
  "Vir",
  "Com",
  "Cen",
  "Hya",
  "Cen",
  "Com",
  "Cen",
  "Com",
  "Cen",
  "Cen",
  "Vir",
  "Com",
  "Cru",
  "Cen",
  "Com",
  "Vir",
  "Cru",
  "Vir",
  "UMa",
  "CVn",
  "Vir",
  "Vir",
  "Cru",
  "Cru",
  "Cru",
  "CVn",
  "Oct",
  "Cen",
  "Cen",
  "Dra",
  "Vir",
  "Crv",
  "Cru",
  "CVn",
  "CVn",
  "UMa",
  "Mus",
  "Cen",
  "Cen",
  "CVn",
  "Vir",
  "Hya",
  "Dra",
  "Dra",
  "Com",
  "Vir",
  "Dra",
  "Com",
  "Cen",
  "Vir",
  "Com",
  "UMa",
  "Com",
  "Dra",
  "Vir",
  "Mus",
  "UMa",
  "Mus",
  "Cen",
  "Vir",
  "Cen",
  "UMi",
  "Cen",
  "Cen",
  "CVn",
  "CVn",
  "Cen",
  "Com",
  "Com",
  "UMa",
  "Cen",
  "Cen",
  "Cen",
  "Com",
  "Cen",
  "Cen",
  "Com",
  "Vir",
  "Mus",
  "Cha",
  "Mus",
  "Vir",
  "Hya",
  "Vir",
  "Vir",
  "CVn",
  "CVn",
  "Vir",
  "Com",
  "Vir",
  "Com",
  "CVn",
  "Cen",
  "Cen",
  "Cen",
  "Hya",
  "Mus",
  "Com",
  "Cen",
  "Cen",
  "Vir",
  "Com",
  "Cen",
  "Cam",
  "Vir",
  "Mus",
  "Cen",
  "Cen",
  "Com",
  "Cen",
  "Vir",
  "CVn",
  "CVn",
  "Cen",
  "Vir",
  "Cen",
  "Cen",
  "Cha",
  "Vir",
  "Cen",
  "Cen",
  "Mus",
  "Mus",
  "CVn",
  "Vir",
  "Com",
  "Dra",
  "Com",
  "Mus",
  "Vir",
  "Com",
  "Cen",
  "Mus",
  "Cen",
  "Vir",
  "Vir",
  "CVn",
  "Vir",
  "CVn",
  "Vir",
  "CVn",
  "Cen",
  "Cha",
  "Hya",
  "CVn",
  "Mus",
  "CVn",
  "Cen",
  "Cen",
  "Cen",
  "Vir",
  "Cen",
  "Cen",
  "Vir",
  "Vir",
  "CVn",
  "Vir",
  "Cen",
  "Cen",
  "Cen",
  "Mus",
  "Vir",
  "Cen",
  "Cen",
  "Vir",
  "Cen",
  "CVn",
  "UMa",
  "Vir",
  "Cen",
  "Vir",
  "Vir",
  "Com",
  "Mus",
  "Vir",
  "UMa",
  "Cen",
  "Mus",
  "UMa",
  "Cen",
  "UMi",
  "Vir",
  "CVn",
  "Vir",
  "Cen",
  "Cam",
  "Cen",
  "Cen",
  "Cen",
  "Vir",
  "UMa",
  "Hya",
  "Vir",
  "CVn",
  "UMa",
  "CVn",
  "Mus",
  "Mus",
  "Vir",
  "Vir",
  "Cen",
  "Hya",
  "Vir",
  "Vir",
  "Cen",
  "CVn",
  "Hya",
  "Vir",
  "Vir",
  "Cen",
  "Hya",
  "Hya",
  "Com",
  "Vir",
  "Vir",
  "Mus",
  "UMa",
  "Vir",
  "CVn",
  "CVn",
  "Cen",
  "Vir",
  "Vir",
  "Cam",
  "Cen",
  "CVn",
  "Vir",
  "Vir",
  "UMa",
  "Hya",
  "Cen",
  "Boo",
  "Cen",
  "UMi",
  "Cen",
  "Cen",
  "CVn",
  "Cen",
  "Boo",
  "Hya",
  "Mus",
  "Cen",
  "Boo",
  "Cha",
  "UMa",
  "UMa",
  "Boo",
  "Cen",
  "Cen",
  "Cen",
  "Cen",
  "Cen",
  "CVn",
  "UMa",
  "UMa",
  "CVn",
  "Boo",
  "UMa",
  "Oct",
  "Boo",
  "Dra",
  "Vir",
  "Cen",
  "Cen",
  "Boo",
  "Cam",
  "CVn",
  "UMi",
  "CVn",
  "Cen",
  "Cen",
  "Cen",
  "Vir",
  "Cen",
  "Boo",
  "UMa",
  "Cen",
  "Vir",
  "Hya",
  "UMa",
  "Boo",
  "Vir",
  "Hya",
  "Cen",
  "Vir",
  "CVn",
  "Cen",
  "CVn",
  "UMa",
  "Cen",
  "Boo",
  "Cen",
  "Vir",
  "CVn",
  "Cen",
  "Vir",
  "Boo",
  "Vir",
  "Cen",
  "UMa",
  "Cen",
  "CVn",
  "Cen",
  "Boo",
  "Cen",
  "Cen",
  "Boo",
  "CVn",
  "UMa",
  "Vir",
  "Hya",
  "Cen",
  "Vir",
  "UMa",
  "Dra",
  "CVn",
  "Hya",
  "Dra",
  "Cen",
  "Cen",
  "Cir",
  "CVn",
  "Cen",
  "Cen",
  "Cen",
  "Boo",
  "CVn",
  "CVn",
  "Cen",
  "Boo",
  "Cen",
  "Cen",
  "UMa",
  "Cen",
  "Cen",
  "Hya",
  "Boo",
  "Vir",
  "Cir",
  "Vir",
  "Cen",
  "Cen",
  "Cha",
  "Boo",
  "CVn",
  "Cen",
  "Cen",
  "Vir",
  "Cen",
  "Boo",
  "Hya",
  "UMa",
  "Cen",
  "Hya",
  "Cen",
  "Hya",
  "Cir",
  "Boo",
  "Boo",
  "Cen",
  "Cen",
  "Vir",
  "Hya",
  "Cen",
  "Aps",
  "Cir",
  "Boo",
  "Cen",
  "Boo",
  "Boo",
  "Vir",
  "Cen",
  "Dra",
  "CVn",
  "Hya",
  "Boo",
  "UMa",
  "Cen",
  "Vir",
  "Cen",
  "Cen",
  "Boo",
  "Boo",
  "Cen",
  "Vir",
  "Vir",
  "Vir",
  "Dra",
  "Vir",
  "Vir",
  "Aps",
  "Cen",
  "Cen",
  "Cen",
  "Hya",
  "Cen",
  "Cen",
  "Vir",
  "UMi",
  "Cen",
  "Cen",
  "Boo",
  "Cen",
  "Boo",
  "Aps",
  "UMa",
  "UMi",
  "Cen",
  "Cen",
  "Vir",
  "Cen",
  "Cen",
  "Boo",
  "Cir",
  "Vir",
  "Cir",
  "Boo",
  "Vir",
  "UMi",
  "Vir",
  "Hya",
  "Hya",
  "Vir",
  "Hya",
  "Cen",
  "Boo",
  "Cen",
  "Vir",
  "Boo",
  "Vir",
  "Boo",
  "Boo",
  "Boo",
  "Cen",
  "Boo",
  "Vir",
  "Cen",
  "Hya",
  "Cen",
  "Vir",
  "Cen",
  "Boo",
  "Vir",
  "Boo",
  "Boo",
  "Vir",
  "Boo",
  "Boo",
  "Vir",
  "Boo",
  "Cir",
  "Vir",
  "Aps",
  "Vir",
  "Boo",
  "Boo",
  "Boo",
  "Boo",
  "Vir",
  "Aps",
  "Vir",
  "Boo",
  "Hya",
  "Vir",
  "Hya",
  "Boo",
  "Cen",
  "Lup",
  "Vir",
  "Vir",
  "Boo",
  "Boo",
  "Cen",
  "Vir",
  "Boo",
  "Lup",
  "Cen",
  "Cen",
  "Lup",
  "Boo",
  "Cen",
  "Aps",
  "Cen",
  "Lup",
  "Cen",
  "Hya",
  "Boo",
  "Vir",
  "Lup",
  "Lup",
  "Boo",
  "Lib",
  "Lup",
  "Boo",
  "Boo",
  "Vir",
  "Boo",
  "Aps",
  "Lup",
  "Lib",
  "Lib",
  "Cir",
  "Boo",
  "Lib",
  "Boo",
  "Cir",
  "Hya",
  "Lup",
  "Lup",
  "Cen",
  "Boo",
  "Cen",
  "Oct",
  "Cir",
  "Lup",
  "Vir",
  "UMi",
  "Hya",
  "Vir",
  "Boo",
  "Boo",
  "Vir",
  "Cen",
  "Lup",
  "Boo",
  "Aps",
  "Boo",
  "Vir",
  "Lup",
  "Lup",
  "Vir",
  "Dra",
  "Cen",
  "Cen",
  "Cir",
  "Dra",
  "Boo",
  "Boo",
  "Boo",
  "Dra",
  "Boo",
  "Lup",
  "Cen",
  "Boo",
  "Lup",
  "Lup",
  "UMi",
  "Boo",
  "Dra",
  "Boo",
  "Boo",
  "Boo",
  "Lib",
  "Cen",
  "Cen",
  "Cen",
  "Boo",
  "Lup",
  "Cen",
  "Cen",
  "Lib",
  "Lup",
  "Lup",
  "Vir",
  "Cir",
  "Lup",
  "Boo",
  "Boo",
  "Boo",
  "Cen",
  "Boo",
  "Lup",
  "Lup",
  "Cen",
  "Cen",
  "Boo",
  "Cen",
  "Boo",
  "Boo",
  "Cen",
  "Boo",
  "Boo",
  "Boo",
  "Cen",
  "Boo",
  "Lup",
  "Cir",
  "Cen",
  "Aps",
  "Dra",
  "Cir",
  "Vir",
  "Lib",
  "Boo",
  "Cir",
  "Cen",
  "Boo",
  "Cir",
  "Cen",
  "Boo",
  "Cir",
  "Vir",
  "Boo",
  "Boo",
  "Cir",
  "Lup",
  "Boo",
  "Vir",
  "Lib",
  "Hya",
  "Boo",
  "Lib",
  "Lib",
  "Vir",
  "Lup",
  "Lup",
  "Cen",
  "Lup",
  "Lib",
  "Hya",
  "Lup",
  "Hya",
  "Aps",
  "Lib",
  "Hya",
  "Boo",
  "Cen",
  "Cir",
  "Lib",
  "Boo",
  "Cir",
  "Boo",
  "Lib",
  "Lib",
  "Boo",
  "Cir",
  "Boo",
  "Boo",
  "Boo",
  "Hya",
  "UMi",
  "Boo",
  "Lib",
  "UMi",
  "Lib",
  "Vir",
  "Lib",
  "Boo",
  "Dra",
  "Aps",
  "Lup",
  "Lib",
  "Cen",
  "Cir",
  "Cen",
  "Aps",
  "Boo",
  "Boo",
  "Lib",
  "Lib",
  "Cen",
  "Cir",
  "Cir",
  "Cir",
  "Cen",
  "Boo",
  "Boo",
  "Lup",
  "Boo",
  "Cen",
  "Lup",
  "Cen",
  "Cir",
  "Cir",
  "Lib",
  "Boo",
  "Lib",
  "Boo",
  "Hya",
  "Lib",
  "Vir",
  "UMi",
  "Aps",
  "Lup",
  "Lup",
  "Cen",
  "Hya",
  "Lib",
  "Lib",
  "Cen",
  "Cen",
  "Vir",
  "Lup",
  "Boo",
  "Aps",
  "Aps",
  "Boo",
  "Boo",
  "Lib",
  "Cen",
  "Lib",
  "Dra",
  "Vir",
  "Oct",
  "Boo",
  "Cen",
  "Hya",
  "Boo",
  "Lib",
  "Vir",
  "Lup",
  "Boo",
  "Boo",
  "UMi",
  "Lib",
  "Boo",
  "Lup",
  "Oct",
  "Cir",
  "Lup",
  "Lup",
  "Boo",
  "Lup",
  "Lup",
  "Lup",
  "Boo",
  "Lib",
  "Lup",
  "Boo",
  "Lib",
  "Lib",
  "Lup",
  "Boo",
  "Boo",
  "Lup",
  "Vir",
  "Cir",
  "TrA",
  "Lup",
  "Boo",
  "Boo",
  "Boo",
  "Lup",
  "Lup",
  "Boo",
  "Cir",
  "TrA",
  "Lup",
  "Lib",
  "UMi",
  "Cir",
  "Oct",
  "Lup",
  "Lup",
  "Lup",
  "Lup",
  "Ser",
  "Lib",
  "Lib",
  "Lup",
  "Lup",
  "Aps",
  "Ser",
  "Lup",
  "Cir",
  "Lup",
  "Lib",
  "Lib",
  "Lib",
  "Ser",
  "Boo",
  "Lib",
  "Cir",
  "Boo",
  "Boo",
  "TrA",
  "Boo",
  "Lib",
  "Lup",
  "UMi",
  "Lib",
  "Ser",
  "Boo",
  "Ser",
  "Boo",
  "Ser",
  "Lup",
  "Lup",
  "Lup",
  "Lib",
  "Cir",
  "Lup",
  "Lup",
  "Cir",
  "Lib",
  "UMi",
  "Cir",
  "Cir",
  "Lup",
  "Lup",
  "Ser",
  "Ser",
  "Ser",
  "Lup",
  "Lup",
  "Cir",
  "TrA",
  "Lup",
  "Ser",
  "CrB",
  "Lup",
  "Boo",
  "CrB",
  "TrA",
  "Boo",
  "UMi",
  "Ser",
  "Lib",
  "Lib",
  "Ser",
  "Ser",
  "Lib",
  "Lup",
  "Lup",
  "Lup",
  "Boo",
  "Lup",
  "Lup",
  "Ser",
  "Dra",
  "Boo",
  "Dra",
  "Lup",
  "Lib",
  "Lib",
  "Lup",
  "Cir",
  "CrB",
  "Cir",
  "Lup",
  "Ser",
  "Lib",
  "Boo",
  "Lib",
  "Boo",
  "Lup",
  "Dra",
  "Lup",
  "Ser",
  "Ser",
  "TrA",
  "Boo",
  "Dra",
  "Lup",
  "TrA",
  "Ser",
  "CrB",
  "Dra",
  "Lib",
  "Oct",
  "Lup",
  "Ser",
  "Boo",
  "Dra",
  "Lib",
  "Ser",
  "Lup",
  "Dra",
  "Lup",
  "Lup",
  "CrB",
  "Lib",
  "Lib",
  "Aps",
  "Boo",
  "Dra",
  "CrB",
  "UMi",
  "Aps",
  "Lib",
  "Boo",
  "Lup",
  "Lup",
  "Ser",
  "Lib",
  "Lib",
  "CrB",
  "Ser",
  "Lib",
  "Lup",
  "Ser",
  "Lup",
  "Lib",
  "Lup",
  "Lib",
  "Lib",
  "CrB",
  "Ser",
  "Lup",
  "CrB",
  "Dra",
  "Lib",
  "Ser",
  "CrB",
  "Lup",
  "Ser",
  "Dra",
  "Lup",
  "Lup",
  "Ser",
  "Ser",
  "TrA",
  "CrB",
  "Lib",
  "Lib",
  "Dra",
  "UMi",
  "Lib",
  "Boo",
  "Lup",
  "Lib",
  "Boo",
  "Lib",
  "Boo",
  "Lib",
  "Lib",
  "Lup",
  "CrB",
  "Nor",
  "Lib",
  "Dra",
  "Aps",
  "Lib",
  "CrB",
  "Lup",
  "Nor",
  "Ser",
  "TrA",
  "Lup",
  "Lib",
  "Aps",
  "Lup",
  "Ser",
  "Lup",
  "Ser",
  "Ser",
  "Aps",
  "Ser",
  "Lib",
  "Nor",
  "Lup",
  "Lup",
  "CrB",
  "Boo",
  "Ser",
  "Oct",
  "Lib",
  "Nor",
  "CrB",
  "Ser",
  "UMi",
  "Lib",
  "Ser",
  "Lup",
  "Ser",
  "Nor",
  "Ser",
  "Ser",
  "Ser",
  "Ser",
  "Lib",
  "Ser",
  "Dra",
  "Dra",
  "Lup",
  "Lib",
  "Ser",
  "Lup",
  "Lup",
  "Dra",
  "TrA",
  "CrB",
  "Ser",
  "CrB",
  "Ser",
  "Nor",
  "Lib",
  "CrB",
  "Ser",
  "Nor",
  "Nor",
  "Nor",
  "Ser",
  "Ser",
  "Lup",
  "Sco",
  "Nor",
  "CrB",
  "Ser",
  "Ser",
  "Nor",
  "Lib",
  "Lup",
  "Dra",
  "Her",
  "Ser",
  "Ser",
  "Lib",
  "TrA",
  "Ser",
  "Sco",
  "Lib",
  "Sco",
  "Sco",
  "Sco",
  "Ser",
  "Her",
  "Sco",
  "Ser",
  "TrA",
  "Lib",
  "TrA",
  "TrA",
  "Sco",
  "Lup",
  "Her",
  "Nor",
  "Ser",
  "CrB",
  "Dra",
  "TrA",
  "Lup",
  "Lup",
  "Lib",
  "Ser",
  "Lib",
  "Sco",
  "Lup",
  "Lup",
  "Nor",
  "Ser",
  "Lup",
  "Her",
  "CrB",
  "Sco",
  "Dra",
  "Lib",
  "Lup",
  "Sco",
  "Sco",
  "CrB",
  "TrA",
  "Her",
  "Lup",
  "Nor",
  "Aps",
  "Lup",
  "Lib",
  "Sco",
  "Lib",
  "Ser",
  "Lup",
  "CrB",
  "Nor",
  "TrA",
  "Her",
  "Lup",
  "CrB",
  "Dra",
  "Nor",
  "Dra",
  "Ser",
  "Sco",
  "Her",
  "TrA",
  "Dra",
  "Nor",
  "CrB",
  "Sco",
  "Lup",
  "UMi",
  "Nor",
  "Lup",
  "Ser",
  "Sco",
  "Nor",
  "Lup",
  "Nor",
  "Lup",
  "Sco",
  "Sco",
  "Ser",
  "Oph",
  "Aps",
  "Oph",
  "Sco",
  "Dra",
  "Nor",
  "Lup",
  "Sco",
  "Sco",
  "Lup",
  "Ser",
  "Nor",
  "Sco",
  "Sco",
  "Ser",
  "Sco",
  "Her",
  "Her",
  "Sco",
  "Ser",
  "Ser",
  "Sco",
  "Her",
  "Her",
  "CrB",
  "Ser",
  "Dra",
  "Ser",
  "Nor",
  "Dra",
  "Sco",
  "Ser",
  "Sco",
  "Sco",
  "TrA",
  "UMi",
  "Sco",
  "Sco",
  "Her",
  "Her",
  "CrB",
  "Her",
  "CrB",
  "Sco",
  "Sco",
  "CrB",
  "Sco",
  "Sco",
  "Sco",
  "Dra",
  "UMi",
  "CrB",
  "Oph",
  "Her",
  "Nor",
  "Nor",
  "Nor",
  "Ser",
  "Sco",
  "Sco",
  "Her",
  "Oph",
  "Sco",
  "Sco",
  "UMi",
  "Sco",
  "CrB",
  "Sco",
  "Nor",
  "Nor",
  "TrA",
  "Her",
  "Sco",
  "CrB",
  "Nor",
  "Sco",
  "Nor",
  "CrB",
  "Oph",
  "Nor",
  "Sco",
  "Nor",
  "TrA",
  "Dra",
  "Nor",
  "UMi",
  "Ser",
  "Dra",
  "Sco",
  "Oph",
  "Sco",
  "Sco",
  "Her",
  "Nor",
  "Sco",
  "Her",
  "Nor",
  "Her",
  "Her",
  "Aps",
  "Nor",
  "Aps",
  "Sco",
  "Sco",
  "Sco",
  "Dra",
  "Her",
  "Ser",
  "CrB",
  "CrB",
  "Nor",
  "Nor",
  "CrB",
  "Oph",
  "CrB",
  "Dra",
  "Sco",
  "Dra",
  "Sco",
  "Oph",
  "Her",
  "Dra",
  "Sco",
  "Sco",
  "Nor",
  "TrA",
  "Her",
  "Her",
  "Oph",
  "UMi",
  "Her",
  "Oph",
  "Oph",
  "Nor",
  "Oph",
  "Oph",
  "Oph",
  "TrA",
  "Dra",
  "Sco",
  "Nor",
  "Dra",
  "TrA",
  "Oph",
  "Her",
  "Oph",
  "Dra",
  "Oph",
  "Sco",
  "Nor",
  "Nor",
  "Oph",
  "Her",
  "Sco",
  "Her",
  "Oph",
  "Her",
  "UMi",
  "TrA",
  "Oph",
  "Her",
  "Oph",
  "Her",
  "Sco",
  "Sco",
  "Dra",
  "Sco",
  "Her",
  "Oph",
  "Dra",
  "Her",
  "Her",
  "Aps",
  "Nor",
  "Her",
  "Aps",
  "Sco",
  "Her",
  "TrA",
  "Sco",
  "Her",
  "Dra",
  "Dra",
  "Oph",
  "Sco",
  "Sco",
  "Her",
  "Dra",
  "Oph",
  "Her",
  "Her",
  "UMi",
  "Dra",
  "Oph",
  "Sco",
  "Her",
  "Oph",
  "Ara",
  "Sco",
  "Oph",
  "Oph",
  "Her",
  "Ara",
  "Ara",
  "Her",
  "Dra",
  "Oph",
  "Her",
  "Oph",
  "Oph",
  "Her",
  "Ara",
  "TrA",
  "Oph",
  "Oph",
  "Her",
  "Ara",
  "Oph",
  "Sco",
  "Oph",
  "Her",
  "Sco",
  "TrA",
  "Her",
  "Dra",
  "Ara",
  "Aps",
  "UMi",
  "TrA",
  "Sco",
  "Sco",
  "Sco",
  "Her",
  "Sco",
  "Ara",
  "Sco",
  "Sco",
  "Her",
  "Dra",
  "Her",
  "Oph",
  "Her",
  "UMi",
  "Ara",
  "Ara",
  "TrA",
  "Sco",
  "Oph",
  "Ara",
  "Her",
  "Her",
  "Her",
  "Oph",
  "TrA",
  "Her",
  "Oph",
  "Her",
  "Her",
  "Ara",
  "Oph",
  "Sco",
  "Her",
  "Oph",
  "Ara",
  "Her",
  "Her",
  "Her",
  "Sco",
  "Oph",
  "Sco",
  "Her",
  "Sco",
  "TrA",
  "TrA",
  "Sco",
  "Sco",
  "Sco",
  "Her",
  "Her",
  "Oph",
  "Sco",
  "Sco",
  "Sco",
  "Ara",
  "Oph",
  "Sco",
  "Sco",
  "Oph",
  "Sco",
  "Ara",
  "Sco",
  "Oph",
  "Sco",
  "Her",
  "Sco",
  "Her",
  "Sco",
  "Her",
  "Her",
  "Ara",
  "Sco",
  "Dra",
  "Oph",
  "Ara",
  "Dra",
  "Dra",
  "Ara",
  "Sco",
  "Oph",
  "Aps",
  "Oph",
  "Sco",
  "Oph",
  "Her",
  "Her",
  "Oph",
  "Her",
  "Her",
  "Ara",
  "Ara",
  "Oph",
  "Sco",
  "Dra",
  "Dra",
  "TrA",
  "Ara",
  "Oph",
  "Ara",
  "Oph",
  "Sco",
  "Her",
  "Ara",
  "Sco",
  "Her",
  "Oct",
  "Oph",
  "Ara",
  "Dra",
  "Her",
  "Her",
  "UMi",
  "Ara",
  "Ara",
  "Oph",
  "Sco",
  "Oph",
  "Dra",
  "Her",
  "Her",
  "Her",
  "Ara",
  "Her",
  "Her",
  "Ara",
  "Sco",
  "Her",
  "Her",
  "Sco",
  "Her",
  "Ara",
  "TrA",
  "Her",
  "Oph",
  "Sco",
  "Her",
  "Her",
  "Sco",
  "Oph",
  "Dra",
  "Her",
  "Oph",
  "Sco",
  "Oph",
  "Oph",
  "Oph",
  "Her",
  "Sco",
  "Sco",
  "Oph",
  "Oph",
  "Her",
  "Her",
  "Her",
  "Oph",
  "Oph",
  "Dra",
  "Dra",
  "Sco",
  "Oph",
  "Her",
  "Oph",
  "Ara",
  "Oph",
  "Dra",
  "Sco",
  "Her",
  "Ara",
  "Her",
  "Oph",
  "Sco",
  "Sco",
  "Sco",
  "Aps",
  "Oph",
  "Oph",
  "Dra",
  "Sco",
  "Ara",
  "Ara",
  "Sco",
  "Her",
  "Her",
  "Her",
  "Sco",
  "Oph",
  "Oph",
  "Sco",
  "Her",
  "Sco",
  "Oph",
  "Oph",
  "Sco",
  "Dra",
  "Oph",
  "Aps",
  "Oph",
  "Oph",
  "UMi",
  "Sco",
  "Sco",
  "Her",
  "Her",
  "Her",
  "Oph",
  "Her",
  "Oph",
  "Sco",
  "Her",
  "Oph",
  "Sco",
  "Her",
  "Ara",
  "Sco",
  "Ara",
  "Ara",
  "Ara",
  "UMi",
  "Oph",
  "Oph",
  "Oph",
  "Her",
  "Her",
  "Her",
  "Her",
  "Oph",
  "Her",
  "Ser",
  "Ser",
  "Her",
  "Oph",
  "Her",
  "Her",
  "Oph",
  "Her",
  "Dra",
  "Aps",
  "Oph",
  "Aps",
  "Sco",
  "Sco",
  "Oph",
  "Sco",
  "Ara",
  "Ara",
  "Ara",
  "Oph",
  "Her",
  "Oph",
  "Ara",
  "Her",
  "Her",
  "Sco",
  "Ara",
  "Her",
  "Her",
  "Her",
  "Oph",
  "Oph",
  "Dra",
  "Sco",
  "Oph",
  "Ara",
  "Ara",
  "Dra",
  "Dra",
  "Her",
  "Oph",
  "Ara",
  "Her",
  "Dra",
  "Oph",
  "Oph",
  "Oph",
  "Oph",
  "Her",
  "Her",
  "Her",
  "Ara",
  "Oph",
  "Ara",
  "Ser",
  "Ser",
  "Ara",
  "Oph",
  "Oph",
  "Oph",
  "Ara",
  "Oph",
  "Ara",
  "Ara",
  "Oph",
  "Sco",
  "Sco",
  "Sco",
  "Oph",
  "Oph",
  "Oph",
  "Dra",
  "Her",
  "Dra",
  "Her",
  "Sco",
  "UMi",
  "Her",
  "Ara",
  "Oph",
  "Ara",
  "Oph",
  "Aps",
  "Oph",
  "Sco",
  "Ara",
  "Her",
  "Ara",
  "Dra",
  "Dra",
  "UMi",
  "Oph",
  "Dra",
  "Sco",
  "Her",
  "Sco",
  "Her",
  "Oph",
  "Dra",
  "Sco",
  "Her",
  "Her",
  "Ara",
  "Oph",
  "Sco",
  "Ser",
  "Oph",
  "Dra",
  "Oph",
  "Ara",
  "Ara",
  "Ara",
  "Her",
  "Sco",
  "Her",
  "Her",
  "Her",
  "Sco",
  "Her",
  "Her",
  "Dra",
  "Dra",
  "Dra",
  "Sco",
  "Sco",
  "Ara",
  "Her",
  "Ser",
  "Ser",
  "Oph",
  "Ara",
  "Sco",
  "Ser",
  "Oph",
  "Oph",
  "Oph",
  "Her",
  "Her",
  "Oph",
  "Ara",
  "Her",
  "Her",
  "Aps",
  "Sco",
  "Her",
  "Her",
  "Ara",
  "Dra",
  "Ser",
  "Oph",
  "Dra",
  "Dra",
  "Her",
  "Ara",
  "Her",
  "Sco",
  "Sco",
  "Her",
  "Sco",
  "Oph",
  "Her",
  "Her",
  "Oph",
  "Oph",
  "Oph",
  "Ser",
  "Dra",
  "Ara",
  "Her",
  "Oph",
  "Sco",
  "Pav",
  "Her",
  "Pav",
  "Her",
  "Sco",
  "Her",
  "Her",
  "Sgr",
  "Sco",
  "Ser",
  "Sgr",
  "Oph",
  "Oph",
  "Her",
  "Sgr",
  "Ara",
  "Her",
  "Her",
  "Dra",
  "Sco",
  "Oph",
  "Dra",
  "Sco",
  "Pav",
  "Dra",
  "Sco",
  "Her",
  "Ara",
  "Oph",
  "Her",
  "Ara",
  "Sco",
  "Pav",
  "Ara",
  "Her",
  "Oph",
  "Her",
  "Her",
  "Sco",
  "Sco",
  "Oph",
  "Oph",
  "Sco",
  "Sco",
  "Sco",
  "Ser",
  "Oph",
  "Her",
  "Pav",
  "Sco",
  "Sco",
  "Dra",
  "Sco",
  "Sco",
  "Oph",
  "Dra",
  "Sco",
  "Sgr",
  "Sco",
  "Dra",
  "Dra",
  "Her",
  "Her",
  "Sgr",
  "Her",
  "Oph",
  "Ser",
  "Pav",
  "Dra",
  "Sgr",
  "Sco",
  "Oph",
  "Her",
  "Sco",
  "Oph",
  "Oph",
  "Her",
  "Oph",
  "Aps",
  "Ara",
  "Her",
  "Sco",
  "Sco",
  "Her",
  "Sgr",
  "Her",
  "Her",
  "Sgr",
  "Oph",
  "Sgr",
  "Oph",
  "Sgr",
  "Her",
  "Sgr",
  "Dra",
  "Her",
  "Dra",
  "Oph",
  "Oph",
  "Her",
  "Ser",
  "Her",
  "Oph",
  "Oph",
  "Her",
  "Sgr",
  "Her",
  "Oct",
  "Her",
  "Oph",
  "Sgr",
  "Sgr",
  "Her",
  "Her",
  "Sgr",
  "Oph",
  "Her",
  "Her",
  "Sgr",
  "Oph",
  "Her",
  "Sgr",
  "Her",
  "Sgr",
  "Aps",
  "Oph",
  "Her",
  "Sgr",
  "Her",
  "Her",
  "Ser",
  "Ser",
  "Ara",
  "Ser",
  "Sgr",
  "Ara",
  "CrA",
  "Dra",
  "Her",
  "Her",
  "Sgr",
  "Oph",
  "Oph",
  "Her",
  "Her",
  "Pav",
  "Sgr",
  "Her",
  "Her",
  "Her",
  "Sgr",
  "Ara",
  "Oph",
  "Pav",
  "Sgr",
  "Her",
  "Her",
  "Her",
  "Oph",
  "Her",
  "Ser",
  "Oph",
  "Pav",
  "Her",
  "Sgr",
  "Sgr",
  "Her",
  "Pav",
  "Dra",
  "Oph",
  "Sgr",
  "Tel",
  "CrA",
  "Dra",
  "Tel",
  "Sgr",
  "Aps",
  "Sgr",
  "Her",
  "Her",
  "Aps",
  "Her",
  "Her",
  "CrA",
  "Her",
  "Sgr",
  "Oph",
  "Dra",
  "Sgr",
  "Pav",
  "Sgr",
  "Sgr",
  "Dra",
  "Sgr",
  "Lyr",
  "Lyr",
  "Pav",
  "CrA",
  "Ser",
  "Oph",
  "Ser",
  "Tel",
  "Lyr",
  "Tel",
  "Sgr",
  "Sgr",
  "Sgr",
  "Ser",
  "Sgr",
  "Sgr",
  "Pav",
  "Oph",
  "Sgr",
  "Her",
  "Her",
  "CrA",
  "Oph",
  "Her",
  "Pav",
  "Lyr",
  "Her",
  "Dra",
  "Ser",
  "Her",
  "Dra",
  "Oph",
  "CrA",
  "Her",
  "Sgr",
  "Her",
  "Dra",
  "Dra",
  "Ser",
  "Sgr",
  "Ser",
  "Sgr",
  "Dra",
  "Sgr",
  "Her",
  "CrA",
  "Oph",
  "Her",
  "Sgr",
  "Sct",
  "Her",
  "Sct",
  "Pav",
  "Sgr",
  "Oct",
  "Sct",
  "Her",
  "Dra",
  "Dra",
  "Lyr",
  "Ser",
  "Dra",
  "Sgr",
  "Lyr",
  "CrA",
  "Tel",
  "Sct",
  "Ser",
  "Her",
  "Sgr",
  "Sgr",
  "Sgr",
  "Pav",
  "Oph",
  "Sgr",
  "Her",
  "Her",
  "Dra",
  "Her",
  "Tel",
  "Tel",
  "Sct",
  "Ser",
  "Dra",
  "Sgr",
  "Sgr",
  "Oph",
  "Sgr",
  "Sgr",
  "Ser",
  "Sgr",
  "Oct",
  "CrA",
  "Tel",
  "Sct",
  "CrA",
  "Oct",
  "Her",
  "Ser",
  "Dra",
  "Sct",
  "Tel",
  "Pav",
  "Sgr",
  "Sct",
  "Her",
  "CrA",
  "Her",
  "Sgr",
  "Pav",
  "Sct",
  "Sgr",
  "Tel",
  "CrA",
  "Ser",
  "Tel",
  "Ser",
  "Sct",
  "CrA",
  "Dra",
  "Sct",
  "Her",
  "Lyr",
  "Pav",
  "CrA",
  "Sct",
  "CrA",
  "CrA",
  "Oph",
  "Pav",
  "CrA",
  "Sct",
  "Sgr",
  "Dra",
  "Sgr",
  "Tel",
  "Oph",
  "Sct",
  "Sct",
  "Her",
  "Lyr",
  "Sgr",
  "Her",
  "Ser",
  "Her",
  "Sgr",
  "Dra",
  "Oph",
  "Lyr",
  "Oph",
  "Lyr",
  "Lyr",
  "Her",
  "Dra",
  "Ser",
  "Sgr",
  "Sct",
  "Lyr",
  "Ser",
  "Sgr",
  "Sgr",
  "Tel",
  "Lyr",
  "CrA",
  "Ser",
  "Oph",
  "Dra",
  "Sct",
  "Lyr",
  "Lyr",
  "Dra",
  "Tel",
  "Lyr",
  "Sct",
  "Sgr",
  "Lyr",
  "Oct",
  "Sct",
  "Pav",
  "Sct",
  "Dra",
  "Sgr",
  "Pav",
  "Dra",
  "Lyr",
  "Dra",
  "Sct",
  "Lyr",
  "Pav",
  "CrA",
  "Sct",
  "Lyr",
  "Sgr",
  "Dra",
  "Sgr",
  "Lyr",
  "Lyr",
  "Her",
  "Lyr",
  "Lyr",
  "Sgr",
  "Aql",
  "Dra",
  "CrA",
  "Pav",
  "Sgr",
  "Pav",
  "Pav",
  "Ser",
  "Dra",
  "Sgr",
  "Her",
  "Dra",
  "Tel",
  "Sgr",
  "Lyr",
  "Lyr",
  "Sgr",
  "Dra",
  "Aql",
  "Her",
  "Dra",
  "Sct",
  "Her",
  "Sct",
  "Sct",
  "CrA",
  "Oct",
  "Lyr",
  "Ser",
  "Dra",
  "Her",
  "Pav",
  "Sct",
  "Sgr",
  "CrA",
  "Her",
  "Tel",
  "CrA",
  "Aql",
  "Sgr",
  "Sct",
  "Pav",
  "Lyr",
  "Lyr",
  "Lyr",
  "Sct",
  "Aql",
  "Sgr",
  "Sct",
  "CrA",
  "Dra",
  "Aql",
  "Dra",
  "Lyr",
  "Lyr",
  "Her",
  "Lyr",
  "CrA",
  "Pav",
  "Her",
  "Tel",
  "Sgr",
  "Sgr",
  "Tel",
  "Tel",
  "Sct",
  "Tel",
  "Tel",
  "Dra",
  "Dra",
  "Lyr",
  "Dra",
  "Sgr",
  "Sgr",
  "Lyr",
  "Dra",
  "Lyr",
  "Sct",
  "Her",
  "Dra",
  "Oct",
  "Lyr",
  "Lyr",
  "Sgr",
  "Sgr",
  "Lyr",
  "CrA",
  "Aql",
  "Sgr",
  "Sgr",
  "Her",
  "Ser",
  "Ser",
  "CrA",
  "Aql",
  "Ser",
  "Dra",
  "Sgr",
  "CrA",
  "Dra",
  "Pav",
  "Pav",
  "Lyr",
  "Sct",
  "CrA",
  "Ser",
  "Dra",
  "Sgr",
  "Dra",
  "CrA",
  "Sgr",
  "Lyr",
  "Oct",
  "Aql",
  "Sgr",
  "Aql",
  "Sgr",
  "Tel",
  "Pav",
  "CrA",
  "Lyr",
  "Aql",
  "Lyr",
  "Dra",
  "Aql",
  "CrA",
  "Lyr",
  "Sgr",
  "Sgr",
  "Pav",
  "Aql",
  "Lyr",
  "Vul",
  "Lyr",
  "Pav",
  "Dra",
  "Sgr",
  "Dra",
  "Lyr",
  "CrA",
  "Sge",
  "Lyr",
  "Lyr",
  "Sgr",
  "Sgr",
  "Aql",
  "Lyr",
  "Vul",
  "Dra",
  "CrA",
  "Aql",
  "Sgr",
  "Sgr",
  "Sge",
  "Aql",
  "Sgr",
  "CrA",
  "Sgr",
  "CrA",
  "Pav",
  "Aql",
  "Tel",
  "Pav",
  "Aql",
  "Sgr",
  "Sgr",
  "Dra",
  "Aql",
  "Lyr",
  "Lyr",
  "Dra",
  "Aql",
  "Sgr",
  "Lyr",
  "Aql",
  "Tel",
  "CrA",
  "Lyr",
  "Vul",
  "Sgr",
  "CrA",
  "Tel",
  "Tel",
  "Sgr",
  "Aql",
  "Sgr",
  "Lyr",
  "Lyr",
  "Sgr",
  "Sge",
  "Vul",
  "Sgr",
  "Sgr",
  "CrA",
  "Cyg",
  "Tel",
  "Aql",
  "Dra",
  "CrA",
  "CrA",
  "Dra",
  "Sgr",
  "Sgr",
  "Aql",
  "Pav",
  "CrA",
  "CrA",
  "CrA",
  "Sgr",
  "Lyr",
  "Lyr",
  "Dra",
  "Lyr",
  "Cyg",
  "Sgr",
  "Dra",
  "Vul",
  "Aql",
  "Tel",
  "Sgr",
  "Sgr",
  "Aql",
  "Aql",
  "Lyr",
  "Dra",
  "CrA",
  "Sge",
  "Dra",
  "Sge",
  "Cyg",
  "Aql",
  "Lyr",
  "Sgr",
  "Sgr",
  "Dra",
  "Sge",
  "Lyr",
  "Vul",
  "Tel",
  "Lyr",
  "Aql",
  "Pav",
  "Aql",
  "Cyg",
  "Pav",
  "Cyg",
  "Pav",
  "Sgr",
  "Vul",
  "Aql",
  "Aql",
  "Tel",
  "Aql",
  "Cyg",
  "Sge",
  "Aql",
  "Aql",
  "Sgr",
  "Lyr",
  "Cyg",
  "Lyr",
  "Aql",
  "Sgr",
  "Aql",
  "Dra",
  "Aql",
  "Lyr",
  "Aql",
  "Sgr",
  "Dra",
  "Sgr",
  "Dra",
  "Sgr",
  "Dra",
  "Sgr",
  "Sgr",
  "Sgr",
  "Sgr",
  "Aql",
  "Lyr",
  "Tel",
  "Sgr",
  "Aql",
  "Vul",
  "Tel",
  "Aql",
  "Sgr",
  "Lyr",
  "Vul",
  "Sgr",
  "Lyr",
  "Pav",
  "Lyr",
  "Cyg",
  "Sgr",
  "Sge",
  "Sgr",
  "Aql",
  "Aql",
  "Sgr",
  "Sgr",
  "Sgr",
  "Vul",
  "Vul",
  "Vul",
  "Sgr",
  "Aql",
  "Cyg",
  "Sgr",
  "Vul",
  "Sgr",
  "Aql",
  "Dra",
  "Vul",
  "Aql",
  "Sgr",
  "Cyg",
  "Aql",
  "Lyr",
  "Tel",
  "Aql",
  "Vul",
  "Vul",
  "Aql",
  "Aql",
  "Vul",
  "Aql",
  "Aql",
  "Sgr",
  "Cyg",
  "Sgr",
  "Tel",
  "Aql",
  "Aql",
  "Tel",
  "Aql",
  "Cyg",
  "Cyg",
  "Cyg",
  "Sgr",
  "Dra",
  "Pav",
  "Cyg",
  "Cyg",
  "Vul",
  "Cyg",
  "Sgr",
  "Dra",
  "Tel",
  "Dra",
  "Tel",
  "Cyg",
  "Aql",
  "Aql",
  "Sgr",
  "Cyg",
  "Vul",
  "Cyg",
  "Dra",
  "Cyg",
  "Cyg",
  "Aql",
  "Tel",
  "Aql",
  "Aql",
  "Sgr",
  "Cyg",
  "Cyg",
  "Sgr",
  "Vul",
  "Aql",
  "Sgr",
  "Cyg",
  "Cyg",
  "Sgr",
  "Aql",
  "Aql",
  "Aql",
  "Sgr",
  "Cyg",
  "Sge",
  "Sgr",
  "Cyg",
  "Aql",
  "Cyg",
  "Vul",
  "Pav",
  "Cyg",
  "Aql",
  "Aql",
  "Cyg",
  "Sge",
  "Cyg",
  "Cyg",
  "Tel",
  "Cyg",
  "Sgr",
  "Pav",
  "Sge",
  "Sgr",
  "Dra",
  "Tel",
  "Cyg",
  "Aql",
  "Sgr",
  "Cyg",
  "Sge",
  "Aql",
  "Vul",
  "Pav",
  "Cyg",
  "Cyg",
  "Cyg",
  "Aql",
  "Cyg",
  "Aql",
  "Sgr",
  "Aql",
  "Cyg",
  "Cyg",
  "Cyg",
  "Cyg",
  "Sgr",
  "Sgr",
  "Cyg",
  "Vul",
  "Cyg",
  "Cyg",
  "Vul",
  "Cyg",
  "Dra",
  "Aql",
  "Cyg",
  "Aql",
  "Cyg",
  "Cyg",
  "Cyg",
  "Aql",
  "Cyg",
  "Aql",
  "Sgr",
  "Aql",
  "Sgr",
  "Cyg",
  "Cyg",
  "Dra",
  "Sge",
  "Cyg",
  "Cyg",
  "Vul",
  "Tel",
  "Sgr",
  "Dra",
  "Aql",
  "Aql",
  "Sgr",
  "Cyg",
  "Tel",
  "Sge",
  "Aql",
  "Sgr",
  "Pav",
  "Cyg",
  "Pav",
  "Vul",
  "Vul",
  "Tel",
  "Aql",
  "Pav",
  "Cyg",
  "Cyg",
  "Cyg",
  "Pav",
  "Aql",
  "Aql",
  "Cyg",
  "Pav",
  "Aql",
  "Vul",
  "Aql",
  "Aql",
  "Cyg",
  "Aql",
  "Sgr",
  "Cyg",
  "Vul",
  "Aql",
  "Cyg",
  "Sgr",
  "Cyg",
  "Sge",
  "Aql",
  "Tel",
  "Tel",
  "Cyg",
  "Sgr",
  "Cyg",
  "Aql",
  "Vul",
  "Cyg",
  "Aql",
  "Aql",
  "Sgr",
  "Vul",
  "Aql",
  "Aql",
  "Aql",
  "Pav",
  "Aql",
  "Cyg",
  "Sgr",
  "Sgr",
  "Aql",
  "Aql",
  "Cyg",
  "Cyg",
  "Sgr",
  "Cyg",
  "Cyg",
  "Sge",
  "Oct",
  "Aql",
  "Cyg",
  "Cyg",
  "Cyg",
  "Cyg",
  "Sgr",
  "Pav",
  "Cyg",
  "Sge",
  "Cyg",
  "Sgr",
  "Dra",
  "Cyg",
  "Cyg",
  "Pav",
  "Dra",
  "Sge",
  "Pav",
  "Sgr",
  "Sgr",
  "Vul",
  "Cyg",
  "Cyg",
  "Aql",
  "Dra",
  "Sgr",
  "Aql",
  "Sgr",
  "Cyg",
  "Sge",
  "Vul",
  "Sgr",
  "Sgr",
  "Pav",
  "Tel",
  "Sgr",
  "Pav",
  "Sgr",
  "Aql",
  "Vul",
  "Cyg",
  "Cyg",
  "Sgr",
  "Sgr",
  "Dra",
  "Vul",
  "Pav",
  "Pav",
  "Sgr",
  "Vul",
  "Dra",
  "Vul",
  "Sgr",
  "Cyg",
  "Dra",
  "Sge",
  "Aql",
  "Sgr",
  "Cyg",
  "Vul",
  "Sgr",
  "Sge",
  "Aql",
  "Sgr",
  "Aql",
  "Cyg",
  "Cyg",
  "Dra",
  "Dra",
  "Aql",
  "Cyg",
  "Sge",
  "Cyg",
  "Cyg",
  "Aql",
  "Pav",
  "Dra",
  "Aql",
  "Cyg",
  "Cyg",
  "Vul",
  "Tel",
  "Tel",
  "Cyg",
  "Aql",
  "Aql",
  "Sge",
  "Tel",
  "Pav",
  "Cap",
  "Aql",
  "Pav",
  "Cep",
  "Tel",
  "Cyg",
  "Cyg",
  "Vul",
  "Sge",
  "Pav",
  "Cap",
  "Sgr",
  "Aql",
  "Vul",
  "Dra",
  "Vul",
  "Cap",
  "Vul",
  "Sgr",
  "Cap",
  "Cyg",
  "Aql",
  "Aql",
  "Aql",
  "Cyg",
  "Cyg",
  "Cep",
  "Tel",
  "Cyg",
  "Cyg",
  "Cyg",
  "Vul",
  "Aql",
  "Tel",
  "Pav",
  "Cyg",
  "Vul",
  "Cap",
  "Cyg",
  "Cyg",
  "Vul",
  "Cyg",
  "Vul",
  "Sgr",
  "Cyg",
  "Cyg",
  "Aql",
  "Sge",
  "Cap",
  "Sgr",
  "Cyg",
  "Vul",
  "Cyg",
  "Cyg",
  "Dra",
  "Vul",
  "Cap",
  "Cyg",
  "Cap",
  "Cap",
  "Cyg",
  "Cyg",
  "Cyg",
  "Cyg",
  "Cyg",
  "Tel",
  "Cyg",
  "Pav",
  "Tel",
  "Cap",
  "Del",
  "Dra",
  "Aql",
  "Cyg",
  "Del",
  "Dra",
  "Cyg",
  "Del",
  "Sge",
  "Cyg",
  "Tel",
  "Cap",
  "Cap",
  "Sgr",
  "Cap",
  "Dra",
  "Pav",
  "Tel",
  "Cyg",
  "Vul",
  "Cyg",
  "Cyg",
  "Sgr",
  "Cyg",
  "Cyg",
  "Del",
  "Cyg",
  "Cap",
  "Aql",
  "Cyg",
  "Cyg",
  "Sgr",
  "Cyg",
  "Aql",
  "Aql",
  "Oct",
  "Cyg",
  "Sgr",
  "Pav",
  "Vul",
  "Aql",
  "Del",
  "Sgr",
  "Del",
  "Del",
  "Del",
  "Cyg",
  "Sgr",
  "Cyg",
  "Cyg",
  "Del",
  "Cap",
  "Cyg",
  "Del",
  "Dra",
  "Del",
  "Aql",
  "Cap",
  "Mic",
  "Cap",
  "Dra",
  "Cyg",
  "Cyg",
  "Cyg",
  "Dra",
  "Cap",
  "Cep",
  "Aql",
  "Cap",
  "Cyg",
  "Dra",
  "Cyg",
  "Del",
  "Mic",
  "Del",
  "Cyg",
  "Cap",
  "Cyg",
  "Cyg",
  "Dra",
  "Cyg",
  "Cyg",
  "Vul",
  "Aql",
  "Cap",
  "Cap",
  "Del",
  "Oct",
  "Cyg",
  "Cyg",
  "Cyg",
  "Mic",
  "Del",
  "Del",
  "Vul",
  "Cap",
  "Mic",
  "Cyg",
  "Mic",
  "Pav",
  "Del",
  "Cap",
  "Pav",
  "Mic",
  "Pav",
  "Vul",
  "Pav",
  "Aql",
  "Vul",
  "Aql",
  "Cyg",
  "Cyg",
  "Del",
  "Ind",
  "Pav",
  "Del",
  "Cap",
  "Del",
  "Oct",
  "Aql",
  "Vul",
  "Vul",
  "Vul",
  "Del",
  "Cyg",
  "Cyg",
  "Del",
  "Aqr",
  "Del",
  "Vul",
  "Aqr",
  "Cap",
  "Aqr",
  "Cyg",
  "Del",
  "Pav",
  "Del",
  "Pav",
  "Cap",
  "Cyg",
  "Cap",
  "Cep",
  "Mic",
  "Cap",
  "Cyg",
  "Del",
  "Mic",
  "Cyg",
  "Del",
  "Mic",
  "Cap",
  "Mic",
  "Cyg",
  "Cyg",
  "Pav",
  "Del",
  "Oct",
  "Cyg",
  "Dra",
  "Cep",
  "Mic",
  "Cep",
  "Cep",
  "Cyg",
  "Del",
  "Ind",
  "Cep",
  "Cep",
  "Vul",
  "Pav",
  "Cap",
  "Cep",
  "Cep",
  "Cyg",
  "Cap",
  "Cap",
  "Cyg",
  "Mic",
  "Mic",
  "Cyg",
  "Cyg",
  "Del",
  "Del",
  "Aqr",
  "Cyg",
  "Cyg",
  "Cyg",
  "Dra",
  "Aqr",
  "Aqr",
  "Del",
  "Del",
  "Cyg",
  "Cyg",
  "Mic",
  "Mic",
  "Cyg",
  "Cyg",
  "Aqr",
  "Cep",
  "Cap",
  "Pav",
  "Cap",
  "Ind",
  "Cyg",
  "Del",
  "Del",
  "Cyg",
  "Mic",
  "Del",
  "Cyg",
  "Aqr",
  "Mic",
  "Mic",
  "Aqr",
  "Vul",
  "Ind",
  "Pav",
  "Cap",
  "Mic",
  "Cyg",
  "Vul",
  "Aqr",
  "Aqr",
  "Cap",
  "Aqr",
  "Cyg",
  "Cyg",
  "Cyg",
  "Mic",
  "Mic",
  "Cyg",
  "Aqr",
  "Mic",
  "Vul",
  "Ind",
  "Cep",
  "Cap",
  "Ind",
  "Del",
  "Del",
  "Del",
  "Cyg",
  "Cep",
  "Cyg",
  "Cyg",
  "Cyg",
  "Cap",
  "Aqr",
  "Cyg",
  "Aqr",
  "Cap",
  "Vul",
  "Cyg",
  "Del",
  "Cyg",
  "Cyg",
  "Aqr",
  "Equ",
  "Equ",
  "Cyg",
  "Cep",
  "Cap",
  "Cyg",
  "Mic",
  "Equ",
  "Ind",
  "Del",
  "Aqr",
  "Ind",
  "Cap",
  "Cyg",
  "Cyg",
  "Mic",
  "Pav",
  "Cap",
  "Cep",
  "Cyg",
  "Cyg",
  "Mic",
  "Cyg",
  "Mic",
  "Aqr",
  "Del",
  "Aqr",
  "Cyg",
  "Mic",
  "Cyg",
  "Cyg",
  "Cyg",
  "Cyg",
  "Aqr",
  "Cap",
  "Equ",
  "Equ",
  "Oct",
  "Aqr",
  "Cyg",
  "Ind",
  "Equ",
  "Cep",
  "Cap",
  "Mic",
  "Cep",
  "Vul",
  "Mic",
  "Mic",
  "Cyg",
  "Cyg",
  "Equ",
  "Cyg",
  "Cyg",
  "Cap",
  "Del",
  "Ind",
  "Cap",
  "Equ",
  "Pav",
  "Cap",
  "Cyg",
  "Oct",
  "Pav",
  "Mic",
  "Cap",
  "Aqr",
  "Equ",
  "Cyg",
  "Equ",
  "Cyg",
  "Equ",
  "Aqr",
  "Pav",
  "Aqr",
  "Cep",
  "Mic",
  "Cyg",
  "Mic",
  "Mic",
  "Mic",
  "Pav",
  "Cep",
  "Cyg",
  "Peg",
  "Cep",
  "Cyg",
  "Equ",
  "Aqr",
  "Cyg",
  "Cap",
  "Mic",
  "Cyg",
  "Cap",
  "Cep",
  "Cap",
  "Ind",
  "Mic",
  "Equ",
  "Cyg",
  "Aqr",
  "Cyg",
  "Aqr",
  "Cyg",
  "Aqr",
  "Cep",
  "Cep",
  "Cyg",
  "Cyg",
  "Cyg",
  "Mic",
  "Cap",
  "Pav",
  "Aqr",
  "Cyg",
  "Cep",
  "Cep",
  "Equ",
  "Mic",
  "Cyg",
  "Cep",
  "Cyg",
  "Cep",
  "Cyg",
  "Ind",
  "Ind",
  "Vul",
  "Cep",
  "Mic",
  "Cyg",
  "Cyg",
  "Peg",
  "Aqr",
  "Equ",
  "Ind",
  "Cyg",
  "Cyg",
  "Peg",
  "Cap",
  "Cyg",
  "Equ",
  "Aqr",
  "Cap",
  "Cyg",
  "Cap",
  "Vul",
  "Vul",
  "Cap",
  "Cap",
  "Aqr",
  "Pav",
  "Ind",
  "Vul",
  "Equ",
  "Mic",
  "Vul",
  "Cep",
  "Aqr",
  "Aqr",
  "Aqr",
  "Pav",
  "Cyg",
  "Cyg",
  "Aqr",
  "Ind",
  "Mic",
  "Pav",
  "Peg",
  "Aqr",
  "Cap",
  "Cyg",
  "Cyg",
  "Mic",
  "Cap",
  "Cyg",
  "Cep",
  "Vul",
  "Cep",
  "Cyg",
  "Peg",
  "Cep",
  "Cap",
  "Pav",
  "Cep",
  "Peg",
  "Peg",
  "Ind",
  "Cyg",
  "Peg",
  "Peg",
  "Cyg",
  "Cep",
  "Peg",
  "Cyg",
  "Aqr",
  "Peg",
  "Oct",
  "Gru",
  "PsA",
  "Cap",
  "Cyg",
  "Ind",
  "Cyg",
  "Oct",
  "Gru",
  "Oct",
  "Cyg",
  "Gru",
  "Cyg",
  "Peg",
  "Aqr",
  "Peg",
  "Cyg",
  "Cap",
  "PsA",
  "Cap",
  "Aqr",
  "Peg",
  "Cep",
  "Peg",
  "Cyg",
  "Peg",
  "PsA",
  "Cyg",
  "PsA",
  "Cyg",
  "Cap",
  "Cyg",
  "Aqr",
  "Cyg",
  "Peg",
  "Aqr",
  "Peg",
  "Cep",
  "Ind",
  "Peg",
  "Peg",
  "Oct",
  "Cep",
  "Peg",
  "PsA",
  "Cap",
  "Aqr",
  "Ind",
  "Cap",
  "Cyg",
  "Ind",
  "Cyg",
  "Oct",
  "Cap",
  "Cyg",
  "Cep",
  "Cap",
  "Cyg",
  "Cyg",
  "Cyg",
  "Aqr",
  "Peg",
  "Cyg",
  "Peg",
  "Cyg",
  "Cap",
  "Cep",
  "Cep",
  "Cap",
  "Cyg",
  "Cap",
  "Cyg",
  "Cep",
  "Peg",
  "Peg",
  "Ind",
  "Cap",
  "Cyg",
  "Peg",
  "Gru",
  "Peg",
  "Peg",
  "Peg",
  "Cep",
  "PsA",
  "Cap",
  "Cyg",
  "Ind",
  "Cep",
  "Ind",
  "Cyg",
  "Peg",
  "Cap",
  "Peg",
  "Cap",
  "Cyg",
  "Cep",
  "Cap",
  "Peg",
  "Peg",
  "Cep",
  "Aqr",
  "PsA",
  "Cyg",
  "Gru",
  "Cyg",
  "Cep",
  "Cep",
  "Peg",
  "Cyg",
  "Cap",
  "Peg",
  "Ind",
  "Peg",
  "Cap",
  "Ind",
  "Oct",
  "Cyg",
  "Peg",
  "Cep",
  "Cap",
  "Cep",
  "Peg",
  "Peg",
  "Peg",
  "Cap",
  "Peg",
  "Gru",
  "Peg",
  "Aqr",
  "Peg",
  "Cep",
  "Aqr",
  "Cep",
  "Ind",
  "Cep",
  "Cep",
  "PsA",
  "Ind",
  "Ind",
  "Gru",
  "Peg",
  "Cep",
  "Peg",
  "Gru",
  "Cep",
  "Cep",
  "Ind",
  "Aqr",
  "Ind",
  "Cap",
  "Cep",
  "Aqr",
  "Peg",
  "Cep",
  "Gru",
  "Peg",
  "Ind",
  "Peg",
  "PsA",
  "Aqr",
  "Peg",
  "Peg",
  "Cyg",
  "Oct",
  "Peg",
  "Cep",
  "Aqr",
  "Aqr",
  "Cyg",
  "Oct",
  "Aqr",
  "Ind",
  "Aqr",
  "Peg",
  "Cep",
  "Cep",
  "PsA",
  "Peg",
  "PsA",
  "Aqr",
  "Cep",
  "Peg",
  "Cep",
  "Peg",
  "Lac",
  "Peg",
  "Peg",
  "Aqr",
  "Lac",
  "Ind",
  "Lac",
  "Lac",
  "Gru",
  "Lac",
  "Cep",
  "Aqr",
  "Peg",
  "Cep",
  "Lac",
  "Peg",
  "Peg",
  "Peg",
  "Gru",
  "Lac",
  "Peg",
  "PsA",
  "PsA",
  "Lac",
  "PsA",
  "Aqr",
  "Peg",
  "Aqr",
  "Cep",
  "PsA",
  "Gru",
  "Peg",
  "PsA",
  "PsA",
  "Peg",
  "Cep",
  "Peg",
  "Aqr",
  "Peg",
  "Peg",
  "Aqr",
  "Peg",
  "Aqr",
  "Cep",
  "Cep",
  "Peg",
  "Aqr",
  "Lac",
  "Cep",
  "Cep",
  "Peg",
  "Oct",
  "Cep",
  "Cep",
  "Peg",
  "Cep",
  "Aqr",
  "Aqr",
  "Peg",
  "Cep",
  "PsA",
  "Peg",
  "Cep",
  "Peg",
  "PsA",
  "Lac",
  "Cep",
  "Lac",
  "Aqr",
  "Peg",
  "PsA",
  "Gru",
  "Lac",
  "Cep",
  "Gru",
  "Gru",
  "Lac",
  "Peg",
  "Cep",
  "Gru",
  "Peg",
  "Aqr",
  "PsA",
  "Aqr",
  "Aqr",
  "Aqr",
  "Aqr",
  "Aqr",
  "Lac",
  "Oct",
  "Aqr",
  "Cep",
  "Gru",
  "Tuc",
  "Lac",
  "Aqr",
  "Oct",
  "Aqr",
  "Peg",
  "Tuc",
  "Cep",
  "Lac",
  "Peg",
  "Peg",
  "Lac",
  "Peg",
  "Peg",
  "Aqr",
  "Aqr",
  "Lac",
  "Gru",
  "Lac",
  "Cep",
  "Cep",
  "Cep",
  "Gru",
  "Aqr",
  "Aqr",
  "Lac",
  "Peg",
  "Lac",
  "Aqr",
  "Aqr",
  "Lac",
  "Ind",
  "Tuc",
  "Ind",
  "Aqr",
  "Peg",
  "Oct",
  "Cep",
  "Aqr",
  "Aqr",
  "Peg",
  "Cep",
  "Lac",
  "Cep",
  "Tuc",
  "Lac",
  "Peg",
  "Peg",
  "Peg",
  "Cep",
  "Ind",
  "Gru",
  "Aqr",
  "Peg",
  "Cep",
  "Peg",
  "Cep",
  "Gru",
  "Lac",
  "Gru",
  "PsA",
  "Cep",
  "Peg",
  "Aqr",
  "Peg",
  "Lac",
  "Aqr",
  "Lac",
  "Aqr",
  "PsA",
  "Lac",
  "Aqr",
  "Aqr",
  "PsA",
  "Peg",
  "Oct",
  "Aqr",
  "Cep",
  "Lac",
  "Lac",
  "Peg",
  "Peg",
  "Tuc",
  "Cep",
  "Cep",
  "Lac",
  "Aqr",
  "Aqr",
  "Aqr",
  "Oct",
  "Aqr",
  "Cep",
  "Aqr",
  "Lac",
  "Lac",
  "Tuc",
  "Lac",
  "Peg",
  "Gru",
  "PsA",
  "Peg",
  "Lac",
  "Gru",
  "Peg",
  "Cep",
  "Lac",
  "Aqr",
  "Lac",
  "Aqr",
  "Lac",
  "Cep",
  "PsA",
  "PsA",
  "Peg",
  "Lac",
  "Lac",
  "PsA",
  "Peg",
  "Lac",
  "PsA",
  "Lac",
  "PsA",
  "Aqr",
  "Tuc",
  "Peg",
  "Peg",
  "Lac",
  "Peg",
  "Lac",
  "Peg",
  "Peg",
  "Aqr",
  "Lac",
  "PsA",
  "Gru",
  "Gru",
  "Gru",
  "Lac",
  "Peg",
  "Aqr",
  "Lac",
  "Aqr",
  "Gru",
  "Aqr",
  "Lac",
  "Lac",
  "Tuc",
  "Lac",
  "Lac",
  "Cep",
  "Peg",
  "Peg",
  "Gru",
  "Gru",
  "Oct",
  "Lac",
  "Gru",
  "Peg",
  "Peg",
  "PsA",
  "Cep",
  "Cep",
  "Aqr",
  "Tuc",
  "Aqr",
  "PsA",
  "Lac",
  "Tuc",
  "Aqr",
  "Gru",
  "Cep",
  "Lac",
  "Cep",
  "Ind",
  "Aqr",
  "Cep",
  "Lac",
  "PsA",
  "Peg",
  "Lac",
  "Lac",
  "Oct",
  "Gru",
  "Cep",
  "PsA",
  "Cep",
  "Tuc",
  "Lac",
  "Tuc",
  "Peg",
  "PsA",
  "Aqr",
  "Lac",
  "Peg",
  "Cep",
  "Lac",
  "Aqr",
  "Gru",
  "Lac",
  "Aqr",
  "Lac",
  "Cep",
  "Aqr",
  "Peg",
  "Aqr",
  "Ind",
  "Aqr",
  "Psc",
  "Lac",
  "Aqr",
  "Peg",
  "Gru",
  "Aqr",
  "Lac",
  "PsA",
  "PsA",
  "Lac",
  "PsA",
  "Lac",
  "Gru",
  "Lac",
  "Aqr",
  "Peg",
  "Psc",
  "PsA",
  "Lac",
  "Psc",
  "Psc",
  "Peg",
  "PsA",
  "Psc",
  "Cep",
  "And",
  "Peg",
  "Psc",
  "Aqr",
  "PsA",
  "Cas",
  "PsA",
  "PsA",
  "Psc",
  "Psc",
  "Gru",
  "Gru",
  "PsA",
  "Aqr",
  "Aqr",
  "Cas",
  "Aqr",
  "Psc",
  "And",
  "And",
  "Aqr",
  "Gru",
  "And",
  "Aqr",
  "And",
  "Cas",
  "PsA",
  "Cep",
  "Peg",
  "Psc",
  "Gru",
  "Psc",
  "And",
  "Gru",
  "Peg",
  "Ind",
  "Peg",
  "Aqr",
  "Aqr",
  "Psc",
  "Peg",
  "Peg",
  "Cas",
  "Aqr",
  "Gru",
  "Gru",
  "Peg",
  "And",
  "Peg",
  "Gru",
  "And",
  "Cas",
  "Gru",
  "Peg",
  "Peg",
  "And",
  "And",
  "Cep",
  "Cep",
  "Cep",
  "Scl",
  "Oct",
  "Ind",
  "Psc",
  "Aqr",
  "Peg",
  "Cas",
  "Scl",
  "Ind",
  "Aqr",
  "Aqr",
  "Gru",
  "Peg",
  "Gru",
  "Ind",
  "Gru",
  "And",
  "Peg",
  "Peg",
  "Peg",
  "Oct",
  "And",
  "Peg",
  "Cas",
  "Peg",
  "Peg",
  "Tuc",
  "And",
  "Aqr",
  "Peg",
  "Peg",
  "Cep",
  "Aqr",
  "Gru",
  "Aqr",
  "Cep",
  "Aqr",
  "Gru",
  "Cas",
  "Gru",
  "Aqr",
  "Tuc",
  "Scl",
  "Psc",
  "And",
  "Cep",
  "Tuc",
  "Aqr",
  "And",
  "Aqr",
  "And",
  "Gru",
  "Ind",
  "And",
  "Cep",
  "Scl",
  "Aqr",
  "Scl",
  "Aqr",
  "Oct",
  "Aqr",
  "Aqr",
  "Peg",
  "And",
  "And",
  "Scl",
  "And",
  "Cas",
  "Psc",
  "Cas",
  "Peg",
  "Aqr",
  "And",
  "Peg",
  "Gru",
  "And",
  "Scl",
  "Peg",
  "Peg",
  "Cas",
  "Aqr",
  "Peg",
  "Tuc",
  "Aqr",
  "Peg",
  "Psc",
  "Gru",
  "Gru",
  "Aqr",
  "Aqr",
  "And",
  "Gru",
  "Cas",
  "Peg",
  "Tuc",
  "Peg",
  "Aqr",
  "Aqr",
  "Gru",
  "Psc",
  "Cep",
  "And",
  "Tuc",
  "Phe",
  "Psc",
  "Tuc",
  "Cep",
  "Peg",
  "Psc",
  "Scl",
  "Oct",
  "Aqr",
  "Aqr",
  "Phe",
  "Tuc",
  "Peg",
  "Peg",
  "Psc",
  "Aqr",
  "Cas",
  "And",
  "And",
  "Aqr",
  "And",
  "Phe",
  "Aqr",
  "Aqr",
  "Peg",
  "Psc",
  "Peg",
  "Scl",
  "Aqr",
  "Oct",
  "Peg",
  "And",
  "Peg",
  "Peg",
  "Psc",
  "And",
  "Peg",
  "And",
  "Aqr",
  "Cep",
  "Phe",
  "Psc",
  "Aqr",
  "Peg",
  "Psc",
  "And",
  "And",
  "And",
  "Aqr",
  "Peg",
  "Phe",
  "Peg",
  "Aqr",
  "And",
  "Oct",
  "And",
  "Cep",
  "Cep",
  "Cep",
  "Phe",
  "Aqr",
  "Peg",
  "Psc",
  "And",
  "And",
  "Scl",
  "And",
  "Aqr",
  "Cas",
  "Aqr",
  "Aqr",
  "Cas",
  "Psc",
  "Psc",
  "And",
  "Aqr",
  "Cas",
  "Aqr",
  "Peg",
  "Cas",
  "Peg",
  "Peg",
  "Phe",
  "Tuc",
  "Aqr",
  "Tuc",
  "Scl",
  "Oct",
  "Cas",
  "Aqr",
  "Phe",
  "And",
  "Psc",
  "Cep",
  "Cas",
  "Cas",
  "Aqr",
  "Phe",
  "And",
  "Cep",
  "Psc",
  "Aqr",
  "Cas",
  "Psc",
  "Cas",
  "Cas",
  "Scl",
  "Cas",
  "Psc",
  "Aqr",
  "Peg",
  "And",
  "Scl",
  "Aqr",
  "Cas",
  "Aqr",
  "Phe",
  "Peg",
  "Aqr",
  "Psc",
  "Oct",
  "Peg",
  "Cep",
  "Peg",
  "Aqr",
  "Peg",
  "Aqr",
  "Psc",
  "Psc",
  "Aqr",
  "Scl",
  "Cas",
  "Phe",
  "Psc",
  "Psc",
  "Scl",
  "And",
  "Cas",
  "Peg",
  "Cet",
  "Peg",
  "And",
  "Scl",
  "Cas",
  "Cet",
  "Tuc",
  "Oct",
  "Cas",
  "Tuc",
  "Peg",
  "Cet",
  "Psc",
  "Phe",
  "Cas",
  "Psc",
  "Scl",
  "And",
  "Tuc",
  "Tuc",
  "Cet",
  "Cet",
  "Eri",
  "Cet",
  "Cet",
  "Tau",
  "Aur",
  "Lep",
  "Gem",
  "Pup",
  "Vel",
  "Lyn",
  "Car",
  "Vel",
  "Ant",
  "UMa",
  "UMa",
  "Vir",
  "Vir",
  "Com",
  "UMa",
  "Boo",
  "CrB",
  "Sco",
  "Sco",
  "Her",
  "Dra",
  "Oph",
  "Oph",
  "Oph",
  "Oph",
  "Oph",
  "CrA",
  "Cap",
  "Pav",
  "Equ",
  "Cyg",
  "Cyg",
  "Ind",
  "Aqr",
  "Aqr",
  "Ori",
  "Car",
  "Gem",
  "CMi",
  "Car",
  "Boo",
  "Sco",
  "Sco",
];

export const STAR_MAG_LIMIT = 6.5;
